/*
Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license/
*/
(function () {
  if (!window.CKEDITOR || !window.CKEDITOR.dom) {
    window.CKEDITOR ||
      (window.CKEDITOR = (function () {
        var a = /(^|.*[\\\/])ckeditor\.js(?:\?.*|;.*)?$/i,
          h = {
            timestamp: 'M6K8',
            version: '4.19.1 (Full)',
            revision: '445cf24ebd',
            rnd: Math.floor(900 * Math.random()) + 100,
            _: { pending: [], basePathSrcPattern: a },
            status: 'unloaded',
            basePath: (function () {
              var b = window.CKEDITOR_BASEPATH || '';
              if (!b)
                for (var f = document.getElementsByTagName('script'), k = 0; k < f.length; k++) {
                  var m = f[k].src.match(a);
                  if (m) {
                    b = m[1];
                    break;
                  }
                }
              -1 == b.indexOf(':/') &&
                '//' != b.slice(0, 2) &&
                (b = 0 === b.indexOf('/') ? location.href.match(/^.*?:\/\/[^\/]*/)[0] + b : location.href.match(/^[^\?]*\/(?:)/)[0] + b);
              if (!b)
                throw 'The CKEditor installation path could not be automatically detected. Please set the global variable "CKEDITOR_BASEPATH" before creating editor instances.';
              return b;
            })(),
            getUrl: function (a) {
              -1 == a.indexOf(':/') && 0 !== a.indexOf('/') && (a = this.basePath + a);
              return (a = this.appendTimestamp(a));
            },
            appendTimestamp: function (a) {
              if (!this.timestamp || '/' === a.charAt(a.length - 1) || /[&?]t=/.test(a)) return a;
              var b = 0 <= a.indexOf('?') ? '\x26' : '?';
              return a + b + 't\x3d' + this.timestamp;
            },
            domReady: (function () {
              function a() {
                try {
                  document.addEventListener
                    ? (document.removeEventListener('DOMContentLoaded', a, !1), window.removeEventListener('load', a, !1), b())
                    : document.attachEvent &&
                      'complete' === document.readyState &&
                      (document.detachEvent('onreadystatechange', a), window.detachEvent('onload', a), b());
                } catch (m) {}
              }
              function b() {
                for (var a; (a = f.shift()); ) a();
              }
              var f = [];
              return function (b) {
                function g() {
                  try {
                    document.documentElement.doScroll('left');
                  } catch (e) {
                    setTimeout(g, 1);
                    return;
                  }
                  a();
                }
                f.push(b);
                'complete' === document.readyState && setTimeout(a, 1);
                if (1 == f.length)
                  if (document.addEventListener)
                    document.addEventListener('DOMContentLoaded', a, !1), window.addEventListener('load', a, !1);
                  else if (document.attachEvent) {
                    document.attachEvent('onreadystatechange', a);
                    window.attachEvent('onload', a);
                    b = !1;
                    try {
                      b = !window.frameElement;
                    } catch (d) {}
                    document.documentElement.doScroll && b && g();
                  }
              };
            })(),
          },
          f = window.CKEDITOR_GETURL;
        if (f) {
          var b = h.getUrl;
          h.getUrl = function (a) {
            return f.call(h, a) || b.call(h, a);
          };
        }
        return h;
      })());
    (function () {
      var a = {};
      CKEDITOR.event ||
        ((CKEDITOR.event = function () {}),
        (CKEDITOR.event.implementOn = function (a) {
          var f = CKEDITOR.event.prototype,
            b;
          for (b in f) null == a[b] && (a[b] = f[b]);
        }),
        (CKEDITOR.event.prototype = (function () {
          function h(a) {
            var l = f(this);
            return l[a] || (l[a] = new b(a));
          }
          var f = function (a) {
              a = (a.getPrivate && a.getPrivate()) || a._ || (a._ = {});
              return a.events || (a.events = {});
            },
            b = function (a) {
              this.name = a;
              this.listeners = [];
            };
          b.prototype = {
            getListenerIndex: function (a) {
              for (var b = 0, f = this.listeners; b < f.length; b++) if (f[b].fn == a) return b;
              return -1;
            },
          };
          return {
            define: function (a, b) {
              var f = h.call(this, a);
              CKEDITOR.tools.extend(f, b, !0);
            },
            on: function (b, f, k, m, g) {
              function d(n, g, d, r) {
                n = { name: b, sender: this, editor: n, data: g, listenerData: m, stop: d, cancel: r, removeListener: e };
                return !1 === f.call(k, n) ? a : n.data;
              }
              function e() {
                n.removeListener(b, f);
              }
              var n = this,
                r = h.call(this, b);
              if (0 > r.getListenerIndex(f)) {
                r = r.listeners;
                k || (k = this);
                isNaN(g) && (g = 10);
                d.fn = f;
                d.priority = g;
                for (var x = r.length - 1; 0 <= x; x--) if (r[x].priority <= g) return r.splice(x + 1, 0, d), { removeListener: e };
                r.unshift(d);
              }
              return { removeListener: e };
            },
            once: function () {
              var a = Array.prototype.slice.call(arguments),
                b = a[1];
              a[1] = function (a) {
                a.removeListener();
                return b.apply(this, arguments);
              };
              return this.on.apply(this, a);
            },
            capture: function () {
              CKEDITOR.event.useCapture = 1;
              var a = this.on.apply(this, arguments);
              CKEDITOR.event.useCapture = 0;
              return a;
            },
            fire: (function () {
              var b = 0,
                l = function () {
                  b = 1;
                },
                k = 0,
                m = function () {
                  k = 1;
                };
              return function (g, d, e) {
                var n = f(this)[g];
                g = b;
                var r = k;
                b = k = 0;
                if (n) {
                  var h = n.listeners;
                  if (h.length)
                    for (var h = h.slice(0), u, p = 0; p < h.length; p++) {
                      if (n.errorProof)
                        try {
                          u = h[p].call(this, e, d, l, m);
                        } catch (t) {}
                      else u = h[p].call(this, e, d, l, m);
                      u === a ? (k = 1) : 'undefined' != typeof u && (d = u);
                      if (b || k) break;
                    }
                }
                d = k ? !1 : 'undefined' == typeof d ? !0 : d;
                b = g;
                k = r;
                return d;
              };
            })(),
            fireOnce: function (a, b, k) {
              b = this.fire(a, b, k);
              delete f(this)[a];
              return b;
            },
            removeListener: function (a, b) {
              var k = f(this)[a];
              if (k) {
                var m = k.getListenerIndex(b);
                0 <= m && k.listeners.splice(m, 1);
              }
            },
            removeAllListeners: function () {
              var a = f(this),
                b;
              for (b in a) delete a[b];
            },
            hasListeners: function (a) {
              return (a = f(this)[a]) && 0 < a.listeners.length;
            },
          };
        })()));
    })();
    CKEDITOR.editor ||
      ((CKEDITOR.editor = function () {
        CKEDITOR._.pending.push([this, arguments]);
        CKEDITOR.event.call(this);
      }),
      (CKEDITOR.editor.prototype.fire = function (a, h) {
        a in { instanceReady: 1, loaded: 1 } && (this[a] = !0);
        return CKEDITOR.event.prototype.fire.call(this, a, h, this);
      }),
      (CKEDITOR.editor.prototype.fireOnce = function (a, h) {
        a in { instanceReady: 1, loaded: 1 } && (this[a] = !0);
        return CKEDITOR.event.prototype.fireOnce.call(this, a, h, this);
      }),
      CKEDITOR.event.implementOn(CKEDITOR.editor.prototype));
    CKEDITOR.env ||
      (CKEDITOR.env = (function () {
        var a = navigator.userAgent.toLowerCase(),
          h = a.match(/edge[ \/](\d+.?\d*)/),
          f = -1 < a.indexOf('trident/'),
          f = !(!h && !f),
          f = {
            ie: f,
            edge: !!h,
            webkit: !f && -1 < a.indexOf(' applewebkit/'),
            air: -1 < a.indexOf(' adobeair/'),
            mac: -1 < a.indexOf('macintosh'),
            quirks: 'BackCompat' == document.compatMode && (!document.documentMode || 10 > document.documentMode),
            mobile: -1 < a.indexOf('mobile'),
            iOS: /(ipad|iphone|ipod)/.test(a),
            isCustomDomain: function () {
              if (!this.ie) return !1;
              var a = document.domain,
                b = window.location.hostname;
              return a != b && a != '[' + b + ']';
            },
            secure: 'https:' == location.protocol,
          };
        f.gecko = 'Gecko' == navigator.product && !f.webkit && !f.ie;
        f.webkit && (-1 < a.indexOf('chrome') ? (f.chrome = !0) : (f.safari = !0));
        var b = 0;
        f.ie &&
          ((b = h ? parseFloat(h[1]) : f.quirks || !document.documentMode ? parseFloat(a.match(/msie (\d+)/)[1]) : document.documentMode),
          (f.ie9Compat = 9 == b),
          (f.ie8Compat = 8 == b),
          (f.ie7Compat = 7 == b),
          (f.ie6Compat = 7 > b || f.quirks));
        f.gecko && (h = a.match(/rv:([\d\.]+)/)) && ((h = h[1].split('.')), (b = 1e4 * h[0] + 100 * (h[1] || 0) + 1 * (h[2] || 0)));
        f.air && (b = parseFloat(a.match(/ adobeair\/(\d+)/)[1]));
        f.webkit && (b = parseFloat(a.match(/ applewebkit\/(\d+)/)[1]));
        f.version = b;
        f.isCompatible = !(f.ie && 7 > b) && !(f.gecko && 4e4 > b) && !(f.webkit && 534 > b);
        f.hidpi = 2 <= window.devicePixelRatio;
        f.needsBrFiller = f.gecko || f.webkit || (f.ie && 10 < b);
        f.needsNbspFiller = f.ie && 11 > b;
        f.cssClass = 'cke_browser_' + (f.ie ? 'ie' : f.gecko ? 'gecko' : f.webkit ? 'webkit' : 'unknown');
        f.quirks && (f.cssClass += ' cke_browser_quirks');
        f.ie && (f.cssClass += ' cke_browser_ie' + (f.quirks ? '6 cke_browser_iequirks' : f.version));
        f.air && (f.cssClass += ' cke_browser_air');
        f.iOS && (f.cssClass += ' cke_browser_ios');
        f.hidpi && (f.cssClass += ' cke_hidpi');
        return f;
      })());
    'unloaded' == CKEDITOR.status &&
      (function () {
        CKEDITOR.event.implementOn(CKEDITOR);
        CKEDITOR.loadFullCore = function () {
          if ('basic_ready' != CKEDITOR.status) CKEDITOR.loadFullCore._load = 1;
          else {
            delete CKEDITOR.loadFullCore;
            var a = document.createElement('script');
            a.type = 'text/javascript';
            a.src = CKEDITOR.basePath + 'ckeditor.js';
            document.getElementsByTagName('head')[0].appendChild(a);
          }
        };
        CKEDITOR.loadFullCoreTimeout = 0;
        CKEDITOR.add = function (a) {
          (this._.pending || (this._.pending = [])).push(a);
        };
        (function () {
          CKEDITOR.domReady(function () {
            var a = CKEDITOR.loadFullCore,
              h = CKEDITOR.loadFullCoreTimeout;
            a &&
              ((CKEDITOR.status = 'basic_ready'),
              a && a._load
                ? a()
                : h &&
                  setTimeout(function () {
                    CKEDITOR.loadFullCore && CKEDITOR.loadFullCore();
                  }, 1e3 * h));
          });
        })();
        CKEDITOR.status = 'basic_loaded';
      })();
    ('use strict');
    CKEDITOR.VERBOSITY_WARN = 1;
    CKEDITOR.VERBOSITY_ERROR = 2;
    CKEDITOR.verbosity = CKEDITOR.VERBOSITY_WARN | CKEDITOR.VERBOSITY_ERROR;
    CKEDITOR.warn = function (a, h) {
      CKEDITOR.verbosity & CKEDITOR.VERBOSITY_WARN && CKEDITOR.fire('log', { type: 'warn', errorCode: a, additionalData: h });
    };
    CKEDITOR.error = function (a, h) {
      CKEDITOR.verbosity & CKEDITOR.VERBOSITY_ERROR && CKEDITOR.fire('log', { type: 'error', errorCode: a, additionalData: h });
    };
    CKEDITOR.on(
      'log',
      function (a) {
        if (window.console && window.console.log) {
          var h = console[a.data.type] ? a.data.type : 'log',
            f = a.data.errorCode;
          if ((a = a.data.additionalData)) console[h]('[CKEDITOR] Error code: ' + f + '.', a);
          else console[h]('[CKEDITOR] Error code: ' + f + '.');
          console[h](
            '[CKEDITOR] For more information about this error go to https://ckeditor.com/docs/ckeditor4/latest/guide/dev_errors.html#' + f,
          );
        }
      },
      null,
      null,
      999,
    );
    CKEDITOR.dom = {};
    (function () {
      function a(e, a, g) {
        this._minInterval = e;
        this._context = g;
        this._lastOutput = this._scheduledTimer = 0;
        this._output = CKEDITOR.tools.bind(a, g || {});
        var b = this;
        this.input = function () {
          function e() {
            b._lastOutput = new Date().getTime();
            b._scheduledTimer = 0;
            b._call();
          }
          if (!b._scheduledTimer || !1 !== b._reschedule()) {
            var a = new Date().getTime() - b._lastOutput;
            a < b._minInterval ? (b._scheduledTimer = setTimeout(e, b._minInterval - a)) : e();
          }
        };
      }
      function h(e, b, g) {
        a.call(this, e, b, g);
        this._args = [];
        var d = this;
        this.input = CKEDITOR.tools.override(this.input, function (e) {
          return function () {
            d._args = Array.prototype.slice.call(arguments);
            e.call(this);
          };
        });
      }
      var f = [],
        b = CKEDITOR.env.gecko ? '-moz-' : CKEDITOR.env.webkit ? '-webkit-' : CKEDITOR.env.ie ? '-ms-' : '',
        c = /&/g,
        l = />/g,
        k = /</g,
        m = /"/g,
        g = /&(lt|gt|amp|quot|nbsp|shy|#\d{1,5});/g,
        d = { lt: '\x3c', gt: '\x3e', amp: '\x26', quot: '"', nbsp: ' ', shy: '­' },
        e = function (e, a) {
          return '#' == a[0] ? String.fromCharCode(parseInt(a.slice(1), 10)) : d[a];
        };
      CKEDITOR.on('reset', function () {
        f = [];
      });
      CKEDITOR.tools = {
        arrayCompare: function (e, a) {
          if (!e && !a) return !0;
          if (!e || !a || e.length != a.length) return !1;
          for (var b = 0; b < e.length; b++) if (e[b] != a[b]) return !1;
          return !0;
        },
        getIndex: function (e, a) {
          for (var b = 0; b < e.length; ++b) if (a(e[b])) return b;
          return -1;
        },
        clone: function (e) {
          var a;
          if (e && e instanceof Array) {
            a = [];
            for (var b = 0; b < e.length; b++) a[b] = CKEDITOR.tools.clone(e[b]);
            return a;
          }
          if (
            null === e ||
            'object' != typeof e ||
            e instanceof String ||
            e instanceof Number ||
            e instanceof Boolean ||
            e instanceof Date ||
            e instanceof RegExp ||
            e.nodeType ||
            e.window === e
          )
            return e;
          a = new e.constructor();
          for (b in e) a[b] = CKEDITOR.tools.clone(e[b]);
          return a;
        },
        capitalize: function (e, a) {
          return e.charAt(0).toUpperCase() + (a ? e.slice(1) : e.slice(1).toLowerCase());
        },
        extend: function (e) {
          var a = arguments.length,
            b,
            g;
          'boolean' == typeof (b = arguments[a - 1])
            ? a--
            : 'boolean' == typeof (b = arguments[a - 2]) && ((g = arguments[a - 1]), (a -= 2));
          for (var d = 1; d < a; d++) {
            var c = arguments[d] || {};
            CKEDITOR.tools.array.forEach(CKEDITOR.tools.object.keys(c), function (a) {
              if (!0 === b || null == e[a]) if (!g || a in g) e[a] = c[a];
            });
          }
          return e;
        },
        prototypedCopy: function (e) {
          var a = function () {};
          a.prototype = e;
          return new a();
        },
        copy: function (e) {
          var a = {},
            b;
          for (b in e) a[b] = e[b];
          return a;
        },
        isArray: function (e) {
          return '[object Array]' == Object.prototype.toString.call(e);
        },
        isEmpty: function (e) {
          for (var a in e) if (e.hasOwnProperty(a)) return !1;
          return !0;
        },
        cssVendorPrefix: function (e, a, g) {
          if (g) return b + e + ':' + a + ';' + e + ':' + a;
          g = {};
          g[e] = a;
          g[b + e] = a;
          return g;
        },
        cssStyleToDomStyle: (function () {
          var e = document.createElement('div').style,
            a = 'undefined' != typeof e.cssFloat ? 'cssFloat' : 'undefined' != typeof e.styleFloat ? 'styleFloat' : 'float';
          return function (e) {
            return 'float' == e
              ? a
              : e.replace(/-./g, function (e) {
                  return e.substr(1).toUpperCase();
                });
          };
        })(),
        buildStyleHtml: function (e) {
          e = [].concat(e);
          for (var a, b = [], g = 0; g < e.length; g++)
            if ((a = e[g]))
              /@import|[{}]/.test(a)
                ? b.push('\x3cstyle\x3e' + a + '\x3c/style\x3e')
                : ((a = CKEDITOR.appendTimestamp(a)), b.push('\x3clink type\x3d"text/css" rel\x3dstylesheet href\x3d"' + a + '"\x3e'));
          return b.join('');
        },
        htmlEncode: function (e) {
          return void 0 === e || null === e ? '' : String(e).replace(c, '\x26amp;').replace(l, '\x26gt;').replace(k, '\x26lt;');
        },
        htmlDecode: function (a) {
          return a.replace(g, e);
        },
        htmlEncodeAttr: function (e) {
          return CKEDITOR.tools.htmlEncode(e).replace(m, '\x26quot;');
        },
        htmlDecodeAttr: function (e) {
          return CKEDITOR.tools.htmlDecode(e);
        },
        transformPlainTextToHtml: function (e, a) {
          var b = a == CKEDITOR.ENTER_BR,
            g = this.htmlEncode(e.replace(/\r\n/g, '\n')),
            g = g.replace(/\t/g, '\x26nbsp;\x26nbsp; \x26nbsp;'),
            d = a == CKEDITOR.ENTER_P ? 'p' : 'div';
          if (!b) {
            var c = /\n{2}/g;
            if (c.test(g))
              var m = '\x3c' + d + '\x3e',
                f = '\x3c/' + d + '\x3e',
                g =
                  m +
                  g.replace(c, function () {
                    return f + m;
                  }) +
                  f;
          }
          g = g.replace(/\n/g, '\x3cbr\x3e');
          b ||
            (g = g.replace(new RegExp('\x3cbr\x3e(?\x3d\x3c/' + d + '\x3e)'), function (e) {
              return CKEDITOR.tools.repeat(e, 2);
            }));
          g = g.replace(/^ | $/g, '\x26nbsp;');
          return (g = g
            .replace(/(>|\s) /g, function (e, a) {
              return a + '\x26nbsp;';
            })
            .replace(/ (?=<)/g, '\x26nbsp;'));
        },
        getNextNumber: (function () {
          var e = 0;
          return function () {
            return ++e;
          };
        })(),
        getNextId: function () {
          return 'cke_' + this.getNextNumber();
        },
        getUniqueId: function () {
          for (var e = 'e', a = 0; 8 > a; a++)
            e += Math.floor(65536 * (1 + Math.random()))
              .toString(16)
              .substring(1);
          return e;
        },
        override: function (e, a) {
          var b = a(e);
          b.prototype = e.prototype;
          return b;
        },
        setTimeout: function (e, a, b, g, d) {
          d || (d = window);
          b || (b = d);
          return d.setTimeout(function () {
            g ? e.apply(b, [].concat(g)) : e.apply(b);
          }, a || 0);
        },
        debounce: function (e, a) {
          var b;
          return function () {
            var g = this,
              d = arguments;
            clearTimeout(b);
            b = setTimeout(function () {
              b = null;
              e.apply(g, d);
            }, a);
          };
        },
        throttle: function (e, a, b) {
          return new this.buffers.throttle(e, a, b);
        },
        trim: (function () {
          var e = /(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g;
          return function (a) {
            return a.replace(e, '');
          };
        })(),
        ltrim: (function () {
          var e = /^[ \t\n\r]+/g;
          return function (a) {
            return a.replace(e, '');
          };
        })(),
        rtrim: (function () {
          var e = /[ \t\n\r]+$/g;
          return function (a) {
            return a.replace(e, '');
          };
        })(),
        indexOf: function (e, a) {
          if ('function' == typeof a)
            for (var b = 0, g = e.length; b < g; b++) {
              if (a(e[b])) return b;
            }
          else {
            if (e.indexOf) return e.indexOf(a);
            b = 0;
            for (g = e.length; b < g; b++) if (e[b] === a) return b;
          }
          return -1;
        },
        search: function (e, a) {
          var b = CKEDITOR.tools.indexOf(e, a);
          return 0 <= b ? e[b] : null;
        },
        bind: function (e, a) {
          var b = Array.prototype.slice.call(arguments, 2);
          return function () {
            return e.apply(a, b.concat(Array.prototype.slice.call(arguments)));
          };
        },
        createClass: function (e) {
          var a = e.$,
            b = e.base,
            g = e.privates || e._,
            d = e.proto;
          e = e.statics;
          !a &&
            (a = function () {
              b && this.base.apply(this, arguments);
            });
          if (g)
            var c = a,
              a = function () {
                var e = this._ || (this._ = {}),
                  a;
                for (a in g) {
                  var b = g[a];
                  e[a] = 'function' == typeof b ? CKEDITOR.tools.bind(b, this) : b;
                }
                c.apply(this, arguments);
              };
          b &&
            ((a.prototype = this.prototypedCopy(b.prototype)),
            (a.prototype.constructor = a),
            (a.base = b),
            (a.baseProto = b.prototype),
            (a.prototype.base = function q() {
              this.base = b.prototype.base;
              b.apply(this, arguments);
              this.base = q;
            }));
          d && this.extend(a.prototype, d, !0);
          e && this.extend(a, e, !0);
          return a;
        },
        addFunction: function (e, a) {
          return (
            f.push(function () {
              return e.apply(a || this, arguments);
            }) - 1
          );
        },
        removeFunction: function (e) {
          f[e] = null;
        },
        callFunction: function (e) {
          var a = f[e];
          return a && a.apply(window, Array.prototype.slice.call(arguments, 1));
        },
        cssLength: (function () {
          var e = /^-?\d+\.?\d*px$/,
            a;
          return function (b) {
            a = CKEDITOR.tools.trim(b + '') + 'px';
            return e.test(a) ? a : b || '';
          };
        })(),
        convertToPx: (function () {
          var e, a;
          return function (b) {
            if (!e || e.isDetached())
              (e = CKEDITOR.dom.element.createFromHtml(
                '\x3cdiv style\x3d"position:absolute;left:-9999px;top:-9999px;margin:0px;padding:0px;border:0px;"\x3e\x3c/div\x3e',
                CKEDITOR.document,
              )),
                CKEDITOR.document.getBody().append(e);
            if (!/%$/.test(b)) {
              var g = 0 > parseFloat(b);
              g && (b = b.replace('-', ''));
              e.setStyle('width', b);
              a = e.getClientRect();
              b = Math.round(a.width);
              return g ? -b : b;
            }
            return b;
          };
        })(),
        repeat: function (e, a) {
          return Array(a + 1).join(e);
        },
        tryThese: function () {
          for (var e, a = 0, b = arguments.length; a < b; a++) {
            var g = arguments[a];
            try {
              e = g();
              break;
            } catch (d) {}
          }
          return e;
        },
        genKey: function () {
          return Array.prototype.slice.call(arguments).join('-');
        },
        defer: function (e) {
          return function () {
            var a = arguments,
              b = this;
            window.setTimeout(function () {
              e.apply(b, a);
            }, 0);
          };
        },
        normalizeCssText: function (e, a) {
          var b = [],
            g,
            d = CKEDITOR.tools.parseCssText(e, !0, a);
          for (g in d) b.push(g + ':' + d[g]);
          b.sort();
          return b.length ? b.join(';') + ';' : '';
        },
        convertRgbToHex: function (e) {
          return e.replace(/(?:rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\))/gi, function (e, a, b, g) {
            e = [a, b, g];
            for (a = 0; 3 > a; a++) e[a] = ('0' + parseInt(e[a], 10).toString(16)).slice(-2);
            return '#' + e.join('');
          });
        },
        normalizeHex: function (e) {
          return e.replace(/#(([0-9a-f]{3}){1,2})($|;|\s+)/gi, function (e, a, b, g) {
            e = a.toLowerCase();
            3 == e.length && ((e = e.split('')), (e = [e[0], e[0], e[1], e[1], e[2], e[2]].join('')));
            return '#' + e + g;
          });
        },
        _isValidColorFormat: function (e) {
          if (!e) return !1;
          e = e.replace(/\s+/g, '');
          return /^[a-z0-9()#%,./]+$/i.test(e);
        },
        parseCssText: function (e, a, b) {
          var g = {};
          b && (e = new CKEDITOR.dom.element('span').setAttribute('style', e).getAttribute('style') || '');
          e && (e = CKEDITOR.tools.normalizeHex(CKEDITOR.tools.convertRgbToHex(e)));
          if (!e || ';' == e) return g;
          e.replace(/&quot;/g, '"').replace(/\s*([^:;\s]+)\s*:\s*([^;]+)\s*(?=;|$)/g, function (e, b, d) {
            a && ((b = b.toLowerCase()), 'font-family' == b && (d = d.replace(/\s*,\s*/g, ',')), (d = CKEDITOR.tools.trim(d)));
            g[b] = d;
          });
          return g;
        },
        writeCssText: function (e, a) {
          var b,
            g = [];
          for (b in e) g.push(b + ':' + e[b]);
          a && g.sort();
          return g.join('; ');
        },
        objectCompare: function (e, a, b) {
          var g;
          if (!e && !a) return !0;
          if (!e || !a) return !1;
          for (g in e) if (e[g] != a[g]) return !1;
          if (!b) for (g in a) if (e[g] != a[g]) return !1;
          return !0;
        },
        objectKeys: function (e) {
          return CKEDITOR.tools.object.keys(e);
        },
        convertArrayToObject: function (e, a) {
          var b = {};
          1 == arguments.length && (a = !0);
          for (var g = 0, d = e.length; g < d; ++g) b[e[g]] = a;
          return b;
        },
        getStyledSpans: function (e, a) {
          var b = CKEDITOR.env.ie && 8 == CKEDITOR.env.version ? e.toUpperCase() : e,
            b = a.find('span[style*\x3d' + b + ']').toArray();
          return CKEDITOR.tools.array.filter(b, function (a) {
            return !!a.getStyle(e);
          });
        },
        fixDomain: function () {
          for (var e; ; )
            try {
              e = window.parent.document.domain;
              break;
            } catch (a) {
              e = e ? e.replace(/.+?(?:\.|$)/, '') : document.domain;
              if (!e) break;
              document.domain = e;
            }
          return !!e;
        },
        eventsBuffer: function (e, a, b) {
          return new this.buffers.event(e, a, b);
        },
        enableHtml5Elements: function (e, a) {
          for (
            var b =
                'abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup main mark meter nav output progress section summary time video'.split(
                  ' ',
                ),
              g = b.length,
              d;
            g--;

          )
            (d = e.createElement(b[g])), a && e.appendChild(d);
        },
        checkIfAnyArrayItemMatches: function (e, a) {
          for (var b = 0, g = e.length; b < g; ++b) if (e[b].match(a)) return !0;
          return !1;
        },
        checkIfAnyObjectPropertyMatches: function (e, a) {
          for (var b in e) if (b.match(a)) return !0;
          return !1;
        },
        keystrokeToString: function (e, a) {
          var b = this.keystrokeToArray(e, a);
          b.display = b.display.join('+');
          b.aria = b.aria.join('+');
          return b;
        },
        keystrokeToArray: function (e, a) {
          var b = a & 16711680,
            g = a & 65535,
            d = CKEDITOR.env.mac,
            c = [],
            m = [];
          b & CKEDITOR.CTRL && (c.push(d ? '⌘' : e[17]), m.push(d ? e[224] : e[17]));
          b & CKEDITOR.ALT && (c.push(d ? '⌥' : e[18]), m.push(e[18]));
          b & CKEDITOR.SHIFT && (c.push(d ? '⇧' : e[16]), m.push(e[16]));
          g && (e[g] ? (c.push(e[g]), m.push(e[g])) : (c.push(String.fromCharCode(g)), m.push(String.fromCharCode(g))));
          return { display: c, aria: m };
        },
        transparentImageData: 'data:image/gif;base64,R0lGODlhAQABAPABAP///wAAACH5BAEKAAAALAAAAAABAAEAAAICRAEAOw\x3d\x3d',
        getCookie: function (e) {
          e = e.toLowerCase();
          for (var a = document.cookie.split(';'), b, g, d = 0; d < a.length; d++)
            if (((b = a[d].split('\x3d')), (g = decodeURIComponent(CKEDITOR.tools.trim(b[0]).toLowerCase())), g === e))
              return decodeURIComponent(1 < b.length ? b[1] : '');
          return null;
        },
        setCookie: function (e, a) {
          document.cookie = encodeURIComponent(e) + '\x3d' + encodeURIComponent(a) + ';path\x3d/';
        },
        getCsrfToken: function () {
          var e = CKEDITOR.tools.getCookie('ckCsrfToken');
          if (!e || 40 != e.length) {
            var e = [],
              a = '';
            if (window.crypto && window.crypto.getRandomValues) (e = new Uint8Array(40)), window.crypto.getRandomValues(e);
            else for (var b = 0; 40 > b; b++) e.push(Math.floor(256 * Math.random()));
            for (b = 0; b < e.length; b++)
              var g = 'abcdefghijklmnopqrstuvwxyz0123456789'.charAt(e[b] % 36), a = a + (0.5 < Math.random() ? g.toUpperCase() : g);
            e = a;
            CKEDITOR.tools.setCookie('ckCsrfToken', e);
          }
          return e;
        },
        escapeCss: function (e) {
          if (e)
            if (window.CSS && CSS.escape) e = CSS.escape(e);
            else {
              e = String(e);
              for (var a = e.length, b = -1, g, d = '', c = e.charCodeAt(0); ++b < a; )
                (g = e.charCodeAt(b)),
                  (d =
                    0 == g
                      ? d + '�'
                      : 127 == g || (1 <= g && 31 >= g) || (0 == b && 48 <= g && 57 >= g) || (1 == b && 48 <= g && 57 >= g && 45 == c)
                        ? d + ('\\' + g.toString(16) + ' ')
                        : 0 == b && 1 == a && 45 == g
                          ? d + ('\\' + e.charAt(b))
                          : 128 <= g || 45 == g || 95 == g || (48 <= g && 57 >= g) || (65 <= g && 90 >= g) || (97 <= g && 122 >= g)
                            ? d + e.charAt(b)
                            : d + ('\\' + e.charAt(b)));
              e = d;
            }
          else e = '';
          return e;
        },
        getMouseButton: function (e) {
          return (e = e && e.data ? e.data.$ : e) ? CKEDITOR.tools.normalizeMouseButton(e.button) : !1;
        },
        normalizeMouseButton: function (e, a) {
          if (!CKEDITOR.env.ie || (9 <= CKEDITOR.env.version && !CKEDITOR.env.ie6Compat)) return e;
          for (
            var b = [
                [CKEDITOR.MOUSE_BUTTON_LEFT, 1],
                [CKEDITOR.MOUSE_BUTTON_MIDDLE, 4],
                [CKEDITOR.MOUSE_BUTTON_RIGHT, 2],
              ],
              g = 0;
            g < b.length;
            g++
          ) {
            var d = b[g];
            if (d[0] === e && a) return d[1];
            if (!a && d[1] === e) return d[0];
          }
        },
        convertHexStringToBytes: function (e) {
          var a = [],
            b = e.length / 2,
            g;
          for (g = 0; g < b; g++) a.push(parseInt(e.substr(2 * g, 2), 16));
          return a;
        },
        convertBytesToBase64: function (e) {
          var a = '',
            b = e.length,
            g;
          for (g = 0; g < b; g += 3) {
            var d = e.slice(g, g + 3),
              c = d.length,
              m = [],
              f;
            if (3 > c) for (f = c; 3 > f; f++) d[f] = 0;
            m[0] = (d[0] & 252) >> 2;
            m[1] = ((d[0] & 3) << 4) | (d[1] >> 4);
            m[2] = ((d[1] & 15) << 2) | ((d[2] & 192) >> 6);
            m[3] = d[2] & 63;
            for (f = 0; 4 > f; f++)
              a = f <= c ? a + 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt(m[f]) : a + '\x3d';
          }
          return a;
        },
        style: {
          parse: {
            _borderStyle: 'none hidden dotted dashed solid double groove ridge inset outset'.split(' '),
            _widthRegExp: /^(thin|medium|thick|[\+-]?\d+(\.\d+)?[a-z%]+|[\+-]?0+(\.0+)?|\.\d+[a-z%]+)$/,
            _rgbaRegExp: /rgba?\(\s*\d+%?\s*,\s*\d+%?\s*,\s*\d+%?\s*(?:,\s*[0-9.]+\s*)?\)/gi,
            _hslaRegExp: /hsla?\(\s*[0-9.]+\s*,\s*\d+%\s*,\s*\d+%\s*(?:,\s*[0-9.]+\s*)?\)/gi,
            background: function (e) {
              var a = {},
                b = this._findColor(e);
              b.length &&
                ((a.color = b[0]),
                CKEDITOR.tools.array.forEach(b, function (a) {
                  e = e.replace(a, '');
                }));
              if ((e = CKEDITOR.tools.trim(e))) a.unprocessed = e;
              return a;
            },
            margin: function (e) {
              return CKEDITOR.tools.style.parse.sideShorthand(e, function (e) {
                return e.match(/(?:\-?[\.\d]+(?:%|\w*)|auto|inherit|initial|unset|revert)/g) || ['0px'];
              });
            },
            sideShorthand: function (e, a) {
              function b(e) {
                g.top = d[e[0]];
                g.right = d[e[1]];
                g.bottom = d[e[2]];
                g.left = d[e[3]];
              }
              var g = {},
                d = a ? a(e) : e.split(/\s+/);
              switch (d.length) {
                case 1:
                  b([0, 0, 0, 0]);
                  break;
                case 2:
                  b([0, 1, 0, 1]);
                  break;
                case 3:
                  b([0, 1, 2, 1]);
                  break;
                case 4:
                  b([0, 1, 2, 3]);
              }
              return g;
            },
            border: function (e) {
              return CKEDITOR.tools.style.border.fromCssRule(e);
            },
            _findColor: function (e) {
              var a = [],
                b = CKEDITOR.tools.array,
                a = a.concat(e.match(this._rgbaRegExp) || []),
                a = a.concat(e.match(this._hslaRegExp) || []);
              return (a = a.concat(
                b.filter(e.split(/\s+/), function (e) {
                  return e.match(/^\#[a-f0-9]{3}(?:[a-f0-9]{3})?$/gi) ? !0 : e.toLowerCase() in CKEDITOR.tools.style.parse._colors;
                }),
              ));
            },
          },
        },
        array: {
          filter: function (e, a, b) {
            var g = [];
            this.forEach(e, function (d, c) {
              a.call(b, d, c, e) && g.push(d);
            });
            return g;
          },
          find: function (e, a, b) {
            for (var g = e.length, d = 0; d < g; ) {
              if (a.call(b, e[d], d, e)) return e[d];
              d++;
            }
          },
          forEach: function (e, a, b) {
            var g = e.length,
              d;
            for (d = 0; d < g; d++) a.call(b, e[d], d, e);
          },
          map: function (e, a, b) {
            for (var g = [], d = 0; d < e.length; d++) g.push(a.call(b, e[d], d, e));
            return g;
          },
          reduce: function (e, a, b, g) {
            for (var d = 0; d < e.length; d++) b = a.call(g, b, e[d], d, e);
            return b;
          },
          every: function (e, a, b) {
            if (!e.length) return !0;
            a = this.filter(e, a, b);
            return e.length === a.length;
          },
          some: function (e, a, b) {
            for (var g = 0; g < e.length; g++) if (a.call(b, e[g], g, e)) return !0;
            return !1;
          },
          zip: function (e, a) {
            return CKEDITOR.tools.array.map(e, function (e, b) {
              return [e, a[b]];
            });
          },
          unique: function (e) {
            return this.filter(e, function (a, b) {
              return b === CKEDITOR.tools.array.indexOf(e, a);
            });
          },
        },
        object: {
          DONT_ENUMS: 'toString toLocaleString valueOf hasOwnProperty isPrototypeOf propertyIsEnumerable constructor'.split(' '),
          entries: function (e) {
            return CKEDITOR.tools.array.map(CKEDITOR.tools.object.keys(e), function (a) {
              return [a, e[a]];
            });
          },
          values: function (e) {
            return CKEDITOR.tools.array.map(CKEDITOR.tools.object.keys(e), function (a) {
              return e[a];
            });
          },
          keys: function (e) {
            var a = Object.prototype.hasOwnProperty,
              b = [],
              g = CKEDITOR.tools.object.DONT_ENUMS;
            if (CKEDITOR.env.ie && 9 > CKEDITOR.env.version && (!e || 'object' !== typeof e)) {
              a = [];
              if ('string' === typeof e) for (b = 0; b < e.length; b++) a.push(String(b));
              return a;
            }
            for (var d in e) b.push(d);
            if (CKEDITOR.env.ie && 9 > CKEDITOR.env.version) for (d = 0; d < g.length; d++) a.call(e, g[d]) && b.push(g[d]);
            return b;
          },
          findKey: function (e, a) {
            if ('object' !== typeof e) return null;
            for (var b in e) if (e[b] === a) return b;
            return null;
          },
          merge: function (e, a) {
            var b = CKEDITOR.tools,
              g = b.clone(e),
              d = b.clone(a);
            b.array.forEach(b.object.keys(d), function (e) {
              g[e] = 'object' === typeof d[e] && 'object' === typeof g[e] ? b.object.merge(g[e], d[e]) : d[e];
            });
            return g;
          },
        },
        getAbsoluteRectPosition: function (e, a) {
          function b(e) {
            if (e) {
              var a = e.getClientRect();
              g.top += a.top;
              g.left += a.left;
              'x' in g && 'y' in g && ((g.x += a.x), (g.y += a.y));
              b(e.getWindow().getFrame());
            }
          }
          var g = CKEDITOR.tools.copy(a);
          b(e.getFrame());
          var d = CKEDITOR.document.getWindow().getScrollPosition();
          g.top += d.y;
          g.left += d.x;
          'x' in g && 'y' in g && ((g.y += d.y), (g.x += d.x));
          g.right = g.left + g.width;
          g.bottom = g.top + g.height;
          return g;
        },
      };
      a.prototype = {
        reset: function () {
          this._lastOutput = 0;
          this._clearTimer();
        },
        _reschedule: function () {
          return !1;
        },
        _call: function () {
          this._output();
        },
        _clearTimer: function () {
          this._scheduledTimer && clearTimeout(this._scheduledTimer);
          this._scheduledTimer = 0;
        },
      };
      h.prototype = CKEDITOR.tools.prototypedCopy(a.prototype);
      h.prototype._reschedule = function () {
        this._scheduledTimer && this._clearTimer();
      };
      h.prototype._call = function () {
        this._output.apply(this._context, this._args);
      };
      CKEDITOR.tools.buffers = {};
      CKEDITOR.tools.buffers.event = a;
      CKEDITOR.tools.buffers.throttle = h;
      CKEDITOR.tools.style.border = CKEDITOR.tools.createClass({
        $: function (e) {
          e = e || {};
          this.width = e.width;
          this.style = e.style;
          this.color = e.color;
          this._.normalize();
        },
        _: {
          normalizeMap: { color: [[/windowtext/g, 'black']] },
          normalize: function () {
            for (var e in this._.normalizeMap) {
              var a = this[e];
              a &&
                (this[e] = CKEDITOR.tools.array.reduce(
                  this._.normalizeMap[e],
                  function (e, a) {
                    return e.replace(a[0], a[1]);
                  },
                  a,
                ));
            }
          },
        },
        proto: {
          toString: function () {
            return CKEDITOR.tools.array
              .filter([this.width, this.style, this.color], function (e) {
                return !!e;
              })
              .join(' ');
          },
        },
        statics: {
          fromCssRule: function (e) {
            var a = {},
              b = e.split(/\s+/g);
            e = CKEDITOR.tools.style.parse._findColor(e);
            e.length && (a.color = e[0]);
            CKEDITOR.tools.array.forEach(b, function (e) {
              a.style || -1 === CKEDITOR.tools.indexOf(CKEDITOR.tools.style.parse._borderStyle, e)
                ? !a.width && CKEDITOR.tools.style.parse._widthRegExp.test(e) && (a.width = e)
                : (a.style = e);
            });
            return new CKEDITOR.tools.style.border(a);
          },
          splitCssValues: function (e, a) {
            a = a || {};
            var b = CKEDITOR.tools.array.reduce(
              ['width', 'style', 'color'],
              function (b, g) {
                var d = e['border-' + g] || a[g];
                b[g] = d ? CKEDITOR.tools.style.parse.sideShorthand(d) : null;
                return b;
              },
              {},
            );
            return CKEDITOR.tools.array.reduce(
              ['top', 'right', 'bottom', 'left'],
              function (a, g) {
                var d = {},
                  c;
                for (c in b) {
                  var m = e['border-' + g + '-' + c];
                  d[c] = m ? m : b[c] && b[c][g];
                }
                a['border-' + g] = new CKEDITOR.tools.style.border(d);
                return a;
              },
              {},
            );
          },
        },
      });
      CKEDITOR.tools.array.indexOf = CKEDITOR.tools.indexOf;
      CKEDITOR.tools.array.isArray = CKEDITOR.tools.isArray;
      CKEDITOR.MOUSE_BUTTON_LEFT = 0;
      CKEDITOR.MOUSE_BUTTON_MIDDLE = 1;
      CKEDITOR.MOUSE_BUTTON_RIGHT = 2;
    })();
    CKEDITOR.dtd = (function () {
      var a = CKEDITOR.tools.extend,
        h = function (a, e) {
          for (var b = CKEDITOR.tools.clone(a), g = 1; g < arguments.length; g++) {
            e = arguments[g];
            for (var c in e) delete b[c];
          }
          return b;
        },
        f = {},
        b = {},
        c = {
          address: 1,
          article: 1,
          aside: 1,
          blockquote: 1,
          details: 1,
          div: 1,
          dl: 1,
          fieldset: 1,
          figure: 1,
          footer: 1,
          form: 1,
          h1: 1,
          h2: 1,
          h3: 1,
          h4: 1,
          h5: 1,
          h6: 1,
          header: 1,
          hgroup: 1,
          hr: 1,
          main: 1,
          menu: 1,
          nav: 1,
          ol: 1,
          p: 1,
          pre: 1,
          section: 1,
          table: 1,
          ul: 1,
        },
        l = { command: 1, link: 1, meta: 1, noscript: 1, script: 1, style: 1 },
        k = {},
        m = { '#': 1 },
        g = { center: 1, dir: 1, noframes: 1 };
      a(
        f,
        {
          a: 1,
          abbr: 1,
          area: 1,
          audio: 1,
          b: 1,
          bdi: 1,
          bdo: 1,
          br: 1,
          button: 1,
          canvas: 1,
          cite: 1,
          code: 1,
          command: 1,
          datalist: 1,
          del: 1,
          dfn: 1,
          em: 1,
          embed: 1,
          i: 1,
          iframe: 1,
          img: 1,
          input: 1,
          ins: 1,
          kbd: 1,
          keygen: 1,
          label: 1,
          map: 1,
          mark: 1,
          meter: 1,
          noscript: 1,
          object: 1,
          output: 1,
          progress: 1,
          q: 1,
          ruby: 1,
          s: 1,
          samp: 1,
          script: 1,
          select: 1,
          small: 1,
          span: 1,
          strong: 1,
          sub: 1,
          sup: 1,
          textarea: 1,
          time: 1,
          u: 1,
          var: 1,
          video: 1,
          wbr: 1,
        },
        m,
        { acronym: 1, applet: 1, basefont: 1, big: 1, font: 1, isindex: 1, strike: 1, style: 1, tt: 1 },
      );
      a(b, c, f, g);
      h = {
        a: h(f, { a: 1, button: 1 }),
        abbr: f,
        address: b,
        area: k,
        article: b,
        aside: b,
        audio: a({ source: 1, track: 1 }, b),
        b: f,
        base: k,
        bdi: f,
        bdo: f,
        blockquote: b,
        body: b,
        br: k,
        button: h(f, { a: 1, button: 1 }),
        canvas: f,
        caption: b,
        cite: f,
        code: f,
        col: k,
        colgroup: { col: 1 },
        command: k,
        datalist: a({ option: 1 }, f),
        dd: b,
        del: f,
        details: a({ summary: 1 }, b),
        dfn: f,
        div: b,
        dl: { dt: 1, dd: 1 },
        dt: b,
        em: f,
        embed: k,
        fieldset: a({ legend: 1 }, b),
        figcaption: b,
        figure: a({ figcaption: 1 }, b),
        footer: b,
        form: b,
        h1: f,
        h2: f,
        h3: f,
        h4: f,
        h5: f,
        h6: f,
        head: a({ title: 1, base: 1 }, l),
        header: b,
        hgroup: { h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1 },
        hr: k,
        html: a({ head: 1, body: 1 }, b, l),
        i: f,
        iframe: m,
        img: k,
        input: k,
        ins: f,
        kbd: f,
        keygen: k,
        label: f,
        legend: f,
        li: b,
        link: k,
        main: b,
        map: b,
        mark: f,
        menu: a({ li: 1 }, b),
        meta: k,
        meter: h(f, { meter: 1 }),
        nav: b,
        noscript: a({ link: 1, meta: 1, style: 1 }, f),
        object: a({ param: 1 }, f),
        ol: { li: 1 },
        optgroup: { option: 1 },
        option: m,
        output: f,
        p: f,
        param: k,
        pre: f,
        progress: h(f, { progress: 1 }),
        q: f,
        rp: f,
        rt: f,
        ruby: a({ rp: 1, rt: 1 }, f),
        s: f,
        samp: f,
        script: m,
        section: b,
        select: { optgroup: 1, option: 1 },
        small: f,
        source: k,
        span: f,
        strong: f,
        style: m,
        sub: f,
        summary: a({ h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1 }, f),
        sup: f,
        table: { caption: 1, colgroup: 1, thead: 1, tfoot: 1, tbody: 1, tr: 1 },
        tbody: { tr: 1 },
        td: b,
        textarea: m,
        tfoot: { tr: 1 },
        th: b,
        thead: { tr: 1 },
        time: h(f, { time: 1 }),
        title: m,
        tr: { th: 1, td: 1 },
        track: k,
        u: f,
        ul: { li: 1 },
        var: f,
        video: a({ source: 1, track: 1 }, b),
        wbr: k,
        acronym: f,
        applet: a({ param: 1 }, b),
        basefont: k,
        big: f,
        center: b,
        dialog: k,
        dir: { li: 1 },
        font: f,
        isindex: k,
        noframes: b,
        strike: f,
        tt: f,
      };
      a(h, {
        $block: a({ audio: 1, dd: 1, dt: 1, figcaption: 1, li: 1, video: 1 }, c, g),
        $blockLimit: {
          article: 1,
          aside: 1,
          audio: 1,
          body: 1,
          caption: 1,
          details: 1,
          dir: 1,
          div: 1,
          dl: 1,
          fieldset: 1,
          figcaption: 1,
          figure: 1,
          footer: 1,
          form: 1,
          header: 1,
          hgroup: 1,
          main: 1,
          menu: 1,
          nav: 1,
          ol: 1,
          section: 1,
          table: 1,
          td: 1,
          th: 1,
          tr: 1,
          ul: 1,
          video: 1,
        },
        $cdata: { script: 1, style: 1 },
        $editable: {
          address: 1,
          article: 1,
          aside: 1,
          blockquote: 1,
          body: 1,
          details: 1,
          div: 1,
          fieldset: 1,
          figcaption: 1,
          footer: 1,
          form: 1,
          h1: 1,
          h2: 1,
          h3: 1,
          h4: 1,
          h5: 1,
          h6: 1,
          header: 1,
          hgroup: 1,
          main: 1,
          nav: 1,
          p: 1,
          pre: 1,
          section: 1,
        },
        $empty: {
          area: 1,
          base: 1,
          basefont: 1,
          br: 1,
          col: 1,
          command: 1,
          dialog: 1,
          embed: 1,
          hr: 1,
          img: 1,
          input: 1,
          isindex: 1,
          keygen: 1,
          link: 1,
          meta: 1,
          param: 1,
          source: 1,
          track: 1,
          wbr: 1,
        },
        $inline: f,
        $list: { dl: 1, ol: 1, ul: 1 },
        $listItem: { dd: 1, dt: 1, li: 1 },
        $nonBodyContent: a({ body: 1, head: 1, html: 1 }, h.head),
        $nonEditable: {
          applet: 1,
          audio: 1,
          button: 1,
          embed: 1,
          iframe: 1,
          map: 1,
          object: 1,
          option: 1,
          param: 1,
          script: 1,
          textarea: 1,
          video: 1,
        },
        $object: {
          applet: 1,
          audio: 1,
          button: 1,
          hr: 1,
          iframe: 1,
          img: 1,
          input: 1,
          object: 1,
          select: 1,
          table: 1,
          textarea: 1,
          video: 1,
        },
        $removeEmpty: {
          abbr: 1,
          acronym: 1,
          b: 1,
          bdi: 1,
          bdo: 1,
          big: 1,
          cite: 1,
          code: 1,
          del: 1,
          dfn: 1,
          em: 1,
          font: 1,
          i: 1,
          ins: 1,
          label: 1,
          kbd: 1,
          mark: 1,
          meter: 1,
          output: 1,
          q: 1,
          ruby: 1,
          s: 1,
          samp: 1,
          small: 1,
          span: 1,
          strike: 1,
          strong: 1,
          sub: 1,
          sup: 1,
          time: 1,
          tt: 1,
          u: 1,
          var: 1,
        },
        $tabIndex: { a: 1, area: 1, button: 1, input: 1, object: 1, select: 1, textarea: 1 },
        $tableContent: { caption: 1, col: 1, colgroup: 1, tbody: 1, td: 1, tfoot: 1, th: 1, thead: 1, tr: 1 },
        $transparent: { a: 1, audio: 1, canvas: 1, del: 1, ins: 1, map: 1, noscript: 1, object: 1, video: 1 },
        $intermediate: {
          caption: 1,
          colgroup: 1,
          dd: 1,
          dt: 1,
          figcaption: 1,
          legend: 1,
          li: 1,
          optgroup: 1,
          option: 1,
          rp: 1,
          rt: 1,
          summary: 1,
          tbody: 1,
          td: 1,
          tfoot: 1,
          th: 1,
          thead: 1,
          tr: 1,
        },
      });
      return h;
    })();
    CKEDITOR.dom.event = function (a) {
      this.$ = a;
    };
    CKEDITOR.dom.event.prototype = {
      getKey: function () {
        return this.$.keyCode || this.$.which;
      },
      getKeystroke: function () {
        var a = this.getKey();
        if (this.$.ctrlKey || this.$.metaKey) a += CKEDITOR.CTRL;
        this.$.shiftKey && (a += CKEDITOR.SHIFT);
        this.$.altKey && (a += CKEDITOR.ALT);
        return a;
      },
      preventDefault: function (a) {
        var h = this.$;
        h.preventDefault ? h.preventDefault() : (h.returnValue = !1);
        a && this.stopPropagation();
      },
      stopPropagation: function () {
        var a = this.$;
        a.stopPropagation ? a.stopPropagation() : (a.cancelBubble = !0);
      },
      getTarget: function () {
        var a = this.$.target || this.$.srcElement;
        return a ? new CKEDITOR.dom.node(a) : null;
      },
      getPhase: function () {
        return this.$.eventPhase || 2;
      },
      getPageOffset: function () {
        var a = this.getTarget().getDocument().$;
        return {
          x: this.$.pageX || this.$.clientX + (a.documentElement.scrollLeft || a.body.scrollLeft),
          y: this.$.pageY || this.$.clientY + (a.documentElement.scrollTop || a.body.scrollTop),
        };
      },
    };
    CKEDITOR.CTRL = 1114112;
    CKEDITOR.SHIFT = 2228224;
    CKEDITOR.ALT = 4456448;
    CKEDITOR.EVENT_PHASE_CAPTURING = 1;
    CKEDITOR.EVENT_PHASE_AT_TARGET = 2;
    CKEDITOR.EVENT_PHASE_BUBBLING = 3;
    CKEDITOR.HISTORY_NATIVE = 1;
    CKEDITOR.HISTORY_HASH = 2;
    CKEDITOR.HISTORY_OFF = 0;
    CKEDITOR.dom.domObject = function (a) {
      a && (this.$ = a);
    };
    CKEDITOR.dom.domObject.prototype = (function () {
      var a = function (a, f) {
        return function (b) {
          'undefined' != typeof CKEDITOR && a.fire(f, new CKEDITOR.dom.event(b));
        };
      };
      return {
        getPrivate: function () {
          var a;
          (a = this.getCustomData('_')) || this.setCustomData('_', (a = {}));
          return a;
        },
        on: function (h) {
          var f = this.getCustomData('_cke_nativeListeners');
          f || ((f = {}), this.setCustomData('_cke_nativeListeners', f));
          f[h] ||
            ((f = f[h] = a(this, h)),
            this.$.addEventListener
              ? this.$.addEventListener(h, f, !!CKEDITOR.event.useCapture)
              : this.$.attachEvent && this.$.attachEvent('on' + h, f));
          return CKEDITOR.event.prototype.on.apply(this, arguments);
        },
        removeListener: function (a) {
          CKEDITOR.event.prototype.removeListener.apply(this, arguments);
          if (!this.hasListeners(a)) {
            var f = this.getCustomData('_cke_nativeListeners'),
              b = f && f[a];
            b &&
              (this.$.removeEventListener ? this.$.removeEventListener(a, b, !1) : this.$.detachEvent && this.$.detachEvent('on' + a, b),
              delete f[a]);
          }
        },
        removeAllListeners: function () {
          try {
            var a = this.getCustomData('_cke_nativeListeners'),
              f;
            for (f in a) {
              var b = a[f];
              this.$.detachEvent ? this.$.detachEvent('on' + f, b) : this.$.removeEventListener && this.$.removeEventListener(f, b, !1);
              delete a[f];
            }
          } catch (c) {
            if (!CKEDITOR.env.edge || -2146828218 !== c.number) throw c;
          }
          CKEDITOR.event.prototype.removeAllListeners.call(this);
        },
      };
    })();
    (function (a) {
      var h = {};
      CKEDITOR.on('reset', function () {
        h = {};
      });
      a.equals = function (a) {
        try {
          return a && a.$ === this.$;
        } catch (b) {
          return !1;
        }
      };
      a.setCustomData = function (a, b) {
        var c = this.getUniqueId();
        (h[c] || (h[c] = {}))[a] = b;
        return this;
      };
      a.getCustomData = function (a) {
        var b = this.$['data-cke-expando'];
        return (b = b && h[b]) && a in b ? b[a] : null;
      };
      a.removeCustomData = function (a) {
        var b = this.$['data-cke-expando'],
          b = b && h[b],
          c,
          l;
        b && ((c = b[a]), (l = a in b), delete b[a]);
        return l ? c : null;
      };
      a.clearCustomData = function () {
        this.removeAllListeners();
        var a = this.getUniqueId();
        a && delete h[a];
      };
      a.getUniqueId = function () {
        return this.$['data-cke-expando'] || (this.$['data-cke-expando'] = CKEDITOR.tools.getNextNumber());
      };
      CKEDITOR.event.implementOn(a);
    })(CKEDITOR.dom.domObject.prototype);
    CKEDITOR.dom.node = function (a) {
      return a
        ? new CKEDITOR.dom[
            a.nodeType == CKEDITOR.NODE_DOCUMENT
              ? 'document'
              : a.nodeType == CKEDITOR.NODE_ELEMENT
                ? 'element'
                : a.nodeType == CKEDITOR.NODE_TEXT
                  ? 'text'
                  : a.nodeType == CKEDITOR.NODE_COMMENT
                    ? 'comment'
                    : a.nodeType == CKEDITOR.NODE_DOCUMENT_FRAGMENT
                      ? 'documentFragment'
                      : 'domObject'
          ](a)
        : this;
    };
    CKEDITOR.dom.node.prototype = new CKEDITOR.dom.domObject();
    CKEDITOR.NODE_ELEMENT = 1;
    CKEDITOR.NODE_DOCUMENT = 9;
    CKEDITOR.NODE_TEXT = 3;
    CKEDITOR.NODE_COMMENT = 8;
    CKEDITOR.NODE_DOCUMENT_FRAGMENT = 11;
    CKEDITOR.POSITION_IDENTICAL = 0;
    CKEDITOR.POSITION_DISCONNECTED = 1;
    CKEDITOR.POSITION_FOLLOWING = 2;
    CKEDITOR.POSITION_PRECEDING = 4;
    CKEDITOR.POSITION_IS_CONTAINED = 8;
    CKEDITOR.POSITION_CONTAINS = 16;
    CKEDITOR.tools.extend(CKEDITOR.dom.node.prototype, {
      appendTo: function (a, h) {
        a.append(this, h);
        return a;
      },
      clone: function (a, h) {
        function f(b) {
          b['data-cke-expando'] && (b['data-cke-expando'] = !1);
          if (b.nodeType == CKEDITOR.NODE_ELEMENT || b.nodeType == CKEDITOR.NODE_DOCUMENT_FRAGMENT)
            if ((h || b.nodeType != CKEDITOR.NODE_ELEMENT || b.removeAttribute('id', !1), a)) {
              b = b.childNodes;
              for (var c = 0; c < b.length; c++) f(b[c]);
            }
        }
        function b(c) {
          if (c.type == CKEDITOR.NODE_ELEMENT || c.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT) {
            if (c.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT) {
              var f = c.getName();
              ':' == f[0] && c.renameNode(f.substring(1));
            }
            if (a) for (f = 0; f < c.getChildCount(); f++) b(c.getChild(f));
          }
        }
        var c = this.$.cloneNode(a);
        f(c);
        c = new CKEDITOR.dom.node(c);
        CKEDITOR.env.ie &&
          9 > CKEDITOR.env.version &&
          (this.type == CKEDITOR.NODE_ELEMENT || this.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT) &&
          b(c);
        return c;
      },
      hasPrevious: function () {
        return !!this.$.previousSibling;
      },
      hasNext: function () {
        return !!this.$.nextSibling;
      },
      insertAfter: function (a) {
        a.$.parentNode.insertBefore(this.$, a.$.nextSibling);
        return a;
      },
      insertBefore: function (a) {
        a.$.parentNode.insertBefore(this.$, a.$);
        return a;
      },
      insertBeforeMe: function (a) {
        this.$.parentNode.insertBefore(a.$, this.$);
        return a;
      },
      getAddress: function (a) {
        for (var h = [], f = this.getDocument().$.documentElement, b = this; b && b != f; ) {
          var c = b.getParent();
          c && h.unshift(this.getIndex.call(b, a));
          b = c;
        }
        return h;
      },
      getDocument: function () {
        return new CKEDITOR.dom.document(this.$.ownerDocument || this.$.parentNode.ownerDocument);
      },
      getIndex: function (a) {
        function h(a, b) {
          var c = b ? a.getNext() : a.getPrevious();
          return c && c.type == CKEDITOR.NODE_TEXT ? (c.isEmpty() ? h(c, b) : c) : null;
        }
        var f = this,
          b = -1,
          c;
        if (!this.getParent() || (a && f.type == CKEDITOR.NODE_TEXT && f.isEmpty() && !h(f) && !h(f, !0))) return -1;
        do if (!a || f.equals(this) || f.type != CKEDITOR.NODE_TEXT || (!c && !f.isEmpty())) b++, (c = f.type == CKEDITOR.NODE_TEXT);
        while ((f = f.getPrevious()));
        return b;
      },
      getNextSourceNode: function (a, h, f) {
        if (f && !f.call) {
          var b = f;
          f = function (a) {
            return !a.equals(b);
          };
        }
        a = !a && this.getFirst && this.getFirst();
        var c;
        if (!a) {
          if (this.type == CKEDITOR.NODE_ELEMENT && f && !1 === f(this, !0)) return null;
          a = this.getNext();
        }
        for (; !a && (c = (c || this).getParent()); ) {
          if (f && !1 === f(c, !0)) return null;
          a = c.getNext();
        }
        return !a || (f && !1 === f(a)) ? null : h && h != a.type ? a.getNextSourceNode(!1, h, f) : a;
      },
      getPreviousSourceNode: function (a, h, f) {
        if (f && !f.call) {
          var b = f;
          f = function (a) {
            return !a.equals(b);
          };
        }
        a = !a && this.getLast && this.getLast();
        var c;
        if (!a) {
          if (this.type == CKEDITOR.NODE_ELEMENT && f && !1 === f(this, !0)) return null;
          a = this.getPrevious();
        }
        for (; !a && (c = (c || this).getParent()); ) {
          if (f && !1 === f(c, !0)) return null;
          a = c.getPrevious();
        }
        return !a || (f && !1 === f(a)) ? null : h && a.type != h ? a.getPreviousSourceNode(!1, h, f) : a;
      },
      getPrevious: function (a) {
        var h = this.$,
          f;
        do f = (h = h.previousSibling) && 10 != h.nodeType && new CKEDITOR.dom.node(h);
        while (f && a && !a(f));
        return f;
      },
      getNext: function (a) {
        var h = this.$,
          f;
        do f = (h = h.nextSibling) && new CKEDITOR.dom.node(h);
        while (f && a && !a(f));
        return f;
      },
      getParent: function (a) {
        var h = this.$.parentNode;
        return h && (h.nodeType == CKEDITOR.NODE_ELEMENT || (a && h.nodeType == CKEDITOR.NODE_DOCUMENT_FRAGMENT))
          ? new CKEDITOR.dom.node(h)
          : null;
      },
      getParents: function (a) {
        var h = this,
          f = [];
        do f[a ? 'push' : 'unshift'](h);
        while ((h = h.getParent()));
        return f;
      },
      getCommonAncestor: function (a) {
        if (a.equals(this)) return this;
        if (a.contains && a.contains(this)) return a;
        var h = this.contains ? this : this.getParent();
        do if (h.contains(a)) return h;
        while ((h = h.getParent()));
        return null;
      },
      getPosition: function (a) {
        var h = this.$,
          f = a.$;
        if (h.compareDocumentPosition) return h.compareDocumentPosition(f);
        if (h == f) return CKEDITOR.POSITION_IDENTICAL;
        if (this.type == CKEDITOR.NODE_ELEMENT && a.type == CKEDITOR.NODE_ELEMENT) {
          if (h.contains) {
            if (h.contains(f)) return CKEDITOR.POSITION_CONTAINS + CKEDITOR.POSITION_PRECEDING;
            if (f.contains(h)) return CKEDITOR.POSITION_IS_CONTAINED + CKEDITOR.POSITION_FOLLOWING;
          }
          if ('sourceIndex' in h)
            return 0 > h.sourceIndex || 0 > f.sourceIndex
              ? CKEDITOR.POSITION_DISCONNECTED
              : h.sourceIndex < f.sourceIndex
                ? CKEDITOR.POSITION_PRECEDING
                : CKEDITOR.POSITION_FOLLOWING;
        }
        h = this.getAddress();
        a = a.getAddress();
        for (var f = Math.min(h.length, a.length), b = 0; b < f; b++)
          if (h[b] != a[b]) return h[b] < a[b] ? CKEDITOR.POSITION_PRECEDING : CKEDITOR.POSITION_FOLLOWING;
        return h.length < a.length
          ? CKEDITOR.POSITION_CONTAINS + CKEDITOR.POSITION_PRECEDING
          : CKEDITOR.POSITION_IS_CONTAINED + CKEDITOR.POSITION_FOLLOWING;
      },
      getAscendant: function (a, h) {
        var f = this.$,
          b,
          c;
        h || (f = f.parentNode);
        'function' == typeof a
          ? ((c = !0), (b = a))
          : ((c = !1),
            (b = function (b) {
              b = 'string' == typeof b.nodeName ? b.nodeName.toLowerCase() : '';
              return 'string' == typeof a ? b == a : b in a;
            }));
        for (; f; ) {
          if (b(c ? new CKEDITOR.dom.node(f) : f)) return new CKEDITOR.dom.node(f);
          try {
            f = f.parentNode;
          } catch (l) {
            f = null;
          }
        }
        return null;
      },
      hasAscendant: function (a, h) {
        var f = this.$;
        h || (f = f.parentNode);
        for (; f; ) {
          if (f.nodeName && f.nodeName.toLowerCase() == a) return !0;
          f = f.parentNode;
        }
        return !1;
      },
      move: function (a, h) {
        a.append(this.remove(), h);
      },
      remove: function (a) {
        var h = this.$,
          f = h.parentNode;
        if (f) {
          if (a) for (; (a = h.firstChild); ) f.insertBefore(h.removeChild(a), h);
          f.removeChild(h);
        }
        return this;
      },
      replace: function (a) {
        this.insertBefore(a);
        a.remove();
      },
      trim: function () {
        this.ltrim();
        this.rtrim();
      },
      ltrim: function () {
        for (var a; this.getFirst && (a = this.getFirst()); ) {
          if (a.type == CKEDITOR.NODE_TEXT) {
            var h = CKEDITOR.tools.ltrim(a.getText()),
              f = a.getLength();
            if (h) h.length < f && (a.split(f - h.length), this.$.removeChild(this.$.firstChild));
            else {
              a.remove();
              continue;
            }
          }
          break;
        }
      },
      rtrim: function () {
        for (var a; this.getLast && (a = this.getLast()); ) {
          if (a.type == CKEDITOR.NODE_TEXT) {
            var h = CKEDITOR.tools.rtrim(a.getText()),
              f = a.getLength();
            if (h) h.length < f && (a.split(h.length), this.$.lastChild.parentNode.removeChild(this.$.lastChild));
            else {
              a.remove();
              continue;
            }
          }
          break;
        }
        CKEDITOR.env.needsBrFiller &&
          (a = this.$.lastChild) &&
          1 == a.type &&
          'br' == a.nodeName.toLowerCase() &&
          a.parentNode.removeChild(a);
      },
      isReadOnly: function (a) {
        var h = this;
        this.type != CKEDITOR.NODE_ELEMENT && (h = this.getParent());
        CKEDITOR.env.edge && h && h.is('textarea', 'input') && (a = !0);
        if (!a && h && 'undefined' != typeof h.$.isContentEditable) return !(h.$.isContentEditable || h.data('cke-editable'));
        for (; h; ) {
          if (h.data('cke-editable')) return !1;
          if (h.hasAttribute('contenteditable')) return 'false' == h.getAttribute('contenteditable');
          h = h.getParent();
        }
        return !0;
      },
    });
    CKEDITOR.dom.window = function (a) {
      CKEDITOR.dom.domObject.call(this, a);
    };
    CKEDITOR.dom.window.prototype = new CKEDITOR.dom.domObject();
    CKEDITOR.tools.extend(CKEDITOR.dom.window.prototype, {
      focus: function () {
        this.$.focus();
      },
      getViewPaneSize: function () {
        var a = this.$.document,
          h = 'CSS1Compat' == a.compatMode;
        return {
          width: (h ? a.documentElement.clientWidth : a.body.clientWidth) || 0,
          height: (h ? a.documentElement.clientHeight : a.body.clientHeight) || 0,
        };
      },
      getScrollPosition: function () {
        var a = this.$;
        if ('pageXOffset' in a) return { x: a.pageXOffset || 0, y: a.pageYOffset || 0 };
        a = a.document;
        return { x: a.documentElement.scrollLeft || a.body.scrollLeft || 0, y: a.documentElement.scrollTop || a.body.scrollTop || 0 };
      },
      getFrame: function () {
        var a = this.$.frameElement;
        return a ? new CKEDITOR.dom.element.get(a) : null;
      },
    });
    CKEDITOR.dom.document = function (a) {
      CKEDITOR.dom.domObject.call(this, a);
    };
    CKEDITOR.dom.document.prototype = new CKEDITOR.dom.domObject();
    CKEDITOR.tools.extend(CKEDITOR.dom.document.prototype, {
      type: CKEDITOR.NODE_DOCUMENT,
      appendStyleSheet: function (a) {
        a = CKEDITOR.appendTimestamp(a);
        if (this.$.createStyleSheet) this.$.createStyleSheet(a);
        else {
          var h = new CKEDITOR.dom.element('link');
          h.setAttributes({ rel: 'stylesheet', type: 'text/css', href: a });
          this.getHead().append(h);
        }
      },
      appendStyleText: function (a) {
        if (this.$.createStyleSheet) {
          var h = this.$.createStyleSheet('');
          h.cssText = a;
        } else {
          var f = new CKEDITOR.dom.element('style', this);
          f.append(new CKEDITOR.dom.text(a, this));
          this.getHead().append(f);
        }
        return h || f.$.sheet;
      },
      createElement: function (a, h) {
        var f = new CKEDITOR.dom.element(a, this);
        h && (h.attributes && f.setAttributes(h.attributes), h.styles && f.setStyles(h.styles));
        return f;
      },
      createText: function (a) {
        return new CKEDITOR.dom.text(a, this);
      },
      focus: function () {
        this.getWindow().focus();
      },
      getActive: function () {
        var a;
        try {
          a = this.$.activeElement;
        } catch (h) {
          return null;
        }
        return new CKEDITOR.dom.element(a);
      },
      getById: function (a) {
        return (a = this.$.getElementById(a)) ? new CKEDITOR.dom.element(a) : null;
      },
      getByAddress: function (a, h) {
        for (var f = this.$.documentElement, b = 0; f && b < a.length; b++) {
          var c = a[b];
          if (h)
            for (var l = -1, k = 0; k < f.childNodes.length; k++) {
              var m = f.childNodes[k];
              if (!0 !== h || 3 != m.nodeType || !m.previousSibling || 3 != m.previousSibling.nodeType)
                if ((l++, l == c)) {
                  f = m;
                  break;
                }
            }
          else f = f.childNodes[c];
        }
        return f ? new CKEDITOR.dom.node(f) : null;
      },
      getElementsByTag: function (a, h) {
        (CKEDITOR.env.ie && 8 >= document.documentMode) || !h || (a = h + ':' + a);
        return new CKEDITOR.dom.nodeList(this.$.getElementsByTagName(a));
      },
      getHead: function () {
        var a = this.$.getElementsByTagName('head')[0];
        return (a = a ? new CKEDITOR.dom.element(a) : this.getDocumentElement().append(new CKEDITOR.dom.element('head'), !0));
      },
      getBody: function () {
        return new CKEDITOR.dom.element(this.$.body);
      },
      getDocumentElement: function () {
        return new CKEDITOR.dom.element(this.$.documentElement);
      },
      getWindow: function () {
        return new CKEDITOR.dom.window(this.$.parentWindow || this.$.defaultView);
      },
      write: function (a) {
        this.$.open('text/html', 'replace');
        CKEDITOR.env.ie &&
          (a = a.replace(
            /(?:^\s*<!DOCTYPE[^>]*?>)|^/i,
            '$\x26\n\x3cscript data-cke-temp\x3d"1"\x3e(' + CKEDITOR.tools.fixDomain + ')();\x3c/script\x3e',
          ));
        this.$.write(a);
        this.$.close();
      },
      find: function (a) {
        return new CKEDITOR.dom.nodeList(this.$.querySelectorAll(a));
      },
      findOne: function (a) {
        return (a = this.$.querySelector(a)) ? new CKEDITOR.dom.element(a) : null;
      },
      _getHtml5ShivFrag: function () {
        var a = this.getCustomData('html5ShivFrag');
        a || ((a = this.$.createDocumentFragment()), CKEDITOR.tools.enableHtml5Elements(a, !0), this.setCustomData('html5ShivFrag', a));
        return a;
      },
    });
    CKEDITOR.dom.nodeList = function (a) {
      this.$ = a;
    };
    CKEDITOR.dom.nodeList.prototype = {
      count: function () {
        return this.$.length;
      },
      getItem: function (a) {
        return 0 > a || a >= this.$.length ? null : (a = this.$[a]) ? new CKEDITOR.dom.node(a) : null;
      },
      toArray: function () {
        return CKEDITOR.tools.array.map(this.$, function (a) {
          return new CKEDITOR.dom.node(a);
        });
      },
    };
    CKEDITOR.dom.element = function (a, h) {
      'string' == typeof a && (a = (h ? h.$ : document).createElement(a));
      CKEDITOR.dom.domObject.call(this, a);
    };
    CKEDITOR.dom.element.get = function (a) {
      return (
        (a = 'string' == typeof a ? document.getElementById(a) || document.getElementsByName(a)[0] : a) &&
        (a.$ ? a : new CKEDITOR.dom.element(a))
      );
    };
    CKEDITOR.dom.element.prototype = new CKEDITOR.dom.node();
    CKEDITOR.dom.element.createFromHtml = function (a, h) {
      var f = new CKEDITOR.dom.element('div', h);
      f.setHtml(a);
      return f.getFirst().remove();
    };
    CKEDITOR.dom.element.setMarker = function (a, h, f, b) {
      var c =
          h.getCustomData('list_marker_id') ||
          h.setCustomData('list_marker_id', CKEDITOR.tools.getNextNumber()).getCustomData('list_marker_id'),
        l = h.getCustomData('list_marker_names') || h.setCustomData('list_marker_names', {}).getCustomData('list_marker_names');
      a[c] = h;
      l[f] = 1;
      return h.setCustomData(f, b);
    };
    CKEDITOR.dom.element.clearAllMarkers = function (a) {
      for (var h in a) CKEDITOR.dom.element.clearMarkers(a, a[h], 1);
    };
    CKEDITOR.dom.element.clearMarkers = function (a, h, f) {
      var b = h.getCustomData('list_marker_names'),
        c = h.getCustomData('list_marker_id'),
        l;
      for (l in b) h.removeCustomData(l);
      h.removeCustomData('list_marker_names');
      f && (h.removeCustomData('list_marker_id'), delete a[c]);
    };
    (function () {
      function a(a, b) {
        return -1 < (' ' + a + ' ').replace(l, ' ').indexOf(' ' + b + ' ');
      }
      function h(a) {
        var b = !0;
        a.$.id || ((a.$.id = 'cke_tmp_' + CKEDITOR.tools.getNextNumber()), (b = !1));
        return function () {
          b || a.removeAttribute('id');
        };
      }
      function f(a, b) {
        var d = CKEDITOR.tools.escapeCss(a.$.id);
        return '#' + d + ' ' + b.split(/,\s*/).join(', #' + d + ' ');
      }
      function b(a) {
        for (var b = 0, d = 0, e = k[a].length; d < e; d++) b += parseFloat(this.getComputedStyle(k[a][d]) || 0, 10) || 0;
        return b;
      }
      var c = document.createElement('_').classList,
        c = 'undefined' !== typeof c && null !== String(c.add).match(/\[Native code\]/gi),
        l = /[\n\t\r]/g;
      CKEDITOR.tools.extend(CKEDITOR.dom.element.prototype, {
        type: CKEDITOR.NODE_ELEMENT,
        addClass: c
          ? function (a) {
              this.$.classList.add(a);
              return this;
            }
          : function (b) {
              var g = this.$.className;
              g && (a(g, b) || (g += ' ' + b));
              this.$.className = g || b;
              return this;
            },
        removeClass: c
          ? function (a) {
              var b = this.$;
              b.classList.remove(a);
              b.className || b.removeAttribute('class');
              return this;
            }
          : function (b) {
              var g = this.getAttribute('class');
              g &&
                a(g, b) &&
                ((g = g.replace(new RegExp('(?:^|\\s+)' + b + '(?\x3d\\s|$)'), '').replace(/^\s+/, ''))
                  ? this.setAttribute('class', g)
                  : this.removeAttribute('class'));
              return this;
            },
        hasClass: function (b) {
          return a(this.$.className, b);
        },
        append: function (a, b) {
          'string' == typeof a && (a = this.getDocument().createElement(a));
          b ? this.$.insertBefore(a.$, this.$.firstChild) : this.$.appendChild(a.$);
          return a;
        },
        appendHtml: function (a) {
          if (this.$.childNodes.length) {
            var b = new CKEDITOR.dom.element('div', this.getDocument());
            b.setHtml(a);
            b.moveChildren(this);
          } else this.setHtml(a);
        },
        appendText: function (a) {
          null != this.$.text && CKEDITOR.env.ie && 9 > CKEDITOR.env.version ? (this.$.text += a) : this.append(new CKEDITOR.dom.text(a));
        },
        appendBogus: function (a) {
          if (a || CKEDITOR.env.needsBrFiller) {
            for (a = this.getLast(); a && a.type == CKEDITOR.NODE_TEXT && !CKEDITOR.tools.rtrim(a.getText()); ) a = a.getPrevious();
            (a && a.is && a.is('br')) ||
              ((a = this.getDocument().createElement('br')), CKEDITOR.env.gecko && a.setAttribute('type', '_moz'), this.append(a));
          }
        },
        breakParent: function (a, b) {
          var d = new CKEDITOR.dom.range(this.getDocument());
          d.setStartAfter(this);
          d.setEndAfter(a);
          var e = d.extractContents(!1, b || !1),
            c;
          d.insertNode(this.remove());
          if (CKEDITOR.env.ie && !CKEDITOR.env.edge) {
            for (d = new CKEDITOR.dom.element('div'); (c = e.getFirst()); )
              c.$.style.backgroundColor && (c.$.style.backgroundColor = c.$.style.backgroundColor), d.append(c);
            d.insertAfter(this);
            d.remove(!0);
          } else e.insertAfterNode(this);
        },
        contains: document.compareDocumentPosition
          ? function (a) {
              return !!(this.$.compareDocumentPosition(a.$) & 16);
            }
          : function (a) {
              var b = this.$;
              return a.type != CKEDITOR.NODE_ELEMENT ? b.contains(a.getParent().$) : b != a.$ && b.contains(a.$);
            },
        focus: (function () {
          function a() {
            try {
              this.$.focus();
            } catch (b) {}
          }
          return function (b) {
            b ? CKEDITOR.tools.setTimeout(a, 100, this) : a.call(this);
          };
        })(),
        getHtml: function () {
          var a = this.$.innerHTML;
          return CKEDITOR.env.ie ? a.replace(/<\?[^>]*>/g, '') : a;
        },
        getOuterHtml: function () {
          if (this.$.outerHTML) return this.$.outerHTML.replace(/<\?[^>]*>/, '');
          var a = this.$.ownerDocument.createElement('div');
          a.appendChild(this.$.cloneNode(!0));
          return a.innerHTML;
        },
        getClientRect: function (a) {
          var b = CKEDITOR.tools.extend({}, this.$.getBoundingClientRect());
          !b.width && (b.width = b.right - b.left);
          !b.height && (b.height = b.bottom - b.top);
          return a ? CKEDITOR.tools.getAbsoluteRectPosition(this.getWindow(), b) : b;
        },
        setHtml:
          CKEDITOR.env.ie && 9 > CKEDITOR.env.version
            ? function (a) {
                try {
                  var b = this.$;
                  if (this.getParent()) return (b.innerHTML = a);
                  var d = this.getDocument()._getHtml5ShivFrag();
                  d.appendChild(b);
                  b.innerHTML = a;
                  d.removeChild(b);
                  return a;
                } catch (e) {
                  this.$.innerHTML = '';
                  b = new CKEDITOR.dom.element('body', this.getDocument());
                  b.$.innerHTML = a;
                  for (b = b.getChildren(); b.count(); ) this.append(b.getItem(0));
                  return a;
                }
              }
            : function (a) {
                return (this.$.innerHTML = a);
              },
        setText: (function () {
          var a = document.createElement('p');
          a.innerHTML = 'x';
          a = a.textContent;
          return function (b) {
            this.$[a ? 'textContent' : 'innerText'] = b;
          };
        })(),
        getAttribute: (function () {
          var a = function (a) {
            return this.$.getAttribute(a, 2);
          };
          return CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks)
            ? function (a) {
                switch (a) {
                  case 'class':
                    a = 'className';
                    break;
                  case 'http-equiv':
                    a = 'httpEquiv';
                    break;
                  case 'name':
                    return this.$.name;
                  case 'tabindex':
                    return (a = this.$.getAttribute(a, 2)), 0 !== a && 0 === this.$.tabIndex && (a = null), a;
                  case 'checked':
                    return (a = this.$.attributes.getNamedItem(a)), (a.specified ? a.nodeValue : this.$.checked) ? 'checked' : null;
                  case 'hspace':
                  case 'value':
                    return this.$[a];
                  case 'style':
                    return this.$.style.cssText;
                  case 'contenteditable':
                  case 'contentEditable':
                    return this.$.attributes.getNamedItem('contentEditable').specified ? this.$.getAttribute('contentEditable') : null;
                }
                return this.$.getAttribute(a, 2);
              }
            : a;
        })(),
        getAttributes: function (a) {
          var b = {},
            d = this.$.attributes,
            e;
          a = CKEDITOR.tools.isArray(a) ? a : [];
          for (e = 0; e < d.length; e++) -1 === CKEDITOR.tools.indexOf(a, d[e].name) && (b[d[e].name] = d[e].value);
          return b;
        },
        getChildren: function () {
          return new CKEDITOR.dom.nodeList(this.$.childNodes);
        },
        getClientSize: function () {
          return { width: this.$.clientWidth, height: this.$.clientHeight };
        },
        getComputedStyle:
          document.defaultView && document.defaultView.getComputedStyle
            ? function (a) {
                var b = this.getWindow().$.getComputedStyle(this.$, null);
                return b ? b.getPropertyValue(a) : '';
              }
            : function (a) {
                return this.$.currentStyle[CKEDITOR.tools.cssStyleToDomStyle(a)];
              },
        getDtd: function () {
          var a = CKEDITOR.dtd[this.getName()];
          this.getDtd = function () {
            return a;
          };
          return a;
        },
        getElementsByTag: CKEDITOR.dom.document.prototype.getElementsByTag,
        getTabIndex: function () {
          var a = this.$.tabIndex;
          return 0 !== a || CKEDITOR.dtd.$tabIndex[this.getName()] || 0 === parseInt(this.getAttribute('tabindex'), 10) ? a : -1;
        },
        getText: function () {
          return this.$.textContent || this.$.innerText || '';
        },
        getWindow: function () {
          return this.getDocument().getWindow();
        },
        getId: function () {
          return this.$.id || null;
        },
        getNameAtt: function () {
          return this.$.name || null;
        },
        getName: function () {
          var a = this.$.nodeName.toLowerCase();
          if (CKEDITOR.env.ie && 8 >= document.documentMode) {
            var b = this.$.scopeName;
            'HTML' != b && (a = b.toLowerCase() + ':' + a);
          }
          this.getName = function () {
            return a;
          };
          return this.getName();
        },
        getValue: function () {
          return this.$.value;
        },
        getFirst: function (a) {
          var b = this.$.firstChild;
          (b = b && new CKEDITOR.dom.node(b)) && a && !a(b) && (b = b.getNext(a));
          return b;
        },
        getLast: function (a) {
          var b = this.$.lastChild;
          (b = b && new CKEDITOR.dom.node(b)) && a && !a(b) && (b = b.getPrevious(a));
          return b;
        },
        getStyle: function (a) {
          return this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)];
        },
        is: function () {
          var a = this.getName();
          if ('object' == typeof arguments[0]) return !!arguments[0][a];
          for (var b = 0; b < arguments.length; b++) if (arguments[b] == a) return !0;
          return !1;
        },
        isEditable: function (a) {
          var b = this.getName();
          return this.isReadOnly() ||
            'none' == this.getComputedStyle('display') ||
            'hidden' == this.getComputedStyle('visibility') ||
            CKEDITOR.dtd.$nonEditable[b] ||
            CKEDITOR.dtd.$empty[b] ||
            (this.is('a') && (this.data('cke-saved-name') || this.hasAttribute('name')) && !this.getChildCount())
            ? !1
            : !1 !== a
              ? ((a = CKEDITOR.dtd[b] || CKEDITOR.dtd.span), !(!a || !a['#']))
              : !0;
        },
        isIdentical: function (a) {
          var b = this.clone(0, 1);
          a = a.clone(0, 1);
          b.removeAttributes(['_moz_dirty', 'data-cke-expando', 'data-cke-saved-href', 'data-cke-saved-name']);
          a.removeAttributes(['_moz_dirty', 'data-cke-expando', 'data-cke-saved-href', 'data-cke-saved-name']);
          if (b.$.isEqualNode)
            return (
              (b.$.style.cssText = CKEDITOR.tools.normalizeCssText(b.$.style.cssText)),
              (a.$.style.cssText = CKEDITOR.tools.normalizeCssText(a.$.style.cssText)),
              b.$.isEqualNode(a.$)
            );
          b = b.getOuterHtml();
          a = a.getOuterHtml();
          if (CKEDITOR.env.ie && 9 > CKEDITOR.env.version && this.is('a')) {
            var d = this.getParent();
            d.type == CKEDITOR.NODE_ELEMENT && ((d = d.clone()), d.setHtml(b), (b = d.getHtml()), d.setHtml(a), (a = d.getHtml()));
          }
          return b == a;
        },
        isVisible: function () {
          var a = (this.$.offsetHeight || this.$.offsetWidth) && 'hidden' != this.getComputedStyle('visibility'),
            b,
            d;
          a &&
            CKEDITOR.env.webkit &&
            ((b = this.getWindow()),
            !b.equals(CKEDITOR.document.getWindow()) && (d = b.$.frameElement) && (a = new CKEDITOR.dom.element(d).isVisible()));
          return !!a;
        },
        isEmptyInlineRemoveable: function () {
          if (!CKEDITOR.dtd.$removeEmpty[this.getName()]) return !1;
          for (var a = this.getChildren(), b = 0, d = a.count(); b < d; b++) {
            var e = a.getItem(b);
            if (e.type != CKEDITOR.NODE_ELEMENT || !e.data('cke-bookmark'))
              if (
                (e.type == CKEDITOR.NODE_ELEMENT && !e.isEmptyInlineRemoveable()) ||
                (e.type == CKEDITOR.NODE_TEXT && CKEDITOR.tools.trim(e.getText()))
              )
                return !1;
          }
          return !0;
        },
        hasAttributes:
          CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks)
            ? function () {
                for (var a = this.$.attributes, b = 0; b < a.length; b++) {
                  var d = a[b];
                  switch (d.nodeName) {
                    case 'class':
                      if (this.getAttribute('class')) return !0;
                    case 'data-cke-expando':
                      continue;
                    default:
                      if (d.specified) return !0;
                  }
                }
                return !1;
              }
            : function () {
                var a = this.$.attributes,
                  b = a.length,
                  d = { 'data-cke-expando': 1, _moz_dirty: 1 };
                return 0 < b && (2 < b || !d[a[0].nodeName] || (2 == b && !d[a[1].nodeName]));
              },
        hasAttribute: (function () {
          function a(b) {
            var d = this.$.attributes.getNamedItem(b);
            if ('input' == this.getName())
              switch (b) {
                case 'class':
                  return 0 < this.$.className.length;
                case 'checked':
                  return !!this.$.checked;
                case 'value':
                  return (b = this.getAttribute('type')), 'checkbox' == b || 'radio' == b ? 'on' != this.$.value : !!this.$.value;
              }
            return d ? d.specified : !1;
          }
          return CKEDITOR.env.ie
            ? 8 > CKEDITOR.env.version
              ? function (b) {
                  return 'name' == b ? !!this.$.name : a.call(this, b);
                }
              : a
            : function (a) {
                return !!this.$.attributes.getNamedItem(a);
              };
        })(),
        hide: function () {
          this.setStyle('display', 'none');
        },
        moveChildren: function (a, b) {
          var d = this.$;
          a = a.$;
          if (d != a) {
            var e;
            if (b) for (; (e = d.lastChild); ) a.insertBefore(d.removeChild(e), a.firstChild);
            else for (; (e = d.firstChild); ) a.appendChild(d.removeChild(e));
          }
        },
        mergeSiblings: (function () {
          function a(b, d, e) {
            if (d && d.type == CKEDITOR.NODE_ELEMENT) {
              for (var c = []; d.data('cke-bookmark') || d.isEmptyInlineRemoveable(); )
                if ((c.push(d), (d = e ? d.getNext() : d.getPrevious()), !d || d.type != CKEDITOR.NODE_ELEMENT)) return;
              if (b.isIdentical(d)) {
                for (var f = e ? b.getLast() : b.getFirst(); c.length; ) c.shift().move(b, !e);
                d.moveChildren(b, !e);
                d.remove();
                f && f.type == CKEDITOR.NODE_ELEMENT && f.mergeSiblings();
              }
            }
          }
          return function (b) {
            if (!1 === b || CKEDITOR.dtd.$removeEmpty[this.getName()] || this.is('a'))
              a(this, this.getNext(), !0), a(this, this.getPrevious());
          };
        })(),
        show: function () {
          this.setStyles({ display: '', visibility: '' });
        },
        setAttribute: (function () {
          var a = function (a, b) {
            this.$.setAttribute(a, b);
            return this;
          };
          return CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks)
            ? function (b, d) {
                'class' == b
                  ? (this.$.className = d)
                  : 'style' == b
                    ? (this.$.style.cssText = d)
                    : 'tabindex' == b
                      ? (this.$.tabIndex = d)
                      : 'checked' == b
                        ? (this.$.checked = d)
                        : 'contenteditable' == b
                          ? a.call(this, 'contentEditable', d)
                          : a.apply(this, arguments);
                return this;
              }
            : CKEDITOR.env.ie8Compat && CKEDITOR.env.secure
              ? function (b, d) {
                  if ('src' == b && d.match(/^http:\/\//))
                    try {
                      a.apply(this, arguments);
                    } catch (e) {}
                  else a.apply(this, arguments);
                  return this;
                }
              : a;
        })(),
        setAttributes: function (a) {
          for (var b in a) this.setAttribute(b, a[b]);
          return this;
        },
        setValue: function (a) {
          this.$.value = a;
          return this;
        },
        removeAttribute: (function () {
          var a = function (a) {
            this.$.removeAttribute(a);
          };
          return CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks)
            ? function (a) {
                'class' == a ? (a = 'className') : 'tabindex' == a ? (a = 'tabIndex') : 'contenteditable' == a && (a = 'contentEditable');
                this.$.removeAttribute(a);
              }
            : a;
        })(),
        removeAttributes: function (a) {
          if (CKEDITOR.tools.isArray(a)) for (var b = 0; b < a.length; b++) this.removeAttribute(a[b]);
          else for (b in ((a = a || this.getAttributes()), a)) a.hasOwnProperty(b) && this.removeAttribute(b);
        },
        removeStyle: function (a) {
          var b = this.$.style;
          if (b.removeProperty || ('border' != a && 'margin' != a && 'padding' != a))
            b.removeProperty ? b.removeProperty(a) : b.removeAttribute(CKEDITOR.tools.cssStyleToDomStyle(a)),
              this.$.style.cssText || this.removeAttribute('style');
          else {
            var d = ['top', 'left', 'right', 'bottom'],
              e;
            'border' == a && (e = ['color', 'style', 'width']);
            for (var b = [], c = 0; c < d.length; c++)
              if (e) for (var f = 0; f < e.length; f++) b.push([a, d[c], e[f]].join('-'));
              else b.push([a, d[c]].join('-'));
            for (a = 0; a < b.length; a++) this.removeStyle(b[a]);
          }
        },
        setStyle: function (a, b) {
          this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)] = b;
          return this;
        },
        setStyles: function (a) {
          for (var b in a) this.setStyle(b, a[b]);
          return this;
        },
        setOpacity: function (a) {
          CKEDITOR.env.ie && 9 > CKEDITOR.env.version
            ? ((a = Math.round(100 * a)),
              this.setStyle('filter', 100 <= a ? '' : 'progid:DXImageTransform.Microsoft.Alpha(opacity\x3d' + a + ')'))
            : this.setStyle('opacity', a);
        },
        unselectable: function () {
          this.setStyles(CKEDITOR.tools.cssVendorPrefix('user-select', 'none'));
          if (CKEDITOR.env.ie) {
            this.setAttribute('unselectable', 'on');
            for (var a, b = this.getElementsByTag('*'), d = 0, e = b.count(); d < e; d++)
              (a = b.getItem(d)), a.setAttribute('unselectable', 'on');
          }
        },
        getPositionedAncestor: function () {
          for (var a = this; 'html' != a.getName(); ) {
            if ('static' != a.getComputedStyle('position')) return a;
            a = a.getParent();
          }
          return null;
        },
        getDocumentPosition: function (a) {
          var b = 0,
            d = 0,
            e = this.getDocument(),
            c = e.getBody(),
            f = 'BackCompat' == e.$.compatMode;
          if (document.documentElement.getBoundingClientRect && (CKEDITOR.env.ie ? 8 !== CKEDITOR.env.version : 1)) {
            var k = this.$.getBoundingClientRect(),
              l = e.$.documentElement,
              h = l.clientTop || c.$.clientTop || 0,
              t = l.clientLeft || c.$.clientLeft || 0,
              A = !0;
            CKEDITOR.env.ie && ((A = e.getDocumentElement().contains(this)), (e = e.getBody().contains(this)), (A = (f && e) || (!f && A)));
            A &&
              (CKEDITOR.env.webkit || (CKEDITOR.env.ie && 12 <= CKEDITOR.env.version)
                ? ((b = c.$.scrollLeft || l.scrollLeft), (d = c.$.scrollTop || l.scrollTop))
                : ((d = f ? c.$ : l), (b = d.scrollLeft), (d = d.scrollTop)),
              (b = k.left + b - t),
              (d = k.top + d - h));
          } else
            for (h = this, t = null; h && 'body' != h.getName() && 'html' != h.getName(); ) {
              b += h.$.offsetLeft - h.$.scrollLeft;
              d += h.$.offsetTop - h.$.scrollTop;
              h.equals(this) || ((b += h.$.clientLeft || 0), (d += h.$.clientTop || 0));
              for (; t && !t.equals(h); ) (b -= t.$.scrollLeft), (d -= t.$.scrollTop), (t = t.getParent());
              t = h;
              h = (k = h.$.offsetParent) ? new CKEDITOR.dom.element(k) : null;
            }
          a &&
            ((k = this.getWindow()),
            (h = a.getWindow()),
            !k.equals(h) &&
              k.$.frameElement &&
              ((a = new CKEDITOR.dom.element(k.$.frameElement).getDocumentPosition(a)), (b += a.x), (d += a.y)));
          document.documentElement.getBoundingClientRect ||
            !CKEDITOR.env.gecko ||
            f ||
            ((b += this.$.clientLeft ? 1 : 0), (d += this.$.clientTop ? 1 : 0));
          return { x: b, y: d };
        },
        scrollIntoView: function (a) {
          var b = this.getParent();
          if (b) {
            do
              if (
                (((b.$.clientWidth && b.$.clientWidth < b.$.scrollWidth) || (b.$.clientHeight && b.$.clientHeight < b.$.scrollHeight)) &&
                  !b.is('body') &&
                  this.scrollIntoParent(b, a, 1),
                b.is('html'))
              ) {
                var d = b.getWindow();
                try {
                  var e = d.$.frameElement;
                  e && (b = new CKEDITOR.dom.element(e));
                } catch (c) {}
              }
            while ((b = b.getParent()));
          }
        },
        scrollIntoParent: function (a, b, d) {
          var e, c, f, k;
          function l(b, e) {
            /body|html/.test(a.getName()) ? a.getWindow().$.scrollBy(b, e) : ((a.$.scrollLeft += b), (a.$.scrollTop += e));
          }
          function h(a, b) {
            var e = { x: 0, y: 0 };
            if (!a.is(A ? 'body' : 'html')) {
              var d = a.$.getBoundingClientRect();
              e.x = d.left;
              e.y = d.top;
            }
            d = a.getWindow();
            d.equals(b) || ((d = h(CKEDITOR.dom.element.get(d.$.frameElement), b)), (e.x += d.x), (e.y += d.y));
            return e;
          }
          function t(a, e) {
            return parseInt(a.getComputedStyle('margin-' + e) || 0, 10) || 0;
          }
          !a && (a = this.getWindow());
          f = a.getDocument();
          var A = 'BackCompat' == f.$.compatMode;
          a instanceof CKEDITOR.dom.window && (a = A ? f.getBody() : f.getDocumentElement());
          CKEDITOR.env.webkit && (f = this.getEditor(!1)) && (f._.previousScrollTop = null);
          f = a.getWindow();
          c = h(this, f);
          var q = h(a, f),
            B = this.$.offsetHeight;
          e = this.$.offsetWidth;
          var z = a.$.clientHeight,
            y = a.$.clientWidth;
          f = c.x - t(this, 'left') - q.x || 0;
          k = c.y - t(this, 'top') - q.y || 0;
          e = c.x + e + t(this, 'right') - (q.x + y) || 0;
          c = c.y + B + t(this, 'bottom') - (q.y + z) || 0;
          (0 > k || 0 < c) && l(0, !0 === b ? k : !1 === b ? c : 0 > k ? k : c);
          d && (0 > f || 0 < e) && l(0 > f ? f : e, 0);
        },
        setState: function (a, b, d) {
          b = b || 'cke';
          switch (a) {
            case CKEDITOR.TRISTATE_ON:
              this.addClass(b + '_on');
              this.removeClass(b + '_off');
              this.removeClass(b + '_disabled');
              d && this.setAttribute('aria-pressed', !0);
              d && this.removeAttribute('aria-disabled');
              break;
            case CKEDITOR.TRISTATE_DISABLED:
              this.addClass(b + '_disabled');
              this.removeClass(b + '_off');
              this.removeClass(b + '_on');
              d && this.setAttribute('aria-disabled', !0);
              d && this.removeAttribute('aria-pressed');
              break;
            default:
              this.addClass(b + '_off'),
                this.removeClass(b + '_on'),
                this.removeClass(b + '_disabled'),
                d && this.removeAttribute('aria-pressed'),
                d && this.removeAttribute('aria-disabled');
          }
        },
        getFrameDocument: function () {
          var a = this.$;
          try {
            a.contentWindow.document;
          } catch (b) {
            a.src = a.src;
          }
          return a && new CKEDITOR.dom.document(a.contentWindow.document);
        },
        copyAttributes: function (a, b) {
          var d = this.$.attributes;
          b = b || {};
          for (var e = 0; e < d.length; e++) {
            var c = d[e],
              f = c.nodeName.toLowerCase(),
              k;
            if (!(f in b))
              if ('checked' == f && (k = this.getAttribute(f))) a.setAttribute(f, k);
              else if (!CKEDITOR.env.ie || this.hasAttribute(f))
                (k = this.getAttribute(f)), null === k && (k = c.nodeValue), a.setAttribute(f, k);
          }
          '' !== this.$.style.cssText && (a.$.style.cssText = this.$.style.cssText);
        },
        renameNode: function (a) {
          if (this.getName() != a) {
            var b = this.getDocument();
            a = new CKEDITOR.dom.element(a, b);
            this.copyAttributes(a);
            this.moveChildren(a);
            this.getParent(!0) && this.$.parentNode.replaceChild(a.$, this.$);
            a.$['data-cke-expando'] = this.$['data-cke-expando'];
            this.$ = a.$;
            delete this.getName;
          }
        },
        getChild: (function () {
          function a(b, d) {
            var e = b.childNodes;
            if (0 <= d && d < e.length) return e[d];
          }
          return function (b) {
            var d = this.$;
            if (b.slice) for (b = b.slice(); 0 < b.length && d; ) d = a(d, b.shift());
            else d = a(d, b);
            return d ? new CKEDITOR.dom.node(d) : null;
          };
        })(),
        getChildCount: function () {
          return this.$.childNodes.length;
        },
        disableContextMenu: function () {
          function a(b) {
            return b.type == CKEDITOR.NODE_ELEMENT && b.hasClass('cke_enable_context_menu');
          }
          this.on('contextmenu', function (b) {
            b.data.getTarget().getAscendant(a, !0) || b.data.preventDefault();
          });
        },
        getDirection: function (a) {
          return a
            ? this.getComputedStyle('direction') ||
                this.getDirection() ||
                (this.getParent() && this.getParent().getDirection(1)) ||
                this.getDocument().$.dir ||
                'ltr'
            : this.getStyle('direction') || this.getAttribute('dir');
        },
        data: function (a, b) {
          a = 'data-' + a;
          if (void 0 === b) return this.getAttribute(a);
          !1 === b ? this.removeAttribute(a) : this.setAttribute(a, b);
          return null;
        },
        getEditor: function (a) {
          var b = CKEDITOR.instances,
            d,
            e,
            c;
          a = a || void 0 === a;
          for (d in b)
            if (
              ((e = b[d]),
              (e.element.equals(this) && e.elementMode != CKEDITOR.ELEMENT_MODE_APPENDTO) ||
                (!a && (c = e.editable()) && (c.equals(this) || c.contains(this))))
            )
              return e;
          return null;
        },
        find: function (a) {
          var b = h(this);
          a = new CKEDITOR.dom.nodeList(this.$.querySelectorAll(f(this, a)));
          b();
          return a;
        },
        findOne: function (a) {
          var b = h(this);
          a = this.$.querySelector(f(this, a));
          b();
          return a ? new CKEDITOR.dom.element(a) : null;
        },
        forEach: function (a, b, d) {
          if (!(d || (b && this.type != b))) var e = a(this);
          if (!1 !== e) {
            d = this.getChildren();
            for (var c = 0; c < d.count(); c++)
              (e = d.getItem(c)), e.type == CKEDITOR.NODE_ELEMENT ? e.forEach(a, b) : (b && e.type != b) || a(e);
          }
        },
        fireEventHandler: function (a, b) {
          var d = 'on' + a,
            e = this.$;
          if (CKEDITOR.env.ie && 9 > CKEDITOR.env.version) {
            var c = e.ownerDocument.createEventObject(),
              f;
            for (f in b) c[f] = b[f];
            e.fireEvent(d, c);
          } else e[e[a] ? a : d](b);
        },
        isDetached: function () {
          var a = this.getDocument(),
            b = a.getDocumentElement();
          return b.equals(this) || b.contains(this)
            ? !CKEDITOR.env.ie || (8 < CKEDITOR.env.version && !CKEDITOR.env.quirks)
              ? !a.$.defaultView
              : !1
            : !0;
        },
      });
      var k = {
        width: ['border-left-width', 'border-right-width', 'padding-left', 'padding-right'],
        height: ['border-top-width', 'border-bottom-width', 'padding-top', 'padding-bottom'],
      };
      CKEDITOR.dom.element.prototype.setSize = function (a, g, d) {
        'number' == typeof g && (!d || (CKEDITOR.env.ie && CKEDITOR.env.quirks) || (g -= b.call(this, a)), this.setStyle(a, g + 'px'));
      };
      CKEDITOR.dom.element.prototype.getSize = function (a, g) {
        var d = Math.max(this.$['offset' + CKEDITOR.tools.capitalize(a)], this.$['client' + CKEDITOR.tools.capitalize(a)]) || 0;
        g && (d -= b.call(this, a));
        return d;
      };
    })();
    CKEDITOR.dom.documentFragment = function (a) {
      a = a || CKEDITOR.document;
      this.$ = a.type == CKEDITOR.NODE_DOCUMENT ? a.$.createDocumentFragment() : a;
    };
    CKEDITOR.tools.extend(
      CKEDITOR.dom.documentFragment.prototype,
      CKEDITOR.dom.element.prototype,
      {
        type: CKEDITOR.NODE_DOCUMENT_FRAGMENT,
        insertAfterNode: function (a) {
          a = a.$;
          a.parentNode.insertBefore(this.$, a.nextSibling);
        },
        getHtml: function () {
          var a = new CKEDITOR.dom.element('div');
          this.clone(1, 1).appendTo(a);
          return a.getHtml().replace(/\s*data-cke-expando=".*?"/g, '');
        },
      },
      !0,
      {
        append: 1,
        appendBogus: 1,
        clone: 1,
        getFirst: 1,
        getHtml: 1,
        getLast: 1,
        getParent: 1,
        getNext: 1,
        getPrevious: 1,
        appendTo: 1,
        moveChildren: 1,
        insertBefore: 1,
        insertAfterNode: 1,
        replace: 1,
        trim: 1,
        type: 1,
        ltrim: 1,
        rtrim: 1,
        getDocument: 1,
        getChildCount: 1,
        getChild: 1,
        getChildren: 1,
      },
    );
    CKEDITOR.tools.extend(CKEDITOR.dom.documentFragment.prototype, CKEDITOR.dom.document.prototype, !0, { find: 1, findOne: 1 });
    (function () {
      function a(a, b) {
        var e = this.range;
        if (this._.end) return null;
        if (!this._.start) {
          this._.start = 1;
          if (e.collapsed) return this.end(), null;
          e.optimize();
        }
        var d,
          g = e.startContainer;
        d = e.endContainer;
        var c = e.startOffset,
          f = e.endOffset,
          k,
          n = this.guard,
          l = this.type,
          h = a ? 'getPreviousSourceNode' : 'getNextSourceNode';
        if (!a && !this._.guardLTR) {
          var m = d.type == CKEDITOR.NODE_ELEMENT ? d : d.getParent(),
            F = d.type == CKEDITOR.NODE_ELEMENT ? d.getChild(f) : d.getNext();
          this._.guardLTR = function (a, b) {
            return (!b || !m.equals(a)) && (!F || !a.equals(F)) && (a.type != CKEDITOR.NODE_ELEMENT || !b || !a.equals(e.root));
          };
        }
        if (a && !this._.guardRTL) {
          var D = g.type == CKEDITOR.NODE_ELEMENT ? g : g.getParent(),
            G = g.type == CKEDITOR.NODE_ELEMENT ? (c ? g.getChild(c - 1) : null) : g.getPrevious();
          this._.guardRTL = function (a, b) {
            return (!b || !D.equals(a)) && (!G || !a.equals(G)) && (a.type != CKEDITOR.NODE_ELEMENT || !b || !a.equals(e.root));
          };
        }
        var H = a ? this._.guardRTL : this._.guardLTR;
        k = n
          ? function (a, b) {
              return !1 === H(a, b) ? !1 : n(a, b);
            }
          : H;
        this.current
          ? (d = this.current[h](!1, l, k))
          : (a
              ? d.type == CKEDITOR.NODE_ELEMENT &&
                (d = 0 < f ? d.getChild(f - 1) : !1 === k(d, !0) ? null : d.getPreviousSourceNode(!0, l, k))
              : ((d = g),
                d.type == CKEDITOR.NODE_ELEMENT && ((d = d.getChild(c)) || (d = !1 === k(g, !0) ? null : g.getNextSourceNode(!0, l, k)))),
            d && !1 === k(d) && (d = null));
        for (; d && !this._.end; ) {
          this.current = d;
          if (!this.evaluator || !1 !== this.evaluator(d)) {
            if (!b) return d;
          } else if (b && this.evaluator) return !1;
          d = d[h](!1, l, k);
        }
        this.end();
        return (this.current = null);
      }
      function h(b) {
        for (var e, d = null; (e = a.call(this, b)); ) d = e;
        return d;
      }
      CKEDITOR.dom.walker = CKEDITOR.tools.createClass({
        $: function (a) {
          this.range = a;
          this._ = {};
        },
        proto: {
          end: function () {
            this._.end = 1;
          },
          next: function () {
            return a.call(this);
          },
          previous: function () {
            return a.call(this, 1);
          },
          checkForward: function () {
            return !1 !== a.call(this, 0, 1);
          },
          checkBackward: function () {
            return !1 !== a.call(this, 1, 1);
          },
          lastForward: function () {
            return h.call(this);
          },
          lastBackward: function () {
            return h.call(this, 1);
          },
          reset: function () {
            delete this.current;
            this._ = {};
          },
        },
      });
      var f = {
          block: 1,
          'list-item': 1,
          table: 1,
          'table-row-group': 1,
          'table-header-group': 1,
          'table-footer-group': 1,
          'table-row': 1,
          'table-column-group': 1,
          'table-column': 1,
          'table-cell': 1,
          'table-caption': 1,
        },
        b = { absolute: 1, fixed: 1 };
      CKEDITOR.dom.element.prototype.isBlockBoundary = function (a) {
        return 'none' != this.getComputedStyle('float') || this.getComputedStyle('position') in b || !f[this.getComputedStyle('display')]
          ? !!(this.is(CKEDITOR.dtd.$block) || (a && this.is(a)))
          : !0;
      };
      CKEDITOR.dom.walker.blockBoundary = function (a) {
        return function (b) {
          return !(b.type == CKEDITOR.NODE_ELEMENT && b.isBlockBoundary(a));
        };
      };
      CKEDITOR.dom.walker.listItemBoundary = function () {
        return this.blockBoundary({ br: 1 });
      };
      CKEDITOR.dom.walker.bookmark = function (a, b) {
        function e(a) {
          return a && a.getName && 'span' == a.getName() && a.data('cke-bookmark');
        }
        return function (d) {
          var g, c;
          g = d && d.type != CKEDITOR.NODE_ELEMENT && (c = d.getParent()) && e(c);
          g = a ? g : g || e(d);
          return !!(b ^ g);
        };
      };
      CKEDITOR.dom.walker.whitespaces = function (a) {
        return function (b) {
          var e;
          b &&
            b.type == CKEDITOR.NODE_TEXT &&
            (e = !CKEDITOR.tools.trim(b.getText()) || (CKEDITOR.env.webkit && b.getText() == CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE));
          return !!(a ^ e);
        };
      };
      CKEDITOR.dom.walker.invisible = function (a) {
        var b = CKEDITOR.dom.walker.whitespaces(),
          e = CKEDITOR.env.webkit ? 1 : 0;
        return function (d) {
          b(d) ? (d = 1) : (d.type == CKEDITOR.NODE_TEXT && (d = d.getParent()), (d = d.$.offsetWidth <= e));
          return !!(a ^ d);
        };
      };
      CKEDITOR.dom.walker.nodeType = function (a, b) {
        return function (e) {
          return !!(b ^ (e.type == a));
        };
      };
      CKEDITOR.dom.walker.bogus = function (a) {
        function b(a) {
          return !l(a) && !k(a);
        }
        return function (e) {
          var d = CKEDITOR.env.needsBrFiller ? e.is && e.is('br') : e.getText && c.test(e.getText());
          d &&
            ((d = e.getParent()),
            (e = e.getNext(b)),
            (d = d.isBlockBoundary() && (!e || (e.type == CKEDITOR.NODE_ELEMENT && e.isBlockBoundary()))));
          return !!(a ^ d);
        };
      };
      CKEDITOR.dom.walker.temp = function (a) {
        return function (b) {
          b.type != CKEDITOR.NODE_ELEMENT && (b = b.getParent());
          b = b && b.hasAttribute('data-cke-temp');
          return !!(a ^ b);
        };
      };
      var c = /^[\t\r\n ]*(?:&nbsp;|\xa0)$/,
        l = CKEDITOR.dom.walker.whitespaces(),
        k = CKEDITOR.dom.walker.bookmark(),
        m = CKEDITOR.dom.walker.temp(),
        g = function (a) {
          return k(a) || l(a) || (a.type == CKEDITOR.NODE_ELEMENT && a.is(CKEDITOR.dtd.$inline) && !a.is(CKEDITOR.dtd.$empty));
        };
      CKEDITOR.dom.walker.ignored = function (a) {
        return function (b) {
          b = l(b) || k(b) || m(b);
          return !!(a ^ b);
        };
      };
      var d = CKEDITOR.dom.walker.ignored();
      CKEDITOR.dom.walker.empty = function (a) {
        return function (b) {
          for (var e = 0, g = b.getChildCount(); e < g; ++e) if (!d(b.getChild(e))) return !!a;
          return !a;
        };
      };
      var e = CKEDITOR.dom.walker.empty(),
        n = (CKEDITOR.dom.walker.validEmptyBlockContainers = CKEDITOR.tools.extend(
          (function (a) {
            var b = {},
              e;
            for (e in a) CKEDITOR.dtd[e]['#'] && (b[e] = 1);
            return b;
          })(CKEDITOR.dtd.$block),
          { caption: 1, td: 1, th: 1 },
        ));
      CKEDITOR.dom.walker.editable = function (a) {
        return function (b) {
          b = d(b)
            ? !1
            : b.type == CKEDITOR.NODE_TEXT ||
                (b.type == CKEDITOR.NODE_ELEMENT &&
                  (b.is(CKEDITOR.dtd.$inline) ||
                    b.is('hr') ||
                    'false' == b.getAttribute('contenteditable') ||
                    (!CKEDITOR.env.needsBrFiller && b.is(n) && e(b))))
              ? !0
              : !1;
          return !!(a ^ b);
        };
      };
      CKEDITOR.dom.element.prototype.getBogus = function () {
        var a = this;
        do a = a.getPreviousSourceNode();
        while (g(a));
        return a && (CKEDITOR.env.needsBrFiller ? a.is && a.is('br') : a.getText && c.test(a.getText())) ? a : !1;
      };
    })();
    ('use strict');
    CKEDITOR.dom.range = function (a) {
      this.endOffset = this.endContainer = this.startOffset = this.startContainer = null;
      this.collapsed = !0;
      var h = a instanceof CKEDITOR.dom.document;
      this.document = h ? a : a.getDocument();
      this.root = h ? a.getBody() : a;
    };
    (function () {
      function a(a) {
        a.collapsed = a.startContainer && a.endContainer && a.startContainer.equals(a.endContainer) && a.startOffset == a.endOffset;
      }
      function h(a, b, d, g, c) {
        function f(a, b, e, d) {
          var g = e ? a.getPrevious() : a.getNext();
          if (d && h) return g;
          z || d ? b.append(a.clone(!0, c), e) : (a.remove(), m && b.append(a, e));
          return g;
        }
        function k() {
          var a,
            b,
            e,
            d = Math.min(I.length, E.length);
          for (a = 0; a < d; a++) if (((b = I[a]), (e = E[a]), !b.equals(e))) return a;
          return a - 1;
        }
        function l() {
          var b = P - 1,
            d = H && L && !y.equals(v);
          b < M - 1 || b < O - 1 || d
            ? (d
                ? a.moveToPosition(v, CKEDITOR.POSITION_BEFORE_START)
                : O == b + 1 && G
                  ? a.moveToPosition(E[b], CKEDITOR.POSITION_BEFORE_END)
                  : a.moveToPosition(E[b + 1], CKEDITOR.POSITION_BEFORE_START),
              g &&
                (b = I[b + 1]) &&
                b.type == CKEDITOR.NODE_ELEMENT &&
                ((d = CKEDITOR.dom.element.createFromHtml(
                  '\x3cspan data-cke-bookmark\x3d"1" style\x3d"display:none"\x3e\x26nbsp;\x3c/span\x3e',
                  a.document,
                )),
                d.insertAfter(b),
                b.mergeSiblings(!1),
                a.moveToBookmark({ startNode: d })))
            : a.collapse(!0);
        }
        a.optimizeBookmark();
        var h = 0 === b,
          m = 1 == b,
          z = 2 == b;
        b = z || m;
        var y = a.startContainer,
          v = a.endContainer,
          C = a.startOffset,
          F = a.endOffset,
          D,
          G,
          H,
          L,
          K,
          S;
        if (z && v.type == CKEDITOR.NODE_TEXT && (y.equals(v) || (y.type === CKEDITOR.NODE_ELEMENT && y.getFirst().equals(v))))
          d.append(a.document.createText(v.substring(C, F)));
        else {
          v.type == CKEDITOR.NODE_TEXT
            ? z
              ? (S = !0)
              : (v = v.split(F))
            : 0 < v.getChildCount()
              ? F >= v.getChildCount()
                ? ((v = v.getChild(F - 1)), (G = !0))
                : (v = v.getChild(F))
              : (L = G = !0);
          y.type == CKEDITOR.NODE_TEXT
            ? z
              ? (K = !0)
              : y.split(C)
            : 0 < y.getChildCount()
              ? 0 === C
                ? ((y = y.getChild(C)), (D = !0))
                : (y = y.getChild(C - 1))
              : (H = D = !0);
          for (
            var I = y.getParents(), E = v.getParents(), P = k(), M = I.length - 1, O = E.length - 1, N = d, X, T, Y, da = -1, U = P;
            U <= M;
            U++
          ) {
            T = I[U];
            Y = T.getNext();
            for (
              U != M || (T.equals(E[U]) && M < O)
                ? b && (X = N.append(T.clone(0, c)))
                : D
                  ? f(T, N, !1, H)
                  : K && N.append(a.document.createText(T.substring(C)));
              Y;

            ) {
              if (Y.equals(E[U])) {
                da = U;
                break;
              }
              Y = f(Y, N);
            }
            N = X;
          }
          N = d;
          for (U = P; U <= O; U++)
            if (((d = E[U]), (Y = d.getPrevious()), d.equals(I[U]))) b && (N = N.getChild(0));
            else {
              U != O || (d.equals(I[U]) && O < M)
                ? b && (X = N.append(d.clone(0, c)))
                : G
                  ? f(d, N, !1, L)
                  : S && N.append(a.document.createText(d.substring(0, F)));
              if (U > da) for (; Y; ) Y = f(Y, N, !0);
              N = X;
            }
          z || l();
        }
      }
      function f() {
        var a = !1,
          b = CKEDITOR.dom.walker.whitespaces(),
          d = CKEDITOR.dom.walker.bookmark(!0),
          g = CKEDITOR.dom.walker.bogus();
        return function (c) {
          return d(c) || b(c)
            ? !0
            : g(c) && !a
              ? (a = !0)
              : (c.type == CKEDITOR.NODE_TEXT && (c.hasAscendant('pre') || CKEDITOR.tools.trim(c.getText()).length)) ||
                  (c.type == CKEDITOR.NODE_ELEMENT && !c.is(l))
                ? !1
                : !0;
        };
      }
      function b(a) {
        var b = CKEDITOR.dom.walker.whitespaces(),
          d = CKEDITOR.dom.walker.bookmark(1);
        return function (g) {
          return d(g) || b(g) ? !0 : (!a && k(g)) || (g.type == CKEDITOR.NODE_ELEMENT && g.is(CKEDITOR.dtd.$removeEmpty));
        };
      }
      function c(a) {
        return function () {
          var b;
          return this[a ? 'getPreviousNode' : 'getNextNode'](function (a) {
            !b && d(a) && (b = a);
            return g(a) && !(k(a) && a.equals(b));
          });
        };
      }
      var l = {
          abbr: 1,
          acronym: 1,
          b: 1,
          bdo: 1,
          big: 1,
          cite: 1,
          code: 1,
          del: 1,
          dfn: 1,
          em: 1,
          font: 1,
          i: 1,
          ins: 1,
          label: 1,
          kbd: 1,
          q: 1,
          samp: 1,
          small: 1,
          span: 1,
          strike: 1,
          strong: 1,
          sub: 1,
          sup: 1,
          tt: 1,
          u: 1,
          var: 1,
        },
        k = CKEDITOR.dom.walker.bogus(),
        m = /^[\t\r\n ]*(?:&nbsp;|\xa0)$/,
        g = CKEDITOR.dom.walker.editable(),
        d = CKEDITOR.dom.walker.ignored(!0);
      CKEDITOR.dom.range.prototype = {
        clone: function () {
          var a = new CKEDITOR.dom.range(this.root);
          a._setStartContainer(this.startContainer);
          a.startOffset = this.startOffset;
          a._setEndContainer(this.endContainer);
          a.endOffset = this.endOffset;
          a.collapsed = this.collapsed;
          return a;
        },
        collapse: function (a) {
          a
            ? (this._setEndContainer(this.startContainer), (this.endOffset = this.startOffset))
            : (this._setStartContainer(this.endContainer), (this.startOffset = this.endOffset));
          this.collapsed = !0;
        },
        cloneContents: function (a) {
          var b = new CKEDITOR.dom.documentFragment(this.document);
          this.collapsed || h(this, 2, b, !1, 'undefined' == typeof a ? !0 : a);
          return b;
        },
        deleteContents: function (a) {
          this.collapsed || h(this, 0, null, a);
        },
        extractContents: function (a, b) {
          var d = new CKEDITOR.dom.documentFragment(this.document);
          this.collapsed || h(this, 1, d, a, 'undefined' == typeof b ? !0 : b);
          return d;
        },
        equals: function (a) {
          return (
            this.startOffset === a.startOffset &&
            this.endOffset === a.endOffset &&
            this.startContainer.equals(a.startContainer) &&
            this.endContainer.equals(a.endContainer)
          );
        },
        createBookmark: function (a) {
          function b(a) {
            return a.getAscendant(function (a) {
              var b;
              if ((b = a.data && a.data('cke-temp')))
                b = -1 === CKEDITOR.tools.array.indexOf(['cke_copybin', 'cke_pastebin'], a.getAttribute('id'));
              return b;
            }, !0);
          }
          var d = this.startContainer,
            g = this.endContainer,
            c = this.collapsed,
            f,
            k,
            l,
            h;
          f = this.document.createElement('span');
          f.data('cke-bookmark', 1);
          f.setStyle('display', 'none');
          f.setHtml('\x26nbsp;');
          a && ((l = 'cke_bm_' + CKEDITOR.tools.getNextNumber()), f.setAttribute('id', l + (c ? 'C' : 'S')));
          c ||
            ((k = f.clone()),
            k.setHtml('\x26nbsp;'),
            a && k.setAttribute('id', l + 'E'),
            (h = this.clone()),
            b(g) && ((g = b(g)), h.moveToPosition(g, CKEDITOR.POSITION_AFTER_END)),
            h.collapse(),
            h.insertNode(k));
          h = this.clone();
          b(d) && ((g = b(d)), h.moveToPosition(g, CKEDITOR.POSITION_BEFORE_START));
          h.collapse(!0);
          h.insertNode(f);
          k ? (this.setStartAfter(f), this.setEndBefore(k)) : this.moveToPosition(f, CKEDITOR.POSITION_AFTER_END);
          return { startNode: a ? l + (c ? 'C' : 'S') : f, endNode: a ? l + 'E' : k, serializable: a, collapsed: c };
        },
        createBookmark2: (function () {
          function a(b) {
            var e = b.container,
              g = b.offset,
              c;
            c = e;
            var f = g;
            c =
              c.type != CKEDITOR.NODE_ELEMENT || 0 === f || f == c.getChildCount()
                ? 0
                : c.getChild(f - 1).type == CKEDITOR.NODE_TEXT && c.getChild(f).type == CKEDITOR.NODE_TEXT;
            c && ((e = e.getChild(g - 1)), (g = e.getLength()));
            if (e.type == CKEDITOR.NODE_ELEMENT && 0 < g) {
              a: {
                for (c = e; g--; )
                  if (((f = c.getChild(g).getIndex(!0)), 0 <= f)) {
                    g = f;
                    break a;
                  }
                g = -1;
              }
              g += 1;
            }
            if (e.type == CKEDITOR.NODE_TEXT) {
              c = e;
              for (f = 0; (c = c.getPrevious()) && c.type == CKEDITOR.NODE_TEXT; )
                f += c.getText().replace(CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE, '').length;
              c = f;
              e.isEmpty()
                ? ((f = e.getPrevious(d)),
                  c ? ((g = c), (e = f ? f.getNext() : e.getParent().getFirst())) : ((e = e.getParent()), (g = f ? f.getIndex(!0) + 1 : 0)))
                : (g += c);
            }
            b.container = e;
            b.offset = g;
          }
          function b(a, e) {
            var d = e.getCustomData('cke-fillingChar');
            if (d) {
              var g = a.container;
              d.equals(g) &&
                ((a.offset -= CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE.length),
                0 >= a.offset && ((a.offset = g.getIndex()), (a.container = g.getParent())));
            }
          }
          var d = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_TEXT, !0);
          return function (d) {
            var g = this.collapsed,
              c = { container: this.startContainer, offset: this.startOffset },
              f = { container: this.endContainer, offset: this.endOffset };
            d && (a(c), b(c, this.root), g || (a(f), b(f, this.root)));
            return {
              start: c.container.getAddress(d),
              end: g ? null : f.container.getAddress(d),
              startOffset: c.offset,
              endOffset: f.offset,
              normalized: d,
              collapsed: g,
              is2: !0,
            };
          };
        })(),
        moveToBookmark: function (a) {
          if (a.is2) {
            var b = this.document.getByAddress(a.start, a.normalized),
              d = a.startOffset,
              g = a.end && this.document.getByAddress(a.end, a.normalized);
            a = a.endOffset;
            this.setStart(b, d);
            g ? this.setEnd(g, a) : this.collapse(!0);
          } else
            (b = (d = a.serializable) ? this.document.getById(a.startNode) : a.startNode),
              (a = d ? this.document.getById(a.endNode) : a.endNode),
              this.setStartBefore(b),
              b.remove(),
              a ? (this.setEndBefore(a), a.remove()) : this.collapse(!0);
        },
        getBoundaryNodes: function () {
          var a = this.startContainer,
            b = this.endContainer,
            d = this.startOffset,
            g = this.endOffset,
            c;
          if (a.type == CKEDITOR.NODE_ELEMENT)
            if (((c = a.getChildCount()), c > d)) a = a.getChild(d);
            else if (1 > c) a = a.getPreviousSourceNode();
            else {
              for (a = a.$; a.lastChild; ) a = a.lastChild;
              a = new CKEDITOR.dom.node(a);
              a = a.getNextSourceNode() || a;
            }
          if (b.type == CKEDITOR.NODE_ELEMENT)
            if (((c = b.getChildCount()), c > g)) b = b.getChild(g).getPreviousSourceNode(!0);
            else if (1 > c) b = b.getPreviousSourceNode();
            else {
              for (b = b.$; b.lastChild; ) b = b.lastChild;
              b = new CKEDITOR.dom.node(b);
            }
          a.getPosition(b) & CKEDITOR.POSITION_FOLLOWING && (a = b);
          return { startNode: a, endNode: b };
        },
        getCommonAncestor: function (a, b) {
          var d = this.startContainer,
            g = this.endContainer,
            d = d.equals(g)
              ? a && d.type == CKEDITOR.NODE_ELEMENT && this.startOffset == this.endOffset - 1
                ? d.getChild(this.startOffset)
                : d
              : d.getCommonAncestor(g);
          return b && !d.is ? d.getParent() : d;
        },
        optimize: function () {
          var a = this.startContainer,
            b = this.startOffset;
          a.type != CKEDITOR.NODE_ELEMENT && (b ? b >= a.getLength() && this.setStartAfter(a) : this.setStartBefore(a));
          a = this.endContainer;
          b = this.endOffset;
          a.type != CKEDITOR.NODE_ELEMENT && (b ? b >= a.getLength() && this.setEndAfter(a) : this.setEndBefore(a));
        },
        optimizeBookmark: function () {
          var a = this.startContainer,
            b = this.endContainer;
          a.is && a.is('span') && a.data('cke-bookmark') && this.setStartAt(a, CKEDITOR.POSITION_BEFORE_START);
          b && b.is && b.is('span') && b.data('cke-bookmark') && this.setEndAt(b, CKEDITOR.POSITION_AFTER_END);
        },
        trim: function (a, b) {
          var d = this.startContainer,
            g = this.startOffset,
            c = this.collapsed;
          if ((!a || c) && d && d.type == CKEDITOR.NODE_TEXT) {
            if (g)
              if (g >= d.getLength()) (g = d.getIndex() + 1), (d = d.getParent());
              else {
                var f = d.split(g),
                  g = d.getIndex() + 1,
                  d = d.getParent();
                this.startContainer.equals(this.endContainer)
                  ? this.setEnd(f, this.endOffset - this.startOffset)
                  : d.equals(this.endContainer) && (this.endOffset += 1);
              }
            else (g = d.getIndex()), (d = d.getParent());
            this.setStart(d, g);
            if (c) {
              this.collapse(!0);
              return;
            }
          }
          d = this.endContainer;
          g = this.endOffset;
          b ||
            c ||
            !d ||
            d.type != CKEDITOR.NODE_TEXT ||
            (g ? (g >= d.getLength() || d.split(g), (g = d.getIndex() + 1)) : (g = d.getIndex()), (d = d.getParent()), this.setEnd(d, g));
        },
        enlarge: function (a, b) {
          function d(a) {
            return a && a.type == CKEDITOR.NODE_ELEMENT && a.hasAttribute('contenteditable') ? null : a;
          }
          function g(a, b, e) {
            var d = new CKEDITOR.dom.range(e);
            d.setStart(a, b);
            d.setEndAt(e, CKEDITOR.POSITION_BEFORE_END);
            e = new CKEDITOR.dom.walker(d);
            for (
              e.guard = function (a) {
                return !(a.type == CKEDITOR.NODE_ELEMENT && a.isBlockBoundary());
              };
              (d = e.next());

            ) {
              if (d.type != CKEDITOR.NODE_TEXT) return !1;
              f = d != a ? d.getText() : d.substring(b);
              if (c.test(f)) return !1;
            }
            return !0;
          }
          var c = new RegExp(/[^\s\ufeff]/),
            f,
            k;
          switch (a) {
            case CKEDITOR.ENLARGE_INLINE:
              var l = 1;
            case CKEDITOR.ENLARGE_ELEMENT:
              if (this.collapsed) break;
              var h = this.getCommonAncestor();
              k = this.root;
              var m,
                z,
                y,
                v,
                C,
                F = !1,
                D;
              D = this.startContainer;
              var G = this.startOffset;
              D.type == CKEDITOR.NODE_TEXT
                ? (G && ((D = !CKEDITOR.tools.trim(D.substring(0, G)).length && D), (F = !!D)),
                  D && ((v = D.getPrevious()) || (y = D.getParent())))
                : (G && (v = D.getChild(G - 1) || D.getLast()), v || (y = D));
              for (y = d(y); y || v; ) {
                if (y && !v) {
                  !C && y.equals(h) && (C = !0);
                  if (l ? y.isBlockBoundary() : !k.contains(y)) break;
                  (F && 'inline' == y.getComputedStyle('display')) || ((F = !1), C ? (m = y) : this.setStartBefore(y));
                  v = y.getPrevious();
                }
                for (; v; )
                  if (((D = !1), v.type == CKEDITOR.NODE_COMMENT)) v = v.getPrevious();
                  else {
                    if (v.type == CKEDITOR.NODE_TEXT) (f = v.getText()), c.test(f) && (v = null), (D = /[\s\ufeff]$/.test(f));
                    else if ((v.$.offsetWidth > (CKEDITOR.env.webkit ? 1 : 0) || (b && v.is('br'))) && !v.data('cke-bookmark'))
                      if (F && CKEDITOR.dtd.$removeEmpty[v.getName()]) {
                        f = v.getText();
                        if (c.test(f)) v = null;
                        else
                          for (var G = v.$.getElementsByTagName('*'), H = 0, L; (L = G[H++]); )
                            if (!CKEDITOR.dtd.$removeEmpty[L.nodeName.toLowerCase()]) {
                              v = null;
                              break;
                            }
                        v && (D = !!f.length);
                      } else v = null;
                    D && (F ? (C ? (m = y) : y && this.setStartBefore(y)) : (F = !0));
                    if (v) {
                      D = v.getPrevious();
                      if (!y && !D) {
                        y = v;
                        v = null;
                        break;
                      }
                      v = D;
                    } else y = null;
                  }
                y && (y = d(y.getParent()));
              }
              D = this.endContainer;
              G = this.endOffset;
              y = v = null;
              C = F = !1;
              D.type == CKEDITOR.NODE_TEXT
                ? CKEDITOR.tools.trim(D.substring(G)).length
                  ? (F = !0)
                  : ((F = !D.getLength()),
                    G == D.getLength() ? (v = D.getNext()) || (y = D.getParent()) : g(D, G, k) && (y = D.getParent()))
                : (v = D.getChild(G)) || (y = D);
              for (; y || v; ) {
                if (y && !v) {
                  !C && y.equals(h) && (C = !0);
                  if (l ? y.isBlockBoundary() : !k.contains(y)) break;
                  (F && 'inline' == y.getComputedStyle('display')) || ((F = !1), C ? (z = y) : y && this.setEndAfter(y));
                  v = y.getNext();
                }
                for (; v; ) {
                  D = !1;
                  if (v.type == CKEDITOR.NODE_TEXT) (f = v.getText()), g(v, 0, k) || (v = null), (D = /^[\s\ufeff]/.test(f));
                  else if (v.type == CKEDITOR.NODE_ELEMENT) {
                    if ((0 < v.$.offsetWidth || (b && v.is('br'))) && !v.data('cke-bookmark'))
                      if (F && CKEDITOR.dtd.$removeEmpty[v.getName()]) {
                        f = v.getText();
                        if (c.test(f)) v = null;
                        else
                          for (G = v.$.getElementsByTagName('*'), H = 0; (L = G[H++]); )
                            if (!CKEDITOR.dtd.$removeEmpty[L.nodeName.toLowerCase()]) {
                              v = null;
                              break;
                            }
                        v && (D = !!f.length);
                      } else v = null;
                  } else D = 1;
                  D && F && (C ? (z = y) : this.setEndAfter(y));
                  if (v) {
                    D = v.getNext();
                    if (!y && !D) {
                      y = v;
                      v = null;
                      break;
                    }
                    v = D;
                  } else y = null;
                }
                y && (y = d(y.getParent()));
              }
              m && z && ((h = m.contains(z) ? z : m), this.setStartBefore(h), this.setEndAfter(h));
              break;
            case CKEDITOR.ENLARGE_BLOCK_CONTENTS:
            case CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:
              y = new CKEDITOR.dom.range(this.root);
              k = this.root;
              y.setStartAt(k, CKEDITOR.POSITION_AFTER_START);
              y.setEnd(this.startContainer, this.startOffset);
              y = new CKEDITOR.dom.walker(y);
              var K,
                S,
                I = CKEDITOR.dom.walker.blockBoundary(a == CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS ? { br: 1 } : null),
                E = null,
                P = function (a) {
                  if (a.type == CKEDITOR.NODE_ELEMENT && 'false' == a.getAttribute('contenteditable'))
                    if (E) {
                      if (E.equals(a)) {
                        E = null;
                        return;
                      }
                    } else E = a;
                  else if (E) return;
                  var b = I(a);
                  b || (K = a);
                  return b;
                },
                l = function (a) {
                  var b = P(a);
                  !b && a.is && a.is('br') && (S = a);
                  return b;
                };
              y.guard = P;
              y = y.lastBackward();
              K = K || k;
              this.setStartAt(
                K,
                !K.is('br') && ((!y && this.checkStartOfBlock()) || (y && K.contains(y)))
                  ? CKEDITOR.POSITION_AFTER_START
                  : CKEDITOR.POSITION_AFTER_END,
              );
              if (a == CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS) {
                y = this.clone();
                y = new CKEDITOR.dom.walker(y);
                var M = CKEDITOR.dom.walker.whitespaces(),
                  O = CKEDITOR.dom.walker.bookmark();
                y.evaluator = function (a) {
                  return !M(a) && !O(a);
                };
                if ((y = y.previous()) && y.type == CKEDITOR.NODE_ELEMENT && y.is('br')) break;
              }
              y = this.clone();
              y.collapse();
              y.setEndAt(k, CKEDITOR.POSITION_BEFORE_END);
              y = new CKEDITOR.dom.walker(y);
              y.guard = a == CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS ? l : P;
              K = E = S = null;
              y = y.lastForward();
              K = K || k;
              this.setEndAt(
                K,
                (!y && this.checkEndOfBlock()) || (y && K.contains(y)) ? CKEDITOR.POSITION_BEFORE_END : CKEDITOR.POSITION_BEFORE_START,
              );
              S && this.setEndAfter(S);
          }
        },
        shrink: function (a, b, d) {
          var g = 'boolean' === typeof d ? d : d && 'boolean' === typeof d.shrinkOnBlockBoundary ? d.shrinkOnBlockBoundary : !0,
            c = d && d.skipBogus;
          if (!this.collapsed) {
            a = a || CKEDITOR.SHRINK_TEXT;
            var f = this.clone(),
              k = this.startContainer,
              l = this.endContainer,
              h = this.startOffset,
              m = this.endOffset,
              z = (d = 1);
            k &&
              k.type == CKEDITOR.NODE_TEXT &&
              (h ? (h >= k.getLength() ? f.setStartAfter(k) : (f.setStartBefore(k), (d = 0))) : f.setStartBefore(k));
            l &&
              l.type == CKEDITOR.NODE_TEXT &&
              (m ? (m >= l.getLength() ? f.setEndAfter(l) : (f.setEndAfter(l), (z = 0))) : f.setEndBefore(l));
            var f = new CKEDITOR.dom.walker(f),
              y = CKEDITOR.dom.walker.bookmark(),
              v = CKEDITOR.dom.walker.bogus();
            f.evaluator = function (b) {
              return b.type == (a == CKEDITOR.SHRINK_ELEMENT ? CKEDITOR.NODE_ELEMENT : CKEDITOR.NODE_TEXT);
            };
            var C;
            f.guard = function (b, d) {
              if ((c && v(b)) || y(b)) return !0;
              if (
                (a == CKEDITOR.SHRINK_ELEMENT && b.type == CKEDITOR.NODE_TEXT) ||
                (d && b.equals(C)) ||
                (!1 === g && b.type == CKEDITOR.NODE_ELEMENT && b.isBlockBoundary()) ||
                (b.type == CKEDITOR.NODE_ELEMENT && b.hasAttribute('contenteditable'))
              )
                return !1;
              d || b.type != CKEDITOR.NODE_ELEMENT || (C = b);
              return !0;
            };
            d &&
              (k = f[a == CKEDITOR.SHRINK_ELEMENT ? 'lastForward' : 'next']()) &&
              this.setStartAt(k, b ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_BEFORE_START);
            z &&
              (f.reset(),
              (f = f[a == CKEDITOR.SHRINK_ELEMENT ? 'lastBackward' : 'previous']()) &&
                this.setEndAt(f, b ? CKEDITOR.POSITION_BEFORE_END : CKEDITOR.POSITION_AFTER_END));
            return !(!d && !z);
          }
        },
        insertNode: function (a) {
          this.optimizeBookmark();
          this.trim(!1, !0);
          var b = this.startContainer,
            d = b.getChild(this.startOffset);
          d ? a.insertBefore(d) : b.append(a);
          a.getParent() && a.getParent().equals(this.endContainer) && this.endOffset++;
          this.setStartBefore(a);
        },
        moveToPosition: function (a, b) {
          this.setStartAt(a, b);
          this.collapse(!0);
        },
        moveToRange: function (a) {
          this.setStart(a.startContainer, a.startOffset);
          this.setEnd(a.endContainer, a.endOffset);
        },
        selectNodeContents: function (a) {
          this.setStart(a, 0);
          this.setEnd(a, a.type == CKEDITOR.NODE_TEXT ? a.getLength() : a.getChildCount());
        },
        setStart: function (b, d) {
          b.type == CKEDITOR.NODE_ELEMENT && CKEDITOR.dtd.$empty[b.getName()] && ((d = b.getIndex()), (b = b.getParent()));
          this._setStartContainer(b);
          this.startOffset = d;
          this.endContainer || (this._setEndContainer(b), (this.endOffset = d));
          a(this);
        },
        setEnd: function (b, d) {
          b.type == CKEDITOR.NODE_ELEMENT && CKEDITOR.dtd.$empty[b.getName()] && ((d = b.getIndex() + 1), (b = b.getParent()));
          this._setEndContainer(b);
          this.endOffset = d;
          this.startContainer || (this._setStartContainer(b), (this.startOffset = d));
          a(this);
        },
        setStartAfter: function (a) {
          this.setStart(a.getParent(), a.getIndex() + 1);
        },
        setStartBefore: function (a) {
          this.setStart(a.getParent(), a.getIndex());
        },
        setEndAfter: function (a) {
          this.setEnd(a.getParent(), a.getIndex() + 1);
        },
        setEndBefore: function (a) {
          this.setEnd(a.getParent(), a.getIndex());
        },
        setStartAt: function (b, d) {
          switch (d) {
            case CKEDITOR.POSITION_AFTER_START:
              this.setStart(b, 0);
              break;
            case CKEDITOR.POSITION_BEFORE_END:
              b.type == CKEDITOR.NODE_TEXT ? this.setStart(b, b.getLength()) : this.setStart(b, b.getChildCount());
              break;
            case CKEDITOR.POSITION_BEFORE_START:
              this.setStartBefore(b);
              break;
            case CKEDITOR.POSITION_AFTER_END:
              this.setStartAfter(b);
          }
          a(this);
        },
        setEndAt: function (b, d) {
          switch (d) {
            case CKEDITOR.POSITION_AFTER_START:
              this.setEnd(b, 0);
              break;
            case CKEDITOR.POSITION_BEFORE_END:
              b.type == CKEDITOR.NODE_TEXT ? this.setEnd(b, b.getLength()) : this.setEnd(b, b.getChildCount());
              break;
            case CKEDITOR.POSITION_BEFORE_START:
              this.setEndBefore(b);
              break;
            case CKEDITOR.POSITION_AFTER_END:
              this.setEndAfter(b);
          }
          a(this);
        },
        fixBlock: function (a, b) {
          var d = this.createBookmark(),
            g = this.document.createElement(b);
          this.collapse(a);
          this.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS);
          this.extractContents().appendTo(g);
          g.trim();
          this.insertNode(g);
          var c = g.getBogus();
          c && c.remove();
          g.appendBogus();
          this.moveToBookmark(d);
          return g;
        },
        splitBlock: function (a, b) {
          var d = new CKEDITOR.dom.elementPath(this.startContainer, this.root),
            g = new CKEDITOR.dom.elementPath(this.endContainer, this.root),
            c = d.block,
            f = g.block,
            k = null;
          if (!d.blockLimit.equals(g.blockLimit)) return null;
          'br' != a &&
            (c || ((c = this.fixBlock(!0, a)), (f = new CKEDITOR.dom.elementPath(this.endContainer, this.root).block)),
            f || (f = this.fixBlock(!1, a)));
          d = c && this.checkStartOfBlock();
          g = f && this.checkEndOfBlock();
          this.deleteContents();
          c &&
            c.equals(f) &&
            (g
              ? ((k = new CKEDITOR.dom.elementPath(this.startContainer, this.root)),
                this.moveToPosition(f, CKEDITOR.POSITION_AFTER_END),
                (f = null))
              : d
                ? ((k = new CKEDITOR.dom.elementPath(this.startContainer, this.root)),
                  this.moveToPosition(c, CKEDITOR.POSITION_BEFORE_START),
                  (c = null))
                : ((f = this.splitElement(c, b || !1)), c.is('ul', 'ol') || c.appendBogus()));
          return { previousBlock: c, nextBlock: f, wasStartOfBlock: d, wasEndOfBlock: g, elementPath: k };
        },
        splitElement: function (a, b) {
          if (!this.collapsed) return null;
          this.setEndAt(a, CKEDITOR.POSITION_BEFORE_END);
          var d = this.extractContents(!1, b || !1),
            g = a.clone(!1, b || !1);
          d.appendTo(g);
          g.insertAfter(a);
          this.moveToPosition(a, CKEDITOR.POSITION_AFTER_END);
          return g;
        },
        removeEmptyBlocksAtEnd: (function () {
          function a(e) {
            return function (a) {
              return b(a) || d(a) || (a.type == CKEDITOR.NODE_ELEMENT && a.isEmptyInlineRemoveable()) || (e.is('table') && a.is('caption'))
                ? !1
                : !0;
            };
          }
          var b = CKEDITOR.dom.walker.whitespaces(),
            d = CKEDITOR.dom.walker.bookmark(!1);
          return function (b) {
            for (
              var d = this.createBookmark(), g = this[b ? 'endPath' : 'startPath'](), c = g.block || g.blockLimit, f;
              c && !c.equals(g.root) && !c.getFirst(a(c));

            )
              (f = c.getParent()), this[b ? 'setEndAt' : 'setStartAt'](c, CKEDITOR.POSITION_AFTER_END), c.remove(1), (c = f);
            this.moveToBookmark(d);
          };
        })(),
        startPath: function () {
          return new CKEDITOR.dom.elementPath(this.startContainer, this.root);
        },
        endPath: function () {
          return new CKEDITOR.dom.elementPath(this.endContainer, this.root);
        },
        checkBoundaryOfElement: function (a, d) {
          var g = d == CKEDITOR.START,
            c = this.clone();
          c.collapse(g);
          c[g ? 'setStartAt' : 'setEndAt'](a, g ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_BEFORE_END);
          c = new CKEDITOR.dom.walker(c);
          c.evaluator = b(g);
          return c[g ? 'checkBackward' : 'checkForward']();
        },
        checkStartOfBlock: function (a) {
          var b = this.startContainer,
            d = this.startOffset;
          CKEDITOR.env.ie &&
            d &&
            b.type == CKEDITOR.NODE_TEXT &&
            ((b = CKEDITOR.tools.ltrim(b.substring(0, d))), m.test(b) && this.trim(0, 1));
          a || this.trim();
          a = new CKEDITOR.dom.elementPath(this.startContainer, this.root);
          b = this.clone();
          b.collapse(!0);
          b.setStartAt(a.block || a.blockLimit, CKEDITOR.POSITION_AFTER_START);
          a = new CKEDITOR.dom.walker(b);
          a.evaluator = f();
          return a.checkBackward();
        },
        checkEndOfBlock: function (a) {
          var b = this.endContainer,
            d = this.endOffset;
          CKEDITOR.env.ie && b.type == CKEDITOR.NODE_TEXT && ((b = CKEDITOR.tools.rtrim(b.substring(d))), m.test(b) && this.trim(1, 0));
          a || this.trim();
          a = new CKEDITOR.dom.elementPath(this.endContainer, this.root);
          b = this.clone();
          b.collapse(!1);
          b.setEndAt(a.block || a.blockLimit, CKEDITOR.POSITION_BEFORE_END);
          a = new CKEDITOR.dom.walker(b);
          a.evaluator = f();
          return a.checkForward();
        },
        getPreviousNode: function (a, b, d) {
          var g = this.clone();
          g.collapse(1);
          g.setStartAt(d || this.root, CKEDITOR.POSITION_AFTER_START);
          d = new CKEDITOR.dom.walker(g);
          d.evaluator = a;
          d.guard = b;
          return d.previous();
        },
        getNextNode: function (a, b, d) {
          var g = this.clone();
          g.collapse();
          g.setEndAt(d || this.root, CKEDITOR.POSITION_BEFORE_END);
          d = new CKEDITOR.dom.walker(g);
          d.evaluator = a;
          d.guard = b;
          return d.next();
        },
        checkReadOnly: (function () {
          function a(b, e) {
            for (; b; ) {
              if (b.type == CKEDITOR.NODE_ELEMENT) {
                if ('false' == b.getAttribute('contentEditable') && !b.data('cke-editable')) return 0;
                if (b.is('html') || ('true' == b.getAttribute('contentEditable') && (b.contains(e) || b.equals(e)))) break;
              }
              b = b.getParent();
            }
            return 1;
          }
          return function () {
            var b = this.startContainer,
              d = this.endContainer;
            return !(a(b, d) && a(d, b));
          };
        })(),
        moveToElementEditablePosition: function (a, b) {
          if (a.type == CKEDITOR.NODE_ELEMENT && !a.isEditable(!1))
            return this.moveToPosition(a, b ? CKEDITOR.POSITION_AFTER_END : CKEDITOR.POSITION_BEFORE_START), !0;
          for (var g = 0; a; ) {
            if (a.type == CKEDITOR.NODE_TEXT) {
              b && this.endContainer && this.checkEndOfBlock() && m.test(a.getText())
                ? this.moveToPosition(a, CKEDITOR.POSITION_BEFORE_START)
                : this.moveToPosition(a, b ? CKEDITOR.POSITION_AFTER_END : CKEDITOR.POSITION_BEFORE_START);
              g = 1;
              break;
            }
            if (a.type == CKEDITOR.NODE_ELEMENT)
              if (a.isEditable()) this.moveToPosition(a, b ? CKEDITOR.POSITION_BEFORE_END : CKEDITOR.POSITION_AFTER_START), (g = 1);
              else if (b && a.is('br') && this.endContainer && this.checkEndOfBlock())
                this.moveToPosition(a, CKEDITOR.POSITION_BEFORE_START);
              else if ('false' == a.getAttribute('contenteditable') && a.is(CKEDITOR.dtd.$block))
                return this.setStartBefore(a), this.setEndAfter(a), !0;
            var c = a,
              f = g,
              k = void 0;
            c.type == CKEDITOR.NODE_ELEMENT && c.isEditable(!1) && (k = c[b ? 'getLast' : 'getFirst'](d));
            f || k || (k = c[b ? 'getPrevious' : 'getNext'](d));
            a = k;
          }
          return !!g;
        },
        moveToClosestEditablePosition: function (a, b) {
          var d,
            g = 0,
            c,
            f,
            k = [CKEDITOR.POSITION_AFTER_END, CKEDITOR.POSITION_BEFORE_START];
          a ? ((d = new CKEDITOR.dom.range(this.root)), d.moveToPosition(a, k[b ? 0 : 1])) : (d = this.clone());
          if (a && !a.is(CKEDITOR.dtd.$block)) g = 1;
          else if ((c = d[b ? 'getNextEditableNode' : 'getPreviousEditableNode']()))
            (g = 1),
              (f = c.type == CKEDITOR.NODE_ELEMENT) && c.is(CKEDITOR.dtd.$block) && 'false' == c.getAttribute('contenteditable')
                ? (d.setStartAt(c, CKEDITOR.POSITION_BEFORE_START), d.setEndAt(c, CKEDITOR.POSITION_AFTER_END))
                : !CKEDITOR.env.needsBrFiller && f && c.is(CKEDITOR.dom.walker.validEmptyBlockContainers)
                  ? (d.setEnd(c, 0), d.collapse())
                  : d.moveToPosition(c, k[b ? 1 : 0]);
          g && this.moveToRange(d);
          return !!g;
        },
        moveToElementEditStart: function (a) {
          return this.moveToElementEditablePosition(a);
        },
        moveToElementEditEnd: function (a) {
          return this.moveToElementEditablePosition(a, !0);
        },
        getEnclosedNode: function () {
          var a = this.clone();
          a.optimize();
          if (a.startContainer.type != CKEDITOR.NODE_ELEMENT || a.endContainer.type != CKEDITOR.NODE_ELEMENT) return null;
          var a = new CKEDITOR.dom.walker(a),
            b = CKEDITOR.dom.walker.bookmark(!1, !0),
            d = CKEDITOR.dom.walker.whitespaces(!0);
          a.evaluator = function (a) {
            return d(a) && b(a);
          };
          var g = a.next();
          a.reset();
          return g && g.equals(a.previous()) ? g : null;
        },
        getTouchedStartNode: function () {
          var a = this.startContainer;
          return this.collapsed || a.type != CKEDITOR.NODE_ELEMENT ? a : a.getChild(this.startOffset) || a;
        },
        getTouchedEndNode: function () {
          var a = this.endContainer;
          return this.collapsed || a.type != CKEDITOR.NODE_ELEMENT ? a : a.getChild(this.endOffset - 1) || a;
        },
        getNextEditableNode: c(),
        getPreviousEditableNode: c(1),
        _getTableElement: function (a) {
          a = a || { td: 1, th: 1, tr: 1, tbody: 1, thead: 1, tfoot: 1, table: 1 };
          var b = this.getTouchedStartNode(),
            d = this.getTouchedEndNode(),
            g = b.getAscendant('table', !0),
            d = d.getAscendant('table', !0);
          return g && !this.root.contains(g)
            ? null
            : this.getEnclosedNode()
              ? this.getEnclosedNode().getAscendant(a, !0)
              : g && d && (g.equals(d) || g.contains(d) || d.contains(g))
                ? b.getAscendant(a, !0)
                : null;
        },
        scrollIntoView: function () {
          var a = new CKEDITOR.dom.element.createFromHtml('\x3cspan\x3e\x26nbsp;\x3c/span\x3e', this.document),
            b,
            d,
            g,
            c = this.clone();
          c.optimize();
          (g = c.startContainer.type == CKEDITOR.NODE_TEXT)
            ? ((d = c.startContainer.getText()), (b = c.startContainer.split(c.startOffset)), a.insertAfter(c.startContainer))
            : c.insertNode(a);
          a.scrollIntoView();
          g && (c.startContainer.setText(d), b.remove());
          a.remove();
        },
        getClientRects: (function () {
          function a(b, e) {
            var d = CKEDITOR.tools.array.map(b, function (a) {
                return a;
              }),
              g = new CKEDITOR.dom.range(e.root),
              c,
              f,
              k;
            e.startContainer instanceof CKEDITOR.dom.element && (f = 0 === e.startOffset && e.startContainer.hasAttribute('data-widget'));
            e.endContainer instanceof CKEDITOR.dom.element &&
              (k =
                (k = e.endOffset === (e.endContainer.getChildCount ? e.endContainer.getChildCount() : e.endContainer.length)) &&
                e.endContainer.hasAttribute('data-widget'));
            f && g.setStart(e.startContainer.getParent(), e.startContainer.getIndex());
            k && g.setEnd(e.endContainer.getParent(), e.endContainer.getIndex() + 1);
            if (f || k) e = g;
            g = e.cloneContents().find('[data-cke-widget-id]').toArray();
            if (
              (g = CKEDITOR.tools.array.map(g, function (a) {
                var b = e.root.editor;
                a = a.getAttribute('data-cke-widget-id');
                return b.widgets.instances[a].element;
              }))
            )
              return (
                (g = CKEDITOR.tools.array.map(
                  g,
                  function (a) {
                    var b;
                    b = a.getParent().hasClass('cke_widget_wrapper') ? a.getParent() : a;
                    c = this.root.getDocument().$.createRange();
                    c.setStart(b.getParent().$, b.getIndex());
                    c.setEnd(b.getParent().$, b.getIndex() + 1);
                    b = c.getClientRects();
                    b.widgetRect = a.getClientRect();
                    return b;
                  },
                  e,
                )),
                CKEDITOR.tools.array.forEach(g, function (a) {
                  function b(g) {
                    CKEDITOR.tools.array.forEach(d, function (b, c) {
                      var f = CKEDITOR.tools.objectCompare(a[g], b);
                      f || (f = CKEDITOR.tools.objectCompare(a.widgetRect, b));
                      f && (Array.prototype.splice.call(d, c, a.length - g, a.widgetRect), (e = !0));
                    });
                    e || (g < d.length - 1 ? b(g + 1) : d.push(a.widgetRect));
                  }
                  var e;
                  b(0);
                }),
                d
              );
          }
          function b(a, e, d) {
            var c;
            e.collapsed
              ? d.startContainer instanceof CKEDITOR.dom.element
                ? ((a = d.checkStartOfBlock()),
                  (c = new CKEDITOR.dom.text('​')),
                  a
                    ? d.startContainer.append(c, !0)
                    : 0 === d.startOffset
                      ? c.insertBefore(d.startContainer.getFirst())
                      : ((d = d.startContainer.getChildren().getItem(d.startOffset - 1)), c.insertAfter(d)),
                  e.setStart(c.$, 0),
                  e.setEnd(c.$, 0),
                  (a = e.getClientRects()),
                  c.remove())
                : d.startContainer instanceof CKEDITOR.dom.text &&
                  ('' === d.startContainer.getText()
                    ? (d.startContainer.setText('​'), (a = e.getClientRects()), d.startContainer.setText(''))
                    : (a = [g(d.createBookmark())]))
              : (a = [g(d.createBookmark())]);
            return a;
          }
          function d(a, b, e) {
            a = CKEDITOR.tools.extend({}, a);
            b && (a = CKEDITOR.tools.getAbsoluteRectPosition(e.document.getWindow(), a));
            !a.width && (a.width = a.right - a.left);
            !a.height && (a.height = a.bottom - a.top);
            return a;
          }
          function g(a) {
            var b = a.startNode;
            a = a.endNode;
            var e;
            b.setText('​');
            b.removeStyle('display');
            a
              ? (a.setText('​'), a.removeStyle('display'), (e = [b.getClientRect(), a.getClientRect()]), a.remove())
              : (e = [b.getClientRect(), b.getClientRect()]);
            b.remove();
            return {
              right: Math.max(e[0].right, e[1].right),
              bottom: Math.max(e[0].bottom, e[1].bottom),
              left: Math.min(e[0].left, e[1].left),
              top: Math.min(e[0].top, e[1].top),
              width: Math.abs(e[0].left - e[1].left),
              height: Math.max(e[0].bottom, e[1].bottom) - Math.min(e[0].top, e[1].top),
            };
          }
          return void 0 !== document.getSelection
            ? function (g) {
                var c = this.root.getDocument().$.createRange(),
                  f;
                c.setStart(this.startContainer.$, this.startOffset);
                c.setEnd(this.endContainer.$, this.endOffset);
                f = c.getClientRects();
                f = a(f, this);
                f.length || (f = b(f, c, this));
                return CKEDITOR.tools.array.map(
                  f,
                  function (a) {
                    return d(a, g, this);
                  },
                  this,
                );
              }
            : function (a) {
                return [d(g(this.createBookmark()), a, this)];
              };
        })(),
        _setStartContainer: function (a) {
          this.startContainer = a;
        },
        _setEndContainer: function (a) {
          this.endContainer = a;
        },
        _find: function (a, b) {
          var d = this.getCommonAncestor(),
            g = this.getBoundaryNodes(),
            c = [],
            f,
            k,
            l,
            h;
          if (d && d.find)
            for (k = d.find(a), f = 0; f < k.count(); f++)
              if (((d = k.getItem(f)), b || !d.isReadOnly()))
                (l = d.getPosition(g.startNode) & CKEDITOR.POSITION_FOLLOWING || g.startNode.equals(d)),
                  (h = d.getPosition(g.endNode) & (CKEDITOR.POSITION_PRECEDING + CKEDITOR.POSITION_IS_CONTAINED) || g.endNode.equals(d)),
                  l && h && c.push(d);
          return c;
        },
      };
      CKEDITOR.dom.range.mergeRanges = function (a) {
        return CKEDITOR.tools.array.reduce(
          a,
          function (a, b) {
            var e = a[a.length - 1],
              d = !1;
            b = b.clone();
            b.enlarge(CKEDITOR.ENLARGE_ELEMENT);
            if (e) {
              var g = new CKEDITOR.dom.range(b.root),
                d = new CKEDITOR.dom.walker(g),
                c = CKEDITOR.dom.walker.whitespaces();
              g.setStart(e.endContainer, e.endOffset);
              g.setEnd(b.startContainer, b.startOffset);
              for (g = d.next(); c(g) || b.endContainer.equals(g); ) g = d.next();
              d = !g;
            }
            d ? e.setEnd(b.endContainer, b.endOffset) : a.push(b);
            return a;
          },
          [],
        );
      };
    })();
    CKEDITOR.POSITION_AFTER_START = 1;
    CKEDITOR.POSITION_BEFORE_END = 2;
    CKEDITOR.POSITION_BEFORE_START = 3;
    CKEDITOR.POSITION_AFTER_END = 4;
    CKEDITOR.ENLARGE_ELEMENT = 1;
    CKEDITOR.ENLARGE_BLOCK_CONTENTS = 2;
    CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS = 3;
    CKEDITOR.ENLARGE_INLINE = 4;
    CKEDITOR.START = 1;
    CKEDITOR.END = 2;
    CKEDITOR.SHRINK_ELEMENT = 1;
    CKEDITOR.SHRINK_TEXT = 2;
    ('use strict');
    (function () {
      function a(a) {
        1 > arguments.length ||
          ((this.range = a), (this.forceBrBreak = 0), (this.enlargeBr = 1), (this.enforceRealBlocks = 0), this._ || (this._ = {}));
      }
      function h(a) {
        var b = [];
        a.forEach(
          function (a) {
            if ('true' == a.getAttribute('contenteditable')) return b.push(a), !1;
          },
          CKEDITOR.NODE_ELEMENT,
          !0,
        );
        return b;
      }
      function f(a, b, g, c) {
        a: {
          null == c && (c = h(g));
          for (var k; (k = c.shift()); )
            if (k.getDtd().p) {
              c = { element: k, remaining: c };
              break a;
            }
          c = null;
        }
        if (!c) return 0;
        if ((k = CKEDITOR.filter.instances[c.element.data('cke-filter')]) && !k.check(b)) return f(a, b, g, c.remaining);
        b = new CKEDITOR.dom.range(c.element);
        b.selectNodeContents(c.element);
        b = b.createIterator();
        b.enlargeBr = a.enlargeBr;
        b.enforceRealBlocks = a.enforceRealBlocks;
        b.activeFilter = b.filter = k;
        a._.nestedEditable = { element: c.element, container: g, remaining: c.remaining, iterator: b };
        return 1;
      }
      function b(a, b, g) {
        if (!b) return !1;
        a = a.clone();
        a.collapse(!g);
        return a.checkBoundaryOfElement(b, g ? CKEDITOR.START : CKEDITOR.END);
      }
      var c = /^[\r\n\t ]+$/,
        l = CKEDITOR.dom.walker.bookmark(!1, !0),
        k = CKEDITOR.dom.walker.whitespaces(!0),
        m = function (a) {
          return l(a) && k(a);
        },
        g = { dd: 1, dt: 1, li: 1 };
      a.prototype = {
        getNextParagraph: function (a) {
          var e, k, h, x, u;
          a = a || 'p';
          if (this._.nestedEditable) {
            if ((e = this._.nestedEditable.iterator.getNextParagraph(a)))
              return (this.activeFilter = this._.nestedEditable.iterator.activeFilter), e;
            this.activeFilter = this.filter;
            if (f(this, a, this._.nestedEditable.container, this._.nestedEditable.remaining))
              return (this.activeFilter = this._.nestedEditable.iterator.activeFilter), this._.nestedEditable.iterator.getNextParagraph(a);
            this._.nestedEditable = null;
          }
          if (!this.range.root.getDtd()[a]) return null;
          if (!this._.started) {
            var p = this.range.clone();
            k = p.startPath();
            var t = p.endPath(),
              A = !p.collapsed && b(p, k.block),
              q = !p.collapsed && b(p, t.block, 1);
            p.shrink(CKEDITOR.SHRINK_ELEMENT, !0);
            A && p.setStartAt(k.block, CKEDITOR.POSITION_BEFORE_END);
            q && p.setEndAt(t.block, CKEDITOR.POSITION_AFTER_START);
            k = p.endContainer.hasAscendant('pre', !0) || p.startContainer.hasAscendant('pre', !0);
            p.enlarge((this.forceBrBreak && !k) || !this.enlargeBr ? CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS : CKEDITOR.ENLARGE_BLOCK_CONTENTS);
            p.collapsed ||
              ((k = new CKEDITOR.dom.walker(p.clone())),
              (t = CKEDITOR.dom.walker.bookmark(!0, !0)),
              (k.evaluator = t),
              (this._.nextNode = k.next()),
              (k = new CKEDITOR.dom.walker(p.clone())),
              (k.evaluator = t),
              (k = k.previous()),
              (this._.lastNode = k.getNextSourceNode(!0, null, p.root)),
              this._.lastNode &&
                this._.lastNode.type == CKEDITOR.NODE_TEXT &&
                !CKEDITOR.tools.trim(this._.lastNode.getText()) &&
                this._.lastNode.getParent().isBlockBoundary() &&
                ((t = this.range.clone()),
                t.moveToPosition(this._.lastNode, CKEDITOR.POSITION_AFTER_END),
                t.checkEndOfBlock() &&
                  ((t = new CKEDITOR.dom.elementPath(t.endContainer, t.root)),
                  (this._.lastNode = (t.block || t.blockLimit).getNextSourceNode(!0)))),
              (this._.lastNode && p.root.contains(this._.lastNode)) ||
                ((this._.lastNode = this._.docEndMarker = p.document.createText('')), this._.lastNode.insertAfter(k)),
              (p = null));
            this._.started = 1;
            k = p;
          }
          t = this._.nextNode;
          p = this._.lastNode;
          for (this._.nextNode = null; t; ) {
            var A = 0,
              q = t.hasAscendant('pre'),
              B = t.type != CKEDITOR.NODE_ELEMENT,
              z = 0;
            if (B) t.type == CKEDITOR.NODE_TEXT && c.test(t.getText()) && (B = 0);
            else {
              var y = t.getName();
              if (CKEDITOR.dtd.$block[y] && 'false' == t.getAttribute('contenteditable')) {
                e = t;
                f(this, a, e);
                break;
              } else if (t.isBlockBoundary(this.forceBrBreak && !q && { br: 1 })) {
                if ('br' == y) B = 1;
                else if (!k && !t.getChildCount() && 'hr' != y) {
                  e = t;
                  h = t.equals(p);
                  break;
                }
                k && (k.setEndAt(t, CKEDITOR.POSITION_BEFORE_START), 'br' != y && (this._.nextNode = t));
                A = 1;
              } else {
                if (t.getFirst()) {
                  k || ((k = this.range.clone()), k.setStartAt(t, CKEDITOR.POSITION_BEFORE_START));
                  t = t.getFirst();
                  continue;
                }
                B = 1;
              }
            }
            B && !k && ((k = this.range.clone()), k.setStartAt(t, CKEDITOR.POSITION_BEFORE_START));
            h = (!A || B) && t.equals(p);
            if (k && !A)
              for (; !t.getNext(m) && !h; ) {
                y = t.getParent();
                if (y.isBlockBoundary(this.forceBrBreak && !q && { br: 1 })) {
                  A = 1;
                  B = 0;
                  h || y.equals(p);
                  k.setEndAt(y, CKEDITOR.POSITION_BEFORE_END);
                  break;
                }
                t = y;
                B = 1;
                h = t.equals(p);
                z = 1;
              }
            B && k.setEndAt(t, CKEDITOR.POSITION_AFTER_END);
            t = this._getNextSourceNode(t, z, p);
            if ((h = !t) || (A && k)) break;
          }
          if (!e) {
            if (!k) return this._.docEndMarker && this._.docEndMarker.remove(), (this._.nextNode = null);
            e = new CKEDITOR.dom.elementPath(k.startContainer, k.root);
            t = e.blockLimit;
            A = { div: 1, th: 1, td: 1 };
            e = e.block;
            !e && t && !this.enforceRealBlocks && A[t.getName()] && k.checkStartOfBlock() && k.checkEndOfBlock() && !t.equals(k.root)
              ? (e = t)
              : !e || (this.enforceRealBlocks && e.is(g))
                ? ((e = this.range.document.createElement(a)), k.extractContents().appendTo(e), e.trim(), k.insertNode(e), (x = u = !0))
                : 'li' != e.getName()
                  ? (k.checkStartOfBlock() && k.checkEndOfBlock()) ||
                    ((e = e.clone(!1)),
                    k.extractContents().appendTo(e),
                    e.trim(),
                    (u = k.splitBlock()),
                    (x = !u.wasStartOfBlock),
                    (u = !u.wasEndOfBlock),
                    k.insertNode(e))
                  : h || (this._.nextNode = e.equals(p) ? null : this._getNextSourceNode(k.getBoundaryNodes().endNode, 1, p));
          }
          x &&
            (x = e.getPrevious()) &&
            x.type == CKEDITOR.NODE_ELEMENT &&
            ('br' == x.getName() ? x.remove() : x.getLast() && 'br' == x.getLast().$.nodeName.toLowerCase() && x.getLast().remove());
          u &&
            (x = e.getLast()) &&
            x.type == CKEDITOR.NODE_ELEMENT &&
            'br' == x.getName() &&
            (!CKEDITOR.env.needsBrFiller || x.getPrevious(l) || x.getNext(l)) &&
            x.remove();
          this._.nextNode || (this._.nextNode = h || e.equals(p) || !p ? null : this._getNextSourceNode(e, 1, p));
          return e;
        },
        _getNextSourceNode: function (a, b, g) {
          function c(a) {
            return !(a.equals(g) || a.equals(f));
          }
          var f = this.range.root;
          for (a = a.getNextSourceNode(b, null, c); !l(a); ) a = a.getNextSourceNode(b, null, c);
          return a;
        },
      };
      CKEDITOR.dom.range.prototype.createIterator = function () {
        return new a(this);
      };
    })();
    CKEDITOR.command = function (a, h) {
      this.uiItems = [];
      this.exec = function (b) {
        if (this.state == CKEDITOR.TRISTATE_DISABLED || !this.checkAllowed()) return !1;
        this.editorFocus && a.focus();
        return !1 === this.fire('exec') ? !0 : !1 !== h.exec.call(this, a, b);
      };
      this.refresh = function (a, c) {
        if (!this.readOnly && a.readOnly) return !0;
        if ((this.context && !c.isContextFor(this.context)) || !this.checkAllowed(!0)) return this.disable(), !0;
        this.startDisabled || this.enable();
        this.modes && !this.modes[a.mode] && this.disable();
        return !1 === this.fire('refresh', { editor: a, path: c }) ? !0 : h.refresh && !1 !== h.refresh.apply(this, arguments);
      };
      var f;
      this.checkAllowed = function (b) {
        return b || 'boolean' != typeof f ? (f = a.activeFilter.checkFeature(this)) : f;
      };
      CKEDITOR.tools.extend(this, h, {
        modes: { wysiwyg: 1 },
        editorFocus: 1,
        contextSensitive: !!h.context,
        state: CKEDITOR.TRISTATE_DISABLED,
      });
      CKEDITOR.event.call(this);
    };
    CKEDITOR.command.prototype = {
      enable: function () {
        this.state == CKEDITOR.TRISTATE_DISABLED &&
          this.checkAllowed() &&
          this.setState(this.preserveState && 'undefined' != typeof this.previousState ? this.previousState : CKEDITOR.TRISTATE_OFF);
      },
      disable: function () {
        this.setState(CKEDITOR.TRISTATE_DISABLED);
      },
      setState: function (a) {
        if (this.state == a || (a != CKEDITOR.TRISTATE_DISABLED && !this.checkAllowed())) return !1;
        this.previousState = this.state;
        this.state = a;
        this.fire('state');
        return !0;
      },
      toggleState: function () {
        this.state == CKEDITOR.TRISTATE_OFF
          ? this.setState(CKEDITOR.TRISTATE_ON)
          : this.state == CKEDITOR.TRISTATE_ON && this.setState(CKEDITOR.TRISTATE_OFF);
      },
    };
    CKEDITOR.event.implementOn(CKEDITOR.command.prototype);
    CKEDITOR.ENTER_P = 1;
    CKEDITOR.ENTER_BR = 2;
    CKEDITOR.ENTER_DIV = 3;
    CKEDITOR.config = {
      customConfig: 'config.js',
      autoUpdateElement: !0,
      language: '',
      defaultLanguage: 'en',
      contentsLangDirection: '',
      enterMode: CKEDITOR.ENTER_P,
      forceEnterMode: !1,
      shiftEnterMode: CKEDITOR.ENTER_BR,
      docType: '\x3c!DOCTYPE html\x3e',
      bodyId: '',
      bodyClass: '',
      fullPage: !1,
      height: 200,
      contentsCss: CKEDITOR.getUrl('contents.css'),
      extraPlugins: '',
      removePlugins: '',
      protectedSource: [],
      tabIndex: 0,
      useComputedState: !0,
      width: '',
      baseFloatZIndex: 1e4,
      blockedKeystrokes: [CKEDITOR.CTRL + 66, CKEDITOR.CTRL + 73, CKEDITOR.CTRL + 85],
    };
    (function () {
      function a(a, b, e, d, g) {
        var c, f;
        a = [];
        for (c in b) {
          f = b[c];
          f = 'boolean' == typeof f ? {} : 'function' == typeof f ? { match: f } : H(f);
          '$' != c.charAt(0) && (f.elements = c);
          e && (f.featureName = e.toLowerCase());
          var l = f;
          l.elements = k(l.elements, /\s+/) || null;
          l.propertiesOnly = l.propertiesOnly || !0 === l.elements;
          var h = /\s*,\s*/,
            m = void 0;
          for (m in S) {
            l[m] = k(l[m], h) || null;
            var n = l,
              t = I[m],
              r = k(l[I[m]], h),
              O = l[m],
              q = [],
              J = !0,
              M = void 0;
            r ? (J = !1) : (r = {});
            for (M in O) '!' == M.charAt(0) && ((M = M.slice(1)), q.push(M), (r[M] = !0), (J = !1));
            for (; (M = q.pop()); ) (O[M] = O['!' + M]), delete O['!' + M];
            n[t] = (J ? !1 : r) || null;
          }
          l.match = l.match || null;
          d.push(f);
          a.push(f);
        }
        b = g.elements;
        g = g.generic;
        var v;
        e = 0;
        for (d = a.length; e < d; ++e) {
          c = H(a[e]);
          f = !0 === c.classes || !0 === c.styles || !0 === c.attributes;
          l = c;
          m = t = h = void 0;
          for (h in S) l[h] = A(l[h]);
          n = !0;
          for (m in I) {
            h = I[m];
            t = l[h];
            r = [];
            O = void 0;
            for (O in t) -1 < O.indexOf('*') ? r.push(new RegExp('^' + O.replace(/\*/g, '.*') + '$')) : r.push(O);
            t = r;
            t.length && ((l[h] = t), (n = !1));
          }
          l.nothingRequired = n;
          l.noProperties = !(l.attributes || l.classes || l.styles);
          if (!0 === c.elements || null === c.elements) g[f ? 'unshift' : 'push'](c);
          else
            for (v in ((l = c.elements), delete c.elements, l))
              if (b[v]) b[v][f ? 'unshift' : 'push'](c);
              else b[v] = [c];
        }
      }
      function h(a, b, e, d) {
        if (!a.match || a.match(b))
          if (d || m(a, b))
            if (
              (a.propertiesOnly || (e.valid = !0),
              e.allAttributes || (e.allAttributes = f(a.attributes, b.attributes, e.validAttributes)),
              e.allStyles || (e.allStyles = f(a.styles, b.styles, e.validStyles)),
              !e.allClasses)
            ) {
              a = a.classes;
              b = b.classes;
              d = e.validClasses;
              if (a)
                if (!0 === a) a = !0;
                else {
                  for (var g = 0, c = b.length, k; g < c; ++g) (k = b[g]), d[k] || (d[k] = a(k));
                  a = !1;
                }
              else a = !1;
              e.allClasses = a;
            }
      }
      function f(a, b, e) {
        if (!a) return !1;
        if (!0 === a) return !0;
        for (var d in b) e[d] || (e[d] = a(d));
        return !1;
      }
      function b(a, b, e) {
        if (!a.match || a.match(b)) {
          if (a.noProperties) return !1;
          e.hadInvalidAttribute = c(a.attributes, b.attributes) || e.hadInvalidAttribute;
          e.hadInvalidStyle = c(a.styles, b.styles) || e.hadInvalidStyle;
          a = a.classes;
          b = b.classes;
          if (a) {
            for (var d = !1, g = !0 === a, f = b.length; f--; ) if (g || a(b[f])) b.splice(f, 1), (d = !0);
            a = d;
          } else a = !1;
          e.hadInvalidClass = a || e.hadInvalidClass;
        }
      }
      function c(a, b) {
        if (!a) return !1;
        var e = !1,
          d = !0 === a,
          g;
        for (g in b) if (d || a(g)) delete b[g], (e = !0);
        return e;
      }
      function l(a, b, e) {
        if (a.disabled || (a.customConfig && !e) || !b) return !1;
        a._.cachedChecks = {};
        return !0;
      }
      function k(a, b) {
        if (!a) return !1;
        if (!0 === a) return a;
        if ('string' == typeof a) return (a = L(a)), '*' == a ? !0 : CKEDITOR.tools.convertArrayToObject(a.split(b));
        if (CKEDITOR.tools.isArray(a)) return a.length ? CKEDITOR.tools.convertArrayToObject(a) : !1;
        var e = {},
          d = 0,
          g;
        for (g in a) (e[g] = a[g]), d++;
        return d ? e : !1;
      }
      function m(a, b) {
        if (a.nothingRequired) return !0;
        var e, d, c, f;
        if ((c = a.requiredClasses))
          for (f = b.classes, e = 0; e < c.length; ++e)
            if (((d = c[e]), 'string' == typeof d)) {
              if (-1 == CKEDITOR.tools.indexOf(f, d)) return !1;
            } else if (!CKEDITOR.tools.checkIfAnyArrayItemMatches(f, d)) return !1;
        return g(b.styles, a.requiredStyles) && g(b.attributes, a.requiredAttributes);
      }
      function g(a, b) {
        if (!b) return !0;
        for (var e = 0, d; e < b.length; ++e)
          if (((d = b[e]), 'string' == typeof d)) {
            if (!(d in a)) return !1;
          } else if (!CKEDITOR.tools.checkIfAnyObjectPropertyMatches(a, d)) return !1;
        return !0;
      }
      function d(a) {
        if (!a) return {};
        a = a.split(/\s*,\s*/).sort();
        for (var b = {}; a.length; ) b[a.shift()] = 'cke-test';
        return b;
      }
      function e(a) {
        var b,
          e,
          d,
          g,
          c = {},
          f = 1;
        for (a = L(a); (b = a.match(E)); )
          (e = b[2]) ? ((d = n(e, 'styles')), (g = n(e, 'attrs')), (e = n(e, 'classes'))) : (d = g = e = null),
            (c['$' + f++] = { elements: b[1], classes: e, styles: d, attributes: g }),
            (a = a.slice(b[0].length));
        return c;
      }
      function n(a, b) {
        var e = a.match(P[b]);
        return e ? L(e[1]) : null;
      }
      function r(a) {
        var b = (a.styleBackup = a.attributes.style),
          e = (a.classBackup = a.attributes['class']);
        a.styles || (a.styles = CKEDITOR.tools.parseCssText(b || '', 1));
        a.classes || (a.classes = e ? e.split(/\s+/) : []);
      }
      function x(a, e, d, g) {
        var c = 0,
          f;
        g.toHtml && (e.name = e.name.replace(M, '$1'));
        if (g.doCallbacks && a.elementCallbacks) {
          a: {
            f = a.elementCallbacks;
            for (var k = 0, l = f.length, m; k < l; ++k)
              if ((m = f[k](e))) {
                f = m;
                break a;
              }
            f = void 0;
          }
          if (f) return f;
        }
        if (g.doTransform && (f = a._.transformations[e.name])) {
          r(e);
          for (k = 0; k < f.length; ++k) y(a, e, f[k]);
          p(e);
        }
        if (g.doFilter) {
          a: {
            k = e.name;
            l = a._;
            a = l.allowedRules.elements[k];
            f = l.allowedRules.generic;
            k = l.disallowedRules.elements[k];
            l = l.disallowedRules.generic;
            m = g.skipRequired;
            var n = {
                valid: !1,
                validAttributes: {},
                validClasses: {},
                validStyles: {},
                allAttributes: !1,
                allClasses: !1,
                allStyles: !1,
                hadInvalidAttribute: !1,
                hadInvalidClass: !1,
                hadInvalidStyle: !1,
              },
              q,
              A;
            if (a || f) {
              r(e);
              if (k)
                for (q = 0, A = k.length; q < A; ++q)
                  if (!1 === b(k[q], e, n)) {
                    a = null;
                    break a;
                  }
              if (l) for (q = 0, A = l.length; q < A; ++q) b(l[q], e, n);
              if (a) for (q = 0, A = a.length; q < A; ++q) h(a[q], e, n, m);
              if (f) for (q = 0, A = f.length; q < A; ++q) h(f[q], e, n, m);
              a = n;
            } else a = null;
          }
          if (!a || !a.valid) return d.push(e), 1;
          A = a.validAttributes;
          var v = a.validStyles;
          f = a.validClasses;
          var k = e.attributes,
            H = e.styles,
            l = e.classes;
          m = e.classBackup;
          var F = e.styleBackup,
            J,
            L,
            G = [],
            n = [],
            x = /^data-cke-/;
          q = !1;
          delete k.style;
          delete k['class'];
          delete e.classBackup;
          delete e.styleBackup;
          if (!a.allAttributes)
            for (J in k)
              A[J] ||
                (x.test(J) ? J == (L = J.replace(/^data-cke-saved-/, '')) || A[L] || (delete k[J], (q = !0)) : (delete k[J], (q = !0)));
          if (!a.allStyles || a.hadInvalidStyle) {
            for (J in H) a.allStyles || v[J] ? G.push(J + ':' + H[J]) : (q = !0);
            G.length && (k.style = G.sort().join('; '));
          } else F && (k.style = F);
          if (!a.allClasses || a.hadInvalidClass) {
            for (J = 0; J < l.length; ++J) (a.allClasses || f[l[J]]) && n.push(l[J]);
            n.length && (k['class'] = n.sort().join(' '));
            m && n.length < m.split(/\s+/).length && (q = !0);
          } else m && (k['class'] = m);
          q && (c = 1);
          if (!g.skipFinalValidation && !t(e)) return d.push(e), 1;
        }
        g.toHtml && (e.name = e.name.replace(O, 'cke:$1'));
        return c;
      }
      function u(a) {
        var b = [],
          e;
        for (e in a) -1 < e.indexOf('*') && b.push(e.replace(/\*/g, '.*'));
        return b.length ? new RegExp('^(?:' + b.join('|') + ')$') : null;
      }
      function p(a) {
        var b = a.attributes,
          e;
        delete b.style;
        delete b['class'];
        if ((e = CKEDITOR.tools.writeCssText(a.styles, !0))) b.style = e;
        a.classes.length && (b['class'] = a.classes.sort().join(' '));
      }
      function t(a) {
        switch (a.name) {
          case 'a':
            if (!(a.children.length || a.attributes.name || a.attributes.id)) return !1;
            break;
          case 'img':
            if (!a.attributes.src) return !1;
        }
        return !0;
      }
      function A(a) {
        if (!a) return !1;
        if (!0 === a) return !0;
        var b = u(a);
        return function (e) {
          return e in a || (b && e.match(b));
        };
      }
      function q() {
        return new CKEDITOR.htmlParser.element('br');
      }
      function B(a) {
        return a.type == CKEDITOR.NODE_ELEMENT && ('br' == a.name || G.$block[a.name]);
      }
      function z(a, b, e) {
        var d = a.name;
        if (G.$empty[d] || !a.children.length)
          'hr' == d && 'br' == b ? a.replaceWith(q()) : (a.parent && e.push({ check: 'it', el: a.parent }), a.remove());
        else if (G.$block[d] || 'tr' == d)
          if ('br' == b)
            a.previous && !B(a.previous) && ((b = q()), b.insertBefore(a)),
              a.next && !B(a.next) && ((b = q()), b.insertAfter(a)),
              a.replaceWithChildren();
          else {
            var d = a.children,
              g;
            b: {
              g = G[b];
              for (var c = 0, f = d.length, k; c < f; ++c)
                if (((k = d[c]), k.type == CKEDITOR.NODE_ELEMENT && !g[k.name])) {
                  g = !1;
                  break b;
                }
              g = !0;
            }
            if (g) (a.name = b), (a.attributes = {}), e.push({ check: 'parent-down', el: a });
            else {
              g = a.parent;
              for (var c = g.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT || 'body' == g.name, l, h, f = d.length; 0 < f; )
                (k = d[--f]),
                  c && (k.type == CKEDITOR.NODE_TEXT || (k.type == CKEDITOR.NODE_ELEMENT && G.$inline[k.name]))
                    ? (l || ((l = new CKEDITOR.htmlParser.element(b)), l.insertAfter(a), e.push({ check: 'parent-down', el: l })),
                      l.add(k, 0))
                    : ((l = null),
                      (h = G[g.name] || G.span),
                      k.insertAfter(a),
                      g.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT ||
                        k.type != CKEDITOR.NODE_ELEMENT ||
                        h[k.name] ||
                        e.push({ check: 'el-up', el: k }));
              a.remove();
            }
          }
        else d in { style: 1, script: 1 } ? a.remove() : (a.parent && e.push({ check: 'it', el: a.parent }), a.replaceWithChildren());
      }
      function y(a, b, e) {
        var d, g;
        for (d = 0; d < e.length; ++d)
          if (((g = e[d]), !((g.check && !a.check(g.check, !1)) || (g.left && !g.left(b))))) {
            g.right(b, N);
            break;
          }
      }
      function v(a, b) {
        var e = b.getDefinition(),
          d = e.attributes,
          g = e.styles,
          c,
          f,
          k,
          l;
        if (a.name != e.element) return !1;
        for (c in d)
          if ('class' == c)
            for (e = d[c].split(/\s+/), k = a.classes.join('|'); (l = e.pop()); ) {
              if (-1 == k.indexOf(l)) return !1;
            }
          else if (a.attributes[c] != d[c]) return !1;
        for (f in g) if (a.styles[f] != g[f]) return !1;
        return !0;
      }
      function C(a, b) {
        var e, d;
        'string' == typeof a ? (e = a) : a instanceof CKEDITOR.style ? (d = a) : ((e = a[0]), (d = a[1]));
        return [
          {
            element: e,
            left: d,
            right: function (a, e) {
              e.transform(a, b);
            },
          },
        ];
      }
      function F(a) {
        return function (b) {
          return v(b, a);
        };
      }
      function D(a) {
        return function (b, e) {
          e[a](b);
        };
      }
      var G = CKEDITOR.dtd,
        H = CKEDITOR.tools.copy,
        L = CKEDITOR.tools.trim,
        K = ['', 'p', 'br', 'div'];
      CKEDITOR.FILTER_SKIP_TREE = 2;
      CKEDITOR.filter = function (a, b) {
        this.allowedContent = [];
        this.disallowedContent = [];
        this.elementCallbacks = null;
        this.disabled = !1;
        this.editor = null;
        this.id = CKEDITOR.tools.getNextNumber();
        this._ = {
          allowedRules: { elements: {}, generic: [] },
          disallowedRules: { elements: {}, generic: [] },
          transformations: {},
          cachedTests: {},
          cachedChecks: {},
        };
        CKEDITOR.filter.instances[this.id] = this;
        var e = (this.editor = a instanceof CKEDITOR.editor ? a : null);
        if (e && !b) {
          this.customConfig = !0;
          var d = e.config.allowedContent;
          !0 === d
            ? (this.disabled = !0)
            : (d || (this.customConfig = !1),
              this.allow(d, 'config', 1),
              this.allow(e.config.extraAllowedContent, 'extra', 1),
              this.allow(K[e.enterMode] + ' ' + K[e.shiftEnterMode], 'default', 1),
              this.disallow(e.config.disallowedContent));
        } else (this.customConfig = !1), this.allow(b || a, 'default', 1);
      };
      CKEDITOR.filter.instances = {};
      CKEDITOR.filter.prototype = {
        allow: function (b, d, g) {
          if (!l(this, b, g)) return !1;
          var c, f;
          if ('string' == typeof b) b = e(b);
          else if (b instanceof CKEDITOR.style) {
            if (b.toAllowedContentRules) return this.allow(b.toAllowedContentRules(this.editor), d, g);
            c = b.getDefinition();
            b = {};
            g = c.attributes;
            b[c.element] = c = { styles: c.styles, requiredStyles: c.styles && CKEDITOR.tools.object.keys(c.styles) };
            g &&
              ((g = H(g)),
              (c.classes = g['class'] ? g['class'].split(/\s+/) : null),
              (c.requiredClasses = c.classes),
              delete g['class'],
              (c.attributes = g),
              (c.requiredAttributes = g && CKEDITOR.tools.object.keys(g)));
          } else if (CKEDITOR.tools.isArray(b)) {
            for (c = 0; c < b.length; ++c) f = this.allow(b[c], d, g);
            return f;
          }
          a(this, b, d, this.allowedContent, this._.allowedRules);
          return !0;
        },
        applyTo: function (a, b, e, d) {
          if (this.disabled) return !1;
          var g = this,
            c = [],
            f = this.editor && this.editor.config.protectedSource,
            k,
            l = !1,
            h = { doFilter: !e, doTransform: !0, doCallbacks: !0, toHtml: b };
          a.forEach(
            function (a) {
              if (a.type == CKEDITOR.NODE_ELEMENT) {
                if ('off' == a.attributes['data-cke-filter']) return !1;
                if (!b || 'span' != a.name || !~CKEDITOR.tools.object.keys(a.attributes).join('|').indexOf('data-cke-'))
                  if (((k = x(g, a, c, h)), k & 1)) l = !0;
                  else if (k & 2) return !1;
              } else if (a.type == CKEDITOR.NODE_COMMENT && a.value.match(/^\{cke_protected\}(?!\{C\})/)) {
                var e;
                a: {
                  var d = decodeURIComponent(a.value.replace(/^\{cke_protected\}/, ''));
                  e = [];
                  var m, n, t;
                  if (f)
                    for (n = 0; n < f.length; ++n)
                      if ((t = d.match(f[n])) && t[0].length == d.length) {
                        e = !0;
                        break a;
                      }
                  d = CKEDITOR.htmlParser.fragment.fromHtml(d);
                  1 == d.children.length && (m = d.children[0]).type == CKEDITOR.NODE_ELEMENT && x(g, m, e, h);
                  e = !e.length;
                }
                e || c.push(a);
              }
            },
            null,
            !0,
          );
          c.length && (l = !0);
          var m;
          a = [];
          d = K[d || (this.editor ? this.editor.enterMode : CKEDITOR.ENTER_P)];
          for (var n; (e = c.pop()); ) e.type == CKEDITOR.NODE_ELEMENT ? z(e, d, a) : e.remove();
          for (; (m = a.pop()); )
            if (((e = m.el), e.parent))
              switch (((n = G[e.parent.name] || G.span), m.check)) {
                case 'it':
                  G.$removeEmpty[e.name] && !e.children.length ? z(e, d, a) : t(e) || z(e, d, a);
                  break;
                case 'el-up':
                  e.parent.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT || n[e.name] || z(e, d, a);
                  break;
                case 'parent-down':
                  e.parent.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT || n[e.name] || z(e.parent, d, a);
              }
          return l;
        },
        checkFeature: function (a) {
          if (this.disabled || !a) return !0;
          a.toFeature && (a = a.toFeature(this.editor));
          return !a.requiredContent || this.check(a.requiredContent);
        },
        disable: function () {
          this.disabled = !0;
        },
        disallow: function (b) {
          if (!l(this, b, !0)) return !1;
          'string' == typeof b && (b = e(b));
          a(this, b, null, this.disallowedContent, this._.disallowedRules);
          return !0;
        },
        addContentForms: function (a) {
          if (!this.disabled && a) {
            var b,
              e,
              d = [],
              g;
            for (b = 0; b < a.length && !g; ++b)
              (e = a[b]), ('string' == typeof e || e instanceof CKEDITOR.style) && this.check(e) && (g = e);
            if (g) {
              for (b = 0; b < a.length; ++b) d.push(C(a[b], g));
              this.addTransformations(d);
            }
          }
        },
        addElementCallback: function (a) {
          this.elementCallbacks || (this.elementCallbacks = []);
          this.elementCallbacks.push(a);
        },
        addFeature: function (a) {
          if (this.disabled || !a) return !0;
          a.toFeature && (a = a.toFeature(this.editor));
          this.allow(a.allowedContent, a.name);
          this.addTransformations(a.contentTransformations);
          this.addContentForms(a.contentForms);
          return a.requiredContent && (this.customConfig || this.disallowedContent.length) ? this.check(a.requiredContent) : !0;
        },
        addTransformations: function (a) {
          var b, e;
          if (!this.disabled && a) {
            var d = this._.transformations,
              g;
            for (g = 0; g < a.length; ++g) {
              b = a[g];
              var c = void 0,
                f = void 0,
                k = void 0,
                l = void 0,
                h = void 0,
                m = void 0;
              e = [];
              for (f = 0; f < b.length; ++f)
                (k = b[f]),
                  'string' == typeof k
                    ? ((k = k.split(/\s*:\s*/)), (l = k[0]), (h = null), (m = k[1]))
                    : ((l = k.check), (h = k.left), (m = k.right)),
                  c || ((c = k), (c = c.element ? c.element : l ? l.match(/^([a-z0-9]+)/i)[0] : c.left.getDefinition().element)),
                  h instanceof CKEDITOR.style && (h = F(h)),
                  e.push({ check: l == c ? null : l, left: h, right: 'string' == typeof m ? D(m) : m });
              b = c;
              d[b] || (d[b] = []);
              d[b].push(e);
            }
          }
        },
        check: function (a, b, g) {
          if (this.disabled) return !0;
          if (CKEDITOR.tools.isArray(a)) {
            for (var c = a.length; c--; ) if (this.check(a[c], b, g)) return !0;
            return !1;
          }
          var f, k;
          if ('string' == typeof a) {
            k = a + '\x3c' + (!1 === b ? '0' : '1') + (g ? '1' : '0') + '\x3e';
            if (k in this._.cachedChecks) return this._.cachedChecks[k];
            f = e(a).$1;
            var l = f.styles,
              c = f.classes;
            f.name = f.elements;
            f.classes = c = c ? c.split(/\s*,\s*/) : [];
            f.styles = d(l);
            f.attributes = d(f.attributes);
            f.children = [];
            c.length && (f.attributes['class'] = c.join(' '));
            l && (f.attributes.style = CKEDITOR.tools.writeCssText(f.styles));
          } else
            (f = a.getDefinition()),
              (l = f.styles),
              (c = f.attributes || {}),
              l && !CKEDITOR.tools.isEmpty(l) ? ((l = H(l)), (c.style = CKEDITOR.tools.writeCssText(l, !0))) : (l = {}),
              (f = { name: f.element, attributes: c, classes: c['class'] ? c['class'].split(/\s+/) : [], styles: l, children: [] });
          var l = CKEDITOR.tools.clone(f),
            h = [],
            m;
          if (!1 !== b && (m = this._.transformations[f.name])) {
            for (c = 0; c < m.length; ++c) y(this, f, m[c]);
            p(f);
          }
          x(this, l, h, { doFilter: !0, doTransform: !1 !== b, skipRequired: !g, skipFinalValidation: !g });
          0 < h.length
            ? (g = !1)
            : ((b = f.attributes['class']) && (f.attributes['class'] = f.attributes['class'].split(' ').sort().join(' ')),
              (g = CKEDITOR.tools.objectCompare(f.attributes, l.attributes, !0)),
              b && (f.attributes['class'] = b));
          'string' == typeof a && (this._.cachedChecks[k] = g);
          return g;
        },
        getAllowedEnterMode: (function () {
          var a = ['p', 'div', 'br'],
            b = { p: CKEDITOR.ENTER_P, div: CKEDITOR.ENTER_DIV, br: CKEDITOR.ENTER_BR };
          return function (e, d) {
            var g = a.slice(),
              c;
            if (this.check(K[e])) return e;
            for (d || (g = g.reverse()); (c = g.pop()); ) if (this.check(c)) return b[c];
            return CKEDITOR.ENTER_BR;
          };
        })(),
        clone: function () {
          var a = new CKEDITOR.filter(),
            b = CKEDITOR.tools.clone;
          a.allowedContent = b(this.allowedContent);
          a._.allowedRules = b(this._.allowedRules);
          a.disallowedContent = b(this.disallowedContent);
          a._.disallowedRules = b(this._.disallowedRules);
          a._.transformations = b(this._.transformations);
          a.disabled = this.disabled;
          a.editor = this.editor;
          return a;
        },
        destroy: function () {
          delete CKEDITOR.filter.instances[this.id];
          delete this._;
          delete this.allowedContent;
          delete this.disallowedContent;
        },
      };
      var S = { styles: 1, attributes: 1, classes: 1 },
        I = { styles: 'requiredStyles', attributes: 'requiredAttributes', classes: 'requiredClasses' },
        E = /^([a-z0-9\-*\s]+)((?:\s*\{[!\w\-,\s\*]+\}\s*|\s*\[[!\w\-,\s\*]+\]\s*|\s*\([!\w\-,\s\*]+\)\s*){0,3})(?:;\s*|$)/i,
        P = { styles: /{([^}]+)}/, attrs: /\[([^\]]+)\]/, classes: /\(([^\)]+)\)/ },
        M = /^cke:(object|embed|param)$/,
        O = /^(object|embed|param)$/,
        N;
      N = CKEDITOR.filter.transformationsTools = {
        sizeToStyle: function (a) {
          this.lengthToStyle(a, 'width');
          this.lengthToStyle(a, 'height');
        },
        sizeToAttribute: function (a) {
          this.lengthToAttribute(a, 'width');
          this.lengthToAttribute(a, 'height');
        },
        lengthToStyle: function (a, b, e) {
          e = e || b;
          if (!(e in a.styles)) {
            var d = a.attributes[b];
            d && (/^\d+$/.test(d) && (d += 'px'), (a.styles[e] = d));
          }
          delete a.attributes[b];
        },
        lengthToAttribute: function (a, b, e) {
          e = e || b;
          if (!(e in a.attributes)) {
            var d = a.styles[b],
              g = d && d.match(/^(\d+)(?:\.\d*)?px$/);
            g ? (a.attributes[e] = g[1]) : 'cke-test' == d && (a.attributes[e] = 'cke-test');
          }
          delete a.styles[b];
        },
        alignmentToStyle: function (a) {
          if (!('float' in a.styles)) {
            var b = a.attributes.align;
            if ('left' == b || 'right' == b) a.styles['float'] = b;
          }
          delete a.attributes.align;
        },
        alignmentToAttribute: function (a) {
          if (!('align' in a.attributes)) {
            var b = a.styles['float'];
            if ('left' == b || 'right' == b) a.attributes.align = b;
          }
          delete a.styles['float'];
        },
        splitBorderShorthand: function (a) {
          if (a.styles.border) {
            var b = CKEDITOR.tools.style.parse.border(a.styles.border);
            b.color && (a.styles['border-color'] = b.color);
            b.style && (a.styles['border-style'] = b.style);
            b.width && (a.styles['border-width'] = b.width);
            delete a.styles.border;
          }
        },
        listTypeToStyle: function (a) {
          if (a.attributes.type)
            switch (a.attributes.type) {
              case 'a':
                a.styles['list-style-type'] = 'lower-alpha';
                break;
              case 'A':
                a.styles['list-style-type'] = 'upper-alpha';
                break;
              case 'i':
                a.styles['list-style-type'] = 'lower-roman';
                break;
              case 'I':
                a.styles['list-style-type'] = 'upper-roman';
                break;
              case '1':
                a.styles['list-style-type'] = 'decimal';
                break;
              default:
                a.styles['list-style-type'] = a.attributes.type;
            }
        },
        splitMarginShorthand: function (a) {
          function b(d) {
            a.styles['margin-top'] = e[d[0]];
            a.styles['margin-right'] = e[d[1]];
            a.styles['margin-bottom'] = e[d[2]];
            a.styles['margin-left'] = e[d[3]];
          }
          if (a.styles.margin) {
            var e = a.styles.margin.match(/(auto|0|(?:\-?[\.\d]+(?:\w+|%)))/g) || ['0px'];
            switch (e.length) {
              case 1:
                b([0, 0, 0, 0]);
                break;
              case 2:
                b([0, 1, 0, 1]);
                break;
              case 3:
                b([0, 1, 2, 1]);
                break;
              case 4:
                b([0, 1, 2, 3]);
            }
            delete a.styles.margin;
          }
        },
        matchesStyle: v,
        transform: function (a, b) {
          if ('string' == typeof b) a.name = b;
          else {
            var e = b.getDefinition(),
              d = e.styles,
              g = e.attributes,
              c,
              f,
              k,
              l;
            a.name = e.element;
            for (c in g)
              if ('class' == c)
                for (e = a.classes.join('|'), k = g[c].split(/\s+/); (l = k.pop()); ) -1 == e.indexOf(l) && a.classes.push(l);
              else a.attributes[c] = g[c];
            for (f in d) a.styles[f] = d[f];
          }
        },
      };
    })();
    (function () {
      CKEDITOR.focusManager = function (a) {
        if (a.focusManager) return a.focusManager;
        this.hasFocus = !1;
        this.currentActive = null;
        this._ = { editor: a };
        return this;
      };
      CKEDITOR.focusManager._ = { blurDelay: 200 };
      CKEDITOR.focusManager.prototype = {
        focus: function (a) {
          this._.timer && clearTimeout(this._.timer);
          a && (this.currentActive = a);
          this.hasFocus ||
            this._.locked ||
            ((a = CKEDITOR.currentInstance) && a.focusManager.blur(1),
            (this.hasFocus = !0),
            (a = this._.editor.container) && a.addClass('cke_focus'),
            this._.editor.fire('focus'));
        },
        lock: function () {
          this._.locked = 1;
        },
        unlock: function () {
          delete this._.locked;
        },
        blur: function (a) {
          function h() {
            if (this.hasFocus) {
              this.hasFocus = !1;
              var a = this._.editor.container;
              a && a.removeClass('cke_focus');
              this._.editor.fire('blur');
            }
          }
          if (!this._.locked) {
            this._.timer && clearTimeout(this._.timer);
            var f = CKEDITOR.focusManager._.blurDelay;
            a || !f
              ? h.call(this)
              : (this._.timer = CKEDITOR.tools.setTimeout(
                  function () {
                    delete this._.timer;
                    h.call(this);
                  },
                  f,
                  this,
                ));
          }
        },
        add: function (a, h) {
          var f = a.getCustomData('focusmanager');
          if (!f || f != this) {
            f && f.remove(a);
            var f = 'focus',
              b = 'blur';
            h && (CKEDITOR.env.ie ? ((f = 'focusin'), (b = 'focusout')) : (CKEDITOR.event.useCapture = 1));
            var c = {
              blur: function () {
                a.equals(this.currentActive) && this.blur();
              },
              focus: function () {
                this.focus(a);
              },
            };
            a.on(f, c.focus, this);
            a.on(b, c.blur, this);
            h && (CKEDITOR.event.useCapture = 0);
            a.setCustomData('focusmanager', this);
            a.setCustomData('focusmanager_handlers', c);
          }
        },
        remove: function (a) {
          a.removeCustomData('focusmanager');
          var h = a.removeCustomData('focusmanager_handlers');
          a.removeListener('blur', h.blur);
          a.removeListener('focus', h.focus);
        },
      };
    })();
    CKEDITOR.keystrokeHandler = function (a) {
      if (a.keystrokeHandler) return a.keystrokeHandler;
      this.keystrokes = {};
      this.blockedKeystrokes = {};
      this._ = { editor: a };
      return this;
    };
    (function () {
      var a,
        h = function (b) {
          b = b.data;
          var c = b.getKeystroke(),
            f = this.keystrokes[c],
            k = this._.editor;
          a = !1 === k.fire('key', { keyCode: c, domEvent: b });
          a || (f && (a = !1 !== k.execCommand(f, { from: 'keystrokeHandler' })), a || (a = !!this.blockedKeystrokes[c]));
          a && b.preventDefault(!0);
          return !a;
        },
        f = function (b) {
          a && ((a = !1), b.data.preventDefault(!0));
        };
      CKEDITOR.keystrokeHandler.prototype = {
        attach: function (a) {
          a.on('keydown', h, this);
          if (CKEDITOR.env.gecko && CKEDITOR.env.mac) a.on('keypress', f, this);
        },
      };
    })();
    (function () {
      CKEDITOR.lang = {
        languages: {
          af: 1,
          ar: 1,
          az: 1,
          bg: 1,
          bn: 1,
          bs: 1,
          ca: 1,
          cs: 1,
          cy: 1,
          da: 1,
          de: 1,
          'de-ch': 1,
          el: 1,
          'en-au': 1,
          'en-ca': 1,
          'en-gb': 1,
          en: 1,
          eo: 1,
          es: 1,
          'es-mx': 1,
          et: 1,
          eu: 1,
          fa: 1,
          fi: 1,
          fo: 1,
          'fr-ca': 1,
          fr: 1,
          gl: 1,
          gu: 1,
          he: 1,
          hi: 1,
          hr: 1,
          hu: 1,
          id: 1,
          is: 1,
          it: 1,
          ja: 1,
          ka: 1,
          km: 1,
          ko: 1,
          ku: 1,
          lt: 1,
          lv: 1,
          mk: 1,
          mn: 1,
          ms: 1,
          nb: 1,
          nl: 1,
          no: 1,
          oc: 1,
          pl: 1,
          'pt-br': 1,
          pt: 1,
          ro: 1,
          ru: 1,
          si: 1,
          sk: 1,
          sl: 1,
          sq: 1,
          'sr-latn': 1,
          sr: 1,
          sv: 1,
          th: 1,
          tr: 1,
          tt: 1,
          ug: 1,
          uk: 1,
          vi: 1,
          'zh-cn': 1,
          zh: 1,
        },
        rtl: { ar: 1, fa: 1, he: 1, ku: 1, ug: 1 },
        load: function (a, h, f) {
          (a && CKEDITOR.lang.languages[a]) || (a = this.detect(h, a));
          var b = this;
          h = function () {
            b[a].dir = b.rtl[a] ? 'rtl' : 'ltr';
            f(a, b[a]);
          };
          this[a] ? h() : CKEDITOR.scriptLoader.load(CKEDITOR.getUrl('lang/' + a + '.js'), h, this);
        },
        detect: function (a, h) {
          var f = this.languages;
          h = h || navigator.userLanguage || navigator.language || a;
          var b = h.toLowerCase().match(/([a-z]+)(?:-([a-z]+))?/),
            c = b[1],
            b = b[2];
          f[c + '-' + b] ? (c = c + '-' + b) : f[c] || (c = null);
          CKEDITOR.lang.detect = c
            ? function () {
                return c;
              }
            : function (a) {
                return a;
              };
          return c || a;
        },
      };
    })();
    CKEDITOR.scriptLoader = (function () {
      var a = {},
        h = {};
      return {
        load: function (f, b, c, l) {
          var k = 'string' == typeof f;
          k && (f = [f]);
          c || (c = CKEDITOR);
          var m = f.length,
            g = m,
            d = [],
            e = [],
            n = function (a) {
              b && (k ? b.call(c, a) : b.call(c, d, e));
            };
          if (0 === g) n(!0);
          else {
            var r = function (a, b) {
                (b ? d : e).push(a);
                0 >= --g && (l && CKEDITOR.document.getDocumentElement().removeStyle('cursor'), n(b));
              },
              x = function (b, e) {
                a[b] = 1;
                var d = h[b];
                delete h[b];
                for (var g = 0; g < d.length; g++) d[g](b, e);
              },
              u = function (e) {
                if (a[e]) r(e, !0);
                else {
                  var d = h[e] || (h[e] = []);
                  d.push(r);
                  if (!(1 < d.length)) {
                    var g = new CKEDITOR.dom.element('script');
                    g.setAttributes({ type: 'text/javascript', src: e });
                    b &&
                      (CKEDITOR.env.ie && (8 >= CKEDITOR.env.version || CKEDITOR.env.ie9Compat)
                        ? (g.$.onreadystatechange = function () {
                            if ('loaded' == g.$.readyState || 'complete' == g.$.readyState) (g.$.onreadystatechange = null), x(e, !0);
                          })
                        : ((g.$.onload = function () {
                            setTimeout(function () {
                              g.$.onload = null;
                              g.$.onerror = null;
                              x(e, !0);
                            }, 0);
                          }),
                          (g.$.onerror = function () {
                            g.$.onload = null;
                            g.$.onerror = null;
                            x(e, !1);
                          })));
                    g.appendTo(CKEDITOR.document.getHead());
                  }
                }
              };
            l && CKEDITOR.document.getDocumentElement().setStyle('cursor', 'wait');
            for (var p = 0; p < m; p++) u(f[p]);
          }
        },
        queue: (function () {
          function a() {
            var c;
            (c = b[0]) && this.load(c.scriptUrl, c.callback, CKEDITOR, 0);
          }
          var b = [];
          return function (c, l) {
            var k = this;
            b.push({
              scriptUrl: c,
              callback: function () {
                l && l.apply(this, arguments);
                b.shift();
                a.call(k);
              },
            });
            1 == b.length && a.call(this);
          };
        })(),
      };
    })();
    CKEDITOR.resourceManager = function (a, h) {
      this.basePath = a;
      this.fileName = h;
      this.registered = {};
      this.loaded = {};
      this.externals = {};
      this._ = { waitingList: {} };
    };
    CKEDITOR.resourceManager.prototype = {
      add: function (a, h) {
        if (this.registered[a]) throw Error('[CKEDITOR.resourceManager.add] The resource name "' + a + '" is already registered.');
        var f = (this.registered[a] = h || {});
        f.name = a;
        f.path = this.getPath(a);
        CKEDITOR.fire(a + CKEDITOR.tools.capitalize(this.fileName) + 'Ready', f);
        return this.get(a);
      },
      get: function (a) {
        return this.registered[a] || null;
      },
      getPath: function (a) {
        var h = this.externals[a];
        return CKEDITOR.getUrl((h && h.dir) || this.basePath + a + '/');
      },
      getFilePath: function (a) {
        var h = this.externals[a];
        return CKEDITOR.getUrl(this.getPath(a) + (h ? h.file : this.fileName + '.js'));
      },
      addExternal: function (a, h, f) {
        f ||
          (h = h.replace(/[^\/]+$/, function (a) {
            f = a;
            return '';
          }));
        f = f || this.fileName + '.js';
        a = a.split(',');
        for (var b = 0; b < a.length; b++) this.externals[a[b]] = { dir: h, file: f };
      },
      load: function (a, h, f) {
        CKEDITOR.tools.isArray(a) || (a = a ? [a] : []);
        for (var b = this.loaded, c = this.registered, l = [], k = {}, m = {}, g = 0; g < a.length; g++) {
          var d = a[g];
          if (d)
            if (b[d] || c[d]) m[d] = this.get(d);
            else {
              var e = this.getFilePath(d);
              l.push(e);
              e in k || (k[e] = []);
              k[e].push(d);
            }
        }
        CKEDITOR.scriptLoader.load(
          l,
          function (a, e) {
            if (e.length)
              throw Error('[CKEDITOR.resourceManager.load] Resource name "' + k[e[0]].join(',') + '" was not found at "' + e[0] + '".');
            for (var d = 0; d < a.length; d++)
              for (var g = k[a[d]], c = 0; c < g.length; c++) {
                var l = g[c];
                m[l] = this.get(l);
                b[l] = 1;
              }
            h.call(f, m);
          },
          this,
        );
      },
    };
    CKEDITOR.plugins = new CKEDITOR.resourceManager('plugins/', 'plugin');
    CKEDITOR.plugins.load = CKEDITOR.tools.override(CKEDITOR.plugins.load, function (a) {
      var h = {};
      return function (f, b, c) {
        var l = {},
          k = function (f) {
            a.call(
              this,
              f,
              function (a) {
                CKEDITOR.tools.extend(l, a);
                var d = [],
                  e;
                for (e in a) {
                  var f = a[e],
                    m = f && f.requires;
                  if (!h[e]) {
                    if (f.icons)
                      for (var x = f.icons.split(','), u = x.length; u--; )
                        CKEDITOR.skin.addIcon(x[u], f.path + 'icons/' + (CKEDITOR.env.hidpi && f.hidpi ? 'hidpi/' : '') + x[u] + '.png');
                    f.isSupportedEnvironment =
                      f.isSupportedEnvironment ||
                      function () {
                        return !0;
                      };
                    h[e] = 1;
                  }
                  if (m) for (m.split && (m = m.split(',')), f = 0; f < m.length; f++) l[m[f]] || d.push(m[f]);
                }
                if (d.length) k.call(this, d);
                else {
                  for (e in l) (f = l[e]), f.onLoad && !f.onLoad._called && (!1 === f.onLoad() && delete l[e], (f.onLoad._called = 1));
                  b && b.call(c || window, l);
                }
              },
              this,
            );
          };
        k.call(this, f);
      };
    });
    CKEDITOR.plugins.setLang = function (a, h, f) {
      var b = this.get(a);
      a = b.langEntries || (b.langEntries = {});
      b = b.lang || (b.lang = []);
      b.split && (b = b.split(','));
      -1 == CKEDITOR.tools.indexOf(b, h) && b.push(h);
      a[h] = f;
    };
    CKEDITOR.ui = function (a) {
      if (a.ui) return a.ui;
      this.items = {};
      this.instances = {};
      this.editor = a;
      this._ = { handlers: {} };
      return this;
    };
    CKEDITOR.ui.prototype = {
      add: function (a, h, f) {
        f.name = a.toLowerCase();
        var b = (this.items[a] = { type: h, command: f.command || null, args: Array.prototype.slice.call(arguments, 2) });
        CKEDITOR.tools.extend(b, f);
      },
      get: function (a) {
        return this.instances[a];
      },
      create: function (a) {
        var h = this.items[a],
          f = h && this._.handlers[h.type],
          b = h && h.command && this.editor.getCommand(h.command),
          f = f && f.create.apply(this, h.args);
        this.instances[a] = f;
        b && b.uiItems.push(f);
        f && !f.type && (f.type = h.type);
        return f;
      },
      addHandler: function (a, h) {
        this._.handlers[a] = h;
      },
      space: function (a) {
        return CKEDITOR.document.getById(this.spaceId(a));
      },
      spaceId: function (a) {
        return this.editor.id + '_' + a;
      },
    };
    CKEDITOR.event.implementOn(CKEDITOR.ui);
    (function () {
      function a(a, e, d) {
        CKEDITOR.event.call(this);
        a = a && CKEDITOR.tools.clone(a);
        if (void 0 !== e) {
          if (!(e instanceof CKEDITOR.dom.element)) throw Error('Expect element of type CKEDITOR.dom.element.');
          if (!d) throw Error('One of the element modes must be specified.');
          if (CKEDITOR.env.ie && CKEDITOR.env.quirks && d == CKEDITOR.ELEMENT_MODE_INLINE)
            throw Error('Inline element mode is not supported on IE quirks.');
          if (!f(e, d)) throw Error('The specified element mode is not supported on element: "' + e.getName() + '".');
          this.element = e;
          this.elementMode = d;
          this.name = this.elementMode != CKEDITOR.ELEMENT_MODE_APPENDTO && (e.getId() || e.getNameAtt());
        } else this.elementMode = CKEDITOR.ELEMENT_MODE_NONE;
        this._ = {};
        this.commands = {};
        this.templates = {};
        this.name = this.name || h();
        this.id = CKEDITOR.tools.getNextId();
        this.status = 'unloaded';
        this.config = CKEDITOR.tools.prototypedCopy(CKEDITOR.config);
        this.ui = new CKEDITOR.ui(this);
        this.focusManager = new CKEDITOR.focusManager(this);
        this.keystrokeHandler = new CKEDITOR.keystrokeHandler(this);
        this.on('readOnly', b);
        this.on('selectionChange', function (a) {
          l(this, a.data.path);
        });
        this.on('activeFilterChange', function () {
          l(this, this.elementPath(), !0);
        });
        this.on('mode', b);
        CKEDITOR.dom.selection.setupEditorOptimization(this);
        this.on('instanceReady', function () {
          if (this.config.startupFocus) {
            if ('end' === this.config.startupFocus) {
              var a = this.createRange();
              a.selectNodeContents(this.editable());
              a.shrink(CKEDITOR.SHRINK_ELEMENT, !0);
              a.collapse();
              this.getSelection().selectRanges([a]);
            }
            this.focus();
          }
        });
        CKEDITOR.fire('instanceCreated', null, this);
        CKEDITOR.add(this);
        CKEDITOR.tools.setTimeout(
          function () {
            this.isDestroyed() || this.isDetached() || m(this, a);
          },
          0,
          this,
        );
      }
      function h() {
        do var a = 'editor' + ++u;
        while (CKEDITOR.instances[a]);
        return a;
      }
      function f(a, b) {
        return b == CKEDITOR.ELEMENT_MODE_INLINE
          ? a.is(CKEDITOR.dtd.$editable) || a.is('textarea')
          : b == CKEDITOR.ELEMENT_MODE_REPLACE
            ? !a.is(CKEDITOR.dtd.$nonBodyContent)
            : 1;
      }
      function b() {
        var a = this.commands,
          b;
        for (b in a) c(this, a[b]);
      }
      function c(a, b) {
        b[b.startDisabled ? 'disable' : a.readOnly && !b.readOnly ? 'disable' : b.modes[a.mode] ? 'enable' : 'disable']();
      }
      function l(a, b, e) {
        if (b) {
          var d,
            g,
            c = a.commands;
          for (g in c) (d = c[g]), (e || d.contextSensitive) && d.refresh(a, b);
        }
      }
      function k(a) {
        var b = a.config.customConfig;
        if (!b) return !1;
        var b = CKEDITOR.getUrl(b),
          e = p[b] || (p[b] = {});
        e.fn
          ? (e.fn.call(a, a.config), (CKEDITOR.getUrl(a.config.customConfig) != b && k(a)) || a.fireOnce('customConfigLoaded'))
          : CKEDITOR.scriptLoader.queue(b, function () {
              e.fn = e.fn || CKEDITOR.editorConfig || function () {};
              k(a);
            });
        return !0;
      }
      function m(a, b) {
        a.on('customConfigLoaded', function () {
          if (b) {
            if (b.on) for (var e in b.on) a.on(e, b.on[e]);
            CKEDITOR.tools.extend(a.config, b, !0);
            delete a.config.on;
          }
          e = a.config;
          a.readOnly = e.readOnly
            ? !0
            : a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE
              ? a.element.is('textarea')
                ? a.element.hasAttribute('disabled') || a.element.hasAttribute('readonly')
                : a.element.isReadOnly()
              : a.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE
                ? a.element.hasAttribute('disabled') || a.element.hasAttribute('readonly')
                : !1;
          a.blockless =
            a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? !(a.element.is('textarea') || CKEDITOR.dtd[a.element.getName()].p) : !1;
          a.tabIndex = e.tabIndex || (a.element && a.element.getAttribute('tabindex')) || 0;
          a.activeEnterMode = a.enterMode = a.blockless ? CKEDITOR.ENTER_BR : e.enterMode;
          a.activeShiftEnterMode = a.shiftEnterMode = a.blockless ? CKEDITOR.ENTER_BR : e.shiftEnterMode;
          e.skin && (CKEDITOR.skinName = e.skin);
          a.fireOnce('configLoaded');
          a.dataProcessor = new CKEDITOR.htmlDataProcessor(a);
          a.filter = a.activeFilter = new CKEDITOR.filter(a);
          g(a);
        });
        b && null != b.customConfig && (a.config.customConfig = b.customConfig);
        k(a) || a.fireOnce('customConfigLoaded');
      }
      function g(a) {
        CKEDITOR.skin.loadPart('editor', function () {
          d(a);
        });
      }
      function d(a) {
        CKEDITOR.lang.load(a.config.language, a.config.defaultLanguage, function (b, d) {
          var g = a.config.title,
            c = a.config.applicationTitle;
          a.langCode = b;
          a.lang = CKEDITOR.tools.prototypedCopy(d);
          a.title = 'string' == typeof g || !1 === g ? g : [a.lang.editor, a.name].join(', ');
          a.applicationTitle = 'string' == typeof c || !1 === c ? c : [a.lang.application, a.name].join(', ');
          a.config.contentsLangDirection ||
            (a.config.contentsLangDirection = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? a.element.getDirection(1) : a.lang.dir);
          a.fire('langLoaded');
          e(a);
        });
      }
      function e(a) {
        a.getStylesSet(function (b) {
          a.once(
            'loaded',
            function () {
              a.fire('stylesSet', { styles: b });
            },
            null,
            null,
            1,
          );
          n(a);
        });
      }
      function n(a) {
        function b(a) {
          if (!a) return '';
          CKEDITOR.tools.isArray(a) && (a = a.join(','));
          return a.replace(/\s/g, '');
        }
        var e = a.config,
          d = b(e.plugins),
          g = b(e.extraPlugins),
          c = b(e.removePlugins);
        if (g)
          var f = new RegExp('(?:^|,)(?:' + g.replace(/,/g, '|') + ')(?\x3d,|$)', 'g'),
            d = d.replace(f, ''),
            d = d + (',' + g);
        if (c)
          var k = new RegExp('(?:^|,)(?:' + c.replace(/,/g, '|') + ')(?\x3d,|$)', 'g'),
            d = d.replace(k, '');
        CKEDITOR.env.air && (d += ',adobeair');
        CKEDITOR.plugins.load(d.split(','), function (b) {
          var d = [],
            g = [],
            c = [];
          a.plugins = CKEDITOR.tools.extend({}, a.plugins, b);
          for (var f in b) {
            var l = b[f],
              h = l.lang,
              m = null,
              n = l.requires,
              r;
            CKEDITOR.tools.isArray(n) && (n = n.join(','));
            if (n && (r = n.match(k)))
              for (; (n = r.pop()); ) CKEDITOR.error('editor-plugin-required', { plugin: n.replace(',', ''), requiredBy: f });
            h &&
              !a.lang[f] &&
              (h.split && (h = h.split(',')),
              0 <= CKEDITOR.tools.indexOf(h, a.langCode)
                ? (m = a.langCode)
                : ((m = a.langCode.replace(/-.*/, '')),
                  (m = m != a.langCode && 0 <= CKEDITOR.tools.indexOf(h, m) ? m : 0 <= CKEDITOR.tools.indexOf(h, 'en') ? 'en' : h[0])),
              l.langEntries && l.langEntries[m]
                ? ((a.lang[f] = l.langEntries[m]), (m = null))
                : c.push(CKEDITOR.getUrl(l.path + 'lang/' + m + '.js')));
            g.push(m);
            d.push(l);
          }
          CKEDITOR.scriptLoader.load(c, function () {
            if (!a.isDestroyed() && !a.isDetached()) {
              for (var b = ['beforeInit', 'init', 'afterInit'], c = 0; c < b.length; c++)
                for (var f = 0; f < d.length; f++) {
                  var k = d[f];
                  0 === c && g[f] && k.lang && k.langEntries && (a.lang[k.name] = k.langEntries[g[f]]);
                  if (k[b[c]]) k[b[c]](a);
                }
              a.fireOnce('pluginsLoaded');
              e.keystrokes && a.setKeystroke(a.config.keystrokes);
              for (f = 0; f < a.config.blockedKeystrokes.length; f++)
                a.keystrokeHandler.blockedKeystrokes[a.config.blockedKeystrokes[f]] = 1;
              a.status = 'loaded';
              a.fireOnce('loaded');
              CKEDITOR.fire('instanceLoaded', null, a);
            }
          });
        });
      }
      function r() {
        var a = this.element;
        if (a && this.elementMode != CKEDITOR.ELEMENT_MODE_APPENDTO) {
          var b = this.getData();
          this.config.htmlEncodeOutput && (b = CKEDITOR.tools.htmlEncode(b));
          a.is('textarea') ? a.setValue(b) : a.setHtml(b);
          return !0;
        }
        return !1;
      }
      function x(a, b) {
        function e(a) {
          var b = a.startContainer,
            d = a.endContainer,
            g = b.is && b.is('tr'),
            c = b.is && b.is('td');
          a = c && b.equals(d) && a.endOffset === b.getChildCount();
          b = c && 1 === b.getChildCount() && 'img' === b.getChildren().getItem(0).getName();
          return g || (a && !b) ? !0 : !1;
        }
        function d(a) {
          var b = a.startContainer;
          return b.is('tr') ? a.cloneContents() : b.clone(!0);
        }
        for (var g = new CKEDITOR.dom.documentFragment(), c, f, k, l = 0; l < a.length; l++) {
          var h = a[l],
            m = h.startContainer.getAscendant('tr', !0);
          e(h)
            ? (c ||
                ((c = m.getAscendant('table').clone()),
                c.append(m.getAscendant({ thead: 1, tbody: 1, tfoot: 1 }).clone()),
                g.append(c),
                (c = c.findOne('thead, tbody, tfoot'))),
              (f && f.equals(m)) || ((f = m), (k = m.clone()), c.append(k)),
              k.append(d(h)))
            : g.append(h.cloneContents());
        }
        return c ? g : b.getHtmlFromRange(a[0]);
      }
      a.prototype = CKEDITOR.editor.prototype;
      CKEDITOR.editor = a;
      var u = 0,
        p = {};
      CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
        plugins: {
          detectConflict: function (a, b) {
            for (var e = 0; e < b.length; e++) {
              var d = b[e];
              if (this[d]) return CKEDITOR.warn('editor-plugin-conflict', { plugin: a, replacedWith: d }), !0;
            }
            return !1;
          },
        },
        addCommand: function (a, b) {
          b.name = a.toLowerCase();
          var e = b instanceof CKEDITOR.command ? b : new CKEDITOR.command(this, b);
          this.mode && c(this, e);
          return (this.commands[a] = e);
        },
        _attachToForm: function () {
          function a(b) {
            e.updateElement();
            e._.required && !d.getValue() && !1 === e.fire('required') && b.data.preventDefault();
          }
          function b(a) {
            return !!(a && a.call && a.apply);
          }
          var e = this,
            d = e.element,
            g = new CKEDITOR.dom.element(d.$.form);
          d.is('textarea') &&
            g &&
            (g.on('submit', a),
            b(g.$.submit) &&
              (g.$.submit = CKEDITOR.tools.override(g.$.submit, function (b) {
                return function () {
                  a();
                  b.apply ? b.apply(this) : b();
                };
              })),
            e.on('destroy', function () {
              g.removeListener('submit', a);
            }));
        },
        destroy: function (a) {
          var b = CKEDITOR.filter.instances,
            e = this;
          this.fire('beforeDestroy');
          !a && r.call(this);
          this.editable(null);
          this.filter && delete this.filter;
          CKEDITOR.tools.array.forEach(CKEDITOR.tools.object.keys(b), function (a) {
            a = b[a];
            e === a.editor && a.destroy();
          });
          delete this.activeFilter;
          this.status = 'destroyed';
          this.fire('destroy');
          this.removeAllListeners();
          CKEDITOR.remove(this);
          CKEDITOR.fire('instanceDestroyed', null, this);
        },
        elementPath: function (a) {
          if (!a) {
            a = this.getSelection();
            if (!a) return null;
            a = a.getStartElement();
          }
          return a ? new CKEDITOR.dom.elementPath(a, this.editable()) : null;
        },
        createRange: function () {
          var a = this.editable();
          return a ? new CKEDITOR.dom.range(a) : null;
        },
        execCommand: function (a, b) {
          var e = this.getCommand(a),
            d = { name: a, commandData: b || {}, command: e };
          return e &&
            e.state != CKEDITOR.TRISTATE_DISABLED &&
            !1 !== this.fire('beforeCommandExec', d) &&
            ((d.returnValue = e.exec(d.commandData)), !e.async && !1 !== this.fire('afterCommandExec', d))
            ? d.returnValue
            : !1;
        },
        getCommand: function (a) {
          return this.commands[a];
        },
        getData: function (a) {
          !a && this.fire('beforeGetData');
          var b = this._.data;
          'string' != typeof b &&
            (b =
              (b = this.element) && this.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE
                ? b.is('textarea')
                  ? b.getValue()
                  : b.getHtml()
                : '');
          b = { dataValue: b };
          !a && this.fire('getData', b);
          return b.dataValue;
        },
        getSnapshot: function () {
          var a = this.fire('getSnapshot');
          'string' != typeof a &&
            (a =
              (a = this.element) && this.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE
                ? a.is('textarea')
                  ? a.getValue()
                  : a.getHtml()
                : '');
          return a;
        },
        loadSnapshot: function (a) {
          this.fire('loadSnapshot', a);
        },
        setData: function (a, b, e) {
          var d = !0,
            g = b;
          b && 'object' == typeof b && ((e = b.internal), (g = b.callback), (d = !b.noSnapshot));
          !e && d && this.fire('saveSnapshot');
          if (g || !e)
            this.once('dataReady', function (a) {
              !e && d && this.fire('saveSnapshot');
              g && g.call(a.editor);
            });
          a = { dataValue: a };
          !e && this.fire('setData', a);
          this._.data = a.dataValue;
          !e && this.fire('afterSetData', a);
        },
        setReadOnly: function (a) {
          a = null == a || a;
          this.readOnly != a &&
            ((this.readOnly = a), (this.keystrokeHandler.blockedKeystrokes[8] = +a), this.editable().setReadOnly(a), this.fire('readOnly'));
        },
        insertHtml: function (a, b, e) {
          this.fire('insertHtml', { dataValue: a, mode: b, range: e });
        },
        insertText: function (a) {
          this.fire('insertText', a);
        },
        insertElement: function (a) {
          this.fire('insertElement', a);
        },
        getSelectedHtml: function (a) {
          var b = this.editable(),
            e = this.getSelection(),
            e = e && e.getRanges();
          if (!b || !e || 0 === e.length) return null;
          b = x(e, b);
          return a ? b.getHtml() : b;
        },
        extractSelectedHtml: function (a, b) {
          var e = this.editable(),
            d = this.getSelection().getRanges(),
            g = new CKEDITOR.dom.documentFragment(),
            c;
          if (!e || 0 === d.length) return null;
          for (c = 0; c < d.length; c++) g.append(e.extractHtmlFromRange(d[c], b));
          b || this.getSelection().selectRanges([d[0]]);
          return a ? g.getHtml() : g;
        },
        focus: function () {
          this.fire('beforeFocus');
        },
        checkDirty: function () {
          return 'ready' == this.status && this._.previousValue !== this.getSnapshot();
        },
        resetDirty: function () {
          this._.previousValue = this.getSnapshot();
        },
        updateElement: function () {
          return r.call(this);
        },
        setKeystroke: function () {
          for (
            var a = this.keystrokeHandler.keystrokes,
              b = CKEDITOR.tools.isArray(arguments[0]) ? arguments[0] : [[].slice.call(arguments, 0)],
              e,
              d,
              g = b.length;
            g--;

          )
            (e = b[g]), (d = 0), CKEDITOR.tools.isArray(e) && ((d = e[1]), (e = e[0])), d ? (a[e] = d) : delete a[e];
        },
        getCommandKeystroke: function (a, b) {
          var e = 'string' === typeof a ? this.getCommand(a) : a,
            d = [];
          if (e) {
            var g = CKEDITOR.tools.object.findKey(this.commands, e),
              c = this.keystrokeHandler.keystrokes;
            if (e.fakeKeystroke) d.push(e.fakeKeystroke);
            else for (var f in c) c[f] === g && d.push(f);
          }
          return b ? d : d[0] || null;
        },
        addFeature: function (a) {
          return this.filter.addFeature(a);
        },
        setActiveFilter: function (a) {
          a || (a = this.filter);
          this.activeFilter !== a &&
            ((this.activeFilter = a),
            this.fire('activeFilterChange'),
            a === this.filter
              ? this.setActiveEnterMode(null, null)
              : this.setActiveEnterMode(a.getAllowedEnterMode(this.enterMode), a.getAllowedEnterMode(this.shiftEnterMode, !0)));
        },
        setActiveEnterMode: function (a, b) {
          a = a ? (this.blockless ? CKEDITOR.ENTER_BR : a) : this.enterMode;
          b = b ? (this.blockless ? CKEDITOR.ENTER_BR : b) : this.shiftEnterMode;
          if (this.activeEnterMode != a || this.activeShiftEnterMode != b)
            (this.activeEnterMode = a), (this.activeShiftEnterMode = b), this.fire('activeEnterModeChange');
        },
        showNotification: function (a) {
          alert(a);
        },
        isDetached: function () {
          return !!this.container && this.container.isDetached();
        },
        isDestroyed: function () {
          return 'destroyed' === this.status;
        },
      });
      CKEDITOR.editor._getEditorElement = function (a) {
        if (!CKEDITOR.env.isCompatible) return null;
        var b = CKEDITOR.dom.element.get(a);
        return b
          ? b.getEditor()
            ? (CKEDITOR.error('editor-element-conflict', { editorName: b.getEditor().name }), null)
            : b
          : (CKEDITOR.error('editor-incorrect-element', { element: a }), null);
      };
      CKEDITOR.editor.initializeDelayedEditorCreation = function (a, b, e) {
        if (b.delayIfDetached_callback)
          return (
            CKEDITOR.warn('editor-delayed-creation', { method: 'callback' }),
            b.delayIfDetached_callback(function () {
              CKEDITOR[e](a, b);
              CKEDITOR.warn('editor-delayed-creation-success', { method: 'callback' });
            }),
            null
          );
        var d = void 0 === b.delayIfDetached_interval ? CKEDITOR.config.delayIfDetached_interval : b.delayIfDetached_interval;
        CKEDITOR.warn('editor-delayed-creation', { method: 'interval - ' + d + ' ms' });
        var g = setInterval(function () {
          a.isDetached() ||
            (clearInterval(g), CKEDITOR[e](a, b), CKEDITOR.warn('editor-delayed-creation-success', { method: 'interval - ' + d + ' ms' }));
        }, d);
        return function () {
          clearInterval(g);
        };
      };
      CKEDITOR.editor.shouldDelayEditorCreation = function (a, b) {
        CKEDITOR.editor.mergeDelayedCreationConfigs(b);
        return b && b.delayIfDetached && a.isDetached();
      };
      CKEDITOR.editor.mergeDelayedCreationConfigs = function (a) {
        a &&
          ((a.delayIfDetached = 'boolean' === typeof a.delayIfDetached ? a.delayIfDetached : CKEDITOR.config.delayIfDetached),
          (a.delayIfDetached_interval = isNaN(a.delayIfDetached_interval)
            ? CKEDITOR.config.delayIfDetached_interval
            : a.delayIfDetached_interval),
          (a.delayIfDetached_callback = a.delayIfDetached_callback || CKEDITOR.config.delayIfDetached_callback));
      };
    })();
    CKEDITOR.ELEMENT_MODE_NONE = 0;
    CKEDITOR.ELEMENT_MODE_REPLACE = 1;
    CKEDITOR.ELEMENT_MODE_APPENDTO = 2;
    CKEDITOR.ELEMENT_MODE_INLINE = 3;
    CKEDITOR.config.delayIfDetached = !1;
    CKEDITOR.config.delayIfDetached_callback = void 0;
    CKEDITOR.config.delayIfDetached_interval = 50;
    CKEDITOR.htmlParser = function () {
      this._ = {
        htmlPartsRegex:
          /<(?:(?:\/([^>]+)>)|(?:!--([\S|\s]*?)--!?>)|(?:([^\/\s>]+)((?:\s+[\w\-:.]+(?:\s*=\s*?(?:(?:"[^"]*")|(?:'[^']*')|[^\s"'\/>]+))?)*)[\S\s]*?(\/?)>))/g,
      };
    };
    (function () {
      var a = /([\w\-:.]+)(?:(?:\s*=\s*(?:(?:"([^"]*)")|(?:'([^']*)')|([^\s>]+)))|(?=\s|$))/g,
        h = {
          checked: 1,
          compact: 1,
          declare: 1,
          defer: 1,
          disabled: 1,
          ismap: 1,
          multiple: 1,
          nohref: 1,
          noresize: 1,
          noshade: 1,
          nowrap: 1,
          readonly: 1,
          selected: 1,
        };
      CKEDITOR.htmlParser.prototype = {
        onTagOpen: function () {},
        onTagClose: function () {},
        onText: function () {},
        onCDATA: function () {},
        onComment: function () {},
        parse: function (f) {
          for (var b, c, l = 0, k; (b = this._.htmlPartsRegex.exec(f)); ) {
            c = b.index;
            if (c > l)
              if (((l = f.substring(l, c)), k)) k.push(l);
              else this.onText(l);
            l = this._.htmlPartsRegex.lastIndex;
            if ((c = b[1]))
              if (((c = c.toLowerCase()), k && CKEDITOR.dtd.$cdata[c] && (this.onCDATA(k.join('')), (k = null)), !k)) {
                this.onTagClose(c);
                continue;
              }
            if (k) k.push(b[0]);
            else if ((c = b[3])) {
              if (((c = c.toLowerCase()), !/="/.test(c))) {
                var m = {},
                  g,
                  d = b[4];
                b = !!b[5];
                if (d)
                  for (; (g = a.exec(d)); ) {
                    var e = g[1].toLowerCase();
                    g = g[2] || g[3] || g[4] || '';
                    m[e] = !g && h[e] ? e : CKEDITOR.tools.htmlDecodeAttr(g);
                  }
                this.onTagOpen(c, m, b);
                !k && CKEDITOR.dtd.$cdata[c] && (k = []);
              }
            } else if ((c = b[2])) this.onComment(c);
          }
          if (f.length > l) this.onText(f.substring(l, f.length));
        },
      };
    })();
    CKEDITOR.htmlParser.basicWriter = CKEDITOR.tools.createClass({
      $: function () {
        this._ = { output: [] };
      },
      proto: {
        openTag: function (a) {
          this._.output.push('\x3c', a);
        },
        openTagClose: function (a, h) {
          h ? this._.output.push(' /\x3e') : this._.output.push('\x3e');
        },
        attribute: function (a, h) {
          'string' == typeof h && (h = CKEDITOR.tools.htmlEncodeAttr(h));
          this._.output.push(' ', a, '\x3d"', h, '"');
        },
        closeTag: function (a) {
          this._.output.push('\x3c/', a, '\x3e');
        },
        text: function (a) {
          this._.output.push(a);
        },
        comment: function (a) {
          this._.output.push('\x3c!--', a, '--\x3e');
        },
        write: function (a) {
          this._.output.push(a);
        },
        reset: function () {
          this._.output = [];
          this._.indent = !1;
        },
        getHtml: function (a) {
          var h = this._.output.join('');
          a && this.reset();
          return h;
        },
      },
    });
    ('use strict');
    (function () {
      CKEDITOR.htmlParser.node = function () {};
      CKEDITOR.htmlParser.node.prototype = {
        remove: function () {
          var a = this.parent.children,
            h = CKEDITOR.tools.indexOf(a, this),
            f = this.previous,
            b = this.next;
          f && (f.next = b);
          b && (b.previous = f);
          a.splice(h, 1);
          this.parent = null;
        },
        replaceWith: function (a) {
          var h = this.parent.children,
            f = CKEDITOR.tools.indexOf(h, this),
            b = (a.previous = this.previous),
            c = (a.next = this.next);
          b && (b.next = a);
          c && (c.previous = a);
          h[f] = a;
          a.parent = this.parent;
          this.parent = null;
        },
        insertAfter: function (a) {
          var h = a.parent.children,
            f = CKEDITOR.tools.indexOf(h, a),
            b = a.next;
          h.splice(f + 1, 0, this);
          this.next = a.next;
          this.previous = a;
          a.next = this;
          b && (b.previous = this);
          this.parent = a.parent;
        },
        insertBefore: function (a) {
          var h = a.parent.children,
            f = CKEDITOR.tools.indexOf(h, a);
          h.splice(f, 0, this);
          this.next = a;
          (this.previous = a.previous) && (a.previous.next = this);
          a.previous = this;
          this.parent = a.parent;
        },
        getAscendant: function (a) {
          var h =
              'function' == typeof a
                ? a
                : 'string' == typeof a
                  ? function (b) {
                      return b.name == a;
                    }
                  : function (b) {
                      return b.name in a;
                    },
            f = this.parent;
          for (; f && f.type == CKEDITOR.NODE_ELEMENT; ) {
            if (h(f)) return f;
            f = f.parent;
          }
          return null;
        },
        wrapWith: function (a) {
          this.replaceWith(a);
          a.add(this);
          return a;
        },
        getIndex: function () {
          return CKEDITOR.tools.indexOf(this.parent.children, this);
        },
        getFilterContext: function (a) {
          return a || {};
        },
      };
    })();
    ('use strict');
    CKEDITOR.htmlParser.comment = function (a) {
      this.value = a;
      this._ = { isBlockLike: !1 };
    };
    CKEDITOR.htmlParser.comment.prototype = CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node(), {
      type: CKEDITOR.NODE_COMMENT,
      filter: function (a, h) {
        var f = this.value;
        if (!(f = a.onComment(h, f, this))) return this.remove(), !1;
        if ('string' != typeof f) return this.replaceWith(f), !1;
        this.value = f;
        return !0;
      },
      writeHtml: function (a, h) {
        h && this.filter(h);
        a.comment(this.value);
      },
    });
    ('use strict');
    (function () {
      CKEDITOR.htmlParser.text = function (a) {
        this.value = a;
        this._ = { isBlockLike: !1 };
      };
      CKEDITOR.htmlParser.text.prototype = CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node(), {
        type: CKEDITOR.NODE_TEXT,
        filter: function (a, h) {
          if (!(this.value = a.onText(h, this.value, this))) return this.remove(), !1;
        },
        writeHtml: function (a, h) {
          h && this.filter(h);
          a.text(this.value);
        },
      });
    })();
    ('use strict');
    (function () {
      CKEDITOR.htmlParser.cdata = function (a) {
        this.value = a;
      };
      CKEDITOR.htmlParser.cdata.prototype = CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node(), {
        type: CKEDITOR.NODE_TEXT,
        filter: function (a) {
          var h = this.getAscendant('style');
          if (h && h.getAscendant({ math: 1, svg: 1 })) {
            var h = CKEDITOR.htmlParser.fragment.fromHtml(this.value),
              f = new CKEDITOR.htmlParser.basicWriter();
            a.applyTo(h);
            h.writeHtml(f);
            this.value = f.getHtml();
          }
        },
        writeHtml: function (a) {
          a.write(this.value);
        },
      });
    })();
    ('use strict');
    CKEDITOR.htmlParser.fragment = function () {
      this.children = [];
      this.parent = null;
      this._ = { isBlockLike: !0, hasInlineStarted: !1 };
    };
    (function () {
      function a(a) {
        return a.attributes['data-cke-survive'] ? !1 : ('a' == a.name && a.attributes.href) || CKEDITOR.dtd.$removeEmpty[a.name];
      }
      var h = CKEDITOR.tools.extend(
          { table: 1, ul: 1, ol: 1, dl: 1 },
          CKEDITOR.dtd.table,
          CKEDITOR.dtd.ul,
          CKEDITOR.dtd.ol,
          CKEDITOR.dtd.dl,
        ),
        f = { ol: 1, ul: 1 },
        b = CKEDITOR.tools.extend({}, { html: 1 }, CKEDITOR.dtd.html, CKEDITOR.dtd.body, CKEDITOR.dtd.head, { style: 1, script: 1 }),
        c = { ul: 'li', ol: 'li', dl: 'dd', table: 'tbody', tbody: 'tr', thead: 'tr', tfoot: 'tr', tr: 'td' };
      CKEDITOR.htmlParser.fragment.fromHtml = function (l, k, m) {
        function g(a) {
          var b;
          if (0 < t.length)
            for (var e = 0; e < t.length; e++) {
              var g = t[e],
                c = g.name,
                f = CKEDITOR.dtd[c],
                k = q.name && CKEDITOR.dtd[q.name];
              (k && !k[c]) || (a && f && !f[a] && CKEDITOR.dtd[a])
                ? c == q.name && (n(q, q.parent, 1), e--)
                : (b || (d(), (b = 1)), (g = g.clone()), (g.parent = q), (q = g), t.splice(e, 1), e--);
            }
        }
        function d() {
          for (; A.length; ) n(A.shift(), q);
        }
        function e(a) {
          if (a._.isBlockLike && 'pre' != a.name && 'textarea' != a.name) {
            var b = a.children.length,
              e = a.children[b - 1],
              d;
            e && e.type == CKEDITOR.NODE_TEXT && ((d = CKEDITOR.tools.rtrim(e.value)) ? (e.value = d) : (a.children.length = b - 1));
          }
        }
        function n(b, d, g) {
          d = d || q || p;
          var c = q;
          void 0 === b.previous &&
            (r(d, b) && ((q = d), u.onTagOpen(m, {}), (b.returnPoint = d = q)),
            e(b),
            (a(b) && !b.children.length) || d.add(b),
            'pre' == b.name && (z = !1),
            'textarea' == b.name && (B = !1));
          b.returnPoint ? ((q = b.returnPoint), delete b.returnPoint) : (q = g ? d : c);
        }
        function r(a, b) {
          if ((a == p || 'body' == a.name) && m && (!a.name || CKEDITOR.dtd[a.name][m])) {
            var e, d;
            return (
              ((e = b.attributes && (d = b.attributes['data-cke-real-element-type']) ? d : b.name) &&
                e in CKEDITOR.dtd.$inline &&
                !(e in CKEDITOR.dtd.head) &&
                !b.isOrphan) ||
              b.type == CKEDITOR.NODE_TEXT
            );
          }
        }
        function x(a, b) {
          return a in CKEDITOR.dtd.$listItem || a in CKEDITOR.dtd.$tableContent
            ? a == b || ('dt' == a && 'dd' == b) || ('dd' == a && 'dt' == b)
            : !1;
        }
        var u = new CKEDITOR.htmlParser(),
          p =
            k instanceof CKEDITOR.htmlParser.element
              ? k
              : 'string' == typeof k
                ? new CKEDITOR.htmlParser.element(k)
                : new CKEDITOR.htmlParser.fragment(),
          t = [],
          A = [],
          q = p,
          B = 'textarea' == p.name,
          z = 'pre' == p.name;
        u.onTagOpen = function (e, c, k, l) {
          c = new CKEDITOR.htmlParser.element(e, c);
          c.isUnknown && k && (c.isEmpty = !0);
          c.isOptionalClose = l;
          if (a(c)) t.push(c);
          else {
            if ('pre' == e) z = !0;
            else {
              if ('br' == e && z) {
                q.add(new CKEDITOR.htmlParser.text('\n'));
                return;
              }
              'textarea' == e && (B = !0);
            }
            if ('br' == e) A.push(c);
            else {
              for (
                ;
                !((l = (k = q.name) ? CKEDITOR.dtd[k] || (q._.isBlockLike ? CKEDITOR.dtd.div : CKEDITOR.dtd.span) : b),
                c.isUnknown || q.isUnknown || l[e]);

              )
                if (q.isOptionalClose) u.onTagClose(k);
                else if (e in f && k in f)
                  (k = q.children),
                    ((k = k[k.length - 1]) && 'li' == k.name) || n((k = new CKEDITOR.htmlParser.element('li')), q),
                    !c.returnPoint && (c.returnPoint = q),
                    (q = k);
                else if (e in CKEDITOR.dtd.$listItem && !x(e, k)) u.onTagOpen('li' == e ? 'ul' : 'dl', {}, 0, 1);
                else if (k in h && !x(e, k)) !c.returnPoint && (c.returnPoint = q), (q = q.parent);
                else if ((k in CKEDITOR.dtd.$inline && t.unshift(q), q.parent)) n(q, q.parent, 1);
                else {
                  c.isOrphan = 1;
                  break;
                }
              g(e);
              d();
              c.parent = q;
              c.isEmpty ? n(c) : (q = c);
            }
          }
        };
        u.onTagClose = function (a) {
          for (var b = t.length - 1; 0 <= b; b--)
            if (a == t[b].name) {
              t.splice(b, 1);
              return;
            }
          for (var e = [], g = [], c = q; c != p && c.name != a; )
            c._.isBlockLike || g.unshift(c), e.push(c), (c = c.returnPoint || c.parent);
          if (c != p) {
            for (b = 0; b < e.length; b++) {
              var f = e[b];
              n(f, f.parent);
            }
            q = c;
            c._.isBlockLike
              ? d()
              : ((b = CKEDITOR.config.shiftLineBreaks),
                !0 !== b &&
                  A.length &&
                  ('function' !== typeof b
                    ? d()
                    : ((b = b(A[A.length - 1])),
                      !0 !== b &&
                        (d(), b instanceof CKEDITOR.htmlParser.text && q.add(b), b instanceof CKEDITOR.htmlParser.element && n(b, q)))));
            n(c, c.parent);
            c == q && (q = q.parent);
            t = t.concat(g);
          }
          'body' == a && (m = !1);
        };
        u.onText = function (a) {
          if (!((q._.hasInlineStarted && !A.length) || z || B) && ((a = CKEDITOR.tools.ltrim(a)), 0 === a.length)) return;
          var e = q.name,
            f = e ? CKEDITOR.dtd[e] || (q._.isBlockLike ? CKEDITOR.dtd.div : CKEDITOR.dtd.span) : b;
          if (!B && !f['#'] && e in h) u.onTagOpen(c[e] || ''), u.onText(a);
          else {
            d();
            g();
            z || B || (a = a.replace(/[\t\r\n ]{2,}|[\t\r\n]/g, ' '));
            a = new CKEDITOR.htmlParser.text(a);
            if (r(q, a)) this.onTagOpen(m, {}, 0, 1);
            q.add(a);
          }
        };
        u.onCDATA = function (a) {
          q.add(new CKEDITOR.htmlParser.cdata(a));
        };
        u.onComment = function (a) {
          d();
          g();
          q.add(new CKEDITOR.htmlParser.comment(a));
        };
        u.parse(l);
        for (d(); q != p; ) n(q, q.parent, 1);
        e(p);
        return p;
      };
      CKEDITOR.htmlParser.fragment.prototype = {
        type: CKEDITOR.NODE_DOCUMENT_FRAGMENT,
        add: function (a, b) {
          isNaN(b) && (b = this.children.length);
          var c = 0 < b ? this.children[b - 1] : null;
          if (c) {
            if (a._.isBlockLike && c.type == CKEDITOR.NODE_TEXT && ((c.value = CKEDITOR.tools.rtrim(c.value)), 0 === c.value.length)) {
              this.children.pop();
              this.add(a);
              return;
            }
            c.next = a;
          }
          a.previous = c;
          a.parent = this;
          this.children.splice(b, 0, a);
          this._.hasInlineStarted ||
            (this._.hasInlineStarted = a.type == CKEDITOR.NODE_TEXT || (a.type == CKEDITOR.NODE_ELEMENT && !a._.isBlockLike));
        },
        filter: function (a, b) {
          b = this.getFilterContext(b);
          a.onRoot(b, this);
          this.filterChildren(a, !1, b);
        },
        filterChildren: function (a, b, c) {
          if (this.childrenFilteredBy != a.id) {
            c = this.getFilterContext(c);
            if (b && !this.parent) a.onRoot(c, this);
            this.childrenFilteredBy = a.id;
            for (b = 0; b < this.children.length; b++) !1 === this.children[b].filter(a, c) && b--;
          }
        },
        writeHtml: function (a, b) {
          b && this.filter(b);
          this.writeChildrenHtml(a);
        },
        writeChildrenHtml: function (a, b, c) {
          var g = this.getFilterContext();
          if (c && !this.parent && b) b.onRoot(g, this);
          b && this.filterChildren(b, !1, g);
          b = 0;
          c = this.children;
          for (g = c.length; b < g; b++) c[b].writeHtml(a);
        },
        forEach: function (a, b, c) {
          if (!(c || (b && this.type != b))) var g = a(this);
          if (!1 !== g) {
            c = this.children;
            for (var d = 0; d < c.length; d++) (g = c[d]), g.type == CKEDITOR.NODE_ELEMENT ? g.forEach(a, b) : (b && g.type != b) || a(g);
          }
        },
        getFilterContext: function (a) {
          return a || {};
        },
      };
      CKEDITOR.config.shiftLineBreaks = !0;
    })();
    ('use strict');
    (function () {
      function a() {
        this.rules = [];
      }
      function h(f, b, c, l) {
        var k, h;
        for (k in b) (h = f[k]) || (h = f[k] = new a()), h.add(b[k], c, l);
      }
      CKEDITOR.htmlParser.filter = CKEDITOR.tools.createClass({
        $: function (f) {
          this.id = CKEDITOR.tools.getNextNumber();
          this.elementNameRules = new a();
          this.attributeNameRules = new a();
          this.elementsRules = {};
          this.attributesRules = {};
          this.textRules = new a();
          this.commentRules = new a();
          this.rootRules = new a();
          f && this.addRules(f, 10);
        },
        proto: {
          addRules: function (a, b) {
            var c;
            'number' == typeof b ? (c = b) : b && 'priority' in b && (c = b.priority);
            'number' != typeof c && (c = 10);
            'object' != typeof b && (b = {});
            a.elementNames && this.elementNameRules.addMany(a.elementNames, c, b);
            a.attributeNames && this.attributeNameRules.addMany(a.attributeNames, c, b);
            a.elements && h(this.elementsRules, a.elements, c, b);
            a.attributes && h(this.attributesRules, a.attributes, c, b);
            a.text && this.textRules.add(a.text, c, b);
            a.comment && this.commentRules.add(a.comment, c, b);
            a.root && this.rootRules.add(a.root, c, b);
          },
          applyTo: function (a) {
            a.filter(this);
          },
          onElementName: function (a, b) {
            return this.elementNameRules.execOnName(a, b);
          },
          onAttributeName: function (a, b) {
            return this.attributeNameRules.execOnName(a, b);
          },
          onText: function (a, b, c) {
            return this.textRules.exec(a, b, c);
          },
          onComment: function (a, b, c) {
            return this.commentRules.exec(a, b, c);
          },
          onRoot: function (a, b) {
            return this.rootRules.exec(a, b);
          },
          onElement: function (a, b) {
            for (var c = [this.elementsRules['^'], this.elementsRules[b.name], this.elementsRules.$], l, k = 0; 3 > k; k++)
              if ((l = c[k])) {
                l = l.exec(a, b, this);
                if (!1 === l) return null;
                if (l && l != b) return this.onNode(a, l);
                if (b.parent && !b.name) break;
              }
            return b;
          },
          onNode: function (a, b) {
            var c = b.type;
            return c == CKEDITOR.NODE_ELEMENT
              ? this.onElement(a, b)
              : c == CKEDITOR.NODE_TEXT
                ? new CKEDITOR.htmlParser.text(this.onText(a, b.value, b))
                : c == CKEDITOR.NODE_COMMENT
                  ? new CKEDITOR.htmlParser.comment(this.onComment(a, b.value, b))
                  : null;
          },
          onAttribute: function (a, b, c, l) {
            return (c = this.attributesRules[c]) ? c.exec(a, l, b, this) : l;
          },
        },
      });
      CKEDITOR.htmlParser.filterRulesGroup = a;
      a.prototype = {
        add: function (a, b, c) {
          this.rules.splice(this.findIndex(b), 0, { value: a, priority: b, options: c });
        },
        addMany: function (a, b, c) {
          for (var l = [this.findIndex(b), 0], k = 0, h = a.length; k < h; k++) l.push({ value: a[k], priority: b, options: c });
          this.rules.splice.apply(this.rules, l);
        },
        findIndex: function (a) {
          for (var b = this.rules, c = b.length - 1; 0 <= c && a < b[c].priority; ) c--;
          return c + 1;
        },
        exec: function (a, b) {
          var c = b instanceof CKEDITOR.htmlParser.node || b instanceof CKEDITOR.htmlParser.fragment,
            l = Array.prototype.slice.call(arguments, 1),
            k = this.rules,
            h = k.length,
            g,
            d,
            e,
            n;
          for (n = 0; n < h; n++)
            if (
              (c && ((g = b.type), (d = b.name)),
              (e = k[n]),
              !((a.nonEditable && !e.options.applyToAll) || (a.nestedEditable && e.options.excludeNestedEditable)))
            ) {
              e = e.value.apply(null, l);
              if (!1 === e || (c && e && (e.name != d || e.type != g))) return e;
              null != e && (l[0] = b = e);
            }
          return b;
        },
        execOnName: function (a, b) {
          for (var c = 0, l = this.rules, k = l.length, h; b && c < k; c++)
            (h = l[c]),
              (a.nonEditable && !h.options.applyToAll) ||
                (a.nestedEditable && h.options.excludeNestedEditable) ||
                (b = b.replace(h.value[0], h.value[1]));
          return b;
        },
      };
    })();
    (function () {
      function a(a, e) {
        function d(a) {
          return a || CKEDITOR.env.needsNbspFiller
            ? new CKEDITOR.htmlParser.text(' ')
            : new CKEDITOR.htmlParser.element('br', { 'data-cke-bogus': 1 });
        }
        function g(a, e) {
          return function (g) {
            if (g.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT) {
              var c = [],
                k = f(g),
                m,
                r;
              if (k)
                for (h(k, 1) && c.push(k); k; )
                  l(k) && (m = b(k)) && h(m) && ((r = b(m)) && !l(r) ? c.push(m) : (d(n).insertAfter(m), m.remove())), (k = k.previous);
              for (k = 0; k < c.length; k++) c[k].remove();
              if ((c = !a || !1 !== ('function' == typeof e ? e(g) : e)))
                n || CKEDITOR.env.needsBrFiller || g.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT
                  ? n ||
                    CKEDITOR.env.needsBrFiller ||
                    !(7 < document.documentMode || g.name in CKEDITOR.dtd.tr || g.name in CKEDITOR.dtd.$listItem)
                    ? ((c = f(g)), (c = !c || ('form' == g.name && 'input' == c.name)))
                    : (c = !1)
                  : (c = !1);
              c && g.add(d(a));
            }
          };
        }
        function h(a, b) {
          if ((!n || CKEDITOR.env.needsBrFiller) && a.type == CKEDITOR.NODE_ELEMENT && 'br' == a.name && !a.attributes['data-cke-eol'])
            return !0;
          var e;
          return a.type == CKEDITOR.NODE_TEXT &&
            (e = a.value.match(A)) &&
            (e.index && (new CKEDITOR.htmlParser.text(a.value.substring(0, e.index)).insertBefore(a), (a.value = e[0])),
            (!CKEDITOR.env.needsBrFiller && n && (!b || a.parent.name in r)) ||
              (!n && (((e = a.previous) && 'br' == e.name) || !e || l(e))))
            ? !0
            : !1;
        }
        var m = { elements: {} },
          n = 'html' == e,
          r = CKEDITOR.tools.extend({}, y),
          M;
        for (M in r) '#' in B[M] || delete r[M];
        for (M in r) m.elements[M] = g(n, a.config.fillEmptyBlocks);
        m.root = g(n, !1);
        m.elements.br = (function (a) {
          return function (e) {
            if (e.parent.type != CKEDITOR.NODE_DOCUMENT_FRAGMENT) {
              var g = e.attributes;
              if ('data-cke-bogus' in g || 'data-cke-eol' in g) delete g['data-cke-bogus'];
              else {
                for (g = e.next; g && c(g); ) g = g.next;
                var f = b(e);
                !g && l(e.parent) ? k(e.parent, d(a)) : l(g) && f && !l(f) && d(a).insertBefore(g);
              }
            }
          };
        })(n);
        return m;
      }
      function h(a, b) {
        return a != CKEDITOR.ENTER_BR && !1 !== b ? (a == CKEDITOR.ENTER_DIV ? 'div' : 'p') : !1;
      }
      function f(a) {
        for (a = a.children[a.children.length - 1]; a && c(a); ) a = a.previous;
        return a;
      }
      function b(a) {
        for (a = a.previous; a && c(a); ) a = a.previous;
        return a;
      }
      function c(a) {
        return (
          (a.type == CKEDITOR.NODE_TEXT && !CKEDITOR.tools.trim(a.value)) ||
          (a.type == CKEDITOR.NODE_ELEMENT && a.attributes['data-cke-bookmark'])
        );
      }
      function l(a) {
        return a && ((a.type == CKEDITOR.NODE_ELEMENT && a.name in y) || a.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT);
      }
      function k(a, b) {
        var e = a.children[a.children.length - 1];
        a.children.push(b);
        b.parent = a;
        e && ((e.next = b), (b.previous = e));
      }
      function m(a) {
        a = a.attributes;
        'false' != a.contenteditable && (a['data-cke-editable'] = a.contenteditable ? 'true' : 1);
        a.contenteditable = 'false';
      }
      function g(a) {
        a = a.attributes;
        switch (a['data-cke-editable']) {
          case 'true':
            a.contenteditable = 'true';
            break;
          case '1':
            delete a.contenteditable;
        }
      }
      function d(a, b) {
        return a.replace(G, function (a, e, d) {
          return (
            '\x3c' +
            e +
            d.replace(H, function (a, e) {
              return L.test(e) && -1 == d.indexOf('data-cke-saved-' + e) ? ' data-cke-saved-' + a + ' data-cke-' + b + '-' + a : a;
            }) +
            '\x3e'
          );
        });
      }
      function e(a, b) {
        return a.replace(b, function (a, b, e) {
          0 === a.indexOf('\x3ctextarea') && (a = b + x(e).replace(/</g, '\x26lt;').replace(/>/g, '\x26gt;') + '\x3c/textarea\x3e');
          return '\x3ccke:encoded\x3e' + encodeURIComponent(a) + '\x3c/cke:encoded\x3e';
        });
      }
      function n(a) {
        return a.replace(I, function (a, b) {
          return decodeURIComponent(b);
        });
      }
      function r(a) {
        return a.replace(/\x3c!--(?!{cke_protected})[\s\S]+?--\x3e/g, function (a) {
          return '\x3c!--' + q + '{C}' + encodeURIComponent(a).replace(/--/g, '%2D%2D') + '--\x3e';
        });
      }
      function x(a) {
        return a.replace(/\x3c!--\{cke_protected\}\{C\}([\s\S]+?)--\x3e/g, function (a, b) {
          return decodeURIComponent(b);
        });
      }
      function u(a, b) {
        var e = b._.dataStore;
        return a
          .replace(/\x3c!--\{cke_protected\}([\s\S]+?)--\x3e/g, function (a, b) {
            return decodeURIComponent(b);
          })
          .replace(/\{cke_protected_(\d+)\}/g, function (a, b) {
            return (e && e[b]) || '';
          });
      }
      function p(a, b, e) {
        var d = [],
          g = b.config.protectedSource,
          c = b._.dataStore || (b._.dataStore = { id: 1 }),
          f = new RegExp('\x3c\\!--\\{cke_temp_' + e + '(comment)?\\}(\\d*?)--\x3e', 'g'),
          g = [/<script[\s\S]*?(<\/script>|$)/gi, /<noscript[\s\S]*?<\/noscript>/gi, /<meta[\s\S]*?\/?>/gi].concat(g);
        a = a.replace(/\x3c!--[\s\S]*?--\x3e/g, function (a) {
          return '\x3c!--{cke_temp_' + e + 'comment}' + (d.push(a) - 1) + '--\x3e';
        });
        for (var k = 0; k < g.length; k++)
          a = a.replace(g[k], function (a) {
            a = a.replace(f, function (a, b, e) {
              return d[e];
            });
            return f.test(a) ? a : '\x3c!--{cke_temp_' + e + '}' + (d.push(a) - 1) + '--\x3e';
          });
        a = a.replace(f, function (a, b, e) {
          return '\x3c!--' + q + (b ? '{C}' : '') + encodeURIComponent(d[e]).replace(/--/g, '%2D%2D') + '--\x3e';
        });
        a = a.replace(/<\w+(?:\s+(?:(?:[^\s=>]+\s*=\s*(?:[^'"\s>]+|'[^']*'|"[^"]*"))|[^\s=\/>]+))+\s*\/?>/g, function (a) {
          return a.replace(/\x3c!--\{cke_protected\}([^>]*)--\x3e/g, function (a, b) {
            c[c.id] = decodeURIComponent(b);
            return '{cke_protected_' + c.id++ + '}';
          });
        });
        return (a = a.replace(/<(title|iframe|textarea)([^>]*)>([\s\S]*?)<\/\1>/g, function (a, e, d, g) {
          return '\x3c' + e + d + '\x3e' + u(x(g), b) + '\x3c/' + e + '\x3e';
        }));
      }
      var t;
      CKEDITOR.htmlDataProcessor = function (b) {
        var g,
          c,
          f = this;
        this.editor = b;
        this.dataFilter = g = new CKEDITOR.htmlParser.filter();
        this.htmlFilter = c = new CKEDITOR.htmlParser.filter();
        this.writer = new CKEDITOR.htmlParser.basicWriter();
        g.addRules(v);
        g.addRules(C, { applyToAll: !0 });
        g.addRules(a(b, 'data'), { applyToAll: !0 });
        c.addRules(F);
        c.addRules(D, { applyToAll: !0 });
        c.addRules(a(b, 'html'), { applyToAll: !0 });
        b.on(
          'toHtml',
          function (a) {
            var g;
            var c = window.crypto || window.msCrypto;
            g = c ? c.getRandomValues(new Uint32Array(1))[0] : Math.floor(9e9 * Math.random() + 1e9);
            a = a.data;
            var c = a.dataValue,
              c = t(c),
              c = p(c, b, g),
              c = e(c, S),
              c = d(c, g),
              c = e(c, K),
              c = c.replace(E, '$1cke:$2'),
              c = c.replace(M, '\x3ccke:$1$2\x3e\x3c/cke:$1\x3e'),
              c = c.replace(/(<pre\b[^>]*>)(\r\n|\n)/g, '$1$2$2'),
              c = c.replace(/([^a-z0-9<\-])(on\w{3,})(?!>)/gi, '$1data-cke-' + g + '-$2'),
              f = a.context || b.editable().getName(),
              k;
            CKEDITOR.env.ie && 9 > CKEDITOR.env.version && 'pre' == f && ((f = 'div'), (c = '\x3cpre\x3e' + c + '\x3c/pre\x3e'), (k = 1));
            f = b.document.createElement(f);
            f.setHtml('a' + c);
            c = f.getHtml().substr(1);
            c = c.replace(new RegExp('data-cke-' + g + '-', 'ig'), '');
            k && (c = c.replace(/^<pre>|<\/pre>$/gi, ''));
            c = c.replace(P, '$1$2');
            c = n(c);
            c = x(c);
            g = !1 === a.fixForBody ? !1 : h(a.enterMode, b.config.autoParagraph);
            c = CKEDITOR.htmlParser.fragment.fromHtml(c, a.context, g);
            g && ((k = c), !k.children.length && CKEDITOR.dtd[k.name][g] && ((g = new CKEDITOR.htmlParser.element(g)), k.add(g)));
            a.dataValue = c;
          },
          null,
          null,
          5,
        );
        b.on(
          'toHtml',
          function (a) {
            a.data.filter.applyTo(a.data.dataValue, !0, a.data.dontFilter, a.data.enterMode) && b.fire('dataFiltered');
          },
          null,
          null,
          6,
        );
        b.on(
          'toHtml',
          function (a) {
            a.data.dataValue.filterChildren(f.dataFilter, !0);
          },
          null,
          null,
          10,
        );
        b.on(
          'toHtml',
          function (a) {
            a = a.data;
            var b = a.dataValue,
              e = new CKEDITOR.htmlParser.basicWriter();
            b.writeChildrenHtml(e);
            b = e.getHtml(!0);
            a.dataValue = r(b);
          },
          null,
          null,
          15,
        );
        b.on(
          'toDataFormat',
          function (a) {
            var e = a.data.dataValue;
            a.data.enterMode != CKEDITOR.ENTER_BR && (e = e.replace(/^<br *\/?>/i, ''));
            a.data.dataValue = CKEDITOR.htmlParser.fragment.fromHtml(e, a.data.context, h(a.data.enterMode, b.config.autoParagraph));
          },
          null,
          null,
          5,
        );
        b.on(
          'toDataFormat',
          function (a) {
            a.data.dataValue.filterChildren(f.htmlFilter, !0);
          },
          null,
          null,
          10,
        );
        b.on(
          'toDataFormat',
          function (a) {
            a.data.filter.applyTo(a.data.dataValue, !1, !0);
          },
          null,
          null,
          11,
        );
        b.on(
          'toDataFormat',
          function (a) {
            var e = a.data.dataValue,
              d = f.writer;
            d.reset();
            e.writeChildrenHtml(d);
            e = d.getHtml(!0);
            e = x(e);
            e = u(e, b);
            a.data.dataValue = e;
          },
          null,
          null,
          15,
        );
      };
      CKEDITOR.htmlDataProcessor.prototype = {
        toHtml: function (a, b, e, d) {
          var c = this.editor,
            g,
            f,
            k,
            l;
          b && 'object' == typeof b
            ? ((g = b.context), (e = b.fixForBody), (d = b.dontFilter), (f = b.filter), (k = b.enterMode), (l = b.protectedWhitespaces))
            : (g = b);
          g || null === g || (g = c.editable().getName());
          return c.fire('toHtml', {
            dataValue: a,
            context: g,
            fixForBody: e,
            dontFilter: d,
            filter: f || c.filter,
            enterMode: k || c.enterMode,
            protectedWhitespaces: l,
          }).dataValue;
        },
        toDataFormat: function (a, b) {
          var e, d, c;
          b && ((e = b.context), (d = b.filter), (c = b.enterMode));
          e || null === e || (e = this.editor.editable().getName());
          return this.editor.fire('toDataFormat', {
            dataValue: a,
            filter: d || this.editor.filter,
            context: e,
            enterMode: c || this.editor.enterMode,
          }).dataValue;
        },
        protectSource: function (a) {
          return p(a, this.editor);
        },
        unprotectSource: function (a) {
          return u(a, this.editor);
        },
        unprotectRealComments: function (a) {
          return x(a);
        },
      };
      var A = /(?:&nbsp;|\xa0)$/,
        q = '{cke_protected}',
        B = CKEDITOR.dtd,
        z = 'caption colgroup col thead tfoot tbody'.split(' '),
        y = CKEDITOR.tools.extend({}, B.$blockLimit, B.$block),
        v = { elements: { input: m, textarea: m } },
        C = {
          attributeNames: [
            [/^on/, 'data-cke-pa-on'],
            [/^srcdoc/, 'data-cke-pa-srcdoc'],
            [/^data-cke-expando$/, ''],
          ],
          elements: {
            iframe: function (a) {
              if (a.attributes && a.attributes.src) {
                var b = a.attributes.src.toLowerCase().replace(/[^a-z]/gi, '');
                if (0 === b.indexOf('javascript') || 0 === b.indexOf('data'))
                  (a.attributes['data-cke-pa-src'] = a.attributes.src), delete a.attributes.src;
              }
            },
          },
        },
        F = {
          elements: {
            embed: function (a) {
              var b = a.parent;
              if (b && 'object' == b.name) {
                var e = b.attributes.width,
                  b = b.attributes.height;
                e && (a.attributes.width = e);
                b && (a.attributes.height = b);
              }
            },
            a: function (a) {
              var b = a.attributes;
              if (!(a.children.length || b.name || b.id || a.attributes['data-cke-saved-name'])) return !1;
            },
          },
        },
        D = {
          elementNames: [
            [/^cke:/, ''],
            [/^\?xml:namespace$/, ''],
          ],
          attributeNames: [
            [/^data-cke-(saved|pa)-/, ''],
            [/^data-cke-.*/, ''],
            ['hidefocus', ''],
          ],
          elements: {
            $: function (a) {
              var b = a.attributes;
              if (b) {
                if (b['data-cke-temp']) return !1;
                for (var e = ['name', 'href', 'src'], d, c = 0; c < e.length; c++) (d = 'data-cke-saved-' + e[c]), d in b && delete b[e[c]];
              }
              return a;
            },
            table: function (a) {
              a.children.slice(0).sort(function (a, b) {
                var e, d;
                a.type == CKEDITOR.NODE_ELEMENT &&
                  b.type == a.type &&
                  ((e = CKEDITOR.tools.indexOf(z, a.name)), (d = CKEDITOR.tools.indexOf(z, b.name)));
                (-1 < e && -1 < d && e != d) || ((e = a.parent ? a.getIndex() : -1), (d = b.parent ? b.getIndex() : -1));
                return e > d ? 1 : -1;
              });
            },
            param: function (a) {
              a.children = [];
              a.isEmpty = !0;
              return a;
            },
            span: function (a) {
              'Apple-style-span' == a.attributes['class'] && delete a.name;
            },
            html: function (a) {
              delete a.attributes.contenteditable;
              delete a.attributes['class'];
            },
            body: function (a) {
              delete a.attributes.spellcheck;
              delete a.attributes.contenteditable;
            },
            style: function (a) {
              var b = a.children[0];
              b && b.value && (b.value = CKEDITOR.tools.trim(b.value));
              a.attributes.type || (a.attributes.type = 'text/css');
            },
            title: function (a) {
              var b = a.children[0];
              !b && k(a, (b = new CKEDITOR.htmlParser.text()));
              b.value = a.attributes['data-cke-title'] || '';
            },
            input: g,
            textarea: g,
          },
          attributes: {
            class: function (a) {
              return CKEDITOR.tools.ltrim(a.replace(/(?:^|\s+)cke_[^\s]*/g, '')) || !1;
            },
          },
        };
      CKEDITOR.env.ie &&
        (D.attributes.style = function (a) {
          return a.replace(/(^|;)([^\:]+)/g, function (a) {
            return a.toLowerCase();
          });
        });
      var G = /<(a|area|img|input|source)\b([^>]*)>/gi,
        H = /([\w-:]+)\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|(?:[^ "'>]+))/gi,
        L = /^(href|src|name)$/i,
        K = /(?:<style(?=[ >])[^>]*>[\s\S]*?<\/style>)|(?:<(:?link|meta|base)[^>]*>)/gi,
        S = /(<textarea(?=[ >])[^>]*>)([\s\S]*?)(?:<\/textarea>)/gi,
        I = /<cke:encoded>([^<]*)<\/cke:encoded>/gi,
        E = /(<\/?)((?:object|embed|param|html|body|head|title)([\s][^>]*)?>)/gi,
        P = /(<\/?)cke:((?:html|body|head|title)[^>]*>)/gi,
        M = /<cke:(param|embed)([^>]*?)\/?>(?!\s*<\/cke:\1)/gi;
      t = (function () {
        function a(b, e) {
          for (var d = 0; d < b.length; d++) {
            var c = b[d];
            c.lastIndex = 0;
            if (c.test(e)) return !0;
          }
          return !1;
        }
        function b(a) {
          return CKEDITOR.tools.array.reduce(
            a.split(''),
            function (a, b) {
              var d = b.toLowerCase(),
                c = b.toUpperCase(),
                g = e(d);
              d !== c && (g += '|' + e(c));
              return a + ('(' + g + ')');
            },
            '',
          );
        }
        function e(a) {
          var b;
          b = a.charCodeAt(0);
          var d = b.toString(16);
          b = {
            htmlCode: '\x26#' + b + ';?',
            hex: '\x26#x0*' + d + ';?',
            entity: { '\x3c': '\x26lt;', '\x3e': '\x26gt;', ':': '\x26colon;' }[a],
          };
          for (var c in b) b[c] && (a += '|' + b[c]);
          return a;
        }
        var d = [
          new RegExp(
            '(' +
              b('\x3ccke:encoded\x3e') +
              '(.*?)' +
              b('\x3c/cke:encoded\x3e') +
              ')|(' +
              b('\x3c') +
              b('/') +
              '?' +
              b('cke:encoded\x3e') +
              ')',
            'gi',
          ),
          new RegExp('((' + b('{cke_protected') + ')(_[0-9]*)?' + b('}') + ')', 'gi'),
          /<!(?:\s*-\s*){2,3}!?\s*>/g,
        ];
        return function (b) {
          for (; a(d, b); ) for (var e = d, c = 0; c < e.length; c++) b = b.replace(e[c], '');
          return b;
        };
      })();
    })();
    ('use strict');
    CKEDITOR.htmlParser.element = function (a, h) {
      this.name = a;
      this.attributes = h || {};
      this.children = [];
      var f = a || '',
        b = f.match(/^cke:(.*)/);
      b && (f = b[1]);
      f = !!(
        CKEDITOR.dtd.$nonBodyContent[f] ||
        CKEDITOR.dtd.$block[f] ||
        CKEDITOR.dtd.$listItem[f] ||
        CKEDITOR.dtd.$tableContent[f] ||
        CKEDITOR.dtd.$nonEditable[f] ||
        'br' == f
      );
      this.isEmpty = !!CKEDITOR.dtd.$empty[a];
      this.isUnknown = !CKEDITOR.dtd[a];
      this._ = { isBlockLike: f, hasInlineStarted: this.isEmpty || !f };
    };
    CKEDITOR.htmlParser.cssStyle = function (a) {
      var h = {};
      ((a instanceof CKEDITOR.htmlParser.element ? a.attributes.style : a) || '')
        .replace(/&quot;/g, '"')
        .replace(/\s*([^ :;]+)\s*:\s*([^;]+)\s*(?=;|$)/g, function (a, b, c) {
          'font-family' == b && (c = c.replace(/["']/g, ''));
          h[b.toLowerCase()] = c;
        });
      return {
        rules: h,
        populate: function (a) {
          var b = this.toString();
          b &&
            (a instanceof CKEDITOR.dom.element
              ? a.setAttribute('style', b)
              : a instanceof CKEDITOR.htmlParser.element
                ? (a.attributes.style = b)
                : (a.style = b));
        },
        toString: function () {
          var a = [],
            b;
          for (b in h) h[b] && a.push(b, ':', h[b], ';');
          return a.join('');
        },
      };
    };
    (function () {
      function a(a) {
        return function (c) {
          return c.type == CKEDITOR.NODE_ELEMENT && ('string' == typeof a ? c.name == a : c.name in a);
        };
      }
      var h = function (a, c) {
          a = a[0];
          c = c[0];
          return a < c ? -1 : a > c ? 1 : 0;
        },
        f = CKEDITOR.htmlParser.fragment.prototype;
      CKEDITOR.htmlParser.element.prototype = CKEDITOR.tools.extend(
        new CKEDITOR.htmlParser.node(),
        {
          type: CKEDITOR.NODE_ELEMENT,
          add: f.add,
          clone: function () {
            return new CKEDITOR.htmlParser.element(this.name, this.attributes);
          },
          filter: function (a, c) {
            var f = this,
              k,
              h;
            c = f.getFilterContext(c);
            if (!f.parent) a.onRoot(c, f);
            for (;;) {
              k = f.name;
              if (!(h = a.onElementName(c, k))) return this.remove(), !1;
              f.name = h;
              if (!(f = a.onElement(c, f))) return this.remove(), !1;
              if (f !== this) return this.replaceWith(f), !1;
              if (f.name == k) break;
              if (f.type != CKEDITOR.NODE_ELEMENT) return this.replaceWith(f), !1;
              if (!f.name) return this.replaceWithChildren(), !1;
            }
            k = f.attributes;
            var g, d;
            for (g in k) {
              for (h = k[g]; ; )
                if ((d = a.onAttributeName(c, g)))
                  if (d != g) delete k[g], (g = d);
                  else break;
                else {
                  delete k[g];
                  break;
                }
              d && (!1 === (h = a.onAttribute(c, f, d, h)) ? delete k[d] : (k[d] = h));
            }
            f.isEmpty || this.filterChildren(a, !1, c);
            return !0;
          },
          filterChildren: f.filterChildren,
          writeHtml: function (a, c) {
            c && this.filter(c);
            var f = this.name,
              k = [],
              m = this.attributes,
              g,
              d;
            a.openTag(f, m);
            for (g in m) k.push([g, m[g]]);
            a.sortAttributes && k.sort(h);
            g = 0;
            for (d = k.length; g < d; g++) (m = k[g]), a.attribute(m[0], m[1]);
            a.openTagClose(f, this.isEmpty);
            this.writeChildrenHtml(a);
            this.isEmpty || a.closeTag(f);
          },
          writeChildrenHtml: f.writeChildrenHtml,
          replaceWithChildren: function () {
            for (var a = this.children, c = a.length; c; ) a[--c].insertAfter(this);
            this.remove();
          },
          forEach: f.forEach,
          getFirst: function (b) {
            if (!b) return this.children.length ? this.children[0] : null;
            'function' != typeof b && (b = a(b));
            for (var c = 0, f = this.children.length; c < f; ++c) if (b(this.children[c])) return this.children[c];
            return null;
          },
          getHtml: function () {
            var a = new CKEDITOR.htmlParser.basicWriter();
            this.writeChildrenHtml(a);
            return a.getHtml();
          },
          setHtml: function (a) {
            a = this.children = CKEDITOR.htmlParser.fragment.fromHtml(a).children;
            for (var c = 0, f = a.length; c < f; ++c) a[c].parent = this;
          },
          getOuterHtml: function () {
            var a = new CKEDITOR.htmlParser.basicWriter();
            this.writeHtml(a);
            return a.getHtml();
          },
          split: function (a) {
            for (var c = this.children.splice(a, this.children.length - a), f = this.clone(), k = 0; k < c.length; ++k) c[k].parent = f;
            f.children = c;
            c[0] && (c[0].previous = null);
            0 < a && (this.children[a - 1].next = null);
            this.parent.add(f, this.getIndex() + 1);
            return f;
          },
          find: function (a, c) {
            void 0 === c && (c = !1);
            var f = [],
              k;
            for (k = 0; k < this.children.length; k++) {
              var h = this.children[k];
              'function' == typeof a && a(h) ? f.push(h) : 'string' == typeof a && h.name === a && f.push(h);
              c && h.find && (f = f.concat(h.find(a, c)));
            }
            return f;
          },
          findOne: function (a, c) {
            var f = null,
              k = CKEDITOR.tools.array.find(this.children, function (k) {
                var g = 'function' === typeof a ? a(k) : k.name === a;
                if (g || !c) return g;
                k.children && k.findOne && (f = k.findOne(a, !0));
                return !!f;
              });
            return f || k || null;
          },
          addClass: function (a) {
            if (!this.hasClass(a)) {
              var c = this.attributes['class'] || '';
              this.attributes['class'] = c + (c ? ' ' : '') + a;
            }
          },
          removeClass: function (a) {
            var c = this.attributes['class'];
            c &&
              ((c = CKEDITOR.tools.trim(c.replace(new RegExp('(?:\\s+|^)' + a + '(?:\\s+|$)'), ' ')))
                ? (this.attributes['class'] = c)
                : delete this.attributes['class']);
          },
          hasClass: function (a) {
            var c = this.attributes['class'];
            return c ? new RegExp('(?:^|\\s)' + a + '(?\x3d\\s|$)').test(c) : !1;
          },
          getFilterContext: function (a) {
            var c = [];
            a || (a = { nonEditable: !1, nestedEditable: !1 });
            a.nonEditable || 'false' != this.attributes.contenteditable
              ? a.nonEditable && !a.nestedEditable && 'true' == this.attributes.contenteditable && c.push('nestedEditable', !0)
              : c.push('nonEditable', !0);
            if (c.length) {
              a = CKEDITOR.tools.copy(a);
              for (var f = 0; f < c.length; f += 2) a[c[f]] = c[f + 1];
            }
            return a;
          },
        },
        !0,
      );
    })();
    (function () {
      var a = /{([^}]+)}/g;
      CKEDITOR.template = function (a) {
        this.source = 'function' === typeof a ? a : String(a);
      };
      CKEDITOR.template.prototype.output = function (h, f) {
        var b = ('function' === typeof this.source ? this.source(h) : this.source).replace(a, function (a, b) {
          return void 0 !== h[b] ? h[b] : a;
        });
        return f ? f.push(b) : b;
      };
    })();
    delete CKEDITOR.loadFullCore;
    CKEDITOR.instances = {};
    CKEDITOR.document = new CKEDITOR.dom.document(document);
    CKEDITOR.add = function (a) {
      function h() {
        CKEDITOR.currentInstance == a && ((CKEDITOR.currentInstance = null), CKEDITOR.fire('currentInstance'));
      }
      CKEDITOR.instances[a.name] = a;
      a.on('focus', function () {
        CKEDITOR.currentInstance != a && ((CKEDITOR.currentInstance = a), CKEDITOR.fire('currentInstance'));
      });
      a.on('blur', h);
      a.on('destroy', h);
      CKEDITOR.fire('instance', null, a);
    };
    CKEDITOR.remove = function (a) {
      delete CKEDITOR.instances[a.name];
    };
    (function () {
      var a = {};
      CKEDITOR.addTemplate = function (h, f) {
        var b = a[h];
        if (b) return b;
        b = { name: h, source: f };
        CKEDITOR.fire('template', b);
        return (a[h] = new CKEDITOR.template(b.source));
      };
      CKEDITOR.getTemplate = function (h) {
        return a[h];
      };
    })();
    (function () {
      var a = [];
      CKEDITOR.addCss = function (h) {
        a.push(h);
      };
      CKEDITOR.getCss = function () {
        return a.join('\n');
      };
    })();
    CKEDITOR.on('instanceDestroyed', function () {
      CKEDITOR.tools.isEmpty(this.instances) && CKEDITOR.fire('reset');
    });
    CKEDITOR.TRISTATE_ON = 1;
    CKEDITOR.TRISTATE_OFF = 2;
    CKEDITOR.TRISTATE_DISABLED = 0;
    (function () {
      CKEDITOR.inline = function (a, h) {
        a = CKEDITOR.editor._getEditorElement(a);
        if (!a) return null;
        if (CKEDITOR.editor.shouldDelayEditorCreation(a, h)) return CKEDITOR.editor.initializeDelayedEditorCreation(a, h, 'inline');
        var f = a.is('textarea') ? a : null,
          b = f ? f.getValue() : a.getHtml(),
          c = new CKEDITOR.editor(h, a, CKEDITOR.ELEMENT_MODE_INLINE);
        f
          ? (c.setData(b, null, !0),
            (a = CKEDITOR.dom.element.createFromHtml(
              '\x3cdiv contenteditable\x3d"' + !!c.readOnly + '" class\x3d"cke_textarea_inline"\x3e' + f.getValue() + '\x3c/div\x3e',
              CKEDITOR.document,
            )),
            a.insertAfter(f),
            f.hide(),
            f.$.form && c._attachToForm())
          : (h && 'undefined' !== typeof h.readOnly && !h.readOnly && a.setAttribute('contenteditable', 'true'), c.setData(b, null, !0));
        c.on(
          'loaded',
          function () {
            c.fire('uiReady');
            c.editable(a);
            c.container = a;
            c.ui.contentsElement = a;
            c.setData(c.getData(1));
            c.resetDirty();
            c.fire('contentDom');
            c.mode = 'wysiwyg';
            c.fire('mode');
            c.status = 'ready';
            c.fireOnce('instanceReady');
            CKEDITOR.fire('instanceReady', null, c);
          },
          null,
          null,
          1e4,
        );
        c.on('destroy', function () {
          var a = c.container;
          f && a && (a.clearCustomData(), a.remove());
          f && f.show();
          c.element.clearCustomData();
          delete c.element;
        });
        return c;
      };
      CKEDITOR.inlineAll = function () {
        var a, h, f;
        for (f in CKEDITOR.dtd.$editable)
          for (var b = CKEDITOR.document.getElementsByTag(f), c = 0, l = b.count(); c < l; c++)
            (a = b.getItem(c)),
              'true' != a.getAttribute('contenteditable') ||
                a.getEditor() ||
                ((h = { element: a, config: {} }), !1 !== CKEDITOR.fire('inline', h) && CKEDITOR.inline(a, h.config));
      };
      CKEDITOR.domReady(function () {
        !CKEDITOR.disableAutoInline && CKEDITOR.inlineAll();
      });
    })();
    CKEDITOR.replaceClass = 'ckeditor';
    (function () {
      function a(a, c, l, k) {
        a = CKEDITOR.editor._getEditorElement(a);
        if (!a) return null;
        if (CKEDITOR.editor.shouldDelayEditorCreation(a, c)) return CKEDITOR.editor.initializeDelayedEditorCreation(a, c, 'replace');
        var m = new CKEDITOR.editor(c, a, k);
        k == CKEDITOR.ELEMENT_MODE_REPLACE &&
          (a.setStyle('visibility', 'hidden'), (m._.required = a.hasAttribute('required')), a.removeAttribute('required'));
        l && m.setData(l, null, !0);
        m.on('loaded', function () {
          m.isDestroyed() ||
            m.isDetached() ||
            (f(m),
            k == CKEDITOR.ELEMENT_MODE_REPLACE && m.config.autoUpdateElement && a.$.form && m._attachToForm(),
            m.setMode(m.config.startupMode, function () {
              m.resetDirty();
              m.status = 'ready';
              m.fireOnce('instanceReady');
              CKEDITOR.fire('instanceReady', null, m);
            }));
        });
        m.on('destroy', h);
        return m;
      }
      function h() {
        var a = this.container,
          c = this.element;
        a && (a.clearCustomData(), a.remove());
        c &&
          (c.clearCustomData(),
          this.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE && (c.show(), this._.required && c.setAttribute('required', 'required')),
          delete this.element);
      }
      function f(a) {
        var c = a.name,
          f = a.element,
          k = a.elementMode,
          h = a.fire('uiSpace', { space: 'top', html: '' }).html,
          g = a.fire('uiSpace', { space: 'bottom', html: '' }).html,
          d = new CKEDITOR.template(
            '\x3c{outerEl} id\x3d"cke_{name}" class\x3d"{id} cke cke_reset cke_chrome cke_editor_{name} cke_{langDir} ' +
              CKEDITOR.env.cssClass +
              '"  dir\x3d"{langDir}" lang\x3d"{langCode}" role\x3d"application"' +
              (a.applicationTitle ? ' aria-labelledby\x3d"cke_{name}_arialbl"' : '') +
              '\x3e' +
              (a.applicationTitle ? '\x3cspan id\x3d"cke_{name}_arialbl" class\x3d"cke_voice_label"\x3e{voiceLabel}\x3c/span\x3e' : '') +
              '\x3c{outerEl} class\x3d"cke_inner cke_reset" role\x3d"presentation"\x3e{topHtml}\x3c{outerEl} id\x3d"{contentId}" class\x3d"cke_contents cke_reset" role\x3d"presentation"\x3e\x3c/{outerEl}\x3e{bottomHtml}\x3c/{outerEl}\x3e\x3c/{outerEl}\x3e',
          ),
          c = CKEDITOR.dom.element.createFromHtml(
            d.output({
              id: a.id,
              name: c,
              langDir: a.lang.dir,
              langCode: a.langCode,
              voiceLabel: a.applicationTitle,
              topHtml: h
                ? '\x3cspan id\x3d"' +
                  a.ui.spaceId('top') +
                  '" class\x3d"cke_top cke_reset_all" role\x3d"presentation" style\x3d"height:auto"\x3e' +
                  h +
                  '\x3c/span\x3e'
                : '',
              contentId: a.ui.spaceId('contents'),
              bottomHtml: g
                ? '\x3cspan id\x3d"' +
                  a.ui.spaceId('bottom') +
                  '" class\x3d"cke_bottom cke_reset_all" role\x3d"presentation"\x3e' +
                  g +
                  '\x3c/span\x3e'
                : '',
              outerEl: CKEDITOR.env.ie ? 'span' : 'div',
            }),
          );
        k == CKEDITOR.ELEMENT_MODE_REPLACE ? (f.hide(), c.insertAfter(f)) : f.append(c);
        a.container = c;
        a.ui.contentsElement = a.ui.space('contents');
        h && a.ui.space('top').unselectable();
        g && a.ui.space('bottom').unselectable();
        f = a.config.width;
        k = a.config.height;
        f && c.setStyle('width', CKEDITOR.tools.cssLength(f));
        k && a.ui.space('contents').setStyle('height', CKEDITOR.tools.cssLength(k));
        c.disableContextMenu();
        CKEDITOR.env.webkit &&
          c.on('focus', function () {
            a.focus();
          });
        a.fireOnce('uiReady');
      }
      CKEDITOR.replace = function (b, c) {
        return a(b, c, null, CKEDITOR.ELEMENT_MODE_REPLACE);
      };
      CKEDITOR.appendTo = function (b, c, f) {
        return a(b, c, f, CKEDITOR.ELEMENT_MODE_APPENDTO);
      };
      CKEDITOR.replaceAll = function () {
        for (var a = document.getElementsByTagName('textarea'), c = 0; c < a.length; c++) {
          var f = null,
            k = a[c];
          if (k.name || k.id) {
            if ('string' == typeof arguments[0]) {
              if (!new RegExp('(?:^|\\s)' + arguments[0] + '(?:$|\\s)').test(k.className)) continue;
            } else if ('function' == typeof arguments[0] && ((f = {}), !1 === arguments[0](k, f))) continue;
            this.replace(k, f);
          }
        }
      };
      CKEDITOR.editor.prototype.addMode = function (a, c) {
        (this._.modes || (this._.modes = {}))[a] = c;
      };
      CKEDITOR.editor.prototype.setMode = function (a, c) {
        var f = this,
          k = this._.modes;
        if (a != f.mode && k && k[a]) {
          f.fire('beforeSetMode', a);
          if (f.mode) {
            var h = f.checkDirty(),
              k = f._.previousModeData,
              g,
              d = 0;
            f.fire('beforeModeUnload');
            f.editable(0);
            f._.previousMode = f.mode;
            f._.previousModeData = g = f.getData(1);
            'source' == f.mode && k == g && (f.fire('lockSnapshot', { forceUpdate: !0 }), (d = 1));
            f.ui.space('contents').setHtml('');
            f.mode = '';
          } else f._.previousModeData = f.getData(1);
          this._.modes[a](function () {
            f.mode = a;
            void 0 !== h && !h && f.resetDirty();
            d ? f.fire('unlockSnapshot') : 'wysiwyg' == a && f.fire('saveSnapshot');
            setTimeout(function () {
              f.isDestroyed() || f.isDetached() || (f.fire('mode'), c && c.call(f));
            }, 0);
          });
        }
      };
      CKEDITOR.editor.prototype.resize = function (a, c, f, k) {
        var h = this.container,
          g = this.ui.space('contents'),
          d = CKEDITOR.env.webkit && this.document && this.document.getWindow().$.frameElement;
        k = k
          ? this.container.getFirst(function (a) {
              return a.type == CKEDITOR.NODE_ELEMENT && a.hasClass('cke_inner');
            })
          : h;
        if (a || 0 === a) a = CKEDITOR.tools.convertToPx(CKEDITOR.tools.cssLength(a));
        k.setSize('width', a, !0);
        d && (d.style.width = '1%');
        c = CKEDITOR.tools.convertToPx(CKEDITOR.tools.cssLength(c));
        var e = (k.$.offsetHeight || 0) - (g.$.clientHeight || 0),
          h = Math.max(c - (f ? 0 : e), 0);
        c = f ? c + e : c;
        g.setStyle('height', CKEDITOR.tools.cssLength(h));
        d && (d.style.width = '100%');
        this.fire('resize', { outerHeight: c, contentsHeight: h, outerWidth: a || k.getSize('width') });
      };
      CKEDITOR.editor.prototype.getResizable = function (a) {
        return a ? this.ui.space('contents') : this.container;
      };
      CKEDITOR.domReady(function () {
        CKEDITOR.replaceClass && CKEDITOR.replaceAll(CKEDITOR.replaceClass);
      });
    })();
    CKEDITOR.config.startupMode = 'wysiwyg';
    (function () {
      function a(a) {
        var e = a.editor,
          d = a.data.path,
          c = d.blockLimit,
          f = a.data.selection,
          k = f.getRanges()[0],
          l;
        if (CKEDITOR.env.gecko || (CKEDITOR.env.ie && CKEDITOR.env.needsBrFiller))
          if ((f = h(f, d))) f.appendBogus(), (l = (CKEDITOR.env.ie && !CKEDITOR.env.edge) || (CKEDITOR.env.edge && e._.previousActive));
        g(e, d.block, c) &&
          k.collapsed &&
          !k.getCommonAncestor().isReadOnly() &&
          ((d = k.clone()),
          d.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS),
          (c = new CKEDITOR.dom.walker(d)),
          (c.guard = function (a) {
            return !b(a) || a.type == CKEDITOR.NODE_COMMENT || a.isReadOnly();
          }),
          !c.checkForward() || (d.checkStartOfBlock() && d.checkEndOfBlock())) &&
          ((e = k.fixBlock(!0, e.activeEnterMode == CKEDITOR.ENTER_DIV ? 'div' : 'p')),
          CKEDITOR.env.needsBrFiller ||
            ((e = e.getFirst(b)) &&
              e.type == CKEDITOR.NODE_TEXT &&
              CKEDITOR.tools.trim(e.getText()).match(/^(?:&nbsp;|\xa0)$/) &&
              e.remove()),
          (l = 1),
          a.cancel());
        l && k.select();
      }
      function h(a, e) {
        if (a.isFake) return 0;
        var d = e.block || e.blockLimit,
          c = d && d.getLast(b);
        if (!(!d || !d.isBlockBoundary() || (c && c.type == CKEDITOR.NODE_ELEMENT && c.isBlockBoundary()) || d.is('pre') || d.getBogus()))
          return d;
      }
      function f(a) {
        var b = a.data.getTarget();
        b.is('input') && ((b = b.getAttribute('type')), ('submit' != b && 'reset' != b) || a.data.preventDefault());
      }
      function b(a) {
        return x(a) && u(a);
      }
      function c(a, b) {
        return function (e) {
          var d = e.data.$.toElement || e.data.$.fromElement || e.data.$.relatedTarget;
          ((d = d && d.nodeType == CKEDITOR.NODE_ELEMENT ? new CKEDITOR.dom.element(d) : null) && (b.equals(d) || b.contains(d))) ||
            a.call(this, e);
        };
      }
      function l(a) {
        return !!a.getRanges()[0].startPath().contains({ table: 1, ul: 1, ol: 1, dl: 1 });
      }
      function k(a) {
        function e(a) {
          var c = { table: 1, ul: 1, ol: 1, dl: 1 };
          return function (e, g) {
            g && e.type == CKEDITOR.NODE_ELEMENT && e.is(c) && (d = e);
            if (!(g || !b(e) || (a && t(e)))) return !1;
          };
        }
        var d,
          c = a.getRanges()[0],
          g = a.root;
        return l(a) &&
          ((a = c.clone()),
          a.collapse(1),
          a.setStartAt(g, CKEDITOR.POSITION_AFTER_START),
          (g = new CKEDITOR.dom.walker(a)),
          (g.guard = e()),
          g.checkBackward(),
          d)
          ? ((a = c.clone()),
            a.collapse(),
            a.setEndAt(d, CKEDITOR.POSITION_AFTER_END),
            (g = new CKEDITOR.dom.walker(a)),
            (g.guard = e(!0)),
            (d = !1),
            g.checkForward(),
            d)
          : null;
      }
      function m(a) {
        return a.block.getParent().getChildCount();
      }
      function g(a, b, e) {
        return (
          !1 !== a.config.autoParagraph &&
          a.activeEnterMode != CKEDITOR.ENTER_BR &&
          ((a.editable().equals(e) && !b) || (b && 'true' == b.getAttribute('contenteditable')))
        );
      }
      function d(a) {
        return a.activeEnterMode != CKEDITOR.ENTER_BR && !1 !== a.config.autoParagraph
          ? a.activeEnterMode == CKEDITOR.ENTER_DIV
            ? 'div'
            : 'p'
          : !1;
      }
      function e(a) {
        a && a.isEmptyInlineRemoveable() && a.remove();
      }
      function n(a) {
        var b = a.editor;
        b.getSelection().scrollIntoView();
        setTimeout(function () {
          b.fire('saveSnapshot');
        }, 0);
      }
      function r(a, b, e) {
        var d = a.getCommonAncestor(b);
        for (b = a = e ? b : a; (a = a.getParent()) && !d.equals(a) && 1 == a.getChildCount(); ) b = a;
        b.remove();
      }
      var x,
        u,
        p,
        t,
        A,
        q,
        B,
        z,
        y,
        v,
        C = { ul: 1, ol: 1, dl: 1 };
      CKEDITOR.editable = CKEDITOR.tools.createClass({
        base: CKEDITOR.dom.element,
        $: function (a, b) {
          this.base(b.$ || b);
          this.editor = a;
          this.status = 'unloaded';
          this.hasFocus = !1;
          this.setup();
        },
        proto: {
          focus: function () {
            var a;
            if (
              CKEDITOR.env.webkit &&
              !this.hasFocus &&
              ((a = this.editor._.previousActive || this.getDocument().getActive()), this.contains(a))
            ) {
              a.focus();
              return;
            }
            CKEDITOR.env.edge &&
              14 < CKEDITOR.env.version &&
              !this.hasFocus &&
              this.getDocument().equals(CKEDITOR.document) &&
              (this.editor._.previousScrollTop = this.$.scrollTop);
            try {
              if (!CKEDITOR.env.ie || (CKEDITOR.env.edge && 14 < CKEDITOR.env.version) || !this.getDocument().equals(CKEDITOR.document))
                if (CKEDITOR.env.chrome) {
                  var b = this.$.scrollTop;
                  this.$.focus();
                  this.$.scrollTop = b;
                } else this.$.focus();
              else this.$.setActive();
            } catch (e) {
              if (!CKEDITOR.env.ie) throw e;
            }
            CKEDITOR.env.safari &&
              !this.isInline() &&
              ((a = CKEDITOR.document.getActive()), a.equals(this.getWindow().getFrame()) || this.getWindow().focus());
          },
          on: function (a, b) {
            var e = Array.prototype.slice.call(arguments, 0);
            CKEDITOR.env.ie &&
              /^focus|blur$/.exec(a) &&
              ((a = 'focus' == a ? 'focusin' : 'focusout'), (b = c(b, this)), (e[0] = a), (e[1] = b));
            return CKEDITOR.dom.element.prototype.on.apply(this, e);
          },
          attachListener: function (a) {
            !this._.listeners && (this._.listeners = []);
            var b = Array.prototype.slice.call(arguments, 1),
              b = a.on.apply(a, b);
            this._.listeners.push(b);
            return b;
          },
          clearListeners: function () {
            var a = this._.listeners;
            try {
              for (; a.length; ) a.pop().removeListener();
            } catch (b) {}
          },
          restoreAttrs: function () {
            var a = this._.attrChanges,
              b,
              e;
            for (e in a) a.hasOwnProperty(e) && ((b = a[e]), null !== b ? this.setAttribute(e, b) : this.removeAttribute(e));
          },
          attachClass: function (a) {
            var b = this.getCustomData('classes');
            this.hasClass(a) || (!b && (b = []), b.push(a), this.setCustomData('classes', b), this.addClass(a));
          },
          changeAttr: function (a, b) {
            var e = this.getAttribute(a);
            b !== e &&
              (!this._.attrChanges && (this._.attrChanges = {}),
              a in this._.attrChanges || (this._.attrChanges[a] = e),
              this.setAttribute(a, b));
          },
          insertText: function (a) {
            this.editor.focus();
            this.insertHtml(this.transformPlainTextToHtml(a), 'text');
          },
          transformPlainTextToHtml: function (a) {
            var b = this.editor.getSelection().getStartElement().hasAscendant('pre', !0) ? CKEDITOR.ENTER_BR : this.editor.activeEnterMode;
            return CKEDITOR.tools.transformPlainTextToHtml(a, b);
          },
          insertHtml: function (a, b, e) {
            var d = this.editor;
            d.focus();
            d.fire('saveSnapshot');
            e || (e = d.getSelection().getRanges()[0]);
            q(this, b || 'html', a, e);
            e.select();
            n(this);
            this.editor.fire('afterInsertHtml', {});
          },
          insertHtmlIntoRange: function (a, b, e) {
            q(this, e || 'html', a, b);
            this.editor.fire('afterInsertHtml', { intoRange: b });
          },
          insertElement: function (a, e) {
            var d = this.editor;
            d.focus();
            d.fire('saveSnapshot');
            var c = d.activeEnterMode,
              d = d.getSelection(),
              g = a.getName(),
              g = CKEDITOR.dtd.$block[g];
            e || (e = d.getRanges()[0]);
            this.insertElementIntoRange(a, e) &&
              (e.moveToPosition(a, CKEDITOR.POSITION_AFTER_END),
              g &&
                ((g = a.getNext(function (a) {
                  return b(a) && !t(a);
                })) &&
                g.type == CKEDITOR.NODE_ELEMENT &&
                g.is(CKEDITOR.dtd.$block)
                  ? g.getDtd()['#']
                    ? e.moveToElementEditStart(g)
                    : e.moveToElementEditEnd(a)
                  : g ||
                    c == CKEDITOR.ENTER_BR ||
                    ((g = e.fixBlock(!0, c == CKEDITOR.ENTER_DIV ? 'div' : 'p')), e.moveToElementEditStart(g))));
            d.selectRanges([e]);
            n(this);
          },
          insertElementIntoSelection: function (a) {
            this.insertElement(a);
          },
          insertElementIntoRange: function (a, b) {
            var d = this.editor,
              c = d.config.enterMode,
              g = a.getName(),
              f = CKEDITOR.dtd.$block[g];
            if (b.checkReadOnly()) return !1;
            b.deleteContents(1);
            b.startContainer.type == CKEDITOR.NODE_ELEMENT &&
              (b.startContainer.is({ tr: 1, table: 1, tbody: 1, thead: 1, tfoot: 1 })
                ? B(b)
                : b.startContainer.is(CKEDITOR.dtd.$list) && z(b));
            var k, h;
            if (f)
              for (; (k = b.getCommonAncestor(0, 1)) && (h = CKEDITOR.dtd[k.getName()]) && (!h || !h[g]); )
                if (k.getName() in CKEDITOR.dtd.span) {
                  var f = b.splitElement(k),
                    l = b.createBookmark();
                  e(k);
                  e(f);
                  b.moveToBookmark(l);
                } else
                  b.checkStartOfBlock() && b.checkEndOfBlock()
                    ? (b.setStartBefore(k), b.collapse(!0), k.remove())
                    : b.splitBlock(c == CKEDITOR.ENTER_DIV ? 'div' : 'p', d.editable());
            b.insertNode(a);
            return !0;
          },
          setData: function (a, b) {
            b || (a = this.editor.dataProcessor.toHtml(a));
            this.setHtml(a);
            this.fixInitialSelection();
            'unloaded' == this.status && (this.status = 'ready');
            this.editor.fire('dataReady');
          },
          getData: function (a) {
            var b = this.getHtml();
            a || (b = this.editor.dataProcessor.toDataFormat(b));
            return b;
          },
          setReadOnly: function (a) {
            this.setAttribute('contenteditable', String(!a));
            this.setAttribute('aria-readonly', String(a));
          },
          detach: function () {
            this.status = 'detached';
            this.editor.setData(this.editor.getData(), { internal: !0 });
            this.clearListeners();
            try {
              this._.cleanCustomData();
            } catch (a) {
              if (!CKEDITOR.env.ie || -2146828218 !== a.number) throw a;
            }
            this.editor.fire('contentDomUnload');
            delete this.editor.document;
            delete this.editor.window;
            delete this.editor;
          },
          isInline: function () {
            return this.getDocument().equals(CKEDITOR.document);
          },
          fixInitialSelection: function () {
            function a() {
              var b = e.getDocument().$,
                d = b.getSelection(),
                c;
              a: if (d.anchorNode && d.anchorNode == e.$) c = !0;
              else {
                if (CKEDITOR.env.webkit && (c = e.getDocument().getActive()) && c.equals(e) && !d.anchorNode) {
                  c = !0;
                  break a;
                }
                c = void 0;
              }
              c &&
                ((c = new CKEDITOR.dom.range(e)),
                c.moveToElementEditStart(e),
                (b = b.createRange()),
                b.setStart(c.startContainer.$, c.startOffset),
                b.collapse(!0),
                d.removeAllRanges(),
                d.addRange(b));
            }
            function b() {
              var a = e.getDocument().$,
                d = a.selection,
                c = e.getDocument().getActive();
              'None' == d.type &&
                c.equals(e) &&
                ((d = new CKEDITOR.dom.range(e)),
                (a = a.body.createTextRange()),
                d.moveToElementEditStart(e),
                (d = d.startContainer),
                d.type != CKEDITOR.NODE_ELEMENT && (d = d.getParent()),
                a.moveToElementText(d.$),
                a.collapse(!0),
                a.select());
            }
            var e = this;
            if (CKEDITOR.env.ie && (9 > CKEDITOR.env.version || CKEDITOR.env.quirks)) this.hasFocus && (this.focus(), b());
            else if (this.hasFocus) this.focus(), a();
            else
              this.once(
                'focus',
                function () {
                  a();
                },
                null,
                null,
                -999,
              );
          },
          getHtmlFromRange: function (a) {
            if (a.collapsed) return new CKEDITOR.dom.documentFragment(a.document);
            a = { doc: this.getDocument(), range: a.clone() };
            y.eol.detect(a, this);
            y.bogus.exclude(a);
            y.cell.shrink(a);
            a.fragment = a.range.cloneContents();
            y.tree.rebuild(a, this);
            y.eol.fix(a, this);
            return new CKEDITOR.dom.documentFragment(a.fragment.$);
          },
          extractHtmlFromRange: function (a, b) {
            var e = v,
              d = { range: a, doc: a.document },
              c = this.getHtmlFromRange(a);
            if (a.collapsed) return a.optimize(), c;
            a.enlarge(CKEDITOR.ENLARGE_INLINE, 1);
            e.table.detectPurge(d);
            d.bookmark = a.createBookmark();
            delete d.range;
            var g = this.editor.createRange();
            g.moveToPosition(d.bookmark.startNode, CKEDITOR.POSITION_BEFORE_START);
            d.targetBookmark = g.createBookmark();
            e.list.detectMerge(d, this);
            e.table.detectRanges(d, this);
            e.block.detectMerge(d, this);
            d.tableContentsRanges
              ? (e.table.deleteRanges(d), a.moveToBookmark(d.bookmark), (d.range = a))
              : (a.moveToBookmark(d.bookmark), (d.range = a), a.extractContents(e.detectExtractMerge(d)));
            a.moveToBookmark(d.targetBookmark);
            a.optimize();
            e.fixUneditableRangePosition(a);
            e.list.merge(d, this);
            e.table.purge(d, this);
            e.block.merge(d, this);
            if (b) {
              e = a.startPath();
              if ((d = a.checkStartOfBlock() && a.checkEndOfBlock() && e.block && !a.root.equals(e.block))) {
                a: {
                  var d = e.block.getElementsByTag('span'),
                    g = 0,
                    f;
                  if (d)
                    for (; (f = d.getItem(g++)); )
                      if (!u(f)) {
                        d = !0;
                        break a;
                      }
                  d = !1;
                }
                d = !d;
              }
              d && (a.moveToPosition(e.block, CKEDITOR.POSITION_BEFORE_START), e.block.remove());
            } else e.autoParagraph(this.editor, a), p(a.startContainer) && a.startContainer.appendBogus();
            a.startContainer.mergeSiblings();
            return c;
          },
          setup: function () {
            var a = this.editor;
            this.attachListener(
              a,
              'beforeGetData',
              function () {
                var b = this.getData();
                this.is('textarea') ||
                  (!1 !== a.config.ignoreEmptyParagraph &&
                    (b = b.replace(A, function (a, b) {
                      return b;
                    })));
                a.setData(b, null, 1);
              },
              this,
            );
            this.attachListener(
              a,
              'getSnapshot',
              function (a) {
                a.data = this.getData(1);
              },
              this,
            );
            this.attachListener(
              a,
              'afterSetData',
              function () {
                this.setData(a.getData(1));
              },
              this,
            );
            this.attachListener(
              a,
              'loadSnapshot',
              function (a) {
                this.setData(a.data, 1);
              },
              this,
            );
            this.attachListener(
              a,
              'beforeFocus',
              function () {
                var b = a.getSelection();
                ((b = b && b.getNative()) && 'Control' == b.type) || this.focus();
              },
              this,
            );
            this.attachListener(
              a,
              'insertHtml',
              function (a) {
                this.insertHtml(a.data.dataValue, a.data.mode, a.data.range);
              },
              this,
            );
            this.attachListener(
              a,
              'insertElement',
              function (a) {
                this.insertElement(a.data);
              },
              this,
            );
            this.attachListener(
              a,
              'insertText',
              function (a) {
                this.insertText(a.data);
              },
              this,
            );
            this.setReadOnly(a.readOnly);
            this.attachClass('cke_editable');
            a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE
              ? this.attachClass('cke_editable_inline')
              : (a.elementMode != CKEDITOR.ELEMENT_MODE_REPLACE && a.elementMode != CKEDITOR.ELEMENT_MODE_APPENDTO) ||
                this.attachClass('cke_editable_themed');
            this.attachClass('cke_contents_' + a.config.contentsLangDirection);
            a.keystrokeHandler.blockedKeystrokes[8] = +a.readOnly;
            a.keystrokeHandler.attach(this);
            this.on(
              'blur',
              function () {
                this.hasFocus = !1;
              },
              null,
              null,
              -1,
            );
            this.on(
              'focus',
              function () {
                this.hasFocus = !0;
              },
              null,
              null,
              -1,
            );
            if (CKEDITOR.env.webkit)
              this.on(
                'scroll',
                function () {
                  a._.previousScrollTop = a.editable().$.scrollTop;
                },
                null,
                null,
                -1,
              );
            if (CKEDITOR.env.edge && 14 < CKEDITOR.env.version) {
              var e = function () {
                var b = a.editable();
                null != a._.previousScrollTop &&
                  b.getDocument().equals(CKEDITOR.document) &&
                  ((b.$.scrollTop = a._.previousScrollTop), (a._.previousScrollTop = null), this.removeListener('scroll', e));
              };
              this.on('scroll', e);
            }
            a.focusManager.add(this);
            this.equals(CKEDITOR.document.getActive()) &&
              ((this.hasFocus = !0),
              a.once(
                'contentDom',
                function () {
                  a.focusManager.focus(this);
                },
                this,
              ));
            this.isInline() && this.changeAttr('tabindex', a.tabIndex);
            if (!this.is('textarea')) {
              a.document = this.getDocument();
              a.window = this.getWindow();
              var d = a.document;
              this.changeAttr('spellcheck', !a.config.disableNativeSpellChecker);
              var c = a.config.contentsLangDirection;
              this.getDirection(1) != c && this.changeAttr('dir', c);
              var g = CKEDITOR.getCss();
              if (g) {
                var c = d.getHead(),
                  h = c.getCustomData('stylesheet');
                h
                  ? g != h.getText() && (CKEDITOR.env.ie && 9 > CKEDITOR.env.version ? (h.$.styleSheet.cssText = g) : h.setText(g))
                  : ((g = d.appendStyleText(g)),
                    (g = new CKEDITOR.dom.element(g.ownerNode || g.owningElement)),
                    c.setCustomData('stylesheet', g),
                    g.data('cke-temp', 1));
              }
              c = d.getCustomData('stylesheet_ref') || 0;
              d.setCustomData('stylesheet_ref', c + 1);
              this.setCustomData('cke_includeReadonly', !a.config.disableReadonlyStyling);
              this.attachListener(this, 'click', function (a) {
                a = a.data;
                var b = new CKEDITOR.dom.elementPath(a.getTarget(), this).contains('a');
                b && 2 != a.$.button && b.isReadOnly() && a.preventDefault();
              });
              var n = { 8: 1, 46: 1 };
              this.attachListener(a, 'key', function (b) {
                if (a.readOnly) return !0;
                var e = b.data.domEvent.getKey(),
                  d,
                  c = a.getSelection();
                if (0 !== c.getRanges().length) {
                  if (e in n) {
                    var g;
                    b = c.getRanges()[0];
                    var f = b.startPath(),
                      h,
                      r,
                      t,
                      e = 8 == e,
                      q = !1;
                    if (CKEDITOR.env.ie && 11 > CKEDITOR.env.version && c.getSelectedElement()) g = c.getSelectedElement();
                    else if (l(c)) {
                      var v = new CKEDITOR.dom.walker(b),
                        L = b.collapsed ? b.startContainer : v.next(),
                        q = !1,
                        H;
                      if (b.checkStartOfBlock()) {
                        H = b.startPath().block || b.startPath().blockLimit;
                        var u = H.getName();
                        H = -1 !== CKEDITOR.tools.array.indexOf(['dd', 'dt', 'li'], u) && null === H.getPrevious();
                      } else H = !1;
                      if (H) {
                        for (; L && !q; ) (q = L.$.nodeName.toLowerCase()), (q = !!C[q]), (L = v.next());
                        v = m(b.startPath());
                        L = m(b.endPath());
                        q = q || v !== L;
                      } else q = void 0;
                      q || (g = k(c));
                    }
                    g || q
                      ? (a.fire('saveSnapshot'),
                        q
                          ? ((d = b.startContainer.getAscendant(C, !0))
                              ? (b.setStart(d, 0), b.enlarge(CKEDITOR.ENLARGE_ELEMENT), (g = b))
                              : (g = null),
                            g.deleteContents())
                          : (b.moveToPosition(g, CKEDITOR.POSITION_BEFORE_START), g.remove()),
                        b.select(),
                        a.fire('saveSnapshot'),
                        (d = 1))
                      : b.collapsed &&
                        ((h = f.block) &&
                        (t = h[e ? 'getPrevious' : 'getNext'](x)) &&
                        t.type == CKEDITOR.NODE_ELEMENT &&
                        t.is('table') &&
                        b[e ? 'checkStartOfBlock' : 'checkEndOfBlock']()
                          ? (a.fire('saveSnapshot'),
                            b[e ? 'checkEndOfBlock' : 'checkStartOfBlock']() && h.remove(),
                            b['moveToElementEdit' + (e ? 'End' : 'Start')](t),
                            b.select(),
                            a.fire('saveSnapshot'),
                            (d = 1))
                          : f.blockLimit &&
                              f.blockLimit.is('td') &&
                              (r = f.blockLimit.getAscendant('table')) &&
                              b.checkBoundaryOfElement(r, e ? CKEDITOR.START : CKEDITOR.END) &&
                              (t = r[e ? 'getPrevious' : 'getNext'](x))
                            ? (a.fire('saveSnapshot'),
                              b['moveToElementEdit' + (e ? 'End' : 'Start')](t),
                              b.checkStartOfBlock() && b.checkEndOfBlock() ? t.remove() : b.select(),
                              a.fire('saveSnapshot'),
                              (d = 1))
                            : (r = f.contains(['td', 'th', 'caption'])) &&
                              b.checkBoundaryOfElement(r, e ? CKEDITOR.START : CKEDITOR.END) &&
                              (d = 1));
                  }
                  return !d;
                }
              });
              a.blockless &&
                CKEDITOR.env.ie &&
                CKEDITOR.env.needsBrFiller &&
                this.attachListener(this, 'keyup', function (e) {
                  e.data.getKeystroke() in n &&
                    !this.getFirst(b) &&
                    (this.appendBogus(), (e = a.createRange()), e.moveToPosition(this, CKEDITOR.POSITION_AFTER_START), e.select());
                });
              this.attachListener(this, 'dblclick', function (b) {
                if (a.readOnly) return !1;
                b = { element: b.data.getTarget() };
                a.fire('doubleclick', b);
              });
              CKEDITOR.env.ie && this.attachListener(this, 'click', f);
              (CKEDITOR.env.ie && !CKEDITOR.env.edge) ||
                this.attachListener(this, 'mousedown', function (b) {
                  var e = b.data.getTarget();
                  e.is('img', 'hr', 'input', 'textarea', 'select') &&
                    !e.isReadOnly() &&
                    (a.getSelection().selectElement(e), e.is('input', 'textarea', 'select') && b.data.preventDefault());
                });
              CKEDITOR.env.edge &&
                this.attachListener(this, 'mouseup', function (b) {
                  (b = b.data.getTarget()) && b.is('img') && !b.isReadOnly() && a.getSelection().selectElement(b);
                });
              CKEDITOR.env.gecko &&
                this.attachListener(this, 'mouseup', function (b) {
                  if (2 == b.data.$.button && ((b = b.data.getTarget()), !b.getAscendant('table') && !b.getOuterHtml().replace(A, ''))) {
                    var e = a.createRange();
                    e.moveToElementEditStart(b);
                    e.select(!0);
                  }
                });
              CKEDITOR.env.webkit &&
                (this.attachListener(this, 'click', function (a) {
                  a.data.getTarget().is('input', 'select') && a.data.preventDefault();
                }),
                this.attachListener(this, 'mouseup', function (a) {
                  a.data.getTarget().is('input', 'textarea') && a.data.preventDefault();
                }));
              CKEDITOR.env.webkit &&
                this.attachListener(
                  a,
                  'key',
                  function (b) {
                    if (a.readOnly) return !0;
                    var e = b.data.domEvent.getKey();
                    if (e in n && ((b = a.getSelection()), 0 !== b.getRanges().length)) {
                      var e = 8 == e,
                        d = b.getRanges()[0];
                      b = d.startPath();
                      if (d.collapsed)
                        a: {
                          var c = b.block;
                          if (
                            c &&
                            d[e ? 'checkStartOfBlock' : 'checkEndOfBlock'](!0) &&
                            d.moveToClosestEditablePosition(c, !e) &&
                            d.collapsed
                          ) {
                            if (d.startContainer.type == CKEDITOR.NODE_ELEMENT) {
                              var g = d.startContainer.getChild(d.startOffset - (e ? 1 : 0));
                              if (g && g.type == CKEDITOR.NODE_ELEMENT && g.is('hr')) {
                                a.fire('saveSnapshot');
                                g.remove();
                                b = !0;
                                break a;
                              }
                            }
                            d = d.startPath().block;
                            if (!d || (d && d.contains(c))) b = void 0;
                            else {
                              a.fire('saveSnapshot');
                              var f;
                              (f = (e ? d : c).getBogus()) && f.remove();
                              f = a.getSelection();
                              g = f.createBookmarks();
                              (e ? c : d).moveChildren(e ? d : c, !1);
                              b.lastElement.mergeSiblings();
                              r(c, d, !e);
                              f.selectBookmarks(g);
                              b = !0;
                            }
                          } else b = !1;
                        }
                      else
                        (e = d),
                          (f = b.block),
                          (d = e.endPath().block),
                          f && d && !f.equals(d)
                            ? (a.fire('saveSnapshot'),
                              (c = f.getBogus()) && c.remove(),
                              e.enlarge(CKEDITOR.ENLARGE_INLINE),
                              e.deleteContents(),
                              d.getParent() && (d.moveChildren(f, !1), b.lastElement.mergeSiblings(), r(f, d, !0)),
                              (e = a.getSelection().getRanges()[0]),
                              e.collapse(1),
                              e.optimize(),
                              '' === e.startContainer.getHtml() && e.startContainer.appendBogus(),
                              e.select(),
                              (b = !0))
                            : (b = !1);
                      if (!b) return;
                      a.getSelection().scrollIntoView();
                      a.fire('saveSnapshot');
                      return !1;
                    }
                  },
                  this,
                  null,
                  100,
                );
            }
          },
          getUniqueId: function () {
            var a;
            try {
              this._.expandoNumber = a = CKEDITOR.dom.domObject.prototype.getUniqueId.call(this);
            } catch (b) {
              a = this._ && this._.expandoNumber;
            }
            return a;
          },
        },
        _: {
          cleanCustomData: function () {
            this.removeClass('cke_editable');
            this.restoreAttrs();
            for (var a = this.removeCustomData('classes'); a && a.length; ) this.removeClass(a.pop());
            if (!this.is('textarea')) {
              var a = this.getDocument(),
                b = a.getHead();
              if (b.getCustomData('stylesheet')) {
                var e = a.getCustomData('stylesheet_ref');
                --e
                  ? a.setCustomData('stylesheet_ref', e)
                  : (a.removeCustomData('stylesheet_ref'), b.removeCustomData('stylesheet').remove());
              }
            }
          },
        },
      });
      CKEDITOR.editor.prototype.editable = function (a) {
        var b = this._.editable;
        if (b && a) return 0;
        if (!arguments.length) return b;
        a ? (b = a instanceof CKEDITOR.editable ? a : new CKEDITOR.editable(this, a)) : (b && b.detach(), (b = null));
        return (this._.editable = b);
      };
      CKEDITOR.on('instanceLoaded', function (b) {
        var e = b.editor;
        e.on('insertElement', function (a) {
          a = a.data;
          a.type == CKEDITOR.NODE_ELEMENT &&
            (a.is('input') || a.is('textarea')) &&
            ('false' != a.getAttribute('contentEditable') && a.data('cke-editable', a.hasAttribute('contenteditable') ? 'true' : '1'),
            a.setAttribute('contentEditable', !1));
        });
        e.on('selectionChange', function (b) {
          if (!e.readOnly) {
            var d = e.getSelection();
            d && !d.isLocked && ((d = e.checkDirty()), e.fire('lockSnapshot'), a(b), e.fire('unlockSnapshot'), !d && e.resetDirty());
          }
        });
      });
      CKEDITOR.on('instanceCreated', function (a) {
        var b = a.editor;
        b.on('mode', function () {
          var a = b.editable();
          if (a && a.isInline()) {
            var e = b.title;
            a.changeAttr('role', 'textbox');
            a.changeAttr('aria-multiline', 'true');
            e && a.changeAttr('aria-label', e);
            e && a.changeAttr('title', e);
            var d = b.fire('ariaEditorHelpLabel', {}).label;
            if (d && (e = this.ui.space(this.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? 'top' : 'contents'))) {
              var c = CKEDITOR.tools.getNextId(),
                d = CKEDITOR.dom.element.createFromHtml('\x3cspan id\x3d"' + c + '" class\x3d"cke_voice_label"\x3e' + d + '\x3c/span\x3e');
              e.append(d);
              a.changeAttr('aria-describedby', c);
            }
          }
        });
      });
      CKEDITOR.addCss('.cke_editable{cursor:text}.cke_editable img,.cke_editable input,.cke_editable textarea{cursor:default}');
      x = CKEDITOR.dom.walker.whitespaces(!0);
      u = CKEDITOR.dom.walker.bookmark(!1, !0);
      p = CKEDITOR.dom.walker.empty();
      t = CKEDITOR.dom.walker.bogus();
      A =
        /(^|<body\b[^>]*>)\s*<(p|div|address|h\d|center|pre)[^>]*>\s*(?:<br[^>]*>|&nbsp;|\u00A0|&#160;)?\s*(:?<\/\2>)?\s*(?=$|<\/body>)/gi;
      q = (function () {
        function a(b) {
          return b.type == CKEDITOR.NODE_ELEMENT;
        }
        function c(b, e) {
          var d,
            g,
            f,
            k,
            h = [],
            l = e.range.startContainer;
          d = e.range.startPath();
          for (
            var l = n[l.getName()], m = 0, r = b.getChildren(), M = r.count(), t = -1, q = -1, x = 0, v = d.contains(n.$list);
            m < M;
            ++m
          )
            (d = r.getItem(m)),
              a(d)
                ? ((f = d.getName()),
                  v && f in CKEDITOR.dtd.$list
                    ? (h = h.concat(c(d, e)))
                    : ((k = !!l[f]),
                      'br' != f ||
                        !d.data('cke-eol') ||
                        (m && m != M - 1) ||
                        ((x = (g = m ? h[m - 1].node : r.getItem(m + 1)) && (!a(g) || !g.is('br'))),
                        (g = g && a(g) && n.$block[g.getName()])),
                      -1 != t || k || (t = m),
                      k || (q = m),
                      h.push({
                        isElement: 1,
                        isLineBreak: x,
                        isBlock: d.isBlockBoundary(),
                        hasBlockSibling: g,
                        node: d,
                        name: f,
                        allowed: k,
                      }),
                      (g = x = 0)))
                : h.push({ isElement: 0, node: d, allowed: 1 });
          -1 < t && (h[t].firstNotAllowed = 1);
          -1 < q && (h[q].lastNotAllowed = 1);
          return h;
        }
        function f(b, e) {
          var d = [],
            c = b.getChildren(),
            g = c.count(),
            k,
            h = 0,
            l = n[e],
            m = !b.is(n.$inline) || b.is('br');
          for (m && d.push(' '); h < g; h++) (k = c.getItem(h)), a(k) && !k.is(l) ? (d = d.concat(f(k, e))) : d.push(k);
          m && d.push(' ');
          return d;
        }
        function k(b) {
          return a(b.startContainer) && b.startContainer.getChild(b.startOffset - 1);
        }
        function h(b) {
          return b && a(b) && (b.is(n.$removeEmpty) || (b.is('a') && !b.isBlockBoundary()));
        }
        function l(b, e, d, c) {
          var g = b.clone(),
            f,
            k;
          g.setEndAt(e, CKEDITOR.POSITION_BEFORE_END);
          (f = new CKEDITOR.dom.walker(g).next()) &&
            a(f) &&
            r[f.getName()] &&
            (k = f.getPrevious()) &&
            a(k) &&
            !k.getParent().equals(b.startContainer) &&
            d.contains(k) &&
            c.contains(f) &&
            f.isIdentical(k) &&
            (f.moveChildren(k), f.remove(), l(b, e, d, c));
        }
        function m(b, e) {
          function d(b, e) {
            if (e.isBlock && e.isElement && !e.node.is('br') && a(b) && b.is('br')) return b.remove(), 1;
          }
          var c = e.endContainer.getChild(e.endOffset),
            g = e.endContainer.getChild(e.endOffset - 1);
          c && d(c, b[b.length - 1]);
          g && d(g, b[0]) && (e.setEnd(e.endContainer, e.endOffset - 1), e.collapse());
        }
        var n = CKEDITOR.dtd,
          r = { p: 1, div: 1, h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1, ul: 1, ol: 1, li: 1, pre: 1, dl: 1, blockquote: 1 },
          t = { p: 1, div: 1, h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1 },
          M = CKEDITOR.tools.extend({}, n.$inline);
        delete M.br;
        return function (r, q, x, v) {
          var u = r.editor,
            p = !1,
            z;
          'unfiltered_html' == q && ((q = 'html'), (p = !0));
          if (!v.checkReadOnly()) {
            var y = new CKEDITOR.dom.elementPath(v.startContainer, v.root).blockLimit || v.root;
            q = { type: q, dontFilter: p, editable: r, editor: u, range: v, blockLimit: y, mergeCandidates: [], zombies: [] };
            var p = q.range,
              y = q.mergeCandidates,
              B = 'html' === q.type,
              E,
              C,
              w,
              Z,
              aa;
            'text' == q.type &&
              p.shrink(CKEDITOR.SHRINK_ELEMENT, !0, !1) &&
              ((C = CKEDITOR.dom.element.createFromHtml('\x3cspan\x3e\x26nbsp;\x3c/span\x3e', p.document)),
              p.insertNode(C),
              p.setStartAfter(C));
            w = new CKEDITOR.dom.elementPath(p.startContainer);
            q.endPath = Z = new CKEDITOR.dom.elementPath(p.endContainer);
            if (!p.collapsed) {
              E = Z.block || Z.blockLimit;
              var ca = p.getCommonAncestor();
              E && !E.equals(ca) && !E.contains(ca) && p.checkEndOfBlock() && q.zombies.push(E);
              p.deleteContents();
            }
            for (; (aa = k(p)) && a(aa) && aa.isBlockBoundary() && w.contains(aa); ) p.moveToPosition(aa, CKEDITOR.POSITION_BEFORE_END);
            l(p, q.blockLimit, w, Z);
            C && (p.setEndBefore(C), p.collapse(), C.remove());
            C = p.startPath();
            if ((E = C.contains(h, !1, 1))) (z = p.splitElement(E)), (q.inlineStylesRoot = E), (q.inlineStylesPeak = C.lastElement);
            C = p.createBookmark();
            B && (e(E), e(z));
            (E = C.startNode.getPrevious(b)) && a(E) && h(E) && y.push(E);
            (E = C.startNode.getNext(b)) && a(E) && h(E) && y.push(E);
            for (E = C.startNode; (E = E.getParent()) && h(E); ) y.push(E);
            p.moveToBookmark(C);
            z = r.getHtml();
            z = '' === z || z.match(A);
            u.enterMode === CKEDITOR.ENTER_DIV &&
              z &&
              ((u = r.getFirst()) && u.remove(), v.setStartAt(r, CKEDITOR.POSITION_AFTER_START), v.collapse(!0));
            if ((r = x)) {
              r = q.range;
              if ('text' == q.type && q.inlineStylesRoot) {
                v = q.inlineStylesPeak;
                u = v.getDocument().createText('{cke-peak}');
                for (z = q.inlineStylesRoot.getParent(); !v.equals(z); ) (u = u.appendTo(v.clone())), (v = v.getParent());
                x = u.getOuterHtml().split('{cke-peak}').join(x);
              }
              v = q.blockLimit.getName();
              if (/^\s+|\s+$/.test(x) && 'span' in CKEDITOR.dtd[v]) {
                var V = '\x3cspan data-cke-marker\x3d"1"\x3e\x26nbsp;\x3c/span\x3e';
                x = V + x + V;
              }
              x = q.editor.dataProcessor.toHtml(x, {
                context: null,
                fixForBody: !1,
                protectedWhitespaces: !!V,
                dontFilter: q.dontFilter,
                filter: q.editor.activeFilter,
                enterMode: q.editor.activeEnterMode,
              });
              v = r.document.createElement('body');
              v.setHtml(x);
              V && (v.getFirst().remove(), v.getLast().remove());
              if ((V = r.startPath().block) && (1 != V.getChildCount() || !V.getBogus()))
                a: {
                  var Q;
                  if (1 == v.getChildCount() && a((Q = v.getFirst())) && Q.is(t) && !Q.hasAttribute('contenteditable')) {
                    V = Q.getElementsByTag('*');
                    r = 0;
                    for (z = V.count(); r < z; r++) if (((u = V.getItem(r)), !u.is(M))) break a;
                    Q.moveChildren(Q.getParent(1));
                    Q.remove();
                  }
                }
              q.dataWrapper = v;
              r = x;
            }
            if (r) {
              Q = q.range;
              r = Q.document;
              v = q.blockLimit;
              z = 0;
              var J,
                V = [],
                ea,
                R;
              x = C = 0;
              var ba,
                u = Q.startContainer;
              aa = q.endPath.elements[0];
              var W,
                p = aa.getPosition(u),
                y =
                  !!aa.getCommonAncestor(u) &&
                  p != CKEDITOR.POSITION_IDENTICAL &&
                  !(p & (CKEDITOR.POSITION_CONTAINS + CKEDITOR.POSITION_IS_CONTAINED)),
                u = c(q.dataWrapper, q);
              for (q.editor.enterMode !== CKEDITOR.ENTER_BR && m(u, Q); z < u.length; z++) {
                p = u[z];
                if ((B = p.isLineBreak))
                  (B = Q),
                    (E = v),
                    (Z = w = void 0),
                    p.hasBlockSibling
                      ? (B = 1)
                      : (w = B.startContainer.getAscendant(n.$block, 1)) && w.is({ div: 1, p: 1 })
                        ? ((Z = w.getPosition(E)),
                          Z == CKEDITOR.POSITION_IDENTICAL || Z == CKEDITOR.POSITION_CONTAINS
                            ? (B = 0)
                            : ((E = B.splitElement(w)), B.moveToPosition(E, CKEDITOR.POSITION_AFTER_START), (B = 1)))
                        : (B = 0);
                if (B) x = 0 < z;
                else {
                  B = Q.startPath();
                  !p.isBlock &&
                    g(q.editor, B.block, B.blockLimit) &&
                    (R = d(q.editor)) &&
                    ((R = r.createElement(R)),
                    R.appendBogus(),
                    Q.insertNode(R),
                    CKEDITOR.env.needsBrFiller && (J = R.getBogus()) && J.remove(),
                    Q.moveToPosition(R, CKEDITOR.POSITION_BEFORE_END));
                  if ((B = Q.startPath().block) && !B.equals(ea)) {
                    if ((J = B.getBogus())) J.remove(), V.push(B);
                    ea = B;
                  }
                  p.firstNotAllowed && (C = 1);
                  if (C && p.isElement) {
                    B = Q.startContainer;
                    for (E = null; B && !n[B.getName()][p.name]; ) {
                      if (B.equals(v)) {
                        B = null;
                        break;
                      }
                      E = B;
                      B = B.getParent();
                    }
                    if (B) E && ((ba = Q.splitElement(E)), q.zombies.push(ba), q.zombies.push(E));
                    else {
                      E = v.getName();
                      W = !z;
                      B = z == u.length - 1;
                      E = f(p.node, E);
                      w = [];
                      Z = E.length;
                      for (var ca = 0, la = void 0, ma = 0, na = -1; ca < Z; ca++)
                        (la = E[ca]),
                          ' ' == la
                            ? (ma || (W && !ca) || (w.push(new CKEDITOR.dom.text(' ')), (na = w.length)), (ma = 1))
                            : (w.push(la), (ma = 0));
                      B && na == w.length && w.pop();
                      W = w;
                    }
                  }
                  if (W) {
                    for (; (B = W.pop()); ) Q.insertNode(B);
                    W = 0;
                  } else Q.insertNode(p.node);
                  p.lastNotAllowed && z < u.length - 1 && ((ba = y ? aa : ba) && Q.setEndAt(ba, CKEDITOR.POSITION_AFTER_START), (C = 0));
                  Q.collapse();
                }
              }
              1 != u.length ? (J = !1) : ((J = u[0]), (J = J.isElement && 'false' == J.node.getAttribute('contenteditable')));
              J && ((x = !0), (B = u[0].node), Q.setStartAt(B, CKEDITOR.POSITION_BEFORE_START), Q.setEndAt(B, CKEDITOR.POSITION_AFTER_END));
              q.dontMoveCaret = x;
              q.bogusNeededBlocks = V;
            }
            J = q.range;
            var ga;
            W = q.bogusNeededBlocks;
            for (ea = J.createBookmark(); (R = q.zombies.pop()); )
              R.getParent() && ((ba = J.clone()), ba.moveToElementEditStart(R), ba.removeEmptyBlocksAtEnd());
            if (W) for (; (R = W.pop()); ) CKEDITOR.env.needsBrFiller ? R.appendBogus() : R.append(J.document.createText(' '));
            for (; (R = q.mergeCandidates.pop()); ) R.mergeSiblings();
            CKEDITOR.env.webkit &&
              J.startPath() &&
              ((R = J.startPath()), R.block ? R.block.$.normalize() : R.blockLimit && R.blockLimit.$.normalize());
            J.moveToBookmark(ea);
            if (!q.dontMoveCaret) {
              for (R = k(J); R && a(R) && !R.is(n.$empty); ) {
                if (R.isBlockBoundary()) J.moveToPosition(R, CKEDITOR.POSITION_BEFORE_END);
                else {
                  if (h(R) && R.getHtml().match(/(\s|&nbsp;)$/g)) {
                    ga = null;
                    break;
                  }
                  ga = J.clone();
                  ga.moveToPosition(R, CKEDITOR.POSITION_BEFORE_END);
                }
                R = R.getLast(b);
              }
              ga && J.moveToRange(ga);
            }
          }
        };
      })();
      B = (function () {
        function a(b) {
          b = new CKEDITOR.dom.walker(b);
          b.guard = function (a, b) {
            if (b) return !1;
            if (a.type == CKEDITOR.NODE_ELEMENT) return a.is(CKEDITOR.dtd.$tableContent);
          };
          b.evaluator = function (a) {
            return a.type == CKEDITOR.NODE_ELEMENT;
          };
          return b;
        }
        function b(a, e, d) {
          e = a.getDocument().createElement(e);
          a.append(e, d);
          return e;
        }
        function e(a) {
          var b = a.count(),
            d;
          for (b; 0 < b--; )
            (d = a.getItem(b)),
              CKEDITOR.tools.trim(d.getHtml()) ||
                (d.appendBogus(), CKEDITOR.env.ie && 9 > CKEDITOR.env.version && d.getChildCount() && d.getFirst().remove());
        }
        return function (d) {
          var c = d.startContainer,
            g = c.getAscendant('table', 1),
            f = !1;
          e(g.getElementsByTag('td'));
          e(g.getElementsByTag('th'));
          g = d.clone();
          g.setStart(c, 0);
          g = a(g).lastBackward();
          g || ((g = d.clone()), g.setEndAt(c, CKEDITOR.POSITION_BEFORE_END), (g = a(g).lastForward()), (f = !0));
          g || (g = c);
          g.is('table')
            ? (d.setStartAt(g, CKEDITOR.POSITION_BEFORE_START), d.collapse(!0), g.remove())
            : (g.is({ tbody: 1, thead: 1, tfoot: 1 }) && (g = b(g, 'tr', f)),
              g.is('tr') && (g = b(g, g.getParent().is('thead') ? 'th' : 'td', f)),
              (c = g.getBogus()) && c.remove(),
              d.moveToPosition(g, f ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_BEFORE_END));
        };
      })();
      z = (function () {
        function a(b) {
          b = new CKEDITOR.dom.walker(b);
          b.guard = function (a, b) {
            if (b) return !1;
            if (a.type == CKEDITOR.NODE_ELEMENT) return a.is(CKEDITOR.dtd.$list) || a.is(CKEDITOR.dtd.$listItem);
          };
          b.evaluator = function (a) {
            return a.type == CKEDITOR.NODE_ELEMENT && a.is(CKEDITOR.dtd.$listItem);
          };
          return b;
        }
        return function (b) {
          var e = b.startContainer,
            d = !1,
            c;
          c = b.clone();
          c.setStart(e, 0);
          c = a(c).lastBackward();
          c || ((c = b.clone()), c.setEndAt(e, CKEDITOR.POSITION_BEFORE_END), (c = a(c).lastForward()), (d = !0));
          c || (c = e);
          c.is(CKEDITOR.dtd.$list)
            ? (b.setStartAt(c, CKEDITOR.POSITION_BEFORE_START), b.collapse(!0), c.remove())
            : ((e = c.getBogus()) && e.remove(),
              b.moveToPosition(c, d ? CKEDITOR.POSITION_AFTER_START : CKEDITOR.POSITION_BEFORE_END),
              b.select());
        };
      })();
      y = {
        eol: {
          detect: function (a, b) {
            var e = a.range,
              d = e.clone(),
              c = e.clone(),
              g = new CKEDITOR.dom.elementPath(e.startContainer, b),
              f = new CKEDITOR.dom.elementPath(e.endContainer, b);
            d.collapse(1);
            c.collapse();
            g.block && d.checkBoundaryOfElement(g.block, CKEDITOR.END) && (e.setStartAfter(g.block), (a.prependEolBr = 1));
            f.block && c.checkBoundaryOfElement(f.block, CKEDITOR.START) && (e.setEndBefore(f.block), (a.appendEolBr = 1));
          },
          fix: function (a, b) {
            var e = b.getDocument(),
              d;
            a.appendEolBr && ((d = this.createEolBr(e)), a.fragment.append(d));
            !a.prependEolBr || (d && !d.getPrevious()) || a.fragment.append(this.createEolBr(e), 1);
          },
          createEolBr: function (a) {
            return a.createElement('br', { attributes: { 'data-cke-eol': 1 } });
          },
        },
        bogus: {
          exclude: function (a) {
            var b = a.range.getBoundaryNodes(),
              e = b.startNode,
              b = b.endNode;
            !b || !t(b) || (e && e.equals(b)) || a.range.setEndBefore(b);
          },
        },
        tree: {
          rebuild: function (a, b) {
            var e = a.range,
              d = e.getCommonAncestor(),
              c = new CKEDITOR.dom.elementPath(d, b),
              g = new CKEDITOR.dom.elementPath(e.startContainer, b),
              e = new CKEDITOR.dom.elementPath(e.endContainer, b),
              f;
            d.type == CKEDITOR.NODE_TEXT && (d = d.getParent());
            if (c.blockLimit.is({ tr: 1, table: 1 })) {
              var k = c.contains('table').getParent();
              f = function (a) {
                return !a.equals(k);
              };
            } else if (
              c.block &&
              c.block.is(CKEDITOR.dtd.$listItem) &&
              ((g = g.contains(CKEDITOR.dtd.$list)), (e = e.contains(CKEDITOR.dtd.$list)), !g.equals(e))
            ) {
              var h = c.contains(CKEDITOR.dtd.$list).getParent();
              f = function (a) {
                return !a.equals(h);
              };
            }
            f ||
              (f = function (a) {
                return !a.equals(c.block) && !a.equals(c.blockLimit);
              });
            this.rebuildFragment(a, b, d, f);
          },
          rebuildFragment: function (a, b, e, d) {
            for (var c; e && !e.equals(b) && d(e); ) (c = e.clone(0, 1)), a.fragment.appendTo(c), (a.fragment = c), (e = e.getParent());
          },
        },
        cell: {
          shrink: function (a) {
            a = a.range;
            var b = a.startContainer,
              e = a.endContainer,
              d = a.startOffset,
              c = a.endOffset;
            b.type == CKEDITOR.NODE_ELEMENT && b.equals(e) && b.is('tr') && ++d == c && a.shrink(CKEDITOR.SHRINK_TEXT);
          },
        },
      };
      v = (function () {
        function a(b, e) {
          var d = b.getParent();
          if (d.is(CKEDITOR.dtd.$inline)) b[e ? 'insertBefore' : 'insertAfter'](d);
        }
        function b(e, d, c) {
          a(d);
          a(c, 1);
          for (var g; (g = c.getNext()); ) g.insertAfter(d), (d = g);
          p(e) && e.remove();
        }
        function e(a, b) {
          var d = new CKEDITOR.dom.range(a);
          d.setStartAfter(b.startNode);
          d.setEndBefore(b.endNode);
          return d;
        }
        return {
          list: {
            detectMerge: function (a, b) {
              var d = e(b, a.bookmark),
                c = d.startPath(),
                g = d.endPath(),
                f = c.contains(CKEDITOR.dtd.$list),
                k = g.contains(CKEDITOR.dtd.$list);
              a.mergeList = f && k && f.getParent().equals(k.getParent()) && !f.equals(k);
              a.mergeListItems = c.block && g.block && c.block.is(CKEDITOR.dtd.$listItem) && g.block.is(CKEDITOR.dtd.$listItem);
              if (a.mergeList || a.mergeListItems)
                (d = d.clone()),
                  d.setStartBefore(a.bookmark.startNode),
                  d.setEndAfter(a.bookmark.endNode),
                  (a.mergeListBookmark = d.createBookmark());
            },
            merge: function (a, e) {
              if (a.mergeListBookmark) {
                var d = a.mergeListBookmark.startNode,
                  c = a.mergeListBookmark.endNode,
                  g = new CKEDITOR.dom.elementPath(d, e),
                  f = new CKEDITOR.dom.elementPath(c, e);
                if (a.mergeList) {
                  var k = g.contains(CKEDITOR.dtd.$list),
                    h = f.contains(CKEDITOR.dtd.$list);
                  k.equals(h) || (h.moveChildren(k), h.remove());
                }
                a.mergeListItems &&
                  ((g = g.contains(CKEDITOR.dtd.$listItem)), (f = f.contains(CKEDITOR.dtd.$listItem)), g.equals(f) || b(f, d, c));
                d.remove();
                c.remove();
              }
            },
          },
          block: {
            detectMerge: function (a, b) {
              if (!a.tableContentsRanges && !a.mergeListBookmark) {
                var e = new CKEDITOR.dom.range(b);
                e.setStartBefore(a.bookmark.startNode);
                e.setEndAfter(a.bookmark.endNode);
                a.mergeBlockBookmark = e.createBookmark();
              }
            },
            merge: function (a, e) {
              if (a.mergeBlockBookmark && !a.purgeTableBookmark) {
                var d = a.mergeBlockBookmark.startNode,
                  c = a.mergeBlockBookmark.endNode,
                  g = new CKEDITOR.dom.elementPath(d, e),
                  f = new CKEDITOR.dom.elementPath(c, e),
                  g = g.block,
                  f = f.block;
                g && f && !g.equals(f) && b(f, d, c);
                d.remove();
                c.remove();
              }
            },
          },
          table: (function () {
            function a(e) {
              var c = [],
                g,
                f = new CKEDITOR.dom.walker(e),
                k = e.startPath().contains(d),
                h = e.endPath().contains(d),
                l = {};
              f.guard = function (a, f) {
                if (a.type == CKEDITOR.NODE_ELEMENT) {
                  var m = 'visited_' + (f ? 'out' : 'in');
                  if (a.getCustomData(m)) return;
                  CKEDITOR.dom.element.setMarker(l, a, m, 1);
                }
                if (f && k && a.equals(k)) (g = e.clone()), g.setEndAt(k, CKEDITOR.POSITION_BEFORE_END), c.push(g);
                else if (!f && h && a.equals(h)) (g = e.clone()), g.setStartAt(h, CKEDITOR.POSITION_AFTER_START), c.push(g);
                else {
                  if ((m = !f)) m = a.type == CKEDITOR.NODE_ELEMENT && a.is(d) && (!k || b(a, k)) && (!h || b(a, h));
                  if (!m && (m = f))
                    if (a.is(d))
                      var m = k && k.getAscendant('table', !0),
                        n = h && h.getAscendant('table', !0),
                        r = a.getAscendant('table', !0),
                        m = (m && m.contains(r)) || (n && n.contains(r));
                    else m = void 0;
                  m && ((g = e.clone()), g.selectNodeContents(a), c.push(g));
                }
              };
              f.lastForward();
              CKEDITOR.dom.element.clearAllMarkers(l);
              return c;
            }
            function b(a, e) {
              var d = CKEDITOR.POSITION_CONTAINS + CKEDITOR.POSITION_IS_CONTAINED,
                c = a.getPosition(e);
              return c === CKEDITOR.POSITION_IDENTICAL ? !1 : 0 === (c & d);
            }
            var d = { td: 1, th: 1, caption: 1 };
            return {
              detectPurge: function (a) {
                var b = a.range,
                  e = b.clone();
                e.enlarge(CKEDITOR.ENLARGE_ELEMENT);
                var e = new CKEDITOR.dom.walker(e),
                  c = 0;
                e.evaluator = function (a) {
                  a.type == CKEDITOR.NODE_ELEMENT && a.is(d) && ++c;
                };
                e.checkForward();
                if (1 < c) {
                  var e = b.startPath().contains('table'),
                    g = b.endPath().contains('table');
                  e &&
                    g &&
                    b.checkBoundaryOfElement(e, CKEDITOR.START) &&
                    b.checkBoundaryOfElement(g, CKEDITOR.END) &&
                    ((b = a.range.clone()), b.setStartBefore(e), b.setEndAfter(g), (a.purgeTableBookmark = b.createBookmark()));
                }
              },
              detectRanges: function (c, g) {
                var f = e(g, c.bookmark),
                  k = f.clone(),
                  h,
                  l,
                  m = f.getCommonAncestor();
                m.is(CKEDITOR.dtd.$tableContent) && !m.is(d) && (m = m.getAscendant('table', !0));
                l = m;
                m = new CKEDITOR.dom.elementPath(f.startContainer, l);
                l = new CKEDITOR.dom.elementPath(f.endContainer, l);
                m = m.contains('table');
                l = l.contains('table');
                if (m || l)
                  m && l && b(m, l)
                    ? ((c.tableSurroundingRange = k),
                      k.setStartAt(m, CKEDITOR.POSITION_AFTER_END),
                      k.setEndAt(l, CKEDITOR.POSITION_BEFORE_START),
                      (k = f.clone()),
                      k.setEndAt(m, CKEDITOR.POSITION_AFTER_END),
                      (h = f.clone()),
                      h.setStartAt(l, CKEDITOR.POSITION_BEFORE_START),
                      (h = a(k).concat(a(h))))
                    : m
                      ? l ||
                        ((c.tableSurroundingRange = k),
                        k.setStartAt(m, CKEDITOR.POSITION_AFTER_END),
                        f.setEndAt(m, CKEDITOR.POSITION_AFTER_END))
                      : ((c.tableSurroundingRange = k),
                        k.setEndAt(l, CKEDITOR.POSITION_BEFORE_START),
                        f.setStartAt(l, CKEDITOR.POSITION_AFTER_START)),
                    (c.tableContentsRanges = h ? h : a(f));
              },
              deleteRanges: function (a) {
                for (var b; (b = a.tableContentsRanges.pop()); ) b.extractContents(), p(b.startContainer) && b.startContainer.appendBogus();
                a.tableSurroundingRange && a.tableSurroundingRange.extractContents();
              },
              purge: function (a) {
                if (a.purgeTableBookmark) {
                  var b = a.doc,
                    e = a.range.clone(),
                    b = b.createElement('p');
                  b.insertBefore(a.purgeTableBookmark.startNode);
                  e.moveToBookmark(a.purgeTableBookmark);
                  e.deleteContents();
                  a.range.moveToPosition(b, CKEDITOR.POSITION_AFTER_START);
                }
              },
            };
          })(),
          detectExtractMerge: function (a) {
            return !(a.range.startPath().contains(CKEDITOR.dtd.$listItem) && a.range.endPath().contains(CKEDITOR.dtd.$listItem));
          },
          fixUneditableRangePosition: function (a) {
            a.startContainer.getDtd()['#'] || a.moveToClosestEditablePosition(null, !0);
          },
          autoParagraph: function (a, b) {
            var e = b.startPath(),
              c;
            g(a, e.block, e.blockLimit) &&
              (c = d(a)) &&
              ((c = b.document.createElement(c)), c.appendBogus(), b.insertNode(c), b.moveToPosition(c, CKEDITOR.POSITION_AFTER_START));
          },
        };
      })();
    })();
    (function () {
      function a(a) {
        return CKEDITOR.plugins.widget && CKEDITOR.plugins.widget.isDomWidget(a);
      }
      function h(b, e) {
        if (0 === b.length || a(b[0].getEnclosedNode())) return !1;
        var d, c;
        if ((d = !e && 1 === b.length) && !(d = b[0].collapsed)) {
          var g = b[0];
          d = g.startContainer.getAscendant({ td: 1, th: 1 }, !0);
          var f = g.endContainer.getAscendant({ td: 1, th: 1 }, !0);
          c = CKEDITOR.tools.trim;
          d && d.equals(f) && !d.findOne('td, th, tr, tbody, table')
            ? ((g = g.cloneContents()), (d = g.getFirst() ? c(g.getFirst().getText()) !== c(d.getText()) : !0))
            : (d = !1);
        }
        if (d) return !1;
        for (c = 0; c < b.length; c++) if (((d = b[c]._getTableElement()), !d)) return !1;
        return !0;
      }
      function f(a) {
        function b(a) {
          a = a.find('td, th');
          var e = [],
            d;
          for (d = 0; d < a.count(); d++) e.push(a.getItem(d));
          return e;
        }
        var e = [],
          d,
          c;
        for (c = 0; c < a.length; c++) (d = a[c]._getTableElement()), d.is && d.is({ td: 1, th: 1 }) ? e.push(d) : (e = e.concat(b(d)));
        return e;
      }
      function b(a) {
        a = f(a);
        var b = '',
          e = [],
          d,
          c;
        for (c = 0; c < a.length; c++)
          d && !d.equals(a[c].getAscendant('tr'))
            ? ((b += e.join('\t') + '\n'), (d = a[c].getAscendant('tr')), (e = []))
            : 0 === c && (d = a[c].getAscendant('tr')),
            e.push(a[c].getText());
        return (b += e.join('\t'));
      }
      function c(a) {
        var e = this.root.editor,
          d = e.getSelection(1);
        this.reset();
        z = !0;
        d.root.once(
          'selectionchange',
          function (a) {
            a.cancel();
          },
          null,
          null,
          0,
        );
        d.selectRanges([a[0]]);
        d = this._.cache;
        d.ranges = new CKEDITOR.dom.rangeList(a);
        d.type = CKEDITOR.SELECTION_TEXT;
        d.selectedElement = a[0]._getTableElement();
        d.selectedText = b(a);
        d.nativeSel = null;
        this.isFake = 1;
        this.rev = A++;
        e._.fakeSelection = this;
        z = !1;
        this.root.fire('selectionchange');
      }
      function l() {
        var b = this._.fakeSelection,
          e;
        if (b) {
          e = this.getSelection(1);
          var d;
          if (!(d = !e) && (d = !e.isHidden())) {
            d = b;
            var c = e.getRanges(),
              g = d.getRanges(),
              f = c.length && c[0]._getTableElement() && c[0]._getTableElement().getAscendant('table', !0),
              k = g.length && g[0]._getTableElement() && g[0]._getTableElement().getAscendant('table', !0),
              l = 1 === c.length && c[0]._getTableElement() && c[0]._getTableElement().is('table'),
              m = 1 === g.length && g[0]._getTableElement() && g[0]._getTableElement().is('table');
            if (a(d.getSelectedElement())) d = !1;
            else {
              var n = 1 === c.length && c[0].collapsed,
                g = h(c, !!CKEDITOR.env.webkit) && h(g);
              f = f && k ? f.equals(k) || k.contains(f) : !1;
              f && (n || g) ? (l && !m && d.selectRanges(c), (d = !0)) : (d = !1);
            }
            d = !d;
          }
          d && (b.reset(), (b = 0));
        }
        if (!b && ((b = e || this.getSelection(1)), !b || b.getType() == CKEDITOR.SELECTION_NONE)) return;
        this.fire('selectionCheck', b);
        e = this.elementPath();
        e.compare(this._.selectionPreviousPath) ||
          ((d = this._.selectionPreviousPath && this._.selectionPreviousPath.blockLimit.equals(e.blockLimit)),
          (!CKEDITOR.env.webkit && !CKEDITOR.env.gecko) || d || (this._.previousActive = this.document.getActive()),
          (this._.selectionPreviousPath = e),
          this.fire('selectionChange', { selection: b, path: e }));
      }
      function k() {
        v = !0;
        y || (m.call(this), (y = CKEDITOR.tools.setTimeout(m, 200, this)));
      }
      function m() {
        y = null;
        v && (CKEDITOR.tools.setTimeout(l, 0, this), (v = !1));
      }
      function g(a) {
        return C(a) || (a.type == CKEDITOR.NODE_ELEMENT && !a.is(CKEDITOR.dtd.$empty)) ? !0 : !1;
      }
      function d(a) {
        function b(e, d) {
          return e && e.type != CKEDITOR.NODE_TEXT ? a.clone()['moveToElementEdit' + (d ? 'End' : 'Start')](e) : !1;
        }
        if (!(a.root instanceof CKEDITOR.editable)) return !1;
        var e = a.startContainer,
          d = a.getPreviousNode(g, null, e),
          c = a.getNextNode(g, null, e);
        return b(d) || b(c, 1) || !(d || c || (e.type == CKEDITOR.NODE_ELEMENT && e.isBlockBoundary() && e.getBogus())) ? !0 : !1;
      }
      function e(a) {
        n(a, !1);
        var b = a.getDocument().createText(q);
        a.setCustomData('cke-fillingChar', b);
        return b;
      }
      function n(a, b) {
        var e = a && a.removeCustomData('cke-fillingChar');
        if (e) {
          if (!1 !== b) {
            var d = a.getDocument().getSelection().getNative(),
              c = d && 'None' != d.type && d.getRangeAt(0),
              g = q.length;
            if (e.getLength() > g && c && c.intersectsNode(e.$)) {
              var f = [
                { node: d.anchorNode, offset: d.anchorOffset },
                { node: d.focusNode, offset: d.focusOffset },
              ];
              d.anchorNode == e.$ && d.anchorOffset > g && (f[0].offset -= g);
              d.focusNode == e.$ && d.focusOffset > g && (f[1].offset -= g);
            }
          }
          e.setText(r(e.getText(), 1));
          f &&
            ((e = a.getDocument().$),
            (d = e.getSelection()),
            (e = e.createRange()),
            e.setStart(f[0].node, f[0].offset),
            e.collapse(!0),
            d.removeAllRanges(),
            d.addRange(e),
            d.extend(f[1].node, f[1].offset));
        }
      }
      function r(a, b) {
        return b
          ? a.replace(B, function (a, b) {
              return b ? ' ' : '';
            })
          : a.replace(q, '');
      }
      function x(a, b) {
        var e = (b && CKEDITOR.tools.htmlEncode(b)) || '\x26nbsp;',
          e = CKEDITOR.dom.element.createFromHtml(
            '\x3cdiv data-cke-hidden-sel\x3d"1" data-cke-temp\x3d"1" style\x3d"' +
              (CKEDITOR.env.ie && 14 > CKEDITOR.env.version
                ? 'display:none'
                : 'position:fixed;top:0;left:-1000px;width:0;height:0;overflow:hidden;') +
              '"\x3e' +
              e +
              '\x3c/div\x3e',
            a.document,
          );
        a.fire('lockSnapshot');
        a.editable().append(e);
        var d = a.getSelection(1),
          c = a.createRange(),
          g = d.root.on(
            'selectionchange',
            function (a) {
              a.cancel();
            },
            null,
            null,
            0,
          );
        c.setStartAt(e, CKEDITOR.POSITION_AFTER_START);
        c.setEndAt(e, CKEDITOR.POSITION_BEFORE_END);
        d.selectRanges([c]);
        g.removeListener();
        a.fire('unlockSnapshot');
        a._.hiddenSelectionContainer = e;
      }
      function u(b) {
        var e = { 37: 1, 39: 1, 8: 1, 46: 1 };
        return function (d) {
          var c = d.data.getKeystroke();
          if (e[c]) {
            var g = b.getSelection(),
              f = g.getRanges()[0];
            g.isCollapsed() &&
              (f = f[38 > c ? 'getPreviousEditableNode' : 'getNextEditableNode']()) &&
              f.type == CKEDITOR.NODE_ELEMENT &&
              'false' == f.getAttribute('contenteditable') &&
              ((g = g.getStartElement()),
              !g.isBlockBoundary() ||
                '' !== (void 0 === g.$.textContent ? g.$.innerText : g.$.textContent) ||
                a(g.getFirst()) ||
                (8 !== c && 46 !== c) ||
                (g.remove(), b.fire('saveSnapshot')),
              b.getSelection().fake(f),
              d.data.preventDefault(),
              d.cancel());
          }
        };
      }
      function p(a) {
        for (var b = 0; b < a.length; b++) {
          var e = a[b];
          e.getCommonAncestor().isReadOnly() && a.splice(b, 1);
          if (!e.collapsed) {
            if (e.startContainer.isReadOnly())
              for (var d = e.startContainer, c; d && !(((c = d.type == CKEDITOR.NODE_ELEMENT) && d.is('body')) || !d.isReadOnly()); )
                c && 'false' == d.getAttribute('contentEditable') && e.setStartAfter(d), (d = d.getParent());
            d = e.startContainer;
            c = e.endContainer;
            var g = e.startOffset,
              f = e.endOffset,
              k = e.clone();
            d && d.type == CKEDITOR.NODE_TEXT && (g >= d.getLength() ? k.setStartAfter(d) : k.setStartBefore(d));
            c && c.type == CKEDITOR.NODE_TEXT && (f ? k.setEndAfter(c) : k.setEndBefore(c));
            d = new CKEDITOR.dom.walker(k);
            d.evaluator = function (d) {
              if (d.type == CKEDITOR.NODE_ELEMENT && d.isReadOnly()) {
                var c = e.clone();
                e.setEndBefore(d);
                e.collapsed && a.splice(b--, 1);
                d.getPosition(k.endContainer) & CKEDITOR.POSITION_CONTAINS || (c.setStartAfter(d), c.collapsed || a.splice(b + 1, 0, c));
                return !0;
              }
              return !1;
            };
            d.next();
          }
        }
        return a;
      }
      var t = 'function' != typeof window.getSelection,
        A = 1,
        q = CKEDITOR.tools.repeat('​', 7),
        B = new RegExp(q + '( )?', 'g'),
        z,
        y,
        v,
        C = CKEDITOR.dom.walker.invisible(1),
        F = (function () {
          function a(b) {
            return function (a) {
              var e = a.editor.createRange();
              e.moveToClosestEditablePosition(a.selected, b) && a.editor.getSelection().selectRanges([e]);
              return !1;
            };
          }
          function b(a) {
            return function (b) {
              var e = b.editor,
                d = e.createRange(),
                c;
              if (!e.readOnly)
                return (
                  (c = d.moveToClosestEditablePosition(b.selected, a)) || (c = d.moveToClosestEditablePosition(b.selected, !a)),
                  c && e.getSelection().selectRanges([d]),
                  e.fire('saveSnapshot'),
                  b.selected.remove(),
                  c || (d.moveToElementEditablePosition(e.editable()), e.getSelection().selectRanges([d])),
                  e.fire('saveSnapshot'),
                  !1
                );
            };
          }
          var e = a(),
            d = a(1);
          return { 37: e, 38: e, 39: d, 40: d, 8: b(), 46: b(1) };
        })();
      CKEDITOR.on('instanceCreated', function (a) {
        function b() {
          var a = e.getSelection();
          a && a.removeAllRanges();
        }
        var e = a.editor;
        e.on('contentDom', function () {
          function a() {
            x = new CKEDITOR.dom.selection(e.getSelection());
            x.lock();
          }
          function b() {
            f.removeListener('mouseup', b);
            r.removeListener('mouseup', b);
            var a = CKEDITOR.document.$.selection,
              e = a.createRange();
            'None' != a.type && e.parentElement() && e.parentElement().ownerDocument == g.$ && e.select();
          }
          function d(a) {
            var b, e;
            b = (b = this.document.getActive()) ? 'input' === b.getName() || 'textarea' === b.getName() : !1;
            b || ((b = this.getSelection(1)), (e = c(b)) && !e.equals(h) && (b.selectElement(e), a.data.preventDefault()));
          }
          function c(a) {
            a = a.getRanges()[0];
            return a
              ? (a = a.startContainer.getAscendant(function (a) {
                  return a.type == CKEDITOR.NODE_ELEMENT && a.hasAttribute('contenteditable');
                }, !0)) && 'false' === a.getAttribute('contenteditable')
                ? a
                : null
              : null;
          }
          var g = e.document,
            f = CKEDITOR.document,
            h = e.editable(),
            m = g.getBody(),
            r = g.getDocumentElement(),
            q = h.isInline(),
            v,
            x;
          CKEDITOR.env.gecko &&
            h.attachListener(
              h,
              'focus',
              function (a) {
                a.removeListener();
                0 !== v &&
                  (a = e.getSelection().getNative()) &&
                  a.isCollapsed &&
                  a.anchorNode == h.$ &&
                  ((a = e.createRange()), a.moveToElementEditStart(h), a.select());
              },
              null,
              null,
              -2,
            );
          h.attachListener(
            h,
            CKEDITOR.env.webkit || CKEDITOR.env.gecko ? 'focusin' : 'focus',
            function () {
              if (v && (CKEDITOR.env.webkit || CKEDITOR.env.gecko)) {
                v = e._.previousActive && e._.previousActive.equals(g.getActive());
                var a = null != e._.previousScrollTop && e._.previousScrollTop != h.$.scrollTop;
                CKEDITOR.env.webkit && v && a && (h.$.scrollTop = e._.previousScrollTop);
              }
              e.unlockSelection(v);
              v = 0;
            },
            null,
            null,
            -1,
          );
          h.attachListener(h, 'mousedown', function () {
            v = 0;
          });
          if (CKEDITOR.env.ie || CKEDITOR.env.gecko || q)
            t ? h.attachListener(h, 'beforedeactivate', a, null, null, -1) : h.attachListener(e, 'selectionCheck', a, null, null, -1),
              h.attachListener(
                h,
                CKEDITOR.env.webkit || CKEDITOR.env.gecko ? 'focusout' : 'blur',
                function () {
                  var a = x && (x.isFake || 2 > x.getRanges().length);
                  (CKEDITOR.env.gecko && !q && a) || (e.lockSelection(x), (v = 1));
                },
                null,
                null,
                -1,
              ),
              h.attachListener(h, 'mousedown', function () {
                v = 0;
              });
          if (CKEDITOR.env.ie && !q) {
            var p;
            h.attachListener(h, 'mousedown', function (a) {
              2 == a.data.$.button &&
                (((a = e.document.getSelection()) && a.getType() != CKEDITOR.SELECTION_NONE) || (p = e.window.getScrollPosition()));
            });
            h.attachListener(h, 'mouseup', function (a) {
              2 == a.data.$.button &&
                p &&
                ((e.document.$.documentElement.scrollLeft = p.x), (e.document.$.documentElement.scrollTop = p.y));
              p = null;
            });
            if ('BackCompat' != g.$.compatMode) {
              if (CKEDITOR.env.ie7Compat || CKEDITOR.env.ie6Compat) {
                var z, y;
                r.on('mousedown', function (a) {
                  function b(a) {
                    a = a.data.$;
                    if (z) {
                      var e = m.$.createTextRange();
                      try {
                        e.moveToPoint(a.clientX, a.clientY);
                      } catch (d) {}
                      z.setEndPoint(0 > y.compareEndPoints('StartToStart', e) ? 'EndToEnd' : 'StartToStart', e);
                      z.select();
                    }
                  }
                  function e() {
                    r.removeListener('mousemove', b);
                    f.removeListener('mouseup', e);
                    r.removeListener('mouseup', e);
                    z.select();
                  }
                  a = a.data;
                  if (a.getTarget().is('html') && a.$.y < r.$.clientHeight && a.$.x < r.$.clientWidth) {
                    z = m.$.createTextRange();
                    try {
                      z.moveToPoint(a.$.clientX, a.$.clientY);
                    } catch (d) {}
                    y = z.duplicate();
                    r.on('mousemove', b);
                    f.on('mouseup', e);
                    r.on('mouseup', e);
                  }
                });
              }
              if (7 < CKEDITOR.env.version && 11 > CKEDITOR.env.version)
                r.on('mousedown', function (a) {
                  a.data.getTarget().is('html') && (f.on('mouseup', b), r.on('mouseup', b));
                });
            }
          }
          h.attachListener(h, 'selectionchange', l, e);
          h.attachListener(h, 'keyup', k, e);
          h.attachListener(h, 'touchstart', k, e);
          h.attachListener(h, 'touchend', k, e);
          CKEDITOR.env.ie && h.attachListener(h, 'keydown', d, e);
          h.attachListener(h, CKEDITOR.env.webkit || CKEDITOR.env.gecko ? 'focusin' : 'focus', function () {
            e.forceNextSelectionCheck();
            e.selectionChange(1);
          });
          if (q && (CKEDITOR.env.webkit || CKEDITOR.env.gecko)) {
            var A;
            h.attachListener(h, 'mousedown', function () {
              A = 1;
            });
            h.attachListener(g.getDocumentElement(), 'mouseup', function () {
              A && k.call(e);
              A = 0;
            });
          } else h.attachListener(CKEDITOR.env.ie ? h : g.getDocumentElement(), 'mouseup', k, e);
          CKEDITOR.env.webkit &&
            h.attachListener(
              g,
              'keydown',
              function (a) {
                switch (a.data.getKey()) {
                  case 13:
                  case 33:
                  case 34:
                  case 35:
                  case 36:
                  case 37:
                  case 39:
                  case 8:
                  case 45:
                  case 46:
                    h.hasFocus && n(h);
                }
              },
              null,
              null,
              -1,
            );
          h.attachListener(h, 'keydown', u(e), null, null, -1);
        });
        e.on('setData', function () {
          e.unlockSelection();
          CKEDITOR.env.webkit && b();
        });
        e.on('contentDomUnload', function () {
          e.unlockSelection();
        });
        if (CKEDITOR.env.ie9Compat) e.on('beforeDestroy', b, null, null, 9);
        e.on('dataReady', function () {
          delete e._.fakeSelection;
          delete e._.hiddenSelectionContainer;
          e.selectionChange(1);
        });
        e.on(
          'loadSnapshot',
          function () {
            var a = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT),
              b = e.editable().getLast(a);
            b &&
              b.hasAttribute('data-cke-hidden-sel') &&
              (b.remove(),
              CKEDITOR.env.gecko && (a = e.editable().getFirst(a)) && a.is('br') && a.getAttribute('_moz_editor_bogus_node') && a.remove());
          },
          null,
          null,
          100,
        );
        e.on('key', function (a) {
          if ('wysiwyg' == e.mode) {
            var b = e.getSelection();
            if (b.isFake) {
              var d = F[a.data.keyCode];
              if (d) return d({ editor: e, selected: b.getSelectedElement(), selection: b, keyEvent: a });
            }
          }
        });
      });
      if (CKEDITOR.env.webkit)
        CKEDITOR.on('instanceReady', function (a) {
          var b = a.editor;
          b.on(
            'selectionChange',
            function () {
              var a = b.editable(),
                e = a.getCustomData('cke-fillingChar');
              e && (e.getCustomData('ready') ? (n(a), a.editor.fire('selectionCheck')) : e.setCustomData('ready', 1));
            },
            null,
            null,
            -1,
          );
          b.on(
            'beforeSetMode',
            function () {
              n(b.editable());
            },
            null,
            null,
            -1,
          );
          b.on(
            'getSnapshot',
            function (a) {
              a.data && (a.data = r(a.data));
            },
            b,
            null,
            20,
          );
          b.on(
            'toDataFormat',
            function (a) {
              a.data.dataValue = r(a.data.dataValue);
            },
            null,
            null,
            0,
          );
        });
      CKEDITOR.editor.prototype.selectionChange = function (a) {
        (a ? l : k).call(this);
      };
      CKEDITOR.editor.prototype.getSelection = function (a) {
        return (!this._.savedSelection && !this._.fakeSelection) || a
          ? (a = this.editable()) && 'wysiwyg' == this.mode && 'recreating' !== this.status
            ? new CKEDITOR.dom.selection(a)
            : null
          : this._.savedSelection || this._.fakeSelection;
      };
      CKEDITOR.editor.prototype.getSelectedRanges = function (a) {
        var b = this.getSelection();
        return (b && b.getRanges(a)) || [];
      };
      CKEDITOR.editor.prototype.lockSelection = function (a) {
        a = a || this.getSelection(1);
        return a.getType() != CKEDITOR.SELECTION_NONE ? (!a.isLocked && a.lock(), (this._.savedSelection = a), !0) : !1;
      };
      CKEDITOR.editor.prototype.unlockSelection = function (a) {
        var b = this._.savedSelection;
        return b ? (b.unlock(a), delete this._.savedSelection, !0) : !1;
      };
      CKEDITOR.editor.prototype.forceNextSelectionCheck = function () {
        delete this._.selectionPreviousPath;
      };
      CKEDITOR.dom.document.prototype.getSelection = function () {
        return new CKEDITOR.dom.selection(this);
      };
      CKEDITOR.dom.range.prototype.select = function () {
        var a = this.root instanceof CKEDITOR.editable ? this.root.editor.getSelection() : new CKEDITOR.dom.selection(this.root);
        a.selectRanges([this]);
        return a;
      };
      CKEDITOR.SELECTION_NONE = 1;
      CKEDITOR.SELECTION_TEXT = 2;
      CKEDITOR.SELECTION_ELEMENT = 3;
      CKEDITOR.dom.selection = function (a) {
        if (a instanceof CKEDITOR.dom.selection) {
          var b = a;
          a = a.root;
        }
        var e = a instanceof CKEDITOR.dom.element;
        this.rev = b ? b.rev : A++;
        this.document = a instanceof CKEDITOR.dom.document ? a : a.getDocument();
        this.root = e ? a : this.document.getBody();
        this.isLocked = 0;
        this._ = { cache: {} };
        if (b) return CKEDITOR.tools.extend(this._.cache, b._.cache), (this.isFake = b.isFake), (this.isLocked = b.isLocked), this;
        a = this.getNative();
        var d, c;
        if (a)
          if (a.getRangeAt) d = (c = a.rangeCount && a.getRangeAt(0)) && new CKEDITOR.dom.node(c.commonAncestorContainer);
          else {
            try {
              c = a.createRange();
            } catch (g) {}
            d = c && CKEDITOR.dom.element.get((c.item && c.item(0)) || c.parentElement());
          }
        if (!d || (d.type != CKEDITOR.NODE_ELEMENT && d.type != CKEDITOR.NODE_TEXT) || (!this.root.equals(d) && !this.root.contains(d)))
          (this._.cache.type = CKEDITOR.SELECTION_NONE),
            (this._.cache.startElement = null),
            (this._.cache.selectedElement = null),
            (this._.cache.selectedText = ''),
            (this._.cache.ranges = new CKEDITOR.dom.rangeList());
        return this;
      };
      var D = {
        img: 1,
        hr: 1,
        li: 1,
        table: 1,
        tr: 1,
        td: 1,
        th: 1,
        embed: 1,
        object: 1,
        ol: 1,
        ul: 1,
        a: 1,
        input: 1,
        form: 1,
        select: 1,
        textarea: 1,
        button: 1,
        fieldset: 1,
        thead: 1,
        tfoot: 1,
      };
      CKEDITOR.tools.extend(CKEDITOR.dom.selection, {
        _removeFillingCharSequenceString: r,
        _createFillingCharSequenceNode: e,
        FILLING_CHAR_SEQUENCE: q,
      });
      CKEDITOR.dom.selection.prototype = {
        getNative: function () {
          return void 0 !== this._.cache.nativeSel
            ? this._.cache.nativeSel
            : (this._.cache.nativeSel = t ? this.document.$.selection : this.document.getWindow().$.getSelection());
        },
        getType: t
          ? function () {
              var a = this._.cache;
              if (a.type) return a.type;
              var b = CKEDITOR.SELECTION_NONE;
              try {
                var e = this.getNative(),
                  d = e.type;
                'Text' == d && (b = CKEDITOR.SELECTION_TEXT);
                'Control' == d && (b = CKEDITOR.SELECTION_ELEMENT);
                e.createRange().parentElement() && (b = CKEDITOR.SELECTION_TEXT);
              } catch (c) {}
              return (a.type = b);
            }
          : function () {
              var a = this._.cache;
              if (a.type) return a.type;
              var b = CKEDITOR.SELECTION_TEXT,
                e = this.getNative();
              if (!e || !e.rangeCount) b = CKEDITOR.SELECTION_NONE;
              else if (1 == e.rangeCount) {
                var e = e.getRangeAt(0),
                  d = e.startContainer;
                d == e.endContainer &&
                  1 == d.nodeType &&
                  1 == e.endOffset - e.startOffset &&
                  D[d.childNodes[e.startOffset].nodeName.toLowerCase()] &&
                  (b = CKEDITOR.SELECTION_ELEMENT);
              }
              return (a.type = b);
            },
        getRanges: (function () {
          var a = t
            ? (function () {
                function a(b) {
                  return new CKEDITOR.dom.node(b).getIndex();
                }
                var b = function (b, e) {
                  b = b.duplicate();
                  b.collapse(e);
                  var d = b.parentElement();
                  if (!d.hasChildNodes()) return { container: d, offset: 0 };
                  for (var c = d.children, g, f, k = b.duplicate(), h = 0, l = c.length - 1, m = -1, n, r; h <= l; )
                    if (
                      ((m = Math.floor((h + l) / 2)),
                      (g = c[m]),
                      k.moveToElementText(g),
                      (n = k.compareEndPoints('StartToStart', b)),
                      0 < n)
                    )
                      l = m - 1;
                    else if (0 > n) h = m + 1;
                    else return { container: d, offset: a(g) };
                  if (-1 == m || (m == c.length - 1 && 0 > n)) {
                    k.moveToElementText(d);
                    k.setEndPoint('StartToStart', b);
                    k = k.text.replace(/(\r\n|\r)/g, '\n').length;
                    c = d.childNodes;
                    if (!k)
                      return (
                        (g = c[c.length - 1]),
                        g.nodeType != CKEDITOR.NODE_TEXT ? { container: d, offset: c.length } : { container: g, offset: g.nodeValue.length }
                      );
                    for (d = c.length; 0 < k && 0 < d; )
                      (f = c[--d]), f.nodeType == CKEDITOR.NODE_TEXT && ((r = f), (k -= f.nodeValue.length));
                    return { container: r, offset: -k };
                  }
                  k.collapse(0 < n ? !0 : !1);
                  k.setEndPoint(0 < n ? 'StartToStart' : 'EndToStart', b);
                  k = k.text.replace(/(\r\n|\r)/g, '\n').length;
                  if (!k) return { container: d, offset: a(g) + (0 < n ? 0 : 1) };
                  for (; 0 < k; )
                    try {
                      (f = g[0 < n ? 'previousSibling' : 'nextSibling']),
                        f.nodeType == CKEDITOR.NODE_TEXT && ((k -= f.nodeValue.length), (r = f)),
                        (g = f);
                    } catch (q) {
                      return { container: d, offset: a(g) };
                    }
                  return { container: r, offset: 0 < n ? -k : r.nodeValue.length + k };
                };
                return function () {
                  var a = this.getNative(),
                    e = a && a.createRange(),
                    d = this.getType();
                  if (!a) return [];
                  if (d == CKEDITOR.SELECTION_TEXT)
                    return (
                      (a = new CKEDITOR.dom.range(this.root)),
                      (d = b(e, !0)),
                      a.setStart(new CKEDITOR.dom.node(d.container), d.offset),
                      (d = b(e)),
                      a.setEnd(new CKEDITOR.dom.node(d.container), d.offset),
                      a.endContainer.getPosition(a.startContainer) & CKEDITOR.POSITION_PRECEDING &&
                        a.endOffset <= a.startContainer.getIndex() &&
                        a.collapse(),
                      [a]
                    );
                  if (d == CKEDITOR.SELECTION_ELEMENT) {
                    for (var d = [], c = 0; c < e.length; c++) {
                      for (
                        var g = e.item(c), f = g.parentNode, k = 0, a = new CKEDITOR.dom.range(this.root);
                        k < f.childNodes.length && f.childNodes[k] != g;
                        k++
                      );
                      a.setStart(new CKEDITOR.dom.node(f), k);
                      a.setEnd(new CKEDITOR.dom.node(f), k + 1);
                      d.push(a);
                    }
                    return d;
                  }
                  return [];
                };
              })()
            : function () {
                var a = [],
                  b,
                  e = this.getNative();
                if (!e) return a;
                for (var d = 0; d < e.rangeCount; d++) {
                  var c = e.getRangeAt(d);
                  b = new CKEDITOR.dom.range(this.root);
                  b.setStart(new CKEDITOR.dom.node(c.startContainer), c.startOffset);
                  b.setEnd(new CKEDITOR.dom.node(c.endContainer), c.endOffset);
                  a.push(b);
                }
                return a;
              };
          return function (b) {
            var e = this._.cache,
              d = e.ranges;
            d || (e.ranges = d = new CKEDITOR.dom.rangeList(a.call(this)));
            return b ? p(new CKEDITOR.dom.rangeList(d.slice())) : d;
          };
        })(),
        getStartElement: function () {
          var a = this._.cache;
          if (void 0 !== a.startElement) return a.startElement;
          var b;
          switch (this.getType()) {
            case CKEDITOR.SELECTION_ELEMENT:
              return this.getSelectedElement();
            case CKEDITOR.SELECTION_TEXT:
              var e = this.getRanges()[0];
              if (e) {
                if (e.collapsed) (b = e.startContainer), b.type != CKEDITOR.NODE_ELEMENT && (b = b.getParent());
                else {
                  for (
                    e.optimize();
                    (b = e.startContainer), e.startOffset == (b.getChildCount ? b.getChildCount() : b.getLength()) && !b.isBlockBoundary();

                  )
                    e.setStartAfter(b);
                  b = e.startContainer;
                  if (b.type != CKEDITOR.NODE_ELEMENT) return b.getParent();
                  if ((b = b.getChild(e.startOffset)) && b.type == CKEDITOR.NODE_ELEMENT)
                    for (e = b.getFirst(); e && e.type == CKEDITOR.NODE_ELEMENT; ) (b = e), (e = e.getFirst());
                  else b = e.startContainer;
                }
                b = b.$;
              }
          }
          return (a.startElement = b ? new CKEDITOR.dom.element(b) : null);
        },
        getSelectedElement: function () {
          var a = this._.cache;
          if (void 0 !== a.selectedElement) return a.selectedElement;
          var b = this,
            e = CKEDITOR.tools.tryThese(
              function () {
                return b.getNative().createRange().item(0);
              },
              function () {
                for (
                  var a = b.getRanges()[0].clone(), e, d, c = 2;
                  c && !((e = a.getEnclosedNode()) && e.type == CKEDITOR.NODE_ELEMENT && D[e.getName()] && (d = e));
                  c--
                )
                  a.shrink(CKEDITOR.SHRINK_ELEMENT);
                return d && d.$;
              },
            );
          return (a.selectedElement = e ? new CKEDITOR.dom.element(e) : null);
        },
        getSelectedText: function () {
          var a = this._.cache;
          if (void 0 !== a.selectedText) return a.selectedText;
          var b = this.getNative(),
            b = t ? ('Control' == b.type ? '' : b.createRange().text) : b.toString();
          return (a.selectedText = b);
        },
        lock: function () {
          this.getRanges();
          this.getStartElement();
          this.getSelectedElement();
          this.getSelectedText();
          this._.cache.nativeSel = null;
          this.isLocked = 1;
        },
        unlock: function (a) {
          if (this.isLocked) {
            if (a)
              var b = this.getSelectedElement(),
                e = this.getRanges(),
                d = this.isFake;
            this.isLocked = 0;
            this.reset();
            a &&
              (a = b || (e[0] && e[0].getCommonAncestor())) &&
              a.getAscendant('body', 1) &&
              ((a = this.root.editor) && a.plugins.tableselection && a.plugins.tableselection.isSupportedEnvironment(a) && h(e)
                ? c.call(this, e)
                : d
                  ? this.fake(b)
                  : b && 2 > e.length
                    ? this.selectElement(b)
                    : this.selectRanges(e));
          }
        },
        reset: function () {
          this._.cache = {};
          this.isFake = 0;
          var a = this.root.editor;
          if (a && a._.fakeSelection)
            if (this.rev == a._.fakeSelection.rev) {
              delete a._.fakeSelection;
              var b = a._.hiddenSelectionContainer;
              if (b) {
                var e = a.checkDirty();
                a.fire('lockSnapshot');
                b.remove();
                a.fire('unlockSnapshot');
                !e && a.resetDirty();
              }
              delete a._.hiddenSelectionContainer;
            } else CKEDITOR.warn('selection-fake-reset');
          this.rev = A++;
        },
        selectElement: function (a) {
          var b = new CKEDITOR.dom.range(this.root);
          b.setStartBefore(a);
          b.setEndAfter(a);
          this.selectRanges([b]);
        },
        selectRanges: function (a) {
          var b = this.root.editor,
            g = b && b._.hiddenSelectionContainer;
          this.reset();
          if (g)
            for (var g = this.root, f, k = 0; k < a.length; ++k)
              (f = a[k]), f.endContainer.equals(g) && (f.endOffset = Math.min(f.endOffset, g.getChildCount()));
          if (a.length)
            if (this.isLocked) {
              var l = CKEDITOR.document.getActive();
              this.unlock();
              this.selectRanges(a);
              this.lock();
              l && !l.equals(this.root) && l.focus();
            } else {
              var m;
              a: {
                var r, q;
                if (
                  1 == a.length &&
                  !(q = a[0]).collapsed &&
                  (m = q.getEnclosedNode()) &&
                  m.type == CKEDITOR.NODE_ELEMENT &&
                  ((q = q.clone()),
                  q.shrink(CKEDITOR.SHRINK_ELEMENT, !0),
                  (r = q.getEnclosedNode()) && r.type == CKEDITOR.NODE_ELEMENT && (m = r),
                  'false' == m.getAttribute('contenteditable'))
                )
                  break a;
                m = void 0;
              }
              if (m) this.fake(m);
              else if (
                b &&
                b.plugins.tableselection &&
                b.plugins.tableselection.isSupportedEnvironment(b) &&
                h(a) &&
                !z &&
                !a[0]._getTableElement({ table: 1 }).hasAttribute('data-cke-tableselection-ignored')
              )
                c.call(this, a);
              else {
                if (t) {
                  r = CKEDITOR.dom.walker.whitespaces(!0);
                  m = /\ufeff|\u00a0/;
                  q = { table: 1, tbody: 1, tr: 1 };
                  1 < a.length && ((b = a[a.length - 1]), a[0].setEnd(b.endContainer, b.endOffset));
                  b = a[0];
                  a = b.collapsed;
                  var v, x, p;
                  if ((g = b.getEnclosedNode()) && g.type == CKEDITOR.NODE_ELEMENT && g.getName() in D && (!g.is('a') || !g.getText()))
                    try {
                      p = g.$.createControlRange();
                      p.addElement(g.$);
                      p.select();
                      return;
                    } catch (u) {}
                  if (
                    (b.startContainer.type == CKEDITOR.NODE_ELEMENT && b.startContainer.getName() in q) ||
                    (b.endContainer.type == CKEDITOR.NODE_ELEMENT && b.endContainer.getName() in q)
                  )
                    b.shrink(CKEDITOR.NODE_ELEMENT, !0), (a = b.collapsed);
                  p = b.createBookmark();
                  q = p.startNode;
                  a || (l = p.endNode);
                  p = b.document.$.body.createTextRange();
                  p.moveToElementText(q.$);
                  p.moveStart('character', 1);
                  l
                    ? ((m = b.document.$.body.createTextRange()),
                      m.moveToElementText(l.$),
                      p.setEndPoint('EndToEnd', m),
                      p.moveEnd('character', -1))
                    : ((v = q.getNext(r)),
                      (x = q.hasAscendant('pre')),
                      (v =
                        !(v && v.getText && v.getText().match(m)) &&
                        (x || !q.hasPrevious() || (q.getPrevious().is && q.getPrevious().is('br')))),
                      (x = b.document.createElement('span')),
                      x.setHtml('\x26#65279;'),
                      x.insertBefore(q),
                      v && b.document.createText('﻿').insertBefore(q));
                  b.setStartBefore(q);
                  q.remove();
                  a
                    ? (v ? (p.moveStart('character', -1), p.select(), b.document.$.selection.clear()) : p.select(),
                      b.moveToPosition(x, CKEDITOR.POSITION_BEFORE_START),
                      x.remove())
                    : (b.setEndBefore(l), l.remove(), p.select());
                } else {
                  l = this.getNative();
                  if (!l) return;
                  this.removeAllRanges();
                  for (p = 0; p < a.length; p++) {
                    if (
                      p < a.length - 1 &&
                      ((v = a[p]),
                      (x = a[p + 1]),
                      (m = v.clone()),
                      m.setStart(v.endContainer, v.endOffset),
                      m.setEnd(x.startContainer, x.startOffset),
                      !m.collapsed &&
                        (m.shrink(CKEDITOR.NODE_ELEMENT, !0),
                        (b = m.getCommonAncestor()),
                        (m = m.getEnclosedNode()),
                        b.isReadOnly() || (m && m.isReadOnly())))
                    ) {
                      x.setStart(v.startContainer, v.startOffset);
                      a.splice(p--, 1);
                      continue;
                    }
                    b = a[p];
                    x = this.document.$.createRange();
                    b.collapsed &&
                      CKEDITOR.env.webkit &&
                      d(b) &&
                      ((m = e(this.root)),
                      b.insertNode(m),
                      (v = m.getNext()) && !m.getPrevious() && v.type == CKEDITOR.NODE_ELEMENT && 'br' == v.getName()
                        ? (n(this.root), b.moveToPosition(v, CKEDITOR.POSITION_BEFORE_START))
                        : b.moveToPosition(m, CKEDITOR.POSITION_AFTER_END));
                    x.setStart(b.startContainer.$, b.startOffset);
                    try {
                      x.setEnd(b.endContainer.$, b.endOffset);
                    } catch (y) {
                      if (0 <= y.toString().indexOf('NS_ERROR_ILLEGAL_VALUE')) b.collapse(1), x.setEnd(b.endContainer.$, b.endOffset);
                      else throw y;
                    }
                    l.addRange(x);
                  }
                }
                this.reset();
                this.root.fire('selectionchange');
              }
            }
        },
        fake: function (a, b) {
          var e = this.root.editor;
          void 0 === b && a.hasAttribute('aria-label') && (b = a.getAttribute('aria-label'));
          this.reset();
          x(e, b);
          var d = this._.cache,
            c = new CKEDITOR.dom.range(this.root);
          c.setStartBefore(a);
          c.setEndAfter(a);
          d.ranges = new CKEDITOR.dom.rangeList(c);
          d.selectedElement = d.startElement = a;
          d.type = CKEDITOR.SELECTION_ELEMENT;
          d.selectedText = d.nativeSel = null;
          this.isFake = 1;
          this.rev = A++;
          e._.fakeSelection = this;
          this.root.fire('selectionchange');
        },
        isHidden: function () {
          var a = this.getCommonAncestor();
          a && a.type == CKEDITOR.NODE_TEXT && (a = a.getParent());
          return !(!a || !a.data('cke-hidden-sel'));
        },
        isInTable: function (a) {
          return h(this.getRanges(), a);
        },
        isCollapsed: function () {
          var a = this.getRanges();
          return 1 === a.length && a[0].collapsed;
        },
        createBookmarks: function (a) {
          a = this.getRanges().createBookmarks(a);
          this.isFake && (a.isFake = 1);
          return a;
        },
        createBookmarks2: function (a) {
          a = this.getRanges().createBookmarks2(a);
          this.isFake && (a.isFake = 1);
          return a;
        },
        selectBookmarks: function (a) {
          for (var b = [], e, d = 0; d < a.length; d++) {
            var c = new CKEDITOR.dom.range(this.root);
            c.moveToBookmark(a[d]);
            b.push(c);
          }
          a.isFake &&
            ((e = h(b) ? b[0]._getTableElement() : b[0].getEnclosedNode()),
            (e && e.type == CKEDITOR.NODE_ELEMENT) || (CKEDITOR.warn('selection-not-fake'), (a.isFake = 0)));
          a.isFake && !h(b) ? this.fake(e) : this.selectRanges(b);
          return this;
        },
        getCommonAncestor: function () {
          var a = this.getRanges();
          return a.length ? a[0].startContainer.getCommonAncestor(a[a.length - 1].endContainer) : null;
        },
        scrollIntoView: function () {
          this.getType() != CKEDITOR.SELECTION_NONE && this.getRanges()[0].scrollIntoView();
        },
        removeAllRanges: function () {
          if (this.getType() != CKEDITOR.SELECTION_NONE) {
            var a = this.getNative();
            try {
              a && a[t ? 'empty' : 'removeAllRanges']();
            } catch (b) {}
            this.reset();
          }
        },
      };
    })();
    ('use strict');
    CKEDITOR.STYLE_BLOCK = 1;
    CKEDITOR.STYLE_INLINE = 2;
    CKEDITOR.STYLE_OBJECT = 3;
    (function () {
      function a(a, b) {
        for (var e, d; (a = a.getParent()) && !a.equals(b); )
          if (a.getAttribute('data-nostyle')) e = a;
          else if (!d) {
            var c = a.getAttribute('contentEditable');
            'false' == c ? (e = a) : 'true' == c && (d = 1);
          }
        return e;
      }
      function h(a, b, e, d) {
        return (a.getPosition(b) | d) == d && (!e.childRule || e.childRule(a));
      }
      function f(b) {
        var e = b.document;
        if (b.collapsed) (e = A(this, e)), b.insertNode(e), b.moveToPosition(e, CKEDITOR.POSITION_BEFORE_END);
        else {
          var d = this.element,
            g = this._.definition,
            k,
            l = g.ignoreReadonly,
            m = l || g.includeReadonly;
          null == m && (m = b.root.getCustomData('cke_includeReadonly'));
          var n = CKEDITOR.dtd[d];
          n || ((k = !0), (n = CKEDITOR.dtd.span));
          b.enlarge(CKEDITOR.ENLARGE_INLINE, 1);
          b.trim();
          var r = b.createBookmark(),
            q = r.startNode,
            v = r.endNode,
            x = q,
            t;
          if (!l) {
            var p = b.getCommonAncestor(),
              l = a(q, p),
              p = a(v, p);
            l && (x = l.getNextSourceNode(!0));
            p && (v = p);
          }
          for (x.getPosition(v) == CKEDITOR.POSITION_FOLLOWING && (x = 0); x; ) {
            l = !1;
            if (x.equals(v)) (x = null), (l = !0);
            else {
              var z = x.type == CKEDITOR.NODE_ELEMENT ? x.getName() : null,
                p = z && 'false' == x.getAttribute('contentEditable'),
                y = z && -1 !== CKEDITOR.tools.array.indexOf(CKEDITOR.style.unstylableElements, z),
                y = z && (x.getAttribute('data-nostyle') || y);
              if ((z && x.data('cke-bookmark')) || x.type === CKEDITOR.NODE_COMMENT) {
                x = x.getNextSourceNode(!0);
                continue;
              }
              if (p && m && CKEDITOR.dtd.$block[z])
                for (var B = x, C = c(B), D = void 0, F = C.length, J = 0, B = F && new CKEDITOR.dom.range(B.getDocument()); J < F; ++J) {
                  var D = C[J],
                    ea = CKEDITOR.filter.instances[D.data('cke-filter')];
                  if (ea ? ea.check(this) : 1) B.selectNodeContents(D), f.call(this, B);
                }
              C = z ? (!n[z] || y ? 0 : p && !m ? 0 : h(x, v, g, w)) : 1;
              if (C)
                if (
                  ((D = x.getParent()),
                  (C = g),
                  (F = d),
                  (J = k),
                  !D || (!(D.getDtd() || CKEDITOR.dtd.span)[F] && !J) || (C.parentRule && !C.parentRule(D)))
                )
                  l = !0;
                else {
                  if (
                    (t || (z && CKEDITOR.dtd.$removeEmpty[z] && (x.getPosition(v) | w) != w) || ((t = b.clone()), t.setStartBefore(x)),
                    (z = x.type),
                    z == CKEDITOR.NODE_TEXT || p || (z == CKEDITOR.NODE_ELEMENT && !x.getChildCount()))
                  ) {
                    for (var z = x, R; (l = !z.getNext(L)) && ((R = z.getParent()), n[R.getName()]) && h(R, q, g, I); ) z = R;
                    t.setEndAfter(z);
                  }
                }
              else l = !0;
              x = x.getNextSourceNode(y || p);
            }
            if (l && t && !t.collapsed) {
              for (
                var l = A(this, e), p = l.hasAttributes(), y = t.getCommonAncestor(), z = {}, C = {}, D = {}, F = {}, ba, W, H;
                l && y;

              ) {
                if (y.getName() == d) {
                  for (ba in g.attributes) !F[ba] && (H = y.getAttribute(W)) && (l.getAttribute(ba) == H ? (C[ba] = 1) : (F[ba] = 1));
                  for (W in g.styles) !D[W] && (H = y.getStyle(W)) && (l.getStyle(W) == H ? (z[W] = 1) : (D[W] = 1));
                }
                y = y.getParent();
              }
              for (ba in C) l.removeAttribute(ba);
              for (W in z) l.removeStyle(W);
              p && !l.hasAttributes() && (l = null);
              l
                ? (t.extractContents().appendTo(l), t.insertNode(l), u.call(this, l), l.mergeSiblings(), CKEDITOR.env.ie || l.$.normalize())
                : ((l = new CKEDITOR.dom.element('span')), t.extractContents().appendTo(l), t.insertNode(l), u.call(this, l), l.remove(!0));
              t = null;
            }
          }
          b.moveToBookmark(r);
          b.shrink(CKEDITOR.SHRINK_TEXT);
          b.shrink(CKEDITOR.NODE_ELEMENT, !0);
        }
      }
      function b(a) {
        function b() {
          for (
            var a = new CKEDITOR.dom.elementPath(d.getParent()), e = new CKEDITOR.dom.elementPath(m.getParent()), c = null, g = null, f = 0;
            f < a.elements.length;
            f++
          ) {
            var k = a.elements[f];
            if (k == a.block || k == a.blockLimit) break;
            n.checkElementRemovable(k, !0) && (c = k);
          }
          for (f = 0; f < e.elements.length; f++) {
            k = e.elements[f];
            if (k == e.block || k == e.blockLimit) break;
            n.checkElementRemovable(k, !0) && (g = k);
          }
          g && m.breakParent(g);
          c && d.breakParent(c);
        }
        a.enlarge(CKEDITOR.ENLARGE_INLINE, 1);
        var e = a.createBookmark(),
          d = e.startNode,
          c = this._.definition.alwaysRemoveElement;
        if (a.collapsed) {
          for (
            var g = new CKEDITOR.dom.elementPath(d.getParent(), a.root), f, k = 0, h;
            k < g.elements.length && (h = g.elements[k]) && h != g.block && h != g.blockLimit;
            k++
          )
            if (this.checkElementRemovable(h)) {
              var l;
              !c && a.collapsed && (a.checkBoundaryOfElement(h, CKEDITOR.END) || (l = a.checkBoundaryOfElement(h, CKEDITOR.START)))
                ? ((f = h), (f.match = l ? 'start' : 'end'))
                : (h.mergeSiblings(), h.is(this.element) ? x.call(this, h) : p(h, z(this)[h.getName()]));
            }
          if (f) {
            c = d;
            for (k = 0; ; k++) {
              h = g.elements[k];
              if (h.equals(f)) break;
              else if (h.match) continue;
              else h = h.clone();
              h.append(c);
              c = h;
            }
            c['start' == f.match ? 'insertBefore' : 'insertAfter'](f);
          }
        } else {
          var m = e.endNode,
            n = this;
          b();
          for (g = d; !g.equals(m); )
            (f = g.getNextSourceNode()),
              g.type == CKEDITOR.NODE_ELEMENT &&
                this.checkElementRemovable(g) &&
                (g.getName() == this.element ? x.call(this, g) : p(g, z(this)[g.getName()]),
                f.type == CKEDITOR.NODE_ELEMENT && f.contains(d) && (b(), (f = d.getNext()))),
              (g = f);
        }
        a.moveToBookmark(e);
        a.shrink(CKEDITOR.NODE_ELEMENT, !0);
      }
      function c(a) {
        var b = [];
        a.forEach(
          function (a) {
            if ('true' == a.getAttribute('contenteditable')) return b.push(a), !1;
          },
          CKEDITOR.NODE_ELEMENT,
          !0,
        );
        return b;
      }
      function l(a) {
        var b = a.getEnclosedNode() || a.getCommonAncestor(!1, !0);
        (a = new CKEDITOR.dom.elementPath(b, a.root).contains(this.element, 1)) && !a.isReadOnly() && q(a, this);
      }
      function k(a) {
        var b = a.getCommonAncestor(!0, !0);
        if ((a = new CKEDITOR.dom.elementPath(b, a.root).contains(this.element, 1))) {
          var b = this._.definition,
            e = b.attributes;
          if (e) for (var d in e) a.removeAttribute(d, e[d]);
          if (b.styles) for (var c in b.styles) b.styles.hasOwnProperty(c) && a.removeStyle(c);
        }
      }
      function m(a) {
        var b = a.createBookmark(!0),
          e = a.createIterator();
        e.enforceRealBlocks = !0;
        this._.enterMode && (e.enlargeBr = this._.enterMode != CKEDITOR.ENTER_BR);
        for (var c, g = a.document, f; (c = e.getNextParagraph()); )
          !c.isReadOnly() && (e.activeFilter ? e.activeFilter.check(this) : 1) && ((f = A(this, g, c)), d(c, f));
        a.moveToBookmark(b);
      }
      function g(a) {
        var b = a.createBookmark(1),
          e = a.createIterator();
        e.enforceRealBlocks = !0;
        e.enlargeBr = this._.enterMode != CKEDITOR.ENTER_BR;
        for (var c, g; (c = e.getNextParagraph()); )
          this.checkElementRemovable(c) &&
            (c.is('pre')
              ? ((g =
                  this._.enterMode == CKEDITOR.ENTER_BR
                    ? null
                    : a.document.createElement(this._.enterMode == CKEDITOR.ENTER_P ? 'p' : 'div')) && c.copyAttributes(g),
                d(c, g))
              : x.call(this, c));
        a.moveToBookmark(b);
      }
      function d(a, b) {
        var d = !b;
        d && ((b = a.getDocument().createElement('div')), a.copyAttributes(b));
        var c = b && b.is('pre'),
          g = a.is('pre'),
          f = !c && g;
        if (c && !g) {
          g = b;
          (f = a.getBogus()) && f.remove();
          f = a.getHtml();
          f = n(f, /(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g, '');
          f = f.replace(/[ \t\r\n]*(<br[^>]*>)[ \t\r\n]*/gi, '$1');
          f = f.replace(/([ \t\n\r]+|&nbsp;)/g, ' ');
          f = f.replace(/<br\b[^>]*>/gi, '\n');
          if (CKEDITOR.env.ie) {
            var k = a.getDocument().createElement('div');
            k.append(g);
            g.$.outerHTML = '\x3cpre\x3e' + f + '\x3c/pre\x3e';
            g.copyAttributes(k.getFirst());
            g = k.getFirst().remove();
          } else g.setHtml(f);
          b = g;
        } else f ? (b = r(d ? [a.getHtml()] : e(a), b)) : a.moveChildren(b);
        b.replace(a);
        if (c) {
          var d = b,
            h;
          (h = d.getPrevious(K)) &&
            h.type == CKEDITOR.NODE_ELEMENT &&
            h.is('pre') &&
            ((c = n(h.getHtml(), /\n$/, '') + '\n\n' + n(d.getHtml(), /^\n/, '')),
            CKEDITOR.env.ie ? (d.$.outerHTML = '\x3cpre\x3e' + c + '\x3c/pre\x3e') : d.setHtml(c),
            h.remove());
        } else d && t(b);
      }
      function e(a) {
        var b = [];
        n(a.getOuterHtml(), /(\S\s*)\n(?:\s|(<span[^>]+data-cke-bookmark.*?\/span>))*\n(?!$)/gi, function (a, b, e) {
          return b + '\x3c/pre\x3e' + e + '\x3cpre\x3e';
        }).replace(/<pre\b.*?>([\s\S]*?)<\/pre>/gi, function (a, e) {
          b.push(e);
        });
        return b;
      }
      function n(a, b, e) {
        var d = '',
          c = '';
        a = a.replace(/(^<span[^>]+data-cke-bookmark.*?\/span>)|(<span[^>]+data-cke-bookmark.*?\/span>$)/gi, function (a, b, e) {
          b && (d = b);
          e && (c = e);
          return '';
        });
        return d + a.replace(b, e) + c;
      }
      function r(a, b) {
        var e;
        1 < a.length && (e = new CKEDITOR.dom.documentFragment(b.getDocument()));
        for (var d = 0; d < a.length; d++) {
          var c = a[d],
            c = c.replace(/(\r\n|\r)/g, '\n'),
            c = n(c, /^[ \t]*\n/, ''),
            c = n(c, /\n$/, ''),
            c = n(c, /^[ \t]+|[ \t]+$/g, function (a, b) {
              return 1 == a.length
                ? '\x26nbsp;'
                : b
                  ? ' ' + CKEDITOR.tools.repeat('\x26nbsp;', a.length - 1)
                  : CKEDITOR.tools.repeat('\x26nbsp;', a.length - 1) + ' ';
            }),
            c = c.replace(/\n/g, '\x3cbr\x3e'),
            c = c.replace(/[ \t]{2,}/g, function (a) {
              return CKEDITOR.tools.repeat('\x26nbsp;', a.length - 1) + ' ';
            });
          if (e) {
            var g = b.clone();
            g.setHtml(c);
            e.append(g);
          } else b.setHtml(c);
        }
        return e || b;
      }
      function x(a, b) {
        var e = this._.definition,
          d = e.attributes,
          e = e.styles,
          c = z(this)[a.getName()],
          g = CKEDITOR.tools.isEmpty(d) && CKEDITOR.tools.isEmpty(e),
          f;
        for (f in d)
          if (('class' != f && !this._.definition.fullMatch) || a.getAttribute(f) == y(f, d[f]))
            (b && 'data-' == f.slice(0, 5)) || ((g = a.hasAttribute(f)), a.removeAttribute(f));
        for (var k in e) (this._.definition.fullMatch && a.getStyle(k) != y(k, e[k], !0)) || ((g = g || !!a.getStyle(k)), a.removeStyle(k));
        p(a, c, F[a.getName()]);
        g &&
          (this._.definition.alwaysRemoveElement
            ? t(a, 1)
            : !CKEDITOR.dtd.$block[a.getName()] || (this._.enterMode == CKEDITOR.ENTER_BR && !a.hasAttributes())
              ? t(a)
              : a.renameNode(this._.enterMode == CKEDITOR.ENTER_P ? 'p' : 'div'));
      }
      function u(a) {
        for (var b = z(this), e = a.getElementsByTag(this.element), d, c = e.count(); 0 <= --c; )
          (d = e.getItem(c)), d.isReadOnly() || x.call(this, d, !0);
        for (var g in b)
          if (g != this.element)
            for (e = a.getElementsByTag(g), c = e.count() - 1; 0 <= c; c--) (d = e.getItem(c)), d.isReadOnly() || p(d, b[g]);
      }
      function p(a, b, e) {
        if ((b = b && b.attributes))
          for (var d = 0; d < b.length; d++) {
            var c = b[d][0],
              g;
            if ((g = a.getAttribute(c))) {
              var f = b[d][1];
              (null === f || (f.test && f.test(g)) || ('string' == typeof f && g == f)) && a.removeAttribute(c);
            }
          }
        e || t(a);
      }
      function t(a, b) {
        if (!a.hasAttributes() || b)
          if (CKEDITOR.dtd.$block[a.getName()]) {
            var e = a.getPrevious(K),
              d = a.getNext(K);
            !e || (e.type != CKEDITOR.NODE_TEXT && e.isBlockBoundary({ br: 1 })) || a.append('br', 1);
            !d || (d.type != CKEDITOR.NODE_TEXT && d.isBlockBoundary({ br: 1 })) || a.append('br');
            a.remove(!0);
          } else
            (e = a.getFirst()),
              (d = a.getLast()),
              a.remove(!0),
              e &&
                (e.type == CKEDITOR.NODE_ELEMENT && e.mergeSiblings(),
                d && !e.equals(d) && d.type == CKEDITOR.NODE_ELEMENT && d.mergeSiblings());
      }
      function A(a, b, e) {
        var d;
        d = a.element;
        '*' == d && (d = 'span');
        d = new CKEDITOR.dom.element(d, b);
        e && e.copyAttributes(d);
        d = q(d, a);
        b.getCustomData('doc_processing_style') && d.hasAttribute('id')
          ? d.removeAttribute('id')
          : b.setCustomData('doc_processing_style', 1);
        return d;
      }
      function q(a, b) {
        var e = b._.definition,
          d = e.attributes,
          e = CKEDITOR.style.getStyleText(e);
        if (d) for (var c in d) a.setAttribute(c, d[c]);
        e && a.setAttribute('style', e);
        a.getDocument().removeCustomData('doc_processing_style');
        return a;
      }
      function B(a, b) {
        for (var e in a)
          a[e] = a[e].replace(H, function (a, e) {
            return b[e];
          });
      }
      function z(a) {
        if (a._.overrides) return a._.overrides;
        var b = (a._.overrides = {}),
          e = a._.definition.overrides;
        if (e) {
          CKEDITOR.tools.isArray(e) || (e = [e]);
          for (var d = 0; d < e.length; d++) {
            var c = e[d],
              g,
              f;
            'string' == typeof c ? (g = c.toLowerCase()) : ((g = c.element ? c.element.toLowerCase() : a.element), (f = c.attributes));
            c = b[g] || (b[g] = {});
            if (f) {
              var c = (c.attributes = c.attributes || []),
                k;
              for (k in f) c.push([k.toLowerCase(), f[k]]);
            }
          }
        }
        return b;
      }
      function y(a, b, e) {
        var d = new CKEDITOR.dom.element('span');
        d[e ? 'setStyle' : 'setAttribute'](a, b);
        return d[e ? 'getStyle' : 'getAttribute'](a);
      }
      function v(a, b) {
        function e(a, b) {
          return 'font-family' == b.toLowerCase() ? a.replace(/["']/g, '') : a;
        }
        'string' == typeof a && (a = CKEDITOR.tools.parseCssText(a));
        'string' == typeof b && (b = CKEDITOR.tools.parseCssText(b, !0));
        for (var d in a) if (!(d in b) || (e(b[d], d) != e(a[d], d) && 'inherit' != a[d] && 'inherit' != b[d])) return !1;
        return !0;
      }
      function C(a, b, e) {
        var d = a.getRanges();
        b = b ? this.removeFromRange : this.applyToRange;
        for (var c, g = d.createIterator(); (c = g.getNextRange()); ) b.call(this, c, e);
        a.selectRanges(d);
      }
      var F = {
          address: 1,
          div: 1,
          h1: 1,
          h2: 1,
          h3: 1,
          h4: 1,
          h5: 1,
          h6: 1,
          p: 1,
          pre: 1,
          section: 1,
          header: 1,
          footer: 1,
          nav: 1,
          article: 1,
          aside: 1,
          figure: 1,
          dialog: 1,
          hgroup: 1,
          time: 1,
          meter: 1,
          menu: 1,
          command: 1,
          keygen: 1,
          output: 1,
          progress: 1,
          details: 1,
          datagrid: 1,
          datalist: 1,
        },
        D = {
          a: 1,
          blockquote: 1,
          embed: 1,
          hr: 1,
          img: 1,
          li: 1,
          object: 1,
          ol: 1,
          table: 1,
          td: 1,
          tr: 1,
          th: 1,
          ul: 1,
          dl: 1,
          dt: 1,
          dd: 1,
          form: 1,
          audio: 1,
          video: 1,
        },
        G = /\s*(?:;\s*|$)/,
        H = /#\((.+?)\)/g,
        L = CKEDITOR.dom.walker.bookmark(0, 1),
        K = CKEDITOR.dom.walker.whitespaces(1);
      CKEDITOR.style = function (a, b) {
        if ('string' == typeof a.type) return new CKEDITOR.style.customHandlers[a.type](a);
        var e = a.attributes;
        e && e.style && ((a.styles = CKEDITOR.tools.extend({}, a.styles, CKEDITOR.tools.parseCssText(e.style))), delete e.style);
        b && ((a = CKEDITOR.tools.clone(a)), B(a.attributes, b), B(a.styles, b));
        e = this.element = a.element ? ('string' == typeof a.element ? a.element.toLowerCase() : a.element) : '*';
        this.type = a.type || (F[e] ? CKEDITOR.STYLE_BLOCK : D[e] ? CKEDITOR.STYLE_OBJECT : CKEDITOR.STYLE_INLINE);
        'object' == typeof this.element && (this.type = CKEDITOR.STYLE_OBJECT);
        this._ = { definition: a };
      };
      CKEDITOR.style.prototype = {
        apply: function (a) {
          if (a instanceof CKEDITOR.dom.document) return C.call(this, a.getSelection());
          if (this.checkApplicable(a.elementPath(), a)) {
            var b = this._.enterMode;
            b || (this._.enterMode = a.activeEnterMode);
            C.call(this, a.getSelection(), 0, a);
            this._.enterMode = b;
          }
        },
        remove: function (a) {
          if (a instanceof CKEDITOR.dom.document) return C.call(this, a.getSelection(), 1);
          if (this.checkApplicable(a.elementPath(), a)) {
            var b = this._.enterMode;
            b || (this._.enterMode = a.activeEnterMode);
            C.call(this, a.getSelection(), 1, a);
            this._.enterMode = b;
          }
        },
        applyToRange: function (a) {
          this.applyToRange =
            this.type == CKEDITOR.STYLE_INLINE ? f : this.type == CKEDITOR.STYLE_BLOCK ? m : this.type == CKEDITOR.STYLE_OBJECT ? l : null;
          return this.applyToRange(a);
        },
        removeFromRange: function (a) {
          this.removeFromRange =
            this.type == CKEDITOR.STYLE_INLINE ? b : this.type == CKEDITOR.STYLE_BLOCK ? g : this.type == CKEDITOR.STYLE_OBJECT ? k : null;
          return this.removeFromRange(a);
        },
        applyToObject: function (a) {
          q(a, this);
        },
        checkActive: function (a, b) {
          switch (this.type) {
            case CKEDITOR.STYLE_BLOCK:
              return this.checkElementRemovable(a.block || a.blockLimit, !0, b);
            case CKEDITOR.STYLE_OBJECT:
            case CKEDITOR.STYLE_INLINE:
              for (var e = a.elements, d = 0, c; d < e.length; d++)
                if (((c = e[d]), this.type != CKEDITOR.STYLE_INLINE || (c != a.block && c != a.blockLimit))) {
                  if (this.type == CKEDITOR.STYLE_OBJECT) {
                    var g = c.getName();
                    if (!('string' == typeof this.element ? g == this.element : g in this.element)) continue;
                  }
                  if (this.checkElementRemovable(c, !0, b)) return !0;
                }
          }
          return !1;
        },
        checkApplicable: function (a, b, e) {
          b && b instanceof CKEDITOR.filter && (e = b);
          if (e && !e.check(this)) return !1;
          switch (this.type) {
            case CKEDITOR.STYLE_OBJECT:
              return !!a.contains(this.element);
            case CKEDITOR.STYLE_BLOCK:
              return !!a.blockLimit.getDtd()[this.element];
          }
          return !0;
        },
        checkElementMatch: function (a, b) {
          var e = this._.definition;
          if (!a || (!e.ignoreReadonly && a.isReadOnly())) return !1;
          var d = a.getName();
          if ('string' == typeof this.element ? d == this.element : d in this.element) {
            if (!b && !a.hasAttributes()) return !0;
            if ((d = e._AC)) e = d;
            else {
              var d = {},
                c = 0,
                g = e.attributes;
              if (g) for (var f in g) c++, (d[f] = g[f]);
              if ((f = CKEDITOR.style.getStyleText(e))) d.style || c++, (d.style = f);
              d._length = c;
              e = e._AC = d;
            }
            if (e._length) {
              for (var k in e)
                if ('_length' != k)
                  if (((d = a.getAttribute(k) || ''), 'style' == k ? v(e[k], d) : e[k] == d)) {
                    if (!b) return !0;
                  } else if (b) return !1;
              if (b) return !0;
            } else return !0;
          }
          return !1;
        },
        checkElementRemovable: function (a, b, e) {
          if (this.checkElementMatch(a, b, e)) return !0;
          if ((b = z(this)[a.getName()])) {
            var d;
            if (!(b = b.attributes)) return !0;
            for (e = 0; e < b.length; e++)
              if (((d = b[e][0]), (d = a.getAttribute(d)))) {
                var c = b[e][1];
                if (null === c) return !0;
                if ('string' == typeof c) {
                  if (d == c) return !0;
                } else if (c.test(d)) return !0;
              }
          }
          return !1;
        },
        buildPreview: function (a) {
          var b = this._.definition,
            e = [],
            d = b.element;
          'bdo' == d && (d = 'span');
          var e = ['\x3c', d],
            c = b.attributes;
          if (c) for (var g in c) e.push(' ', g, '\x3d"', c[g], '"');
          (c = CKEDITOR.style.getStyleText(b)) && e.push(' style\x3d"', c, '"');
          e.push('\x3e', a || b.name, '\x3c/', d, '\x3e');
          return e.join('');
        },
        getDefinition: function () {
          return this._.definition;
        },
      };
      CKEDITOR.style.getStyleText = function (a) {
        var b = a._ST;
        if (b) return b;
        var b = a.styles,
          e = (a.attributes && a.attributes.style) || '',
          d = '';
        e.length && (e = e.replace(G, ';'));
        for (var c in b) {
          var g = b[c],
            f = (c + ':' + g).replace(G, ';');
          'inherit' == g ? (d += f) : (e += f);
        }
        e.length && (e = CKEDITOR.tools.normalizeCssText(e, !0));
        return (a._ST = e + d);
      };
      CKEDITOR.style.customHandlers = {};
      CKEDITOR.style.unstylableElements = [];
      CKEDITOR.style.addCustomHandler = function (a) {
        var b = function (a) {
          this._ = { definition: a };
          this.setup && this.setup(a);
        };
        b.prototype = CKEDITOR.tools.extend(
          CKEDITOR.tools.prototypedCopy(CKEDITOR.style.prototype),
          { assignedTo: CKEDITOR.STYLE_OBJECT },
          a,
          !0,
        );
        return (this.customHandlers[a.type] = b);
      };
      var w = CKEDITOR.POSITION_PRECEDING | CKEDITOR.POSITION_IDENTICAL | CKEDITOR.POSITION_IS_CONTAINED,
        I = CKEDITOR.POSITION_FOLLOWING | CKEDITOR.POSITION_IDENTICAL | CKEDITOR.POSITION_IS_CONTAINED;
    })();
    CKEDITOR.styleCommand = function (a, h) {
      this.requiredContent = this.allowedContent = this.style = a;
      CKEDITOR.tools.extend(this, h, !0);
    };
    CKEDITOR.styleCommand.prototype.exec = function (a) {
      a.focus();
      this.state == CKEDITOR.TRISTATE_OFF ? a.applyStyle(this.style) : this.state == CKEDITOR.TRISTATE_ON && a.removeStyle(this.style);
    };
    CKEDITOR.stylesSet = new CKEDITOR.resourceManager('', 'stylesSet');
    CKEDITOR.addStylesSet = CKEDITOR.tools.bind(CKEDITOR.stylesSet.add, CKEDITOR.stylesSet);
    CKEDITOR.loadStylesSet = function (a, h, f) {
      CKEDITOR.stylesSet.addExternal(a, h, '');
      CKEDITOR.stylesSet.load(a, f);
    };
    CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
      attachStyleStateChange: function (a, h) {
        var f = this._.styleStateChangeCallbacks;
        f ||
          ((f = this._.styleStateChangeCallbacks = []),
          this.on('selectionChange', function (a) {
            for (var c = 0; c < f.length; c++) {
              var h = f[c],
                k = h.style.checkActive(a.data.path, this) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF;
              h.fn.call(this, k);
            }
          }));
        f.push({ style: a, fn: h });
      },
      applyStyle: function (a) {
        a.apply(this);
      },
      removeStyle: function (a) {
        a.remove(this);
      },
      getStylesSet: function (a) {
        if (this._.stylesDefinitions) a(this._.stylesDefinitions);
        else {
          var h = this,
            f = h.config.stylesCombo_stylesSet || h.config.stylesSet;
          if (!1 === f) a(null);
          else if (f instanceof Array) (h._.stylesDefinitions = f), a(f);
          else {
            f || (f = 'default');
            var f = f.split(':'),
              b = f[0];
            CKEDITOR.stylesSet.addExternal(b, f[1] ? f.slice(1).join(':') : CKEDITOR.getUrl('styles.js'), '');
            CKEDITOR.stylesSet.load(b, function (c) {
              h._.stylesDefinitions = c[b];
              a(h._.stylesDefinitions);
            });
          }
        }
      },
    });
    (function () {
      if (window.Promise) CKEDITOR.tools.promise = Promise;
      else {
        var a = CKEDITOR.getUrl('vendor/promise.js');
        if ('function' === typeof window.define && window.define.amd && 'function' === typeof window.require)
          return window.require([a], function (a) {
            CKEDITOR.tools.promise = a;
          });
        CKEDITOR.scriptLoader.load(a, function (h) {
          if (!h) return CKEDITOR.error('no-vendor-lib', { path: a });
          if ('undefined' !== typeof window.ES6Promise) return (CKEDITOR.tools.promise = ES6Promise);
        });
      }
    })();
    (function () {
      function a(a, c, l) {
        a.once(
          'selectionCheck',
          function (a) {
            if (!h) {
              var b = a.data.getRanges()[0];
              l.equals(b) ? a.cancel() : c.equals(b) && (f = !0);
            }
          },
          null,
          null,
          -1,
        );
      }
      var h = !0,
        f = !1;
      CKEDITOR.dom.selection.setupEditorOptimization = function (a) {
        a.on('selectionCheck', function (a) {
          a.data && !f && a.data.optimizeInElementEnds();
          f = !1;
        });
        a.on('contentDom', function () {
          var c = a.editable();
          c &&
            (c.attachListener(
              c,
              'keydown',
              function (a) {
                this._.shiftPressed = a.data.$.shiftKey;
              },
              this,
            ),
            c.attachListener(
              c,
              'keyup',
              function (a) {
                this._.shiftPressed = a.data.$.shiftKey;
              },
              this,
            ));
        });
      };
      CKEDITOR.dom.selection.prototype.optimizeInElementEnds = function () {
        var b = this.getRanges()[0],
          c = this.root.editor,
          f;
        if (this.root.editor._.shiftPressed || this.isFake || b.isCollapsed || b.startContainer.equals(b.endContainer)) f = !1;
        else if (0 === b.endOffset) f = !0;
        else {
          f = b.startContainer.type === CKEDITOR.NODE_TEXT;
          var k = b.endContainer.type === CKEDITOR.NODE_TEXT,
            m = f ? b.startContainer.getLength() : b.startContainer.getChildCount();
          f = b.startOffset === m || f ^ k;
        }
        f &&
          ((f = b.clone()),
          b.shrink(CKEDITOR.SHRINK_TEXT, !1, { skipBogus: !CKEDITOR.env.webkit }),
          (h = !1),
          a(c, b, f),
          b.select(),
          (h = !0));
      };
    })();
    (function () {
      function a(a, b) {
        if (f(a)) a = Math.round(b * (parseFloat(a) / 100));
        else if (('string' === typeof a && a.match(/^\d+$/gm)) || ('string' === typeof a && a.match(/^\d+(?:deg)?$/gm)))
          a = parseInt(a, 10);
        return a;
      }
      function h(a, b) {
        f(a) ? (a = b * (parseFloat(a) / 100)) : 'string' === typeof a && a.match(/^\d?\.\d+/gm) && (a = parseFloat(a));
        return a;
      }
      function f(a) {
        return 'string' === typeof a && a.match(/^((\d*\.\d+)|(\d+))%{1}$/gm);
      }
      function b(a, b, c) {
        return !isNaN(a) && a >= b && a <= c;
      }
      function c(a) {
        a = a.toString(16);
        return 1 == a.length ? '0' + a : a;
      }
      CKEDITOR.tools.color = CKEDITOR.tools.createClass({
        $: function (a, b) {
          this._.initialColorCode = a;
          this._.defaultValue = b;
          this._.parseInput(a);
        },
        proto: {
          getHex: function () {
            if (!this._.isValidColor) return this._.defaultValue;
            var a = this._.blendAlphaColor(this._.red, this._.green, this._.blue, this._.alpha);
            return this._.formatHexString(a[0], a[1], a[2]);
          },
          getHexWithAlpha: function () {
            if (!this._.isValidColor) return this._.defaultValue;
            var a = Math.round(this._.alpha * CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE);
            return this._.formatHexString(this._.red, this._.green, this._.blue, a);
          },
          getRgb: function () {
            if (!this._.isValidColor) return this._.defaultValue;
            var a = this._.blendAlphaColor(this._.red, this._.green, this._.blue, this._.alpha);
            return this._.formatRgbString('rgb', a[0], a[1], a[2]);
          },
          getRgba: function () {
            return this._.isValidColor
              ? this._.formatRgbString('rgba', this._.red, this._.green, this._.blue, this._.alpha)
              : this._.defaultValue;
          },
          getHsl: function () {
            var a = 0 === this._.alpha || 1 === this._.alpha;
            if (!this._.isValidColor) return this._.defaultValue;
            this._.type === CKEDITOR.tools.color.TYPE_HSL && a
              ? (a = [this._.hue, this._.saturation, this._.lightness])
              : ((a = this._.blendAlphaColor(this._.red, this._.green, this._.blue, this._.alpha)),
                (a = this._.rgbToHsl(a[0], a[1], a[2])));
            return this._.formatHslString('hsl', a[0], a[1], a[2]);
          },
          getHsla: function () {
            var a;
            if (!this._.isValidColor) return this._.defaultValue;
            a =
              this._.type === CKEDITOR.tools.color.TYPE_HSL
                ? [this._.hue, this._.saturation, this._.lightness]
                : this._.rgbToHsl(this._.red, this._.green, this._.blue);
            return this._.formatHslString('hsla', a[0], a[1], a[2], this._.alpha);
          },
          getInitialValue: function () {
            return this._.initialColorCode;
          },
        },
        _: {
          initialColorCode: '',
          isValidColor: !0,
          type: 0,
          hue: 0,
          saturation: 0,
          lightness: 0,
          red: 0,
          green: 0,
          blue: 0,
          alpha: 1,
          blendAlphaColor: function (a, b, c, g) {
            return CKEDITOR.tools.array.map([a, b, c], function (a) {
              return Math.round(CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE - g * (CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE - a));
            });
          },
          formatHexString: function (a, b, f, g) {
            a = '#' + c(a) + c(b) + c(f);
            void 0 !== g && (a += c(g));
            return a.toUpperCase();
          },
          formatRgbString: function (a, b, c, g, d) {
            b = [b, c, g];
            void 0 !== d && b.push(d);
            return a + '(' + b.join(',') + ')';
          },
          formatHslString: function (a, b, c, g, d) {
            return a + '(' + b + ',' + c + '%,' + g + '%' + (void 0 !== d ? ',' + d : '') + ')';
          },
          parseInput: function (a) {
            if ('string' !== typeof a) this._.isValidColor = !1;
            else {
              a = CKEDITOR.tools.trim(a);
              var b = this._.matchStringToNamedColor(a);
              b && (a = b);
              var b = this._.extractColorChannelsFromHex(a),
                c = this._.extractColorChannelsFromRgba(a);
              a = this._.extractColorChannelsFromHsla(a);
              (a = b || c || a)
                ? ((this._.type = a.type),
                  (this._.red = a.red),
                  (this._.green = a.green),
                  (this._.blue = a.blue),
                  (this._.alpha = a.alpha),
                  a.type === CKEDITOR.tools.color.TYPE_HSL &&
                    ((this._.hue = a.hue), (this._.saturation = a.saturation), (this._.lightness = a.lightness)))
                : (this._.isValidColor = !1);
            }
          },
          matchStringToNamedColor: function (a) {
            return CKEDITOR.tools.color.namedColors[a.toLowerCase()] || null;
          },
          extractColorChannelsFromHex: function (a) {
            -1 === a.indexOf('#') && (a = '#' + a);
            a.match(CKEDITOR.tools.color.hex3CharsRegExp) && (a = this._.hex3ToHex6(a));
            a.match(CKEDITOR.tools.color.hex4CharsRegExp) && (a = this._.hex4ToHex8(a));
            if (!a.match(CKEDITOR.tools.color.hex6CharsRegExp) && !a.match(CKEDITOR.tools.color.hex8CharsRegExp)) return null;
            a = a.split('');
            var b = 1;
            a[7] &&
              a[8] &&
              ((b = parseInt(a[7] + a[8], 16)), (b /= CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE), (b = Number(b.toFixed(1))));
            return {
              type: CKEDITOR.tools.color.TYPE_RGB,
              red: parseInt(a[1] + a[2], 16),
              green: parseInt(a[3] + a[4], 16),
              blue: parseInt(a[5] + a[6], 16),
              alpha: b,
            };
          },
          extractColorChannelsFromRgba: function (b) {
            var c = this._.extractColorChannelsByPattern(b, CKEDITOR.tools.color.rgbRegExp);
            if (!c || 3 > c.length || 4 < c.length) return null;
            var f = 4 === c.length;
            b = a(c[0], CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE);
            var g = a(c[1], CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE),
              d = a(c[2], CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE),
              e = 1;
            f && (e = h(c[3], CKEDITOR.tools.color.MAX_ALPHA_CHANNEL_VALUE));
            c = { type: CKEDITOR.tools.color.TYPE_RGB, red: b, green: g, blue: d, alpha: e };
            return this._.areColorChannelsValid(b, g, d, e) ? c : null;
          },
          extractColorChannelsFromHsla: function (b) {
            var c = this._.extractColorChannelsByPattern(b, CKEDITOR.tools.color.hslRegExp);
            if (!c || 3 > c.length || 4 < c.length) return null;
            var f = 4 === c.length,
              g = a(c[0], CKEDITOR.tools.color.MAX_HUE_CHANNEL_VALUE),
              d = h(c[1], CKEDITOR.tools.color.MAX_SATURATION_LIGHTNESS_CHANNEL_VALUE),
              e = h(c[2], CKEDITOR.tools.color.MAX_SATURATION_LIGHTNESS_CHANNEL_VALUE),
              n = 1;
            b = this._.hslToRgb(g, d, e);
            f && (n = h(c[3], CKEDITOR.tools.color.MAX_ALPHA_CHANNEL_VALUE));
            b.push(n);
            c = {
              type: CKEDITOR.tools.color.TYPE_HSL,
              red: b[0],
              green: b[1],
              blue: b[2],
              alpha: b[3],
              hue: g,
              saturation: Math.round(100 * d),
              lightness: Math.round(100 * e),
            };
            return this._.areColorChannelsValid(b[0], b[1], b[2], b[3]) ? c : null;
          },
          hex3ToHex6: function (a) {
            a = a.split('');
            return '#' + a[1] + a[1] + a[2] + a[2] + a[3] + a[3];
          },
          hex4ToHex8: function (a) {
            return this._.hex3ToHex6(a.substr(0, 4)) + CKEDITOR.tools.repeat(a[4], 2);
          },
          extractColorChannelsByPattern: function (a, b) {
            var c = a.match(b);
            if (!c) return null;
            var g = -1 === c[1].indexOf(',') ? /\s/ : ',',
              g = c[1].split(g),
              g = CKEDITOR.tools.array.reduce(
                g,
                function (a, b) {
                  var c = CKEDITOR.tools.trim(b);
                  return 0 === c.length ? a : a.concat([c]);
                },
                [],
              );
            c[2] && ((c = CKEDITOR.tools.trim(c[2].replace(/[\/,]/, ''))), g.push(c));
            return g;
          },
          areColorChannelsValid: function (a, c, f, g) {
            return (
              b(a, 0, CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE) &&
              b(c, 0, CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE) &&
              b(f, 0, CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE) &&
              b(g, 0, CKEDITOR.tools.color.MAX_ALPHA_CHANNEL_VALUE)
            );
          },
          hslToRgb: function (a, b, c) {
            var g = function (d) {
              var e = (d + a / 30) % 12;
              d = b * Math.min(c, 1 - c);
              e = Math.min(e - 3, 9 - e, 1);
              e = Math.max(-1, e);
              return Math.round((c - d * e) * CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE);
            };
            return [g(0), g(8), g(4)];
          },
          rgbToHsl: function (a, b, c) {
            a /= CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE;
            b /= CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE;
            var g = c / CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE,
              d = Math.max(a, b, g),
              e = Math.min(a, b, g);
            c = d - e;
            var f = 0;
            switch (d) {
              case a:
                f = ((b - g) / c) % 6;
                break;
              case b:
                f = (g - a) / c + 2;
                break;
              case g:
                f = (a - b) / c + 4;
            }
            a = 0 === c ? 0 : 60 * f;
            b = (d + e) / 2;
            d = 0;
            1 !== b && 0 !== b && (d = c / (1 - Math.abs(2 * b - 1)));
            a = Math.round(a);
            d = Math.round(100 * d);
            b = Math.round(100 * b);
            return [a, d, b];
          },
        },
        statics: {
          TYPE_RGB: 1,
          TYPE_HSL: 2,
          MAX_RGB_CHANNEL_VALUE: 255,
          MAX_ALPHA_CHANNEL_VALUE: 1,
          MAX_HUE_CHANNEL_VALUE: 360,
          MAX_SATURATION_LIGHTNESS_CHANNEL_VALUE: 1,
          hex3CharsRegExp: /#([0-9a-f]{3}$)/gim,
          hex4CharsRegExp: /#([0-9a-f]{4}$)/gim,
          hex6CharsRegExp: /#([0-9a-f]{6}$)/gim,
          hex8CharsRegExp: /#([0-9a-f]{8}$)/gim,
          rgbRegExp: /rgba?\(([.,\d\s%]*)(\s*\/\s*[\d.%]+)?\s*\)/i,
          hslRegExp: /hsla?\((\s*(?:[.\d]+(?:deg)?)(?:\s*,?\s*[.\d]+%){2})((?:(?:\s*\/\s*)|(?:\s*,\s*))[\d.]+%?)?\s*\)/i,
          namedColors: {
            aliceblue: '#F0F8FF',
            antiquewhite: '#FAEBD7',
            aqua: '#00FFFF',
            aquamarine: '#7FFFD4',
            azure: '#F0FFFF',
            beige: '#F5F5DC',
            bisque: '#FFE4C4',
            black: '#000000',
            blanchedalmond: '#FFEBCD',
            blue: '#0000FF',
            blueviolet: '#8A2BE2',
            brown: '#A52A2A',
            burlywood: '#DEB887',
            cadetblue: '#5F9EA0',
            chartreuse: '#7FFF00',
            chocolate: '#D2691E',
            coral: '#FF7F50',
            cornflowerblue: '#6495ED',
            cornsilk: '#FFF8DC',
            crimson: '#DC143C',
            cyan: '#00FFFF',
            darkblue: '#00008B',
            darkcyan: '#008B8B',
            darkgoldenrod: '#B8860B',
            darkgray: '#A9A9A9',
            darkgreen: '#006400',
            darkgrey: '#A9A9A9',
            darkkhaki: '#BDB76B',
            darkmagenta: '#8B008B',
            darkolivegreen: '#556B2F',
            darkorange: '#FF8C00',
            darkorchid: '#9932CC',
            darkred: '#8B0000',
            darksalmon: '#E9967A',
            darkseagreen: '#8FBC8F',
            darkslateblue: '#483D8B',
            darkslategray: '#2F4F4F',
            darkslategrey: '#2F4F4F',
            darkturquoise: '#00CED1',
            darkviolet: '#9400D3',
            deeppink: '#FF1493',
            deepskyblue: '#00BFFF',
            dimgray: '#696969',
            dimgrey: '#696969',
            dodgerblue: '#1E90FF',
            firebrick: '#B22222',
            floralwhite: '#FFFAF0',
            forestgreen: '#228B22',
            fuchsia: '#FF00FF',
            gainsboro: '#DCDCDC',
            ghostwhite: '#F8F8FF',
            gold: '#FFD700',
            goldenrod: '#DAA520',
            gray: '#808080',
            green: '#008000',
            greenyellow: '#ADFF2F',
            grey: '#808080',
            honeydew: '#F0FFF0',
            hotpink: '#FF69B4',
            indianred: '#CD5C5C',
            indigo: '#4B0082',
            ivory: '#FFFFF0',
            khaki: '#F0E68C',
            lavender: '#E6E6FA',
            lavenderblush: '#FFF0F5',
            lawngreen: '#7CFC00',
            lemonchiffon: '#FFFACD',
            lightblue: '#ADD8E6',
            lightcoral: '#F08080',
            lightcyan: '#E0FFFF',
            lightgoldenrodyellow: '#FAFAD2',
            lightgray: '#D3D3D3',
            lightgreen: '#90EE90',
            lightgrey: '#D3D3D3',
            lightpink: '#FFB6C1',
            lightsalmon: '#FFA07A',
            lightseagreen: '#20B2AA',
            lightskyblue: '#87CEFA',
            lightslategray: '#778899',
            lightslategrey: '#778899',
            lightsteelblue: '#B0C4DE',
            lightyellow: '#FFFFE0',
            lime: '#00FF00',
            limegreen: '#32CD32',
            linen: '#FAF0E6',
            magenta: '#FF00FF',
            maroon: '#800000',
            mediumaquamarine: '#66CDAA',
            mediumblue: '#0000CD',
            mediumorchid: '#BA55D3',
            mediumpurple: '#9370DB',
            mediumseagreen: '#3CB371',
            mediumslateblue: '#7B68EE',
            mediumspringgreen: '#00FA9A',
            mediumturquoise: '#48D1CC',
            mediumvioletred: '#C71585',
            midnightblue: '#191970',
            mintcream: '#F5FFFA',
            mistyrose: '#FFE4E1',
            moccasin: '#FFE4B5',
            navajowhite: '#FFDEAD',
            navy: '#000080',
            oldlace: '#FDF5E6',
            olive: '#808000',
            olivedrab: '#6B8E23',
            orange: '#FFA500',
            orangered: '#FF4500',
            orchid: '#DA70D6',
            palegoldenrod: '#EEE8AA',
            palegreen: '#98FB98',
            paleturquoise: '#AFEEEE',
            palevioletred: '#DB7093',
            papayawhip: '#FFEFD5',
            peachpuff: '#FFDAB9',
            peru: '#CD853F',
            pink: '#FFC0CB',
            plum: '#DDA0DD',
            powderblue: '#B0E0E6',
            purple: '#800080',
            rebeccapurple: '#663399',
            red: '#FF0000',
            rosybrown: '#BC8F8F',
            royalblue: '#4169E1',
            saddlebrown: '#8B4513',
            salmon: '#FA8072',
            sandybrown: '#F4A460',
            seagreen: '#2E8B57',
            seashell: '#FFF5EE',
            sienna: '#A0522D',
            silver: '#C0C0C0',
            skyblue: '#87CEEB',
            slateblue: '#6A5ACD',
            slategray: '#708090',
            slategrey: '#708090',
            snow: '#FFFAFA',
            springgreen: '#00FF7F',
            steelblue: '#4682B4',
            tan: '#D2B48C',
            teal: '#008080',
            thistle: '#D8BFD8',
            tomato: '#FF6347',
            turquoise: '#40E0D0',
            violet: '#EE82EE',
            windowtext: 'windowtext',
            wheat: '#F5DEB3',
            white: '#FFFFFF',
            whitesmoke: '#F5F5F5',
            yellow: '#FFFF00',
            yellowgreen: '#9ACD32',
          },
        },
      });
      CKEDITOR.tools.style.parse._colors = CKEDITOR.tools.color.namedColors;
    })();
    CKEDITOR.dom.comment = function (a, h) {
      'string' == typeof a && (a = (h ? h.$ : document).createComment(a));
      CKEDITOR.dom.domObject.call(this, a);
    };
    CKEDITOR.dom.comment.prototype = new CKEDITOR.dom.node();
    CKEDITOR.tools.extend(CKEDITOR.dom.comment.prototype, {
      type: CKEDITOR.NODE_COMMENT,
      getOuterHtml: function () {
        return '\x3c!--' + this.$.nodeValue + '--\x3e';
      },
    });
    ('use strict');
    (function () {
      var a = {},
        h = {},
        f;
      for (f in CKEDITOR.dtd.$blockLimit) f in CKEDITOR.dtd.$list || (a[f] = 1);
      for (f in CKEDITOR.dtd.$block) f in CKEDITOR.dtd.$blockLimit || f in CKEDITOR.dtd.$empty || (h[f] = 1);
      CKEDITOR.dom.elementPath = function (b, c) {
        var f = null,
          k = null,
          m = [],
          g = b,
          d;
        c = c || b.getDocument().getBody();
        g || (g = c);
        do
          if (g.type == CKEDITOR.NODE_ELEMENT) {
            m.push(g);
            if (!this.lastElement && ((this.lastElement = g), g.is(CKEDITOR.dtd.$object) || 'false' == g.getAttribute('contenteditable')))
              continue;
            if (g.equals(c)) break;
            if (!k && ((d = g.getName()), 'true' == g.getAttribute('contenteditable') ? (k = g) : !f && h[d] && (f = g), a[d])) {
              if ((d = !f && 'div' == d)) {
                a: {
                  d = g.getChildren();
                  for (var e = 0, n = d.count(); e < n; e++) {
                    var r = d.getItem(e);
                    if (r.type == CKEDITOR.NODE_ELEMENT && CKEDITOR.dtd.$block[r.getName()]) {
                      d = !0;
                      break a;
                    }
                  }
                  d = !1;
                }
                d = !d;
              }
              d ? (f = g) : (k = g);
            }
          }
        while ((g = g.getParent()));
        k || (k = c);
        this.block = f;
        this.blockLimit = k;
        this.root = c;
        this.elements = m;
      };
    })();
    CKEDITOR.dom.elementPath.prototype = {
      compare: function (a) {
        var h = this.elements;
        a = a && a.elements;
        if (!a || h.length != a.length) return !1;
        for (var f = 0; f < h.length; f++) if (!h[f].equals(a[f])) return !1;
        return !0;
      },
      contains: function (a, h, f) {
        var b = 0,
          c;
        'string' == typeof a &&
          (c = function (b) {
            return b.getName() == a;
          });
        a instanceof CKEDITOR.dom.element
          ? (c = function (b) {
              return b.equals(a);
            })
          : CKEDITOR.tools.isArray(a)
            ? (c = function (b) {
                return -1 < CKEDITOR.tools.indexOf(a, b.getName());
              })
            : 'function' == typeof a
              ? (c = a)
              : 'object' == typeof a &&
                (c = function (b) {
                  return b.getName() in a;
                });
        var l = this.elements,
          k = l.length;
        h && (f ? (b += 1) : --k);
        f && ((l = Array.prototype.slice.call(l, 0)), l.reverse());
        for (; b < k; b++) if (c(l[b])) return l[b];
        return null;
      },
      isContextFor: function (a) {
        var h;
        return a in CKEDITOR.dtd.$block
          ? ((h = this.contains(CKEDITOR.dtd.$intermediate) || (this.root.equals(this.block) && this.block) || this.blockLimit),
            !!h.getDtd()[a])
          : !0;
      },
      direction: function () {
        return (this.block || this.blockLimit || this.root).getDirection(1);
      },
    };
    CKEDITOR.dom.text = function (a, h) {
      'string' == typeof a && (a = (h ? h.$ : document).createTextNode(a));
      this.$ = a;
    };
    CKEDITOR.dom.text.prototype = new CKEDITOR.dom.node();
    CKEDITOR.tools.extend(CKEDITOR.dom.text.prototype, {
      type: CKEDITOR.NODE_TEXT,
      getLength: function () {
        return this.$.nodeValue.length;
      },
      getText: function () {
        return this.$.nodeValue;
      },
      setText: function (a) {
        this.$.nodeValue = a;
      },
      isEmpty: function (a) {
        var h = this.getText();
        a && (h = CKEDITOR.tools.trim(h));
        return !h || h === CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE;
      },
      split: function (a) {
        var h = this.$.parentNode,
          f = h.childNodes.length,
          b = this.getLength(),
          c = this.getDocument(),
          l = new CKEDITOR.dom.text(this.$.splitText(a), c);
        h.childNodes.length == f &&
          (a >= b ? ((l = c.createText('')), l.insertAfter(this)) : ((a = c.createText('')), a.insertAfter(l), a.remove()));
        return l;
      },
      substring: function (a, h) {
        return 'number' != typeof h ? this.$.nodeValue.substr(a) : this.$.nodeValue.substring(a, h);
      },
    });
    (function () {
      function a(a, b, c) {
        var h = a.serializable,
          k = b[c ? 'endContainer' : 'startContainer'],
          m = c ? 'endOffset' : 'startOffset',
          g = h ? b.document.getById(a.startNode) : a.startNode;
        a = h ? b.document.getById(a.endNode) : a.endNode;
        k.equals(g.getPrevious())
          ? ((b.startOffset = b.startOffset - k.getLength() - a.getPrevious().getLength()), (k = a.getNext()))
          : k.equals(a.getPrevious()) && ((b.startOffset -= k.getLength()), (k = a.getNext()));
        k.equals(g.getParent()) && b[m]++;
        k.equals(a.getParent()) && b[m]++;
        b[c ? 'endContainer' : 'startContainer'] = k;
        return b;
      }
      CKEDITOR.dom.rangeList = function (a) {
        if (a instanceof CKEDITOR.dom.rangeList) return a;
        a ? a instanceof CKEDITOR.dom.range && (a = [a]) : (a = []);
        return CKEDITOR.tools.extend(a, h);
      };
      var h = {
        createIterator: function () {
          var a = this,
            b = CKEDITOR.dom.walker.bookmark(),
            c = [],
            h;
          return {
            getNextRange: function (k) {
              h = void 0 === h ? 0 : h + 1;
              var m = a[h];
              if (m && 1 < a.length) {
                if (!h) for (var g = a.length - 1; 0 <= g; g--) c.unshift(a[g].createBookmark(!0));
                if (k)
                  for (var d = 0; a[h + d + 1]; ) {
                    var e = m.document;
                    k = 0;
                    g = e.getById(c[d].endNode);
                    for (e = e.getById(c[d + 1].startNode); ; ) {
                      g = g.getNextSourceNode(!1);
                      if (e.equals(g)) k = 1;
                      else if (b(g) || (g.type == CKEDITOR.NODE_ELEMENT && g.isBlockBoundary())) continue;
                      break;
                    }
                    if (!k) break;
                    d++;
                  }
                for (m.moveToBookmark(c.shift()); d--; ) (g = a[++h]), g.moveToBookmark(c.shift()), m.setEnd(g.endContainer, g.endOffset);
              }
              return m;
            },
          };
        },
        createBookmarks: function (f) {
          for (var b = [], c, h = 0; h < this.length; h++) {
            b.push((c = this[h].createBookmark(f, !0)));
            for (var k = h + 1; k < this.length; k++) (this[k] = a(c, this[k])), (this[k] = a(c, this[k], !0));
          }
          return b;
        },
        createBookmarks2: function (a) {
          for (var b = [], c = 0; c < this.length; c++) b.push(this[c].createBookmark2(a));
          return b;
        },
        moveToBookmarks: function (a) {
          for (var b = 0; b < this.length; b++) this[b].moveToBookmark(a[b]);
        },
      };
    })();
    (function () {
      function a() {
        return CKEDITOR.getUrl(CKEDITOR.skinName.split(',')[1] || 'skins/' + CKEDITOR.skinName.split(',')[0] + '/');
      }
      function h(b) {
        var e = CKEDITOR.skin['ua_' + b],
          c = CKEDITOR.env;
        if (e)
          for (
            var e = e.split(',').sort(function (a, b) {
                return a > b ? -1 : 1;
              }),
              g = 0,
              f;
            g < e.length;
            g++
          )
            if (((f = e[g]), c.ie && (f.replace(/^ie/, '') == c.version || (c.quirks && 'iequirks' == f)) && (f = 'ie'), c[f])) {
              b += '_' + e[g];
              break;
            }
        return CKEDITOR.getUrl(a() + b + '.css');
      }
      function f(a, b) {
        l[a] || (CKEDITOR.document.appendStyleSheet(h(a)), (l[a] = 1));
        b && b();
      }
      function b(a) {
        var b = a.getById(k);
        b || ((b = a.getHead().append('style')), b.setAttribute('id', k), b.setAttribute('type', 'text/css'));
        return b;
      }
      function c(a, b, c) {
        var g, f, k;
        if (CKEDITOR.env.webkit) for (b = b.split('}').slice(0, -1), f = 0; f < b.length; f++) b[f] = b[f].split('{');
        for (var h = 0; h < a.length; h++)
          if (CKEDITOR.env.webkit)
            for (f = 0; f < b.length; f++) {
              k = b[f][1];
              for (g = 0; g < c.length; g++) k = k.replace(c[g][0], c[g][1]);
              a[h].$.sheet.addRule(b[f][0], k);
            }
          else {
            k = b;
            for (g = 0; g < c.length; g++) k = k.replace(c[g][0], c[g][1]);
            CKEDITOR.env.ie && 11 > CKEDITOR.env.version ? (a[h].$.styleSheet.cssText += k) : (a[h].$.innerHTML += k);
          }
      }
      var l = {};
      CKEDITOR.skin = {
        path: a,
        loadPart: function (b, e) {
          CKEDITOR.skin.name != CKEDITOR.skinName.split(',')[0]
            ? CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(a() + 'skin.js'), function () {
                f(b, e);
              })
            : f(b, e);
        },
        getPath: function (a) {
          return CKEDITOR.getUrl(h(a));
        },
        icons: {},
        addIcon: function (a, b, c, g) {
          a = a.toLowerCase();
          this.icons[a] || (this.icons[a] = { path: b, offset: c || 0, bgsize: g || '16px' });
        },
        getIconStyle: function (a, b, c, g, f) {
          var k;
          a && ((a = a.toLowerCase()), b && (k = this.icons[a + '-rtl']), k || (k = this.icons[a]));
          a = c || (k && k.path) || '';
          g = g || (k && k.offset);
          f = f || (k && k.bgsize) || '16px';
          a && (a = a.replace(/'/g, "\\'"));
          return a && "background-image:url('" + CKEDITOR.getUrl(a) + "');background-position:0 " + g + 'px;background-size:' + f + ';';
        },
      };
      CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
        getUiColor: function () {
          return this.uiColor;
        },
        setUiColor: function (a) {
          var e = b(CKEDITOR.document);
          return (this.setUiColor = function (a) {
            this.uiColor = a;
            var b = CKEDITOR.skin.chameleon,
              d = '',
              f = '';
            'function' == typeof b && ((d = b(this, 'editor')), (f = b(this, 'panel')));
            a = [[g, a]];
            c([e], d, a);
            c(m, f, a);
          }).call(this, a);
        },
      });
      var k = 'cke_ui_color',
        m = [],
        g = /\$color/g;
      CKEDITOR.on('instanceLoaded', function (a) {
        if (!CKEDITOR.env.ie || !CKEDITOR.env.quirks) {
          var e = a.editor;
          a = function (a) {
            a = (a.data[0] || a.data).element.getElementsByTag('iframe').getItem(0).getFrameDocument();
            if (!a.getById('cke_ui_color')) {
              var d = b(a);
              m.push(d);
              e.on('destroy', function () {
                m = CKEDITOR.tools.array.filter(m, function (a) {
                  return d !== a;
                });
              });
              (a = e.getUiColor()) && c([d], CKEDITOR.skin.chameleon(e, 'panel'), [[g, a]]);
            }
          };
          e.on('panelShow', a);
          e.on('menuShow', a);
          e.config.uiColor && e.setUiColor(e.config.uiColor);
        }
      });
    })();
    (function () {
      var a = CKEDITOR.dom.element.createFromHtml(
        '\x3cdiv style\x3d"width:0;height:0;position:absolute;left:-10000px;border:1px solid;border-color:red blue"\x3e\x3c/div\x3e',
        CKEDITOR.document,
      );
      a.appendTo(CKEDITOR.document.getHead());
      try {
        var h = a.getComputedStyle('border-top-color'),
          f = a.getComputedStyle('border-right-color');
        CKEDITOR.env.hc = !(!h || h != f);
      } catch (b) {
        CKEDITOR.env.hc = !1;
      }
      a.remove();
      CKEDITOR.env.hc && (CKEDITOR.env.cssClass += ' cke_hc');
      CKEDITOR.document.appendStyleText('.cke{visibility:hidden;}');
      CKEDITOR.status = 'loaded';
      CKEDITOR.fireOnce('loaded');
      if ((a = CKEDITOR._.pending))
        for (delete CKEDITOR._.pending, h = 0; h < a.length; h++)
          CKEDITOR.editor.prototype.constructor.apply(a[h][0], a[h][1]), CKEDITOR.add(a[h][0]);
    })();
    CKEDITOR.skin.name = 'moono-lisa';
    CKEDITOR.skin.ua_editor = 'ie,iequirks,ie8,gecko';
    CKEDITOR.skin.ua_dialog = 'ie,iequirks,ie8';
    CKEDITOR.skin.chameleon = (function () {
      var a = (function () {
          return function (a, b) {
            for (var c = a.match(/[^#]./g), h = 0; 3 > h; h++) {
              var k = h,
                m;
              m = parseInt(c[h], 16);
              m = ('0' + (0 > b ? 0 | (m * (1 + b)) : 0 | (m + (255 - m) * b)).toString(16)).slice(-2);
              c[k] = m;
            }
            return '#' + c.join('');
          };
        })(),
        h = {
          editor: new CKEDITOR.template(
            '{id}.cke_chrome [border-color:{defaultBorder};] {id} .cke_top [ background-color:{defaultBackground};border-bottom-color:{defaultBorder};] {id} .cke_bottom [background-color:{defaultBackground};border-top-color:{defaultBorder};] {id} .cke_resizer [border-right-color:{ckeResizer}] {id} .cke_dialog_title [background-color:{defaultBackground};border-bottom-color:{defaultBorder};] {id} .cke_dialog_footer [background-color:{defaultBackground};outline-color:{defaultBorder};] {id} .cke_dialog_tab [background-color:{dialogTab};border-color:{defaultBorder};] {id} .cke_dialog_tab:hover [background-color:{lightBackground};] {id} .cke_dialog_contents [border-top-color:{defaultBorder};] {id} .cke_dialog_tab_selected, {id} .cke_dialog_tab_selected:hover [background:{dialogTabSelected};border-bottom-color:{dialogTabSelectedBorder};] {id} .cke_dialog_body [background:{dialogBody};border-color:{defaultBorder};] {id} a.cke_button_off:hover,{id} a.cke_button_off:focus,{id} a.cke_button_off:active [background-color:{darkBackground};border-color:{toolbarElementsBorder};] {id} .cke_button_on [background-color:{ckeButtonOn};border-color:{toolbarElementsBorder};] {id} .cke_toolbar_separator,{id} .cke_toolgroup a.cke_button:last-child:after,{id} .cke_toolgroup a.cke_button.cke_button_disabled:hover:last-child:after [background-color: {toolbarElementsBorder};border-color: {toolbarElementsBorder};] {id} a.cke_combo_button:hover,{id} a.cke_combo_button:focus,{id} .cke_combo_on a.cke_combo_button [border-color:{toolbarElementsBorder};background-color:{darkBackground};] {id} .cke_combo:after [border-color:{toolbarElementsBorder};] {id} .cke_path_item [color:{elementsPathColor};] {id} a.cke_path_item:hover,{id} a.cke_path_item:focus,{id} a.cke_path_item:active [background-color:{darkBackground};] {id}.cke_panel [border-color:{defaultBorder};] ',
          ),
          panel: new CKEDITOR.template(
            '.cke_panel_grouptitle [background-color:{lightBackground};border-color:{defaultBorder};] .cke_menubutton_icon [background-color:{menubuttonIcon};] .cke_menubutton:hover,.cke_menubutton:focus,.cke_menubutton:active [background-color:{menubuttonHover};] .cke_menubutton:hover .cke_menubutton_icon, .cke_menubutton:focus .cke_menubutton_icon, .cke_menubutton:active .cke_menubutton_icon [background-color:{menubuttonIconHover};] .cke_menubutton_disabled:hover .cke_menubutton_icon,.cke_menubutton_disabled:focus .cke_menubutton_icon,.cke_menubutton_disabled:active .cke_menubutton_icon [background-color:{menubuttonIcon};] .cke_menuseparator [background-color:{menubuttonIcon};] a:hover.cke_colorbox, a:active.cke_colorbox [border-color:{defaultBorder};] a:hover.cke_colorauto, a:hover.cke_colormore, a:active.cke_colorauto, a:active.cke_colormore [background-color:{ckeColorauto};border-color:{defaultBorder};] ',
          ),
        };
      return function (f, b) {
        var c = a(f.uiColor, 0.4),
          c = {
            id: '.' + f.id,
            defaultBorder: a(c, -0.2),
            toolbarElementsBorder: a(c, -0.25),
            defaultBackground: c,
            lightBackground: a(c, 0.8),
            darkBackground: a(c, -0.15),
            ckeButtonOn: a(c, 0.4),
            ckeResizer: a(c, -0.4),
            ckeColorauto: a(c, 0.8),
            dialogBody: a(c, 0.7),
            dialogTab: a(c, 0.65),
            dialogTabSelected: '#FFF',
            dialogTabSelectedBorder: '#FFF',
            elementsPathColor: a(c, -0.6),
            menubuttonHover: a(c, 0.1),
            menubuttonIcon: a(c, 0.5),
            menubuttonIconHover: a(c, 0.3),
          };
        return h[b].output(c).replace(/\[/g, '{').replace(/\]/g, '}');
      };
    })();
    CKEDITOR.plugins.add('dialogui', {
      onLoad: function () {
        var a = function (a) {
            this._ || (this._ = {});
            this._['default'] = this._.initValue = a['default'] || '';
            this._.required = a.required || !1;
            for (var b = [this._], e = 1; e < arguments.length; e++) b.push(arguments[e]);
            b.push(!0);
            CKEDITOR.tools.extend.apply(CKEDITOR.tools, b);
            return this._;
          },
          h = {
            build: function (a, b, e) {
              return new CKEDITOR.ui.dialog.textInput(a, b, e);
            },
          },
          f = {
            build: function (a, b, e) {
              return new CKEDITOR.ui.dialog[b.type](a, b, e);
            },
          },
          b = {
            isChanged: function () {
              return this.getValue() != this.getInitValue();
            },
            reset: function (a) {
              this.setValue(this.getInitValue(), a);
            },
            setInitValue: function () {
              this._.initValue = this.getValue();
            },
            resetInitValue: function () {
              this._.initValue = this._['default'];
            },
            getInitValue: function () {
              return this._.initValue;
            },
          },
          c = CKEDITOR.tools.extend(
            {},
            CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,
            {
              onChange: function (a, b) {
                this._.domOnChangeRegistered ||
                  (a.on(
                    'load',
                    function () {
                      this.getInputElement().on(
                        'change',
                        function () {
                          a.parts.dialog.isVisible() && this.fire('change', { value: this.getValue() });
                        },
                        this,
                      );
                    },
                    this,
                  ),
                  (this._.domOnChangeRegistered = !0));
                this.on('change', b);
              },
            },
            !0,
          ),
          l = /^on([A-Z]\w+)/,
          k = function (a) {
            for (var b in a) (l.test(b) || 'title' == b || 'type' == b) && delete a[b];
            return a;
          },
          m = function (a) {
            a = a.data.getKeystroke();
            a == CKEDITOR.SHIFT + CKEDITOR.ALT + 36
              ? this.setDirectionMarker('ltr')
              : a == CKEDITOR.SHIFT + CKEDITOR.ALT + 35 && this.setDirectionMarker('rtl');
          };
        CKEDITOR.tools.extend(
          CKEDITOR.ui.dialog,
          {
            labeledElement: function (b, d, e, c) {
              if (!(4 > arguments.length)) {
                var f = a.call(this, d);
                f.labelId = CKEDITOR.tools.getNextId() + '_label';
                this._.children = [];
                var k = { role: d.role || 'presentation' };
                d.includeLabel && (k['aria-labelledby'] = f.labelId);
                CKEDITOR.ui.dialog.uiElement.call(this, b, d, e, 'div', null, k, function () {
                  var a = [],
                    e = d.required ? ' cke_required' : '';
                  'horizontal' != d.labelLayout
                    ? a.push(
                        '\x3clabel class\x3d"cke_dialog_ui_labeled_label' + e + '" ',
                        ' id\x3d"' + f.labelId + '"',
                        f.inputId ? ' for\x3d"' + f.inputId + '"' : '',
                        (d.labelStyle ? ' style\x3d"' + d.labelStyle + '"' : '') + '\x3e',
                        d.required
                          ? d.label + '\x3cspan class\x3d"cke_dialog_ui_labeled_required" aria-hidden\x3d"true"\x3e*\x3c/span\x3e'
                          : d.label,
                        '\x3c/label\x3e',
                        '\x3cdiv class\x3d"cke_dialog_ui_labeled_content"',
                        d.controlStyle ? ' style\x3d"' + d.controlStyle + '"' : '',
                        ' role\x3d"presentation"\x3e',
                        c.call(this, b, d),
                        '\x3c/div\x3e',
                      )
                    : ((e = {
                        type: 'hbox',
                        widths: d.widths,
                        padding: 0,
                        children: [
                          {
                            type: 'html',
                            html:
                              '\x3clabel class\x3d"cke_dialog_ui_labeled_label' +
                              e +
                              '" id\x3d"' +
                              f.labelId +
                              '" for\x3d"' +
                              f.inputId +
                              '"' +
                              (d.labelStyle ? ' style\x3d"' + d.labelStyle + '"' : '') +
                              '\x3e' +
                              CKEDITOR.tools.htmlEncode(d.label) +
                              '\x3c/label\x3e',
                          },
                          {
                            type: 'html',
                            html:
                              '\x3cspan class\x3d"cke_dialog_ui_labeled_content"' +
                              (d.controlStyle ? ' style\x3d"' + d.controlStyle + '"' : '') +
                              '\x3e' +
                              c.call(this, b, d) +
                              '\x3c/span\x3e',
                          },
                        ],
                      }),
                      CKEDITOR.dialog._.uiElementBuilders.hbox.build(b, e, a));
                  return a.join('');
                });
              }
            },
            textInput: function (b, d, e) {
              if (!(3 > arguments.length)) {
                a.call(this, d);
                var c = (this._.inputId = CKEDITOR.tools.getNextId() + '_textInput'),
                  f = { class: 'cke_dialog_ui_input_' + d.type, id: c, type: d.type };
                d.validate && (this.validate = d.validate);
                d.maxLength && (f.maxlength = d.maxLength);
                d.size && (f.size = d.size);
                d.inputStyle && (f.style = d.inputStyle);
                var k = this,
                  h = !1;
                b.on('load', function () {
                  k.getInputElement().on('keydown', function (a) {
                    13 == a.data.getKeystroke() && (h = !0);
                  });
                  k.getInputElement().on(
                    'keyup',
                    function (a) {
                      13 == a.data.getKeystroke() &&
                        h &&
                        (b.getButton('ok') &&
                          setTimeout(function () {
                            b.getButton('ok').click();
                          }, 0),
                        (h = !1));
                      k.bidi && m.call(k, a);
                    },
                    null,
                    null,
                    1e3,
                  );
                });
                CKEDITOR.ui.dialog.labeledElement.call(this, b, d, e, function () {
                  var a = ['\x3cdiv class\x3d"cke_dialog_ui_input_', d.type, '" role\x3d"presentation"'];
                  d.width && a.push('style\x3d"width:' + d.width + '" ');
                  a.push('\x3e\x3cinput ');
                  f['aria-labelledby'] = this._.labelId;
                  this._.required && (f['aria-required'] = this._.required);
                  for (var b in f) a.push(b + '\x3d"' + f[b] + '" ');
                  a.push(' /\x3e\x3c/div\x3e');
                  return a.join('');
                });
              }
            },
            textarea: function (b, d, e) {
              if (!(3 > arguments.length)) {
                a.call(this, d);
                var c = this,
                  f = (this._.inputId = CKEDITOR.tools.getNextId() + '_textarea'),
                  k = {};
                d.validate && (this.validate = d.validate);
                k.rows = d.rows || 5;
                k.cols = d.cols || 20;
                k['class'] = 'cke_dialog_ui_input_textarea ' + (d['class'] || '');
                'undefined' != typeof d.inputStyle && (k.style = d.inputStyle);
                d.dir && (k.dir = d.dir);
                if (c.bidi)
                  b.on(
                    'load',
                    function () {
                      c.getInputElement().on('keyup', m);
                    },
                    c,
                  );
                CKEDITOR.ui.dialog.labeledElement.call(this, b, d, e, function () {
                  k['aria-labelledby'] = this._.labelId;
                  this._.required && (k['aria-required'] = this._.required);
                  var a = ['\x3cdiv class\x3d"cke_dialog_ui_input_textarea" role\x3d"presentation"\x3e\x3ctextarea id\x3d"', f, '" '],
                    b;
                  for (b in k) a.push(b + '\x3d"' + CKEDITOR.tools.htmlEncode(k[b]) + '" ');
                  a.push('\x3e', CKEDITOR.tools.htmlEncode(c._['default']), '\x3c/textarea\x3e\x3c/div\x3e');
                  return a.join('');
                });
              }
            },
            checkbox: function (b, d, e) {
              if (!(3 > arguments.length)) {
                var c = a.call(this, d, { default: !!d['default'] });
                d.validate && (this.validate = d.validate);
                CKEDITOR.ui.dialog.uiElement.call(this, b, d, e, 'span', null, null, function () {
                  var a = CKEDITOR.tools.extend({}, d, { id: d.id ? d.id + '_checkbox' : CKEDITOR.tools.getNextId() + '_checkbox' }, !0),
                    e = [],
                    f = CKEDITOR.tools.getNextId() + '_label',
                    h = { class: 'cke_dialog_ui_checkbox_input', type: 'checkbox', 'aria-labelledby': f };
                  k(a);
                  d['default'] && (h.checked = 'checked');
                  'undefined' != typeof a.inputStyle && (a.style = a.inputStyle);
                  c.checkbox = new CKEDITOR.ui.dialog.uiElement(b, a, e, 'input', null, h);
                  e.push(
                    ' \x3clabel id\x3d"',
                    f,
                    '" for\x3d"',
                    h.id,
                    '"' + (d.labelStyle ? ' style\x3d"' + d.labelStyle + '"' : '') + '\x3e',
                    CKEDITOR.tools.htmlEncode(d.label),
                    '\x3c/label\x3e',
                  );
                  return e.join('');
                });
              }
            },
            radio: function (b, d, e) {
              if (!(3 > arguments.length)) {
                a.call(this, d);
                this._['default'] || (this._['default'] = this._.initValue = d.items[0][1]);
                d.validate && (this.validate = d.validate);
                var c = [],
                  f = this;
                d.role = 'radiogroup';
                d.includeLabel = !0;
                CKEDITOR.ui.dialog.labeledElement.call(this, b, d, e, function () {
                  for (var a = [], e = [], h = (d.id ? d.id : CKEDITOR.tools.getNextId()) + '_radio', m = 0; m < d.items.length; m++) {
                    var l = d.items[m],
                      q = void 0 !== l[2] ? l[2] : l[0],
                      B = void 0 !== l[1] ? l[1] : l[0],
                      z = CKEDITOR.tools.getNextId() + '_radio_input',
                      y = z + '_label',
                      z = CKEDITOR.tools.extend({}, d, { id: z, title: null, type: null }, !0),
                      q = CKEDITOR.tools.extend({}, z, { title: q }, !0),
                      v = { type: 'radio', class: 'cke_dialog_ui_radio_input', name: h, value: B, 'aria-labelledby': y },
                      C = [];
                    f._['default'] == B && (v.checked = 'checked');
                    k(z);
                    k(q);
                    'undefined' != typeof z.inputStyle && (z.style = z.inputStyle);
                    z.keyboardFocusable = !0;
                    c.push(new CKEDITOR.ui.dialog.uiElement(b, z, C, 'input', null, v));
                    C.push(' ');
                    new CKEDITOR.ui.dialog.uiElement(b, q, C, 'label', null, { id: y, for: v.id }, l[0]);
                    a.push(C.join(''));
                  }
                  new CKEDITOR.ui.dialog.hbox(b, c, a, e);
                  return e.join('');
                });
                this._.children = c;
              }
            },
            button: function (b, d, e) {
              if (arguments.length) {
                'function' == typeof d && (d = d(b.getParentEditor()));
                a.call(this, d, { disabled: d.disabled || !1 });
                CKEDITOR.event.implementOn(this);
                var c = this;
                b.on(
                  'load',
                  function () {
                    var a = this.getElement();
                    (function () {
                      a.on('click', function (a) {
                        c.click();
                        a.data.preventDefault();
                      });
                      a.on('keydown', function (a) {
                        a.data.getKeystroke() in { 32: 1 } && (c.click(), a.data.preventDefault());
                      });
                    })();
                    a.unselectable();
                  },
                  this,
                );
                var f = CKEDITOR.tools.extend({}, d);
                delete f.style;
                var k = CKEDITOR.tools.getNextId() + '_label';
                CKEDITOR.ui.dialog.uiElement.call(
                  this,
                  b,
                  f,
                  e,
                  'a',
                  null,
                  {
                    style: d.style,
                    href: 'javascript:void(0)',
                    title: d.label,
                    hidefocus: 'true',
                    class: d['class'],
                    role: 'button',
                    'aria-labelledby': k,
                  },
                  '\x3cspan id\x3d"' + k + '" class\x3d"cke_dialog_ui_button"\x3e' + CKEDITOR.tools.htmlEncode(d.label) + '\x3c/span\x3e',
                );
              }
            },
            select: function (b, d, e) {
              if (!(3 > arguments.length)) {
                var c = a.call(this, d);
                d.validate && (this.validate = d.validate);
                c.inputId = CKEDITOR.tools.getNextId() + '_select';
                CKEDITOR.ui.dialog.labeledElement.call(this, b, d, e, function () {
                  var a = CKEDITOR.tools.extend({}, d, { id: d.id ? d.id + '_select' : CKEDITOR.tools.getNextId() + '_select' }, !0),
                    e = [],
                    f = [],
                    h = { id: c.inputId, class: 'cke_dialog_ui_input_select', 'aria-labelledby': this._.labelId };
                  e.push('\x3cdiv class\x3d"cke_dialog_ui_input_', d.type, '" role\x3d"presentation"');
                  d.width && e.push('style\x3d"width:' + d.width + '" ');
                  e.push('\x3e');
                  void 0 !== d.size && (h.size = d.size);
                  void 0 !== d.multiple && (h.multiple = d.multiple);
                  k(a);
                  for (var m = 0, l; m < d.items.length && (l = d.items[m]); m++)
                    f.push(
                      '\x3coption value\x3d"',
                      CKEDITOR.tools.htmlEncode(void 0 !== l[1] ? l[1] : l[0]).replace(/"/g, '\x26quot;'),
                      '" /\x3e ',
                      CKEDITOR.tools.htmlEncode(l[0]),
                    );
                  'undefined' != typeof a.inputStyle && (a.style = a.inputStyle);
                  c.select = new CKEDITOR.ui.dialog.uiElement(b, a, e, 'select', null, h, f.join(''));
                  e.push('\x3c/div\x3e');
                  return e.join('');
                });
              }
            },
            file: function (b, d, e) {
              if (!(3 > arguments.length)) {
                void 0 === d['default'] && (d['default'] = '');
                var c = CKEDITOR.tools.extend(a.call(this, d), { definition: d, buttons: [] });
                d.validate && (this.validate = d.validate);
                b.on('load', function () {
                  CKEDITOR.document.getById(c.frameId).getParent().addClass('cke_dialog_ui_input_file');
                });
                CKEDITOR.ui.dialog.labeledElement.call(this, b, d, e, function () {
                  c.frameId = CKEDITOR.tools.getNextId() + '_fileInput';
                  var a = [
                    '\x3ciframe frameborder\x3d"0" allowtransparency\x3d"0" class\x3d"cke_dialog_ui_input_file" role\x3d"presentation" id\x3d"',
                    c.frameId,
                    '" title\x3d"',
                    d.label,
                    '" src\x3d"javascript:void(',
                  ];
                  a.push(
                    CKEDITOR.env.ie
                      ? '(function(){' +
                          encodeURIComponent('document.open();(' + CKEDITOR.tools.fixDomain + ')();document.close();') +
                          '})()'
                      : '0',
                  );
                  a.push(')"\x3e\x3c/iframe\x3e');
                  return a.join('');
                });
              }
            },
            fileButton: function (b, d, e) {
              var c = this;
              if (!(3 > arguments.length)) {
                a.call(this, d);
                d.validate && (this.validate = d.validate);
                var f = CKEDITOR.tools.extend({}, d),
                  k = f.onClick;
                f.className = (f.className ? f.className + ' ' : '') + 'cke_dialog_ui_button';
                f.onClick = function (a) {
                  var e = d['for'];
                  a = k ? k.call(this, a) : !1;
                  !1 !== a && ('xhr' !== a && b.getContentElement(e[0], e[1]).submit(), this.disable());
                };
                b.on('load', function () {
                  b.getContentElement(d['for'][0], d['for'][1])._.buttons.push(c);
                });
                CKEDITOR.ui.dialog.button.call(this, b, f, e);
              }
            },
            html: (function () {
              var a = /^\s*<[\w:]+\s+([^>]*)?>/,
                b = /^(\s*<[\w:]+(?:\s+[^>]*)?)((?:.|\r|\n)+)$/,
                e = /\/$/;
              return function (c, f, k) {
                if (!(3 > arguments.length)) {
                  var h = [],
                    m = f.html;
                  '\x3c' != m.charAt(0) && (m = '\x3cspan\x3e' + m + '\x3c/span\x3e');
                  var l = f.focus;
                  if (l) {
                    var A = this.focus;
                    this.focus = function () {
                      ('function' == typeof l ? l : A).call(this);
                      this.fire('focus');
                    };
                    f.isFocusable && (this.isFocusable = this.isFocusable);
                    this.keyboardFocusable = !0;
                  }
                  CKEDITOR.ui.dialog.uiElement.call(this, c, f, h, 'span', null, null, '');
                  h = h.join('').match(a);
                  m = m.match(b) || ['', '', ''];
                  e.test(m[1]) && ((m[1] = m[1].slice(0, -1)), (m[2] = '/' + m[2]));
                  k.push([m[1], ' ', h[1] || '', m[2]].join(''));
                }
              };
            })(),
            fieldset: function (a, b, e, c, f) {
              var k = f.label;
              this._ = { children: b };
              CKEDITOR.ui.dialog.uiElement.call(this, a, f, c, 'fieldset', null, null, function () {
                var a = [];
                k && a.push('\x3clegend' + (f.labelStyle ? ' style\x3d"' + f.labelStyle + '"' : '') + '\x3e' + k + '\x3c/legend\x3e');
                for (var b = 0; b < e.length; b++) a.push(e[b]);
                return a.join('');
              });
            },
          },
          !0,
        );
        CKEDITOR.ui.dialog.html.prototype = new CKEDITOR.ui.dialog.uiElement();
        CKEDITOR.ui.dialog.labeledElement.prototype = CKEDITOR.tools.extend(
          new CKEDITOR.ui.dialog.uiElement(),
          {
            setLabel: function (a) {
              var b = CKEDITOR.document.getById(this._.labelId);
              1 > b.getChildCount() ? new CKEDITOR.dom.text(a, CKEDITOR.document).appendTo(b) : (b.getChild(0).$.nodeValue = a);
              return this;
            },
            getLabel: function () {
              var a = CKEDITOR.document.getById(this._.labelId);
              return !a || 1 > a.getChildCount() ? '' : a.getChild(0).getText();
            },
            eventProcessors: c,
          },
          !0,
        );
        CKEDITOR.ui.dialog.button.prototype = CKEDITOR.tools.extend(
          new CKEDITOR.ui.dialog.uiElement(),
          {
            click: function () {
              return this._.disabled ? !1 : this.fire('click', { dialog: this._.dialog });
            },
            enable: function () {
              this._.disabled = !1;
              var a = this.getElement();
              a && a.removeClass('cke_disabled');
            },
            disable: function () {
              this._.disabled = !0;
              this.getElement().addClass('cke_disabled');
            },
            isVisible: function () {
              return this.getElement().getFirst().isVisible();
            },
            isEnabled: function () {
              return !this._.disabled;
            },
            eventProcessors: CKEDITOR.tools.extend(
              {},
              CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,
              {
                onClick: function (a, b) {
                  this.on('click', function () {
                    b.apply(this, arguments);
                  });
                },
              },
              !0,
            ),
            accessKeyUp: function () {
              this.click();
            },
            accessKeyDown: function () {
              this.focus();
            },
            keyboardFocusable: !0,
          },
          !0,
        );
        CKEDITOR.ui.dialog.textInput.prototype = CKEDITOR.tools.extend(
          new CKEDITOR.ui.dialog.labeledElement(),
          {
            getInputElement: function () {
              return CKEDITOR.document.getById(this._.inputId);
            },
            focus: function () {
              var a = this.selectParentTab();
              setTimeout(function () {
                var b = a.getInputElement();
                b && b.$.focus();
              }, 0);
            },
            select: function () {
              var a = this.selectParentTab();
              setTimeout(function () {
                var b = a.getInputElement();
                b && (b.$.focus(), b.$.select());
              }, 0);
            },
            accessKeyUp: function () {
              this.select();
            },
            setValue: function (a) {
              if (this.bidi) {
                var b = a && a.charAt(0);
                (b = '‪' == b ? 'ltr' : '‫' == b ? 'rtl' : null) && (a = a.slice(1));
                this.setDirectionMarker(b);
              }
              a || (a = '');
              return CKEDITOR.ui.dialog.uiElement.prototype.setValue.apply(this, arguments);
            },
            getValue: function () {
              var a = CKEDITOR.ui.dialog.uiElement.prototype.getValue.call(this);
              if (this.bidi && a) {
                var b = this.getDirectionMarker();
                b && (a = ('ltr' == b ? '‪' : '‫') + a);
              }
              return a;
            },
            setDirectionMarker: function (a) {
              var b = this.getInputElement();
              a
                ? b.setAttributes({ dir: a, 'data-cke-dir-marker': a })
                : this.getDirectionMarker() && b.removeAttributes(['dir', 'data-cke-dir-marker']);
            },
            getDirectionMarker: function () {
              return this.getInputElement().data('cke-dir-marker');
            },
            keyboardFocusable: !0,
          },
          b,
          !0,
        );
        CKEDITOR.ui.dialog.textarea.prototype = new CKEDITOR.ui.dialog.textInput();
        CKEDITOR.ui.dialog.select.prototype = CKEDITOR.tools.extend(
          new CKEDITOR.ui.dialog.labeledElement(),
          {
            getInputElement: function () {
              return this._.select.getElement();
            },
            add: function (a, b, e) {
              var c = new CKEDITOR.dom.element('option', this.getDialog().getParentEditor().document),
                f = this.getInputElement().$;
              c.$.text = a;
              c.$.value = void 0 === b || null === b ? a : b;
              void 0 === e || null === e ? (CKEDITOR.env.ie ? f.add(c.$) : f.add(c.$, null)) : f.add(c.$, e);
              return this;
            },
            remove: function (a) {
              this.getInputElement().$.remove(a);
              return this;
            },
            clear: function () {
              for (var a = this.getInputElement().$; 0 < a.length; ) a.remove(0);
              return this;
            },
            keyboardFocusable: !0,
          },
          b,
          !0,
        );
        CKEDITOR.ui.dialog.checkbox.prototype = CKEDITOR.tools.extend(
          new CKEDITOR.ui.dialog.uiElement(),
          {
            getInputElement: function () {
              return this._.checkbox.getElement();
            },
            setValue: function (a, b) {
              this.getInputElement().$.checked = a;
              !b && this.fire('change', { value: a });
              return this;
            },
            getValue: function () {
              return this.getInputElement().$.checked;
            },
            accessKeyUp: function () {
              this.setValue(!this.getValue());
            },
            eventProcessors: {
              onChange: function (a, b) {
                if (!CKEDITOR.env.ie || 8 < CKEDITOR.env.version) return c.onChange.apply(this, arguments);
                a.on(
                  'load',
                  function () {
                    var a = this._.checkbox.getElement();
                    a.on(
                      'propertychange',
                      function (b) {
                        b = b.data.$;
                        'checked' == b.propertyName && this.fire('change', { value: a.$.checked });
                      },
                      this,
                    );
                  },
                  this,
                );
                this.on('change', b);
                return null;
              },
            },
            keyboardFocusable: !0,
          },
          b,
          !0,
        );
        CKEDITOR.ui.dialog.radio.prototype = CKEDITOR.tools.extend(
          new CKEDITOR.ui.dialog.uiElement(),
          {
            setValue: function (a, b) {
              for (var e = this._.children, c, f = 0; f < e.length && (c = e[f]); f++) c.getElement().$.checked = c.getValue() == a;
              !b && this.fire('change', { value: a });
              return this;
            },
            getValue: function () {
              for (var a = this._.children, b = 0; b < a.length; b++) if (a[b].getElement().$.checked) return a[b].getValue();
              return null;
            },
            accessKeyUp: function () {
              var a = this._.children,
                b;
              for (b = 0; b < a.length; b++)
                if (a[b].getElement().$.checked) {
                  a[b].getElement().focus();
                  return;
                }
              a[0].getElement().focus();
            },
            eventProcessors: {
              onChange: function (a, b) {
                if (!CKEDITOR.env.ie || 8 < CKEDITOR.env.version) return c.onChange.apply(this, arguments);
                a.on(
                  'load',
                  function () {
                    for (var a = this._.children, b = this, d = 0; d < a.length; d++)
                      a[d].getElement().on('propertychange', function (a) {
                        a = a.data.$;
                        'checked' == a.propertyName && this.$.checked && b.fire('change', { value: this.getAttribute('value') });
                      });
                  },
                  this,
                );
                this.on('change', b);
                return null;
              },
            },
          },
          b,
          !0,
        );
        CKEDITOR.ui.dialog.file.prototype = CKEDITOR.tools.extend(
          new CKEDITOR.ui.dialog.labeledElement(),
          b,
          {
            getInputElement: function () {
              var a = CKEDITOR.document.getById(this._.frameId).getFrameDocument();
              return 0 < a.$.forms.length ? new CKEDITOR.dom.element(a.$.forms[0].elements[0]) : this.getElement();
            },
            submit: function () {
              this.getInputElement().getParent().$.submit();
              return this;
            },
            getAction: function () {
              return this.getInputElement().getParent().$.action;
            },
            registerEvents: function (a) {
              var b = /^on([A-Z]\w+)/,
                e,
                c = function (a, b, e, d) {
                  a.on('formLoaded', function () {
                    a.getInputElement().on(e, d, a);
                  });
                },
                f;
              for (f in a)
                if ((e = f.match(b)))
                  this.eventProcessors[f]
                    ? this.eventProcessors[f].call(this, this._.dialog, a[f])
                    : c(this, this._.dialog, e[1].toLowerCase(), a[f]);
              return this;
            },
            reset: function () {
              function a() {
                e.$.open();
                var g = '';
                c.size && (g = c.size - (CKEDITOR.env.ie ? 7 : 0));
                var q = b.frameId + '_input';
                e.$.write(
                  [
                    '\x3chtml dir\x3d"' +
                      m +
                      '" lang\x3d"' +
                      l +
                      '"\x3e\x3chead\x3e\x3ctitle\x3e\x3c/title\x3e\x3c/head\x3e\x3cbody style\x3d"margin: 0; overflow: hidden; background: transparent;"\x3e',
                    '\x3cform enctype\x3d"multipart/form-data" method\x3d"POST" dir\x3d"' + m + '" lang\x3d"' + l + '" action\x3d"',
                    CKEDITOR.tools.htmlEncode(c.action),
                    '"\x3e\x3clabel id\x3d"',
                    b.labelId,
                    '" for\x3d"',
                    q,
                    '" style\x3d"display:none"\x3e',
                    CKEDITOR.tools.htmlEncode(c.label),
                    '\x3c/label\x3e\x3cinput style\x3d"width:100%" id\x3d"',
                    q,
                    '" aria-labelledby\x3d"',
                    b.labelId,
                    '" type\x3d"file" name\x3d"',
                    CKEDITOR.tools.htmlEncode(c.id || 'cke_upload'),
                    '" size\x3d"',
                    CKEDITOR.tools.htmlEncode(0 < g ? g : ''),
                    '" /\x3e\x3c/form\x3e\x3c/body\x3e\x3c/html\x3e\x3cscript\x3e',
                    CKEDITOR.env.ie ? '(' + CKEDITOR.tools.fixDomain + ')();' : '',
                    'window.parent.CKEDITOR.tools.callFunction(' + k + ');',
                    'window.onbeforeunload \x3d function() {window.parent.CKEDITOR.tools.callFunction(' + h + ')}',
                    '\x3c/script\x3e',
                  ].join(''),
                );
                e.$.close();
                for (g = 0; g < f.length; g++) f[g].enable();
              }
              var b = this._,
                e = CKEDITOR.document.getById(b.frameId).getFrameDocument(),
                c = b.definition,
                f = b.buttons,
                k = this.formLoadedNumber,
                h = this.formUnloadNumber,
                m = b.dialog._.editor.lang.dir,
                l = b.dialog._.editor.langCode;
              k ||
                ((k = this.formLoadedNumber =
                  CKEDITOR.tools.addFunction(function () {
                    this.fire('formLoaded');
                  }, this)),
                (h = this.formUnloadNumber =
                  CKEDITOR.tools.addFunction(function () {
                    this.getInputElement().clearCustomData();
                  }, this)),
                this.getDialog()._.editor.on('destroy', function () {
                  CKEDITOR.tools.removeFunction(k);
                  CKEDITOR.tools.removeFunction(h);
                }));
              CKEDITOR.env.gecko ? setTimeout(a, 500) : a();
            },
            getValue: function () {
              return this.getInputElement().$.value || '';
            },
            setInitValue: function () {
              this._.initValue = '';
            },
            eventProcessors: {
              onChange: function (a, b) {
                this._.domOnChangeRegistered ||
                  (this.on(
                    'formLoaded',
                    function () {
                      this.getInputElement().on(
                        'change',
                        function () {
                          this.fire('change', { value: this.getValue() });
                        },
                        this,
                      );
                    },
                    this,
                  ),
                  (this._.domOnChangeRegistered = !0));
                this.on('change', b);
              },
            },
            keyboardFocusable: !0,
          },
          !0,
        );
        CKEDITOR.ui.dialog.fileButton.prototype = new CKEDITOR.ui.dialog.button();
        CKEDITOR.ui.dialog.fieldset.prototype = CKEDITOR.tools.clone(CKEDITOR.ui.dialog.hbox.prototype);
        CKEDITOR.dialog.addUIElement('text', h);
        CKEDITOR.dialog.addUIElement('password', h);
        CKEDITOR.dialog.addUIElement('tel', h);
        CKEDITOR.dialog.addUIElement('textarea', f);
        CKEDITOR.dialog.addUIElement('checkbox', f);
        CKEDITOR.dialog.addUIElement('radio', f);
        CKEDITOR.dialog.addUIElement('button', f);
        CKEDITOR.dialog.addUIElement('select', f);
        CKEDITOR.dialog.addUIElement('file', f);
        CKEDITOR.dialog.addUIElement('fileButton', f);
        CKEDITOR.dialog.addUIElement('html', f);
        CKEDITOR.dialog.addUIElement('fieldset', {
          build: function (a, b, e) {
            for (var c = b.children, f, k = [], h = [], m = 0; m < c.length && (f = c[m]); m++) {
              var l = [];
              k.push(l);
              h.push(CKEDITOR.dialog._.uiElementBuilders[f.type].build(a, f, l));
            }
            return new CKEDITOR.ui.dialog[b.type](a, h, k, e, b);
          },
        });
      },
    });
    CKEDITOR.DIALOG_RESIZE_NONE = 0;
    CKEDITOR.DIALOG_RESIZE_WIDTH = 1;
    CKEDITOR.DIALOG_RESIZE_HEIGHT = 2;
    CKEDITOR.DIALOG_RESIZE_BOTH = 3;
    CKEDITOR.DIALOG_STATE_IDLE = 1;
    CKEDITOR.DIALOG_STATE_BUSY = 2;
    (function () {
      function a(a) {
        a._.tabBarMode = !0;
        a._.tabs[a._.currentTabId][0].focus();
        a._.currentFocusIndex = -1;
      }
      function h() {
        for (
          var a = this._.tabIdList.length, b = CKEDITOR.tools.indexOf(this._.tabIdList, this._.currentTabId) + a, e = b - 1;
          e > b - a;
          e--
        )
          if (this._.tabs[this._.tabIdList[e % a]][0].$.offsetHeight) return this._.tabIdList[e % a];
        return null;
      }
      function f() {
        for (var a = this._.tabIdList.length, b = CKEDITOR.tools.indexOf(this._.tabIdList, this._.currentTabId), e = b + 1; e < b + a; e++)
          if (this._.tabs[this._.tabIdList[e % a]][0].$.offsetHeight) return this._.tabIdList[e % a];
        return null;
      }
      function b(a, b) {
        for (var e = a.$.getElementsByTagName('input'), d = 0, c = e.length; d < c; d++) {
          var g = new CKEDITOR.dom.element(e[d]);
          'text' == g.getAttribute('type').toLowerCase() &&
            (b
              ? (g.setAttribute('value', g.getCustomData('fake_value') || ''), g.removeCustomData('fake_value'))
              : (g.setCustomData('fake_value', g.getAttribute('value')), g.setAttribute('value', '')));
        }
      }
      function c(a, b) {
        var e = this.getInputElement();
        e && (a ? e.removeAttribute('aria-invalid') : e.setAttribute('aria-invalid', !0));
        a || (this.select ? this.select() : this.focus());
        b && alert(b);
        this.fire('validated', { valid: a, msg: b });
      }
      function l() {
        var a = this.getInputElement();
        a && a.removeAttribute('aria-invalid');
      }
      function k(a) {
        var b = CKEDITOR.dom.element.createFromHtml(
            CKEDITOR.addTemplate('dialog', L).output({
              id: CKEDITOR.tools.getNextNumber(),
              editorId: a.id,
              langDir: a.lang.dir,
              langCode: a.langCode,
              editorDialogClass: 'cke_editor_' + a.name.replace(/\./g, '\\.') + '_dialog',
              closeTitle: a.lang.common.close,
              hidpi: CKEDITOR.env.hidpi ? 'cke_hidpi' : '',
            }),
          ),
          e = b.getChild([0, 0, 0, 0, 0]),
          d = e.getChild(0),
          c = e.getChild(1);
        a.plugins.clipboard && CKEDITOR.plugins.clipboard.preventDefaultDropOnElement(e);
        !CKEDITOR.env.ie ||
          CKEDITOR.env.quirks ||
          CKEDITOR.env.edge ||
          ((a =
            'javascript:void(function(){' +
            encodeURIComponent('document.open();(' + CKEDITOR.tools.fixDomain + ')();document.close();') +
            '}())'),
          CKEDITOR.dom.element
            .createFromHtml(
              '\x3ciframe frameBorder\x3d"0" class\x3d"cke_iframe_shim" src\x3d"' + a + '" tabIndex\x3d"-1"\x3e\x3c/iframe\x3e',
            )
            .appendTo(e.getParent()));
        d.unselectable();
        c.unselectable();
        return {
          element: b,
          parts: {
            dialog: b.getChild(0),
            title: d,
            close: c,
            tabs: e.getChild(2),
            contents: e.getChild([3, 0, 0, 0]),
            footer: e.getChild([3, 0, 1, 0]),
          },
        };
      }
      function m(a, b, e) {
        this.element = b;
        this.focusIndex = e;
        this.tabIndex = 0;
        this.isFocusable = function () {
          return !b.getAttribute('disabled') && b.isVisible();
        };
        this.focus = function () {
          a._.currentFocusIndex = this.focusIndex;
          this.element.focus();
        };
        b.on('keydown', function (a) {
          a.data.getKeystroke() in { 32: 1, 13: 1 } && this.fire('click');
        });
        b.on('focus', function () {
          this.fire('mouseover');
        });
        b.on('blur', function () {
          this.fire('mouseout');
        });
      }
      function g(a) {
        function b() {
          a.layout();
        }
        var e = CKEDITOR.document.getWindow();
        e.on('resize', b);
        a.on('hide', function () {
          e.removeListener('resize', b);
        });
      }
      function d(a, b) {
        this.dialog = a;
        for (var d = b.contents, c = 0, g; (g = d[c]); c++) d[c] = g && new e(a, g);
        CKEDITOR.tools.extend(this, b);
      }
      function e(a, b) {
        this._ = { dialog: a };
        CKEDITOR.tools.extend(this, b);
      }
      function n(a) {
        function b(e) {
          var h = a.getSize(),
            m = a.parts.dialog.getParent().getClientSize(),
            l = e.data.$.screenX,
            n = e.data.$.screenY,
            r = l - d.x,
            q = n - d.y;
          d = { x: l, y: n };
          c.x += r;
          c.y += q;
          l = c.x + k[3] < f ? -k[3] : c.x - k[1] > m.width - h.width - f ? m.width - h.width + ('rtl' == g.lang.dir ? 0 : k[1]) : c.x;
          h = c.y + k[0] < f ? -k[0] : c.y - k[2] > m.height - h.height - f ? m.height - h.height + k[2] : c.y;
          l = Math.floor(l);
          h = Math.floor(h);
          a.move(l, h, 1);
          e.data.preventDefault();
        }
        function e() {
          CKEDITOR.document.removeListener('mousemove', b);
          CKEDITOR.document.removeListener('mouseup', e);
          if (CKEDITOR.env.ie6Compat) {
            var a = D.getChild(0).getFrameDocument();
            a.removeListener('mousemove', b);
            a.removeListener('mouseup', e);
          }
        }
        var d = null,
          c = null,
          g = a.getParentEditor(),
          f = g.config.dialog_magnetDistance,
          k = CKEDITOR.skin.margins || [0, 0, 0, 0];
        'undefined' == typeof f && (f = 20);
        a.parts.title.on(
          'mousedown',
          function (g) {
            if (!a._.moved) {
              var f = a._.element;
              f.getFirst().setStyle('position', 'absolute');
              f.removeStyle('display');
              a._.moved = !0;
              a.layout();
            }
            d = { x: g.data.$.screenX, y: g.data.$.screenY };
            CKEDITOR.document.on('mousemove', b);
            CKEDITOR.document.on('mouseup', e);
            c = a.getPosition();
            CKEDITOR.env.ie6Compat && ((f = D.getChild(0).getFrameDocument()), f.on('mousemove', b), f.on('mouseup', e));
            g.data.preventDefault();
          },
          a,
        );
      }
      function r(a) {
        function b(e) {
          var n = 'rtl' == g.lang.dir,
            r = l.width,
            q = l.height,
            v = r + (e.data.$.screenX - m.x) * (n ? -1 : 1) * (a._.moved ? 1 : 2),
            J = q + (e.data.$.screenY - m.y) * (a._.moved ? 1 : 2),
            t = a._.element.getFirst(),
            t = n && parseInt(t.getComputedStyle('right'), 10),
            z = a.getPosition();
          z.x = z.x || 0;
          z.y = z.y || 0;
          z.y + J > h.height && (J = h.height - z.y);
          (n ? t : z.x) + v > h.width && (v = h.width - (n ? t : z.x));
          J = Math.floor(J);
          v = Math.floor(v);
          if (c == CKEDITOR.DIALOG_RESIZE_WIDTH || c == CKEDITOR.DIALOG_RESIZE_BOTH) r = Math.max(d.minWidth || 0, v - f);
          if (c == CKEDITOR.DIALOG_RESIZE_HEIGHT || c == CKEDITOR.DIALOG_RESIZE_BOTH) q = Math.max(d.minHeight || 0, J - k);
          a.resize(r, q);
          a._.moved && x(a, a._.position.x, a._.position.y);
          a._.moved || a.layout();
          e.data.preventDefault();
        }
        function e() {
          CKEDITOR.document.removeListener('mouseup', e);
          CKEDITOR.document.removeListener('mousemove', b);
          n && (n.remove(), (n = null));
          if (CKEDITOR.env.ie6Compat) {
            var a = D.getChild(0).getFrameDocument();
            a.removeListener('mouseup', e);
            a.removeListener('mousemove', b);
          }
        }
        var d = a.definition,
          c = d.resizable;
        if (c != CKEDITOR.DIALOG_RESIZE_NONE) {
          var g = a.getParentEditor(),
            f,
            k,
            h,
            m,
            l,
            n,
            r = CKEDITOR.tools.addFunction(function (d) {
              function c(a) {
                return a.isVisible();
              }
              l = a.getSize();
              var g = a.parts.contents,
                r = g.$.getElementsByTagName('iframe').length,
                q = !(CKEDITOR.env.gecko || (CKEDITOR.env.ie && CKEDITOR.env.quirks));
              r &&
                ((n = CKEDITOR.dom.element.createFromHtml(
                  '\x3cdiv class\x3d"cke_dialog_resize_cover" style\x3d"height: 100%; position: absolute; width: 100%; left:0; top:0;"\x3e\x3c/div\x3e',
                )),
                g.append(n));
              k = l.height - a.parts.contents.getFirst(c).getSize('height', q);
              f = l.width - a.parts.contents.getFirst(c).getSize('width', 1);
              m = { x: d.screenX, y: d.screenY };
              h = CKEDITOR.document.getWindow().getViewPaneSize();
              CKEDITOR.document.on('mousemove', b);
              CKEDITOR.document.on('mouseup', e);
              CKEDITOR.env.ie6Compat && ((g = D.getChild(0).getFrameDocument()), g.on('mousemove', b), g.on('mouseup', e));
              d.preventDefault && d.preventDefault();
            });
          a.on('load', function () {
            var b = '';
            c == CKEDITOR.DIALOG_RESIZE_WIDTH
              ? (b = ' cke_resizer_horizontal')
              : c == CKEDITOR.DIALOG_RESIZE_HEIGHT && (b = ' cke_resizer_vertical');
            b = CKEDITOR.dom.element.createFromHtml(
              '\x3cdiv class\x3d"cke_resizer' +
                b +
                ' cke_resizer_' +
                g.lang.dir +
                '" title\x3d"' +
                CKEDITOR.tools.htmlEncode(g.lang.common.resize) +
                '" onmousedown\x3d"CKEDITOR.tools.callFunction(' +
                r +
                ', event )"\x3e' +
                ('ltr' == g.lang.dir ? '◢' : '◣') +
                '\x3c/div\x3e',
            );
            a.parts.footer.append(b, 1);
          });
          g.on('destroy', function () {
            CKEDITOR.tools.removeFunction(r);
          });
        }
      }
      function x(a, b, e) {
        var d = a.parts.dialog.getParent().getClientSize(),
          c = a.getSize(),
          g = a._.viewportRatio,
          f = Math.max(d.width - c.width, 0),
          d = Math.max(d.height - c.height, 0);
        g.width = f ? b / f : g.width;
        g.height = d ? e / d : g.height;
        a._.viewportRatio = g;
      }
      function u(a) {
        a.data.preventDefault(1);
      }
      function p(a) {
        var b = a.config,
          e = CKEDITOR.skinName || a.config.skin,
          d = b.dialog_backgroundCoverColor || ('moono-lisa' == e ? 'black' : 'white'),
          e = b.dialog_backgroundCoverOpacity,
          c = b.baseFloatZIndex,
          b = CKEDITOR.tools.genKey(d, e, c),
          g = E[b];
        CKEDITOR.document.getBody().addClass('cke_dialog_open');
        g
          ? g.show()
          : ((c = [
              '\x3cdiv tabIndex\x3d"-1" style\x3d"position: ',
              CKEDITOR.env.ie6Compat ? 'absolute' : 'fixed',
              '; z-index: ',
              c,
              '; top: 0px; left: 0px; ',
              '; width: 100%; height: 100%;',
              CKEDITOR.env.ie6Compat ? '' : 'background-color: ' + d,
              '" class\x3d"cke_dialog_background_cover"\x3e',
            ]),
            CKEDITOR.env.ie6Compat &&
              ((d = "\x3chtml\x3e\x3cbody style\x3d\\'background-color:" + d + ";\\'\x3e\x3c/body\x3e\x3c/html\x3e"),
              c.push('\x3ciframe hidefocus\x3d"true" frameborder\x3d"0" id\x3d"cke_dialog_background_iframe" src\x3d"javascript:'),
              c.push(
                'void((function(){' +
                  encodeURIComponent(
                    'document.open();(' + CKEDITOR.tools.fixDomain + ")();document.write( '" + d + "' );document.close();",
                  ) +
                  '})())',
              ),
              c.push(
                '" style\x3d"position:absolute;left:0;top:0;width:100%;height: 100%;filter: progid:DXImageTransform.Microsoft.Alpha(opacity\x3d0)"\x3e\x3c/iframe\x3e',
              )),
            c.push('\x3c/div\x3e'),
            (g = CKEDITOR.dom.element.createFromHtml(c.join(''))),
            g.setOpacity(void 0 !== e ? e : 0.5),
            g.on('keydown', u),
            g.on('keypress', u),
            g.on('keyup', u),
            g.appendTo(CKEDITOR.document.getBody()),
            (E[b] = g));
        a.focusManager.add(g);
        D = g;
        (CKEDITOR.env.mac && CKEDITOR.env.webkit) || g.focus();
      }
      function t(a) {
        CKEDITOR.document.getBody().removeClass('cke_dialog_open');
        D && (a.focusManager.remove(D), D.hide());
      }
      function A(a) {
        var b = a.data.$.ctrlKey || a.data.$.metaKey,
          e = a.data.$.altKey,
          d = a.data.$.shiftKey,
          c = String.fromCharCode(a.data.$.keyCode);
        (b = P[(b ? 'CTRL+' : '') + (e ? 'ALT+' : '') + (d ? 'SHIFT+' : '') + c]) &&
          b.length &&
          ((b = b[b.length - 1]), b.keydown && b.keydown.call(b.uiElement, b.dialog, b.key), a.data.preventDefault());
      }
      function q(a) {
        var b = a.data.$.ctrlKey || a.data.$.metaKey,
          e = a.data.$.altKey,
          d = a.data.$.shiftKey,
          c = String.fromCharCode(a.data.$.keyCode);
        (b = P[(b ? 'CTRL+' : '') + (e ? 'ALT+' : '') + (d ? 'SHIFT+' : '') + c]) &&
          b.length &&
          ((b = b[b.length - 1]), b.keyup && (b.keyup.call(b.uiElement, b.dialog, b.key), a.data.preventDefault()));
      }
      function B(a, b, e, d, c) {
        (P[e] || (P[e] = [])).push({ uiElement: a, dialog: b, key: e, keyup: c || a.accessKeyUp, keydown: d || a.accessKeyDown });
      }
      function z(a) {
        for (var b in P) {
          for (var e = P[b], d = e.length - 1; 0 <= d; d--) (e[d].dialog != a && e[d].uiElement != a) || e.splice(d, 1);
          0 === e.length && delete P[b];
        }
      }
      function y(a, b) {
        a._.accessKeyMap[b] && a.selectPage(a._.accessKeyMap[b]);
      }
      function v() {}
      var C = CKEDITOR.tools.cssLength,
        F,
        D,
        G = !1,
        H = !CKEDITOR.env.ie || CKEDITOR.env.edge,
        L =
          '\x3cdiv class\x3d"cke_reset_all cke_dialog_container {editorId} {editorDialogClass} {hidpi}" dir\x3d"{langDir}" style\x3d"' +
          (H ? 'display:flex' : '') +
          '" lang\x3d"{langCode}" role\x3d"dialog" aria-labelledby\x3d"cke_dialog_title_{id}"\x3e\x3ctable class\x3d"cke_dialog ' +
          CKEDITOR.env.cssClass +
          ' cke_{langDir}" style\x3d"' +
          (H ? 'margin:auto' : 'position:absolute') +
          '" role\x3d"presentation"\x3e\x3ctr\x3e\x3ctd role\x3d"presentation"\x3e\x3cdiv class\x3d"cke_dialog_body" role\x3d"presentation"\x3e\x3cdiv id\x3d"cke_dialog_title_{id}" class\x3d"cke_dialog_title" role\x3d"presentation"\x3e\x3c/div\x3e\x3ca id\x3d"cke_dialog_close_button_{id}" class\x3d"cke_dialog_close_button" href\x3d"javascript:void(0)" title\x3d"{closeTitle}" role\x3d"button"\x3e\x3cspan class\x3d"cke_label"\x3eX\x3c/span\x3e\x3c/a\x3e\x3cdiv id\x3d"cke_dialog_tabs_{id}" class\x3d"cke_dialog_tabs" role\x3d"tablist"\x3e\x3c/div\x3e\x3ctable class\x3d"cke_dialog_contents" role\x3d"presentation"\x3e\x3ctr\x3e\x3ctd id\x3d"cke_dialog_contents_{id}" class\x3d"cke_dialog_contents_body" role\x3d"presentation"\x3e\x3c/td\x3e\x3c/tr\x3e\x3ctr\x3e\x3ctd id\x3d"cke_dialog_footer_{id}" class\x3d"cke_dialog_footer" role\x3d"presentation"\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3c/div\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3c/div\x3e';
      CKEDITOR.dialog = function (b, e) {
        function g() {
          var a = C._.focusList;
          a.sort(function (a, b) {
            return a.tabIndex != b.tabIndex ? b.tabIndex - a.tabIndex : a.focusIndex - b.focusIndex;
          });
          for (var b = a.length, e = 0; e < b; e++) a[e].focusIndex = e;
        }
        function m(a) {
          var b = C._.focusList;
          a = a || 0;
          if (!(1 > b.length)) {
            var e = C._.currentFocusIndex;
            C._.tabBarMode && 0 > a && (e = 0);
            try {
              b[e].getInputElement().$.blur();
            } catch (d) {}
            var c = e,
              g = 1 < C._.pageCount;
            do {
              c += a;
              if (g && !C._.tabBarMode && (c == b.length || -1 == c)) {
                C._.tabBarMode = !0;
                C._.tabs[C._.currentTabId][0].focus();
                C._.currentFocusIndex = -1;
                return;
              }
              c = (c + b.length) % b.length;
              if (c == e) break;
            } while (a && !b[c].isFocusable());
            b[c].focus();
            'text' == b[c].type && b[c].select();
          }
        }
        function q(e) {
          if (C == CKEDITOR.dialog._.currentTop) {
            var d = e.data.getKeystroke(),
              c = 'rtl' == b.lang.dir,
              g = [37, 38, 39, 40];
            A = B = 0;
            if (9 == d || d == CKEDITOR.SHIFT + 9) m(d == CKEDITOR.SHIFT + 9 ? -1 : 1), (A = 1);
            else if (d == CKEDITOR.ALT + 121 && !C._.tabBarMode && 1 < C.getPageCount()) a(C), (A = 1);
            else if (-1 != CKEDITOR.tools.indexOf(g, d) && C._.tabBarMode)
              (d = -1 != CKEDITOR.tools.indexOf([c ? 39 : 37, 38], d) ? h.call(C) : f.call(C)),
                C.selectPage(d),
                C._.tabs[d][0].focus(),
                (A = 1);
            else if ((13 != d && 32 != d) || !C._.tabBarMode)
              if (13 == d)
                (d = e.data.getTarget()),
                  d.is('a', 'button', 'select', 'textarea') ||
                    (d.is('input') && 'button' == d.$.type) ||
                    ((d = this.getButton('ok')) && CKEDITOR.tools.setTimeout(d.click, 0, d), (A = 1)),
                  (B = 1);
              else if (27 == d)
                (d = this.getButton('cancel'))
                  ? CKEDITOR.tools.setTimeout(d.click, 0, d)
                  : !1 !== this.fire('cancel', { hide: !0 }).hide && this.hide(),
                  (B = 1);
              else return;
            else this.selectPage(this._.currentTabId), (this._.tabBarMode = !1), (this._.currentFocusIndex = -1), m(1), (A = 1);
            v(e);
          }
        }
        function v(a) {
          A ? a.data.preventDefault(1) : B && a.data.stopPropagation();
        }
        var t = CKEDITOR.dialog._.dialogDefinitions[e],
          z = CKEDITOR.tools.clone(F),
          x = b.config.dialog_buttonsOrder || 'OS',
          y = b.lang.dir,
          p = {},
          A,
          B;
        (('OS' == x && CKEDITOR.env.mac) || ('rtl' == x && 'ltr' == y) || ('ltr' == x && 'rtl' == y)) && z.buttons.reverse();
        t = CKEDITOR.tools.extend(t(b), z);
        t = CKEDITOR.tools.clone(t);
        t = new d(this, t);
        z = k(b);
        this._ = {
          editor: b,
          element: z.element,
          name: e,
          model: null,
          contentSize: { width: 0, height: 0 },
          size: { width: 0, height: 0 },
          contents: {},
          buttons: {},
          accessKeyMap: {},
          viewportRatio: { width: 0.5, height: 0.5 },
          tabs: {},
          tabIdList: [],
          currentTabId: null,
          currentTabIndex: null,
          pageCount: 0,
          lastTab: null,
          tabBarMode: !1,
          focusList: [],
          currentFocusIndex: 0,
          hasFocus: !1,
        };
        this.parts = z.parts;
        CKEDITOR.tools.setTimeout(
          function () {
            b.fire('ariaWidget', this.parts.contents);
          },
          0,
          this,
        );
        z = { top: 0, visibility: 'hidden' };
        CKEDITOR.env.ie6Compat && (z.position = 'absolute');
        z['rtl' == y ? 'right' : 'left'] = 0;
        this.parts.dialog.setStyles(z);
        CKEDITOR.event.call(this);
        this.definition = t = CKEDITOR.fire('dialogDefinition', { name: e, definition: t, dialog: this }, b).definition;
        if (!('removeDialogTabs' in b._) && b.config.removeDialogTabs) {
          z = b.config.removeDialogTabs.split(';');
          for (y = 0; y < z.length; y++)
            if (((x = z[y].split(':')), 2 == x.length)) {
              var u = x[0];
              p[u] || (p[u] = []);
              p[u].push(x[1]);
            }
          b._.removeDialogTabs = p;
        }
        if (b._.removeDialogTabs && (p = b._.removeDialogTabs[e])) for (y = 0; y < p.length; y++) t.removeContents(p[y]);
        if (t.onLoad) this.on('load', t.onLoad);
        if (t.onShow) this.on('show', t.onShow);
        if (t.onHide) this.on('hide', t.onHide);
        if (t.onOk)
          this.on('ok', function (a) {
            b.fire('saveSnapshot');
            setTimeout(function () {
              b.fire('saveSnapshot');
            }, 0);
            !1 === t.onOk.call(this, a) && (a.data.hide = !1);
          });
        this.state = CKEDITOR.DIALOG_STATE_IDLE;
        if (t.onCancel)
          this.on('cancel', function (a) {
            !1 === t.onCancel.call(this, a) && (a.data.hide = !1);
          });
        var C = this,
          D = function (a) {
            var b = C._.contents,
              e = !1,
              d;
            for (d in b) for (var c in b[d]) if ((e = a.call(this, b[d][c]))) return;
          };
        this.on(
          'ok',
          function (a) {
            D(function (b) {
              if (b.validate) {
                var e = b.validate(this),
                  d = 'string' == typeof e || !1 === e;
                d && ((a.data.hide = !1), a.stop());
                c.call(b, !d, 'string' == typeof e ? e : void 0);
                return d;
              }
            });
          },
          this,
          null,
          0,
        );
        this.on(
          'cancel',
          function (a) {
            D(function (e) {
              if (e.isChanged()) return b.config.dialog_noConfirmCancel || confirm(b.lang.common.confirmCancel) || (a.data.hide = !1), !0;
            });
          },
          this,
          null,
          0,
        );
        this.parts.close.on(
          'click',
          function (a) {
            !1 !== this.fire('cancel', { hide: !0 }).hide && this.hide();
            a.data.preventDefault();
          },
          this,
        );
        this.changeFocus = m;
        var H = this._.element;
        b.focusManager.add(H, 1);
        this.on('show', function () {
          H.on('keydown', q, this);
          if (CKEDITOR.env.gecko) H.on('keypress', v, this);
        });
        this.on('hide', function () {
          H.removeListener('keydown', q);
          CKEDITOR.env.gecko && H.removeListener('keypress', v);
          D(function (a) {
            l.apply(a);
          });
        });
        this.on('iframeAdded', function (a) {
          new CKEDITOR.dom.document(a.data.iframe.$.contentWindow.document).on('keydown', q, this, null, 0);
        });
        this.on(
          'show',
          function () {
            g();
            var a = 1 < C._.pageCount;
            b.config.dialog_startupFocusTab && a
              ? ((C._.tabBarMode = !0), C._.tabs[C._.currentTabId][0].focus(), (C._.currentFocusIndex = -1))
              : this._.hasFocus ||
                ((this._.currentFocusIndex = a ? -1 : this._.focusList.length - 1),
                t.onFocus ? (a = t.onFocus.call(this)) && a.focus() : m(1));
          },
          this,
          null,
          4294967295,
        );
        if (CKEDITOR.env.ie6Compat)
          this.on(
            'load',
            function () {
              var a = this.getElement(),
                b = a.getFirst();
              b.remove();
              b.appendTo(a);
            },
            this,
          );
        n(this);
        r(this);
        new CKEDITOR.dom.text(t.title, CKEDITOR.document).appendTo(this.parts.title);
        for (y = 0; y < t.contents.length; y++) (p = t.contents[y]) && this.addPage(p);
        this.parts.tabs.on(
          'click',
          function (b) {
            var e = b.data.getTarget();
            e.hasClass('cke_dialog_tab') &&
              ((e = e.$.id), this.selectPage(e.substring(4, e.lastIndexOf('_'))), a(this), b.data.preventDefault());
          },
          this,
        );
        y = [];
        p = CKEDITOR.dialog._.uiElementBuilders.hbox
          .build(this, { type: 'hbox', className: 'cke_dialog_footer_buttons', widths: [], children: t.buttons }, y)
          .getChild();
        this.parts.footer.setHtml(y.join(''));
        for (y = 0; y < p.length; y++) this._.buttons[p[y].id] = p[y];
      };
      CKEDITOR.dialog.prototype = {
        destroy: function () {
          this.hide();
          this._.element.remove();
        },
        resize: function (a, b) {
          if (!this._.contentSize || this._.contentSize.width != a || this._.contentSize.height != b) {
            CKEDITOR.dialog.fire('resize', { dialog: this, width: a, height: b }, this._.editor);
            this.fire('resize', { width: a, height: b }, this._.editor);
            this.parts.contents.setStyles({ width: a + 'px', height: b + 'px' });
            if ('rtl' == this._.editor.lang.dir && this._.position) {
              var e = this.parts.dialog.getParent().getClientSize().width;
              this._.position.x = e - this._.contentSize.width - parseInt(this._.element.getFirst().getStyle('right'), 10);
            }
            this._.contentSize = { width: a, height: b };
          }
        },
        getSize: function () {
          var a = this._.element.getFirst();
          return { width: a.$.offsetWidth || 0, height: a.$.offsetHeight || 0 };
        },
        move: function (a, b, e) {
          var d = this._.element.getFirst(),
            c = 'rtl' == this._.editor.lang.dir;
          CKEDITOR.env.ie && d.setStyle('zoom', '100%');
          var g = this.parts.dialog.getParent().getClientSize(),
            f = this.getSize(),
            k = this._.viewportRatio,
            h = Math.max(g.width - f.width, 0),
            g = Math.max(g.height - f.height, 0);
          this._.position && this._.position.x == a && this._.position.y == b
            ? ((a = Math.floor(h * k.width)), (b = Math.floor(g * k.height)))
            : x(this, a, b);
          this._.position = { x: a, y: b };
          c && (a = h - a);
          b = { top: (0 < b ? b : 0) + 'px' };
          b[c ? 'right' : 'left'] = (0 < a ? a : 0) + 'px';
          d.setStyles(b);
          e && (this._.moved = 1);
        },
        getPosition: function () {
          return CKEDITOR.tools.extend({}, this._.position);
        },
        show: function () {
          var a = this._.element,
            b = this.definition,
            e = CKEDITOR.document.getBody(),
            d = this._.editor.config.baseFloatZIndex;
          a.getParent() && a.getParent().equals(e) ? a.setStyle('display', H ? 'flex' : 'block') : a.appendTo(e);
          this.resize(
            (this._.contentSize && this._.contentSize.width) || b.width || b.minWidth,
            (this._.contentSize && this._.contentSize.height) || b.height || b.minHeight,
          );
          this.reset();
          null === this._.currentTabId && this.selectPage(this.definition.contents[0].id);
          null === CKEDITOR.dialog._.currentZIndex && (CKEDITOR.dialog._.currentZIndex = d);
          this._.element.getFirst().setStyle('z-index', (CKEDITOR.dialog._.currentZIndex += 10));
          this.getElement().setStyle('z-index', CKEDITOR.dialog._.currentZIndex);
          null === CKEDITOR.dialog._.currentTop
            ? ((CKEDITOR.dialog._.currentTop = this), (this._.parentDialog = null), p(this._.editor))
            : CKEDITOR.dialog._.currentTop !== this &&
              ((this._.parentDialog = CKEDITOR.dialog._.currentTop),
              (e = this._.parentDialog.getElement().getFirst()),
              (e.$.style.zIndex -= Math.floor(d / 2)),
              this._.parentDialog.getElement().setStyle('z-index', e.$.style.zIndex),
              (CKEDITOR.dialog._.currentTop = this));
          a.on('keydown', A);
          a.on('keyup', q);
          this._.hasFocus = !1;
          for (var c in b.contents)
            if (b.contents[c]) {
              var a = b.contents[c],
                d = this._.tabs[a.id],
                e = a.requiredContent,
                f = 0;
              if (d) {
                for (var k in this._.contents[a.id]) {
                  var h = this._.contents[a.id][k];
                  'hbox' != h.type &&
                    'vbox' != h.type &&
                    h.getInputElement() &&
                    (h.requiredContent && !this._.editor.activeFilter.check(h.requiredContent) ? h.disable() : (h.enable(), f++));
                }
                !f || (e && !this._.editor.activeFilter.check(e))
                  ? d[0].addClass('cke_dialog_tab_disabled')
                  : d[0].removeClass('cke_dialog_tab_disabled');
              }
            }
          CKEDITOR.tools.setTimeout(
            function () {
              this.layout();
              g(this);
              this.parts.dialog.setStyle('visibility', '');
              this.fireOnce('load', {});
              CKEDITOR.ui.fire('ready', this);
              this.fire('show', {});
              this._.editor.fire('dialogShow', this);
              this._.parentDialog || this._.editor.focusManager.lock();
              this.foreach(function (a) {
                a.setInitValue && a.setInitValue();
              });
            },
            100,
            this,
          );
        },
        layout: function () {
          var a = this.parts.dialog;
          if (this._.moved || !H) {
            var b = this.getSize(),
              e = CKEDITOR.document.getWindow().getViewPaneSize(),
              d;
            this._.moved && this._.position
              ? ((d = this._.position.x), (b = this._.position.y))
              : ((d = (e.width - b.width) / 2), (b = (e.height - b.height) / 2));
            CKEDITOR.env.ie6Compat || (a.setStyle('position', 'absolute'), a.removeStyle('margin'));
            d = Math.floor(d);
            b = Math.floor(b);
            this.move(d, b);
          }
        },
        foreach: function (a) {
          for (var b in this._.contents) for (var e in this._.contents[b]) a.call(this, this._.contents[b][e]);
          return this;
        },
        reset: (function () {
          var a = function (a) {
            a.reset && a.reset(1);
          };
          return function () {
            this.foreach(a);
            return this;
          };
        })(),
        setupContent: function () {
          var a = arguments;
          this.foreach(function (b) {
            b.setup && b.setup.apply(b, a);
          });
        },
        commitContent: function () {
          var a = arguments;
          this.foreach(function (b) {
            CKEDITOR.env.ie && this._.currentFocusIndex == b.focusIndex && b.getInputElement().$.blur();
            b.commit && b.commit.apply(b, a);
          });
        },
        hide: function () {
          if (this.parts.dialog.isVisible()) {
            this.fire('hide', {});
            this._.editor.fire('dialogHide', this);
            this.selectPage(this._.tabIdList[0]);
            var a = this._.element;
            a.setStyle('display', 'none');
            this.parts.dialog.setStyle('visibility', 'hidden');
            for (z(this); CKEDITOR.dialog._.currentTop != this; ) CKEDITOR.dialog._.currentTop.hide();
            if (this._.parentDialog) {
              var b = this._.parentDialog.getElement().getFirst();
              this._.parentDialog.getElement().removeStyle('z-index');
              b.setStyle('z-index', parseInt(b.$.style.zIndex, 10) + Math.floor(this._.editor.config.baseFloatZIndex / 2));
            } else t(this._.editor);
            if ((CKEDITOR.dialog._.currentTop = this._.parentDialog)) CKEDITOR.dialog._.currentZIndex -= 10;
            else {
              CKEDITOR.dialog._.currentZIndex = null;
              a.removeListener('keydown', A);
              a.removeListener('keyup', q);
              var e = this._.editor;
              e.focus();
              setTimeout(function () {
                e.focusManager.unlock();
                CKEDITOR.env.iOS && e.window.focus();
              }, 0);
            }
            delete this._.parentDialog;
            this.foreach(function (a) {
              a.resetInitValue && a.resetInitValue();
            });
            this.setState(CKEDITOR.DIALOG_STATE_IDLE);
          }
        },
        addPage: function (a) {
          if (!a.requiredContent || this._.editor.filter.check(a.requiredContent)) {
            for (
              var b = [],
                e = a.label ? ' title\x3d"' + CKEDITOR.tools.htmlEncode(a.label) + '"' : '',
                d = CKEDITOR.dialog._.uiElementBuilders.vbox.build(
                  this,
                  {
                    type: 'vbox',
                    className: 'cke_dialog_page_contents',
                    children: a.elements,
                    expand: !!a.expand,
                    padding: a.padding,
                    style: a.style || 'width: 100%;',
                  },
                  b,
                ),
                c = (this._.contents[a.id] = {}),
                g = d.getChild(),
                f = 0;
              (d = g.shift());

            )
              d.notAllowed || 'hbox' == d.type || 'vbox' == d.type || f++,
                (c[d.id] = d),
                'function' == typeof d.getChild && g.push.apply(g, d.getChild());
            f || (a.hidden = !0);
            b = CKEDITOR.dom.element.createFromHtml(b.join(''));
            b.setAttribute('role', 'tabpanel');
            b.setStyle('min-height', '100%');
            d = CKEDITOR.env;
            c = 'cke_' + a.id + '_' + CKEDITOR.tools.getNextNumber();
            e = CKEDITOR.dom.element.createFromHtml(
              [
                '\x3ca class\x3d"cke_dialog_tab"',
                0 < this._.pageCount ? ' cke_last' : 'cke_first',
                e,
                a.hidden ? ' style\x3d"display:none"' : '',
                ' id\x3d"',
                c,
                '"',
                d.gecko && !d.hc ? '' : ' href\x3d"javascript:void(0)"',
                ' tabIndex\x3d"-1" hidefocus\x3d"true" role\x3d"tab"\x3e',
                a.label,
                '\x3c/a\x3e',
              ].join(''),
            );
            b.setAttribute('aria-labelledby', c);
            this._.tabs[a.id] = [e, b];
            this._.tabIdList.push(a.id);
            !a.hidden && this._.pageCount++;
            this._.lastTab = e;
            this.updateStyle();
            b.setAttribute('name', a.id);
            b.appendTo(this.parts.contents);
            e.unselectable();
            this.parts.tabs.append(e);
            a.accessKey && (B(this, this, 'CTRL+' + a.accessKey, v, y), (this._.accessKeyMap['CTRL+' + a.accessKey] = a.id));
          }
        },
        selectPage: function (a) {
          if (
            this._.currentTabId != a &&
            !this._.tabs[a][0].hasClass('cke_dialog_tab_disabled') &&
            !1 !== this.fire('selectPage', { page: a, currentPage: this._.currentTabId })
          ) {
            for (var e in this._.tabs) {
              var d = this._.tabs[e][0],
                c = this._.tabs[e][1];
              e != a && (d.removeClass('cke_dialog_tab_selected'), d.removeAttribute('aria-selected'), c.hide());
              c.setAttribute('aria-hidden', e != a);
            }
            var g = this._.tabs[a];
            g[0].addClass('cke_dialog_tab_selected');
            g[0].setAttribute('aria-selected', !0);
            CKEDITOR.env.ie6Compat || CKEDITOR.env.ie7Compat
              ? (b(g[1]),
                g[1].show(),
                setTimeout(function () {
                  b(g[1], 1);
                }, 0))
              : g[1].show();
            this._.currentTabId = a;
            this._.currentTabIndex = CKEDITOR.tools.indexOf(this._.tabIdList, a);
          }
        },
        updateStyle: function () {
          this.parts.dialog[(1 === this._.pageCount ? 'add' : 'remove') + 'Class']('cke_single_page');
        },
        hidePage: function (a) {
          var b = this._.tabs[a] && this._.tabs[a][0];
          b &&
            1 != this._.pageCount &&
            b.isVisible() &&
            (a == this._.currentTabId && this.selectPage(h.call(this)), b.hide(), this._.pageCount--, this.updateStyle());
        },
        showPage: function (a) {
          if ((a = this._.tabs[a] && this._.tabs[a][0])) a.show(), this._.pageCount++, this.updateStyle();
        },
        getElement: function () {
          return this._.element;
        },
        getName: function () {
          return this._.name;
        },
        getContentElement: function (a, b) {
          var e = this._.contents[a];
          return e && e[b];
        },
        getValueOf: function (a, b) {
          return this.getContentElement(a, b).getValue();
        },
        setValueOf: function (a, b, e) {
          return this.getContentElement(a, b).setValue(e);
        },
        getButton: function (a) {
          return this._.buttons[a];
        },
        click: function (a) {
          return this._.buttons[a].click();
        },
        disableButton: function (a) {
          return this._.buttons[a].disable();
        },
        enableButton: function (a) {
          return this._.buttons[a].enable();
        },
        getPageCount: function () {
          return this._.pageCount;
        },
        getParentEditor: function () {
          return this._.editor;
        },
        getSelectedElement: function () {
          return this.getParentEditor().getSelection().getSelectedElement();
        },
        addFocusable: function (a, b) {
          if ('undefined' == typeof b) (b = this._.focusList.length), this._.focusList.push(new m(this, a, b));
          else {
            this._.focusList.splice(b, 0, new m(this, a, b));
            for (var e = b + 1; e < this._.focusList.length; e++) this._.focusList[e].focusIndex++;
          }
        },
        setState: function (a) {
          if (this.state != a) {
            this.state = a;
            if (a == CKEDITOR.DIALOG_STATE_BUSY) {
              if (!this.parts.spinner) {
                var b = this.getParentEditor().lang.dir,
                  e = { attributes: { class: 'cke_dialog_spinner' }, styles: { float: 'rtl' == b ? 'right' : 'left' } };
                e.styles['margin-' + ('rtl' == b ? 'left' : 'right')] = '8px';
                this.parts.spinner = CKEDITOR.document.createElement('div', e);
                this.parts.spinner.setHtml('\x26#8987;');
                this.parts.spinner.appendTo(this.parts.title, 1);
              }
              this.parts.spinner.show();
              this.getButton('ok') && this.getButton('ok').disable();
            } else
              a == CKEDITOR.DIALOG_STATE_IDLE &&
                (this.parts.spinner && this.parts.spinner.hide(), this.getButton('ok') && this.getButton('ok').enable());
            this.fire('state', a);
          }
        },
        getModel: function (a) {
          return this._.model ? this._.model : this.definition.getModel ? this.definition.getModel(a) : null;
        },
        setModel: function (a) {
          this._.model = a;
        },
        getMode: function (a) {
          if (this.definition.getMode) return this.definition.getMode(a);
          a = this.getModel(a);
          return !a || (a instanceof CKEDITOR.dom.element && !a.getParent()) ? CKEDITOR.dialog.CREATION_MODE : CKEDITOR.dialog.EDITING_MODE;
        },
      };
      CKEDITOR.tools.extend(CKEDITOR.dialog, {
        CREATION_MODE: 0,
        EDITING_MODE: 1,
        add: function (a, b) {
          (this._.dialogDefinitions[a] && 'function' != typeof b) || (this._.dialogDefinitions[a] = b);
        },
        exists: function (a) {
          return !!this._.dialogDefinitions[a];
        },
        getCurrent: function () {
          return CKEDITOR.dialog._.currentTop;
        },
        isTabEnabled: function (a, b, e) {
          a = a.config.removeDialogTabs;
          return !(a && a.match(new RegExp('(?:^|;)' + b + ':' + e + '(?:$|;)', 'i')));
        },
        okButton: (function () {
          var a = function (a, b) {
            b = b || {};
            return CKEDITOR.tools.extend(
              {
                id: 'ok',
                type: 'button',
                label: a.lang.common.ok,
                class: 'cke_dialog_ui_button_ok',
                onClick: function (a) {
                  a = a.data.dialog;
                  !1 !== a.fire('ok', { hide: !0 }).hide && a.hide();
                },
              },
              b,
              !0,
            );
          };
          a.type = 'button';
          a.override = function (b) {
            return CKEDITOR.tools.extend(
              function (e) {
                return a(e, b);
              },
              { type: 'button' },
              !0,
            );
          };
          return a;
        })(),
        cancelButton: (function () {
          var a = function (a, b) {
            b = b || {};
            return CKEDITOR.tools.extend(
              {
                id: 'cancel',
                type: 'button',
                label: a.lang.common.cancel,
                class: 'cke_dialog_ui_button_cancel',
                onClick: function (a) {
                  a = a.data.dialog;
                  !1 !== a.fire('cancel', { hide: !0 }).hide && a.hide();
                },
              },
              b,
              !0,
            );
          };
          a.type = 'button';
          a.override = function (b) {
            return CKEDITOR.tools.extend(
              function (e) {
                return a(e, b);
              },
              { type: 'button' },
              !0,
            );
          };
          return a;
        })(),
        addUIElement: function (a, b) {
          this._.uiElementBuilders[a] = b;
        },
      });
      CKEDITOR.dialog._ = { uiElementBuilders: {}, dialogDefinitions: {}, currentTop: null, currentZIndex: null };
      CKEDITOR.event.implementOn(CKEDITOR.dialog);
      CKEDITOR.event.implementOn(CKEDITOR.dialog.prototype);
      F = {
        resizable: CKEDITOR.DIALOG_RESIZE_BOTH,
        minWidth: 600,
        minHeight: 400,
        buttons: [CKEDITOR.dialog.okButton, CKEDITOR.dialog.cancelButton],
      };
      var K = function (a, b, e) {
          for (var d = 0, c; (c = a[d]); d++) if (c.id == b || (e && c[e] && (c = K(c[e], b, e)))) return c;
          return null;
        },
        w = function (a, b, e, d, c) {
          if (e) {
            for (var g = 0, f; (f = a[g]); g++) {
              if (f.id == e) return a.splice(g, 0, b), b;
              if (d && f[d] && (f = w(f[d], b, e, d, !0))) return f;
            }
            if (c) return null;
          }
          a.push(b);
          return b;
        },
        I = function (a, b, e) {
          for (var d = 0, c; (c = a[d]); d++) {
            if (c.id == b) return a.splice(d, 1);
            if (e && c[e] && (c = I(c[e], b, e))) return c;
          }
          return null;
        };
      d.prototype = {
        getContents: function (a) {
          return K(this.contents, a);
        },
        getButton: function (a) {
          return K(this.buttons, a);
        },
        addContents: function (a, b) {
          return w(this.contents, a, b);
        },
        addButton: function (a, b) {
          return w(this.buttons, a, b);
        },
        removeContents: function (a) {
          I(this.contents, a);
        },
        removeButton: function (a) {
          I(this.buttons, a);
        },
      };
      e.prototype = {
        get: function (a) {
          return K(this.elements, a, 'children');
        },
        add: function (a, b) {
          return w(this.elements, a, b, 'children');
        },
        remove: function (a) {
          I(this.elements, a, 'children');
        },
      };
      var E = {},
        P = {};
      (function () {
        CKEDITOR.ui.dialog = {
          uiElement: function (a, b, e, d, c, g, f) {
            if (!(4 > arguments.length)) {
              var k = (d.call ? d(b) : d) || 'div',
                h = ['\x3c', k, ' '],
                m = (c && c.call ? c(b) : c) || {},
                l = (g && g.call ? g(b) : g) || {},
                n = (f && f.call ? f.call(this, a, b) : f) || '',
                r = (this.domId = l.id || CKEDITOR.tools.getNextId() + '_uiElement');
              b.requiredContent && !a.getParentEditor().filter.check(b.requiredContent) && ((m.display = 'none'), (this.notAllowed = !0));
              l.id = r;
              var q = {};
              b.type && (q['cke_dialog_ui_' + b.type] = 1);
              b.className && (q[b.className] = 1);
              b.disabled && (q.cke_disabled = 1);
              for (var v = l['class'] && l['class'].split ? l['class'].split(' ') : [], r = 0; r < v.length; r++) v[r] && (q[v[r]] = 1);
              v = [];
              for (r in q) v.push(r);
              l['class'] = v.join(' ');
              b.title && (l.title = b.title);
              q = (b.style || '').split(';');
              b.align && ((v = b.align), (m['margin-left'] = 'left' == v ? 0 : 'auto'), (m['margin-right'] = 'right' == v ? 0 : 'auto'));
              for (r in m) q.push(r + ':' + m[r]);
              b.hidden && q.push('display:none');
              for (r = q.length - 1; 0 <= r; r--) '' === q[r] && q.splice(r, 1);
              0 < q.length && (l.style = (l.style ? l.style + '; ' : '') + q.join('; '));
              for (r in l) h.push(r + '\x3d"' + CKEDITOR.tools.htmlEncode(l[r]) + '" ');
              h.push('\x3e', n, '\x3c/', k, '\x3e');
              e.push(h.join(''));
              (this._ || (this._ = {})).dialog = a;
              'boolean' == typeof b.isChanged &&
                (this.isChanged = function () {
                  return b.isChanged;
                });
              'function' == typeof b.isChanged && (this.isChanged = b.isChanged);
              'function' == typeof b.setValue &&
                (this.setValue = CKEDITOR.tools.override(this.setValue, function (a) {
                  return function (e) {
                    a.call(this, b.setValue.call(this, e));
                  };
                }));
              'function' == typeof b.getValue &&
                (this.getValue = CKEDITOR.tools.override(this.getValue, function (a) {
                  return function () {
                    return b.getValue.call(this, a.call(this));
                  };
                }));
              CKEDITOR.event.implementOn(this);
              this.registerEvents(b);
              this.accessKeyUp && this.accessKeyDown && b.accessKey && B(this, a, 'CTRL+' + b.accessKey);
              var t = this;
              a.on('load', function () {
                var b = t.getInputElement();
                if (b) {
                  var e = t.type in { checkbox: 1, ratio: 1 } && CKEDITOR.env.ie && 8 > CKEDITOR.env.version ? 'cke_dialog_ui_focused' : '';
                  b.on('focus', function () {
                    a._.tabBarMode = !1;
                    a._.hasFocus = !0;
                    t.fire('focus');
                    e && this.addClass(e);
                  });
                  b.on('blur', function () {
                    t.fire('blur');
                    e && this.removeClass(e);
                  });
                }
              });
              CKEDITOR.tools.extend(this, b);
              this.keyboardFocusable &&
                ((this.tabIndex = b.tabIndex || 0),
                (this.focusIndex = a._.focusList.push(this) - 1),
                this.on('focus', function () {
                  a._.currentFocusIndex = t.focusIndex;
                }));
            }
          },
          hbox: function (a, b, e, d, c) {
            if (!(4 > arguments.length)) {
              this._ || (this._ = {});
              var g = (this._.children = b),
                f = (c && c.widths) || null,
                k = (c && c.height) || null,
                h,
                m = { role: 'presentation' };
              c && c.align && (m.align = c.align);
              CKEDITOR.ui.dialog.uiElement.call(this, a, c || { type: 'hbox' }, d, 'table', {}, m, function () {
                var a = ['\x3ctbody\x3e\x3ctr class\x3d"cke_dialog_ui_hbox"\x3e'];
                for (h = 0; h < e.length; h++) {
                  var b = 'cke_dialog_ui_hbox_child',
                    d = [];
                  0 === h && (b = 'cke_dialog_ui_hbox_first');
                  h == e.length - 1 && (b = 'cke_dialog_ui_hbox_last');
                  a.push('\x3ctd class\x3d"', b, '" role\x3d"presentation" ');
                  f ? f[h] && d.push('width:' + C(f[h])) : d.push('width:' + Math.floor(100 / e.length) + '%');
                  k && d.push('height:' + C(k));
                  c && void 0 !== c.padding && d.push('padding:' + C(c.padding));
                  CKEDITOR.env.ie && CKEDITOR.env.quirks && g[h].align && d.push('text-align:' + g[h].align);
                  0 < d.length && a.push('style\x3d"' + d.join('; ') + '" ');
                  a.push('\x3e', e[h], '\x3c/td\x3e');
                }
                a.push('\x3c/tr\x3e\x3c/tbody\x3e');
                return a.join('');
              });
            }
          },
          vbox: function (a, b, e, d, c) {
            if (!(3 > arguments.length)) {
              this._ || (this._ = {});
              var g = (this._.children = b),
                f = (c && c.width) || null,
                k = (c && c.heights) || null;
              CKEDITOR.ui.dialog.uiElement.call(this, a, c || { type: 'vbox' }, d, 'div', null, { role: 'presentation' }, function () {
                var b = ['\x3ctable role\x3d"presentation" cellspacing\x3d"0" border\x3d"0" '];
                b.push('style\x3d"');
                c && c.expand && b.push('height:100%;');
                b.push('width:' + C(f || '100%'), ';');
                CKEDITOR.env.webkit && b.push('float:none;');
                b.push('"');
                b.push(
                  'align\x3d"',
                  CKEDITOR.tools.htmlEncode((c && c.align) || ('ltr' == a.getParentEditor().lang.dir ? 'left' : 'right')),
                  '" ',
                );
                b.push('\x3e\x3ctbody\x3e');
                for (var d = 0; d < e.length; d++) {
                  var h = [];
                  b.push('\x3ctr\x3e\x3ctd role\x3d"presentation" ');
                  f && h.push('width:' + C(f || '100%'));
                  k ? h.push('height:' + C(k[d])) : c && c.expand && h.push('height:' + Math.floor(100 / e.length) + '%');
                  c && void 0 !== c.padding && h.push('padding:' + C(c.padding));
                  CKEDITOR.env.ie && CKEDITOR.env.quirks && g[d].align && h.push('text-align:' + g[d].align);
                  0 < h.length && b.push('style\x3d"', h.join('; '), '" ');
                  b.push(' class\x3d"cke_dialog_ui_vbox_child"\x3e', e[d], '\x3c/td\x3e\x3c/tr\x3e');
                }
                b.push('\x3c/tbody\x3e\x3c/table\x3e');
                return b.join('');
              });
            }
          },
        };
      })();
      CKEDITOR.ui.dialog.uiElement.prototype = {
        getElement: function () {
          return CKEDITOR.document.getById(this.domId);
        },
        getInputElement: function () {
          return this.getElement();
        },
        getDialog: function () {
          return this._.dialog;
        },
        setValue: function (a, b) {
          this.getInputElement().setValue(a);
          !b && this.fire('change', { value: a });
          return this;
        },
        getValue: function () {
          return this.getInputElement().getValue();
        },
        isChanged: function () {
          return !1;
        },
        selectParentTab: function () {
          for (var a = this.getInputElement(); (a = a.getParent()) && -1 == a.$.className.search('cke_dialog_page_contents'); );
          if (!a) return this;
          a = a.getAttribute('name');
          this._.dialog._.currentTabId != a && this._.dialog.selectPage(a);
          return this;
        },
        focus: function () {
          this.selectParentTab().getInputElement().focus();
          return this;
        },
        registerEvents: function (a) {
          var b = /^on([A-Z]\w+)/,
            e,
            d = function (a, b, e, d) {
              b.on('load', function () {
                a.getInputElement().on(e, d, a);
              });
            },
            c;
          for (c in a)
            if ((e = c.match(b)))
              this.eventProcessors[c]
                ? this.eventProcessors[c].call(this, this._.dialog, a[c])
                : d(this, this._.dialog, e[1].toLowerCase(), a[c]);
          return this;
        },
        eventProcessors: {
          onLoad: function (a, b) {
            a.on('load', b, this);
          },
          onShow: function (a, b) {
            a.on('show', b, this);
          },
          onHide: function (a, b) {
            a.on('hide', b, this);
          },
        },
        accessKeyDown: function () {
          this.focus();
        },
        accessKeyUp: function () {},
        disable: function () {
          var a = this.getElement();
          this.getInputElement().setAttribute('disabled', 'true');
          a.addClass('cke_disabled');
        },
        enable: function () {
          var a = this.getElement();
          this.getInputElement().removeAttribute('disabled');
          a.removeClass('cke_disabled');
        },
        isEnabled: function () {
          return !this.getElement().hasClass('cke_disabled');
        },
        isVisible: function () {
          return this.getInputElement().isVisible();
        },
        isFocusable: function () {
          return this.isEnabled() && this.isVisible() ? !0 : !1;
        },
      };
      CKEDITOR.ui.dialog.hbox.prototype = CKEDITOR.tools.extend(
        new CKEDITOR.ui.dialog.uiElement(),
        {
          getChild: function (a) {
            if (1 > arguments.length) return this._.children.concat();
            a.splice || (a = [a]);
            return 2 > a.length
              ? this._.children[a[0]]
              : this._.children[a[0]] && this._.children[a[0]].getChild
                ? this._.children[a[0]].getChild(a.slice(1, a.length))
                : null;
          },
        },
        !0,
      );
      CKEDITOR.ui.dialog.vbox.prototype = new CKEDITOR.ui.dialog.hbox();
      (function () {
        var a = {
          build: function (a, b, e) {
            for (var d = b.children, c, g = [], f = [], k = 0; k < d.length && (c = d[k]); k++) {
              var h = [];
              g.push(h);
              f.push(CKEDITOR.dialog._.uiElementBuilders[c.type].build(a, c, h));
            }
            return new CKEDITOR.ui.dialog[b.type](a, f, g, e, b);
          },
        };
        CKEDITOR.dialog.addUIElement('hbox', a);
        CKEDITOR.dialog.addUIElement('vbox', a);
      })();
      CKEDITOR.dialogCommand = function (a, b) {
        this.dialogName = a;
        CKEDITOR.tools.extend(this, b, !0);
      };
      CKEDITOR.dialogCommand.prototype = {
        exec: function (a) {
          var b = this.tabId;
          a.openDialog(this.dialogName, function (a) {
            b && a.selectPage(b);
          });
        },
        canUndo: !1,
        editorFocus: 1,
      };
      (function () {
        var a = /^\d*$/,
          b = /^\d*(?:\.\d+)?$/,
          e = /^(((\d*(\.\d+))|(\d*))(px|\%)?)?$/,
          d = /^(((\d*(\.\d+))|(\d*))(px|em|ex|in|cm|mm|pt|pc|\%)?)?$/i,
          c = /^(--|-?([a-zA-Z_]|\\))(\\|[a-zA-Z0-9-_])*\s*?:\s*?[^:;]+$/;
        CKEDITOR.VALIDATE_OR = 1;
        CKEDITOR.VALIDATE_AND = 2;
        CKEDITOR.dialog.validate = {
          functions: function () {
            var a = arguments;
            return function (b) {
              this && this.getValue && (b = this.getValue());
              var e,
                d = CKEDITOR.VALIDATE_AND,
                c = [],
                g;
              for (g = 0; g < a.length; g++)
                if ('function' == typeof a[g]) c.push(a[g]);
                else break;
              g < a.length && 'string' == typeof a[g] && ((e = a[g]), g++);
              g < a.length && 'number' == typeof a[g] && (d = a[g]);
              g = d == CKEDITOR.VALIDATE_AND;
              for (var f = 0; f < c.length; f++) {
                var k = !0 === c[f](b);
                g = d == CKEDITOR.VALIDATE_AND ? g && k : g || k;
              }
              return g ? !0 : e;
            };
          },
          regex: function (a, b) {
            return this.functions(function (b) {
              return a.test(b);
            }, b);
          },
          notEmpty: function (a) {
            return this.functions(function (a) {
              return (
                0 <
                a.replace(
                  RegExp(
                    '^[\\u0020\\u00a0\\u1680\\u202f\\u205f\\u3000\\u2000-\\u200a\\s]+|[\\u0020\\u00a0\\u1680\\u202f\\u205f\\u3000\\u2000-\\u200a\\s]+$',
                    'g',
                  ),
                  '',
                ).length
              );
            }, a);
          },
          integer: function (b) {
            return this.regex(a, b);
          },
          number: function (a) {
            return this.regex(b, a);
          },
          cssLength: function (a) {
            return this.functions(function (a) {
              return d.test(CKEDITOR.tools.trim(a));
            }, a);
          },
          htmlLength: function (a) {
            return this.functions(function (a) {
              return e.test(CKEDITOR.tools.trim(a));
            }, a);
          },
          inlineStyle: function (a) {
            return this.functions(function (a) {
              a = CKEDITOR.tools.trim(a).split(';');
              '' === a[a.length - 1] && a.pop();
              return CKEDITOR.tools.array.every(a, function (a) {
                return c.test(CKEDITOR.tools.trim(a));
              });
            }, a);
          },
          equals: function (a, b) {
            return this.functions(function (b) {
              return b == a;
            }, b);
          },
          notEqual: function (a, b) {
            return this.functions(function (b) {
              return b != a;
            }, b);
          },
        };
        CKEDITOR.on('instanceDestroyed', function (a) {
          if (CKEDITOR.tools.isEmpty(CKEDITOR.instances)) {
            for (var b; (b = CKEDITOR.dialog._.currentTop); ) b.hide();
            for (var e in E) E[e].remove();
            E = {};
          }
          a = a.editor._.storedDialogs;
          for (var d in a) a[d].destroy();
        });
      })();
      CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
        openDialog: function (a, b, e) {
          var d = null,
            c = CKEDITOR.dialog._.dialogDefinitions[a];
          null === CKEDITOR.dialog._.currentTop && p(this);
          if ('function' == typeof c)
            (c = this._.storedDialogs || (this._.storedDialogs = {})),
              (d = c[a] || (c[a] = new CKEDITOR.dialog(this, a))),
              d.setModel(e),
              b && b.call(d, d),
              d.show();
          else {
            if ('failed' == c) throw (t(this), Error('[CKEDITOR.dialog.openDialog] Dialog "' + a + '" failed when loading definition.'));
            'string' == typeof c &&
              CKEDITOR.scriptLoader.load(
                CKEDITOR.getUrl(c),
                function () {
                  'function' != typeof CKEDITOR.dialog._.dialogDefinitions[a] && (CKEDITOR.dialog._.dialogDefinitions[a] = 'failed');
                  this.openDialog(a, b, e);
                },
                this,
                0,
                1,
              );
          }
          CKEDITOR.skin.loadPart('dialog');
          if (d)
            d.once(
              'hide',
              function () {
                d.setModel(null);
              },
              null,
              null,
              999,
            );
          return d;
        },
      });
      CKEDITOR.plugins.add('dialog', {
        requires: 'dialogui',
        init: function (a) {
          G || (CKEDITOR.document.appendStyleSheet(this.path + 'styles/dialog.css'), (G = !0));
          a.on(
            'doubleclick',
            function (b) {
              b.data.dialog && a.openDialog(b.data.dialog);
            },
            null,
            null,
            999,
          );
        },
      });
    })();
    (function () {
      CKEDITOR.plugins.add('a11yhelp', {
        requires: 'dialog',
        availableLangs: {
          af: 1,
          ar: 1,
          az: 1,
          bg: 1,
          ca: 1,
          cs: 1,
          cy: 1,
          da: 1,
          de: 1,
          'de-ch': 1,
          el: 1,
          en: 1,
          'en-au': 1,
          'en-gb': 1,
          eo: 1,
          es: 1,
          'es-mx': 1,
          et: 1,
          eu: 1,
          fa: 1,
          fi: 1,
          fo: 1,
          fr: 1,
          'fr-ca': 1,
          gl: 1,
          gu: 1,
          he: 1,
          hi: 1,
          hr: 1,
          hu: 1,
          id: 1,
          it: 1,
          ja: 1,
          km: 1,
          ko: 1,
          ku: 1,
          lt: 1,
          lv: 1,
          mk: 1,
          mn: 1,
          nb: 1,
          nl: 1,
          no: 1,
          oc: 1,
          pl: 1,
          pt: 1,
          'pt-br': 1,
          ro: 1,
          ru: 1,
          si: 1,
          sk: 1,
          sl: 1,
          sq: 1,
          sr: 1,
          'sr-latn': 1,
          sv: 1,
          th: 1,
          tr: 1,
          tt: 1,
          ug: 1,
          uk: 1,
          vi: 1,
          zh: 1,
          'zh-cn': 1,
        },
        init: function (a) {
          var h = this;
          a.addCommand('a11yHelp', {
            exec: function () {
              var f = a.langCode,
                f = h.availableLangs[f] ? f : h.availableLangs[f.replace(/-.*/, '')] ? f.replace(/-.*/, '') : 'en';
              CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(h.path + 'dialogs/lang/' + f + '.js'), function () {
                a.lang.a11yhelp = h.langEntries[f];
                a.openDialog('a11yHelp');
              });
            },
            modes: { wysiwyg: 1, source: 1 },
            readOnly: 1,
            canUndo: !1,
          });
          a.setKeystroke(CKEDITOR.ALT + 48, 'a11yHelp');
          CKEDITOR.dialog.add('a11yHelp', this.path + 'dialogs/a11yhelp.js');
          a.on('ariaEditorHelpLabel', function (f) {
            f.data.label = a.lang.common.editorHelp;
          });
        },
      });
    })();
    CKEDITOR.plugins.add('about', {
      requires: 'dialog',
      init: function (a) {
        var h = a.addCommand('about', new CKEDITOR.dialogCommand('about'));
        h.modes = { wysiwyg: 1, source: 1 };
        h.canUndo = !1;
        h.readOnly = 1;
        a.ui.addButton && a.ui.addButton('About', { label: a.lang.about.dlgTitle, command: 'about', toolbar: 'about' });
        CKEDITOR.dialog.add('about', this.path + 'dialogs/about.js');
      },
    });
    CKEDITOR.plugins.add('basicstyles', {
      init: function (a) {
        var h = 0,
          f = function (c, f, g, d) {
            if (d) {
              d = new CKEDITOR.style(d);
              var e = b[g];
              e.unshift(d);
              a.attachStyleStateChange(d, function (b) {
                !a.readOnly && a.getCommand(g).setState(b);
              });
              a.addCommand(g, new CKEDITOR.styleCommand(d, { contentForms: e }));
              a.ui.addButton && a.ui.addButton(c, { isToggle: !0, label: f, command: g, toolbar: 'basicstyles,' + (h += 10) });
            }
          },
          b = {
            bold: [
              'strong',
              'b',
              [
                'span',
                function (a) {
                  a = a.styles['font-weight'];
                  return 'bold' == a || 700 <= +a;
                },
              ],
            ],
            italic: [
              'em',
              'i',
              [
                'span',
                function (a) {
                  return 'italic' == a.styles['font-style'];
                },
              ],
            ],
            underline: [
              'u',
              [
                'span',
                function (a) {
                  return 'underline' == a.styles['text-decoration'];
                },
              ],
            ],
            strike: [
              's',
              'strike',
              [
                'span',
                function (a) {
                  return 'line-through' == a.styles['text-decoration'];
                },
              ],
            ],
            subscript: ['sub'],
            superscript: ['sup'],
          },
          c = a.config,
          l = a.lang.basicstyles;
        f('Bold', l.bold, 'bold', c.coreStyles_bold);
        f('Italic', l.italic, 'italic', c.coreStyles_italic);
        f('Underline', l.underline, 'underline', c.coreStyles_underline);
        f('Strike', l.strike, 'strike', c.coreStyles_strike);
        f('Subscript', l.subscript, 'subscript', c.coreStyles_subscript);
        f('Superscript', l.superscript, 'superscript', c.coreStyles_superscript);
        a.setKeystroke([
          [CKEDITOR.CTRL + 66, 'bold'],
          [CKEDITOR.CTRL + 73, 'italic'],
          [CKEDITOR.CTRL + 85, 'underline'],
        ]);
      },
    });
    CKEDITOR.config.coreStyles_bold = { element: 'strong', overrides: 'b' };
    CKEDITOR.config.coreStyles_italic = { element: 'em', overrides: 'i' };
    CKEDITOR.config.coreStyles_underline = { element: 'u' };
    CKEDITOR.config.coreStyles_strike = { element: 's', overrides: 'strike' };
    CKEDITOR.config.coreStyles_subscript = { element: 'sub' };
    CKEDITOR.config.coreStyles_superscript = { element: 'sup' };
    (function () {
      function a(a, b, d, c) {
        if (!a.isReadOnly() && !a.equals(d.editable())) {
          CKEDITOR.dom.element.setMarker(c, a, 'bidi_processed', 1);
          c = a;
          for (var g = d.editable(); (c = c.getParent()) && !c.equals(g); )
            if (c.getCustomData('bidi_processed')) {
              a.removeStyle('direction');
              a.removeAttribute('dir');
              return;
            }
          c = d.config.useComputedState;
          (c ? a.getComputedStyle('direction') : a.getStyle('direction') || a.hasAttribute('dir')) != b &&
            (a.removeStyle('direction'),
            c ? (a.removeAttribute('dir'), b != a.getComputedStyle('direction') && a.setAttribute('dir', b)) : a.setAttribute('dir', b),
            d.forceNextSelectionCheck());
        }
      }
      function h(a, b, d) {
        var c = a.getCommonAncestor(!1, !0);
        a = a.clone();
        a.enlarge(d == CKEDITOR.ENTER_BR ? CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS : CKEDITOR.ENLARGE_BLOCK_CONTENTS);
        if (a.checkBoundaryOfElement(c, CKEDITOR.START) && a.checkBoundaryOfElement(c, CKEDITOR.END)) {
          for (var g; c && c.type == CKEDITOR.NODE_ELEMENT && (g = c.getParent()) && 1 == g.getChildCount() && !(c.getName() in b); ) c = g;
          return c.type == CKEDITOR.NODE_ELEMENT && c.getName() in b && c;
        }
      }
      function f(b) {
        return {
          context: 'p',
          allowedContent: { 'h1 h2 h3 h4 h5 h6 table ul ol blockquote div tr p div li td': { propertiesOnly: !0, attributes: 'dir' } },
          requiredContent: 'p[dir]',
          refresh: function (a, b) {
            var e = a.config.useComputedState,
              d;
            if (!e) {
              d = b.lastElement;
              for (var c = a.editable(); d && !(d.getName() in k || d.equals(c)); ) {
                var g = d.getParent();
                if (!g) break;
                d = g;
              }
            }
            d = d || b.block || b.blockLimit;
            d.equals(a.editable()) && (c = a.getSelection().getRanges()[0].getEnclosedNode()) && c.type == CKEDITOR.NODE_ELEMENT && (d = c);
            d &&
              ((e = e ? d.getComputedStyle('direction') : d.getStyle('direction') || d.getAttribute('dir')),
              a.getCommand('bidirtl').setState('rtl' == e ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF),
              a.getCommand('bidiltr').setState('ltr' == e ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF));
            e = (b.block || b.blockLimit || a.editable()).getDirection(1);
            e != (a._.selDir || a.lang.dir) && ((a._.selDir = e), a.fire('contentDirChanged', e));
          },
          exec: function (d) {
            var g = d.getSelection(),
              f = d.config.enterMode,
              k = g.getRanges();
            if (k && k.length) {
              for (var m = {}, t = g.createBookmarks(), k = k.createIterator(), A, q = 0; (A = k.getNextRange(1)); ) {
                var B = A.getEnclosedNode();
                (B && (!B || (B.type == CKEDITOR.NODE_ELEMENT && B.getName() in l))) || (B = h(A, c, f));
                B && a(B, b, d, m);
                var z = new CKEDITOR.dom.walker(A),
                  y = t[q].startNode,
                  v = t[q++].endNode;
                z.evaluator = function (a) {
                  var b = f == CKEDITOR.ENTER_P ? 'p' : 'div',
                    e;
                  if ((e = (a ? a.type == CKEDITOR.NODE_ELEMENT : !1) && a.getName() in c)) {
                    if ((b = a.is(b))) b = (b = a.getParent()) ? b.type == CKEDITOR.NODE_ELEMENT : !1;
                    e = !(b && a.getParent().is('blockquote'));
                  }
                  return !!(
                    e &&
                    a.getPosition(y) & CKEDITOR.POSITION_FOLLOWING &&
                    (a.getPosition(v) & (CKEDITOR.POSITION_PRECEDING + CKEDITOR.POSITION_CONTAINS)) == CKEDITOR.POSITION_PRECEDING
                  );
                };
                for (; (B = z.next()); ) a(B, b, d, m);
                A = A.createIterator();
                for (A.enlargeBr = f != CKEDITOR.ENTER_BR; (B = A.getNextParagraph(f == CKEDITOR.ENTER_P ? 'p' : 'div')); ) a(B, b, d, m);
              }
              CKEDITOR.dom.element.clearAllMarkers(m);
              d.forceNextSelectionCheck();
              g.selectBookmarks(t);
              d.focus();
            }
          },
        };
      }
      function b(a) {
        var b = a == m.setAttribute,
          d = a == m.removeAttribute,
          c = /\bdirection\s*:\s*(.*?)\s*(:?$|;)/;
        return function (g, f) {
          if (!this.isReadOnly()) {
            var k;
            if ((k = g == (b || d ? 'dir' : 'direction') || ('style' == g && (d || c.test(f))))) {
              a: {
                k = this;
                for (var h = k.getDocument().getBody().getParent(); k; ) {
                  if (k.equals(h)) {
                    k = !1;
                    break a;
                  }
                  k = k.getParent();
                }
                k = !0;
              }
              k = !k;
            }
            if (k && ((k = this.getDirection(1)), (h = a.apply(this, arguments)), k != this.getDirection(1)))
              return this.getDocument().fire('dirChanged', this), h;
          }
          return a.apply(this, arguments);
        };
      }
      var c = { table: 1, ul: 1, ol: 1, blockquote: 1, div: 1 },
        l = {},
        k = {};
      CKEDITOR.tools.extend(l, c, { tr: 1, p: 1, div: 1, li: 1 });
      CKEDITOR.tools.extend(k, l, { td: 1 });
      CKEDITOR.plugins.add('bidi', {
        init: function (a) {
          function b(d, c, g, f, k) {
            a.addCommand(g, new CKEDITOR.command(a, f));
            a.ui.addButton && a.ui.addButton(d, { isToggle: !0, label: c, command: g, toolbar: 'bidi,' + k });
          }
          if (!a.blockless) {
            var d = a.lang.bidi;
            b('BidiLtr', d.ltr, 'bidiltr', f('ltr'), 10);
            b('BidiRtl', d.rtl, 'bidirtl', f('rtl'), 20);
            a.on('contentDom', function () {
              a.document.on('dirChanged', function (b) {
                a.fire('dirChanged', { node: b.data, dir: b.data.getDirection(1) });
              });
            });
            a.on('contentDirChanged', function (b) {
              b = (a.lang.dir != b.data ? 'add' : 'remove') + 'Class';
              var d = a.ui.space(a.config.toolbarLocation);
              if (d) d[b]('cke_mixed_dir_content');
            });
          }
        },
      });
      for (
        var m = CKEDITOR.dom.element.prototype, g = ['setStyle', 'removeStyle', 'setAttribute', 'removeAttribute'], d = 0;
        d < g.length;
        d++
      )
        m[g[d]] = CKEDITOR.tools.override(m[g[d]], b);
    })();
    (function () {
      var a = {
        exec: function (a) {
          var f = a.getCommand('blockquote').state,
            b = a.getSelection(),
            c = b && b.getRanges()[0];
          if (c) {
            var l = b.createBookmarks();
            if (CKEDITOR.env.ie) {
              var k = l[0].startNode,
                m = l[0].endNode,
                g;
              if (k && 'blockquote' == k.getParent().getName())
                for (g = k; (g = g.getNext()); )
                  if (g.type == CKEDITOR.NODE_ELEMENT && g.isBlockBoundary()) {
                    k.move(g, !0);
                    break;
                  }
              if (m && 'blockquote' == m.getParent().getName())
                for (g = m; (g = g.getPrevious()); )
                  if (g.type == CKEDITOR.NODE_ELEMENT && g.isBlockBoundary()) {
                    m.move(g);
                    break;
                  }
            }
            var d = c.createIterator();
            d.enlargeBr = a.config.enterMode != CKEDITOR.ENTER_BR;
            if (f == CKEDITOR.TRISTATE_OFF) {
              for (k = []; (f = d.getNextParagraph()); ) k.push(f);
              1 > k.length &&
                ((f = a.document.createElement(a.config.enterMode == CKEDITOR.ENTER_P ? 'p' : 'div')),
                (m = l.shift()),
                c.insertNode(f),
                f.append(new CKEDITOR.dom.text('﻿', a.document)),
                c.moveToBookmark(m),
                c.selectNodeContents(f),
                c.collapse(!0),
                (m = c.createBookmark()),
                k.push(f),
                l.unshift(m));
              g = k[0].getParent();
              c = [];
              for (m = 0; m < k.length; m++) (f = k[m]), (g = g.getCommonAncestor(f.getParent()));
              for (f = { table: 1, tbody: 1, tr: 1, ol: 1, ul: 1 }; f[g.getName()]; ) g = g.getParent();
              for (m = null; 0 < k.length; ) {
                for (f = k.shift(); !f.getParent().equals(g); ) f = f.getParent();
                f.equals(m) || c.push(f);
                m = f;
              }
              for (; 0 < c.length; )
                if (((f = c.shift()), 'blockquote' == f.getName())) {
                  for (m = new CKEDITOR.dom.documentFragment(a.document); f.getFirst(); )
                    m.append(f.getFirst().remove()), k.push(m.getLast());
                  m.replace(f);
                } else k.push(f);
              c = a.document.createElement('blockquote');
              for (c.insertBefore(k[0]); 0 < k.length; ) (f = k.shift()), c.append(f);
            } else if (f == CKEDITOR.TRISTATE_ON) {
              m = [];
              for (g = {}; (f = d.getNextParagraph()); ) {
                for (k = c = null; f.getParent(); ) {
                  if ('blockquote' == f.getParent().getName()) {
                    c = f.getParent();
                    k = f;
                    break;
                  }
                  f = f.getParent();
                }
                c &&
                  k &&
                  !k.getCustomData('blockquote_moveout') &&
                  (m.push(k), CKEDITOR.dom.element.setMarker(g, k, 'blockquote_moveout', !0));
              }
              CKEDITOR.dom.element.clearAllMarkers(g);
              f = [];
              k = [];
              for (g = {}; 0 < m.length; )
                (d = m.shift()),
                  (c = d.getParent()),
                  d.getPrevious()
                    ? d.getNext()
                      ? (d.breakParent(d.getParent()), k.push(d.getNext()))
                      : d.remove().insertAfter(c)
                    : d.remove().insertBefore(c),
                  c.getCustomData('blockquote_processed') || (k.push(c), CKEDITOR.dom.element.setMarker(g, c, 'blockquote_processed', !0)),
                  f.push(d);
              CKEDITOR.dom.element.clearAllMarkers(g);
              for (m = k.length - 1; 0 <= m; m--) {
                c = k[m];
                a: {
                  g = c;
                  for (var d = 0, e = g.getChildCount(), n = void 0; d < e && (n = g.getChild(d)); d++)
                    if (n.type == CKEDITOR.NODE_ELEMENT && n.isBlockBoundary()) {
                      g = !1;
                      break a;
                    }
                  g = !0;
                }
                g && c.remove();
              }
              if (a.config.enterMode == CKEDITOR.ENTER_BR)
                for (c = !0; f.length; )
                  if (((d = f.shift()), 'div' == d.getName())) {
                    m = new CKEDITOR.dom.documentFragment(a.document);
                    !c ||
                      !d.getPrevious() ||
                      (d.getPrevious().type == CKEDITOR.NODE_ELEMENT && d.getPrevious().isBlockBoundary()) ||
                      m.append(a.document.createElement('br'));
                    for (c = d.getNext() && !(d.getNext().type == CKEDITOR.NODE_ELEMENT && d.getNext().isBlockBoundary()); d.getFirst(); )
                      d.getFirst().remove().appendTo(m);
                    c && m.append(a.document.createElement('br'));
                    m.replace(d);
                    c = !1;
                  }
            }
            b.selectBookmarks(l);
            a.focus();
          }
        },
        refresh: function (a, f) {
          this.setState(a.elementPath(f.block || f.blockLimit).contains('blockquote', 1) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF);
        },
        context: 'blockquote',
        allowedContent: 'blockquote',
        requiredContent: 'blockquote',
      };
      CKEDITOR.plugins.add('blockquote', {
        init: function (h) {
          h.blockless ||
            (h.addCommand('blockquote', a),
            h.ui.addButton &&
              h.ui.addButton('Blockquote', {
                isToggle: !0,
                label: h.lang.blockquote.toolbar,
                command: 'blockquote',
                toolbar: 'blocks,10',
              }));
        },
      });
    })();
    ('use strict');
    (function () {
      function a(a, b) {
        CKEDITOR.tools.extend(this, b, { editor: a, id: 'cke-' + CKEDITOR.tools.getUniqueId(), area: a._.notificationArea });
        b.type || (this.type = 'info');
        this.element = this._createElement();
        a.plugins.clipboard && CKEDITOR.plugins.clipboard.preventDefaultDropOnElement(this.element);
      }
      function h(a) {
        var b = this;
        this.editor = a;
        this.notifications = [];
        this.element = this._createElement();
        this._uiBuffer = CKEDITOR.tools.eventsBuffer(10, this._layout, this);
        this._changeBuffer = CKEDITOR.tools.eventsBuffer(500, this._layout, this);
        a.on('destroy', function () {
          b._removeListeners();
          b.element.remove();
        });
      }
      CKEDITOR.plugins.add('notification', {
        init: function (a) {
          function b(a) {
            var b = new CKEDITOR.dom.element('div');
            b.setStyles({ position: 'fixed', 'margin-left': '-9999px' });
            b.setAttributes({ 'aria-live': 'assertive', 'aria-atomic': 'true' });
            b.setText(a);
            CKEDITOR.document.getBody().append(b);
            setTimeout(function () {
              b.remove();
            }, 100);
          }
          a._.notificationArea = new h(a);
          a.showNotification = function (b, h, k) {
            var m, g;
            'progress' == h ? (m = k) : (g = k);
            b = new CKEDITOR.plugins.notification(a, { message: b, type: h, progress: m, duration: g });
            b.show();
            return b;
          };
          a.on('key', function (c) {
            if (27 == c.data.keyCode) {
              var h = a._.notificationArea.notifications;
              h.length && (b(a.lang.notification.closed), h[h.length - 1].hide(), c.cancel());
            }
          });
        },
      });
      a.prototype = {
        show: function () {
          !1 !== this.editor.fire('notificationShow', { notification: this }) && (this.area.add(this), this._hideAfterTimeout());
        },
        update: function (a) {
          var b = !0;
          !1 === this.editor.fire('notificationUpdate', { notification: this, options: a }) && (b = !1);
          var c = this.element,
            h = c.findOne('.cke_notification_message'),
            k = c.findOne('.cke_notification_progress'),
            m = a.type;
          c.removeAttribute('role');
          a.progress && 'progress' != this.type && (m = 'progress');
          m &&
            (c.removeClass(this._getClass()),
            c.removeAttribute('aria-label'),
            (this.type = m),
            c.addClass(this._getClass()),
            c.setAttribute('aria-label', this.type),
            'progress' != this.type || k
              ? 'progress' != this.type && k && k.remove()
              : ((k = this._createProgressElement()), k.insertBefore(h)));
          void 0 !== a.message && ((this.message = a.message), h.setHtml(this.message));
          void 0 !== a.progress && ((this.progress = a.progress), k && k.setStyle('width', this._getPercentageProgress()));
          b && a.important && (c.setAttribute('role', 'alert'), this.isVisible() || this.area.add(this));
          this.duration = a.duration;
          this._hideAfterTimeout();
        },
        hide: function () {
          !1 !== this.editor.fire('notificationHide', { notification: this }) && this.area.remove(this);
        },
        isVisible: function () {
          return 0 <= CKEDITOR.tools.indexOf(this.area.notifications, this);
        },
        _createElement: function () {
          var a = this,
            b,
            c,
            h = this.editor.lang.common.close;
          b = new CKEDITOR.dom.element('div');
          b.addClass('cke_notification');
          b.addClass(this._getClass());
          b.setAttributes({ id: this.id, role: 'alert', 'aria-label': this.type });
          'progress' == this.type && b.append(this._createProgressElement());
          c = new CKEDITOR.dom.element('p');
          c.addClass('cke_notification_message');
          c.setHtml(this.message);
          b.append(c);
          c = CKEDITOR.dom.element.createFromHtml(
            '\x3ca class\x3d"cke_notification_close" href\x3d"javascript:void(0)" title\x3d"' +
              h +
              '" role\x3d"button" tabindex\x3d"-1"\x3e\x3cspan class\x3d"cke_label"\x3eX\x3c/span\x3e\x3c/a\x3e',
          );
          b.append(c);
          c.on('click', function () {
            a.editor.focus();
            a.hide();
          });
          return b;
        },
        _getClass: function () {
          return 'progress' == this.type ? 'cke_notification_info' : 'cke_notification_' + this.type;
        },
        _createProgressElement: function () {
          var a = new CKEDITOR.dom.element('span');
          a.addClass('cke_notification_progress');
          a.setStyle('width', this._getPercentageProgress());
          return a;
        },
        _getPercentageProgress: function () {
          return Math.round(100 * (this.progress || 0)) + '%';
        },
        _hideAfterTimeout: function () {
          var a = this,
            b;
          this._hideTimeoutId && clearTimeout(this._hideTimeoutId);
          if ('number' == typeof this.duration) b = this.duration;
          else if ('info' == this.type || 'success' == this.type)
            b = 'number' == typeof this.editor.config.notification_duration ? this.editor.config.notification_duration : 5e3;
          b &&
            (a._hideTimeoutId = setTimeout(function () {
              a.hide();
            }, b));
        },
      };
      h.prototype = {
        add: function (a) {
          this.notifications.push(a);
          this.element.append(a.element);
          1 == this.element.getChildCount() && (CKEDITOR.document.getBody().append(this.element), this._attachListeners());
          this._layout();
        },
        remove: function (a) {
          var b = CKEDITOR.tools.indexOf(this.notifications, a);
          0 > b ||
            (this.notifications.splice(b, 1),
            a.element.remove(),
            this.element.getChildCount() || (this._removeListeners(), this.element.remove()));
        },
        _createElement: function () {
          var a = this.editor,
            b = a.config,
            c = new CKEDITOR.dom.element('div');
          c.addClass('cke_notifications_area');
          c.setAttribute('id', 'cke_notifications_area_' + a.name);
          c.setStyle('z-index', b.baseFloatZIndex - 2);
          return c;
        },
        _attachListeners: function () {
          var a = CKEDITOR.document.getWindow(),
            b = this.editor;
          a.on('scroll', this._uiBuffer.input);
          a.on('resize', this._uiBuffer.input);
          b.on('change', this._changeBuffer.input);
          b.on('floatingSpaceLayout', this._layout, this, null, 20);
          b.on('blur', this._layout, this, null, 20);
        },
        _removeListeners: function () {
          var a = CKEDITOR.document.getWindow(),
            b = this.editor;
          a.removeListener('scroll', this._uiBuffer.input);
          a.removeListener('resize', this._uiBuffer.input);
          b.removeListener('change', this._changeBuffer.input);
          b.removeListener('floatingSpaceLayout', this._layout);
          b.removeListener('blur', this._layout);
        },
        _layout: function () {
          function a() {
            b.setStyle('left', A(q + h.width - n - r));
          }
          var b = this.element,
            c = this.editor,
            h = c.ui.contentsElement.getClientRect(),
            k = c.ui.contentsElement.getDocumentPosition(),
            m,
            g,
            d = b.getClientRect(),
            e,
            n = this._notificationWidth,
            r = this._notificationMargin;
          e = CKEDITOR.document.getWindow();
          var x = e.getScrollPosition(),
            u = e.getViewPaneSize(),
            p = CKEDITOR.document.getBody(),
            t = p.getDocumentPosition(),
            A = CKEDITOR.tools.cssLength;
          (n && r) ||
            ((e = this.element.getChild(0)),
            (n = this._notificationWidth = e.getClientRect().width),
            (r = this._notificationMargin =
              parseInt(e.getComputedStyle('margin-left'), 10) + parseInt(e.getComputedStyle('margin-right'), 10)));
          c.toolbar && ((m = c.ui.space(c.config.toolbarLocation)), (g = m.getClientRect()));
          m && m.isVisible() && g.bottom > h.top && g.bottom < h.bottom - d.height
            ? b.setStyles({ position: 'fixed', top: A(g.bottom) })
            : 0 < h.top
              ? b.setStyles({ position: 'absolute', top: A(k.y) })
              : k.y + h.height - d.height > x.y
                ? b.setStyles({ position: 'fixed', top: 0 })
                : b.setStyles({ position: 'absolute', top: A(k.y + h.height - d.height) });
          var q = 'fixed' == b.getStyle('position') ? h.left : 'static' != p.getComputedStyle('position') ? k.x - t.x : k.x;
          h.width < n + r
            ? k.x + n + r > x.x + u.width
              ? a()
              : b.setStyle('left', A(q))
            : k.x + n + r > x.x + u.width
              ? b.setStyle('left', A(q))
              : k.x + h.width / 2 + n / 2 + r > x.x + u.width
                ? b.setStyle('left', A(q - k.x + x.x + u.width - n - r))
                : 0 > h.left + h.width - n - r
                  ? a()
                  : 0 > h.left + h.width / 2 - n / 2
                    ? b.setStyle('left', A(q - k.x + x.x))
                    : b.setStyle('left', A(q + h.width / 2 - n / 2 - r / 2));
        },
      };
      CKEDITOR.plugins.notification = a;
    })();
    (function () {
      var a =
        '\x3ca id\x3d"{id}" class\x3d"cke_button cke_button__{name} cke_button_{state} {cls}"' +
        (CKEDITOR.env.gecko && !CKEDITOR.env.hc ? '' : ' href\x3d"javascript:void(\'{titleJs}\')"') +
        ' title\x3d"{title}" tabindex\x3d"-1" hidefocus\x3d"true" role\x3d"button" aria-labelledby\x3d"{id}_label" aria-describedby\x3d"{id}_description" aria-haspopup\x3d"{hasArrow}" aria-disabled\x3d"{ariaDisabled}"{hasArrowAriaHtml}{toggleAriaHtml}';
      CKEDITOR.env.gecko && CKEDITOR.env.mac && (a += ' onkeypress\x3d"return false;"');
      CKEDITOR.env.gecko && (a += ' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');
      var h = '';
      CKEDITOR.env.ie &&
        (h = 'return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26');
      var a =
          a +
          (' onkeydown\x3d"return CKEDITOR.tools.callFunction({keydownFn},event);" onfocus\x3d"return CKEDITOR.tools.callFunction({focusFn},event);" onclick\x3d"' +
            h +
            'CKEDITOR.tools.callFunction({clickFn},this);return false;"\x3e\x3cspan class\x3d"cke_button_icon cke_button__{iconName}_icon" style\x3d"{style}"') +
          '\x3e\x26nbsp;\x3c/span\x3e\x3cspan id\x3d"{id}_label" class\x3d"cke_button_label cke_button__{name}_label" aria-hidden\x3d"false"\x3e{label}\x3c/span\x3e\x3cspan id\x3d"{id}_description" class\x3d"cke_button_label" aria-hidden\x3d"false"\x3e{ariaShortcutSpace}{ariaShortcut}\x3c/span\x3e{arrowHtml}\x3c/a\x3e',
        f = CKEDITOR.addTemplate(
          'buttonArrow',
          '\x3cspan class\x3d"cke_button_arrow"\x3e' + (CKEDITOR.env.hc ? '\x26#9660;' : '') + '\x3c/span\x3e',
        ),
        b = CKEDITOR.addTemplate('button', a);
      CKEDITOR.plugins.add('button', {
        beforeInit: function (a) {
          a.ui.addHandler(CKEDITOR.UI_BUTTON, CKEDITOR.ui.button.handler);
        },
      });
      CKEDITOR.UI_BUTTON = 'button';
      CKEDITOR.ui.button = function (a) {
        CKEDITOR.tools.extend(this, a, {
          isToggle: a.isToggle || !1,
          title: a.label,
          click:
            a.click ||
            function (b) {
              b.execCommand(a.command);
            },
        });
        this._ = {};
      };
      CKEDITOR.ui.button.handler = {
        create: function (a) {
          return new CKEDITOR.ui.button(a);
        },
      };
      CKEDITOR.ui.button.prototype = {
        render: function (a, h) {
          function k() {
            var b = a.mode;
            b &&
              ((b = this.modes[b] ? (void 0 !== m[b] ? m[b] : CKEDITOR.TRISTATE_OFF) : CKEDITOR.TRISTATE_DISABLED),
              (b = a.readOnly && !this.readOnly ? CKEDITOR.TRISTATE_DISABLED : b),
              this.setState(b),
              this.refresh && this.refresh());
          }
          var m = null,
            g = CKEDITOR.env,
            d = (this._.id = CKEDITOR.tools.getNextId()),
            e = '',
            n = this.command,
            r,
            x,
            u;
          this._.editor = a;
          var p = {
              id: d,
              button: this,
              editor: a,
              focus: function () {
                CKEDITOR.document.getById(d).focus();
              },
              execute: function () {
                this.button.click(a);
              },
              attach: function (a) {
                this.button.attach(a);
              },
            },
            t = CKEDITOR.tools.addFunction(function (a) {
              if (p.onkey) return (a = new CKEDITOR.dom.event(a)), !1 !== p.onkey(p, a.getKeystroke());
            }),
            A = CKEDITOR.tools.addFunction(function (a) {
              var b;
              p.onfocus && (b = !1 !== p.onfocus(p, new CKEDITOR.dom.event(a)));
              return b;
            }),
            q = 0;
          p.clickFn = r = CKEDITOR.tools.addFunction(function () {
            q && (a.unlockSelection(1), (q = 0));
            p.execute();
            g.iOS && a.focus();
          });
          this.modes
            ? ((m = {}),
              a.on(
                'beforeModeUnload',
                function () {
                  a.mode && this._.state != CKEDITOR.TRISTATE_DISABLED && (m[a.mode] = this._.state);
                },
                this,
              ),
              a.on('activeFilterChange', k, this),
              a.on('mode', k, this),
              !this.readOnly && a.on('readOnly', k, this))
            : n &&
              (n = a.getCommand(n)) &&
              (n.on(
                'state',
                function () {
                  this.setState(n.state);
                },
                this,
              ),
              (e += n.state == CKEDITOR.TRISTATE_ON ? 'on' : n.state == CKEDITOR.TRISTATE_DISABLED ? 'disabled' : 'off'));
          var B;
          if (this.directional)
            a.on(
              'contentDirChanged',
              function (b) {
                var e = CKEDITOR.document.getById(this._.id),
                  d = e.getFirst();
                b = b.data;
                b != a.lang.dir ? e.addClass('cke_' + b) : e.removeClass('cke_ltr').removeClass('cke_rtl');
                d.setAttribute('style', CKEDITOR.skin.getIconStyle(B, 'rtl' == b, this.icon, this.iconOffset));
              },
              this,
            );
          n ? (x = a.getCommandKeystroke(n)) && (u = CKEDITOR.tools.keystrokeToString(a.lang.common.keyboard, x)) : (e += 'off');
          x = this.name || this.command;
          var z = null,
            y = this.icon;
          B = x;
          this.icon && !/\./.test(this.icon)
            ? ((B = this.icon), (y = null))
            : (this.icon && (z = this.icon), CKEDITOR.env.hidpi && this.iconHiDpi && (z = this.iconHiDpi));
          z ? (CKEDITOR.skin.addIcon(z, z), (y = null)) : (z = B);
          e = {
            id: d,
            name: x,
            iconName: B,
            label: this.label,
            cls: (this.hasArrow ? 'cke_button_expandable ' : '') + (this.className || ''),
            state: e,
            ariaDisabled: 'disabled' == e ? 'true' : 'false',
            title: this.title + (u ? ' (' + u.display + ')' : ''),
            ariaShortcutSpace: u ? '\x26nbsp;' : '',
            ariaShortcut: u ? a.lang.common.keyboardShortcut + ' ' + u.aria : '',
            titleJs: g.gecko && !g.hc ? '' : (this.title || '').replace("'", ''),
            hasArrow: ('string' === typeof this.hasArrow && this.hasArrow) || (this.hasArrow ? 'true' : 'false'),
            keydownFn: t,
            focusFn: A,
            clickFn: r,
            style: CKEDITOR.skin.getIconStyle(z, 'rtl' == a.lang.dir, y, this.iconOffset),
            arrowHtml: this.hasArrow ? f.output() : '',
            hasArrowAriaHtml: this.hasArrow ? ' aria-expanded\x3d"false"' : '',
            toggleAriaHtml: this.isToggle ? 'aria-pressed\x3d"false"' : '',
          };
          b.output(e, h);
          if (this.onRender) this.onRender();
          return p;
        },
        setState: function (a) {
          if (this._.state == a) return !1;
          this._.state = a;
          var b = CKEDITOR.document.getById(this._.id);
          return b
            ? (b.setState(a, 'cke_button'),
              b.setAttribute('aria-disabled', a == CKEDITOR.TRISTATE_DISABLED),
              this.isToggle && !this.hasArrow && b.setAttribute('aria-pressed', a === CKEDITOR.TRISTATE_ON),
              !0)
            : !1;
        },
        getState: function () {
          return this._.state;
        },
        toFeature: function (a) {
          if (this._.feature) return this._.feature;
          var b = this;
          this.allowedContent || this.requiredContent || !this.command || (b = a.getCommand(this.command) || b);
          return (this._.feature = b);
        },
      };
      CKEDITOR.ui.prototype.addButton = function (a, b) {
        this.add(a, CKEDITOR.UI_BUTTON, b);
      };
    })();
    (function () {
      function a(a) {
        function b() {
          for (var e = f(), d = CKEDITOR.tools.clone(a.config.toolbarGroups) || h(a), g = 0; g < d.length; g++) {
            var l = d[g];
            if ('/' != l) {
              'string' == typeof l && (l = d[g] = { name: l });
              var p,
                t = l.groups;
              if (t) for (var A = 0; A < t.length; A++) (p = t[A]), (p = e[p]) && m(l, p);
              (p = e[l.name]) && m(l, p);
            }
          }
          return d;
        }
        function f() {
          var b = {},
            e,
            d,
            g;
          for (e in a.ui.items)
            (d = a.ui.items[e]),
              (g = d.toolbar || 'others'),
              (g = g.split(',')),
              (d = g[0]),
              (g = parseInt(g[1] || -1, 10)),
              b[d] || (b[d] = []),
              b[d].push({ name: e, order: g });
          for (d in b)
            b[d] = b[d].sort(function (a, b) {
              return a.order == b.order ? 0 : 0 > b.order ? -1 : 0 > a.order ? 1 : a.order < b.order ? -1 : 1;
            });
          return b;
        }
        function m(b, e) {
          if (e.length) {
            b.items ? b.items.push(a.ui.create('-')) : (b.items = []);
            for (var g; (g = e.shift()); )
              (g = 'string' == typeof g ? g : g.name),
                (d && -1 != CKEDITOR.tools.indexOf(d, g)) || ((g = a.ui.create(g)) && a.addFeature(g) && b.items.push(g));
          }
        }
        function g(a) {
          var b = [],
            e,
            d,
            c;
          for (e = 0; e < a.length; ++e)
            (d = a[e]),
              (c = {}),
              '/' == d
                ? b.push(d)
                : CKEDITOR.tools.isArray(d)
                  ? (m(c, CKEDITOR.tools.clone(d)), b.push(c))
                  : d.items && (m(c, CKEDITOR.tools.clone(d.items)), (c.name = d.name), b.push(c));
          return b;
        }
        var d = a.config.removeButtons,
          d = d && d.split(','),
          e = a.config.toolbar;
        'string' == typeof e && (e = a.config['toolbar_' + e]);
        return (a.toolbar = e ? g(e) : b());
      }
      function h(a) {
        return (
          a._.toolbarGroups ||
          (a._.toolbarGroups = [
            { name: 'document', groups: ['mode', 'document', 'doctools'] },
            { name: 'clipboard', groups: ['clipboard', 'undo'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
            { name: 'forms' },
            '/',
            { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
            { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi'] },
            { name: 'links' },
            { name: 'insert' },
            '/',
            { name: 'styles' },
            { name: 'colors' },
            { name: 'tools' },
            { name: 'others' },
            { name: 'about' },
          ])
        );
      }
      var f = function () {
        this.toolbars = [];
      };
      f.prototype.focus = function () {
        for (var a = 0, b; (b = this.toolbars[a++]); )
          for (var f = 0, h; (h = b.items[f++]); )
            if (h.focus) {
              h.focus();
              return;
            }
      };
      var b = {
        modes: { wysiwyg: 1, source: 1 },
        readOnly: 1,
        exec: function (a) {
          a.toolbox &&
            (CKEDITOR.env.ie || CKEDITOR.env.air
              ? setTimeout(function () {
                  a.toolbox.focus();
                }, 100)
              : a.toolbox.focus());
        },
      };
      CKEDITOR.plugins.add('toolbar', {
        requires: 'button',
        init: function (c) {
          var h,
            k = function (a, b) {
              var d,
                e = 'rtl' == c.lang.dir,
                f = c.config.toolbarGroupCycling,
                r = e ? 37 : 39,
                e = e ? 39 : 37,
                f = void 0 === f || f;
              switch (b) {
                case 9:
                case CKEDITOR.SHIFT + 9:
                  for (; !d || !d.items.length; )
                    if (
                      ((d =
                        9 == b
                          ? (d ? d.next : a.toolbar.next) || c.toolbox.toolbars[0]
                          : (d ? d.previous : a.toolbar.previous) || c.toolbox.toolbars[c.toolbox.toolbars.length - 1]),
                      d.items.length)
                    )
                      for (a = d.items[h ? d.items.length - 1 : 0]; a && !a.focus; ) (a = h ? a.previous : a.next) || (d = 0);
                  a && a.focus();
                  return !1;
                case r:
                  d = a;
                  do (d = d.next), !d && f && (d = a.toolbar.items[0]);
                  while (d && !d.focus);
                  d ? d.focus() : k(a, 9);
                  return !1;
                case 40:
                  return a.button && a.button.hasArrow ? a.execute() : k(a, 40 == b ? r : e), !1;
                case e:
                case 38:
                  d = a;
                  do (d = d.previous), !d && f && (d = a.toolbar.items[a.toolbar.items.length - 1]);
                  while (d && !d.focus);
                  d ? d.focus() : ((h = 1), k(a, CKEDITOR.SHIFT + 9), (h = 0));
                  return !1;
                case 27:
                  return c.focus(), !1;
                case 13:
                case 32:
                  return a.execute(), !1;
                case CKEDITOR.ALT + 122:
                  return c.execCommand('elementsPathFocus'), !1;
              }
              return !0;
            };
          c.on('uiSpace', function (b) {
            if (b.data.space == c.config.toolbarLocation) {
              b.removeListener();
              c.toolbox = new f();
              var g = CKEDITOR.tools.getNextId(),
                d = [
                  '\x3cspan id\x3d"',
                  g,
                  '" class\x3d"cke_voice_label"\x3e',
                  c.lang.toolbar.toolbars,
                  '\x3c/span\x3e',
                  '\x3cspan id\x3d"' + c.ui.spaceId('toolbox') + '" class\x3d"cke_toolbox" role\x3d"group" aria-labelledby\x3d"',
                  g,
                  '" onmousedown\x3d"return false;"\x3e',
                ],
                g = !1 !== c.config.toolbarStartupExpanded,
                e,
                h;
              c.config.toolbarCanCollapse &&
                c.elementMode != CKEDITOR.ELEMENT_MODE_INLINE &&
                d.push('\x3cspan class\x3d"cke_toolbox_main"' + (g ? '\x3e' : ' style\x3d"display:none"\x3e'));
              for (var l = c.toolbox.toolbars, x = a(c), u = x.length, p = 0; p < u; p++) {
                var t,
                  A = 0,
                  q,
                  B = x[p],
                  z = '/' !== B && ('/' === x[p + 1] || p == u - 1),
                  y;
                if (B)
                  if ((e && (d.push('\x3c/span\x3e'), (h = e = 0)), '/' === B))
                    d.push('\x3cspan class\x3d"cke_toolbar_break"\x3e\x3c/span\x3e');
                  else {
                    y = B.items || B;
                    for (var v = 0; v < y.length; v++) {
                      var C = y[v],
                        F;
                      if (C) {
                        var D = function (a) {
                          a = a.render(c, d);
                          G = A.items.push(a) - 1;
                          0 < G && ((a.previous = A.items[G - 1]), (a.previous.next = a));
                          a.toolbar = A;
                          a.onkey = k;
                        };
                        if (C.type == CKEDITOR.UI_SEPARATOR) h = e && C;
                        else {
                          F = !1 !== C.canGroup;
                          if (!A) {
                            t = CKEDITOR.tools.getNextId();
                            A = { id: t, items: [] };
                            q = B.name && (c.lang.toolbar.toolbarGroups[B.name] || B.name);
                            d.push(
                              '\x3cspan id\x3d"',
                              t,
                              '" class\x3d"cke_toolbar' + (z ? ' cke_toolbar_last"' : '"'),
                              q ? ' aria-labelledby\x3d"' + t + '_label"' : '',
                              ' role\x3d"toolbar"\x3e',
                            );
                            q && d.push('\x3cspan id\x3d"', t, '_label" class\x3d"cke_voice_label"\x3e', q, '\x3c/span\x3e');
                            d.push('\x3cspan class\x3d"cke_toolbar_start"\x3e\x3c/span\x3e');
                            var G = l.push(A) - 1;
                            0 < G && ((A.previous = l[G - 1]), (A.previous.next = A));
                          }
                          F
                            ? e || (d.push('\x3cspan class\x3d"cke_toolgroup" role\x3d"presentation"\x3e'), (e = 1))
                            : e && (d.push('\x3c/span\x3e'), (e = 0));
                          h && (D(h), (h = 0));
                          D(C);
                        }
                      }
                    }
                    e && (d.push('\x3c/span\x3e'), (h = e = 0));
                    A && d.push('\x3cspan class\x3d"cke_toolbar_end"\x3e\x3c/span\x3e\x3c/span\x3e');
                  }
              }
              c.config.toolbarCanCollapse && d.push('\x3c/span\x3e');
              if (c.config.toolbarCanCollapse && c.elementMode != CKEDITOR.ELEMENT_MODE_INLINE) {
                var H = CKEDITOR.tools.addFunction(function () {
                  c.execCommand('toolbarCollapse');
                });
                c.on('destroy', function () {
                  CKEDITOR.tools.removeFunction(H);
                });
                c.addCommand('toolbarCollapse', {
                  readOnly: 1,
                  exec: function (a) {
                    var b = a.ui.space('toolbar_collapser'),
                      e = b.getPrevious(),
                      d = a.ui.space('contents'),
                      c = e.getParent(),
                      g = parseInt(d.$.style.height, 10),
                      f = c.$.offsetHeight,
                      k = b.hasClass('cke_toolbox_collapser_min');
                    k
                      ? (e.show(), b.removeClass('cke_toolbox_collapser_min'), b.setAttribute('title', a.lang.toolbar.toolbarCollapse))
                      : (e.hide(), b.addClass('cke_toolbox_collapser_min'), b.setAttribute('title', a.lang.toolbar.toolbarExpand));
                    b.getFirst().setText(k ? '▲' : '◀');
                    d.setStyle('height', g - (c.$.offsetHeight - f) + 'px');
                    a.fire('resize', {
                      outerHeight: a.container.$.offsetHeight,
                      contentsHeight: d.$.offsetHeight,
                      outerWidth: a.container.$.offsetWidth,
                    });
                  },
                  modes: { wysiwyg: 1, source: 1 },
                });
                c.setKeystroke(CKEDITOR.ALT + (CKEDITOR.env.ie || CKEDITOR.env.webkit ? 189 : 109), 'toolbarCollapse');
                d.push(
                  '\x3ca title\x3d"' +
                    (g ? c.lang.toolbar.toolbarCollapse : c.lang.toolbar.toolbarExpand) +
                    '" id\x3d"' +
                    c.ui.spaceId('toolbar_collapser') +
                    '" tabIndex\x3d"-1" class\x3d"cke_toolbox_collapser',
                );
                g || d.push(' cke_toolbox_collapser_min');
                d.push(
                  '" onclick\x3d"CKEDITOR.tools.callFunction(' + H + ')"\x3e',
                  '\x3cspan class\x3d"cke_arrow"\x3e\x26#9650;\x3c/span\x3e',
                  '\x3c/a\x3e',
                );
              }
              d.push('\x3c/span\x3e');
              b.data.html += d.join('');
            }
          });
          c.on('destroy', function () {
            if (this.toolbox) {
              var a,
                b = 0,
                d,
                e,
                c;
              for (a = this.toolbox.toolbars; b < a.length; b++)
                for (e = a[b].items, d = 0; d < e.length; d++)
                  (c = e[d]),
                    c.clickFn && CKEDITOR.tools.removeFunction(c.clickFn),
                    c.keyDownFn && CKEDITOR.tools.removeFunction(c.keyDownFn);
            }
          });
          c.on('uiReady', function () {
            var a = c.ui.space('toolbox');
            a && c.focusManager.add(a, 1);
          });
          c.addCommand('toolbarFocus', b);
          c.setKeystroke(CKEDITOR.ALT + 121, 'toolbarFocus');
          c.ui.add('-', CKEDITOR.UI_SEPARATOR, {});
          c.ui.addHandler(CKEDITOR.UI_SEPARATOR, {
            create: function () {
              return {
                render: function (a, b) {
                  b.push('\x3cspan class\x3d"cke_toolbar_separator" role\x3d"separator"\x3e\x3c/span\x3e');
                  return {};
                },
              };
            },
          });
        },
      });
      CKEDITOR.ui.prototype.addToolbarGroup = function (a, b, f) {
        var m = h(this.editor),
          g = 0 === b,
          d = { name: a };
        if (f) {
          if (
            (f = CKEDITOR.tools.search(m, function (a) {
              return a.name == f;
            }))
          ) {
            !f.groups && (f.groups = []);
            if (b && ((b = CKEDITOR.tools.indexOf(f.groups, b)), 0 <= b)) {
              f.groups.splice(b + 1, 0, a);
              return;
            }
            g ? f.groups.splice(0, 0, a) : f.groups.push(a);
            return;
          }
          b = null;
        }
        b &&
          (b = CKEDITOR.tools.indexOf(m, function (a) {
            return a.name == b;
          }));
        g ? m.splice(0, 0, a) : 'number' == typeof b ? m.splice(b + 1, 0, d) : m.push(a);
      };
    })();
    CKEDITOR.UI_SEPARATOR = 'separator';
    CKEDITOR.config.toolbarLocation = 'top';
    ('use strict');
    (function () {
      function a(a, b, d) {
        b.type || (b.type = 'auto');
        if ((d && !1 === a.fire('beforePaste', b)) || (!b.dataValue && b.dataTransfer.isEmpty())) return !1;
        b.dataValue || (b.dataValue = '');
        if (CKEDITOR.env.gecko && 'drop' == b.method && a.toolbox)
          a.once('afterPaste', function () {
            a.toolbox.focus();
            a.focus();
          });
        return a.fire('paste', b);
      }
      function h(b) {
        function d() {
          var a = b.editable();
          if (CKEDITOR.plugins.clipboard.isCustomCopyCutSupported) {
            var c = function (a) {
              b.getSelection().isCollapsed() || ((b.readOnly && 'cut' == a.name) || F.initPasteDataTransfer(a, b), a.data.preventDefault());
            };
            a.on('copy', c);
            a.on('cut', c);
            a.on(
              'cut',
              function () {
                b.readOnly || b.extractSelectedHtml();
              },
              null,
              null,
              999,
            );
          }
          a.on(F.mainPasteEvent, function (a) {
            ('beforepaste' == F.mainPasteEvent && D) || y(a);
          });
          'beforepaste' == F.mainPasteEvent &&
            (a.on('paste', function (a) {
              G || (f(), a.data.preventDefault(), y(a), h('paste'));
            }),
            a.on('contextmenu', k, null, null, 0),
            a.on(
              'beforepaste',
              function (a) {
                !a.data || a.data.$.ctrlKey || a.data.$.shiftKey || k();
              },
              null,
              null,
              0,
            ));
          a.on('beforecut', function () {
            !D && m(b);
          });
          var g;
          a.attachListener(CKEDITOR.env.ie ? a : b.document.getDocumentElement(), 'mouseup', function () {
            g = setTimeout(v, 0);
          });
          b.on('destroy', function () {
            clearTimeout(g);
          });
          a.on('keyup', v);
        }
        function c(a) {
          return {
            type: a,
            canUndo: 'cut' == a,
            startDisabled: !0,
            fakeKeystroke: 'cut' == a ? CKEDITOR.CTRL + 88 : CKEDITOR.CTRL + 67,
            exec: function () {
              'cut' == this.type && m();
              var a;
              var d = this.type;
              if (CKEDITOR.env.ie) a = h(d);
              else
                try {
                  a = b.document.$.execCommand(d, !1, null);
                } catch (c) {
                  a = !1;
                }
              a || b.showNotification(b.lang.clipboard[this.type + 'Error']);
              return a;
            },
          };
        }
        function g() {
          return {
            canUndo: !1,
            async: !0,
            fakeKeystroke: CKEDITOR.CTRL + 86,
            exec: function (b, e) {
              function d(e, f) {
                f = 'undefined' !== typeof f ? f : !0;
                e
                  ? ((e.method = 'paste'), e.dataTransfer || (e.dataTransfer = F.initPasteDataTransfer()), a(b, e, f))
                  : g && !b._.forcePasteDialog && b.showNotification(h, 'info', b.config.clipboard_notificationDuration);
                b._.forcePasteDialog = !1;
                b.fire('afterCommandExec', { name: 'paste', command: c, returnValue: !!e });
              }
              e = 'undefined' !== typeof e && null !== e ? e : {};
              var c = this,
                g = 'undefined' !== typeof e.notification ? e.notification : !0,
                f = e.type,
                k = CKEDITOR.tools.keystrokeToString(b.lang.common.keyboard, b.getCommandKeystroke(this)),
                h =
                  'string' === typeof g
                    ? g
                    : b.lang.clipboard.pasteNotification.replace(
                        /%1/,
                        '\x3ckbd aria-label\x3d"' + k.aria + '"\x3e' + k.display + '\x3c/kbd\x3e',
                      ),
                k = 'string' === typeof e ? e : e.dataValue;
              f && !0 !== b.config.forcePasteAsPlainText && 'allow-word' !== b.config.forcePasteAsPlainText
                ? (b._.nextPasteType = f)
                : delete b._.nextPasteType;
              'string' === typeof k ? d({ dataValue: k }) : b.getClipboardData(d);
            },
          };
        }
        function f() {
          G = 1;
          setTimeout(function () {
            G = 0;
          }, 100);
        }
        function k() {
          D = 1;
          setTimeout(function () {
            D = 0;
          }, 10);
        }
        function h(a) {
          var d = b.document,
            c = d.getBody(),
            g = !1,
            f = function () {
              g = !0;
            };
          c.on(a, f);
          7 < CKEDITOR.env.version ? d.$.execCommand(a) : d.$.selection.createRange().execCommand(a);
          c.removeListener(a, f);
          return g;
        }
        function m() {
          if (CKEDITOR.env.ie && !CKEDITOR.env.quirks) {
            var a = b.getSelection(),
              d,
              c,
              g;
            a.getType() == CKEDITOR.SELECTION_ELEMENT &&
              (d = a.getSelectedElement()) &&
              ((c = a.getRanges()[0]),
              (g = b.document.createText('')),
              g.insertBefore(d),
              c.setStartBefore(g),
              c.setEndAfter(d),
              a.selectRanges([c]),
              setTimeout(function () {
                d.getParent() && (g.remove(), a.selectElement(d));
              }, 0));
          }
        }
        function l(a, d) {
          var c = b.document,
            g = b.editable(),
            f = function (a) {
              a.cancel();
            },
            k;
          if (!c.getById('cke_pastebin')) {
            var h = b.getSelection(),
              m = h.createBookmarks();
            CKEDITOR.env.ie && h.root.fire('selectionchange');
            var n = new CKEDITOR.dom.element((!CKEDITOR.env.webkit && !g.is('body')) || CKEDITOR.env.ie ? 'div' : 'body', c);
            n.setAttributes({ id: 'cke_pastebin', 'data-cke-temp': '1' });
            var r = 0,
              c = c.getWindow();
            CKEDITOR.env.webkit
              ? (g.append(n),
                n.addClass('cke_editable'),
                g.is('body') ||
                  ((r = 'static' != g.getComputedStyle('position') ? g : CKEDITOR.dom.element.get(g.$.offsetParent)),
                  (r = r.getDocumentPosition().y)))
              : g.getAscendant(CKEDITOR.env.ie ? 'body' : 'html', 1).append(n);
            n.setStyles({
              position: 'absolute',
              top: c.getScrollPosition().y - r + 10 + 'px',
              width: '1px',
              height: Math.max(1, c.getViewPaneSize().height - 20) + 'px',
              overflow: 'hidden',
              margin: 0,
              padding: 0,
            });
            CKEDITOR.env.safari && n.setStyles(CKEDITOR.tools.cssVendorPrefix('user-select', 'text'));
            (r = n.getParent().isReadOnly())
              ? (n.setOpacity(0), n.setAttribute('contenteditable', !0))
              : n.setStyle('ltr' == b.config.contentsLangDirection ? 'left' : 'right', '-10000px');
            b.on('selectionChange', f, null, null, 0);
            if (CKEDITOR.env.webkit || CKEDITOR.env.gecko) k = g.once('blur', f, null, null, -100);
            r && n.focus();
            r = new CKEDITOR.dom.range(n);
            r.selectNodeContents(n);
            var q = r.select();
            CKEDITOR.env.ie &&
              (k = g.once('blur', function () {
                b.lockSelection(q);
              }));
            var v = CKEDITOR.document.getWindow().getScrollPosition().y;
            setTimeout(function () {
              CKEDITOR.env.webkit && (CKEDITOR.document.getBody().$.scrollTop = v);
              k && k.removeListener();
              CKEDITOR.env.ie && g.focus();
              h.selectBookmarks(m);
              n.remove();
              var a;
              CKEDITOR.env.webkit && (a = n.getFirst()) && a.is && a.hasClass('Apple-style-span') && (n = a);
              b.removeListener('selectionChange', f);
              d(n.getHtml());
            }, 0);
          }
        }
        function B() {
          if ('paste' == F.mainPasteEvent) return b.fire('beforePaste', { type: 'auto', method: 'paste' }), !1;
          b.focus();
          f();
          var a = b.focusManager;
          a.lock();
          if (b.editable().fire(F.mainPasteEvent) && !h('paste')) return a.unlock(), !1;
          a.unlock();
          return !0;
        }
        function z(a) {
          if ('wysiwyg' == b.mode)
            switch (a.data.keyCode) {
              case CKEDITOR.CTRL + 86:
              case CKEDITOR.SHIFT + 45:
                a = b.editable();
                f();
                'paste' == F.mainPasteEvent && a.fire('beforepaste');
                break;
              case CKEDITOR.CTRL + 88:
              case CKEDITOR.SHIFT + 46:
                b.fire('saveSnapshot'),
                  setTimeout(function () {
                    b.fire('saveSnapshot');
                  }, 50);
            }
        }
        function y(d) {
          var c = { type: 'auto', method: 'paste', dataTransfer: F.initPasteDataTransfer(d) };
          c.dataTransfer.cacheData();
          var g = !1 !== b.fire('beforePaste', c);
          g && F.canClipboardApiBeTrusted(c.dataTransfer, b)
            ? (d.data.preventDefault(),
              setTimeout(function () {
                a(b, c);
              }, 0))
            : l(d, function (d) {
                c.dataValue = d.replace(/<span[^>]+data-cke-bookmark[^<]*?<\/span>/gi, '');
                g && a(b, c);
              });
        }
        function v() {
          if ('wysiwyg' == b.mode) {
            var a = C('paste');
            b.getCommand('cut').setState(C('cut'));
            b.getCommand('copy').setState(C('copy'));
            b.getCommand('paste').setState(a);
            b.fire('pasteState', a);
          }
        }
        function C(a) {
          var d = b.getSelection(),
            d = d && d.getRanges()[0];
          if ((b.readOnly || (d && d.checkReadOnly())) && a in { paste: 1, cut: 1 }) return CKEDITOR.TRISTATE_DISABLED;
          if ('paste' == a) return CKEDITOR.TRISTATE_OFF;
          a = b.getSelection();
          d = a.getRanges();
          return a.getType() == CKEDITOR.SELECTION_NONE || (1 == d.length && d[0].collapsed)
            ? CKEDITOR.TRISTATE_DISABLED
            : CKEDITOR.TRISTATE_OFF;
        }
        var F = CKEDITOR.plugins.clipboard,
          D = 0,
          G = 0;
        (function () {
          b.on('key', z);
          b.on('contentDom', d);
          b.on('selectionChange', v);
          if (b.contextMenu) {
            b.contextMenu.addListener(function () {
              return { cut: C('cut'), copy: C('copy'), paste: C('paste') };
            });
            var a = null;
            b.on('menuShow', function () {
              a && (a.removeListener(), (a = null));
              var d = b.contextMenu.findItemByCommandName('paste');
              d &&
                d.element &&
                (a = d.element.on('touchend', function () {
                  b._.forcePasteDialog = !0;
                }));
            });
          }
          if (b.ui.addButton)
            b.once('instanceReady', function () {
              b._.pasteButtons &&
                CKEDITOR.tools.array.forEach(b._.pasteButtons, function (a) {
                  if ((a = b.ui.get(a)))
                    if ((a = CKEDITOR.document.getById(a._.id)))
                      a.on('touchend', function () {
                        b._.forcePasteDialog = !0;
                      });
                });
            });
        })();
        (function () {
          function a(d, c, g, f, k) {
            var h = b.lang.clipboard[c];
            b.addCommand(c, g);
            b.ui.addButton && b.ui.addButton(d, { label: h, command: c, toolbar: 'clipboard,' + f });
            b.addMenuItems && b.addMenuItem(c, { label: h, command: c, group: 'clipboard', order: k });
          }
          a('Cut', 'cut', c('cut'), 10, 1);
          a('Copy', 'copy', c('copy'), 20, 4);
          a('Paste', 'paste', g(), 30, 8);
          b._.pasteButtons || (b._.pasteButtons = []);
          b._.pasteButtons.push('Paste');
        })();
        b.getClipboardData = function (a, d) {
          function c(a) {
            a.removeListener();
            a.cancel();
            d(a.data);
          }
          function g(a) {
            a.removeListener();
            a.cancel();
            d({ type: k, dataValue: a.data.dataValue, dataTransfer: a.data.dataTransfer, method: 'paste' });
          }
          var f = !1,
            k = 'auto';
          d || ((d = a), (a = null));
          b.on(
            'beforePaste',
            function (a) {
              a.removeListener();
              f = !0;
              k = a.data.type;
            },
            null,
            null,
            1e3,
          );
          b.on('paste', c, null, null, 0);
          !1 === B() &&
            (b.removeListener('paste', c),
            b._.forcePasteDialog && f && b.fire('pasteDialog')
              ? (b.on('pasteDialogCommit', g),
                b.on('dialogHide', function (a) {
                  a.removeListener();
                  a.data.removeListener('pasteDialogCommit', g);
                  a.data._.committed || d(null);
                }))
              : d(null));
        };
      }
      function f(a) {
        if (CKEDITOR.env.webkit) {
          if (!a.match(/^[^<]*$/g) && !a.match(/^(<div><br( ?\/)?><\/div>|<div>[^<]*<\/div>)*$/gi)) return 'html';
        } else if (CKEDITOR.env.ie) {
          if (!a.match(/^([^<]|<br( ?\/)?>)*$/gi) && !a.match(/^(<p>([^<]|<br( ?\/)?>)*<\/p>|(\r\n))*$/gi)) return 'html';
        } else if (CKEDITOR.env.gecko) {
          if (!a.match(/^([^<]|<br( ?\/)?>)*$/gi)) return 'html';
        } else return 'html';
        return 'htmlifiedtext';
      }
      function b(a, b) {
        function d(a) {
          return CKEDITOR.tools.repeat('\x3c/p\x3e\x3cp\x3e', ~~(a / 2)) + (1 == a % 2 ? '\x3cbr\x3e' : '');
        }
        b = b
          .replace(/(?!\u3000)\s+/g, ' ')
          .replace(/> +</g, '\x3e\x3c')
          .replace(/<br ?\/>/gi, '\x3cbr\x3e');
        b = b.replace(/<\/?[A-Z]+>/g, function (a) {
          return a.toLowerCase();
        });
        if (b.match(/^[^<]$/)) return b;
        CKEDITOR.env.webkit &&
          -1 < b.indexOf('\x3cdiv\x3e') &&
          ((b = b
            .replace(/^(<div>(<br>|)<\/div>)(?!$|(<div>(<br>|)<\/div>))/g, '\x3cbr\x3e')
            .replace(/^(<div>(<br>|)<\/div>){2}(?!$)/g, '\x3cdiv\x3e\x3c/div\x3e')),
          b.match(/<div>(<br>|)<\/div>/) &&
            (b =
              '\x3cp\x3e' +
              b.replace(/(<div>(<br>|)<\/div>)+/g, function (a) {
                return d(a.split('\x3c/div\x3e\x3cdiv\x3e').length + 1);
              }) +
              '\x3c/p\x3e'),
          (b = b.replace(/<\/div><div>/g, '\x3cbr\x3e')),
          (b = b.replace(/<\/?div>/g, '')));
        CKEDITOR.env.gecko &&
          a.enterMode != CKEDITOR.ENTER_BR &&
          (CKEDITOR.env.gecko && (b = b.replace(/^<br><br>$/, '\x3cbr\x3e')),
          -1 < b.indexOf('\x3cbr\x3e\x3cbr\x3e') &&
            (b =
              '\x3cp\x3e' +
              b.replace(/(<br>){2,}/g, function (a) {
                return d(a.length / 4);
              }) +
              '\x3c/p\x3e'));
        return k(a, b);
      }
      function c(a) {
        function b() {
          var a = {},
            e;
          for (e in CKEDITOR.dtd) '$' != e.charAt(0) && 'div' != e && 'span' != e && (a[e] = 1);
          return a;
        }
        var d = {};
        return {
          get: function (c) {
            return 'plain-text' == c
              ? d.plainText || (d.plainText = new CKEDITOR.filter(a, 'br'))
              : 'semantic-content' == c
                ? ((c = d.semanticContent) ||
                    ((c = new CKEDITOR.filter(a, {})),
                    c.allow({ $1: { elements: b(), attributes: !0, styles: !1, classes: !1 } }),
                    (c = d.semanticContent = c)),
                  c)
                : c
                  ? new CKEDITOR.filter(a, c)
                  : null;
          },
        };
      }
      function l(a, b, d) {
        b = CKEDITOR.htmlParser.fragment.fromHtml(b);
        var c = new CKEDITOR.htmlParser.basicWriter();
        d.applyTo(b, !0, !1, a.activeEnterMode);
        b.writeHtml(c);
        return c.getHtml();
      }
      function k(a, b) {
        a.enterMode == CKEDITOR.ENTER_BR
          ? (b = b
              .replace(/(<\/p><p>)+/g, function (a) {
                return CKEDITOR.tools.repeat('\x3cbr\x3e', (a.length / 7) * 2);
              })
              .replace(/<\/?p>/g, ''))
          : a.enterMode == CKEDITOR.ENTER_DIV && (b = b.replace(/<(\/)?p>/g, '\x3c$1div\x3e'));
        return b;
      }
      function m(a) {
        a.data.preventDefault();
        a.data.$.dataTransfer.dropEffect = 'none';
      }
      function g(b) {
        var d = CKEDITOR.plugins.clipboard;
        b.on('contentDom', function () {
          function c(d, g, f) {
            g.select();
            a(b, { dataTransfer: f, method: 'drop' }, 1);
            f.sourceEditor.fire('saveSnapshot');
            f.sourceEditor.editable().extractHtmlFromRange(d);
            f.sourceEditor.getSelection().selectRanges([d]);
            f.sourceEditor.fire('saveSnapshot');
          }
          function g(c, f) {
            c.select();
            a(b, { dataTransfer: f, method: 'drop' }, 1);
            d.resetDragDataTransfer();
          }
          function f(a, d, c) {
            var g = { $: a.data.$, target: a.data.getTarget() };
            d && (g.dragRange = d);
            c && (g.dropRange = c);
            !1 === b.fire(a.name, g) && a.data.preventDefault();
          }
          function k(a) {
            a.type != CKEDITOR.NODE_ELEMENT && (a = a.getParent());
            return a.getChildCount();
          }
          var h = b.editable(),
            m = CKEDITOR.plugins.clipboard.getDropTarget(b),
            l = b.ui.space('top'),
            B = b.ui.space('bottom');
          d.preventDefaultDropOnElement(l);
          d.preventDefaultDropOnElement(B);
          h.attachListener(m, 'dragstart', f);
          h.attachListener(b, 'dragstart', d.resetDragDataTransfer, d, null, 1);
          h.attachListener(
            b,
            'dragstart',
            function (a) {
              d.initDragDataTransfer(a, b);
            },
            null,
            null,
            2,
          );
          h.attachListener(
            b,
            'dragstart',
            function () {
              var a = (d.dragRange = b.getSelection().getRanges()[0]);
              CKEDITOR.env.ie &&
                10 > CKEDITOR.env.version &&
                ((d.dragStartContainerChildCount = a ? k(a.startContainer) : null),
                (d.dragEndContainerChildCount = a ? k(a.endContainer) : null));
            },
            null,
            null,
            100,
          );
          h.attachListener(m, 'dragend', f);
          h.attachListener(b, 'dragend', d.initDragDataTransfer, d, null, 1);
          h.attachListener(b, 'dragend', d.resetDragDataTransfer, d, null, 100);
          h.attachListener(m, 'dragover', function (a) {
            if (CKEDITOR.env.edge) a.data.preventDefault();
            else {
              var b = a.data.getTarget();
              b && b.is && b.is('html')
                ? a.data.preventDefault()
                : CKEDITOR.env.ie &&
                  CKEDITOR.plugins.clipboard.isFileApiSupported &&
                  a.data.$.dataTransfer.types.contains('Files') &&
                  a.data.preventDefault();
            }
          });
          h.attachListener(
            m,
            'drop',
            function (a) {
              if (!a.data.$.defaultPrevented && (a.data.preventDefault(), !b.readOnly)) {
                var c = a.data.getTarget();
                if (!c.isReadOnly() || (c.type == CKEDITOR.NODE_ELEMENT && c.is('html'))) {
                  var c = d.getRangeAtDropPosition(a, b),
                    g = d.dragRange;
                  c && f(a, g, c);
                }
              }
            },
            null,
            null,
            9999,
          );
          h.attachListener(b, 'drop', d.initDragDataTransfer, d, null, 1);
          h.attachListener(
            b,
            'drop',
            function (a) {
              if ((a = a.data)) {
                var f = a.dropRange,
                  k = a.dragRange,
                  h = a.dataTransfer;
                h.getTransferType(b) == CKEDITOR.DATA_TRANSFER_INTERNAL
                  ? setTimeout(function () {
                      d.internalDrop(k, f, h, b);
                    }, 0)
                  : h.getTransferType(b) == CKEDITOR.DATA_TRANSFER_CROSS_EDITORS
                    ? c(k, f, h)
                    : g(f, h);
              }
            },
            null,
            null,
            9999,
          );
        });
      }
      var d;
      CKEDITOR.plugins.add('clipboard', {
        requires: 'dialog,notification,toolbar',
        _supportedFileMatchers: [],
        init: function (a) {
          function d(a) {
            return -1 !== CKEDITOR.tools.indexOf(['image/png', 'image/jpeg', 'image/gif'], a.type);
          }
          function k(b) {
            return CKEDITOR.tools.array.some(a.plugins.clipboard._supportedFileMatchers, function (a) {
              return a(b);
            });
          }
          function m(b) {
            b.length &&
              ((b = CKEDITOR.tools.array.unique(b)),
              (b = CKEDITOR.tools.array.filter(b, function (a) {
                return !!CKEDITOR.tools.trim(a);
              })),
              (b = u(b.join(', '))),
              a.showNotification(b, 'info', a.config.clipboard_notificationDuration));
          }
          function u(b) {
            return b
              ? a.lang.clipboard.fileFormatNotSupportedNotification.replace(/\${formats\}/g, '\x3cem\x3e' + b + '\x3c/em\x3e')
              : a.lang.clipboard.fileWithoutFormatNotSupportedNotification;
          }
          function p(a, b) {
            return (CKEDITOR.env.ie && a.data.fileTransferCancel) || !(CKEDITOR.env.ie || (b && B !== b.id))
              ? !1
              : b.isFileTransfer() && 1 === b.getFilesCount();
          }
          var t,
            A = c(a);
          a.config.forcePasteAsPlainText
            ? (t = 'plain-text')
            : a.config.pasteFilter
              ? (t = a.config.pasteFilter)
              : !CKEDITOR.env.webkit || 'pasteFilter' in a.config || (t = 'semantic-content');
          a.pasteFilter = A.get(t);
          h(a);
          g(a);
          CKEDITOR.dialog.add('paste', CKEDITOR.getUrl(this.path + 'dialogs/paste.js'));
          var q = CKEDITOR.plugins.clipboard.isCustomDataTypesSupported || CKEDITOR.plugins.clipboard.isFileApiSupported,
            B;
          CKEDITOR.plugins.clipboard.addFileMatcher(a, d);
          a.on(
            'paste',
            function (a) {
              if (q) {
                var b = a.data;
                a = b.dataTransfer;
                if (!b.dataValue) {
                  for (var b = [], e = 0; e < a.getFilesCount(); e++) {
                    var d = a.getFile(e);
                    k(d) || b.push(d.type);
                  }
                  m(b);
                }
              }
            },
            null,
            null,
            1,
          );
          a.on(
            'paste',
            function (b) {
              if (q && a.config.clipboard_handleImages) {
                var c = b.data,
                  g = c.dataTransfer;
                if (!c.dataValue && p(b, g) && ((g = g.getFile(0)), d(g))) {
                  var f = new FileReader();
                  f.addEventListener(
                    'load',
                    function () {
                      b.data.dataValue = '\x3cimg src\x3d"' + f.result + '" /\x3e';
                      a.fire('paste', b.data);
                    },
                    !1,
                  );
                  f.addEventListener(
                    'abort',
                    function () {
                      CKEDITOR.env.ie && (b.data.fileTransferCancel = !0);
                      a.fire('paste', b.data);
                    },
                    !1,
                  );
                  f.addEventListener(
                    'error',
                    function () {
                      CKEDITOR.env.ie && (b.data.fileTransferCancel = !0);
                      a.fire('paste', b.data);
                    },
                    !1,
                  );
                  f.readAsDataURL(g);
                  B = c.dataTransfer.id;
                  b.stop();
                }
              }
            },
            null,
            null,
            1,
          );
          a.on(
            'paste',
            function (b) {
              b.data.dataTransfer || (b.data.dataTransfer = new CKEDITOR.plugins.clipboard.dataTransfer());
              if (!b.data.dataValue) {
                var d = b.data.dataTransfer,
                  c = d.getData('text/html');
                if (c) (b.data.dataValue = c), (b.data.type = 'html');
                else if ((c = d.getData('text/plain')))
                  (b.data.dataValue = a.editable().transformPlainTextToHtml(c)), (b.data.type = 'text');
              }
            },
            null,
            null,
            1,
          );
          a.on(
            'paste',
            function (a) {
              var b = a.data.dataValue,
                e = CKEDITOR.dtd.$block;
              -1 < b.indexOf('Apple-') &&
                ((b = b.replace(/<span class="Apple-converted-space">&nbsp;<\/span>/gi, ' ')),
                'html' != a.data.type &&
                  (b = b.replace(/<span class="Apple-tab-span"[^>]*>([^<]*)<\/span>/gi, function (a, b) {
                    return b.replace(/\t/g, '\x26nbsp;\x26nbsp; \x26nbsp;');
                  })),
                -1 < b.indexOf('\x3cbr class\x3d"Apple-interchange-newline"\x3e') &&
                  ((a.data.startsWithEOL = 1),
                  (a.data.preSniffing = 'html'),
                  (b = b.replace(/<br class="Apple-interchange-newline">/, ''))),
                (b = b.replace(/(<[^>]+) class="Apple-[^"]*"/gi, '$1')));
              if (b.match(/^<[^<]+cke_(editable|contents)/i)) {
                var d,
                  c,
                  g = new CKEDITOR.dom.element('div');
                for (
                  g.setHtml(b);
                  1 == g.getChildCount() &&
                  (d = g.getFirst()) &&
                  d.type == CKEDITOR.NODE_ELEMENT &&
                  (d.hasClass('cke_editable') || d.hasClass('cke_contents'));

                )
                  g = c = d;
                c && (b = c.getHtml().replace(/<br>$/i, ''));
              }
              CKEDITOR.env.ie
                ? (b = b.replace(/^&nbsp;(?: |\r\n)?<(\w+)/g, function (b, d) {
                    return d.toLowerCase() in e ? ((a.data.preSniffing = 'html'), '\x3c' + d) : b;
                  }))
                : CKEDITOR.env.webkit
                  ? (b = b.replace(/<\/(\w+)><div><br><\/div>$/, function (b, d) {
                      return d in e ? ((a.data.endsWithEOL = 1), '\x3c/' + d + '\x3e') : b;
                    }))
                  : CKEDITOR.env.gecko && (b = b.replace(/(\s)<br>$/, '$1'));
              a.data.dataValue = b;
            },
            null,
            null,
            3,
          );
          a.on(
            'paste',
            function (d) {
              d = d.data;
              var c = a._.nextPasteType || d.type,
                g = d.dataValue,
                k,
                h = a.config.clipboard_defaultContentType || 'html',
                m = d.dataTransfer.getTransferType(a) == CKEDITOR.DATA_TRANSFER_EXTERNAL,
                n = !0 === a.config.forcePasteAsPlainText;
              k = 'html' == c || 'html' == d.preSniffing ? 'html' : f(g);
              delete a._.nextPasteType;
              'htmlifiedtext' == k && (g = b(a.config, g));
              if ('text' == c && 'html' == k) g = l(a, g, A.get('plain-text'));
              else if ((m && a.pasteFilter && !d.dontFilter) || n) g = l(a, g, a.pasteFilter);
              d.startsWithEOL && (g = '\x3cbr data-cke-eol\x3d"1"\x3e' + g);
              d.endsWithEOL && (g += '\x3cbr data-cke-eol\x3d"1"\x3e');
              'auto' == c && (c = 'html' == k || 'html' == h ? 'html' : 'text');
              d.type = c;
              d.dataValue = g;
              delete d.preSniffing;
              delete d.startsWithEOL;
              delete d.endsWithEOL;
            },
            null,
            null,
            6,
          );
          a.on(
            'paste',
            function (b) {
              b = b.data;
              b.dataValue &&
                (a.insertHtml(b.dataValue, b.type, b.range),
                setTimeout(function () {
                  a.fire('afterPaste');
                }, 0));
            },
            null,
            null,
            1e3,
          );
          a.on('pasteDialog', function (b) {
            setTimeout(function () {
              a.openDialog('paste', b.data);
            }, 0);
          });
        },
      });
      CKEDITOR.plugins.clipboard = {
        addFileMatcher: function (a, b) {
          a.plugins.clipboard._supportedFileMatchers.push(b);
        },
        isCustomCopyCutSupported:
          (CKEDITOR.env.ie && 16 > CKEDITOR.env.version) || (CKEDITOR.env.iOS && 605 > CKEDITOR.env.version) ? !1 : !0,
        isCustomDataTypesSupported: !CKEDITOR.env.ie || 16 <= CKEDITOR.env.version,
        isFileApiSupported: !CKEDITOR.env.ie || 9 < CKEDITOR.env.version,
        mainPasteEvent: CKEDITOR.env.ie && !CKEDITOR.env.edge ? 'beforepaste' : 'paste',
        addPasteButton: function (a, b, d) {
          a.ui.addButton && (a.ui.addButton(b, d), a._.pasteButtons || (a._.pasteButtons = []), a._.pasteButtons.push(b));
        },
        canClipboardApiBeTrusted: function (a, b) {
          return a.getTransferType(b) != CKEDITOR.DATA_TRANSFER_EXTERNAL ||
            (CKEDITOR.env.chrome && !a.isEmpty()) ||
            (CKEDITOR.env.gecko && (a.getData('text/html') || a.getFilesCount())) ||
            (CKEDITOR.env.safari && 603 <= CKEDITOR.env.version && !CKEDITOR.env.iOS) ||
            (CKEDITOR.env.iOS && 605 <= CKEDITOR.env.version) ||
            (CKEDITOR.env.edge && 16 <= CKEDITOR.env.version)
            ? !0
            : !1;
        },
        getDropTarget: function (a) {
          var b = a.editable();
          return (CKEDITOR.env.ie && 9 > CKEDITOR.env.version) || b.isInline() ? b : a.document;
        },
        fixSplitNodesAfterDrop: function (a, b, d, c) {
          function g(a, e, d) {
            var c = a;
            c.type == CKEDITOR.NODE_TEXT && (c = a.getParent());
            if (c.equals(e) && d != e.getChildCount())
              return (
                (a = b.startContainer.getChild(b.startOffset - 1)),
                (e = b.startContainer.getChild(b.startOffset)),
                a &&
                  a.type == CKEDITOR.NODE_TEXT &&
                  e &&
                  e.type == CKEDITOR.NODE_TEXT &&
                  ((d = a.getLength()), a.setText(a.getText() + e.getText()), e.remove(), b.setStart(a, d), b.collapse(!0)),
                !0
              );
          }
          var f = b.startContainer;
          'number' == typeof c &&
            'number' == typeof d &&
            f.type == CKEDITOR.NODE_ELEMENT &&
            (g(a.startContainer, f, d) || g(a.endContainer, f, c));
        },
        isDropRangeAffectedByDragRange: function (a, b) {
          var d = b.startContainer,
            c = b.endOffset;
          return (a.endContainer.equals(d) && a.endOffset <= c) ||
            (a.startContainer.getParent().equals(d) && a.startContainer.getIndex() < c) ||
            (a.endContainer.getParent().equals(d) && a.endContainer.getIndex() < c)
            ? !0
            : !1;
        },
        internalDrop: function (b, d, c, g) {
          var f = CKEDITOR.plugins.clipboard,
            k = g.editable(),
            h,
            m;
          g.fire('saveSnapshot');
          g.fire('lockSnapshot', { dontUpdate: 1 });
          CKEDITOR.env.ie &&
            10 > CKEDITOR.env.version &&
            this.fixSplitNodesAfterDrop(b, d, f.dragStartContainerChildCount, f.dragEndContainerChildCount);
          (m = this.isDropRangeAffectedByDragRange(b, d)) || (h = b.createBookmark(!1));
          f = d.clone().createBookmark(!1);
          m && (h = b.createBookmark(!1));
          b = h.startNode;
          d = h.endNode;
          m = f.startNode;
          d && b.getPosition(m) & CKEDITOR.POSITION_PRECEDING && d.getPosition(m) & CKEDITOR.POSITION_FOLLOWING && m.insertBefore(b);
          b = g.createRange();
          b.moveToBookmark(h);
          k.extractHtmlFromRange(b, 1);
          d = g.createRange();
          f.startNode.getCommonAncestor(k) || (f = g.getSelection().createBookmarks()[0]);
          d.moveToBookmark(f);
          a(g, { dataTransfer: c, method: 'drop', range: d }, 1);
          g.fire('unlockSnapshot');
        },
        getRangeAtDropPosition: function (a, b) {
          var d = a.data.$,
            c = d.clientX,
            g = d.clientY,
            f = b.getSelection(!0).getRanges()[0],
            k = b.createRange();
          if (a.data.testRange) return a.data.testRange;
          if (document.caretRangeFromPoint && b.document.$.caretRangeFromPoint(c, g))
            (d = b.document.$.caretRangeFromPoint(c, g)), k.setStart(CKEDITOR.dom.node(d.startContainer), d.startOffset), k.collapse(!0);
          else if (d.rangeParent) k.setStart(CKEDITOR.dom.node(d.rangeParent), d.rangeOffset), k.collapse(!0);
          else {
            if (CKEDITOR.env.ie && 8 < CKEDITOR.env.version && f && b.editable().hasFocus) return f;
            if (document.body.createTextRange) {
              b.focus();
              d = b.document.getBody().$.createTextRange();
              try {
                for (var h = !1, m = 0; 20 > m && !h; m++) {
                  if (!h)
                    try {
                      d.moveToPoint(c, g - m), (h = !0);
                    } catch (l) {}
                  if (!h)
                    try {
                      d.moveToPoint(c, g + m), (h = !0);
                    } catch (z) {}
                }
                if (h) {
                  var y = 'cke-temp-' + new Date().getTime();
                  d.pasteHTML('\x3cspan id\x3d"' + y + '"\x3e​\x3c/span\x3e');
                  var v = b.document.getById(y);
                  k.moveToPosition(v, CKEDITOR.POSITION_BEFORE_START);
                  v.remove();
                } else {
                  var C = b.document.$.elementFromPoint(c, g),
                    F = new CKEDITOR.dom.element(C),
                    D;
                  if (F.equals(b.editable()) || 'html' == F.getName())
                    return f && f.startContainer && !f.startContainer.equals(b.editable()) ? f : null;
                  D = F.getClientRect();
                  c < D.left ? k.setStartAt(F, CKEDITOR.POSITION_AFTER_START) : k.setStartAt(F, CKEDITOR.POSITION_BEFORE_END);
                  k.collapse(!0);
                }
              } catch (G) {
                return null;
              }
            } else return null;
          }
          return k;
        },
        initDragDataTransfer: function (a, b) {
          var d = a.data.$ ? a.data.$.dataTransfer : null,
            c = new this.dataTransfer(d, b);
          'dragstart' === a.name && c.storeId();
          d
            ? this.dragData && c.id == this.dragData.id
              ? (c = this.dragData)
              : (this.dragData = c)
            : this.dragData
              ? (c = this.dragData)
              : (this.dragData = c);
          a.data.dataTransfer = c;
        },
        resetDragDataTransfer: function () {
          this.dragData = null;
        },
        initPasteDataTransfer: function (a, b) {
          if (this.isCustomCopyCutSupported) {
            if (a && a.data && a.data.$) {
              var d = a.data.$.clipboardData,
                c = new this.dataTransfer(d, b);
              ('copy' !== a.name && 'cut' !== a.name) || c.storeId();
              this.copyCutData && c.id == this.copyCutData.id ? ((c = this.copyCutData), (c.$ = d)) : (this.copyCutData = c);
              return c;
            }
            return new this.dataTransfer(null, b);
          }
          return new this.dataTransfer((CKEDITOR.env.edge && a && a.data.$ && a.data.$.clipboardData) || null, b);
        },
        preventDefaultDropOnElement: function (a) {
          a && a.on('dragover', m);
        },
      };
      d = CKEDITOR.plugins.clipboard.isCustomDataTypesSupported ? 'cke/id' : 'Text';
      CKEDITOR.plugins.clipboard.dataTransfer = function (a, b) {
        a && (this.$ = a);
        this._ = {
          metaRegExp: /^<meta.*?>/i,
          fragmentRegExp: /\s*\x3c!--StartFragment--\x3e|\x3c!--EndFragment--\x3e\s*/g,
          types: [],
          data: {},
          files: [],
          nativeHtmlCache: '',
          normalizeType: function (a) {
            a = a.toLowerCase();
            return 'text' == a || 'text/plain' == a ? 'Text' : 'url' == a ? 'URL' : 'files' === a ? 'Files' : a;
          },
        };
        this._.fallbackDataTransfer = new CKEDITOR.plugins.clipboard.fallbackDataTransfer(this);
        this.id = this.getData(d);
        this.id || (this.id = 'Text' == d ? '' : 'cke-' + CKEDITOR.tools.getUniqueId());
        b &&
          ((this.sourceEditor = b),
          this.setData('text/html', b.getSelectedHtml(1)),
          'Text' == d || this.getData('text/plain') || this.setData('text/plain', b.getSelection().getSelectedText()));
      };
      CKEDITOR.DATA_TRANSFER_INTERNAL = 1;
      CKEDITOR.DATA_TRANSFER_CROSS_EDITORS = 2;
      CKEDITOR.DATA_TRANSFER_EXTERNAL = 3;
      CKEDITOR.plugins.clipboard.dataTransfer.prototype = {
        getData: function (a, b) {
          a = this._.normalizeType(a);
          var d = 'text/html' == a && b ? this._.nativeHtmlCache : this._.data[a];
          if (void 0 === d || null === d || '' === d) {
            if (this._.fallbackDataTransfer.isRequired()) d = this._.fallbackDataTransfer.getData(a, b);
            else
              try {
                d = this.$.getData(a) || '';
              } catch (c) {
                d = '';
              }
            'text/html' != a || b || (d = this._stripHtml(d));
          }
          'Text' == a && CKEDITOR.env.gecko && this.getFilesCount() && 'file://' == d.substring(0, 7) && (d = '');
          if ('string' === typeof d)
            var g = d.indexOf('\x3c/html\x3e'),
              d = -1 !== g ? d.substring(0, g + 7) : d;
          return d;
        },
        setData: function (a, b) {
          a = this._.normalizeType(a);
          'text/html' == a ? ((this._.data[a] = this._stripHtml(b)), (this._.nativeHtmlCache = b)) : (this._.data[a] = b);
          if (CKEDITOR.plugins.clipboard.isCustomDataTypesSupported || 'URL' == a || 'Text' == a)
            if (('Text' == d && 'Text' == a && (this.id = b), this._.fallbackDataTransfer.isRequired()))
              this._.fallbackDataTransfer.setData(a, b);
            else
              try {
                this.$.setData(a, b);
              } catch (c) {}
        },
        storeId: function () {
          'Text' !== d && this.setData(d, this.id);
        },
        getTransferType: function (a) {
          return this.sourceEditor
            ? this.sourceEditor == a
              ? CKEDITOR.DATA_TRANSFER_INTERNAL
              : CKEDITOR.DATA_TRANSFER_CROSS_EDITORS
            : CKEDITOR.DATA_TRANSFER_EXTERNAL;
        },
        cacheData: function () {
          function a(d) {
            d = b._.normalizeType(d);
            var e = b.getData(d);
            'text/html' == d && ((b._.nativeHtmlCache = b.getData(d, !0)), (e = b._stripHtml(e)));
            e && (b._.data[d] = e);
            b._.types.push(d);
          }
          if (this.$) {
            var b = this,
              d,
              c,
              g;
            if (CKEDITOR.plugins.clipboard.isCustomDataTypesSupported) {
              if (this.$.types) for (d = 0; d < this.$.types.length; d++) a(this.$.types[d]);
            } else a('Text'), a('URL');
            c = this._getImageFromClipboard();
            if ((g = (this.$ && this.$.files) || null) || c) {
              this._.files = [];
              if (g && g.length) for (d = 0; d < g.length; d++) this._.files.push(g[d]);
              0 === this._.files.length && c && this._.files.push(c);
            }
          }
        },
        getFilesCount: function () {
          if (this._.files.length) return this._.files.length;
          var a = (this.$ && this.$.files) || null;
          return a && a.length ? a.length : this._getImageFromClipboard() ? 1 : 0;
        },
        getFile: function (a) {
          if (this._.files.length) return this._.files[a];
          var b = (this.$ && this.$.files) || null;
          return b && b.length ? b[a] : 0 === a ? this._getImageFromClipboard() : void 0;
        },
        isFileTransfer: function () {
          var a = this.getTypes(),
            a = CKEDITOR.tools.array.filter(a, function (a) {
              return 'application/x-moz-file' !== a;
            });
          return 1 === a.length && 'files' === a[0].toLowerCase();
        },
        isEmpty: function () {
          var a = {},
            b;
          if (this.getFilesCount()) return !1;
          CKEDITOR.tools.array.forEach(CKEDITOR.tools.object.keys(this._.data), function (b) {
            a[b] = 1;
          });
          if (this.$)
            if (CKEDITOR.plugins.clipboard.isCustomDataTypesSupported) {
              if (this.$.types) for (var c = 0; c < this.$.types.length; c++) a[this.$.types[c]] = 1;
            } else (a.Text = 1), (a.URL = 1);
          'Text' != d && (a[d] = 0);
          for (b in a) if (a[b] && '' !== this.getData(b)) return !1;
          return !0;
        },
        getTypes: function () {
          return 0 < this._.types.length ? this._.types : this.$ && this.$.types ? [].slice.call(this.$.types) : [];
        },
        _getImageFromClipboard: function () {
          var a;
          try {
            if (this.$ && this.$.items && this.$.items[0] && (a = this.$.items[0].getAsFile()) && a.type) return a;
          } catch (b) {}
        },
        _stripHtml: function (a) {
          function b(a) {
            var d = new CKEDITOR.htmlParser(),
              e,
              c;
            d.onTagOpen = function (a) {
              'body' === a && (e = d._.htmlPartsRegex.lastIndex);
            };
            d.onTagClose = function (a) {
              'body' === a && (c = d._.htmlPartsRegex.lastIndex);
            };
            d.parse(a);
            return 'number' !== typeof e || 'number' !== typeof c ? a : a.substring(e, c).replace(/<\/body\s*>$/gi, '');
          }
          a && a.length && ((a = b(a)), (a = a.replace(this._.metaRegExp, '')), (a = a.replace(this._.fragmentRegExp, '')));
          return a;
        },
      };
      CKEDITOR.plugins.clipboard.fallbackDataTransfer = function (a) {
        this._dataTransfer = a;
        this._customDataFallbackType = 'text/html';
      };
      CKEDITOR.plugins.clipboard.fallbackDataTransfer._isCustomMimeTypeSupported = null;
      CKEDITOR.plugins.clipboard.fallbackDataTransfer._customTypes = [];
      CKEDITOR.plugins.clipboard.fallbackDataTransfer.prototype = {
        isRequired: function () {
          var a = CKEDITOR.plugins.clipboard.fallbackDataTransfer,
            b = this._dataTransfer.$;
          if (null === a._isCustomMimeTypeSupported)
            if (b) {
              a._isCustomMimeTypeSupported = !1;
              if (CKEDITOR.env.edge && 17 <= CKEDITOR.env.version) return !0;
              try {
                b.setData('cke/mimetypetest', 'cke test value'),
                  (a._isCustomMimeTypeSupported = 'cke test value' === b.getData('cke/mimetypetest')),
                  b.clearData('cke/mimetypetest');
              } catch (d) {}
            } else return !1;
          return !a._isCustomMimeTypeSupported;
        },
        getData: function (a, b) {
          var d = this._getData(this._customDataFallbackType, !0);
          if (b) return d;
          var d = this._extractDataComment(d),
            c = null,
            c = a === this._customDataFallbackType ? d.content : d.data && d.data[a] ? d.data[a] : this._getData(a, !0);
          return null !== c ? c : '';
        },
        setData: function (a, b) {
          var d = a === this._customDataFallbackType;
          d && (b = this._applyDataComment(b, this._getFallbackTypeData()));
          var c = b,
            g = this._dataTransfer.$;
          try {
            g.setData(a, c), d && (this._dataTransfer._.nativeHtmlCache = c);
          } catch (f) {
            if (this._isUnsupportedMimeTypeError(f)) {
              d = CKEDITOR.plugins.clipboard.fallbackDataTransfer;
              -1 === CKEDITOR.tools.indexOf(d._customTypes, a) && d._customTypes.push(a);
              var d = this._getFallbackTypeContent(),
                k = this._getFallbackTypeData();
              k[a] = c;
              try {
                (c = this._applyDataComment(d, k)), g.setData(this._customDataFallbackType, c), (this._dataTransfer._.nativeHtmlCache = c);
              } catch (h) {
                c = '';
              }
            }
          }
          return c;
        },
        _getData: function (a, b) {
          var d = this._dataTransfer._.data;
          if (!b && d[a]) return d[a];
          try {
            return this._dataTransfer.$.getData(a);
          } catch (c) {
            return null;
          }
        },
        _getFallbackTypeContent: function () {
          var a = this._dataTransfer._.data[this._customDataFallbackType];
          a || (a = this._extractDataComment(this._getData(this._customDataFallbackType, !0)).content);
          return a;
        },
        _getFallbackTypeData: function () {
          var a = CKEDITOR.plugins.clipboard.fallbackDataTransfer._customTypes,
            b = this._extractDataComment(this._getData(this._customDataFallbackType, !0)).data || {},
            d = this._dataTransfer._.data;
          CKEDITOR.tools.array.forEach(
            a,
            function (a) {
              void 0 !== d[a] ? (b[a] = d[a]) : void 0 !== b[a] && (b[a] = b[a]);
            },
            this,
          );
          return b;
        },
        _isUnsupportedMimeTypeError: function (a) {
          return a.message && -1 !== a.message.search(/element not found/gi);
        },
        _extractDataComment: function (a) {
          var b = { data: null, content: a || '' };
          if (a && 16 < a.length) {
            var d;
            (d = /\x3c!--cke-data:(.*?)--\x3e/g.exec(a)) &&
              d[1] &&
              ((b.data = JSON.parse(decodeURIComponent(d[1]))), (b.content = a.replace(d[0], '')));
          }
          return b;
        },
        _applyDataComment: function (a, b) {
          var d = '';
          b && CKEDITOR.tools.object.keys(b).length && (d = '\x3c!--cke-data:' + encodeURIComponent(JSON.stringify(b)) + '--\x3e');
          return d + (a && a.length ? a : '');
        },
      };
    })();
    CKEDITOR.config.clipboard_notificationDuration = 1e4;
    CKEDITOR.config.clipboard_handleImages = !0;
    CKEDITOR.plugins.add('panelbutton', {
      requires: 'button',
      onLoad: function () {
        function a(a) {
          var f = this._;
          f.state != CKEDITOR.TRISTATE_DISABLED &&
            (this.createPanel(a), f.on ? f.panel.hide() : f.panel.showBlock(this._.id, this.document.getById(this._.id), 4));
        }
        CKEDITOR.ui.panelButton = CKEDITOR.tools.createClass({
          base: CKEDITOR.ui.button,
          $: function (h) {
            var f = h.panel || {};
            delete h.panel;
            this.base(h);
            this.document = (f.parent && f.parent.getDocument()) || CKEDITOR.document;
            f.block = { attributes: f.attributes };
            f.toolbarRelated = !0;
            this.hasArrow = 'listbox';
            this.click = a;
            this._ = { panelDefinition: f };
          },
          statics: {
            handler: {
              create: function (a) {
                return new CKEDITOR.ui.panelButton(a);
              },
            },
          },
          proto: {
            createPanel: function (a) {
              var f = this._;
              if (!f.panel) {
                var b = this._.panelDefinition,
                  c = this._.panelDefinition.block,
                  l = b.parent || CKEDITOR.document.getBody(),
                  k = CKEDITOR.document.getById(this._.id),
                  m = (this._.panel = new CKEDITOR.ui.floatPanel(a, l, b)),
                  b = m.addBlock(f.id, c),
                  g = this,
                  d = a.getCommand(this.command);
                m.onShow = function () {
                  g.className && this.element.addClass(g.className + '_panel');
                  g.setState(CKEDITOR.TRISTATE_ON);
                  k.setAttribute('aria-expanded', 'true');
                  f.on = 1;
                  g.editorFocus && a.focus();
                  if (g.onOpen) g.onOpen();
                };
                m.onHide = function (b) {
                  g.className && this.element.getFirst().removeClass(g.className + '_panel');
                  !g.modes && d
                    ? g.setStateFromCommand(d)
                    : g.setState(g.modes && g.modes[a.mode] ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
                  f.on = 0;
                  k.setAttribute('aria-expanded', 'false');
                  if (!b && g.onClose) g.onClose();
                };
                m.onEscape = function () {
                  m.hide(1);
                  g.document.getById(f.id).focus();
                };
                if (this.onBlock) this.onBlock(m, b);
                b.onHide = function () {
                  f.on = 0;
                  !g.modes && g.command ? g.setStateFromCommand(d) : g.setState(CKEDITOR.TRISTATE_OFF);
                };
              }
            },
            setStateFromCommand: function (a) {
              this.setState(a.state);
            },
          },
        });
      },
      beforeInit: function (a) {
        a.ui.addHandler(CKEDITOR.UI_PANELBUTTON, CKEDITOR.ui.panelButton.handler);
      },
    });
    CKEDITOR.UI_PANELBUTTON = 'panelbutton';
    (function () {
      CKEDITOR.plugins.add('panel', {
        beforeInit: function (a) {
          a.ui.addHandler(CKEDITOR.UI_PANEL, CKEDITOR.ui.panel.handler);
        },
      });
      CKEDITOR.UI_PANEL = 'panel';
      CKEDITOR.ui.panel = function (a, c) {
        c && CKEDITOR.tools.extend(this, c);
        CKEDITOR.tools.extend(this, { className: '', css: [] });
        this.id = CKEDITOR.tools.getNextId();
        this.document = a;
        this.isFramed = this.forceIFrame || this.css.length;
        this._ = { blocks: {} };
      };
      CKEDITOR.ui.panel.handler = {
        create: function (a) {
          return new CKEDITOR.ui.panel(a);
        },
      };
      var a = CKEDITOR.addTemplate(
          'panel',
          '\x3cdiv lang\x3d"{langCode}" id\x3d"{id}" dir\x3d{dir} class\x3d"cke cke_reset_all {editorId} cke_panel cke_panel {cls} cke_{dir}" style\x3d"z-index:{z-index}" role\x3d"presentation"\x3e{frame}\x3c/div\x3e',
        ),
        h = CKEDITOR.addTemplate(
          'panel-frame',
          '\x3ciframe id\x3d"{id}" class\x3d"cke_panel_frame" role\x3d"presentation" frameborder\x3d"0" src\x3d"{src}"\x3e\x3c/iframe\x3e',
        ),
        f = CKEDITOR.addTemplate(
          'panel-frame-inner',
          '\x3c!DOCTYPE html\x3e\x3chtml class\x3d"cke_panel_container {env}" dir\x3d"{dir}" lang\x3d"{langCode}"\x3e\x3chead\x3e{css}\x3c/head\x3e\x3cbody class\x3d"cke_{dir}" style\x3d"margin:0;padding:0" onload\x3d"{onload}"\x3e\x3c/body\x3e\x3c/html\x3e',
        );
      CKEDITOR.ui.panel.prototype = {
        render: function (b, c) {
          var l = {
            editorId: b.id,
            id: this.id,
            langCode: b.langCode,
            dir: b.lang.dir,
            cls: this.className,
            frame: '',
            env: CKEDITOR.env.cssClass,
            'z-index': b.config.baseFloatZIndex + 1,
          };
          this.getHolderElement = function () {
            var a = this._.holder;
            if (!a) {
              if (this.isFramed) {
                var a = this.document.getById(this.id + '_frame'),
                  b = a.getParent(),
                  a = a.getFrameDocument();
                CKEDITOR.env.iOS && b.setStyles({ overflow: 'scroll', '-webkit-overflow-scrolling': 'touch' });
                b = CKEDITOR.tools.addFunction(
                  CKEDITOR.tools.bind(function () {
                    this.isLoaded = !0;
                    if (this.onLoad) this.onLoad();
                  }, this),
                );
                a.write(
                  f.output(
                    CKEDITOR.tools.extend(
                      { css: CKEDITOR.tools.buildStyleHtml(this.css), onload: 'window.parent.CKEDITOR.tools.callFunction(' + b + ');' },
                      l,
                    ),
                  ),
                );
                a.getWindow().$.CKEDITOR = CKEDITOR;
                a.on(
                  'keydown',
                  function (a) {
                    var b = a.data.getKeystroke(),
                      c = this.document.getById(this.id).getAttribute('dir');
                    if ('input' !== a.data.getTarget().getName() || (37 !== b && 39 !== b))
                      this._.onKeyDown && !1 === this._.onKeyDown(b)
                        ? ('input' === a.data.getTarget().getName() && 32 === b) || a.data.preventDefault()
                        : (27 == b || b == ('rtl' == c ? 39 : 37)) && this.onEscape && !1 === this.onEscape(b) && a.data.preventDefault();
                  },
                  this,
                );
                a = a.getBody();
                a.unselectable();
                CKEDITOR.env.air && CKEDITOR.tools.callFunction(b);
              } else a = this.document.getById(this.id);
              this._.holder = a;
            }
            return a;
          };
          if (this.isFramed) {
            var k = CKEDITOR.env.air
              ? 'javascript:void(0)'
              : CKEDITOR.env.ie && !CKEDITOR.env.edge
                ? 'javascript:void(function(){' +
                  encodeURIComponent('document.open();(' + CKEDITOR.tools.fixDomain + ')();document.close();') +
                  '}())'
                : '';
            l.frame = h.output({ id: this.id + '_frame', src: k });
          }
          k = a.output(l);
          c && c.push(k);
          return k;
        },
        addBlock: function (a, c) {
          c = this._.blocks[a] = c instanceof CKEDITOR.ui.panel.block ? c : new CKEDITOR.ui.panel.block(this.getHolderElement(), c);
          this._.currentBlock || this.showBlock(a);
          return c;
        },
        getBlock: function (a) {
          return this._.blocks[a];
        },
        showBlock: function (a) {
          a = this._.blocks[a];
          var c = this._.currentBlock,
            f = !this.forceIFrame || CKEDITOR.env.ie ? this._.holder : this.document.getById(this.id + '_frame');
          c && c.hide();
          this._.currentBlock = a;
          CKEDITOR.fire('ariaWidget', f);
          a._.focusIndex = -1;
          this._.onKeyDown = a.onKeyDown && CKEDITOR.tools.bind(a.onKeyDown, a);
          a.show();
          return a;
        },
        destroy: function () {
          this.element && this.element.remove();
        },
      };
      CKEDITOR.ui.panel.block = CKEDITOR.tools.createClass({
        $: function (a, c) {
          this.element = a.append(
            a.getDocument().createElement('div', { attributes: { tabindex: -1, class: 'cke_panel_block' }, styles: { display: 'none' } }),
          );
          c && CKEDITOR.tools.extend(this, c);
          this.element.setAttributes({
            role: this.attributes.role || 'presentation',
            'aria-label': this.attributes['aria-label'],
            title: this.attributes.title || this.attributes['aria-label'],
          });
          this.keys = {};
          this._.focusIndex = -1;
          this.element.disableContextMenu();
        },
        _: {
          markItem: function (a) {
            -1 != a &&
              ((a = this._.getItems().getItem((this._.focusIndex = a))),
              CKEDITOR.env.webkit && a.getDocument().getWindow().focus(),
              a.focus(),
              this.onMark && this.onMark(a));
          },
          markFirstDisplayed: function (a) {
            for (
              var c = function (a) {
                  return a.type == CKEDITOR.NODE_ELEMENT && 'none' == a.getStyle('display');
                },
                f = this._.getItems(),
                k,
                h,
                g = f.count() - 1;
              0 <= g;
              g--
            )
              if (
                ((k = f.getItem(g)), k.getAscendant(c) || ((h = k), (this._.focusIndex = g)), 'true' == k.getAttribute('aria-selected'))
              ) {
                h = k;
                this._.focusIndex = g;
                break;
              }
            h && (a && a(), CKEDITOR.env.webkit && h.getDocument().getWindow().focus(), h.focus(), this.onMark && this.onMark(h));
          },
          getItems: function () {
            return this.element.find('a,input');
          },
        },
        proto: {
          show: function () {
            this.element.setStyle('display', '');
          },
          hide: function () {
            (this.onHide && !0 === this.onHide.call(this)) || this.element.setStyle('display', 'none');
          },
          onKeyDown: function (a, c) {
            var f = this.keys[a];
            switch (f) {
              case 'next':
                for (var k = this._.focusIndex, f = this._.getItems(), h; (h = f.getItem(++k)); )
                  if (h.getAttribute('_cke_focus') && h.$.offsetWidth) {
                    this._.focusIndex = k;
                    h.focus(!0);
                    break;
                  }
                return h || c ? !1 : ((this._.focusIndex = -1), this.onKeyDown(a, 1));
              case 'prev':
                k = this._.focusIndex;
                for (f = this._.getItems(); 0 < k && (h = f.getItem(--k)); ) {
                  if (h.getAttribute('_cke_focus') && h.$.offsetWidth) {
                    this._.focusIndex = k;
                    h.focus(!0);
                    break;
                  }
                  h = null;
                }
                return h || c ? !1 : ((this._.focusIndex = f.count()), this.onKeyDown(a, 1));
              case 'click':
              case 'mouseup':
                return (
                  (k = this._.focusIndex),
                  (h = 0 <= k && this._.getItems().getItem(k)) &&
                    h.fireEventHandler(f, { button: CKEDITOR.tools.normalizeMouseButton(CKEDITOR.MOUSE_BUTTON_LEFT, !0) }),
                  !1
                );
            }
            return !0;
          },
        },
      });
    })();
    CKEDITOR.plugins.add('floatpanel', { requires: 'panel' });
    (function () {
      function a(a, b, c, l, k) {
        k = CKEDITOR.tools.genKey(b.getUniqueId(), c.getUniqueId(), a.lang.dir, a.uiColor || '', l.css || '', k || '');
        var m = h[k];
        m ||
          ((m = h[k] = new CKEDITOR.ui.panel(b, l)),
          (m.element = c.append(CKEDITOR.dom.element.createFromHtml(m.render(a), b))),
          m.element.setStyles({ display: 'none', position: 'absolute' }));
        return m;
      }
      var h = {};
      CKEDITOR.ui.floatPanel = CKEDITOR.tools.createClass({
        $: function (f, b, c, h) {
          function k() {
            e.hide();
          }
          c.forceIFrame = 1;
          c.toolbarRelated && f.elementMode == CKEDITOR.ELEMENT_MODE_INLINE && (b = CKEDITOR.document.getById('cke_' + f.name));
          var m = b.getDocument();
          h = a(f, m, b, c, h || 0);
          var g = h.element,
            d = g.getFirst(),
            e = this;
          g.disableContextMenu();
          this.element = g;
          this._ = {
            editor: f,
            panel: h,
            parentElement: b,
            definition: c,
            document: m,
            iframe: d,
            children: [],
            dir: f.lang.dir,
            showBlockParams: null,
            markFirst: void 0 !== c.markFirst ? c.markFirst : !0,
          };
          f.on('mode', k);
          f.on('resize', k);
          m.getWindow().on(
            'resize',
            function () {
              this.reposition();
            },
            this,
          );
        },
        proto: {
          addBlock: function (a, b) {
            return this._.panel.addBlock(a, b);
          },
          addListBlock: function (a, b) {
            return this._.panel.addListBlock(a, b);
          },
          getBlock: function (a) {
            return this._.panel.getBlock(a);
          },
          showBlock: function (a, b, c, h, k, m) {
            var g = this._.panel,
              d = g.showBlock(a);
            this._.showBlockParams = [].slice.call(arguments);
            this.allowBlur(!1);
            var e = this._.editor.editable();
            this._.returnFocus = e.hasFocus ? e : new CKEDITOR.dom.element(CKEDITOR.document.$.activeElement);
            this._.hideTimeout = 0;
            var n = this.element,
              e = this._.iframe,
              e = CKEDITOR.env.ie && !CKEDITOR.env.edge ? e : new CKEDITOR.dom.window(e.$.contentWindow),
              r = n.getDocument(),
              x = this._.parentElement.getPositionedAncestor(),
              u = b.getDocumentPosition(r),
              r = x ? x.getDocumentPosition(r) : { x: 0, y: 0 },
              p = 'rtl' == this._.dir,
              t = u.x + (h || 0) - r.x,
              A = u.y + (k || 0) - r.y;
            !p || (1 != c && 4 != c) ? p || (2 != c && 3 != c) || (t += b.$.offsetWidth - 1) : (t += b.$.offsetWidth);
            if (3 == c || 4 == c) A += b.$.offsetHeight - 1;
            this._.panel._.offsetParentId = b.getId();
            n.setStyles({ top: A + 'px', left: 0, display: '' });
            n.setOpacity(0);
            n.getFirst().removeStyle('width');
            this._.editor.focusManager.add(e);
            this._.blurSet ||
              ((CKEDITOR.event.useCapture = !0),
              e.on(
                'blur',
                function (a) {
                  function b() {
                    delete this._.returnFocus;
                    this.hide();
                  }
                  this.allowBlur() &&
                    a.data.getPhase() == CKEDITOR.EVENT_PHASE_AT_TARGET &&
                    this.visible &&
                    !this._.activeChild &&
                    (CKEDITOR.env.iOS ? this._.hideTimeout || (this._.hideTimeout = CKEDITOR.tools.setTimeout(b, 0, this)) : b.call(this));
                },
                this,
              ),
              e.on(
                'focus',
                function () {
                  this._.focused = !0;
                  this.hideChild();
                  this.allowBlur(!0);
                },
                this,
              ),
              CKEDITOR.env.iOS &&
                (e.on(
                  'touchstart',
                  function () {
                    clearTimeout(this._.hideTimeout);
                  },
                  this,
                ),
                e.on(
                  'touchend',
                  function () {
                    this._.hideTimeout = 0;
                    this.focus();
                  },
                  this,
                )),
              (CKEDITOR.event.useCapture = !1),
              (this._.blurSet = 1));
            g.onEscape = CKEDITOR.tools.bind(function (a) {
              if (this.onEscape && !1 === this.onEscape(a)) return !1;
            }, this);
            CKEDITOR.tools.setTimeout(
              function () {
                var a = CKEDITOR.tools.bind(function () {
                  var a = n;
                  a.removeStyle('width');
                  if (d.autoSize) {
                    var b = d.element.getDocument(),
                      b = (CKEDITOR.env.webkit || CKEDITOR.env.edge ? d.element : b.getBody()).$.scrollWidth;
                    CKEDITOR.env.ie && CKEDITOR.env.quirks && 0 < b && (b += (a.$.offsetWidth || 0) - (a.$.clientWidth || 0) + 3);
                    a.setStyle('width', b + 10 + 'px');
                    b = d.element.$.scrollHeight;
                    CKEDITOR.env.ie && CKEDITOR.env.quirks && 0 < b && (b += (a.$.offsetHeight || 0) - (a.$.clientHeight || 0) + 3);
                    a.setStyle('height', b + 'px');
                    g._.currentBlock.element.setStyle('display', 'none').removeStyle('display');
                  } else a.removeStyle('height');
                  p && (t -= n.$.offsetWidth);
                  n.setStyle('left', t + 'px');
                  var b = g.element.getWindow(),
                    a = n.$.getBoundingClientRect(),
                    b = b.getViewPaneSize(),
                    e = a.width || a.right - a.left,
                    c = a.height || a.bottom - a.top,
                    f = p ? a.right : b.width - a.left,
                    k = p ? b.width - a.right : a.left;
                  p
                    ? f < e && (t = k > e ? t + e : b.width > e ? t - a.left : t - a.right + b.width)
                    : f < e && (t = k > e ? t - e : b.width > e ? t - a.right + b.width : t - a.left);
                  e = a.top;
                  b.height - a.top < c && (A = e > c ? A - c : b.height > c ? A - a.bottom + b.height : A - a.top);
                  CKEDITOR.env.ie &&
                    !CKEDITOR.env.edge &&
                    ((b = a = n.$.offsetParent && new CKEDITOR.dom.element(n.$.offsetParent)) &&
                      'html' == b.getName() &&
                      (b = b.getDocument().getBody()),
                    b &&
                      'rtl' == b.getComputedStyle('direction') &&
                      (t = CKEDITOR.env.ie8Compat
                        ? t - 2 * n.getDocument().getDocumentElement().$.scrollLeft
                        : t - (a.$.scrollWidth - a.$.clientWidth)));
                  var a = n.getFirst(),
                    h;
                  (h = a.getCustomData('activePanel')) && h.onHide && h.onHide.call(this, 1);
                  a.setCustomData('activePanel', this);
                  n.setStyles({ top: A + 'px', left: t + 'px' });
                  n.setOpacity(1);
                  m && m();
                }, this);
                g.isLoaded ? a() : (g.onLoad = a);
                CKEDITOR.tools.setTimeout(
                  function () {
                    var a = CKEDITOR.env.webkit && CKEDITOR.document.getWindow().getScrollPosition().y;
                    this.focus();
                    d.element.focus();
                    CKEDITOR.env.webkit && (CKEDITOR.document.getBody().$.scrollTop = a);
                    this.allowBlur(!0);
                    this._.markFirst &&
                      (CKEDITOR.env.ie
                        ? CKEDITOR.tools.setTimeout(function () {
                            d.markFirstDisplayed ? d.markFirstDisplayed() : d._.markFirstDisplayed();
                          }, 0)
                        : d.markFirstDisplayed
                          ? d.markFirstDisplayed()
                          : d._.markFirstDisplayed());
                    this._.editor.fire('panelShow', this);
                  },
                  0,
                  this,
                );
              },
              CKEDITOR.env.air ? 200 : 0,
              this,
            );
            this.visible = 1;
            this.onShow && this.onShow.call(this);
          },
          reposition: function () {
            var a = this._.showBlockParams;
            this.visible && this._.showBlockParams && (this.hide(), this.showBlock.apply(this, a));
          },
          focus: function () {
            if (CKEDITOR.env.webkit) {
              var a = CKEDITOR.document.getActive();
              a && !a.equals(this._.iframe) && a.$.blur();
            }
            (this._.lastFocused || this._.iframe.getFrameDocument().getWindow()).focus();
          },
          blur: function () {
            var a = this._.iframe.getFrameDocument().getActive();
            a && a.is('a') && (this._.lastFocused = a);
          },
          hide: function (a) {
            if (this.visible && (!this.onHide || !0 !== this.onHide.call(this))) {
              this.hideChild();
              CKEDITOR.env.gecko && this._.iframe.getFrameDocument().$.activeElement.blur();
              this.element.setStyle('display', 'none');
              this.visible = 0;
              this.element.getFirst().removeCustomData('activePanel');
              if ((a = a && this._.returnFocus)) CKEDITOR.env.webkit && a.type && a.getWindow().$.focus(), a.focus();
              delete this._.lastFocused;
              this._.showBlockParams = null;
              this._.editor.fire('panelHide', this);
            }
          },
          allowBlur: function (a) {
            var b = this._.panel;
            void 0 !== a && (b.allowBlur = a);
            return b.allowBlur;
          },
          showAsChild: function (a, b, c, h, k, m) {
            if (this._.activeChild != a || a._.panel._.offsetParentId != c.getId())
              this.hideChild(),
                (a.onHide = CKEDITOR.tools.bind(function () {
                  CKEDITOR.tools.setTimeout(
                    function () {
                      this._.focused || this.hide();
                    },
                    0,
                    this,
                  );
                }, this)),
                (this._.activeChild = a),
                (this._.focused = !1),
                a.showBlock(b, c, h, k, m),
                this.blur(),
                (CKEDITOR.env.ie7Compat || CKEDITOR.env.ie6Compat) &&
                  setTimeout(function () {
                    a.element.getChild(0).$.style.cssText += '';
                  }, 100);
          },
          hideChild: function (a) {
            var b = this._.activeChild;
            b && (delete b.onHide, delete this._.activeChild, b.hide(), a && this.focus());
          },
        },
      });
      CKEDITOR.on('instanceDestroyed', function () {
        var a = CKEDITOR.tools.isEmpty(CKEDITOR.instances),
          b;
        for (b in h) {
          var c = h[b];
          a ? c.destroy() : c.element.hide();
        }
        a && (h = {});
      });
    })();
    (function () {
      var a, h, f;
      CKEDITOR.plugins.add('colorbutton', {
        requires: 'panelbutton,floatpanel',
        init: function (b) {
          function c(e) {
            function c() {
              var a = b.config['colorButton_' + t + 'Style'];
              a.childRule =
                'back' == t
                  ? function (a) {
                      return k(a);
                    }
                  : function (a) {
                      return !(a.is('a') || a.getElementsByTag('a').count()) || k(a);
                    };
              return a;
            }
            function n(a, d, e) {
              var g = {};
              a && (g.color = a);
              d && (g.colorName = d);
              d = !CKEDITOR.tools.isEmpty(g) && new CKEDITOR.style(c(), g);
              b.execCommand(B, { newStyle: d });
              if (a && e)
                for (e.addColor(a.substr(1).toUpperCase()), a = G.element.find('[role\x3doption]').toArray(), e = 0; e < a.length; e++)
                  a[e].setAttributes({ 'aria-posinset': e + 1, 'aria-setsize': a.length });
            }
            var p = e.name,
              t = e.type,
              A = e.title,
              q = e.order,
              B = e.commandName;
            e = e.contentTransformations || {};
            var z = new CKEDITOR.style(g['colorButton_' + t + 'Style']),
              y = CKEDITOR.tools.getNextId() + '_colorBox',
              v = { type: t },
              C = new CKEDITOR.style(g['colorButton_' + t + 'Style'], { color: 'inherit' }),
              F = (function () {
                return CKEDITOR.tools.addFunction(function (a, d, e) {
                  b.focus();
                  b.fire('saveSnapshot');
                  '?' == a
                    ? b.getColorFromDialog(
                        function (a) {
                          a && n(a, d, D);
                        },
                        null,
                        v,
                      )
                    : n(a && '#' + a, d, D);
                  e &&
                    (e.setAttribute('cke_colorlast', !0),
                    b.once('selectionChange', function () {
                      e.removeAttribute('cke_colorlast');
                    }));
                });
              })(),
              D = f.getRowLimit(b) ? new f(b, 'back' == t ? 'background-color' : 'color', F) : void 0,
              G;
            b.addCommand(B, {
              contextSensitive: !0,
              exec: function (a, b) {
                if (!a.readOnly) {
                  var d = b.newStyle;
                  a.removeStyle(C);
                  a.focus();
                  d && a.applyStyle(d);
                  a.fire('saveSnapshot');
                }
              },
              refresh: function (a, b) {
                C.checkApplicable(b, a, a.activeFilter)
                  ? C.checkActive(b, a)
                    ? this.setState(CKEDITOR.TRISTATE_ON)
                    : this.setState(CKEDITOR.TRISTATE_OFF)
                  : this.setState(CKEDITOR.TRISTATE_DISABLED);
              },
            });
            b.ui.add(p, CKEDITOR.UI_PANELBUTTON, {
              label: A,
              title: A,
              command: B,
              editorFocus: 0,
              toolbar: 'colors,' + q,
              allowedContent: z,
              requiredContent: z,
              contentTransformations: e,
              panel: { css: CKEDITOR.skin.getPath('editor'), attributes: { role: 'listbox', 'aria-label': d.panelTitle } },
              select: function (b) {
                var d = g.colorButton_colors.split(',');
                b = CKEDITOR.tools.array.find(d, b);
                b = a.normalizeColor(b);
                m(G, b);
                G._.markFirstDisplayed();
              },
              onBlock: function (a, d) {
                G = d;
                d.autoSize = !0;
                d.element.addClass('cke_colorblock');
                d.element.setHtml(h(y, F, D ? D.getLength() : 0));
                d.element.getDocument().getBody().setStyle('overflow', 'hidden');
                d.element.getAscendant({ html: 1 }).setStyle('overflow', 'hidden');
                CKEDITOR.ui.fire('ready', this);
                var e = d.keys,
                  c = 'rtl' == b.lang.dir;
                e[c ? 37 : 39] = 'next';
                e[40] = 'next';
                e[9] = 'next';
                e[c ? 39 : 37] = 'prev';
                e[38] = 'prev';
                e[CKEDITOR.SHIFT + 9] = 'prev';
                e[32] = 'click';
                D && D.setContainer(d.element.findOne('.cke_colorhistory'));
              },
              onOpen: function () {
                var d = b.getSelection(),
                  e = d && d.getStartElement(),
                  c = b.elementPath(e),
                  f = 'back' == t ? 'background-color' : 'color';
                if (c) {
                  e = c.block || c.blockLimit || b.document.getBody();
                  do c = (e && e.getComputedStyle(f)) || 'transparent';
                  while ('back' == t && 'transparent' == c && e && (e = e.getParent()));
                  (c && 'transparent' != c) || (c = '#ffffff');
                  g.colorButton_enableAutomatic && G.element.findOne('#' + y).setStyle('background-color', c);
                  if ((e = d && d.getRanges()[0])) {
                    for (var d = new CKEDITOR.dom.walker(e), k = e.collapsed ? e.startContainer : d.next(), e = ''; k; ) {
                      k.type !== CKEDITOR.NODE_ELEMENT && (k = k.getParent());
                      k = a.normalizeColor(k.getComputedStyle(f));
                      e = e || k;
                      if (e !== k) {
                        e = '';
                        break;
                      }
                      k = d.next();
                    }
                    'transparent' == e && (e = '');
                    'fore' == t && (v.automaticTextColor = '#' + a.normalizeColor(c));
                    v.selectionColor = e ? '#' + e : '';
                    m(G, e);
                  }
                  return c;
                }
              },
            });
          }
          function h(e, c, k) {
            var m = [],
              l = g.colorButton_colors.split(','),
              n = b.plugins.colordialog && g.colorButton_enableMore;
            k = l.length + k + (n ? 1 : 0);
            var q = 1;
            g.colorButton_enableAutomatic &&
              ((k += 1),
              (q += 1),
              m.push(
                '\x3ca class\x3d"cke_colorauto" _cke_focus\x3d1 hidefocus\x3dtrue',
                ' title\x3d"',
                d.auto,
                '"',
                ' draggable\x3d"false"',
                ' ondragstart\x3d"return false;"',
                ' onclick\x3d"CKEDITOR.tools.callFunction(',
                c,
                ',null);return false;"',
                ' href\x3d"javascript:void(\'',
                d.auto,
                '\')"',
                ' role\x3d"option" aria-posinset\x3d"1" aria-setsize\x3d"',
                k,
                '"\x3e',
                '\x3ctable role\x3d"presentation" cellspacing\x3d0 cellpadding\x3d0 width\x3d"100%"\x3e',
                '\x3ctr\x3e',
                '\x3ctd colspan\x3d"',
                b.config.colorButton_colorsPerRow,
                '" align\x3d"center"\x3e',
                '\x3cspan class\x3d"cke_colorbox" id\x3d"',
                e,
                '"\x3e\x3c/span\x3e',
                d.auto,
                '\x3c/td\x3e',
                '\x3c/tr\x3e',
                '\x3c/table\x3e',
                '\x3c/a\x3e',
              ));
            m.push('\x3ctable role\x3d"presentation" cellspacing\x3d0 cellpadding\x3d0 width\x3d"100%"\x3e\x3ctbody\x3e');
            for (e = 0; e < l.length; e++) {
              0 === e % b.config.colorButton_colorsPerRow && m.push('\x3c/tr\x3e\x3ctr\x3e');
              var B = l[e].split('/'),
                z = B[0],
                B = new a(b, { color: B[1] || z, label: B[1] ? z : void 0 }, c);
              B.setPositionIndex(q + e, k);
              m.push(B.getHtml());
            }
            f.getRowLimit(b) && f.renderContainer(m, b);
            n &&
              m.push(
                '\x3c/tr\x3e',
                '\x3ctr\x3e',
                '\x3ctd colspan\x3d"',
                b.config.colorButton_colorsPerRow,
                '" align\x3d"center"\x3e',
                '\x3ca class\x3d"cke_colormore" _cke_focus\x3d1 hidefocus\x3dtrue',
                ' title\x3d"',
                d.more,
                '"',
                ' draggable\x3d"false"',
                ' ondragstart\x3d"return false;"',
                ' onclick\x3d"CKEDITOR.tools.callFunction(',
                c,
                ",'?');return false;\"",
                ' href\x3d"javascript:void(\'',
                d.more,
                '\')"',
                ' role\x3d"option" aria-posinset\x3d"',
                k,
                '" aria-setsize\x3d"',
                k,
                '"\x3e',
                d.more,
                '\x3c/a\x3e',
                '\x3c/td\x3e',
              );
            m.push('\x3c/tr\x3e\x3c/tbody\x3e\x3c/table\x3e');
            return m.join('');
          }
          function k(a) {
            return 'false' == a.getAttribute('contentEditable') || a.getAttribute('data-nostyle');
          }
          function m(b, d) {
            var e = b._.getItems(),
              c = b.element.findOne('[aria-selected]'),
              g = b.element.findOne('[cke_colorlast]');
            c && c.removeAttribute('aria-selected');
            if (g) g.setAttribute('aria-selected', !0);
            else
              for (c = 0; c < e.count(); c++)
                if (((g = e.getItem(c)), d && d == a.normalizeColor(g.getAttribute('data-value')))) {
                  g.setAttribute('aria-selected', !0);
                  break;
                }
          }
          var g = b.config,
            d = b.lang.colorbutton;
          if (!CKEDITOR.env.hc) {
            c({
              name: 'TextColor',
              type: 'fore',
              commandName: 'textColor',
              title: d.textColorTitle,
              order: 10,
              contentTransformations: [
                [
                  {
                    element: 'font',
                    check: 'span{color}',
                    left: function (a) {
                      return !!a.attributes.color;
                    },
                    right: function (a) {
                      a.name = 'span';
                      a.attributes.color && (a.styles.color = a.attributes.color);
                      delete a.attributes.color;
                    },
                  },
                ],
              ],
            });
            var e,
              n = b.config.colorButton_normalizeBackground;
            if (void 0 === n || n)
              e = [
                [
                  {
                    element: 'span',
                    left: function (a) {
                      var b = CKEDITOR.tools;
                      if ('span' != a.name || !a.styles || !a.styles.background) return !1;
                      a = b.style.parse.background(a.styles.background);
                      return a.color && 1 === b.object.keys(a).length;
                    },
                    right: function (a) {
                      var d = new CKEDITOR.style(b.config.colorButton_backStyle, { color: a.styles.background }).getDefinition();
                      a.name = d.element;
                      a.styles = d.styles;
                      a.attributes = d.attributes || {};
                      return a;
                    },
                  },
                ],
              ];
            c({ name: 'BGColor', type: 'back', commandName: 'bgColor', title: d.bgColorTitle, order: 20, contentTransformations: e });
          }
        },
      });
      a = CKEDITOR.tools.createClass({
        $: function (b, c, f) {
          this.$ = new CKEDITOR.dom.element('td');
          this.color = CKEDITOR.tools._isValidColorFormat(c.color) ? c.color : '';
          this.clickFn = f;
          this.label = c.label || a.colorNames(b)[this.color] || this.color;
          this.setHtml();
        },
        statics: {
          colorNames: function (a) {
            return a.lang.colorbutton.colors;
          },
          normalizeColor: function (a) {
            var c = /^(rgb|hsl)a\(/g.test(a),
              f = /^rgba\((\s*0\s*,?){4}\)$/g.test(a);
            return c && !f
              ? ((a = new CKEDITOR.tools.color(a)), CKEDITOR.tools.normalizeHex(a.getHex() || '').replace(/#/g, ''))
              : CKEDITOR.tools.normalizeHex('#' + CKEDITOR.tools.convertRgbToHex(a || '')).replace(/#/g, '');
          },
        },
        proto: {
          getElement: function () {
            return this.$;
          },
          getHtml: function () {
            return this.getElement().getOuterHtml();
          },
          setHtml: function () {
            this.getElement().setHtml(
              '\x3ca class\x3d"cke_colorbox" _cke_focus\x3d1 hidefocus\x3dtrue title\x3d"' +
                this.label +
                '" draggable\x3d"false" ondragstart\x3d"return false;" onclick\x3d"CKEDITOR.tools.callFunction(' +
                this.clickFn +
                ",'" +
                this.color +
                "','" +
                this.label +
                '\', this); return false;" href\x3d"javascript:void(\'' +
                this.color +
                '\')" data-value\x3d"' +
                this.color +
                '" role\x3d"option"\x3e\x3cspan class\x3d"cke_colorbox" style\x3d"background-color:#' +
                this.color +
                '"\x3e\x3c/span\x3e\x3c/a\x3e',
            );
          },
          setPositionIndex: function (a, c) {
            this.getElement().getChild(0).setAttributes({ 'aria-posinset': a, 'aria-setsize': c });
          },
        },
      });
      h = CKEDITOR.tools.createClass({
        $: function () {
          this.$ = new CKEDITOR.dom.element('tr');
          this.$.addClass('cke_colorhistory_row');
          this.boxes = [];
        },
        proto: {
          getElement: function () {
            return this.$;
          },
          removeLastColor: function () {
            this.getElement().getLast().remove();
            return this.boxes.pop();
          },
          addNewColor: function (a) {
            this.boxes.unshift(a);
            this.getElement().append(a.getElement(), !0);
          },
          extractColorBox: function (a) {
            var c = CKEDITOR.tools.getIndex(this.boxes, function (c) {
              return c.color === a;
            });
            if (0 > c) return null;
            this.boxes[c].getElement().remove();
            return this.boxes.splice(c, 1)[0];
          },
        },
      });
      f = CKEDITOR.tools.createClass({
        $: function (a, c, f) {
          this.editor = a;
          this.cssProperty = c;
          this.clickFn = f;
          this.rows = [];
          this._.addNewRow();
          if (this.editor.config.colorButton_renderContentColors)
            this.editor.once(
              'instanceReady',
              function () {
                this.renderContentColors();
              },
              this,
            );
        },
        statics: {
          renderContainer: function (a, c) {
            a.push(
              '\x3c/tbody\x3e\x3ctbody class\x3d"cke_colorhistory" style\x3d"display:none;"\x3e',
              '\x3ctr\x3e',
              '\x3ctd colspan\x3d"',
              c.config.colorButton_colorsPerRow,
              '" align\x3d"center"\x3e',
              '\x3cspan\x3e\x3chr\x3e\x3c/span\x3e',
              '\x3c/td\x3e',
              '\x3c/tr\x3e',
              '\x3c/tbody\x3e\x3ctbody\x3e',
            );
          },
          getRowLimit: function (a) {
            return a.config.colorButton_historyRowLimit;
          },
          getCapacity: function (a) {
            return f.getRowLimit(a) * a.config.colorButton_colorsPerRow;
          },
          colorList: CKEDITOR.tools.style.parse._colors,
        },
        _: {
          countColors: function () {
            var a = CKEDITOR.tools.getStyledSpans(this.cssProperty, this.editor.editable());
            return CKEDITOR.tools.array.reduce(
              a,
              function (a, b) {
                var k = this._.getHexCode(b, this.cssProperty, f.colorList);
                a[k] = a[k] || 0;
                a[k] += 1;
                return a;
              },
              {},
              this,
            );
          },
          getHexCode: function (b, c, f) {
            var k = b.getStyle(c);
            return k in f ? f[k].substr(1) : a.normalizeColor(b.getComputedStyle(c)).toUpperCase();
          },
          sortByOccurrencesAscending: function (a, c) {
            var f = [],
              k;
            for (k in a) {
              var h = {};
              h[c] = k;
              h.frequency = a[k];
              f.push(h);
            }
            f.sort(function (a, b) {
              return b.frequency - a.frequency;
            });
            this._.trimToCapacity(f);
            return f.reverse();
          },
          trimToCapacity: function (a) {
            a.splice(f.getCapacity(this.editor));
          },
          addColors: function (a) {
            CKEDITOR.tools.array.forEach(
              a,
              function (a) {
                this.addColor(a.colorCode);
              },
              this,
            );
          },
          extractColorBox: function (a) {
            for (var c = 0; c < this.rows.length; c++) {
              var f = this.rows[c].extractColorBox(a);
              if (f) return f;
            }
            return null;
          },
          moveToBeginning: function (a) {
            this.rows[0].addNewColor(a);
          },
          createAtBeginning: function (b) {
            this._.moveToBeginning(new a(this.editor, { color: b }, this.clickFn));
          },
          addNewRow: function () {
            this.rows.push(new h());
            this.container && this.container.append(this.rows[this.rows.length - 1].getElement());
          },
          alignRows: function () {
            for (
              var a = 0;
              a < f.getRowLimit(this.editor) && !(this.rows[a].boxes.length <= this.editor.config.colorButton_colorsPerRow);
              a++
            )
              this.rows[a + 1]
                ? this._.moveLastBoxToNextRow(a)
                : a < f.getRowLimit(this.editor) - 1
                  ? (this._.addNewRow(), this._.moveLastBoxToNextRow(a))
                  : this.rows[a].removeLastColor();
          },
          moveLastBoxToNextRow: function (a) {
            this.rows[a + 1].addNewColor(this.rows[a].removeLastColor());
          },
          refreshPositions: function () {
            var a = this._.countPanelElements(),
              c = this._.calculateFirstPosition(a);
            CKEDITOR.tools.array.forEach(this.rows, function (f) {
              CKEDITOR.tools.array.forEach(f.boxes, function (f) {
                f.setPositionIndex(c, a);
                c += 1;
              });
            });
          },
          countPanelElements: function () {
            var a = this.editor.config.colorButton_colors.split(',').length + this.getLength();
            this.editor.plugins.colordialog && this.editor.config.colorButton_enableMore && (a += 1);
            this.editor.config.colorButton_enableAutomatic && (a += 1);
            return a;
          },
          calculateFirstPosition: function (a) {
            return this.editor.plugins.colordialog && this.editor.config.colorButton_enableMore
              ? a - this.getLength()
              : a - this.getLength() + 1;
          },
          attachRows: function () {
            CKEDITOR.tools.array.forEach(
              this.rows,
              function (a) {
                this.container.append(a.getElement());
              },
              this,
            );
          },
        },
        proto: {
          setContainer: function (a) {
            this.container = a;
            this._.attachRows();
            this.getLength() && this.show();
          },
          show: function () {
            this.container && this.container.show();
          },
          renderContentColors: function () {
            var a = this._.countColors();
            CKEDITOR.tools.isEmpty(a) ||
              ((a = this._.sortByOccurrencesAscending(a, 'colorCode')), this._.addColors(a), this._.refreshPositions());
          },
          addColor: function (a) {
            var c = this._.extractColorBox(a);
            this.container && !this.container.isVisible() && this.show();
            c ? this._.moveToBeginning(c) : this._.createAtBeginning(a);
            this._.alignRows();
          },
          getLength: function () {
            return CKEDITOR.tools.array.reduce(
              this.rows,
              function (a, c) {
                return a + c.boxes.length;
              },
              0,
            );
          },
        },
      });
    })();
    CKEDITOR.config.colorButton_enableMore = !0;
    CKEDITOR.config.colorButton_colors =
      '1ABC9C,2ECC71,3498DB,9B59B6,4E5F70,F1C40F,16A085,27AE60,2980B9,8E44AD,2C3E50,F39C12,E67E22,E74C3C,ECF0F1,95A5A6,DDD,FFF,D35400,C0392B,BDC3C7,7F8C8D,999,000';
    CKEDITOR.config.colorButton_foreStyle = {
      element: 'span',
      styles: { color: '#(color)' },
      overrides: [{ element: 'font', attributes: { color: null } }],
    };
    CKEDITOR.config.colorButton_backStyle = { element: 'span', styles: { 'background-color': '#(color)' } };
    CKEDITOR.config.colorButton_enableAutomatic = !0;
    CKEDITOR.config.colorButton_colorsPerRow = 6;
    CKEDITOR.config.colorButton_historyRowLimit = 1;
    CKEDITOR.config.colorButton_renderContentColors = !0;
    CKEDITOR.plugins.colordialog = {
      requires: 'dialog',
      init: function (a) {
        var h = new CKEDITOR.dialogCommand('colordialog');
        h.editorFocus = !1;
        a.addCommand('colordialog', h);
        CKEDITOR.dialog.add('colordialog', this.path + 'dialogs/colordialog.js');
        a.getColorFromDialog = function (f, b, c) {
          var h, k, m, g;
          h = function (a) {
            m(this);
            (a = 'ok' == a.name ? this.getValueOf('picker', 'selectedColor') : null) &&
              !CKEDITOR.tools._isValidColorFormat(a) &&
              (a = null);
            /^[0-9a-f]{3}([0-9a-f]{3})?$/i.test(a) && (a = '#' + a);
            f.call(b, a);
          };
          k = function (a) {
            c && (a.data = c);
          };
          m = function (a) {
            a.removeListener('ok', h);
            a.removeListener('cancel', h);
            a.removeListener('show', k);
          };
          g = function (a) {
            a.on('ok', h);
            a.on('cancel', h);
            a.on('show', k, null, null, 5);
          };
          a.execCommand('colordialog');
          if (a._.storedDialogs && a._.storedDialogs.colordialog) g(a._.storedDialogs.colordialog);
          else
            CKEDITOR.on('dialogDefinition', function (a) {
              if ('colordialog' == a.data.name) {
                var b = a.data.definition;
                a.removeListener();
                b.onLoad = CKEDITOR.tools.override(b.onLoad, function (a) {
                  return function () {
                    g(this);
                    b.onLoad = a;
                    'function' == typeof a && a.call(this);
                  };
                });
              }
            });
        };
      },
    };
    CKEDITOR.plugins.add('colordialog', CKEDITOR.plugins.colordialog);
    (function () {
      function a(a, b, c, d) {
        var e = new CKEDITOR.dom.walker(a);
        if ((a = a.startContainer.getAscendant(b, !0) || a.endContainer.getAscendant(b, !0))) if ((c(a), d)) return;
        for (; (a = e.next()); ) if ((a = a.getAscendant(b, !0))) if ((c(a), d)) break;
      }
      function h(a, c) {
        var g = { ul: 'ol', ol: 'ul' };
        return (
          -1 !==
          b(c, function (b) {
            return b.element === a || b.element === g[a];
          })
        );
      }
      function f(a) {
        this.styles = null;
        this.sticky = !1;
        this.editor = a;
        this.filter = new CKEDITOR.filter(a, a.config.copyFormatting_allowRules);
        !0 === a.config.copyFormatting_allowRules && (this.filter.disabled = !0);
        a.config.copyFormatting_disallowRules && this.filter.disallow(a.config.copyFormatting_disallowRules);
      }
      var b = CKEDITOR.tools.indexOf,
        c = CKEDITOR.tools.getMouseButton,
        l = !1;
      CKEDITOR.plugins.add('copyformatting', {
        lang: 'ar,az,bg,cs,da,de,de-ch,el,en,en-au,eo,es-mx,et,eu,fa,fr,gl,hr,hu,it,ja,ko,ku,lv,nb,nl,oc,pl,pt,pt-br,ro,ru,sk,sq,sr,sr-latn,sv,tr,uk,vi,zh,zh-cn',
        icons: 'copyformatting',
        hidpi: !0,
        init: function (a) {
          var f = CKEDITOR.plugins.copyformatting;
          f._addScreenReaderContainer();
          l || (CKEDITOR.document.appendStyleSheet(this.path + 'styles/copyformatting.css'), (l = !0));
          a.addContentsCss && a.addContentsCss(this.path + 'styles/copyformatting.css');
          a.copyFormatting = new f.state(a);
          a.addCommand('copyFormatting', f.commands.copyFormatting);
          a.addCommand('applyFormatting', f.commands.applyFormatting);
          a.ui.addButton('CopyFormatting', {
            isToggle: !0,
            label: a.lang.copyformatting.label,
            command: 'copyFormatting',
            toolbar: 'cleanup,0',
          });
          a.on('contentDom', function () {
            var b = a.getCommand('copyFormatting'),
              d = a.editable(),
              e = d.isInline() ? d : a.document,
              f = a.ui.get('CopyFormatting');
            d.attachListener(e, 'mouseup', function (d) {
              c(d) === CKEDITOR.MOUSE_BUTTON_LEFT && b.state === CKEDITOR.TRISTATE_ON && a.execCommand('applyFormatting');
            });
            d.attachListener(CKEDITOR.document, 'mouseup', function (e) {
              c(e) !== CKEDITOR.MOUSE_BUTTON_LEFT ||
                b.state !== CKEDITOR.TRISTATE_ON ||
                d.contains(e.data.getTarget()) ||
                a.execCommand('copyFormatting');
            });
            f &&
              ((e = CKEDITOR.document.getById(f._.id)),
              d.attachListener(e, 'dblclick', function () {
                a.execCommand('copyFormatting', { sticky: !0 });
              }),
              d.attachListener(e, 'mouseup', function (a) {
                a.data.stopPropagation();
              }));
          });
          a.config.copyFormatting_keystrokeCopy && a.setKeystroke(a.config.copyFormatting_keystrokeCopy, 'copyFormatting');
          a.on('key', function (b) {
            var d = a.getCommand('copyFormatting');
            b = b.data.domEvent;
            b.getKeystroke && 27 === b.getKeystroke() && d.state === CKEDITOR.TRISTATE_ON && a.execCommand('copyFormatting');
          });
          a.copyFormatting.on('extractFormatting', function (b) {
            var d = b.data.element;
            if (d.contains(a.editable()) || d.equals(a.editable())) return b.cancel();
            d = f._convertElementToStyleDef(d);
            if (!a.copyFormatting.filter.check(new CKEDITOR.style(d), !0, !0)) return b.cancel();
            b.data.styleDef = d;
          });
          a.copyFormatting.on('applyFormatting', function (c) {
            if (!c.data.preventFormatStripping) {
              var d = c.data.range,
                e = f._extractStylesFromRange(a, d),
                l = f._determineContext(d),
                r,
                x;
              if (a.copyFormatting._isContextAllowed(l))
                for (x = 0; x < e.length; x++)
                  (l = e[x]),
                    (r = d.createBookmark()),
                    -1 === b(f.preservedElements, l.element)
                      ? CKEDITOR.env.webkit && !CKEDITOR.env.chrome
                        ? e[x].removeFromRange(c.data.range, c.editor)
                        : e[x].remove(c.editor)
                      : h(l.element, c.data.styles) && f._removeStylesFromElementInRange(d, l.element),
                    d.moveToBookmark(r);
            }
          });
          a.copyFormatting.on(
            'applyFormatting',
            function (b) {
              var d = CKEDITOR.plugins.copyformatting,
                e = d._determineContext(b.data.range);
              'list' === e && a.copyFormatting._isContextAllowed('list')
                ? d._applyStylesToListContext(b.editor, b.data.range, b.data.styles)
                : 'table' === e && a.copyFormatting._isContextAllowed('table')
                  ? d._applyStylesToTableContext(b.editor, b.data.range, b.data.styles)
                  : a.copyFormatting._isContextAllowed('text') && d._applyStylesToTextContext(b.editor, b.data.range, b.data.styles);
            },
            null,
            null,
            999,
          );
        },
      });
      f.prototype._isContextAllowed = function (a) {
        var c = this.editor.config.copyFormatting_allowedContexts;
        return !0 === c || -1 !== b(c, a);
      };
      CKEDITOR.event.implementOn(f.prototype);
      CKEDITOR.plugins.copyformatting = {
        state: f,
        inlineBoundary: 'h1 h2 h3 h4 h5 h6 p div'.split(' '),
        excludedAttributes: ['id', 'style', 'href', 'data-cke-saved-href', 'dir'],
        elementsForInlineTransform: ['li'],
        excludedElementsFromInlineTransform: ['table', 'thead', 'tbody', 'ul', 'ol'],
        excludedAttributesFromInlineTransform: ['value', 'type'],
        preservedElements: 'ul ol li td th tr thead tbody table'.split(' '),
        breakOnElements: ['ul', 'ol', 'table'],
        _initialKeystrokePasteCommand: null,
        commands: {
          copyFormatting: {
            exec: function (a, b) {
              var c = CKEDITOR.plugins.copyformatting,
                d = a.copyFormatting,
                e = b ? 'keystrokeHandler' == b.from : !1,
                f = b ? b.sticky || e : !1,
                h = c._getCursorContainer(a),
                l = CKEDITOR.document.getDocumentElement();
              if (this.state === CKEDITOR.TRISTATE_ON)
                return (
                  (d.styles = null),
                  (d.sticky = !1),
                  h.removeClass('cke_copyformatting_active'),
                  l.removeClass('cke_copyformatting_disabled'),
                  l.removeClass('cke_copyformatting_tableresize_cursor'),
                  c._putScreenReaderMessage(a, 'canceled'),
                  c._detachPasteKeystrokeHandler(a),
                  this.setState(CKEDITOR.TRISTATE_OFF)
                );
              d.styles = c._extractStylesFromElement(a, a.elementPath().lastElement);
              this.setState(CKEDITOR.TRISTATE_ON);
              e ||
                (h.addClass('cke_copyformatting_active'),
                l.addClass('cke_copyformatting_tableresize_cursor'),
                a.config.copyFormatting_outerCursor && l.addClass('cke_copyformatting_disabled'));
              d.sticky = f;
              c._putScreenReaderMessage(a, 'copied');
              c._attachPasteKeystrokeHandler(a);
            },
          },
          applyFormatting: {
            editorFocus: CKEDITOR.env.ie && !CKEDITOR.env.edge ? !1 : !0,
            exec: function (a, b) {
              var c = a.getCommand('copyFormatting'),
                d = b ? 'keystrokeHandler' == b.from : !1,
                e = CKEDITOR.plugins.copyformatting,
                f = a.copyFormatting,
                h = e._getCursorContainer(a),
                l = CKEDITOR.document.getDocumentElement();
              if (d && !f.styles) return e._putScreenReaderMessage(a, 'failed'), e._detachPasteKeystrokeHandler(a), !1;
              d = e._applyFormat(a, f.styles);
              f.sticky ||
                ((f.styles = null),
                h.removeClass('cke_copyformatting_active'),
                l.removeClass('cke_copyformatting_disabled'),
                l.removeClass('cke_copyformatting_tableresize_cursor'),
                c.setState(CKEDITOR.TRISTATE_OFF),
                e._detachPasteKeystrokeHandler(a));
              e._putScreenReaderMessage(a, d ? 'applied' : 'canceled');
            },
          },
        },
        _getCursorContainer: function (a) {
          return a.elementMode === CKEDITOR.ELEMENT_MODE_INLINE ? a.editable() : a.editable().getParent();
        },
        _convertElementToStyleDef: function (a) {
          var b = CKEDITOR.tools,
            c = a.getAttributes(CKEDITOR.plugins.copyformatting.excludedAttributes),
            b = b.parseCssText(a.getAttribute('style'), !0, !0);
          return { element: a.getName(), type: CKEDITOR.STYLE_INLINE, attributes: c, styles: b };
        },
        _extractStylesFromElement: function (a, c) {
          var g = {},
            d = [];
          do
            if (
              c.type === CKEDITOR.NODE_ELEMENT &&
              !c.hasAttribute('data-cke-bookmark') &&
              ((g.element = c),
              a.copyFormatting.fire('extractFormatting', g, a) && g.styleDef && d.push(new CKEDITOR.style(g.styleDef)),
              c.getName && -1 !== b(CKEDITOR.plugins.copyformatting.breakOnElements, c.getName()))
            )
              break;
          while ((c = c.getParent()) && c.type === CKEDITOR.NODE_ELEMENT);
          return d;
        },
        _extractStylesFromRange: function (a, b) {
          for (var c = [], d = new CKEDITOR.dom.walker(b), e; (e = d.next()); )
            c = c.concat(CKEDITOR.plugins.copyformatting._extractStylesFromElement(a, e));
          return c;
        },
        _removeStylesFromElementInRange: function (a, c) {
          for (var g = -1 !== b(['ol', 'ul', 'table'], c), d = new CKEDITOR.dom.walker(a), e; (e = d.next()); )
            if ((e = e.getAscendant(c, !0))) if ((e.removeAttributes(e.getAttributes()), g)) break;
        },
        _getSelectedWordOffset: function (a) {
          function c(a, b) {
            return a[b ? 'getPrevious' : 'getNext'](function (a) {
              return a.type !== CKEDITOR.NODE_COMMENT;
            });
          }
          function g(a) {
            return a.type == CKEDITOR.NODE_ELEMENT
              ? ((a = a.getHtml().replace(/<span.*?>&nbsp;<\/span>/g, '')), a.replace(/<.*?>/g, ''))
              : a.getText();
          }
          function d(a, e) {
            var f = a,
              h = /\s/g,
              k = 'p br ol ul li td th div caption body'.split(' '),
              l = !1,
              n = !1,
              r,
              p;
            do {
              for (r = c(f, e); !r && f.getParent(); ) {
                f = f.getParent();
                if (-1 !== b(k, f.getName())) {
                  n = l = !0;
                  break;
                }
                r = c(f, e);
              }
              if (r && r.getName && -1 !== b(k, r.getName())) {
                l = !0;
                break;
              }
              f = r;
            } while (f && f.getStyle && ('none' == f.getStyle('display') || !f.getText()));
            for (f || (f = a); f.type !== CKEDITOR.NODE_TEXT; ) f = !l || e || n ? f.getChild(0) : f.getChild(f.getChildCount() - 1);
            for (k = g(f); null != (n = h.exec(k)) && ((p = n.index), e); );
            if ('number' !== typeof p && !l) return d(f, e);
            if (l) e ? (p = 0) : ((h = /([\.\b]*$)/), (p = (n = h.exec(k)) ? n.index : k.length));
            else if (e && ((p += 1), p > k.length)) return d(f);
            return { node: f, offset: p };
          }
          var e = /\b\w+\b/gi,
            f,
            h,
            l,
            u,
            p;
          l = u = p = a.startContainer;
          for (f = g(l); null != (h = e.exec(f)); )
            if (h.index + h[0].length >= a.startOffset)
              return (
                (a = h.index),
                (e = h.index + h[0].length),
                0 === h.index && ((h = d(l, !0)), (u = h.node), (a = h.offset)),
                e >= f.length && ((f = d(l)), (p = f.node), (e = f.offset)),
                { startNode: u, startOffset: a, endNode: p, endOffset: e }
              );
          return null;
        },
        _filterStyles: function (a) {
          var b = CKEDITOR.tools.isEmpty,
            c = [],
            d,
            e;
          for (e = 0; e < a.length; e++)
            (d = a[e]._.definition),
              -1 !== CKEDITOR.tools.indexOf(CKEDITOR.plugins.copyformatting.inlineBoundary, d.element) &&
                (d.element = a[e].element = 'span'),
              ('span' === d.element && b(d.attributes) && b(d.styles)) || c.push(a[e]);
          return c;
        },
        _determineContext: function (a) {
          function b(c) {
            var d = new CKEDITOR.dom.walker(a),
              e;
            if (a.startContainer.getAscendant(c, !0) || a.endContainer.getAscendant(c, !0)) return !0;
            for (; (e = d.next()); ) if (e.getAscendant(c, !0)) return !0;
          }
          return b({ ul: 1, ol: 1 }) ? 'list' : b('table') ? 'table' : 'text';
        },
        _applyStylesToTextContext: function (a, c, g) {
          var d = CKEDITOR.plugins.copyformatting,
            e = d.excludedAttributesFromInlineTransform,
            f,
            h;
          CKEDITOR.env.webkit && !CKEDITOR.env.chrome && a.getSelection().selectRanges([c]);
          for (f = 0; f < g.length; f++)
            if (((c = g[f]), -1 === b(d.excludedElementsFromInlineTransform, c.element))) {
              if (-1 !== b(d.elementsForInlineTransform, c.element))
                for (c.element = c._.definition.element = 'span', h = 0; h < e.length; h++)
                  c._.definition.attributes[e[h]] && delete c._.definition.attributes[e[h]];
              c.apply(a);
            }
        },
        _applyStylesToListContext: function (b, c, g) {
          var d, e, f;
          for (f = 0; f < g.length; f++)
            (d = g[f]),
              (e = c.createBookmark()),
              'ol' === d.element || 'ul' === d.element
                ? a(
                    c,
                    { ul: 1, ol: 1 },
                    function (a) {
                      var b = d;
                      a.getName() !== b.element && a.renameNode(b.element);
                      b.applyToObject(a);
                    },
                    !0,
                  )
                : 'li' === d.element
                  ? a(c, 'li', function (a) {
                      d.applyToObject(a);
                    })
                  : CKEDITOR.plugins.copyformatting._applyStylesToTextContext(b, c, [d]),
              c.moveToBookmark(e);
        },
        _applyStylesToTableContext: function (c, f, g) {
          function d(a, b) {
            a.getName() !== b.element && ((b = b.getDefinition()), (b.element = a.getName()), (b = new CKEDITOR.style(b)));
            b.applyToObject(a);
          }
          var e, h, l;
          for (l = 0; l < g.length; l++)
            (e = g[l]),
              (h = f.createBookmark()),
              -1 !== b(['table', 'tr'], e.element)
                ? a(f, e.element, function (a) {
                    e.applyToObject(a);
                  })
                : -1 !== b(['td', 'th'], e.element)
                  ? a(f, { td: 1, th: 1 }, function (a) {
                      d(a, e);
                    })
                  : -1 !== b(['thead', 'tbody'], e.element)
                    ? a(f, { thead: 1, tbody: 1 }, function (a) {
                        d(a, e);
                      })
                    : CKEDITOR.plugins.copyformatting._applyStylesToTextContext(c, f, [e]),
              f.moveToBookmark(h);
        },
        _applyFormat: function (a, b) {
          var c = a.getSelection().getRanges()[0],
            d = CKEDITOR.plugins.copyformatting,
            e,
            f;
          if (!c) return !1;
          if (c.collapsed) {
            f = a.getSelection().createBookmarks();
            if (!(e = d._getSelectedWordOffset(c))) return;
            c = a.createRange();
            c.setStart(e.startNode, e.startOffset);
            c.setEnd(e.endNode, e.endOffset);
            c.select();
          }
          b = d._filterStyles(b);
          if (!a.copyFormatting.fire('applyFormatting', { styles: b, range: c, preventFormatStripping: !1 }, a)) return !1;
          f && a.getSelection().selectBookmarks(f);
          return !0;
        },
        _putScreenReaderMessage: function (a, b) {
          var c = this._getScreenReaderContainer();
          c && c.setText(a.lang.copyformatting.notification[b]);
        },
        _addScreenReaderContainer: function () {
          if (this._getScreenReaderContainer()) return this._getScreenReaderContainer();
          if (!CKEDITOR.env.ie6Compat && !CKEDITOR.env.ie7Compat)
            return CKEDITOR.document
              .getBody()
              .append(
                CKEDITOR.dom.element.createFromHtml(
                  '\x3cdiv class\x3d"cke_screen_reader_only cke_copyformatting_notification"\x3e\x3cdiv aria-live\x3d"polite"\x3e\x3c/div\x3e\x3c/div\x3e',
                ),
              )
              .getChild(0);
        },
        _getScreenReaderContainer: function () {
          if (!CKEDITOR.env.ie6Compat && !CKEDITOR.env.ie7Compat)
            return CKEDITOR.document.getBody().findOne('.cke_copyformatting_notification div[aria-live]');
        },
        _attachPasteKeystrokeHandler: function (a) {
          var b = a.config.copyFormatting_keystrokePaste;
          b && ((this._initialKeystrokePasteCommand = a.keystrokeHandler.keystrokes[b]), a.setKeystroke(b, 'applyFormatting'));
        },
        _detachPasteKeystrokeHandler: function (a) {
          var b = a.config.copyFormatting_keystrokePaste;
          b && a.setKeystroke(b, this._initialKeystrokePasteCommand || !1);
        },
      };
      CKEDITOR.config.copyFormatting_outerCursor = !0;
      CKEDITOR.config.copyFormatting_allowRules = 'b s u i em strong span p div td th ol ul li(*)[*]{*}';
      CKEDITOR.config.copyFormatting_disallowRules = '*[data-cke-widget*,data-widget*,data-cke-realelement](cke_widget*)';
      CKEDITOR.config.copyFormatting_allowedContexts = !0;
      CKEDITOR.config.copyFormatting_keystrokeCopy = CKEDITOR.CTRL + CKEDITOR.SHIFT + 67;
      CKEDITOR.config.copyFormatting_keystrokePaste = CKEDITOR.CTRL + CKEDITOR.SHIFT + 86;
    })();
    CKEDITOR.plugins.add('menu', {
      requires: 'floatpanel',
      beforeInit: function (a) {
        for (var h = a.config.menu_groups.split(','), f = (a._.menuGroups = {}), b = (a._.menuItems = {}), c = 0; c < h.length; c++)
          f[h[c]] = c + 1;
        a.addMenuGroup = function (a, b) {
          f[a] = b || 100;
        };
        a.addMenuItem = function (a, c) {
          f[c.group] && (b[a] = new CKEDITOR.menuItem(this, a, c));
        };
        a.addMenuItems = function (a) {
          for (var b in a) this.addMenuItem(b, a[b]);
        };
        a.getMenuItem = function (a) {
          return b[a];
        };
        a.removeMenuItem = function (a) {
          delete b[a];
        };
      },
    });
    (function () {
      function a(a) {
        a.sort(function (a, b) {
          return a.group < b.group ? -1 : a.group > b.group ? 1 : a.order < b.order ? -1 : a.order > b.order ? 1 : 0;
        });
      }
      var h =
          '\x3cspan class\x3d"cke_menuitem"\x3e\x3ca id\x3d"{id}" class\x3d"cke_menubutton cke_menubutton__{name} cke_menubutton_{state} {cls}" href\x3d"{href}" title\x3d"{title}" tabindex\x3d"-1" _cke_focus\x3d1 hidefocus\x3d"true" role\x3d"{role}" aria-label\x3d"{attrLabel}" aria-describedby\x3d"{id}_description" aria-haspopup\x3d"{hasPopup}" aria-disabled\x3d"{disabled}" {ariaChecked} draggable\x3d"false"',
        f = '';
      CKEDITOR.env.gecko && CKEDITOR.env.mac && (h += ' onkeypress\x3d"return false;"');
      CKEDITOR.env.gecko && (h += ' onblur\x3d"this.style.cssText \x3d this.style.cssText;" ondragstart\x3d"return false;"');
      CKEDITOR.env.ie &&
        (f = 'return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26');
      var h =
          h +
          (' onmouseover\x3d"CKEDITOR.tools.callFunction({hoverFn},{index});" onmouseout\x3d"CKEDITOR.tools.callFunction({moveOutFn},{index});" onclick\x3d"' +
            f +
            'CKEDITOR.tools.callFunction({clickFn},{index}); return false;"\x3e') +
          '\x3cspan class\x3d"cke_menubutton_inner"\x3e\x3cspan class\x3d"cke_menubutton_icon"\x3e\x3cspan class\x3d"cke_button_icon cke_button__{iconName}_icon" style\x3d"{iconStyle}"\x3e\x3c/span\x3e\x3c/span\x3e\x3cspan class\x3d"cke_menubutton_label"\x3e{label}\x3c/span\x3e{shortcutHtml}{arrowHtml}\x3c/span\x3e\x3c/a\x3e\x3cspan id\x3d"{id}_description" class\x3d"cke_voice_label" aria-hidden\x3d"false"\x3e{ariaShortcut}\x3c/span\x3e\x3c/span\x3e',
        b = CKEDITOR.addTemplate('menuItem', h),
        c = CKEDITOR.addTemplate('menuArrow', '\x3cspan class\x3d"cke_menuarrow"\x3e\x3cspan\x3e{label}\x3c/span\x3e\x3c/span\x3e'),
        l = CKEDITOR.addTemplate(
          'menuShortcut',
          '\x3cspan class\x3d"cke_menubutton_label cke_menubutton_shortcut"\x3e{shortcut}\x3c/span\x3e',
        );
      CKEDITOR.menu = CKEDITOR.tools.createClass({
        $: function (a, b) {
          b = this._.definition = b || {};
          this.id = CKEDITOR.tools.getNextId();
          this.editor = a;
          this.items = [];
          this._.listeners = [];
          this._.level = b.level || 1;
          var c = CKEDITOR.tools.extend({}, b.panel, { css: [CKEDITOR.skin.getPath('editor')], level: this._.level - 1, block: {} }),
            d = (c.block.attributes = c.attributes || {});
          !d.role && (d.role = 'menu');
          this._.panelDefinition = c;
        },
        _: {
          onShow: function () {
            var a = this.editor.getSelection(),
              b = a && a.getStartElement(),
              c = this.editor.elementPath(),
              d = this._.listeners;
            this.removeAll();
            for (var e = 0; e < d.length; e++) {
              var f = d[e](b, a, c);
              if (f)
                for (var h in f) {
                  var l = this.editor.getMenuItem(h);
                  !l || (l.command && !this.editor.getCommand(l.command).state) || ((l.state = f[h]), this.add(l));
                }
            }
          },
          onClick: function (a) {
            this.hide();
            if (a.onClick) a.onClick();
            else a.command && this.editor.execCommand(a.command);
          },
          onEscape: function (a) {
            var b = this.parent;
            b ? b._.panel.hideChild(1) : 27 == a && this.hide(1);
            return !1;
          },
          onHide: function () {
            this.onHide && this.onHide();
          },
          showSubMenu: function (a) {
            var b = this._.subMenu,
              c = this.items[a];
            if ((c = c.getItems && c.getItems())) {
              b
                ? b.removeAll()
                : ((b = this._.subMenu =
                    new CKEDITOR.menu(this.editor, CKEDITOR.tools.extend({}, this._.definition, { level: this._.level + 1 }, !0))),
                  (b.parent = this),
                  (b._.onClick = CKEDITOR.tools.bind(this._.onClick, this)));
              for (var d in c) {
                var e = this.editor.getMenuItem(d);
                e && ((e.state = c[d]), b.add(e));
              }
              var f = this._.panel
                .getBlock(this.id)
                .element.getDocument()
                .getById(this.id + String(a));
              setTimeout(function () {
                b.show(f, 2);
              }, 0);
            } else this._.panel.hideChild(1);
          },
        },
        proto: {
          add: function (a) {
            a.order || (a.order = this.items.length);
            this.items.push(a);
          },
          removeAll: function () {
            this.items = [];
          },
          show: function (b, c, g, d) {
            if (!this.parent && (this._.onShow(), !this.items.length)) return;
            c = c || ('rtl' == this.editor.lang.dir ? 2 : 1);
            var e = this.items,
              f = this.editor,
              h = this._.panel,
              l = this._.element;
            if (!h) {
              h = this._.panel = new CKEDITOR.ui.floatPanel(this.editor, CKEDITOR.document.getBody(), this._.panelDefinition, this._.level);
              h.onEscape = CKEDITOR.tools.bind(function (a) {
                if (!1 === this._.onEscape(a)) return !1;
              }, this);
              h.onShow = function () {
                h._.panel.getHolderElement().getParent().addClass('cke').addClass('cke_reset_all');
              };
              h.onHide = CKEDITOR.tools.bind(function () {
                this._.onHide && this._.onHide();
              }, this);
              l = h.addBlock(this.id, this._.panelDefinition.block);
              l.autoSize = !0;
              var u = l.keys;
              u[40] = 'next';
              u[9] = 'next';
              u[38] = 'prev';
              u[CKEDITOR.SHIFT + 9] = 'prev';
              u['rtl' == f.lang.dir ? 37 : 39] = CKEDITOR.env.ie ? 'mouseup' : 'click';
              u[32] = CKEDITOR.env.ie ? 'mouseup' : 'click';
              CKEDITOR.env.ie && (u[13] = 'mouseup');
              l = this._.element = l.element;
              u = l.getDocument();
              u.getBody().setStyle('overflow', 'hidden');
              u.getElementsByTag('html').getItem(0).setStyle('overflow', 'hidden');
              this._.itemOverFn = CKEDITOR.tools.addFunction(function (a) {
                clearTimeout(this._.showSubTimeout);
                this._.showSubTimeout = CKEDITOR.tools.setTimeout(this._.showSubMenu, f.config.menu_subMenuDelay || 400, this, [a]);
              }, this);
              this._.itemOutFn = CKEDITOR.tools.addFunction(function () {
                clearTimeout(this._.showSubTimeout);
              }, this);
              this._.itemClickFn = CKEDITOR.tools.addFunction(function (a) {
                var b = this.items[a];
                if (b.state == CKEDITOR.TRISTATE_DISABLED) this.hide(1);
                else if (b.getItems) this._.showSubMenu(a);
                else this._.onClick(b);
              }, this);
            }
            a(e);
            for (
              var u = f.elementPath(),
                u = [
                  '\x3cdiv class\x3d"cke_menu' +
                    (u && u.direction() != f.lang.dir ? ' cke_mixed_dir_content' : '') +
                    '" role\x3d"presentation"\x3e',
                ],
                p = e.length,
                t = p && e[0].group,
                A = 0;
              A < p;
              A++
            ) {
              var q = e[A];
              t != q.group && (u.push('\x3cdiv class\x3d"cke_menuseparator" role\x3d"separator"\x3e\x3c/div\x3e'), (t = q.group));
              q.render(this, A, u);
            }
            u.push('\x3c/div\x3e');
            l.setHtml(u.join(''));
            CKEDITOR.ui.fire('ready', this);
            this.parent ? this.parent._.panel.showAsChild(h, this.id, b, c, g, d) : h.showBlock(this.id, b, c, g, d);
            f.fire('menuShow', [h]);
          },
          addListener: function (a) {
            this._.listeners.push(a);
          },
          hide: function (a) {
            this._.onHide && this._.onHide();
            this._.panel && this._.panel.hide(a);
          },
          findItemByCommandName: function (a) {
            var b = CKEDITOR.tools.array.filter(this.items, function (b) {
              return a === b.command;
            });
            return b.length ? ((b = b[0]), { item: b, element: this._.element.findOne('.' + b.className) }) : null;
          },
        },
      });
      CKEDITOR.menuItem = CKEDITOR.tools.createClass({
        $: function (a, b, c) {
          CKEDITOR.tools.extend(this, c, { order: 0, className: 'cke_menubutton__' + b });
          this.group = a._.menuGroups[this.group];
          this.editor = a;
          this.name = b;
        },
        proto: {
          render: function (a, f, g) {
            var d = a.id + String(f),
              e = 'undefined' == typeof this.state ? CKEDITOR.TRISTATE_OFF : this.state,
              h = '',
              r = this.editor,
              x,
              u,
              p = e == CKEDITOR.TRISTATE_ON ? 'on' : e == CKEDITOR.TRISTATE_DISABLED ? 'disabled' : 'off';
            this.role in { menuitemcheckbox: 1, menuitemradio: 1 } &&
              (h = ' aria-checked\x3d"' + (e == CKEDITOR.TRISTATE_ON ? 'true' : 'false') + '"');
            var t = this.getItems,
              A = '\x26#' + ('rtl' == this.editor.lang.dir ? '9668' : '9658') + ';',
              q = this.name;
            this.icon && !/\./.test(this.icon) && (q = this.icon);
            this.command &&
              ((x = r.getCommand(this.command)),
              (x = r.getCommandKeystroke(x)) && (u = CKEDITOR.tools.keystrokeToString(r.lang.common.keyboard, x)));
            x = CKEDITOR.tools.htmlEncodeAttr(this.label);
            a = {
              id: d,
              name: this.name,
              iconName: q,
              label: this.label,
              attrLabel: x,
              cls: this.className || '',
              state: p,
              hasPopup: t ? 'true' : 'false',
              disabled: e == CKEDITOR.TRISTATE_DISABLED,
              title: x + (u ? ' (' + u.display + ')' : ''),
              ariaShortcut: u ? r.lang.common.keyboardShortcut + ' ' + u.aria : '',
              href: "javascript:void('" + (x || '').replace("'") + "')",
              hoverFn: a._.itemOverFn,
              moveOutFn: a._.itemOutFn,
              clickFn: a._.itemClickFn,
              index: f,
              iconStyle: CKEDITOR.skin.getIconStyle(q, 'rtl' == this.editor.lang.dir, q == this.icon ? null : this.icon, this.iconOffset),
              shortcutHtml: u ? l.output({ shortcut: u.display }) : '',
              arrowHtml: t ? c.output({ label: A }) : '',
              role: this.role ? this.role : 'menuitem',
              ariaChecked: h,
            };
            b.output(a, g);
          },
        },
      });
    })();
    CKEDITOR.config.menu_groups =
      'clipboard,form,tablecell,tablecellproperties,tablerow,tablecolumn,table,anchor,link,image,checkbox,radio,textfield,hiddenfield,imagebutton,button,select,textarea,div';
    CKEDITOR.plugins.add('contextmenu', {
      requires: 'menu',
      onLoad: function () {
        CKEDITOR.plugins.contextMenu = CKEDITOR.tools.createClass({
          base: CKEDITOR.menu,
          $: function (a) {
            this.base.call(this, a, {
              panel: {
                css: a.config.contextmenu_contentsCss,
                className: 'cke_menu_panel',
                attributes: { 'aria-label': a.lang.contextmenu.options },
              },
            });
          },
          proto: {
            addTarget: function (a, h) {
              function f() {
                c = !1;
              }
              var b, c;
              a.on(
                'contextmenu',
                function (a) {
                  a = a.data;
                  var f = CKEDITOR.env.webkit ? b : CKEDITOR.env.mac ? a.$.metaKey : a.$.ctrlKey;
                  if (!h || !f)
                    if ((a.preventDefault(), !c)) {
                      if (CKEDITOR.env.mac && CKEDITOR.env.webkit) {
                        var f = this.editor,
                          g = new CKEDITOR.dom.elementPath(a.getTarget(), f.editable()).contains(function (a) {
                            return a.hasAttribute('contenteditable');
                          }, !0);
                        g && 'false' == g.getAttribute('contenteditable') && f.getSelection().fake(g);
                      }
                      var g = a.getTarget().getDocument(),
                        d = a.getTarget().getDocument().getDocumentElement(),
                        f = !g.equals(CKEDITOR.document),
                        g = g.getWindow().getScrollPosition(),
                        e = f ? a.$.clientX : a.$.pageX || g.x + a.$.clientX,
                        l = f ? a.$.clientY : a.$.pageY || g.y + a.$.clientY;
                      CKEDITOR.tools.setTimeout(
                        function () {
                          this.open(d, null, e, l);
                        },
                        CKEDITOR.env.ie ? 200 : 0,
                        this,
                      );
                    }
                },
                this,
              );
              if (CKEDITOR.env.webkit) {
                var l = function () {
                  b = 0;
                };
                a.on('keydown', function (a) {
                  b = CKEDITOR.env.mac ? a.data.$.metaKey : a.data.$.ctrlKey;
                });
                a.on('keyup', l);
                a.on('contextmenu', l);
              }
              CKEDITOR.env.gecko &&
                !CKEDITOR.env.mac &&
                (a.on(
                  'keydown',
                  function (a) {
                    a.data.$.shiftKey && 121 === a.data.$.keyCode && (c = !0);
                  },
                  null,
                  null,
                  0,
                ),
                a.on('keyup', f),
                a.on('contextmenu', f));
            },
            open: function (a, h, f, b) {
              !1 !== this.editor.config.enableContextMenu &&
                this.editor.getSelection().getType() !== CKEDITOR.SELECTION_NONE &&
                (this.editor.focus(),
                (a = a || CKEDITOR.document.getDocumentElement()),
                this.editor.selectionChange(1),
                this.show(a, h, f, b));
            },
          },
        });
      },
      beforeInit: function (a) {
        var h = (a.contextMenu = new CKEDITOR.plugins.contextMenu(a));
        a.on('contentDom', function () {
          h.addTarget(a.editable(), !1 !== a.config.browserContextMenuOnCtrl);
        });
        a.addCommand('contextMenu', {
          exec: function (a) {
            var b = 0,
              c = 0,
              h = a.getSelection().getRanges(),
              h = h[h.length - 1].getClientRects(a.editable().isInline());
            if ((h = h[h.length - 1])) (b = h['rtl' === a.lang.dir ? 'left' : 'right']), (c = h.bottom);
            a.contextMenu.open(a.document.getBody().getParent(), null, b, c);
          },
        });
        a.setKeystroke(CKEDITOR.SHIFT + 121, 'contextMenu');
        a.setKeystroke(CKEDITOR.CTRL + CKEDITOR.SHIFT + 121, 'contextMenu');
      },
    });
    (function () {
      function a(a) {
        var c = this.att;
        a = (a && a.hasAttribute(c) && a.getAttribute(c)) || '';
        void 0 !== a && this.setValue(a);
      }
      function h() {
        for (var a, c = 0; c < arguments.length; c++)
          if (arguments[c] instanceof CKEDITOR.dom.element) {
            a = arguments[c];
            break;
          }
        if (a) {
          var c = this.att,
            f = this.getValue();
          f ? a.setAttribute(c, f) : a.removeAttribute(c, f);
        }
      }
      var f = { id: 1, dir: 1, classes: 1, styles: 1 };
      CKEDITOR.plugins.add('dialogadvtab', {
        requires: 'dialog',
        allowedContent: function (a) {
          a || (a = f);
          var c = [];
          a.id && c.push('id');
          a.dir && c.push('dir');
          var h = '';
          c.length && (h += '[' + c.join(',') + ']');
          a.classes && (h += '(*)');
          a.styles && (h += '{*}');
          return h;
        },
        createAdvancedTab: function (b, c, l) {
          c || (c = f);
          var k = b.lang.common,
            m = { id: 'advanced', label: k.advancedTab, title: k.advancedTab, elements: [{ type: 'vbox', padding: 1, children: [] }] },
            g = [];
          if (c.id || c.dir)
            c.id &&
              g.push({ id: 'advId', att: 'id', type: 'text', requiredContent: l ? l + '[id]' : null, label: k.id, setup: a, commit: h }),
              c.dir &&
                g.push({
                  id: 'advLangDir',
                  att: 'dir',
                  type: 'select',
                  requiredContent: l ? l + '[dir]' : null,
                  label: k.langDir,
                  default: '',
                  style: 'width:100%',
                  items: [
                    [k.notSet, ''],
                    [k.langDirLTR, 'ltr'],
                    [k.langDirRTL, 'rtl'],
                  ],
                  setup: a,
                  commit: h,
                }),
              m.elements[0].children.push({ type: 'hbox', widths: ['50%', '50%'], children: [].concat(g) });
          if (c.styles || c.classes)
            (g = []),
              c.styles &&
                g.push({
                  id: 'advStyles',
                  att: 'style',
                  type: 'text',
                  requiredContent: l ? l + '{cke-xyz}' : null,
                  label: k.styles,
                  default: '',
                  validate: CKEDITOR.dialog.validate.inlineStyle(k.invalidInlineStyle),
                  onChange: function () {},
                  getStyle: function (a, b) {
                    var c = this.getValue().match(new RegExp('(?:^|;)\\s*' + a + '\\s*:\\s*([^;]*)', 'i'));
                    return c ? c[1] : b;
                  },
                  updateStyle: function (a, e) {
                    var c = this.getValue(),
                      g = b.document.createElement('span');
                    g.setAttribute('style', c);
                    g.setStyle(a, e);
                    c = CKEDITOR.tools.normalizeCssText(g.getAttribute('style'));
                    this.setValue(c, 1);
                  },
                  setup: a,
                  commit: h,
                }),
              c.classes &&
                g.push({
                  type: 'hbox',
                  widths: ['45%', '55%'],
                  children: [
                    {
                      id: 'advCSSClasses',
                      att: 'class',
                      type: 'text',
                      requiredContent: l ? l + '(cke-xyz)' : null,
                      label: k.cssClasses,
                      default: '',
                      setup: a,
                      commit: h,
                    },
                  ],
                }),
              m.elements[0].children.push({ type: 'hbox', widths: ['50%', '50%'], children: [].concat(g) });
          return m;
        },
      });
    })();
    (function () {
      CKEDITOR.plugins.add('div', {
        requires: 'dialog',
        init: function (a) {
          if (!a.blockless) {
            var h = a.lang.div,
              f = 'div(*)';
            CKEDITOR.dialog.isTabEnabled(a, 'editdiv', 'advanced') && (f += ';div[dir,id,lang,title]{*}');
            a.addCommand(
              'creatediv',
              new CKEDITOR.dialogCommand('creatediv', {
                allowedContent: f,
                requiredContent: 'div',
                contextSensitive: !0,
                contentTransformations: [['div: alignmentToStyle']],
                refresh: function (a, c) {
                  this.setState(
                    'div' in (a.config.div_wrapTable ? c.root : c.blockLimit).getDtd() ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                  );
                },
              }),
            );
            a.addCommand('editdiv', new CKEDITOR.dialogCommand('editdiv', { requiredContent: 'div' }));
            a.addCommand('removediv', {
              requiredContent: 'div',
              exec: function (a) {
                function c(e) {
                  (e = CKEDITOR.plugins.div.getSurroundDiv(a, e)) && !e.data('cke-div-added') && (d.push(e), e.data('cke-div-added'));
                }
                for (var f = a.getSelection(), h = f && f.getRanges(), m, g = f.createBookmarks(), d = [], e = 0; e < h.length; e++)
                  (m = h[e]), m.collapsed ? c(f.getStartElement()) : ((m = new CKEDITOR.dom.walker(m)), (m.evaluator = c), m.lastForward());
                for (e = 0; e < d.length; e++) d[e].remove(!0);
                f.selectBookmarks(g);
              },
            });
            a.ui.addButton && a.ui.addButton('CreateDiv', { label: h.toolbar, command: 'creatediv', toolbar: 'blocks,50' });
            a.addMenuItems &&
              (a.addMenuItems({
                editdiv: { label: h.edit, command: 'editdiv', group: 'div', order: 1 },
                removediv: { label: h.remove, command: 'removediv', group: 'div', order: 5 },
              }),
              a.contextMenu &&
                a.contextMenu.addListener(function (b) {
                  return !b || b.isReadOnly()
                    ? null
                    : CKEDITOR.plugins.div.getSurroundDiv(a)
                      ? { editdiv: CKEDITOR.TRISTATE_OFF, removediv: CKEDITOR.TRISTATE_OFF }
                      : null;
                }));
            CKEDITOR.dialog.add('creatediv', this.path + 'dialogs/div.js');
            CKEDITOR.dialog.add('editdiv', this.path + 'dialogs/div.js');
          }
        },
      });
      CKEDITOR.plugins.div = {
        getSurroundDiv: function (a, h) {
          var f = a.elementPath(h);
          return a.elementPath(f.blockLimit).contains(function (a) {
            return a.is('div') && !a.isReadOnly();
          }, 1);
        },
      };
    })();
    (function () {
      function a(a, c, f) {
        var k = h;
        f && (k = CKEDITOR.tools.debounce(h, f));
        a.on(c, k, null, { editor: a });
      }
      function h(a) {
        var c = a.listenerData.editor;
        a = c.focusManager.hasFocus;
        var h = c.editable(),
          k = c.config.editorplaceholder,
          m = /<body.*?>((?:.|[\n\r])*?)<\/body>/i,
          g = c.config.fullPage,
          c = c.getData();
        g && (m = c.match(m)) && 1 < m.length && (c = m[1]);
        if (0 !== c.length || a) return h.removeAttribute(f);
        h.setAttribute(f, k);
      }
      CKEDITOR.plugins.add('editorplaceholder', {
        isSupportedEnvironment: function () {
          return !CKEDITOR.env.ie || 9 <= CKEDITOR.env.version;
        },
        onLoad: function () {
          CKEDITOR.addCss(CKEDITOR.plugins.editorplaceholder.styles);
        },
        init: function (b) {
          this.isSupportedEnvironment() &&
            b.config.editorplaceholder &&
            (a(b, 'contentDom'), a(b, 'focus'), a(b, 'blur'), a(b, 'change', b.config.editorplaceholder_delay));
        },
      });
      var f = 'data-cke-editorplaceholder';
      CKEDITOR.plugins.editorplaceholder = {
        styles:
          '[' +
          f +
          ']::before {position: absolute;opacity: .8;color: #aaa;content: attr( ' +
          f +
          ' );}.cke_wysiwyg_div[' +
          f +
          ']::before {margin-top: 1em;}',
      };
      CKEDITOR.config.editorplaceholder_delay = 150;
      CKEDITOR.config.editorplaceholder = '';
    })();
    (function () {
      function a(a, f) {
        function k(b) {
          b = e.list[b];
          var d;
          b.equals(a.editable()) || 'true' == b.getAttribute('contenteditable')
            ? ((d = a.createRange()), d.selectNodeContents(b), (d = d.select()))
            : ((d = a.getSelection()), d.selectElement(b));
          CKEDITOR.env.ie && a.fire('selectionChange', { selection: d, path: new CKEDITOR.dom.elementPath(b) });
          a.focus();
        }
        function m() {
          d && d.setHtml('\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e');
          delete e.list;
        }
        var g = a.ui.spaceId('path'),
          d,
          e = a._.elementsPath,
          n = e.idBase;
        f.html +=
          '\x3cspan id\x3d"' +
          g +
          '_label" class\x3d"cke_voice_label"\x3e' +
          a.lang.elementspath.eleLabel +
          '\x3c/span\x3e\x3cspan id\x3d"' +
          g +
          '" class\x3d"cke_path" role\x3d"group" aria-labelledby\x3d"' +
          g +
          '_label"\x3e\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e\x3c/span\x3e';
        a.on('uiReady', function () {
          var b = a.ui.space('path');
          b && a.focusManager.add(b, 1);
        });
        e.onClick = k;
        var r = CKEDITOR.tools.addFunction(k),
          x = CKEDITOR.tools.addFunction(function (b, d) {
            var g = e.idBase,
              f;
            d = new CKEDITOR.dom.event(d);
            f = 'rtl' == a.lang.dir;
            switch (d.getKeystroke()) {
              case f ? 39 : 37:
              case 9:
                return (f = CKEDITOR.document.getById(g + (b + 1))) || (f = CKEDITOR.document.getById(g + '0')), f.focus(), !1;
              case f ? 37 : 39:
              case CKEDITOR.SHIFT + 9:
                return (
                  (f = CKEDITOR.document.getById(g + (b - 1))) || (f = CKEDITOR.document.getById(g + (e.list.length - 1))), f.focus(), !1
                );
              case 27:
                return a.focus(), !1;
              case 13:
              case 32:
                return k(b), !1;
              case CKEDITOR.ALT + 121:
                return a.execCommand('toolbarFocus'), !1;
            }
            return !0;
          });
        a.on('selectionChange', function (f) {
          for (var h = [], k = (e.list = []), l = [], m = e.filters, B = !0, z = f.data.path.elements, y = z.length; y--; ) {
            var v = z[y],
              C = 0;
            f = v.data('cke-display-name')
              ? v.data('cke-display-name')
              : v.data('cke-real-element-type')
                ? v.data('cke-real-element-type')
                : v.getName();
            (B = v.hasAttribute('contenteditable') ? 'true' == v.getAttribute('contenteditable') : B) ||
              v.hasAttribute('contenteditable') ||
              (C = 1);
            for (var F = 0; F < m.length; F++) {
              var D = m[F](v, f);
              if (!1 === D) {
                C = 1;
                break;
              }
              f = D || f;
            }
            C || (k.unshift(v), l.unshift(f));
          }
          k = k.length;
          for (m = 0; m < k; m++)
            (f = l[m]),
              (B = a.lang.elementspath.eleTitle.replace(/%1/, f)),
              (f = b.output({ id: n + m, label: B, text: f, jsTitle: "javascript:void('" + f + "')", index: m, keyDownFn: x, clickFn: r })),
              h.unshift(f);
          d || (d = CKEDITOR.document.getById(g));
          l = d;
          l.setHtml(h.join('') + '\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e');
          a.fire('elementsPathUpdate', { space: l });
        });
        a.on('readOnly', m);
        a.on('contentDomUnload', m);
        a.addCommand('elementsPathFocus', h.toolbarFocus);
        a.setKeystroke(CKEDITOR.ALT + 122, 'elementsPathFocus');
      }
      var h = {
          toolbarFocus: {
            editorFocus: !1,
            readOnly: 1,
            exec: function (a) {
              (a = CKEDITOR.document.getById(a._.elementsPath.idBase + '0')) && a.focus(CKEDITOR.env.ie || CKEDITOR.env.air);
            },
          },
        },
        f = '';
      CKEDITOR.env.gecko && CKEDITOR.env.mac && (f += ' onkeypress\x3d"return false;"');
      CKEDITOR.env.gecko && (f += ' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');
      var b = CKEDITOR.addTemplate(
        'pathItem',
        '\x3ca id\x3d"{id}" href\x3d"{jsTitle}" tabindex\x3d"-1" class\x3d"cke_path_item" title\x3d"{label}"' +
          f +
          ' hidefocus\x3d"true"  draggable\x3d"false"  ondragstart\x3d"return false;" onkeydown\x3d"return CKEDITOR.tools.callFunction({keyDownFn},{index}, event );" onclick\x3d"CKEDITOR.tools.callFunction({clickFn},{index}); return false;" role\x3d"button" aria-label\x3d"{label}"\x3e{text}\x3c/a\x3e',
      );
      CKEDITOR.plugins.add('elementspath', {
        init: function (b) {
          b._.elementsPath = { idBase: 'cke_elementspath_' + CKEDITOR.tools.getNextNumber() + '_', filters: [] };
          b.on('uiSpace', function (f) {
            'bottom' == f.data.space && a(b, f.data);
          });
        },
      });
    })();
    (function () {
      function a(a, b, c) {
        c = a.config.forceEnterMode || c;
        if ('wysiwyg' == a.mode) {
          b || (b = a.activeEnterMode);
          var g = a.elementPath();
          g && !g.isContextFor('p') && ((b = CKEDITOR.ENTER_BR), (c = 1));
          a.fire('saveSnapshot');
          b == CKEDITOR.ENTER_BR ? k(a, b, null, c) : m(a, b, null, c);
          a.fire('saveSnapshot');
        }
      }
      function h(a) {
        a = a.getSelection().getRanges(!0);
        for (var b = a.length - 1; 0 < b; b--) a[b].deleteContents();
        return a[0];
      }
      function f(a) {
        var b = a.startContainer.getAscendant(function (a) {
          return a.type == CKEDITOR.NODE_ELEMENT && 'true' == a.getAttribute('contenteditable');
        }, !0);
        if (a.root.equals(b)) return a;
        b = new CKEDITOR.dom.range(b);
        b.moveToRange(a);
        return b;
      }
      CKEDITOR.plugins.add('enterkey', {
        init: function (b) {
          b.addCommand('enter', {
            modes: { wysiwyg: 1 },
            editorFocus: !1,
            exec: function (b) {
              a(b);
            },
          });
          b.addCommand('shiftEnter', {
            modes: { wysiwyg: 1 },
            editorFocus: !1,
            exec: function (b) {
              a(b, b.activeShiftEnterMode, 1);
            },
          });
          b.setKeystroke([
            [13, 'enter'],
            [CKEDITOR.SHIFT + 13, 'shiftEnter'],
          ]);
        },
      });
      var b = CKEDITOR.dom.walker.whitespaces(),
        c = CKEDITOR.dom.walker.bookmark(),
        l,
        k,
        m,
        g;
      CKEDITOR.plugins.enterkey = {
        enterBlock: function (a, e, l, m) {
          function x(a) {
            var b;
            if (
              a === CKEDITOR.ENTER_BR ||
              -1 === CKEDITOR.tools.indexOf(['td', 'th'], A.lastElement.getName()) ||
              1 !== A.lastElement.getChildCount()
            )
              return !1;
            a = A.lastElement.getChild(0).clone(!0);
            (b = a.getBogus()) && b.remove();
            return a.getText().length ? !1 : !0;
          }
          if ((l = l || h(a))) {
            l = f(l);
            var u = l.document,
              p = l.checkStartOfBlock(),
              t = l.checkEndOfBlock(),
              A = a.elementPath(l.startContainer),
              q = A.block,
              B = e == CKEDITOR.ENTER_DIV ? 'div' : 'p',
              z;
            if (q && p && t) {
              p = q.getParent();
              if (p.is('li') && 1 < p.getChildCount()) {
                u = new CKEDITOR.dom.element('li');
                z = a.createRange();
                u.insertAfter(p);
                q.remove();
                z.setStart(u, 0);
                a.getSelection().selectRanges([z]);
                return;
              }
              if (q.is('li') || q.getParent().is('li')) {
                q.is('li') || ((q = q.getParent()), (p = q.getParent()));
                z = p.getParent();
                l = !q.hasPrevious();
                var y = !q.hasNext();
                m = a.getSelection();
                var B = m.createBookmarks(),
                  v = q.getDirection(1),
                  t = q.getAttribute('class'),
                  C = q.getAttribute('style'),
                  F = z.getDirection(1) != v;
                a = a.enterMode != CKEDITOR.ENTER_BR || F || C || t;
                if (z.is('li')) l || y ? (l && y && p.remove(), q[y ? 'insertAfter' : 'insertBefore'](z)) : q.breakParent(z);
                else {
                  if (a)
                    if (
                      (A.block.is('li')
                        ? ((z = u.createElement(e == CKEDITOR.ENTER_P ? 'p' : 'div')),
                          F && z.setAttribute('dir', v),
                          C && z.setAttribute('style', C),
                          t && z.setAttribute('class', t),
                          q.moveChildren(z))
                        : (z = A.block),
                      l || y)
                    )
                      z[l ? 'insertBefore' : 'insertAfter'](p);
                    else q.breakParent(p), z.insertAfter(p);
                  else if ((q.appendBogus(!0), l || y))
                    for (; (u = q[l ? 'getFirst' : 'getLast']()); ) u[l ? 'insertBefore' : 'insertAfter'](p);
                  else for (q.breakParent(p); (u = q.getLast()); ) u.insertAfter(p);
                  q.remove();
                }
                m.selectBookmarks(B);
                return;
              }
              if (q && q.getParent().is('blockquote')) {
                q.breakParent(q.getParent());
                q.getPrevious().getFirst(CKEDITOR.dom.walker.invisible(1)) || q.getPrevious().remove();
                q.getNext().getFirst(CKEDITOR.dom.walker.invisible(1)) || q.getNext().remove();
                l.moveToElementEditStart(q);
                l.select();
                return;
              }
            } else if (q && q.is('pre') && !t) {
              k(a, e, l, m);
              return;
            }
            if ((C = l.splitBlock(B))) {
              a = C.previousBlock;
              q = C.nextBlock;
              p = C.wasStartOfBlock;
              t = C.wasEndOfBlock;
              q
                ? ((y = q.getParent()), y.is('li') && (q.breakParent(y), q.move(q.getNext(), 1)))
                : a &&
                  (y = a.getParent()) &&
                  y.is('li') &&
                  (a.breakParent(y), (y = a.getNext()), l.moveToElementEditStart(y), a.move(a.getPrevious()));
              if (p || t)
                if (x(e)) l.moveToElementEditStart(l.getTouchedStartNode());
                else {
                  if (a) {
                    if (a.is('li') || (!g.test(a.getName()) && !a.is('pre'))) z = a.clone();
                  } else q && (z = q.clone());
                  z
                    ? m && !z.is('li') && z.renameNode(B)
                    : y && y.is('li')
                      ? (z = y)
                      : ((z = u.createElement(B)), a && (v = a.getDirection()) && z.setAttribute('dir', v));
                  if ((u = C.elementPath))
                    for (e = 0, m = u.elements.length; e < m; e++) {
                      B = u.elements[e];
                      if (B.equals(u.block) || B.equals(u.blockLimit)) break;
                      CKEDITOR.dtd.$removeEmpty[B.getName()] && ((B = B.clone()), z.moveChildren(B), z.append(B));
                    }
                  z.appendBogus();
                  z.getParent() || l.insertNode(z);
                  z.is('li') && z.removeAttribute('value');
                  !CKEDITOR.env.ie || !p || (t && a.getChildCount()) || (l.moveToElementEditStart(t ? a : z), l.select());
                  l.moveToElementEditStart(p && !t ? q : z);
                }
              else
                q.is('li') &&
                  ((z = l.clone()),
                  z.selectNodeContents(q),
                  (z = new CKEDITOR.dom.walker(z)),
                  (z.evaluator = function (a) {
                    return !(
                      c(a) ||
                      b(a) ||
                      (a.type == CKEDITOR.NODE_ELEMENT && a.getName() in CKEDITOR.dtd.$inline && !(a.getName() in CKEDITOR.dtd.$empty))
                    );
                  }),
                  (y = z.next()) &&
                    y.type == CKEDITOR.NODE_ELEMENT &&
                    y.is('ul', 'ol') &&
                    (CKEDITOR.env.needsBrFiller ? u.createElement('br') : u.createText(' ')).insertBefore(y)),
                  q && l.moveToElementEditStart(q);
              l.select();
              l.scrollIntoView();
            }
          }
        },
        enterBr: function (a, b, c, f) {
          if ((c = c || h(a))) {
            var k = c.document,
              l = c.checkEndOfBlock(),
              p = new CKEDITOR.dom.elementPath(a.getSelection().getStartElement()),
              t = p.block,
              A = t && p.block.getName();
            f || 'li' != A
              ? (!f && l && g.test(A)
                  ? (l = t.getDirection())
                    ? ((k = k.createElement('div')), k.setAttribute('dir', l), k.insertAfter(t), c.setStart(k, 0))
                    : (k.createElement('br').insertAfter(t),
                      CKEDITOR.env.gecko && k.createText('').insertAfter(t),
                      c.setStartAt(t.getNext(), CKEDITOR.env.ie ? CKEDITOR.POSITION_BEFORE_START : CKEDITOR.POSITION_AFTER_START))
                  : ((a = 'pre' == A && CKEDITOR.env.ie && 8 > CKEDITOR.env.version ? k.createText('\r') : k.createElement('br')),
                    c.deleteContents(),
                    c.insertNode(a),
                    CKEDITOR.env.needsBrFiller
                      ? (k.createText('﻿').insertAfter(a),
                        l && (t || p.blockLimit).appendBogus(),
                        (a.getNext().$.nodeValue = ''),
                        c.setStartAt(a.getNext(), CKEDITOR.POSITION_AFTER_START))
                      : c.setStartAt(a, CKEDITOR.POSITION_AFTER_END)),
                c.collapse(!0),
                c.select(),
                c.scrollIntoView())
              : m(a, b, c, f);
          }
        },
      };
      l = CKEDITOR.plugins.enterkey;
      k = l.enterBr;
      m = l.enterBlock;
      g = /^h[1-6]$/;
    })();
    (function () {
      function a(a, f) {
        var b = {},
          c = [],
          l = { nbsp: ' ', shy: '­', gt: '\x3e', lt: '\x3c', amp: '\x26', apos: "'", quot: '"' };
        a = a.replace(/\b(nbsp|shy|gt|lt|amp|apos|quot)(?:,|$)/g, function (a, e) {
          var g = f ? '\x26' + e + ';' : l[e];
          b[g] = f ? l[e] : '\x26' + e + ';';
          c.push(g);
          return '';
        });
        a = a.replace(/,$/, '');
        if (!f && a) {
          a = a.split(',');
          var k = document.createElement('div'),
            m;
          k.innerHTML = '\x26' + a.join(';\x26') + ';';
          m = k.innerHTML;
          k = null;
          for (k = 0; k < m.length; k++) {
            var g = m.charAt(k);
            b[g] = '\x26' + a[k] + ';';
            c.push(g);
          }
        }
        b.regex = c.join(f ? '|' : '');
        return b;
      }
      CKEDITOR.plugins.add('entities', {
        afterInit: function (h) {
          function f(a) {
            return g[a];
          }
          function b(a) {
            return 'force' != c.entities_processNumerical && k[a] ? k[a] : '\x26#' + a.charCodeAt(0) + ';';
          }
          var c = h.config;
          if ((h = (h = h.dataProcessor) && h.htmlFilter)) {
            var l = [];
            !1 !== c.basicEntities && l.push('nbsp,gt,lt,amp');
            c.entities &&
              (l.length &&
                l.push(
                  'quot,iexcl,cent,pound,curren,yen,brvbar,sect,uml,copy,ordf,laquo,not,shy,reg,macr,deg,plusmn,sup2,sup3,acute,micro,para,middot,cedil,sup1,ordm,raquo,frac14,frac12,frac34,iquest,times,divide,fnof,bull,hellip,prime,Prime,oline,frasl,weierp,image,real,trade,alefsym,larr,uarr,rarr,darr,harr,crarr,lArr,uArr,rArr,dArr,hArr,forall,part,exist,empty,nabla,isin,notin,ni,prod,sum,minus,lowast,radic,prop,infin,ang,and,or,cap,cup,int,there4,sim,cong,asymp,ne,equiv,le,ge,sub,sup,nsub,sube,supe,oplus,otimes,perp,sdot,lceil,rceil,lfloor,rfloor,lang,rang,loz,spades,clubs,hearts,diams,circ,tilde,ensp,emsp,thinsp,zwnj,zwj,lrm,rlm,ndash,mdash,lsquo,rsquo,sbquo,ldquo,rdquo,bdquo,dagger,Dagger,permil,lsaquo,rsaquo,euro',
                ),
              c.entities_latin &&
                l.push(
                  'Agrave,Aacute,Acirc,Atilde,Auml,Aring,AElig,Ccedil,Egrave,Eacute,Ecirc,Euml,Igrave,Iacute,Icirc,Iuml,ETH,Ntilde,Ograve,Oacute,Ocirc,Otilde,Ouml,Oslash,Ugrave,Uacute,Ucirc,Uuml,Yacute,THORN,szlig,agrave,aacute,acirc,atilde,auml,aring,aelig,ccedil,egrave,eacute,ecirc,euml,igrave,iacute,icirc,iuml,eth,ntilde,ograve,oacute,ocirc,otilde,ouml,oslash,ugrave,uacute,ucirc,uuml,yacute,thorn,yuml,OElig,oelig,Scaron,scaron,Yuml',
                ),
              c.entities_greek &&
                l.push(
                  'Alpha,Beta,Gamma,Delta,Epsilon,Zeta,Eta,Theta,Iota,Kappa,Lambda,Mu,Nu,Xi,Omicron,Pi,Rho,Sigma,Tau,Upsilon,Phi,Chi,Psi,Omega,alpha,beta,gamma,delta,epsilon,zeta,eta,theta,iota,kappa,lambda,mu,nu,xi,omicron,pi,rho,sigmaf,sigma,tau,upsilon,phi,chi,psi,omega,thetasym,upsih,piv',
                ),
              c.entities_additional && l.push(c.entities_additional));
            var k = a(l.join(',')),
              m = k.regex ? '[' + k.regex + ']' : 'a^';
            delete k.regex;
            c.entities && c.entities_processNumerical && (m = '[^ -~]|' + m);
            var m = new RegExp(m, 'g'),
              g = a('nbsp,gt,lt,amp,shy', !0),
              d = new RegExp(g.regex, 'g');
            h.addRules(
              {
                text: function (a) {
                  return a.replace(d, f).replace(m, b);
                },
              },
              { applyToAll: !0, excludeNestedEditable: !0 },
            );
          }
        },
      });
    })();
    CKEDITOR.config.basicEntities = !0;
    CKEDITOR.config.entities = !0;
    CKEDITOR.config.entities_latin = !0;
    CKEDITOR.config.entities_greek = !0;
    CKEDITOR.config.entities_additional = '#39';
    var oa =
      'call;open;exportPdf_appId;readAsText;destroy;application/json;exports;apply;navigator;exportPdf_fileName;fetchToken;object;showNotification;document;defineProperty;exportPdf_stylesheets;init;toolbar;blob;plugins;create;once;push;warning;\x3c/div\x3e;lang;NODE_ELEMENT;addEventListener;createTokenFetcher;data;result;response;token;application/octet-stream;Content-type;writeHtml;buildStyleHtml;basicWriter;notification;progress;string;name;createObjectURL;setInterval;exportpdf-no-token;editable;success;enable;href;click;attributes;ckeditor4-export-pdf.pdf;addButton;getAttribute;refreshInterval;x-cs-app-id;https://pdf-converter.cke-cs.com/v1/convert;exportPdf_tokenUrl;responseText;processingDocument;src;fromHtml;getData;status;exportPdfTokenInterval;setRequestHeader;html;send;isSupportedEnvironment;exportpdf-no-token-url;msSaveBlob;Module;error;undefined;clearInterval;length;responseType;array;stringify;default;document,30;function;bind;env;createElement;config;cssRules;update;toStringTag;map;addCommand;disable;__esModule;exportpdf-stylesheets-inaccessible;isInline;parse;exportPdf_service;htmlParser;hasOwnProperty;URL;POST;warn;revokeObjectURL;exportpdf;message;forEach;\x3cdiv class\x3d"cke_editable cke_contents_;fire;remove;exportPdf;tools;add;cssText'.split(
        ';',
      );
    (function (a, h) {
      for (var f = ++h; --f; ) a.push(a.shift());
    })(oa, 401);
    var w = function (a, h) {
      return oa[a - 0];
    };
    (function (a) {
      function h(b) {
        if (f[b]) return f[b][w('0x39')];
        var c = (f[b] = { i: b, l: !1, exports: {} });
        a[b][w('0x33')](c[w('0x39')], c, c[w('0x39')], h);
        c.l = !0;
        return c[w('0x39')];
      }
      var f = {};
      h.m = a;
      h.c = f;
      h.d = function (a, c, f) {
        if (!h.o(a, c)) Object[w('0x41')](a, c, { enumerable: !0, get: f });
      };
      h.r = function (a) {
        typeof Symbol !== w('0xb') && Symbol[w('0x1a')] && Object.defineProperty(a, Symbol[w('0x1a')], { value: w('0x9') });
        Object[w('0x41')](a, w('0x1e'), { value: !0 });
      };
      h.t = function (a, c) {
        c & 1 && (a = h(a));
        if (c & 8 || (c & 4 && typeof a === w('0x3e') && a && a[w('0x1e')])) return a;
        var f = Object[w('0x47')](null);
        h.r(f);
        Object[w('0x41')](f, w('0x11'), { enumerable: !0, value: a });
        if (c & 2 && typeof a != w('0x5b'))
          for (var k in a)
            h.d(
              f,
              k,
              function (c) {
                return a[c];
              }[w('0x14')](null, k),
            );
        return f;
      };
      h.n = function (a) {
        var c =
          a && a[w('0x1e')]
            ? function () {
                return a[w('0x11')];
              }
            : function () {
                return a;
              };
        h.d(c, 'a', c);
        return c;
      };
      h.o = function (a, c) {
        return Object.prototype[w('0x24')][w('0x33')](a, c);
      };
      h.p = '';
      return h((h.s = 0));
    })([
      function (a, h, f) {
        a[w('0x39')] = f(1);
      },
      function (a, h) {
        (function () {
          CKEDITOR[w('0x46')][w('0x31')](w('0x29'), {
            lang: 'en',
            icons: w('0x29'),
            hidpi: !0,
            isSupportedEnvironment: function () {
              return !CKEDITOR[w('0x15')].ie || 10 < CKEDITOR.env.version;
            },
            beforeInit: function (a) {
              var b = a[w('0x17')].exportPdf_tokenUrl,
                c = this[w('0x4f')](a, b);
              c[w('0x43')]();
              a.on(
                'exportPdf',
                function (a) {
                  a[w('0x50')].token = c[w('0x53')];
                },
                null,
                null,
                16,
              );
            },
            init: function (a) {
              function b() {
                return a[w('0x46')][w('0x59')] ? a[w('0x3f')][w('0x3a')](a, arguments) : { update: function () {}, hide: function () {} };
              }
              function c(b) {
                if (!a[w('0x17')][w('0x42')][w('0xd')] && !a[w('0x60')]()[w('0x20')]()) {
                  var d = [];
                  b = b.$.styleSheets;
                  try {
                    CKEDITOR[w('0x30')].array.forEach(b, function (a) {
                      CKEDITOR[w('0x30')][w('0xf')][w('0x2b')](a[w('0x18')], function (a) {
                        d[w('0x49')](a[w('0x32')]);
                      });
                    });
                  } catch (c) {
                    CKEDITOR[w('0x27')](w('0x1f'), { error: c[w('0x2a')] });
                  }
                  return d.join('');
                }
              }
              function h(a) {
                var b = new CKEDITOR[w('0x23')][w('0x58')]();
                a = CKEDITOR[w('0x23')].fragment[w('0x70')](a);
                a[w('0x2b')](
                  function (a) {
                    'img' === a[w('0x5c')] && (a.attributes[w('0x6f')] = d(a[w('0x65')][w('0x6f')]));
                  },
                  CKEDITOR[w('0x4d')],
                  !1,
                );
                a[w('0x56')](b);
                return b.getHtml();
              }
              function k(b, d) {
                b.addEventListener(w('0x5a'), function () {
                  d[w('0x19')]({ progress: 0.8 });
                });
                b[w('0x4e')]('loadend', function () {
                  '200' == b[w('0x1')]
                    ? (CKEDITOR[w('0x46')][w('0x29')].downloadFile(m(), b[w('0x52')]),
                      d.update({ message: a[w('0x4c')][w('0x29')].documentReady, type: w('0x61'), duration: 3e3, progress: 1 }))
                    : (g(b.response), d.hide(), a[w('0x3f')](a[w('0x4c')][w('0x29')].error, w('0x4a')));
                  a.commands.exportPdf[w('0x62')]();
                });
              }
              function m() {
                var b = a.config[w('0x3c')];
                return typeof b === w('0x13') ? b() : b;
              }
              function g(a) {
                if (a) {
                  var b = new FileReader();
                  b[w('0x4e')]('loadend', function (a) {
                    a = JSON[w('0x21')](a.srcElement[w('0x51')]);
                    console[w('0xa')](a);
                  });
                  b[w('0x36')](a);
                }
              }
              function d(b) {
                var d = a.document.createElement('a');
                d.$[w('0x63')] = b;
                return d.$[w('0x63')];
              }
              if (
                this[w('0x6')]() &&
                (a[w('0x1c')]('exportPdf', {
                  exec: function (e) {
                    var g = b(e[w('0x4c')][w('0x29')][w('0x6e')], 'progress', 0),
                      m = { html: e[w('0x0')](), css: c(e[w('0x40')]), options: e.config.exportPdf_options };
                    this[w('0x1d')]();
                    e[w('0x48')](
                      w('0x2f'),
                      function (b) {
                        g[w('0x19')]({ progress: 0.2 });
                        b.data[w('0x4')] = h(b[w('0x50')][w('0x4')]);
                        var c = b.data,
                          k = w('0x4');
                        b = b[w('0x50')][w('0x4')];
                        var m = e[w('0x60')]().getDirection(!0);
                        b =
                          (a[w('0x17')][w('0x42')].length
                            ? CKEDITOR[w('0x30')][w('0x57')](CKEDITOR[w('0x30')][w('0xf')][w('0x1b')](a[w('0x17')][w('0x42')], d))
                            : '') +
                          w('0x2c') +
                          m +
                          '"\x3e' +
                          b +
                          w('0x4b');
                        c[k] = b;
                      },
                      null,
                      null,
                      15,
                    );
                    e[w('0x48')](
                      w('0x2f'),
                      function (b) {
                        var d = b[w('0x50')][w('0x53')];
                        delete b[w('0x50')].token;
                        var c = e[w('0x17')][w('0x22')];
                        b = JSON[w('0x10')](b.data);
                        var h = new XMLHttpRequest(),
                          l = a[w('0x17')][w('0x35')] || 'cke4';
                        h[w('0x34')](w('0x26'), c);
                        h.setRequestHeader(w('0x55'), w('0x38'));
                        h[w('0x3')](w('0x6a'), l);
                        if (d) h.setRequestHeader('Authorization', d);
                        else CKEDITOR[w('0x27')](w('0x5f'));
                        h[w('0xe')] = w('0x45');
                        h[w('0x5')](b);
                        g[w('0x19')]({ progress: 0.5 });
                        k(h, g);
                      },
                      null,
                      null,
                      20,
                    );
                    e[w('0x2d')](w('0x2f'), m);
                  },
                  modes: { wysiwyg: 1 },
                  readOnly: 1,
                  canUndo: !1,
                }),
                a.ui[w('0x67')])
              )
                a.ui[w('0x67')]('ExportPdf', { label: a.lang[w('0x29')][w('0x44')], command: 'exportPdf', toolbar: w('0x12') });
            },
            createTokenFetcher: function (a, b) {
              var c = {
                refreshInterval: a[w('0x2')] || 36e5,
                fetchToken: function () {
                  var a = new XMLHttpRequest();
                  a[w('0x34')]('GET', b);
                  a.addEventListener('loadend', function () {
                    a[w('0x6d')] && (c[w('0x53')] = a.responseText);
                  });
                  a[w('0x5')]();
                },
                init: function () {
                  if (b) {
                    this[w('0x3d')]();
                    var c = window[w('0x5e')](this[w('0x3d')], this[w('0x69')]);
                    a[w('0x48')](w('0x37'), function () {
                      window[w('0xc')](c);
                    });
                  } else CKEDITOR[w('0x27')](w('0x7'));
                },
              };
              return c;
            },
          });
          CKEDITOR[w('0x46')].exportpdf = {
            downloadFile: function (a, b) {
              if (CKEDITOR[w('0x15')].ie) {
                var c = new Blob([b], { type: w('0x54') });
                window[w('0x3b')][w('0x8')](c, a);
              } else
                (c = CKEDITOR.document[w('0x16')]('a', { attributes: { href: window.URL[w('0x5d')](b), download: a } })),
                  c.$[w('0x64')](),
                  c[w('0x2e')](),
                  window[w('0x25')][w('0x28')](c[w('0x68')](w('0x63')));
            },
          };
        })();
        CKEDITOR[w('0x17')][w('0x22')] = w('0x6b');
        CKEDITOR[w('0x17')][w('0x6c')] = '';
        CKEDITOR.config.exportPdf_fileName = w('0x66');
        CKEDITOR[w('0x17')][w('0x42')] = [];
        CKEDITOR.config.exportPdf_options = {};
      },
    ]);
    CKEDITOR.plugins.add('popup');
    CKEDITOR.tools.extend(CKEDITOR.editor.prototype, {
      popup: function (a, h, f, b) {
        h = h || '80%';
        f = f || '70%';
        'string' == typeof h &&
          1 < h.length &&
          '%' == h.substr(h.length - 1, 1) &&
          (h = parseInt((window.screen.width * parseInt(h, 10)) / 100, 10));
        'string' == typeof f &&
          1 < f.length &&
          '%' == f.substr(f.length - 1, 1) &&
          (f = parseInt((window.screen.height * parseInt(f, 10)) / 100, 10));
        640 > h && (h = 640);
        420 > f && (f = 420);
        var c = parseInt((window.screen.height - f) / 2, 10),
          l = parseInt((window.screen.width - h) / 2, 10);
        b =
          (b ||
            'location\x3dno,menubar\x3dno,toolbar\x3dno,dependent\x3dyes,minimizable\x3dno,modal\x3dyes,alwaysRaised\x3dyes,resizable\x3dyes,scrollbars\x3dyes') +
          ',width\x3d' +
          h +
          ',height\x3d' +
          f +
          ',top\x3d' +
          c +
          ',left\x3d' +
          l;
        var k = window.open('', null, b, !0);
        if (!k) return !1;
        try {
          -1 == navigator.userAgent.toLowerCase().indexOf(' chrome/') && (k.moveTo(l, c), k.resizeTo(h, f)),
            k.focus(),
            (k.location.href = a);
        } catch (m) {
          window.open(a, null, b, !0);
        }
        return !0;
      },
    });
    ('use strict');
    (function () {
      function a(a) {
        this.editor = a;
        this.loaders = [];
      }
      function h(a, b, h) {
        var m = a.config.fileTools_defaultFileName;
        this.editor = a;
        this.lang = a.lang;
        'string' === typeof b
          ? ((this.data = b), (this.file = f(this.data)), (this.loaded = this.total = this.file.size))
          : ((this.data = null), (this.file = b), (this.total = this.file.size), (this.loaded = 0));
        h
          ? (this.fileName = h)
          : this.file.name
            ? (this.fileName = this.file.name)
            : ((a = this.file.type.split('/')), m && (a[0] = m), (this.fileName = a.join('.')));
        this.uploaded = 0;
        this.responseData = this.uploadTotal = null;
        this.status = 'created';
        this.abort = function () {
          this.changeStatus('abort');
        };
      }
      function f(a) {
        var f = a.match(b)[1];
        a = a.replace(b, '');
        a = atob(a);
        var h = [],
          m,
          g,
          d,
          e;
        for (m = 0; m < a.length; m += 512) {
          g = a.slice(m, m + 512);
          d = Array(g.length);
          for (e = 0; e < g.length; e++) d[e] = g.charCodeAt(e);
          g = new Uint8Array(d);
          h.push(g);
        }
        return new Blob(h, { type: f });
      }
      CKEDITOR.plugins.add('filetools', {
        beforeInit: function (b) {
          b.uploadRepository = new a(b);
          b.on(
            'fileUploadRequest',
            function (a) {
              var b = a.data.fileLoader;
              b.xhr.open('POST', b.uploadUrl, !0);
              a.data.requestData.upload = { file: b.file, name: b.fileName };
            },
            null,
            null,
            5,
          );
          b.on(
            'fileUploadRequest',
            function (a) {
              var f = a.data.fileLoader,
                h = new FormData();
              a = a.data.requestData;
              var g = b.config.fileTools_requestHeaders,
                d,
                e;
              for (e in a) {
                var n = a[e];
                'object' === typeof n && n.file ? h.append(e, n.file, n.name) : h.append(e, n);
              }
              h.append('ckCsrfToken', CKEDITOR.tools.getCsrfToken());
              if (g) for (d in g) f.xhr.setRequestHeader(d, g[d]);
              f.xhr.send(h);
            },
            null,
            null,
            999,
          );
          b.on(
            'fileUploadResponse',
            function (a) {
              var b = a.data.fileLoader,
                c = b.xhr,
                g = a.data;
              try {
                var d = JSON.parse(c.responseText);
                d.error && d.error.message && (g.message = d.error.message);
                if (d.uploaded) for (var e in d) g[e] = d[e];
                else a.cancel();
              } catch (f) {
                (g.message = b.lang.filetools.responseError),
                  CKEDITOR.warn('filetools-response-error', { responseText: c.responseText }),
                  a.cancel();
              }
            },
            null,
            null,
            999,
          );
        },
      });
      a.prototype = {
        create: function (a, b, f) {
          f = f || h;
          var m = this.loaders.length;
          a = new f(this.editor, a, b);
          a.id = m;
          this.loaders[m] = a;
          this.fire('instanceCreated', a);
          return a;
        },
        isFinished: function () {
          for (var a = 0; a < this.loaders.length; ++a) if (!this.loaders[a].isFinished()) return !1;
          return !0;
        },
      };
      h.prototype = {
        loadAndUpload: function (a, b) {
          var f = this;
          this.once(
            'loaded',
            function (h) {
              h.cancel();
              f.once(
                'update',
                function (a) {
                  a.cancel();
                },
                null,
                null,
                0,
              );
              f.upload(a, b);
            },
            null,
            null,
            0,
          );
          this.load();
        },
        load: function () {
          var a = this,
            b = (this.reader = new FileReader());
          a.changeStatus('loading');
          this.abort = function () {
            a.reader.abort();
          };
          b.onabort = function () {
            a.changeStatus('abort');
          };
          b.onerror = function () {
            a.message = a.lang.filetools.loadError;
            a.changeStatus('error');
          };
          b.onprogress = function (b) {
            a.loaded = b.loaded;
            a.update();
          };
          b.onload = function () {
            a.loaded = a.total;
            a.data = b.result;
            a.changeStatus('loaded');
          };
          b.readAsDataURL(this.file);
        },
        upload: function (a, b) {
          var f = b || {};
          a
            ? ((this.uploadUrl = a),
              (this.xhr = new XMLHttpRequest()),
              this.attachRequestListeners(),
              this.editor.fire('fileUploadRequest', { fileLoader: this, requestData: f }) && this.changeStatus('uploading'))
            : ((this.message = this.lang.filetools.noUrlError), this.changeStatus('error'));
        },
        attachRequestListeners: function () {
          function a() {
            'error' != f.status && ((f.message = f.lang.filetools.networkError), f.changeStatus('error'));
          }
          function b() {
            'abort' != f.status && f.changeStatus('abort');
          }
          var f = this,
            h = this.xhr;
          f.abort = function () {
            h.abort();
            b();
          };
          h.onerror = a;
          h.onabort = b;
          h.upload
            ? ((h.upload.onprogress = function (a) {
                a.lengthComputable && (f.uploadTotal || (f.uploadTotal = a.total), (f.uploaded = a.loaded), f.update());
              }),
              (h.upload.onerror = a),
              (h.upload.onabort = b))
            : ((f.uploadTotal = f.total), f.update());
          h.onload = function () {
            f.update();
            if ('abort' != f.status)
              if (((f.uploaded = f.uploadTotal), 200 > h.status || 299 < h.status))
                (f.message = f.lang.filetools['httpError' + h.status]),
                  f.message || (f.message = f.lang.filetools.httpError.replace('%1', h.status)),
                  f.changeStatus('error');
              else {
                for (
                  var a = { fileLoader: f }, b = ['message', 'fileName', 'url'], e = f.editor.fire('fileUploadResponse', a), c = 0;
                  c < b.length;
                  c++
                ) {
                  var l = b[c];
                  'string' === typeof a[l] && (f[l] = a[l]);
                }
                f.responseData = a;
                delete f.responseData.fileLoader;
                !1 === e ? f.changeStatus('error') : f.changeStatus('uploaded');
              }
          };
        },
        changeStatus: function (a) {
          this.status = a;
          if ('error' == a || 'abort' == a || 'loaded' == a || 'uploaded' == a) this.abort = function () {};
          this.fire(a);
          this.update();
        },
        update: function () {
          this.fire('update');
        },
        isFinished: function () {
          return !!this.status.match(/^(?:loaded|uploaded|error|abort)$/);
        },
      };
      CKEDITOR.event.implementOn(a.prototype);
      CKEDITOR.event.implementOn(h.prototype);
      var b = /^data:(\S*?);base64,/;
      CKEDITOR.fileTools || (CKEDITOR.fileTools = {});
      CKEDITOR.tools.extend(CKEDITOR.fileTools, {
        uploadRepository: a,
        fileLoader: h,
        getUploadUrl: function (a, b) {
          var f = CKEDITOR.tools.capitalize;
          return b && a[b + 'UploadUrl']
            ? a[b + 'UploadUrl']
            : a.uploadUrl
              ? a.uploadUrl
              : b && a['filebrowser' + f(b, 1) + 'UploadUrl']
                ? a['filebrowser' + f(b, 1) + 'UploadUrl'] + '\x26responseType\x3djson'
                : a.filebrowserUploadUrl
                  ? a.filebrowserUploadUrl + '\x26responseType\x3djson'
                  : null;
        },
        isTypeSupported: function (a, b) {
          return !!a.type.match(b);
        },
        isFileUploadSupported:
          'function' === typeof FileReader &&
          'function' === typeof new FileReader().readAsDataURL &&
          'function' === typeof FormData &&
          'function' === typeof new FormData().append &&
          'function' === typeof XMLHttpRequest &&
          'function' === typeof Blob,
      });
    })();
    (function () {
      function a(a, b) {
        var d = [];
        if (b) for (var e in b) d.push(e + '\x3d' + encodeURIComponent(b[e]));
        else return a;
        return a + (-1 != a.indexOf('?') ? '\x26' : '?') + d.join('\x26');
      }
      function h(b) {
        return !b.match(/command=QuickUpload/) || b.match(/(\?|&)responseType=json/) ? b : a(b, { responseType: 'json' });
      }
      function f(a) {
        a += '';
        return a.charAt(0).toUpperCase() + a.substr(1);
      }
      function b() {
        var b = this.getDialog(),
          d = b.getParentEditor();
        d._.filebrowserSe = this;
        var e = d.config['filebrowser' + f(b.getName()) + 'WindowWidth'] || d.config.filebrowserWindowWidth || '80%',
          b = d.config['filebrowser' + f(b.getName()) + 'WindowHeight'] || d.config.filebrowserWindowHeight || '70%',
          c = this.filebrowser.params || {};
        c.CKEditor = d.name;
        c.CKEditorFuncNum = d._.filebrowserFn;
        c.langCode || (c.langCode = d.langCode);
        c = a(this.filebrowser.url, c);
        d.popup(c, e, b, d.config.filebrowserWindowFeatures || d.config.fileBrowserWindowFeatures);
      }
      function c(a) {
        var b = new CKEDITOR.dom.element(a.$.form);
        b &&
          ((a = b.$.elements.ckCsrfToken)
            ? (a = new CKEDITOR.dom.element(a))
            : ((a = new CKEDITOR.dom.element('input')), a.setAttributes({ name: 'ckCsrfToken', type: 'hidden' }), b.append(a)),
          a.setAttribute('value', CKEDITOR.tools.getCsrfToken()));
      }
      function l() {
        var a = this.getDialog();
        a.getParentEditor()._.filebrowserSe = this;
        return a.getContentElement(this['for'][0], this['for'][1]).getInputElement().$.value &&
          a.getContentElement(this['for'][0], this['for'][1]).getAction()
          ? !0
          : !1;
      }
      function k(b, d, e) {
        var c = e.params || {};
        c.CKEditor = b.name;
        c.CKEditorFuncNum = b._.filebrowserFn;
        c.langCode || (c.langCode = b.langCode);
        d.action = a(e.url, c);
        d.filebrowser = e;
      }
      function m(a, d, x, u) {
        if (u && u.length)
          for (var p, t = u.length; t--; )
            if (((p = u[t]), ('hbox' != p.type && 'vbox' != p.type && 'fieldset' != p.type) || m(a, d, x, p.children), p.filebrowser))
              if (
                ('string' == typeof p.filebrowser &&
                  (p.filebrowser = { action: 'fileButton' == p.type ? 'QuickUpload' : 'Browse', target: p.filebrowser }),
                'Browse' == p.filebrowser.action)
              ) {
                var A = p.filebrowser.url;
                void 0 === A && ((A = a.config['filebrowser' + f(d) + 'BrowseUrl']), void 0 === A && (A = a.config.filebrowserBrowseUrl));
                A && ((p.onClick = b), (p.filebrowser.url = A), (p.hidden = !1));
              } else if (
                'QuickUpload' == p.filebrowser.action &&
                p['for'] &&
                ((A = p.filebrowser.url),
                void 0 === A && ((A = a.config['filebrowser' + f(d) + 'UploadUrl']), void 0 === A && (A = a.config.filebrowserUploadUrl)),
                A)
              ) {
                var q = p.onClick;
                p.onClick = function (b) {
                  var d = b.sender,
                    f = d.getDialog().getContentElement(this['for'][0], this['for'][1]).getInputElement(),
                    k = CKEDITOR.fileTools && CKEDITOR.fileTools.isFileUploadSupported;
                  if (q && !1 === q.call(d, b)) return !1;
                  if (l.call(d, b)) {
                    if ('form' !== a.config.filebrowserUploadMethod && k)
                      return (
                        (b = a.uploadRepository.create(f.$.files[0])),
                        b.on('uploaded', function (a) {
                          var b = a.sender.responseData;
                          e.call(a.sender.editor, b.url, b.message);
                        }),
                        b.on('error', g.bind(this)),
                        b.on('abort', g.bind(this)),
                        b.loadAndUpload(h(A)),
                        'xhr'
                      );
                    c(f);
                    return !0;
                  }
                  return !1;
                };
                p.filebrowser.url = A;
                p.hidden = !1;
                k(a, x.getContents(p['for'][0]).get(p['for'][1]), p.filebrowser);
              }
      }
      function g(a) {
        var b = {};
        try {
          b = JSON.parse(a.sender.xhr.response) || {};
        } catch (d) {}
        this.enable();
        alert(b.error ? b.error.message : a.sender.message);
      }
      function d(a, b, e) {
        if (-1 !== e.indexOf(';')) {
          e = e.split(';');
          for (var c = 0; c < e.length; c++) if (d(a, b, e[c])) return !0;
          return !1;
        }
        return (a = a.getContents(b).get(e).filebrowser) && a.url;
      }
      function e(a, b) {
        var d = this._.filebrowserSe.getDialog(),
          e = this._.filebrowserSe['for'],
          c = this._.filebrowserSe.filebrowser.onSelect;
        e && d.getContentElement(e[0], e[1]).reset();
        if ('function' != typeof b || !1 !== b.call(this._.filebrowserSe))
          if (!c || !1 !== c.call(this._.filebrowserSe, a, b))
            if (
              ('string' == typeof b && b && alert(b),
              a && ((e = this._.filebrowserSe), (d = e.getDialog()), (e = e.filebrowser.target || null)))
            )
              if (((e = e.split(':')), (c = d.getContentElement(e[0], e[1])))) c.setValue(a), d.selectPage(e[0]);
      }
      CKEDITOR.plugins.add('filebrowser', {
        requires: 'popup,filetools',
        init: function (a) {
          a._.filebrowserFn = CKEDITOR.tools.addFunction(e, a);
          a.on('destroy', function () {
            CKEDITOR.tools.removeFunction(this._.filebrowserFn);
          });
        },
      });
      CKEDITOR.on('dialogDefinition', function (a) {
        if (a.editor.plugins.filebrowser)
          for (var b = a.data.definition, e, c = 0; c < b.contents.length; ++c)
            if ((e = b.contents[c]))
              m(a.editor, a.data.name, b, e.elements), e.hidden && e.filebrowser && (e.hidden = !d(b, e.id, e.filebrowser));
      });
    })();
    CKEDITOR.plugins.add('find', {
      requires: 'dialog',
      init: function (a) {
        var h = a.addCommand('find', new CKEDITOR.dialogCommand('find')),
          f = a.addCommand('replace', new CKEDITOR.dialogCommand('find', { tabId: 'replace' }));
        h.canUndo = !1;
        h.readOnly = 1;
        f.canUndo = !1;
        a.ui.addButton &&
          (a.ui.addButton('Find', { label: a.lang.find.find, command: 'find', toolbar: 'find,10' }),
          a.ui.addButton('Replace', { label: a.lang.find.replace, command: 'replace', toolbar: 'find,20' }));
        CKEDITOR.dialog.add('find', this.path + 'dialogs/find.js');
      },
    });
    CKEDITOR.config.find_highlight = { element: 'span', styles: { 'background-color': '#004', color: '#fff' } };
    (function () {
      function a(a) {
        var c = a.config,
          l = a.fire('uiSpace', { space: 'top', html: '' }).html,
          k = (function () {
            function d(a, b, e) {
              g.setStyle(b, f(e));
              g.setStyle('position', a);
            }
            function e(a) {
              var b = l.getDocumentPosition();
              switch (a) {
                case 'top':
                  d('absolute', 'top', b.y - q - y);
                  break;
                case 'pin':
                  d('fixed', 'top', C);
                  break;
                case 'bottom':
                  d('absolute', 'top', b.y + (t.height || t.bottom - t.top) + y);
              }
              m = a;
            }
            var m,
              l,
              p,
              t,
              A,
              q,
              B,
              z = c.floatSpaceDockedOffsetX || 0,
              y = c.floatSpaceDockedOffsetY || 0,
              v = c.floatSpacePinnedOffsetX || 0,
              C = c.floatSpacePinnedOffsetY || 0;
            return function (d) {
              if ((l = a.editable())) {
                var n = d && 'focus' == d.name;
                n && g.show();
                a.fire('floatingSpaceLayout', { show: n });
                g.removeStyle('left');
                g.removeStyle('right');
                p = g.getClientRect();
                t = l.getClientRect();
                A = h.getViewPaneSize();
                q = p.height;
                B = 'pageXOffset' in h.$ ? h.$.pageXOffset : CKEDITOR.document.$.documentElement.scrollLeft;
                m
                  ? (q + y <= t.top ? e('top') : q + y > A.height - t.bottom ? e('pin') : e('bottom'),
                    (d = A.width / 2),
                    (d = c.floatSpacePreferRight
                      ? 'right'
                      : 0 < t.left && t.right < A.width && t.width > p.width
                        ? 'rtl' == c.contentsLangDirection
                          ? 'right'
                          : 'left'
                        : d - t.left > t.right - d
                          ? 'left'
                          : 'right'),
                    p.width > A.width
                      ? ((d = 'left'), (n = 0))
                      : ((n = 'left' == d ? (0 < t.left ? t.left : 0) : t.right < A.width ? A.width - t.right : 0),
                        n + p.width > A.width && ((d = 'left' == d ? 'right' : 'left'), (n = 0))),
                    g.setStyle(d, f(('pin' == m ? v : z) + n + ('pin' == m ? 0 : 'left' == d ? B : -B))))
                  : ((m = 'pin'), e('pin'), k(d));
              }
            };
          })();
        if (l) {
          var m = new CKEDITOR.template(
              '\x3cdiv id\x3d"cke_{name}" class\x3d"cke {id} cke_reset_all cke_chrome cke_editor_{name} cke_float cke_{langDir} ' +
                CKEDITOR.env.cssClass +
                '" dir\x3d"{langDir}" title\x3d"' +
                (CKEDITOR.env.gecko ? ' ' : '') +
                '" lang\x3d"{langCode}" role\x3d"application" style\x3d"{style}"' +
                (a.applicationTitle ? ' aria-labelledby\x3d"cke_{name}_arialbl"' : ' ') +
                '\x3e' +
                (a.applicationTitle ? '\x3cspan id\x3d"cke_{name}_arialbl" class\x3d"cke_voice_label"\x3e{voiceLabel}\x3c/span\x3e' : ' ') +
                '\x3cdiv class\x3d"cke_inner"\x3e\x3cdiv id\x3d"{topId}" class\x3d"cke_top" role\x3d"presentation"\x3e{content}\x3c/div\x3e\x3c/div\x3e\x3c/div\x3e',
            ),
            g = CKEDITOR.document.getBody().append(
              CKEDITOR.dom.element.createFromHtml(
                m.output({
                  content: l,
                  id: a.id,
                  langDir: a.lang.dir,
                  langCode: a.langCode,
                  name: a.name,
                  style: 'display:none;z-index:' + (c.baseFloatZIndex - 1),
                  topId: a.ui.spaceId('top'),
                  voiceLabel: a.applicationTitle,
                }),
              ),
            ),
            d = CKEDITOR.tools.eventsBuffer(500, k),
            e = CKEDITOR.tools.eventsBuffer(100, k);
          g.unselectable();
          g.on('mousedown', function (a) {
            a = a.data;
            a.getTarget().hasAscendant('a', 1) || a.preventDefault();
          });
          a.on('focus', function (c) {
            k(c);
            a.on('change', d.input);
            h.on('scroll', e.input);
            h.on('resize', e.input);
          });
          a.on('blur', function () {
            g.hide();
            a.removeListener('change', d.input);
            h.removeListener('scroll', e.input);
            h.removeListener('resize', e.input);
          });
          a.on('destroy', function () {
            h.removeListener('scroll', e.input);
            h.removeListener('resize', e.input);
            g.clearCustomData();
            g.remove();
          });
          a.focusManager.hasFocus && g.show();
          a.focusManager.add(g, 1);
        }
      }
      var h = CKEDITOR.document.getWindow(),
        f = CKEDITOR.tools.cssLength;
      CKEDITOR.plugins.add('floatingspace', {
        init: function (b) {
          b.on(
            'loaded',
            function () {
              a(this);
            },
            null,
            null,
            20,
          );
        },
      });
    })();
    CKEDITOR.plugins.add('listblock', {
      requires: 'panel',
      onLoad: function () {
        var a = CKEDITOR.addTemplate('panel-list', '\x3cul role\x3d"presentation" class\x3d"cke_panel_list"\x3e{items}\x3c/ul\x3e'),
          h = CKEDITOR.addTemplate(
            'panel-list-item',
            '\x3cli id\x3d"{id}" class\x3d"cke_panel_listItem" role\x3dpresentation\x3e\x3ca id\x3d"{id}_option" _cke_focus\x3d1 hidefocus\x3dtrue title\x3d"{title}" draggable\x3d"false" ondragstart\x3d"return false;" href\x3d"javascript:void(\'{val}\')"  onclick\x3d"{onclick}CKEDITOR.tools.callFunction({clickFn},\'{val}\'); return false;" role\x3d"option"\x3e{text}\x3c/a\x3e\x3c/li\x3e',
          ),
          f = CKEDITOR.addTemplate(
            'panel-list-group',
            '\x3ch1 id\x3d"{id}" draggable\x3d"false" ondragstart\x3d"return false;" class\x3d"cke_panel_grouptitle" role\x3d"presentation" \x3e{label}\x3c/h1\x3e',
          ),
          b = /\'/g;
        CKEDITOR.ui.panel.prototype.addListBlock = function (a, b) {
          return this.addBlock(a, new CKEDITOR.ui.listBlock(this.getHolderElement(), b));
        };
        CKEDITOR.ui.listBlock = CKEDITOR.tools.createClass({
          base: CKEDITOR.ui.panel.block,
          $: function (a, b) {
            b = b || {};
            var f = b.attributes || (b.attributes = {});
            (this.multiSelect = !!b.multiSelect) && (f['aria-multiselectable'] = !0);
            !f.role && (f.role = 'listbox');
            this.base.apply(this, arguments);
            this.element.setAttribute('role', f.role);
            f = this.keys;
            f[40] = 'next';
            f[9] = 'next';
            f[38] = 'prev';
            f[CKEDITOR.SHIFT + 9] = 'prev';
            f[32] = CKEDITOR.env.ie ? 'mouseup' : 'click';
            CKEDITOR.env.ie && (f[13] = 'mouseup');
            this._.pendingHtml = [];
            this._.pendingList = [];
            this._.items = {};
            this._.groups = {};
          },
          _: {
            close: function () {
              if (this._.started) {
                var b = a.output({ items: this._.pendingList.join('') });
                this._.pendingList = [];
                this._.pendingHtml.push(b);
                delete this._.started;
              }
            },
            getClick: function () {
              this._.click ||
                (this._.click = CKEDITOR.tools.addFunction(function (a) {
                  var b = this.toggle(a);
                  if (this.onClick) this.onClick(a, b);
                }, this));
              return this._.click;
            },
          },
          proto: {
            add: function (a, f, k) {
              var m = CKEDITOR.tools.getNextId();
              this._.started || ((this._.started = 1), (this._.size = this._.size || 0));
              this._.items[a] = m;
              var g;
              g = CKEDITOR.tools.htmlEncodeAttr(a).replace(b, "\\'");
              a = {
                id: m,
                val: g,
                onclick: CKEDITOR.env.ie
                  ? 'return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26'
                  : '',
                clickFn: this._.getClick(),
                title: CKEDITOR.tools.htmlEncodeAttr(k || a),
                text: f || a,
              };
              this._.pendingList.push(h.output(a));
            },
            startGroup: function (a) {
              this._.close();
              var b = CKEDITOR.tools.getNextId();
              this._.groups[a] = b;
              this._.pendingHtml.push(f.output({ id: b, label: a }));
            },
            commit: function () {
              this._.close();
              this.element.appendHtml(this._.pendingHtml.join(''));
              delete this._.size;
              this._.pendingHtml = [];
            },
            toggle: function (a) {
              var b = this.isMarked(a);
              b ? this.unmark(a) : this.mark(a);
              return !b;
            },
            hideGroup: function (a) {
              var b = (a = this.element.getDocument().getById(this._.groups[a])) && a.getNext();
              a && (a.setStyle('display', 'none'), b && 'ul' == b.getName() && b.setStyle('display', 'none'));
            },
            hideItem: function (a) {
              this.element.getDocument().getById(this._.items[a]).setStyle('display', 'none');
            },
            showAll: function () {
              var a = this._.items,
                b = this._.groups,
                f = this.element.getDocument(),
                h;
              for (h in a) f.getById(a[h]).setStyle('display', '');
              for (var g in b)
                (a = f.getById(b[g])), (h = a.getNext()), a.setStyle('display', ''), h && 'ul' == h.getName() && h.setStyle('display', '');
            },
            mark: function (a) {
              this.multiSelect || this.unmarkAll();
              a = this._.items[a];
              var b = this.element.getDocument().getById(a);
              b.addClass('cke_selected');
              this.element
                .getDocument()
                .getById(a + '_option')
                .setAttribute('aria-selected', !0);
              this.onMark && this.onMark(b);
            },
            markFirstDisplayed: function () {
              var a = this;
              this._.markFirstDisplayed(function () {
                a.multiSelect || a.unmarkAll();
              });
            },
            unmark: function (a) {
              var b = this.element.getDocument();
              a = this._.items[a];
              var f = b.getById(a);
              f.removeClass('cke_selected');
              b.getById(a + '_option').removeAttribute('aria-selected');
              this.onUnmark && this.onUnmark(f);
            },
            unmarkAll: function () {
              var a = this._.items,
                b = this.element.getDocument(),
                f;
              for (f in a) {
                var h = a[f];
                b.getById(h).removeClass('cke_selected');
                b.getById(h + '_option').removeAttribute('aria-selected');
              }
              this.onUnmark && this.onUnmark();
            },
            isMarked: function (a) {
              return this.element.getDocument().getById(this._.items[a]).hasClass('cke_selected');
            },
            focus: function (a) {
              this._.focusIndex = -1;
              var b = this.element.getElementsByTag('a'),
                f,
                h = -1;
              if (a)
                for (f = this.element.getDocument().getById(this._.items[a]).getFirst(); (a = b.getItem(++h)); ) {
                  if (a.equals(f)) {
                    this._.focusIndex = h;
                    break;
                  }
                }
              else this.element.focus();
              f &&
                setTimeout(function () {
                  f.focus();
                }, 0);
            },
          },
        });
      },
    });
    CKEDITOR.plugins.add('richcombo', {
      requires: 'floatpanel,listblock,button',
      beforeInit: function (a) {
        a.ui.addHandler(CKEDITOR.UI_RICHCOMBO, CKEDITOR.ui.richCombo.handler);
      },
    });
    (function () {
      var a =
          '\x3cspan id\x3d"{id}" class\x3d"cke_combo cke_combo__{name} {cls}" role\x3d"presentation"\x3e\x3cspan id\x3d"{id}_label" class\x3d"cke_combo_label"\x3e{label}\x3c/span\x3e\x3ca class\x3d"cke_combo_button" title\x3d"{title}" tabindex\x3d"-1"' +
          (CKEDITOR.env.gecko && !CKEDITOR.env.hc ? '' : ' href\x3d"javascript:void(\'{titleJs}\')"') +
          ' hidefocus\x3d"true" role\x3d"button" aria-labelledby\x3d"{id}_label" aria-haspopup\x3d"listbox"',
        h = '';
      CKEDITOR.env.gecko && CKEDITOR.env.mac && (a += ' onkeypress\x3d"return false;"');
      CKEDITOR.env.gecko && (a += ' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');
      CKEDITOR.env.ie &&
        (h = 'return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26');
      var a =
          a +
          (' onkeydown\x3d"return CKEDITOR.tools.callFunction({keydownFn},event,this);" onfocus\x3d"return CKEDITOR.tools.callFunction({focusFn},event);" onclick\x3d"' +
            h +
            'CKEDITOR.tools.callFunction({clickFn},this);return false;"\x3e\x3cspan id\x3d"{id}_text" class\x3d"cke_combo_text cke_combo_inlinelabel"\x3e{label}\x3c/span\x3e\x3cspan class\x3d"cke_combo_open"\x3e\x3cspan class\x3d"cke_combo_arrow"\x3e' +
            (CKEDITOR.env.hc ? '\x26#9660;' : CKEDITOR.env.air ? '\x26nbsp;' : '') +
            '\x3c/span\x3e\x3c/span\x3e\x3c/a\x3e\x3c/span\x3e'),
        f = CKEDITOR.addTemplate('combo', a);
      CKEDITOR.UI_RICHCOMBO = 'richcombo';
      CKEDITOR.ui.richCombo = CKEDITOR.tools.createClass({
        $: function (a) {
          CKEDITOR.tools.extend(this, a, { canGroup: !1, title: a.label, modes: { wysiwyg: 1 }, editorFocus: 1 });
          a = this.panel || {};
          delete this.panel;
          this.id = CKEDITOR.tools.getNextNumber();
          this.document = (a.parent && a.parent.getDocument()) || CKEDITOR.document;
          a.className = 'cke_combopanel';
          a.block = { multiSelect: a.multiSelect, attributes: a.attributes };
          a.toolbarRelated = !0;
          this._ = { panelDefinition: a, items: {}, listeners: [] };
        },
        proto: {
          renderHtml: function (a) {
            var c = [];
            this.render(a, c);
            return c.join('');
          },
          render: function (a, c) {
            function h() {
              if (this.getState() != CKEDITOR.TRISTATE_ON) {
                var d = this.modes[a.mode] ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED;
                a.readOnly && !this.readOnly && (d = CKEDITOR.TRISTATE_DISABLED);
                this.setState(d);
                this.setValue('');
                d != CKEDITOR.TRISTATE_DISABLED && this.refresh && this.refresh();
              }
            }
            var k = CKEDITOR.env,
              m,
              g,
              d = 'cke_' + this.id,
              e = CKEDITOR.tools.addFunction(function (d) {
                g && (a.unlockSelection(1), (g = 0));
                m.execute(d);
              }, this),
              n = this;
            m = {
              id: d,
              combo: this,
              focus: function () {
                CKEDITOR.document.getById(d).getChild(1).focus();
              },
              execute: function (d) {
                var e = n._;
                if (e.state != CKEDITOR.TRISTATE_DISABLED)
                  if ((n.createPanel(a), e.on)) e.panel.hide();
                  else {
                    n.commit();
                    var c = n.getValue();
                    c ? e.list.mark(c) : e.list.unmarkAll();
                    e.panel.showBlock(n.id, new CKEDITOR.dom.element(d), 4);
                  }
              },
              clickFn: e,
            };
            this._.listeners.push(a.on('activeFilterChange', h, this));
            this._.listeners.push(a.on('mode', h, this));
            this._.listeners.push(a.on('selectionChange', h, this));
            !this.readOnly && this._.listeners.push(a.on('readOnly', h, this));
            var r = CKEDITOR.tools.addFunction(function (a, b) {
                a = new CKEDITOR.dom.event(a);
                var d = a.getKeystroke();
                switch (d) {
                  case 13:
                  case 32:
                  case 40:
                    CKEDITOR.tools.callFunction(e, b);
                    break;
                  default:
                    m.onkey(m, d);
                }
                a.preventDefault();
              }),
              x = CKEDITOR.tools.addFunction(function () {
                m.onfocus && m.onfocus();
              });
            g = 0;
            m.keyDownFn = r;
            k = {
              id: d,
              name: this.name || this.command,
              label: this.label,
              title: this.title,
              cls: this.className || '',
              titleJs: k.gecko && !k.hc ? '' : (this.title || '').replace("'", ''),
              keydownFn: r,
              focusFn: x,
              clickFn: e,
            };
            f.output(k, c);
            if (this.onRender) this.onRender();
            return m;
          },
          createPanel: function (a) {
            if (!this._.panel) {
              var c = this._.panelDefinition,
                f = this._.panelDefinition.block,
                h = c.parent || CKEDITOR.document.getBody(),
                m = 'cke_combopanel__' + this.name,
                g = new CKEDITOR.ui.floatPanel(a, h, c),
                c = g.addListBlock(this.id, f),
                d = this;
              g.onShow = function () {
                this.element.addClass(m);
                d.setState(CKEDITOR.TRISTATE_ON);
                d._.on = 1;
                d.editorFocus && !a.focusManager.hasFocus && a.focus();
                if (d.onOpen) d.onOpen();
              };
              g.onHide = function (e) {
                this.element.removeClass(m);
                d.setState(d.modes && d.modes[a.mode] ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
                d._.on = 0;
                if (!e && d.onClose) d.onClose();
              };
              g.onEscape = function () {
                g.hide(1);
              };
              c.onClick = function (a, b) {
                d.onClick && d.onClick.call(d, a, b);
                g.hide();
              };
              this._.panel = g;
              this._.list = c;
              g.getBlock(this.id).onHide = function () {
                d._.on = 0;
                d.setState(CKEDITOR.TRISTATE_OFF);
              };
              this.init && this.init();
            }
          },
          setValue: function (a, c) {
            this._.value = a;
            var f = this.document.getById('cke_' + this.id + '_text');
            f &&
              (a || c ? f.removeClass('cke_combo_inlinelabel') : ((c = this.label), f.addClass('cke_combo_inlinelabel')),
              f.setText('undefined' != typeof c ? c : a));
            var f = 'undefined' != typeof c ? c : a,
              h = this.label,
              f = f === h ? f : f + ', ' + h;
            (h = this.document.getById('cke_' + this.id + '_label')) && h.setText(f);
          },
          getValue: function () {
            return this._.value || '';
          },
          unmarkAll: function () {
            this._.list.unmarkAll();
          },
          mark: function (a) {
            this._.list.mark(a);
          },
          hideItem: function (a) {
            this._.list.hideItem(a);
          },
          hideGroup: function (a) {
            this._.list.hideGroup(a);
          },
          showAll: function () {
            this._.list.showAll();
          },
          add: function (a, c, f) {
            this._.items[a] = f || a;
            this._.list.add(a, c, f);
          },
          startGroup: function (a) {
            this._.list.startGroup(a);
          },
          commit: function () {
            this._.committed || (this._.list.commit(), (this._.committed = 1), CKEDITOR.ui.fire('ready', this));
            this._.committed = 1;
          },
          setState: function (a) {
            if (this._.state != a) {
              var c = this.document.getById('cke_' + this.id),
                f = c.getElementsByTag('a').getItem(0);
              c.setState(a, 'cke_combo');
              a == CKEDITOR.TRISTATE_DISABLED ? c.setAttribute('aria-disabled', !0) : c.removeAttribute('aria-disabled');
              f && f.setAttribute('aria-expanded', a == CKEDITOR.TRISTATE_ON);
              this._.state = a;
            }
          },
          getState: function () {
            return this._.state;
          },
          enable: function () {
            this._.state == CKEDITOR.TRISTATE_DISABLED && this.setState(this._.lastState);
          },
          disable: function () {
            this._.state != CKEDITOR.TRISTATE_DISABLED && ((this._.lastState = this._.state), this.setState(CKEDITOR.TRISTATE_DISABLED));
          },
          destroy: function () {
            CKEDITOR.tools.array.forEach(this._.listeners, function (a) {
              a.removeListener();
            });
            this._.listeners = [];
          },
          select: function (a) {
            if (!CKEDITOR.tools.isEmpty(this._.items))
              for (var c in this._.items)
                if (a({ value: c, text: this._.items[c] })) {
                  this.setValue(c);
                  break;
                }
          },
        },
        statics: {
          handler: {
            create: function (a) {
              return new CKEDITOR.ui.richCombo(a);
            },
          },
        },
      });
      CKEDITOR.ui.prototype.addRichCombo = function (a, c) {
        this.add(a, CKEDITOR.UI_RICHCOMBO, c);
      };
    })();
    (function () {
      function a(a, b) {
        var m = a.config,
          g = b.lang,
          d = new CKEDITOR.style(b.styleDefinition),
          e = new c({ entries: b.entries, styleVariable: b.styleVariable, styleDefinition: b.styleDefinition }),
          n;
        a.addCommand(b.commandName, {
          exec: function (a, b) {
            var d = b.newStyle,
              e = b.oldStyle,
              c = a.getSelection().getRanges()[0],
              g = void 0 === d;
            if (e || d)
              e && c.collapsed && f({ editor: a, range: c, style: e }),
                g ? a.removeStyle(e) : (e && !h(e, d) && a.removeStyle(e), a.applyStyle(d));
          },
          refresh: function (a, b) {
            d.checkApplicable(b, a, a.activeFilter) || this.setState(CKEDITOR.TRISTATE_DISABLED);
          },
        });
        n = a.getCommand(b.commandName);
        a.ui.addRichCombo(b.comboName, {
          label: g.label,
          title: g.panelTitle,
          command: b.commandName,
          toolbar: 'styles,' + b.order,
          defaultValue: 'cke-default',
          allowedContent: d,
          requiredContent: d,
          contentTransformations:
            'span' === b.styleDefinition.element
              ? [
                  [
                    {
                      element: 'font',
                      check: 'span',
                      left: function (a) {
                        return !!a.attributes.size || !!a.attributes.align || !!a.attributes.face;
                      },
                      right: function (a) {
                        var b = ' x-small small medium large x-large xx-large 48px'.split(' ');
                        a.name = 'span';
                        a.attributes.size && ((a.styles['font-size'] = b[a.attributes.size]), delete a.attributes.size);
                        a.attributes.align && ((a.styles['text-align'] = a.attributes.align), delete a.attributes.align);
                        a.attributes.face && ((a.styles['font-family'] = a.attributes.face), delete a.attributes.face);
                      },
                    },
                  ],
                ]
              : null,
          panel: {
            css: [CKEDITOR.skin.getPath('editor')].concat(m.contentsCss),
            multiSelect: !1,
            attributes: { 'aria-label': g.panelTitle },
          },
          init: function () {
            var b = '(' + a.lang.common.optionDefault + ')';
            this.startGroup(g.panelTitle);
            this.add(this.defaultValue, b, b);
            e.addToCombo(this);
          },
          onClick: function (d) {
            var c = this.getValue();
            a.focus();
            a.fire('saveSnapshot');
            a.execCommand(b.commandName, { newStyle: e.getStyle(d), oldStyle: e.getStyle(c) });
            a.fire('saveSnapshot');
          },
          onRender: function () {
            a.on(
              'selectionChange',
              function (d) {
                var c = this.getValue();
                (d = e.getMatchingValue(a, d.data.path)) ? d != c && this.setValue(d) : this.setValue('', b.defaultLabel);
              },
              this,
            );
            n.on(
              'state',
              function () {
                this.setState(n.state);
              },
              this,
            );
          },
          refresh: function () {
            this.setState(n.state);
          },
        });
      }
      function h(a, b) {
        if (!(a instanceof CKEDITOR.style && b instanceof CKEDITOR.style)) return !1;
        var c = (function (a, b) {
            var c = a.getDefinition().attributes,
              g = b.getDefinition().attributes;
            return CKEDITOR.tools.objectCompare(c, g);
          })(a, b),
          g = (function (a, b) {
            return CKEDITOR.style.getStyleText(a.getDefinition()) === CKEDITOR.style.getStyleText(b.getDefinition());
          })(a, b);
        return c && g;
      }
      function f(a) {
        var c = a.editor,
          f = a.range,
          g = a.style,
          d,
          e,
          h;
        d = c.elementPath();
        if (
          (a = d.contains(function (a) {
            return g.checkElementRemovable(a);
          }))
        ) {
          e = f.checkBoundaryOfElement(a, CKEDITOR.START);
          h = f.checkBoundaryOfElement(a, CKEDITOR.END);
          if (e && h) {
            for (e = f.createBookmark(); (d = a.getFirst()); ) d.insertBefore(a);
            a.remove();
            f.moveToBookmark(e);
          } else
            e || h
              ? f.moveToPosition(a, e ? CKEDITOR.POSITION_BEFORE_START : CKEDITOR.POSITION_AFTER_END)
              : (f.splitElement(a), f.moveToPosition(a, CKEDITOR.POSITION_AFTER_END)),
              b(f, d.elements.slice(), a);
          c.getSelection().selectRanges([f]);
        }
      }
      function b(a, c, f) {
        var g = c.pop();
        if (g) {
          if (f) return b(a, c, g.equals(f) ? null : f);
          f = g.clone();
          a.insertNode(f);
          a.moveToPosition(f, CKEDITOR.POSITION_AFTER_START);
          b(a, c);
        }
      }
      var c = CKEDITOR.tools.createClass({
        $: function (a) {
          var b = a.entries.split(';');
          this._.data = {};
          this._.names = [];
          for (var c = 0; c < b.length; c++) {
            var g = b[c],
              d,
              e;
            g
              ? ((g = g.split('/')),
                (d = g[0]),
                (g = g[1]),
                (e = {}),
                (e[a.styleVariable] = g || d),
                (this._.data[d] = new CKEDITOR.style(a.styleDefinition, e)),
                (this._.data[d]._.definition.name = d),
                this._.names.push(d))
              : (b.splice(c, 1), c--);
          }
        },
        proto: {
          getStyle: function (a) {
            return this._.data[a];
          },
          addToCombo: function (a) {
            for (var b = 0; b < this._.names.length; b++) {
              var c = this._.names[b];
              a.add(c, this.getStyle(c).buildPreview(), c);
            }
          },
          getMatchingValue: function (a, b) {
            for (var c = b.elements, g = 0, d; g < c.length; g++) if (((d = c[g]), (d = this._.findMatchingStyleName(a, d)))) return d;
            return null;
          },
        },
        _: {
          findMatchingStyleName: function (a, b) {
            return CKEDITOR.tools.array.find(
              this._.names,
              function (c) {
                return this.getStyle(c).checkElementMatch(b, !0, a);
              },
              this,
            );
          },
        },
      });
      CKEDITOR.plugins.add('font', {
        requires: 'richcombo',
        init: function (b) {
          var c = b.config;
          a(b, {
            comboName: 'Font',
            commandName: 'font',
            styleVariable: 'family',
            lang: b.lang.font,
            entries: c.font_names,
            defaultLabel: c.font_defaultLabel,
            styleDefinition: c.font_style,
            order: 30,
          });
          a(b, {
            comboName: 'FontSize',
            commandName: 'fontSize',
            styleVariable: 'size',
            lang: b.lang.font.fontSize,
            entries: c.fontSize_sizes,
            defaultLabel: c.fontSize_defaultLabel,
            styleDefinition: c.fontSize_style,
            order: 40,
          });
        },
      });
    })();
    CKEDITOR.config.font_names =
      'Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif';
    CKEDITOR.config.font_defaultLabel = '';
    CKEDITOR.config.font_style = {
      element: 'span',
      styles: { 'font-family': '#(family)' },
      overrides: [{ element: 'font', attributes: { face: null } }],
    };
    CKEDITOR.config.fontSize_sizes =
      '8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;48/48px;72/72px';
    CKEDITOR.config.fontSize_defaultLabel = '';
    CKEDITOR.config.fontSize_style = {
      element: 'span',
      styles: { 'font-size': '#(size)' },
      overrides: [{ element: 'font', attributes: { size: null } }],
    };
    CKEDITOR.plugins.add('format', {
      requires: 'richcombo',
      init: function (a) {
        if (!a.blockless) {
          for (var h = a.config, f = a.lang.format, b = h.format_tags.split(';'), c = {}, l = 0, k = [], m = 0; m < b.length; m++) {
            var g = b[m],
              d = new CKEDITOR.style(h['format_' + g]);
            if (!a.filter.customConfig || a.filter.check(d)) l++, (c[g] = d), (c[g]._.enterMode = a.config.enterMode), k.push(d);
          }
          0 !== l &&
            a.ui.addRichCombo('Format', {
              label: f.label,
              title: f.panelTitle,
              toolbar: 'styles,20',
              allowedContent: k,
              panel: {
                css: [CKEDITOR.skin.getPath('editor')].concat(h.contentsCss),
                multiSelect: !1,
                attributes: { 'aria-label': f.panelTitle },
              },
              init: function () {
                this.startGroup(f.panelTitle);
                for (var a in c) {
                  var b = f['tag_' + a];
                  this.add(a, c[a].buildPreview(b), b);
                }
              },
              onClick: function (b) {
                a.focus();
                a.fire('saveSnapshot');
                b = c[b];
                var d = a.elementPath();
                a.fire('stylesRemove', { type: CKEDITOR.STYLE_BLOCK });
                b.checkActive(d, a) || a.applyStyle(b);
                setTimeout(function () {
                  a.fire('saveSnapshot');
                }, 0);
              },
              onRender: function () {
                a.on(
                  'selectionChange',
                  function (b) {
                    var d = this.getValue();
                    b = b.data.path;
                    this.refresh();
                    for (var g in c)
                      if (c[g].checkActive(b, a)) {
                        g != d && this.setValue(g, a.lang.format['tag_' + g]);
                        return;
                      }
                    this.setValue('');
                  },
                  this,
                );
              },
              onOpen: function () {
                this.showAll();
                for (var b in c) a.activeFilter.check(c[b]) || this.hideItem(b);
              },
              refresh: function () {
                var b = a.elementPath();
                if (b) {
                  if (b.isContextFor('p')) for (var d in c) if (a.activeFilter.check(c[d])) return;
                  this.setState(CKEDITOR.TRISTATE_DISABLED);
                }
              },
            });
        }
      },
    });
    CKEDITOR.config.format_tags = 'p;h1;h2;h3;h4;h5;h6;pre;address;div';
    CKEDITOR.config.format_p = { element: 'p' };
    CKEDITOR.config.format_div = { element: 'div' };
    CKEDITOR.config.format_pre = { element: 'pre' };
    CKEDITOR.config.format_address = { element: 'address' };
    CKEDITOR.config.format_h1 = { element: 'h1' };
    CKEDITOR.config.format_h2 = { element: 'h2' };
    CKEDITOR.config.format_h3 = { element: 'h3' };
    CKEDITOR.config.format_h4 = { element: 'h4' };
    CKEDITOR.config.format_h5 = { element: 'h5' };
    CKEDITOR.config.format_h6 = { element: 'h6' };
    (function () {
      function a(a, b) {
        var c = l.exec(a),
          d = l.exec(b);
        if (c) {
          if (!c[2] && 'px' == d[2]) return d[1];
          if ('px' == c[2] && !d[2]) return d[1] + 'px';
        }
        return b;
      }
      function h(c) {
        return {
          elements: {
            $: function (h) {
              var g = h.attributes,
                g = g && g['data-cke-realelement'],
                d = f(c, decodeURIComponent(g));
              if ((g = (g = g && new CKEDITOR.htmlParser.fragment.fromHtml(d)) && g.children[0]) && h.attributes['data-cke-resizable']) {
                var e = new b(h).rules;
                h = g.attributes;
                d = e.width;
                e = e.height;
                d && (h.width = a(h.width, d));
                e && (h.height = a(h.height, e));
              }
              return g;
            },
          },
        };
      }
      function f(a, b) {
        var c = [],
          d = /^cke:/i,
          e = new CKEDITOR.htmlParser.filter({
            elements: {
              '^': function (a) {
                d.test(a.name) && ((a.name = a.name.replace(d, '')), c.push(a));
              },
              iframe: function (a) {
                a.children = [];
              },
            },
          }),
          f = a.activeFilter,
          h = new CKEDITOR.htmlParser.basicWriter(),
          l = CKEDITOR.htmlParser.fragment.fromHtml(b);
        e.applyTo(l);
        f.applyTo(l);
        CKEDITOR.tools.array.forEach(c, function (a) {
          a.name = 'cke:' + a.name;
        });
        l.writeHtml(h);
        return h.getHtml();
      }
      var b = CKEDITOR.htmlParser.cssStyle,
        c = CKEDITOR.tools.cssLength,
        l = /^((?:\d*(?:\.\d+))|(?:\d+))(.*)?$/i;
      CKEDITOR.plugins.add('fakeobjects', {
        init: function (a) {
          a.filter.allow('img[!data-cke-realelement,src,alt,title](*){*}', 'fakeobjects');
        },
        afterInit: function (a) {
          var b = a.dataProcessor;
          (b = b && b.htmlFilter) && b.addRules(h(a), { applyToAll: !0 });
        },
      });
      CKEDITOR.editor.prototype.createFakeElement = function (a, f, g, d) {
        var e = this.lang.fakeobjects,
          e = e[g] || e.unknown;
        f = {
          class: f,
          'data-cke-realelement': encodeURIComponent(a.getOuterHtml()),
          'data-cke-real-node-type': a.type,
          alt: e,
          title: e,
          align: a.getAttribute('align') || '',
        };
        CKEDITOR.env.hc || (f.src = CKEDITOR.tools.transparentImageData);
        g && (f['data-cke-real-element-type'] = g);
        d &&
          ((f['data-cke-resizable'] = d),
          (g = new b()),
          (d = a.getAttribute('width')),
          (a = a.getAttribute('height')),
          d && (g.rules.width = c(d)),
          a && (g.rules.height = c(a)),
          g.populate(f));
        return this.document.createElement('img', { attributes: f });
      };
      CKEDITOR.editor.prototype.createFakeParserElement = function (a, f, g, d) {
        var e = this.lang.fakeobjects,
          e = e[g] || e.unknown,
          h;
        h = new CKEDITOR.htmlParser.basicWriter();
        a.writeHtml(h);
        h = h.getHtml();
        f = {
          class: f,
          'data-cke-realelement': encodeURIComponent(h),
          'data-cke-real-node-type': a.type,
          alt: e,
          title: e,
          align: a.attributes.align || '',
        };
        CKEDITOR.env.hc || (f.src = CKEDITOR.tools.transparentImageData);
        g && (f['data-cke-real-element-type'] = g);
        d &&
          ((f['data-cke-resizable'] = d),
          (d = a.attributes),
          (a = new b()),
          (g = d.width),
          (d = d.height),
          void 0 !== g && (a.rules.width = c(g)),
          void 0 !== d && (a.rules.height = c(d)),
          a.populate(f));
        return new CKEDITOR.htmlParser.element('img', f);
      };
      CKEDITOR.editor.prototype.restoreRealElement = function (b) {
        if (b.data('cke-real-node-type') != CKEDITOR.NODE_ELEMENT) return null;
        var c = decodeURIComponent(b.data('cke-realelement')),
          c = f(this, c),
          c = CKEDITOR.dom.element.createFromHtml(c, this.document);
        if (b.data('cke-resizable')) {
          var g = b.getStyle('width');
          b = b.getStyle('height');
          g && c.setAttribute('width', a(c.getAttribute('width'), g));
          b && c.setAttribute('height', a(c.getAttribute('height'), b));
        }
        return c;
      };
    })();
    CKEDITOR.plugins.add('forms', {
      requires: 'dialog,fakeobjects',
      onLoad: function () {
        CKEDITOR.addCss('.cke_editable form{border: 1px dotted #FF0000;padding: 2px;}\n');
        CKEDITOR.addCss(
          'img.cke_hidden{background-image: url(' +
            CKEDITOR.getUrl(this.path + 'images/hiddenfield.gif') +
            ');background-position: center center;background-repeat: no-repeat;border: 1px solid #a9a9a9;width: 16px !important;height: 16px !important;}',
        );
        CKEDITOR.style.unstylableElements.push('select', 'option');
      },
      init: function (a) {
        var h = a.lang,
          f = 0,
          b = { email: 1, password: 1, search: 1, tel: 1, text: 1, url: 1 },
          c = {
            checkbox: 'input[type,name,checked,required]',
            radio: 'input[type,name,checked,required]',
            textfield: 'input[type,name,value,size,maxlength,required]',
            textarea: 'textarea[cols,rows,name,required]',
            select: 'select[name,size,multiple,required]; option[value,selected]',
            button: 'input[type,name,value]',
            form: 'form[action,name,id,enctype,target,method]',
            hiddenfield: 'input[type,name,value]',
            imagebutton: 'input[type,alt,src]{width,height,border,border-width,border-style,margin,float}',
          },
          l = {
            checkbox: 'input',
            radio: 'input',
            textfield: 'input',
            textarea: 'textarea',
            select: 'select',
            button: 'input',
            form: 'form',
            hiddenfield: 'input',
            imagebutton: 'input',
          },
          k = function (b, e, g) {
            var k = { allowedContent: c[e], requiredContent: l[e] };
            'form' == e && (k.context = 'form');
            a.addCommand(e, new CKEDITOR.dialogCommand(e, k));
            a.ui.addButton &&
              a.ui.addButton(b, { label: h.common[b.charAt(0).toLowerCase() + b.slice(1)], command: e, toolbar: 'forms,' + (f += 10) });
            CKEDITOR.dialog.add(e, g);
          },
          m = this.path + 'dialogs/';
        !a.blockless && k('Form', 'form', m + 'form.js');
        k('Checkbox', 'checkbox', m + 'checkbox.js');
        k('Radio', 'radio', m + 'radio.js');
        k('TextField', 'textfield', m + 'textfield.js');
        k('Textarea', 'textarea', m + 'textarea.js');
        k('Select', 'select', m + 'select.js');
        k('Button', 'button', m + 'button.js');
        var g = a.plugins.image;
        g && !a.plugins.image2 && k('ImageButton', 'imagebutton', CKEDITOR.plugins.getPath('image') + 'dialogs/image.js');
        k('HiddenField', 'hiddenfield', m + 'hiddenfield.js');
        a.addMenuItems &&
          ((k = {
            checkbox: { label: h.forms.checkboxAndRadio.checkboxTitle, command: 'checkbox', group: 'checkbox' },
            radio: { label: h.forms.checkboxAndRadio.radioTitle, command: 'radio', group: 'radio' },
            textfield: { label: h.forms.textfield.title, command: 'textfield', group: 'textfield' },
            hiddenfield: { label: h.forms.hidden.title, command: 'hiddenfield', group: 'hiddenfield' },
            button: { label: h.forms.button.title, command: 'button', group: 'button' },
            select: { label: h.forms.select.title, command: 'select', group: 'select' },
            textarea: { label: h.forms.textarea.title, command: 'textarea', group: 'textarea' },
          }),
          g && (k.imagebutton = { label: h.image.titleButton, command: 'imagebutton', group: 'imagebutton' }),
          !a.blockless && (k.form = { label: h.forms.form.menu, command: 'form', group: 'form' }),
          a.addMenuItems(k));
        a.contextMenu &&
          (!a.blockless &&
            a.contextMenu.addListener(function (a, b, c) {
              if ((a = c.contains('form', 1)) && !a.isReadOnly()) return { form: CKEDITOR.TRISTATE_OFF };
            }),
          a.contextMenu.addListener(function (a) {
            if (a && !a.isReadOnly()) {
              var e = a.getName();
              if ('select' == e) return { select: CKEDITOR.TRISTATE_OFF };
              if ('textarea' == e) return { textarea: CKEDITOR.TRISTATE_OFF };
              if ('input' == e) {
                var c = a.getAttribute('type') || 'text';
                switch (c) {
                  case 'button':
                  case 'submit':
                  case 'reset':
                    return { button: CKEDITOR.TRISTATE_OFF };
                  case 'checkbox':
                    return { checkbox: CKEDITOR.TRISTATE_OFF };
                  case 'radio':
                    return { radio: CKEDITOR.TRISTATE_OFF };
                  case 'image':
                    return g ? { imagebutton: CKEDITOR.TRISTATE_OFF } : null;
                }
                if (b[c]) return { textfield: CKEDITOR.TRISTATE_OFF };
              }
              if ('img' == e && 'hiddenfield' == a.data('cke-real-element-type')) return { hiddenfield: CKEDITOR.TRISTATE_OFF };
            }
          }));
        a.on('doubleclick', function (d) {
          var e = d.data.element;
          if (!a.blockless && e.is('form')) d.data.dialog = 'form';
          else if (e.is('select')) d.data.dialog = 'select';
          else if (e.is('textarea')) d.data.dialog = 'textarea';
          else if (e.is('img') && 'hiddenfield' == e.data('cke-real-element-type')) d.data.dialog = 'hiddenfield';
          else if (e.is('input')) {
            e = e.getAttribute('type') || 'text';
            switch (e) {
              case 'button':
              case 'submit':
              case 'reset':
                d.data.dialog = 'button';
                break;
              case 'checkbox':
                d.data.dialog = 'checkbox';
                break;
              case 'radio':
                d.data.dialog = 'radio';
                break;
              case 'image':
                d.data.dialog = 'imagebutton';
            }
            b[e] && (d.data.dialog = 'textfield');
          }
        });
      },
      afterInit: function (a) {
        var h = a.dataProcessor,
          f = h && h.htmlFilter,
          h = h && h.dataFilter;
        CKEDITOR.env.ie &&
          f &&
          f.addRules(
            {
              elements: {
                input: function (a) {
                  a = a.attributes;
                  var c = a.type;
                  c || (a.type = 'text');
                  ('checkbox' != c && 'radio' != c) || 'on' != a.value || delete a.value;
                },
              },
            },
            { applyToAll: !0 },
          );
        h &&
          h.addRules(
            {
              elements: {
                input: function (b) {
                  if ('hidden' == b.attributes.type) return a.createFakeParserElement(b, 'cke_hidden', 'hiddenfield');
                },
              },
            },
            { applyToAll: !0 },
          );
      },
    });
    CKEDITOR.plugins.forms = {
      _setupRequiredAttribute: function (a) {
        this.setValue(a.hasAttribute('required'));
      },
    };
    (function () {
      var a = {
        canUndo: !1,
        exec: function (a) {
          var f = a.document.createElement('hr');
          a.insertElement(f);
        },
        allowedContent: 'hr',
        requiredContent: 'hr',
      };
      CKEDITOR.plugins.add('horizontalrule', {
        init: function (h) {
          h.blockless ||
            (h.addCommand('horizontalrule', a),
            h.ui.addButton &&
              h.ui.addButton('HorizontalRule', { label: h.lang.horizontalrule.toolbar, command: 'horizontalrule', toolbar: 'insert,40' }));
        },
      });
    })();
    CKEDITOR.plugins.add('htmlwriter', {
      init: function (a) {
        var h = new CKEDITOR.htmlWriter();
        h.forceSimpleAmpersand = a.config.forceSimpleAmpersand;
        h.indentationChars = 'string' === typeof a.config.dataIndentationChars ? a.config.dataIndentationChars : '\t';
        a.dataProcessor.writer = h;
      },
    });
    CKEDITOR.htmlWriter = CKEDITOR.tools.createClass({
      base: CKEDITOR.htmlParser.basicWriter,
      $: function () {
        this.base();
        this.indentationChars = '\t';
        this.selfClosingEnd = ' /\x3e';
        this.lineBreakChars = '\n';
        this.sortAttributes = 1;
        this._.indent = 0;
        this._.indentation = '';
        this._.inPre = 0;
        this._.rules = {};
        var a = CKEDITOR.dtd,
          h;
        for (h in CKEDITOR.tools.extend({}, a.$nonBodyContent, a.$block, a.$listItem, a.$tableContent))
          this.setRules(h, {
            indent: !a[h]['#'],
            breakBeforeOpen: 1,
            breakBeforeClose: !a[h]['#'],
            breakAfterClose: 1,
            needsSpace: h in a.$block && !(h in { li: 1, dt: 1, dd: 1 }),
          });
        this.setRules('br', { breakAfterOpen: 1 });
        this.setRules('title', { indent: 0, breakAfterOpen: 0 });
        this.setRules('style', { indent: 0, breakBeforeClose: 1 });
        this.setRules('pre', { breakAfterOpen: 1, indent: 0 });
      },
      proto: {
        openTag: function (a) {
          var h = this._.rules[a];
          this._.afterCloser && h && h.needsSpace && this._.needsSpace && this._.output.push('\n');
          this._.indent ? this.indentation() : h && h.breakBeforeOpen && (this.lineBreak(), this.indentation());
          this._.output.push('\x3c', a);
          this._.afterCloser = 0;
        },
        openTagClose: function (a, h) {
          var f = this._.rules[a];
          h
            ? (this._.output.push(this.selfClosingEnd), f && f.breakAfterClose && (this._.needsSpace = f.needsSpace))
            : (this._.output.push('\x3e'), f && f.indent && (this._.indentation += this.indentationChars));
          f && f.breakAfterOpen && this.lineBreak();
          'pre' == a && (this._.inPre = 1);
        },
        attribute: function (a, h) {
          'string' == typeof h && ((h = CKEDITOR.tools.htmlEncodeAttr(h)), this.forceSimpleAmpersand && (h = h.replace(/&amp;/g, '\x26')));
          this._.output.push(' ', a, '\x3d"', h, '"');
        },
        closeTag: function (a) {
          var h = this._.rules[a];
          h && h.indent && (this._.indentation = this._.indentation.substr(this.indentationChars.length));
          this._.indent ? this.indentation() : h && h.breakBeforeClose && (this.lineBreak(), this.indentation());
          this._.output.push('\x3c/', a, '\x3e');
          'pre' == a && (this._.inPre = 0);
          h && h.breakAfterClose && (this.lineBreak(), (this._.needsSpace = h.needsSpace));
          this._.afterCloser = 1;
        },
        text: function (a) {
          this._.indent && (this.indentation(), !this._.inPre && (a = CKEDITOR.tools.ltrim(a)));
          this._.output.push(a);
        },
        comment: function (a) {
          this._.indent && this.indentation();
          this._.output.push('\x3c!--', a, '--\x3e');
        },
        lineBreak: function () {
          !this._.inPre && 0 < this._.output.length && this._.output.push(this.lineBreakChars);
          this._.indent = 1;
        },
        indentation: function () {
          !this._.inPre && this._.indentation && this._.output.push(this._.indentation);
          this._.indent = 0;
        },
        reset: function () {
          this._.output = [];
          this._.indent = 0;
          this._.indentation = '';
          this._.afterCloser = 0;
          this._.inPre = 0;
          this._.needsSpace = 0;
        },
        setRules: function (a, h) {
          var f = this._.rules[a];
          f ? CKEDITOR.tools.extend(f, h, !0) : (this._.rules[a] = h);
        },
      },
    });
    (function () {
      CKEDITOR.plugins.add('iframe', {
        requires: 'dialog,fakeobjects',
        onLoad: function () {
          CKEDITOR.addCss(
            'img.cke_iframe{background-image: url(' +
              CKEDITOR.getUrl(this.path + 'images/placeholder.png') +
              ');background-position: center center;background-repeat: no-repeat;border: 1px solid #a9a9a9;width: 80px;height: 80px;}',
          );
        },
        init: function (a) {
          var h = a.lang.iframe,
            f = 'iframe[align,longdesc,tabindex,frameborder,height,name,scrolling,src,title,width]';
          a.plugins.dialogadvtab && (f += ';iframe' + a.plugins.dialogadvtab.allowedContent({ id: 1, classes: 1, styles: 1 }));
          CKEDITOR.dialog.add('iframe', this.path + 'dialogs/iframe.js');
          a.addCommand('iframe', new CKEDITOR.dialogCommand('iframe', { allowedContent: f, requiredContent: 'iframe' }));
          a.ui.addButton && a.ui.addButton('Iframe', { label: h.toolbar, command: 'iframe', toolbar: 'insert,80' });
          a.on('doubleclick', function (a) {
            var c = a.data.element;
            c.is('img') && 'iframe' == c.data('cke-real-element-type') && (a.data.dialog = 'iframe');
          });
          a.addMenuItems && a.addMenuItems({ iframe: { label: h.title, command: 'iframe', group: 'image' } });
          a.contextMenu &&
            a.contextMenu.addListener(function (a) {
              if (a && a.is('img') && 'iframe' == a.data('cke-real-element-type')) return { iframe: CKEDITOR.TRISTATE_OFF };
            });
        },
        afterInit: function (a) {
          var h = a.dataProcessor;
          (h = h && h.dataFilter) &&
            h.addRules({
              elements: {
                iframe: function (f) {
                  return a.createFakeParserElement(f, 'cke_iframe', 'iframe', !0);
                },
              },
            });
        },
      });
    })();
    (function () {
      function a(a, b) {
        b || (b = a.getSelection().getSelectedElement());
        if (b && b.is('img') && !b.data('cke-realelement') && !b.isReadOnly()) return b;
      }
      function h(a) {
        var b = a.getStyle('float');
        if ('inherit' == b || 'none' == b) b = 0;
        b || (b = a.getAttribute('align'));
        return b;
      }
      CKEDITOR.plugins.add('image', {
        requires: 'dialog',
        init: function (f) {
          if (!f.plugins.detectConflict('image', ['easyimage', 'image2'])) {
            CKEDITOR.dialog.add('image', this.path + 'dialogs/image.js');
            var b = 'img[alt,!src]{border-style,border-width,float,height,margin,margin-bottom,margin-left,margin-right,margin-top,width}';
            CKEDITOR.dialog.isTabEnabled(f, 'image', 'advanced') && (b = 'img[alt,dir,id,lang,longdesc,!src,title]{*}(*)');
            f.addCommand(
              'image',
              new CKEDITOR.dialogCommand('image', {
                allowedContent: b,
                requiredContent: 'img[alt,src]',
                contentTransformations: [
                  ['img{width}: sizeToStyle', 'img[width]: sizeToAttribute'],
                  ['img{float}: alignmentToStyle', 'img[align]: alignmentToAttribute'],
                ],
              }),
            );
            f.ui.addButton && f.ui.addButton('Image', { label: f.lang.common.image, command: 'image', toolbar: 'insert,10' });
            f.on('doubleclick', function (a) {
              var b = a.data.element;
              !b.is('img') || b.data('cke-realelement') || b.isReadOnly() || (a.data.dialog = 'image');
            });
            f.addMenuItems && f.addMenuItems({ image: { label: f.lang.image.menu, command: 'image', group: 'image' } });
            f.contextMenu &&
              f.contextMenu.addListener(function (b) {
                if (a(f, b)) return { image: CKEDITOR.TRISTATE_OFF };
              });
          }
        },
        afterInit: function (f) {
          function b(b) {
            var l = f.getCommand('justify' + b);
            if (l) {
              if ('left' == b || 'right' == b)
                l.on('exec', function (k) {
                  var m = a(f),
                    g;
                  m &&
                    ((g = h(m)),
                    g == b ? (m.removeStyle('float'), b == h(m) && m.removeAttribute('align')) : m.setStyle('float', b),
                    k.cancel());
                });
              l.on('refresh', function (k) {
                var m = a(f);
                m &&
                  ((m = h(m)),
                  this.setState(
                    m == b ? CKEDITOR.TRISTATE_ON : 'right' == b || 'left' == b ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                  ),
                  k.cancel());
              });
            }
          }
          f.plugins.image2 || (b('left'), b('right'), b('center'), b('block'));
        },
      });
    })();
    CKEDITOR.config.image_removeLinkByEmptyURL = !0;
    (function () {
      function a(a, c) {
        var l, k;
        c.on(
          'refresh',
          function (a) {
            var b = [h],
              d;
            for (d in a.data.states) b.push(a.data.states[d]);
            this.setState(CKEDITOR.tools.search(b, f) ? f : h);
          },
          c,
          null,
          100,
        );
        c.on(
          'exec',
          function (c) {
            l = a.getSelection();
            k = l.createBookmarks(1);
            c.data || (c.data = {});
            c.data.done = !1;
          },
          c,
          null,
          0,
        );
        c.on(
          'exec',
          function () {
            a.forceNextSelectionCheck();
            l.selectBookmarks(k);
          },
          c,
          null,
          100,
        );
      }
      var h = CKEDITOR.TRISTATE_DISABLED,
        f = CKEDITOR.TRISTATE_OFF;
      CKEDITOR.plugins.add('indent', {
        init: function (b) {
          var c = CKEDITOR.plugins.indent.genericDefinition;
          a(b, b.addCommand('indent', new c(!0)));
          a(b, b.addCommand('outdent', new c()));
          b.ui.addButton &&
            (b.ui.addButton('Indent', { label: b.lang.indent.indent, command: 'indent', directional: !0, toolbar: 'indent,20' }),
            b.ui.addButton('Outdent', { label: b.lang.indent.outdent, command: 'outdent', directional: !0, toolbar: 'indent,10' }));
          b.on('dirChanged', function (a) {
            var c = b.createRange(),
              f = a.data.node;
            c.setStartBefore(f);
            c.setEndAfter(f);
            for (var g = new CKEDITOR.dom.walker(c), d; (d = g.next()); )
              if (d.type == CKEDITOR.NODE_ELEMENT)
                if (!d.equals(f) && d.getDirection()) c.setStartAfter(d), (g = new CKEDITOR.dom.walker(c));
                else {
                  var e = b.config.indentClasses;
                  if (e)
                    for (var h = 'ltr' == a.data.dir ? ['_rtl', ''] : ['', '_rtl'], r = 0; r < e.length; r++)
                      d.hasClass(e[r] + h[0]) && (d.removeClass(e[r] + h[0]), d.addClass(e[r] + h[1]));
                  e = d.getStyle('margin-right');
                  h = d.getStyle('margin-left');
                  e ? d.setStyle('margin-left', e) : d.removeStyle('margin-left');
                  h ? d.setStyle('margin-right', h) : d.removeStyle('margin-right');
                }
          });
        },
      });
      CKEDITOR.plugins.indent = {
        genericDefinition: function (a) {
          this.isIndent = !!a;
          this.startDisabled = !this.isIndent;
        },
        specificDefinition: function (a, c, f) {
          this.name = c;
          this.editor = a;
          this.jobs = {};
          this.enterBr = a.config.enterMode == CKEDITOR.ENTER_BR;
          this.isIndent = !!f;
          this.relatedGlobal = f ? 'indent' : 'outdent';
          this.indentKey = f ? 9 : CKEDITOR.SHIFT + 9;
          this.database = {};
        },
        registerCommands: function (a, c) {
          a.on('pluginsLoaded', function () {
            for (var a in c)
              (function (a, b) {
                var c = a.getCommand(b.relatedGlobal),
                  d;
                for (d in b.jobs)
                  c.on(
                    'exec',
                    function (e) {
                      e.data.done ||
                        (a.fire('lockSnapshot'),
                        b.execJob(a, d) && (e.data.done = !0),
                        a.fire('unlockSnapshot'),
                        CKEDITOR.dom.element.clearAllMarkers(b.database));
                    },
                    this,
                    null,
                    d,
                  ),
                    c.on(
                      'refresh',
                      function (e) {
                        e.data.states || (e.data.states = {});
                        e.data.states[b.name + '@' + d] = b.refreshJob(a, d, e.data.path);
                      },
                      this,
                      null,
                      d,
                    );
                a.addFeature(b);
              })(this, c[a]);
          });
        },
      };
      CKEDITOR.plugins.indent.genericDefinition.prototype = { context: 'p', exec: function () {} };
      CKEDITOR.plugins.indent.specificDefinition.prototype = {
        execJob: function (a, c) {
          var f = this.jobs[c];
          if (f.state != h) return f.exec.call(this, a);
        },
        refreshJob: function (a, c, f) {
          c = this.jobs[c];
          a.activeFilter.checkFeature(this) ? (c.state = c.refresh.call(this, a, f)) : (c.state = h);
          return c.state;
        },
        getContext: function (a) {
          return a.contains(this.context);
        },
      };
    })();
    (function () {
      function a(a, b, c) {
        if (!a.getCustomData('indent_processed')) {
          var d = this.editor,
            e = this.isIndent;
          if (b) {
            d = a.$.className.match(this.classNameRegex);
            c = 0;
            d && ((d = d[1]), (c = CKEDITOR.tools.indexOf(b, d) + 1));
            if (0 > (c += e ? 1 : -1)) return;
            c = Math.min(c, b.length);
            c = Math.max(c, 0);
            a.$.className = CKEDITOR.tools.ltrim(a.$.className.replace(this.classNameRegex, ''));
            0 < c && a.addClass(b[c - 1]);
          } else {
            b = h(a, c);
            c = parseInt(a.getStyle(b), 10);
            var f = d.config.indentOffset || 40;
            isNaN(c) && (c = 0);
            c += (e ? 1 : -1) * f;
            if (0 > c) return;
            c = Math.max(c, 0);
            c = Math.ceil(c / f) * f;
            a.setStyle(b, c ? c + (d.config.indentUnit || 'px') : '');
            '' === a.getAttribute('style') && a.removeAttribute('style');
          }
          CKEDITOR.dom.element.setMarker(this.database, a, 'indent_processed', 1);
        }
      }
      function h(a, b) {
        return 'ltr' == (b || a.getComputedStyle('direction')) ? 'margin-left' : 'margin-right';
      }
      var f = CKEDITOR.dtd.$listItem,
        b = CKEDITOR.dtd.$list,
        c = CKEDITOR.TRISTATE_DISABLED,
        l = CKEDITOR.TRISTATE_OFF;
      CKEDITOR.plugins.add('indentblock', {
        requires: 'indent',
        init: function (k) {
          function m() {
            g.specificDefinition.apply(this, arguments);
            this.allowedContent = {
              'div h1 h2 h3 h4 h5 h6 ol p pre ul': {
                propertiesOnly: !0,
                styles: d ? null : 'margin-left,margin-right',
                classes: d || null,
              },
            };
            this.contentTransformations = [
              ['div: splitMarginShorthand'],
              ['h1: splitMarginShorthand'],
              ['h2: splitMarginShorthand'],
              ['h3: splitMarginShorthand'],
              ['h4: splitMarginShorthand'],
              ['h5: splitMarginShorthand'],
              ['h6: splitMarginShorthand'],
              ['ol: splitMarginShorthand'],
              ['p: splitMarginShorthand'],
              ['pre: splitMarginShorthand'],
              ['ul: splitMarginShorthand'],
            ];
            this.enterBr && (this.allowedContent.div = !0);
            this.requiredContent = (this.enterBr ? 'div' : 'p') + (d ? '(' + d.join(',') + ')' : '{margin-left}');
            this.jobs = {
              20: {
                refresh: function (a, b) {
                  var g = b.block || b.blockLimit;
                  if (!g.is(f))
                    var k = g.getAscendant(f),
                      g = (k && b.contains(k)) || g;
                  g.is(f) && (g = g.getParent());
                  if (this.enterBr || this.getContext(b)) {
                    if (d) {
                      var k = d,
                        g = g.$.className.match(this.classNameRegex),
                        m = this.isIndent,
                        k = g ? (m ? g[1] != k.slice(-1) : !0) : m;
                      return k ? l : c;
                    }
                    return this.isIndent
                      ? l
                      : g
                        ? CKEDITOR[0 >= (parseInt(g.getStyle(h(g)), 10) || 0) ? 'TRISTATE_DISABLED' : 'TRISTATE_OFF']
                        : c;
                  }
                  return c;
                },
                exec: function (e) {
                  var c = e.getSelection(),
                    c = c && c.getRanges()[0],
                    f;
                  if ((f = e.elementPath().contains(b))) a.call(this, f, d);
                  else
                    for (
                      c = c.createIterator(), e = e.config.enterMode, c.enforceRealBlocks = !0, c.enlargeBr = e != CKEDITOR.ENTER_BR;
                      (f = c.getNextParagraph(e == CKEDITOR.ENTER_P ? 'p' : 'div'));

                    )
                      f.isReadOnly() || a.call(this, f, d);
                  return !0;
                },
              },
            };
          }
          var g = CKEDITOR.plugins.indent,
            d = k.config.indentClasses;
          g.registerCommands(k, { indentblock: new m(k, 'indentblock', !0), outdentblock: new m(k, 'outdentblock') });
          CKEDITOR.tools.extend(m.prototype, g.specificDefinition.prototype, {
            context: { div: 1, dl: 1, h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1, ul: 1, ol: 1, p: 1, pre: 1, table: 1 },
            classNameRegex: d ? new RegExp('(?:^|\\s+)(' + d.join('|') + ')(?\x3d$|\\s)') : null,
          });
        },
      });
    })();
    (function () {
      function a(a) {
        function b(g) {
          for (var h = k.startContainer, l = k.endContainer; h && !h.getParent().equals(g); ) h = h.getParent();
          for (; l && !l.getParent().equals(g); ) l = l.getParent();
          if (!h || !l) return !1;
          for (var p = [], z = !1; !z; ) h.equals(l) && (z = !0), p.push(h), (h = h.getNext());
          if (1 > p.length) return !1;
          h = g.getParents(!0);
          for (l = 0; l < h.length; l++)
            if (h[l].getName && c[h[l].getName()]) {
              g = h[l];
              break;
            }
          for (
            var h = d.isIndent ? 1 : -1,
              l = p[0],
              p = p[p.length - 1],
              z = CKEDITOR.plugins.list.listToArray(g, e),
              y = z[p.getCustomData('listarray_index')].indent,
              l = l.getCustomData('listarray_index');
            l <= p.getCustomData('listarray_index');
            l++
          )
            if (((z[l].indent += h), 0 < h)) {
              for (var v = z[l].parent, C = l - 1; 0 <= C; C--)
                if (z[C].indent === h) {
                  v = z[C].parent;
                  break;
                }
              z[l].parent = new CKEDITOR.dom.element(v.getName(), v.getDocument());
            }
          for (l = p.getCustomData('listarray_index') + 1; l < z.length && z[l].indent > y; l++) z[l].indent += h;
          h = CKEDITOR.plugins.list.arrayToList(z, e, null, a.config.enterMode, g.getDirection());
          if (!d.isIndent) {
            var F;
            if ((F = g.getParent()) && F.is('li'))
              for (var p = h.listNode.getChildren(), D = [], u, l = p.count() - 1; 0 <= l; l--)
                (u = p.getItem(l)) && u.is && u.is('li') && D.push(u);
          }
          h && h.listNode.replace(g);
          if (D && D.length)
            for (l = 0; l < D.length; l++) {
              for (u = g = D[l]; (u = u.getNext()) && u.is && u.getName() in c; )
                CKEDITOR.env.needsNbspFiller && !g.getFirst(f) && g.append(k.document.createText(' ')), g.append(u);
              g.insertAfter(F);
            }
          h && a.fire('contentDomInvalidated');
          return !0;
        }
        for (
          var d = this, e = this.database, c = this.context, k, l = a.getSelection(), l = (l && l.getRanges()).createIterator();
          (k = l.getNextRange());

        ) {
          for (var u = k.getCommonAncestor(); u && (u.type != CKEDITOR.NODE_ELEMENT || !c[u.getName()]); ) {
            if (a.editable().equals(u)) {
              u = !1;
              break;
            }
            u = u.getParent();
          }
          u || ((u = k.startPath().contains(c)) && k.setEndAt(u, CKEDITOR.POSITION_BEFORE_END));
          if (!u) {
            var p = k.getEnclosedNode();
            p &&
              p.type == CKEDITOR.NODE_ELEMENT &&
              p.getName() in c &&
              (k.setStartAt(p, CKEDITOR.POSITION_AFTER_START), k.setEndAt(p, CKEDITOR.POSITION_BEFORE_END), (u = p));
          }
          u &&
            k.startContainer.type == CKEDITOR.NODE_ELEMENT &&
            k.startContainer.getName() in c &&
            ((p = new CKEDITOR.dom.walker(k)), (p.evaluator = h), (k.startContainer = p.next()));
          u &&
            k.endContainer.type == CKEDITOR.NODE_ELEMENT &&
            k.endContainer.getName() in c &&
            ((p = new CKEDITOR.dom.walker(k)), (p.evaluator = h), (k.endContainer = p.previous()));
          if (u) return b(u);
        }
        return 0;
      }
      function h(a) {
        return a.type == CKEDITOR.NODE_ELEMENT && a.is('li');
      }
      function f(a) {
        return b(a) && c(a);
      }
      var b = CKEDITOR.dom.walker.whitespaces(!0),
        c = CKEDITOR.dom.walker.bookmark(!1, !0),
        l = CKEDITOR.TRISTATE_DISABLED,
        k = CKEDITOR.TRISTATE_OFF;
      CKEDITOR.plugins.add('indentlist', {
        requires: 'indent',
        init: function (b) {
          function c(b) {
            d.specificDefinition.apply(this, arguments);
            this.requiredContent = ['ul', 'ol'];
            b.on(
              'key',
              function (a) {
                var d = b.elementPath();
                if ('wysiwyg' == b.mode && a.data.keyCode == this.indentKey && d) {
                  var c = this.getContext(d);
                  !c ||
                    (this.isIndent && CKEDITOR.plugins.indentList.firstItemInPath(this.context, d, c)) ||
                    (b.execCommand(this.relatedGlobal), a.cancel());
                }
              },
              this,
            );
            this.jobs[this.isIndent ? 10 : 30] = {
              refresh: this.isIndent
                ? function (a, b) {
                    var d = this.getContext(b),
                      e = CKEDITOR.plugins.indentList.firstItemInPath(this.context, b, d);
                    return d && this.isIndent && !e ? k : l;
                  }
                : function (a, b) {
                    return !this.getContext(b) || this.isIndent ? l : k;
                  },
              exec: CKEDITOR.tools.bind(a, this),
            };
          }
          var d = CKEDITOR.plugins.indent;
          d.registerCommands(b, { indentlist: new c(b, 'indentlist', !0), outdentlist: new c(b, 'outdentlist') });
          CKEDITOR.tools.extend(c.prototype, d.specificDefinition.prototype, { context: { ol: 1, ul: 1 } });
        },
      });
      CKEDITOR.plugins.indentList = {};
      CKEDITOR.plugins.indentList.firstItemInPath = function (a, b, d) {
        var e = b.contains(h);
        d || (d = b.contains(a));
        return d && e && e.equals(d.getFirst(h));
      };
    })();
    (function () {
      function a(a, c) {
        var f;
        if (c) f = a.getComputedStyle('text-align');
        else {
          for (; !a.hasAttribute || (!a.hasAttribute('align') && !a.getStyle('text-align')); ) {
            f = a.getParent();
            if (!f) break;
            a = f;
          }
          f = a.getStyle('text-align') || a.getAttribute('align') || '';
        }
        f && (f = f.replace(/(?:-(?:moz|webkit)-)?(?:start|auto)/i, ''));
        !f && c && (f = 'rtl' == a.getComputedStyle('direction') ? 'right' : 'left');
        return f;
      }
      function h(a, c, f) {
        this.editor = a;
        this.name = c;
        this.value = f;
        this.context = 'p';
        c = a.config.justifyClasses;
        var h = a.config.enterMode == CKEDITOR.ENTER_P ? 'p' : 'div';
        if (c) {
          switch (f) {
            case 'left':
              this.cssClassName = c[0];
              break;
            case 'center':
              this.cssClassName = c[1];
              break;
            case 'right':
              this.cssClassName = c[2];
              break;
            case 'justify':
              this.cssClassName = c[3];
          }
          this.cssClassRegex = new RegExp('(?:^|\\s+)(?:' + c.join('|') + ')(?\x3d$|\\s)');
          this.requiredContent = h + '(' + this.cssClassName + ')';
        } else this.requiredContent = h + '{text-align}';
        this.allowedContent = {
          'caption div h1 h2 h3 h4 h5 h6 p pre td th li': {
            propertiesOnly: !0,
            styles: this.cssClassName ? null : 'text-align',
            classes: this.cssClassName || null,
          },
        };
        a.config.enterMode == CKEDITOR.ENTER_BR && (this.allowedContent.div = !0);
      }
      function f(a) {
        var c = a.editor,
          f = c.createRange();
        f.setStartBefore(a.data.node);
        f.setEndAfter(a.data.node);
        for (var h = new CKEDITOR.dom.walker(f), m; (m = h.next()); )
          if (m.type == CKEDITOR.NODE_ELEMENT)
            if (!m.equals(a.data.node) && m.getDirection()) f.setStartAfter(m), (h = new CKEDITOR.dom.walker(f));
            else {
              var g = c.config.justifyClasses;
              g &&
                (m.hasClass(g[0]) ? (m.removeClass(g[0]), m.addClass(g[2])) : m.hasClass(g[2]) && (m.removeClass(g[2]), m.addClass(g[0])));
              g = m.getStyle('text-align');
              'left' == g ? m.setStyle('text-align', 'right') : 'right' == g && m.setStyle('text-align', 'left');
            }
      }
      h.prototype = {
        exec: function (b) {
          var c = b.getSelection(),
            f = b.config.enterMode;
          if (c) {
            for (
              var h = c.createBookmarks(), m = c.getRanges(), g = this.cssClassName, d, e, n = b.config.useComputedState, r = m.length - 1;
              0 <= r;
              r--
            )
              for (
                d = m[r].createIterator(), d.enlargeBr = f != CKEDITOR.ENTER_BR;
                (e = d.getNextParagraph(f == CKEDITOR.ENTER_P ? 'p' : 'div'));

              )
                if (!e.isReadOnly()) {
                  var x = e.getName(),
                    u;
                  u = b.activeFilter.check(x + '{text-align}');
                  if ((x = b.activeFilter.check(x + '(' + g + ')')) || u) {
                    e.removeAttribute('align');
                    e.removeStyle('text-align');
                    var p = g && (e.$.className = CKEDITOR.tools.ltrim(e.$.className.replace(this.cssClassRegex, ''))),
                      t = this.state == CKEDITOR.TRISTATE_OFF && (!n || a(e, !0) != this.value);
                    g && x ? (t ? e.addClass(g) : p || e.removeAttribute('class')) : t && u && e.setStyle('text-align', this.value);
                  }
                }
            b.focus();
            b.forceNextSelectionCheck();
            c.selectBookmarks(h);
          }
        },
        refresh: function (b, c) {
          var f = c.block || c.blockLimit,
            h = f.getName(),
            m = f.equals(b.editable()),
            h = this.cssClassName ? b.activeFilter.check(h + '(' + this.cssClassName + ')') : b.activeFilter.check(h + '{text-align}');
          m && !CKEDITOR.dtd.$list[c.lastElement.getName()]
            ? this.setState(CKEDITOR.TRISTATE_OFF)
            : !m && h
              ? this.setState(a(f, this.editor.config.useComputedState) == this.value ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF)
              : this.setState(CKEDITOR.TRISTATE_DISABLED);
        },
      };
      CKEDITOR.plugins.add('justify', {
        init: function (a) {
          if (!a.blockless) {
            var c = new h(a, 'justifyleft', 'left'),
              l = new h(a, 'justifycenter', 'center'),
              k = new h(a, 'justifyright', 'right'),
              m = new h(a, 'justifyblock', 'justify');
            a.addCommand('justifyleft', c);
            a.addCommand('justifycenter', l);
            a.addCommand('justifyright', k);
            a.addCommand('justifyblock', m);
            a.ui.addButton &&
              (a.ui.addButton('JustifyLeft', { isToggle: !0, label: a.lang.common.alignLeft, command: 'justifyleft', toolbar: 'align,10' }),
              a.ui.addButton('JustifyCenter', { isToggle: !0, label: a.lang.common.center, command: 'justifycenter', toolbar: 'align,20' }),
              a.ui.addButton('JustifyRight', {
                isToggle: !0,
                label: a.lang.common.alignRight,
                command: 'justifyright',
                toolbar: 'align,30',
              }),
              a.ui.addButton('JustifyBlock', { isToggle: !0, label: a.lang.common.justify, command: 'justifyblock', toolbar: 'align,40' }));
            a.on('dirChanged', f);
          }
        },
      });
    })();
    CKEDITOR.plugins.add('menubutton', {
      requires: 'button,menu',
      onLoad: function () {
        var a = function (a) {
          var f = this._,
            b = CKEDITOR.document.getById(f.id),
            c = f.menu;
          f.state !== CKEDITOR.TRISTATE_DISABLED &&
            (f.on && c
              ? c.hide()
              : ((f.previousState = f.state),
                c ||
                  ((c = f.menu =
                    new CKEDITOR.menu(a, { panel: { className: 'cke_menu_panel', attributes: { 'aria-label': a.lang.common.options } } })),
                  (c.onHide = CKEDITOR.tools.bind(function () {
                    var c = this.command ? a.getCommand(this.command).modes : this.modes;
                    this.setState(!c || c[a.mode] ? f.previousState : CKEDITOR.TRISTATE_DISABLED);
                    f.on = 0;
                    b.setAttribute('aria-expanded', 'false');
                  }, this)),
                  this.onMenu && c.addListener(this.onMenu)),
                this.setState(CKEDITOR.TRISTATE_ON),
                (f.on = 1),
                b.setAttribute('aria-expanded', 'true'),
                setTimeout(function () {
                  c.show(CKEDITOR.document.getById(f.id), 4);
                }, 0)));
        };
        CKEDITOR.ui.menuButton = CKEDITOR.tools.createClass({
          base: CKEDITOR.ui.button,
          $: function (h) {
            delete h.panel;
            this.base(h);
            this.hasArrow = 'menu';
            this.click = a;
          },
          statics: {
            handler: {
              create: function (a) {
                return new CKEDITOR.ui.menuButton(a);
              },
            },
          },
        });
      },
      beforeInit: function (a) {
        a.ui.addHandler(CKEDITOR.UI_MENUBUTTON, CKEDITOR.ui.menuButton.handler);
      },
    });
    CKEDITOR.UI_MENUBUTTON = 'menubutton';
    ('use strict');
    (function () {
      CKEDITOR.plugins.add('language', {
        requires: 'menubutton',
        init: function (a) {
          var h = a.config.language_list || ['ar:Arabic:rtl', 'fr:French', 'es:Spanish'],
            f = this,
            b = a.lang.language,
            c = {},
            l,
            k,
            m,
            g;
          a.addCommand('language', {
            allowedContent: 'span[!lang,dir]',
            requiredContent: 'span[lang]',
            contextSensitive: !0,
            exec: function (a, b) {
              var f = c['language_' + b];
              if (f) a[f.style.checkActive(a.elementPath(), a) ? 'removeStyle' : 'applyStyle'](f.style);
            },
            refresh: function (a) {
              this.setState(f.getCurrentLangElement(a) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF);
            },
          });
          for (g = 0; g < h.length; g++)
            (l = h[g].split(':')),
              (k = l[0]),
              (m = 'language_' + k),
              (c[m] = {
                label: l[1],
                langId: k,
                group: 'language',
                order: g,
                ltr: 'rtl' != ('' + l[2]).toLowerCase(),
                onClick: function () {
                  a.execCommand('language', this.langId);
                },
                role: 'menuitemcheckbox',
              }),
              (c[m].style = new CKEDITOR.style({ element: 'span', attributes: { lang: k, dir: c[m].ltr ? 'ltr' : 'rtl' } }));
          c.language_remove = {
            label: b.remove,
            group: 'language_remove',
            state: CKEDITOR.TRISTATE_DISABLED,
            order: c.length,
            onClick: function () {
              var b = f.getCurrentLangElement(a);
              b && a.execCommand('language', b.getAttribute('lang'));
            },
          };
          a.addMenuGroup('language', 1);
          a.addMenuGroup('language_remove');
          a.addMenuItems(c);
          a.ui.add('Language', CKEDITOR.UI_MENUBUTTON, {
            label: b.button,
            allowedContent: 'span[!lang,dir]',
            requiredContent: 'span[lang]',
            toolbar: 'bidi,30',
            command: 'language',
            contentTransformations: [
              [
                {
                  element: 'span',
                  left: function (a) {
                    return a.attributes.lang && (!a.attributes.dir || '' === a.attributes.dir);
                  },
                  right: function (a) {
                    var b = CKEDITOR.tools.object.keys(CKEDITOR.lang.rtl),
                      b = -1 !== CKEDITOR.tools.array.indexOf(b, a.attributes.lang) ? 'rtl' : 'ltr';
                    a.attributes.dir = b;
                  },
                },
              ],
            ],
            onMenu: function () {
              var b = {},
                e = f.getCurrentLangElement(a),
                g;
              for (g in c) b[g] = CKEDITOR.TRISTATE_OFF;
              b.language_remove = e ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED;
              e && (b['language_' + e.getAttribute('lang')] = CKEDITOR.TRISTATE_ON);
              return b;
            },
          });
          a.addRemoveFormatFilter &&
            a.addRemoveFormatFilter(function (a) {
              return !(a.is('span') && a.getAttribute('dir') && a.getAttribute('lang'));
            });
        },
        getCurrentLangElement: function (a) {
          var h = a.elementPath();
          a = h && h.elements;
          var f;
          if (h) for (var b = 0; b < a.length; b++) (h = a[b]), !f && 'span' == h.getName() && h.hasAttribute('lang') && (f = h);
          return f;
        },
      });
    })();
    ('use strict');
    (function () {
      function a(a) {
        return a.replace(/'/g, '\\$\x26');
      }
      function h(a) {
        for (var b = a.length, d = [], e, c = 0; c < b; c++) (e = a.charCodeAt(c)), d.push(e);
        return 'String.fromCharCode(' + d.join(',') + ')';
      }
      function f(b, d) {
        for (
          var e = b.plugins.link, c = e.compiledProtectionFunction.params, e = [e.compiledProtectionFunction.name, '('], f, g, h = 0;
          h < c.length;
          h++
        )
          (f = c[h].toLowerCase()), (g = d[f]), 0 < h && e.push(','), e.push("'", g ? a(encodeURIComponent(d[f])) : '', "'");
        e.push(')');
        return e.join('');
      }
      function b(a) {
        a = a.config.emailProtection || '';
        var b;
        a &&
          'encode' != a &&
          ((b = {}),
          a.replace(/^([^(]+)\(([^)]+)\)$/, function (a, d, e) {
            b.name = d;
            b.params = [];
            e.replace(/[^,\s]+/g, function (a) {
              b.params.push(a);
            });
          }));
        return b;
      }
      CKEDITOR.plugins.add('link', {
        requires: 'dialog,fakeobjects',
        onLoad: function () {
          function a(b) {
            return d.replace(/%1/g, 'rtl' == b ? 'right' : 'left').replace(/%2/g, 'cke_contents_' + b);
          }
          var b =
              'background:url(' +
              CKEDITOR.getUrl(this.path + 'images' + (CKEDITOR.env.hidpi ? '/hidpi' : '') + '/anchor.png') +
              ') no-repeat %1 center;border:1px dotted #00f;background-size:16px;',
            d =
              '.%2 a.cke_anchor,.%2 a.cke_anchor_empty,.cke_editable.%2 a[name],.cke_editable.%2 a[data-cke-saved-name]{' +
              b +
              'padding-%1:18px;cursor:auto;}.%2 img.cke_anchor{' +
              b +
              'width:16px;min-height:15px;height:1.15em;vertical-align:text-bottom;}';
          CKEDITOR.addCss(a('ltr') + a('rtl'));
        },
        init: function (a) {
          var d = 'a[!href]';
          CKEDITOR.dialog.isTabEnabled(a, 'link', 'advanced') &&
            (d = d.replace(']', ',accesskey,charset,dir,id,lang,name,rel,tabindex,title,type,download]{*}(*)'));
          CKEDITOR.dialog.isTabEnabled(a, 'link', 'target') && (d = d.replace(']', ',target,onclick]'));
          a.addCommand('link', new CKEDITOR.dialogCommand('link', { allowedContent: d, requiredContent: 'a[href]' }));
          a.addCommand('anchor', new CKEDITOR.dialogCommand('anchor', { allowedContent: 'a[!name,id]', requiredContent: 'a[name]' }));
          a.addCommand('unlink', new CKEDITOR.unlinkCommand());
          a.addCommand('removeAnchor', new CKEDITOR.removeAnchorCommand());
          a.setKeystroke(CKEDITOR.CTRL + 76, 'link');
          a.setKeystroke(CKEDITOR.CTRL + 75, 'link');
          a.ui.addButton &&
            (a.ui.addButton('Link', { label: a.lang.link.toolbar, command: 'link', toolbar: 'links,10' }),
            a.ui.addButton('Unlink', { label: a.lang.link.unlink, command: 'unlink', toolbar: 'links,20' }),
            a.ui.addButton('Anchor', { label: a.lang.link.anchor.toolbar, command: 'anchor', toolbar: 'links,30' }));
          CKEDITOR.dialog.add('link', this.path + 'dialogs/link.js');
          CKEDITOR.dialog.add('anchor', this.path + 'dialogs/anchor.js');
          a.on(
            'doubleclick',
            function (b) {
              var d = b.data.element.getAscendant({ a: 1, img: 1 }, !0);
              d &&
                !d.isReadOnly() &&
                (d.is('a')
                  ? ((b.data.dialog = !d.getAttribute('name') || (d.getAttribute('href') && d.getChildCount()) ? 'link' : 'anchor'),
                    (b.data.link = d))
                  : CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, d) && (b.data.dialog = 'anchor'));
            },
            null,
            null,
            0,
          );
          a.on(
            'doubleclick',
            function (b) {
              b.data.dialog in { link: 1, anchor: 1 } && b.data.link && a.getSelection().selectElement(b.data.link);
            },
            null,
            null,
            20,
          );
          a.addMenuItems &&
            a.addMenuItems({
              anchor: { label: a.lang.link.anchor.menu, command: 'anchor', group: 'anchor', order: 1 },
              removeAnchor: { label: a.lang.link.anchor.remove, command: 'removeAnchor', group: 'anchor', order: 5 },
              link: { label: a.lang.link.menu, command: 'link', group: 'link', order: 1 },
              unlink: { label: a.lang.link.unlink, command: 'unlink', group: 'link', order: 5 },
            });
          a.contextMenu &&
            a.contextMenu.addListener(function (b) {
              if (!b || b.isReadOnly()) return null;
              b = CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, b);
              if (!b && !(b = CKEDITOR.plugins.link.getSelectedLink(a))) return null;
              var d = {};
              b.getAttribute('href') && b.getChildCount() && (d = { link: CKEDITOR.TRISTATE_OFF, unlink: CKEDITOR.TRISTATE_OFF });
              b && b.hasAttribute('name') && (d.anchor = d.removeAnchor = CKEDITOR.TRISTATE_OFF);
              return d;
            });
          this.compiledProtectionFunction = b(a);
        },
        afterInit: function (a) {
          a.dataProcessor.dataFilter.addRules({
            elements: {
              a: function (b) {
                return b.attributes.name ? (b.children.length ? null : a.createFakeParserElement(b, 'cke_anchor', 'anchor')) : null;
              },
            },
          });
          var b = a._.elementsPath && a._.elementsPath.filters;
          b &&
            b.push(function (b, d) {
              if (
                'a' == d &&
                (CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, b) ||
                  (b.getAttribute('name') && (!b.getAttribute('href') || !b.getChildCount())))
              )
                return 'anchor';
            });
        },
      });
      var c = /^javascript:/,
        l = /^(?:mailto)(?:(?!\?(subject|body)=).)+/i,
        k = /subject=([^;?:@&=$,\/]*)/i,
        m = /body=([^;?:@&=$,\/]*)/i,
        g = /^#(.*)$/,
        d = /^((?:http|https|ftp|news):\/\/)?(.*)$/,
        e = /^(_(?:self|top|parent|blank))$/,
        n = /^javascript:void\(location\.href='mailto:'\+String\.fromCharCode\(([^)]+)\)(?:\+'(.*)')?\)$/,
        r = /^javascript:([^(]+)\(([^)]+)\)$/,
        x = /\s*window.open\(\s*this\.href\s*,\s*(?:'([^']*)'|null)\s*,\s*'([^']*)'\s*\)\s*;\s*return\s*false;*\s*/,
        u = /(?:^|,)([^=]+)=(\d+|yes|no)/gi,
        p = /^tel:(.*)$/,
        t = {
          id: 'advId',
          dir: 'advLangDir',
          accessKey: 'advAccessKey',
          name: 'advName',
          lang: 'advLangCode',
          tabindex: 'advTabIndex',
          title: 'advTitle',
          type: 'advContentType',
          class: 'advCSSClasses',
          charset: 'advCharset',
          style: 'advStyles',
          rel: 'advRel',
        };
      CKEDITOR.plugins.link = {
        getSelectedLink: function (a, b) {
          var d = a.getSelection(),
            e = d.getSelectedElement(),
            c = d.getRanges(),
            f = [],
            g;
          if (!b && e && e.is('a')) return e;
          for (e = 0; e < c.length; e++)
            if (
              ((g = d.getRanges()[e]),
              g.shrink(CKEDITOR.SHRINK_ELEMENT, !0, { skipBogus: !0 }),
              (g = a.elementPath(g.getCommonAncestor()).contains('a', 1)) && b)
            )
              f.push(g);
            else if (g) return g;
          return b ? f : null;
        },
        getEditorAnchors: function (a) {
          for (
            var b = a.editable(),
              d = b.isInline() && !a.plugins.divarea ? a.document : b,
              b = d.getElementsByTag('a'),
              d = d.getElementsByTag('img'),
              e = [],
              c = 0,
              f;
            (f = b.getItem(c++));

          )
            (f.data('cke-saved-name') || f.hasAttribute('name')) &&
              e.push({ name: f.data('cke-saved-name') || f.getAttribute('name'), id: f.getAttribute('id') });
          for (c = 0; (f = d.getItem(c++)); )
            (f = this.tryRestoreFakeAnchor(a, f)) && e.push({ name: f.getAttribute('name'), id: f.getAttribute('id') });
          return e;
        },
        fakeAnchor: !0,
        tryRestoreFakeAnchor: function (a, b) {
          if (b && b.data('cke-real-element-type') && 'anchor' == b.data('cke-real-element-type')) {
            var d = a.restoreRealElement(b);
            if (d.data('cke-saved-name')) return d;
          }
        },
        parseLinkAttributes: function (a, b) {
          var f = (b && (b.data('cke-saved-href') || b.getAttribute('href'))) || '',
            h = a.plugins.link.compiledProtectionFunction,
            y = a.config.emailProtection,
            v = {},
            C;
          f.match(c) &&
            ('encode' == y
              ? (f = f.replace(n, function (a, b, d) {
                  d = d || '';
                  return 'mailto:' + String.fromCharCode.apply(String, b.split(',')) + d.replace(/\\'/g, "'");
                }))
              : y &&
                f.replace(r, function (a, b, d) {
                  if (b == h.name) {
                    v.type = 'email';
                    a = v.email = {};
                    b = /(^')|('$)/g;
                    d = d.match(/[^,\s]+/g);
                    for (var e = d.length, c, f, g = 0; g < e; g++)
                      (c = decodeURIComponent),
                        (f = d[g].replace(b, '').replace(/\\'/g, "'")),
                        (f = c(f)),
                        (c = h.params[g].toLowerCase()),
                        (a[c] = f);
                    a.address = [a.name, a.domain].join('@');
                  }
                }));
          if (!v.type)
            if ((y = f.match(g))) (v.type = 'anchor'), (v.anchor = {}), (v.anchor.name = v.anchor.id = y[1]);
            else if ((y = f.match(p))) (v.type = 'tel'), (v.tel = y[1]);
            else if ((y = f.match(l))) {
              C = f.match(k);
              var f = f.match(m),
                F = (v.email = {});
              v.type = 'email';
              F.address = y[0].replace('mailto:', '');
              C && (F.subject = decodeURIComponent(C[1]));
              f && (F.body = decodeURIComponent(f[1]));
            } else f && (C = f.match(d)) && ((v.type = 'url'), (v.url = {}), (v.url.protocol = C[1]), (v.url.url = C[2]));
          if (b) {
            if ((f = b.getAttribute('target'))) v.target = { type: f.match(e) ? f : 'frame', name: f };
            else if ((f = (f = b.data('cke-pa-onclick') || b.getAttribute('onclick')) && f.match(x)))
              for (v.target = { type: 'popup', name: f[1] }; (y = u.exec(f[2])); )
                ('yes' != y[2] && '1' != y[2]) || y[1] in { height: 1, width: 1, top: 1, left: 1 }
                  ? isFinite(y[2]) && (v.target[y[1]] = y[2])
                  : (v.target[y[1]] = !0);
            null !== b.getAttribute('download') && (v.download = !0);
            var f = {},
              D;
            for (D in t) (y = b.getAttribute(D)) && (f[t[D]] = y);
            if ((D = b.data('cke-saved-name') || f.advName)) f.advName = D;
            CKEDITOR.tools.isEmpty(f) || (v.advanced = f);
          }
          return v;
        },
        getLinkAttributes: function (b, d) {
          var e = b.config.emailProtection || '',
            c = {};
          switch (d.type) {
            case 'url':
              var e = d.url && void 0 !== d.url.protocol ? d.url.protocol : 'http://',
                g = (d.url && CKEDITOR.tools.trim(d.url.url)) || '';
              c['data-cke-saved-href'] = 0 === g.indexOf('/') ? g : e + g;
              break;
            case 'anchor':
              e = d.anchor && d.anchor.id;
              c['data-cke-saved-href'] = '#' + ((d.anchor && d.anchor.name) || e || '');
              break;
            case 'email':
              var k = d.email,
                g = k.address;
              switch (e) {
                case '':
                case 'encode':
                  var l = encodeURIComponent(k.subject || ''),
                    m = encodeURIComponent(k.body || ''),
                    k = [];
                  l && k.push('subject\x3d' + l);
                  m && k.push('body\x3d' + m);
                  k = k.length ? '?' + k.join('\x26') : '';
                  'encode' == e
                    ? ((e = ["javascript:void(location.href\x3d'mailto:'+", h(g)]), k && e.push("+'", a(k), "'"), e.push(')'))
                    : (e = ['mailto:', g, k]);
                  break;
                default:
                  (e = g.split('@', 2)), (k.name = e[0]), (k.domain = e[1]), (e = ['javascript:', f(b, k)]);
              }
              c['data-cke-saved-href'] = e.join('');
              break;
            case 'tel':
              c['data-cke-saved-href'] = 'tel:' + d.tel;
          }
          if (d.target)
            if ('popup' == d.target.type) {
              for (
                var e = ["window.open(this.href, '", d.target.name || '', "', '"],
                  n = 'resizable status location toolbar menubar fullscreen scrollbars dependent'.split(' '),
                  g = n.length,
                  l = function (a) {
                    d.target[a] && n.push(a + '\x3d' + d.target[a]);
                  },
                  k = 0;
                k < g;
                k++
              )
                n[k] += d.target[n[k]] ? '\x3dyes' : '\x3dno';
              l('width');
              l('left');
              l('height');
              l('top');
              e.push(n.join(','), "'); return false;");
              c['data-cke-pa-onclick'] = e.join('');
            } else 'notSet' != d.target.type && d.target.name && (c.target = d.target.name);
          d.download && (c.download = '');
          if (d.advanced) {
            for (var p in t) (e = d.advanced[t[p]]) && (c[p] = e);
            c.name && (c['data-cke-saved-name'] = c.name);
          }
          c['data-cke-saved-href'] && (c.href = c['data-cke-saved-href']);
          p = { target: 1, onclick: 1, 'data-cke-pa-onclick': 1, 'data-cke-saved-name': 1, download: 1 };
          d.advanced && CKEDITOR.tools.extend(p, t);
          for (var r in c) delete p[r];
          return { set: c, removed: CKEDITOR.tools.object.keys(p) };
        },
        showDisplayTextForElement: function (a, b) {
          var d = { img: 1, table: 1, tbody: 1, thead: 1, tfoot: 1, input: 1, select: 1, textarea: 1 },
            e = b.getSelection();
          return (b.widgets && b.widgets.focused) || (e && 1 < e.getRanges().length) ? !1 : !a || !a.getName || !a.is(d);
        },
      };
      CKEDITOR.unlinkCommand = function () {};
      CKEDITOR.unlinkCommand.prototype = {
        exec: function (a) {
          if (CKEDITOR.env.ie) {
            var b = a.getSelection().getRanges()[0],
              d =
                (b.getPreviousEditableNode() && b.getPreviousEditableNode().getAscendant('a', !0)) ||
                (b.getNextEditableNode() && b.getNextEditableNode().getAscendant('a', !0)),
              e;
            b.collapsed && d && ((e = b.createBookmark()), b.selectNodeContents(d), b.select());
          }
          d = new CKEDITOR.style({ element: 'a', type: CKEDITOR.STYLE_INLINE, alwaysRemoveElement: 1 });
          a.removeStyle(d);
          e && (b.moveToBookmark(e), b.select());
        },
        refresh: function (a, b) {
          var d = b.lastElement && b.lastElement.getAscendant('a', !0);
          d && 'a' == d.getName() && d.getAttribute('href') && d.getChildCount()
            ? this.setState(CKEDITOR.TRISTATE_OFF)
            : this.setState(CKEDITOR.TRISTATE_DISABLED);
        },
        contextSensitive: 1,
        startDisabled: 1,
        requiredContent: 'a[href]',
        editorFocus: 1,
      };
      CKEDITOR.removeAnchorCommand = function () {};
      CKEDITOR.removeAnchorCommand.prototype = {
        exec: function (a) {
          var b = a.getSelection(),
            d = b.createBookmarks(),
            e;
          if (b && (e = b.getSelectedElement()) && (e.getChildCount() ? e.is('a') : CKEDITOR.plugins.link.tryRestoreFakeAnchor(a, e)))
            e.remove(1);
          else if ((e = CKEDITOR.plugins.link.getSelectedLink(a)))
            e.hasAttribute('href') ? (e.removeAttributes({ name: 1, 'data-cke-saved-name': 1 }), e.removeClass('cke_anchor')) : e.remove(1);
          b.selectBookmarks(d);
        },
        requiredContent: 'a[name]',
      };
      CKEDITOR.tools.extend(CKEDITOR.config, { linkShowAdvancedTab: !0, linkShowTargetTab: !0, linkDefaultProtocol: 'http://' });
    })();
    (function () {
      function a(a, b, d, e) {
        for (var c = CKEDITOR.plugins.list.listToArray(b.root, d), f = [], g = 0; g < b.contents.length; g++) {
          var h = b.contents[g];
          (h = h.getAscendant('li', !0)) &&
            !h.getCustomData('list_item_processed') &&
            (f.push(h), CKEDITOR.dom.element.setMarker(d, h, 'list_item_processed', !0));
        }
        for (var h = b.root.getDocument(), k, l, g = 0; g < f.length; g++) {
          var m = f[g].getCustomData('listarray_index');
          k = c[m].parent;
          k.is(this.type) ||
            ((l = h.createElement(this.type)),
            k.copyAttributes(l, { start: 1, type: 1 }),
            l.removeStyle('list-style-type'),
            (c[m].parent = l));
        }
        d = CKEDITOR.plugins.list.arrayToList(c, d, null, a.config.enterMode);
        for (var n, c = d.listNode.getChildCount(), g = 0; g < c && (n = d.listNode.getChild(g)); g++)
          n.getName() == this.type && e.push(n);
        d.listNode.replace(b.root);
        a.fire('contentDomInvalidated');
      }
      function h(a, b, d) {
        var e = b.contents,
          c = b.root.getDocument(),
          f = [];
        if (1 == e.length && e[0].equals(b.root)) {
          var g = c.createElement('div');
          e[0].moveChildren && e[0].moveChildren(g);
          e[0].append(g);
          e[0] = g;
        }
        b = b.contents[0].getParent();
        for (g = 0; g < e.length; g++) b = b.getCommonAncestor(e[g].getParent());
        a = a.config.useComputedState;
        for (var h, k, g = 0; g < e.length; g++)
          for (var l = e[g], m; (m = l.getParent()); ) {
            if (m.equals(b)) {
              f.push(l);
              !k && l.getDirection() && (k = 1);
              l = l.getDirection(a);
              null !== h && (h = h && h != l ? null : l);
              break;
            }
            l = m;
          }
        if (!(1 > f.length)) {
          e = f[f.length - 1].getNext();
          g = c.createElement(this.type);
          for (d.push(g); f.length; )
            (d = f.shift()),
              (a = c.createElement('li')),
              (l = d),
              l.is('pre') || u.test(l.getName()) || 'false' == l.getAttribute('contenteditable')
                ? d.appendTo(a)
                : (d.copyAttributes(a),
                  h && d.getDirection() && (a.removeStyle('direction'), a.removeAttribute('dir')),
                  d.moveChildren(a),
                  d.remove()),
              a.appendTo(g);
          h && k && g.setAttribute('dir', h);
          e ? g.insertBefore(e) : g.appendTo(b);
        }
      }
      function f(a, b, d) {
        function e(d) {
          if (
            !(
              !(l = k[d ? 'getFirst' : 'getLast']()) ||
              (l.is && l.isBlockBoundary()) ||
              !(m = b.root[d ? 'getPrevious' : 'getNext'](CKEDITOR.dom.walker.invisible(!0))) ||
              (m.is && m.isBlockBoundary({ br: 1 }))
            )
          )
            a.document.createElement('br')[d ? 'insertBefore' : 'insertAfter'](l);
        }
        for (var c = CKEDITOR.plugins.list.listToArray(b.root, d), f = [], g = 0; g < b.contents.length; g++) {
          var h = b.contents[g];
          (h = h.getAscendant('li', !0)) &&
            !h.getCustomData('list_item_processed') &&
            (f.push(h), CKEDITOR.dom.element.setMarker(d, h, 'list_item_processed', !0));
        }
        h = null;
        for (g = 0; g < f.length; g++) (h = f[g].getCustomData('listarray_index')), (c[h].indent = -1);
        for (g = h + 1; g < c.length; g++)
          if (c[g].indent > c[g - 1].indent + 1) {
            f = c[g - 1].indent + 1 - c[g].indent;
            for (h = c[g].indent; c[g] && c[g].indent >= h; ) (c[g].indent += f), g++;
            g--;
          }
        var k = CKEDITOR.plugins.list.arrayToList(c, d, null, a.config.enterMode, b.root.getAttribute('dir')).listNode,
          l,
          m;
        e(!0);
        e();
        k.replace(b.root);
        a.fire('contentDomInvalidated');
      }
      function b(a, b) {
        this.name = a;
        this.context = this.type = b;
        this.allowedContent = b + ' li';
        this.requiredContent = b;
      }
      function c(a, b, d, e) {
        for (var c, f; (c = a[e ? 'getLast' : 'getFirst'](p)); )
          (f = c.getDirection(1)) !== b.getDirection(1) && c.setAttribute('dir', f),
            c.remove(),
            d ? c[e ? 'insertBefore' : 'insertAfter'](d) : b.append(c, e),
            (d = c);
      }
      function l(a) {
        function b(d) {
          var e = a[d ? 'getPrevious' : 'getNext'](r);
          e && e.type == CKEDITOR.NODE_ELEMENT && e.is(a.getName()) && (c(a, e, null, !d), a.remove(), (a = e));
        }
        b();
        b(1);
      }
      function k(a) {
        return (
          a.type == CKEDITOR.NODE_ELEMENT &&
          (a.getName() in CKEDITOR.dtd.$block || a.getName() in CKEDITOR.dtd.$listItem) &&
          CKEDITOR.dtd[a.getName()]['#']
        );
      }
      function m(a, b, d) {
        a.fire('saveSnapshot');
        d.enlarge(CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS);
        var e = d.extractContents();
        b.trim(!1, !0);
        var f = b.createBookmark(),
          h = new CKEDITOR.dom.elementPath(b.startContainer),
          k = h.block,
          h = h.lastElement.getAscendant('li', 1) || k,
          m = new CKEDITOR.dom.elementPath(d.startContainer),
          n = m.contains(CKEDITOR.dtd.$listItem),
          m = m.contains(CKEDITOR.dtd.$list);
        k ? (k = k.getBogus()) && k.remove() : m && (k = m.getPrevious(r)) && x(k) && k.remove();
        (k = e.getLast()) && k.type == CKEDITOR.NODE_ELEMENT && k.is('br') && k.remove();
        (k = b.startContainer.getChild(b.startOffset)) ? e.insertBefore(k) : b.startContainer.append(e);
        n && (e = g(n)) && (h.contains(n) ? (c(e, n.getParent(), n), e.remove()) : h.append(e));
        for (; d.checkStartOfBlock() && d.checkEndOfBlock(); ) {
          m = d.startPath();
          e = m.block;
          if (!e) break;
          e.is('li') && ((h = e.getParent()), e.equals(h.getLast(r)) && e.equals(h.getFirst(r)) && (e = h));
          d.moveToPosition(e, CKEDITOR.POSITION_BEFORE_START);
          e.remove();
        }
        d = d.clone();
        e = a.editable();
        d.setEndAt(e, CKEDITOR.POSITION_BEFORE_END);
        d = new CKEDITOR.dom.walker(d);
        d.evaluator = function (a) {
          return r(a) && !x(a);
        };
        (d = d.next()) && d.type == CKEDITOR.NODE_ELEMENT && d.getName() in CKEDITOR.dtd.$list && l(d);
        b.moveToBookmark(f);
        b.select();
        a.fire('saveSnapshot');
      }
      function g(a) {
        return (a = a.getLast(r)) && a.type == CKEDITOR.NODE_ELEMENT && a.getName() in d ? a : null;
      }
      var d = { ol: 1, ul: 1 },
        e = CKEDITOR.dom.walker.whitespaces(),
        n = CKEDITOR.dom.walker.bookmark(),
        r = function (a) {
          return !(e(a) || n(a));
        },
        x = CKEDITOR.dom.walker.bogus();
      CKEDITOR.plugins.list = {
        listToArray: function (a, b, e, c, f) {
          if (!d[a.getName()]) return [];
          c || (c = 0);
          e || (e = []);
          for (var g = 0, h = a.getChildCount(); g < h; g++) {
            var k = a.getChild(g);
            k.type == CKEDITOR.NODE_ELEMENT && k.getName() in CKEDITOR.dtd.$list && CKEDITOR.plugins.list.listToArray(k, b, e, c + 1);
            if ('li' == k.$.nodeName.toLowerCase()) {
              var l = { parent: a, indent: c, element: k, contents: [] };
              f
                ? (l.grandparent = f)
                : ((l.grandparent = a.getParent()),
                  l.grandparent && 'li' == l.grandparent.$.nodeName.toLowerCase() && (l.grandparent = l.grandparent.getParent()));
              b && CKEDITOR.dom.element.setMarker(b, k, 'listarray_index', e.length);
              e.push(l);
              for (var m = 0, n = k.getChildCount(), p; m < n; m++)
                (p = k.getChild(m)),
                  p.type == CKEDITOR.NODE_ELEMENT && d[p.getName()]
                    ? CKEDITOR.plugins.list.listToArray(p, b, e, c + 1, l.grandparent)
                    : l.contents.push(p);
            }
          }
          return e;
        },
        arrayToList: function (a, b, e, c, f) {
          e || (e = 0);
          if (!a || a.length < e + 1) return null;
          for (
            var g,
              h = a[e].parent.getDocument(),
              k = new CKEDITOR.dom.documentFragment(h),
              l = null,
              m = e,
              p = Math.max(a[e].indent, 0),
              u = null,
              x,
              w,
              S = c == CKEDITOR.ENTER_P ? 'p' : 'div';
            ;

          ) {
            var I = a[m];
            g = I.grandparent;
            x = I.element.getDirection(1);
            if (I.indent == p) {
              (l && a[m].parent.getName() == l.getName()) || ((l = a[m].parent.clone(!1, 1)), f && l.setAttribute('dir', f), k.append(l));
              u = l.append(I.element.clone(0, 1));
              x != l.getDirection(1) && u.setAttribute('dir', x);
              for (g = 0; g < I.contents.length; g++) u.append(I.contents[g].clone(1, 1));
              m++;
            } else if (I.indent == Math.max(p, 0) + 1)
              (I = a[m - 1].element.getDirection(1)),
                (m = CKEDITOR.plugins.list.arrayToList(a, null, m, c, I != x ? x : null)),
                !u.getChildCount() && CKEDITOR.env.needsNbspFiller && 7 >= h.$.documentMode && u.append(h.createText(' ')),
                u.append(m.listNode),
                (m = m.nextIndex);
            else if (-1 == I.indent && !e && g) {
              d[g.getName()]
                ? ((u = I.element.clone(!1, !0)), x != g.getDirection(1) && u.setAttribute('dir', x))
                : (u = new CKEDITOR.dom.documentFragment(h));
              var l = g.getDirection(1) != x,
                E = I.element,
                P = E.getAttribute('class'),
                M = E.getAttribute('style'),
                O = u.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT && (c != CKEDITOR.ENTER_BR || l || M || P),
                N,
                X = I.contents.length,
                T;
              for (g = 0; g < X; g++)
                if (((N = I.contents[g]), n(N) && 1 < X)) O ? (T = N.clone(1, 1)) : u.append(N.clone(1, 1));
                else if (N.type == CKEDITOR.NODE_ELEMENT && N.isBlockBoundary()) {
                  l && !N.getDirection() && N.setAttribute('dir', x);
                  w = N;
                  var Y = E.getAttribute('style');
                  Y && w.setAttribute('style', Y.replace(/([^;])$/, '$1;') + (w.getAttribute('style') || ''));
                  P && N.addClass(P);
                  w = null;
                  T && (u.append(T), (T = null));
                  u.append(N.clone(1, 1));
                } else
                  O
                    ? (w || ((w = h.createElement(S)), u.append(w), l && w.setAttribute('dir', x)),
                      M && w.setAttribute('style', M),
                      P && w.setAttribute('class', P),
                      T && (w.append(T), (T = null)),
                      w.append(N.clone(1, 1)))
                    : u.append(N.clone(1, 1));
              T && ((w || u).append(T), (T = null));
              u.type == CKEDITOR.NODE_DOCUMENT_FRAGMENT &&
                m != a.length - 1 &&
                (CKEDITOR.env.needsBrFiller && (x = u.getLast()) && x.type == CKEDITOR.NODE_ELEMENT && x.is('br') && x.remove(),
                ((x = u.getLast(r)) && x.type == CKEDITOR.NODE_ELEMENT && x.is(CKEDITOR.dtd.$block)) || u.append(h.createElement('br')));
              x = u.$.nodeName.toLowerCase();
              ('div' != x && 'p' != x) || u.appendBogus();
              k.append(u);
              l = null;
              m++;
            } else return null;
            w = null;
            if (a.length <= m || Math.max(a[m].indent, 0) < p) break;
          }
          if (b)
            for (a = k.getFirst(); a; ) {
              if (
                a.type == CKEDITOR.NODE_ELEMENT &&
                (CKEDITOR.dom.element.clearMarkers(b, a),
                a.getName() in CKEDITOR.dtd.$listItem && ((e = a), (h = f = c = void 0), (c = e.getDirection())))
              ) {
                for (f = e.getParent(); f && !(h = f.getDirection()); ) f = f.getParent();
                c == h && e.removeAttribute('dir');
              }
              a = a.getNextSourceNode();
            }
          return { listNode: k, nextIndex: m };
        },
      };
      var u = /^h[1-6]$/,
        p = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT);
      b.prototype = {
        exec: function (b) {
          function e(a) {
            return d[a.root.getName()] && !c(a.root, [CKEDITOR.NODE_COMMENT]);
          }
          function c(a, b) {
            return CKEDITOR.tools.array.filter(a.getChildren().toArray(), function (a) {
              return -1 === CKEDITOR.tools.array.indexOf(b, a.type);
            }).length;
          }
          function g(a) {
            var b = !0;
            if (0 === a.getChildCount()) return !1;
            a.forEach(
              function (a) {
                if (a.type !== CKEDITOR.NODE_COMMENT) return (b = !1);
              },
              null,
              !0,
            );
            return b;
          }
          this.refresh(b, b.elementPath());
          var k = b.config,
            m = b.getSelection(),
            n = m && m.getRanges();
          if (this.state == CKEDITOR.TRISTATE_OFF) {
            var p = b.editable();
            if (p.getFirst(r)) {
              var u = 1 == n.length && n[0];
              (k = u && u.getEnclosedNode()) && k.is && this.type == k.getName() && this.setState(CKEDITOR.TRISTATE_ON);
            } else
              k.enterMode == CKEDITOR.ENTER_BR ? p.appendBogus() : n[0].fixBlock(1, k.enterMode == CKEDITOR.ENTER_P ? 'p' : 'div'),
                m.selectRanges(n);
          }
          for (var k = m.createBookmarks(!0), p = [], D = {}, n = n.createIterator(), x = 0; (u = n.getNextRange()) && ++x; ) {
            var w = u.getBoundaryNodes(),
              L = w.startNode,
              K = w.endNode;
            L.type == CKEDITOR.NODE_ELEMENT && 'td' == L.getName() && u.setStartAt(w.startNode, CKEDITOR.POSITION_AFTER_START);
            K.type == CKEDITOR.NODE_ELEMENT && 'td' == K.getName() && u.setEndAt(w.endNode, CKEDITOR.POSITION_BEFORE_END);
            u = u.createIterator();
            for (u.forceBrBreak = this.state == CKEDITOR.TRISTATE_OFF; (w = u.getNextParagraph()); )
              if (!w.getCustomData('list_block') && !g(w)) {
                CKEDITOR.dom.element.setMarker(D, w, 'list_block', 1);
                for (var S = b.elementPath(w), L = S.elements, K = 0, S = S.blockLimit, I, E = L.length - 1; 0 <= E && (I = L[E]); E--)
                  if (d[I.getName()] && S.contains(I)) {
                    S.removeCustomData('list_group_object_' + x);
                    (L = I.getCustomData('list_group_object'))
                      ? L.contents.push(w)
                      : ((L = { root: I, contents: [w] }), p.push(L), CKEDITOR.dom.element.setMarker(D, I, 'list_group_object', L));
                    K = 1;
                    break;
                  }
                K ||
                  ((K = S),
                  K.getCustomData('list_group_object_' + x)
                    ? K.getCustomData('list_group_object_' + x).contents.push(w)
                    : ((L = { root: K, contents: [w] }), CKEDITOR.dom.element.setMarker(D, K, 'list_group_object_' + x, L), p.push(L)));
              }
          }
          for (I = []; 0 < p.length; )
            (L = p.shift()),
              this.state == CKEDITOR.TRISTATE_OFF
                ? e(L) || (d[L.root.getName()] ? a.call(this, b, L, D, I) : h.call(this, b, L, I))
                : this.state == CKEDITOR.TRISTATE_ON && d[L.root.getName()] && !e(L) && f.call(this, b, L, D);
          for (E = 0; E < I.length; E++) l(I[E]);
          CKEDITOR.dom.element.clearAllMarkers(D);
          m.selectBookmarks(k);
          b.focus();
        },
        refresh: function (a, b) {
          var e = b.contains(d, 1),
            c = b.blockLimit || b.root;
          e && c.contains(e)
            ? this.setState(e.is(this.type) ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF)
            : this.setState(CKEDITOR.TRISTATE_OFF);
        },
      };
      CKEDITOR.plugins.add('list', {
        requires: 'indentlist',
        init: function (a) {
          a.blockless ||
            (a.addCommand('numberedlist', new b('numberedlist', 'ol')),
            a.addCommand('bulletedlist', new b('bulletedlist', 'ul')),
            a.ui.addButton &&
              (a.ui.addButton('NumberedList', {
                isToggle: !0,
                label: a.lang.list.numberedlist,
                command: 'numberedlist',
                directional: !0,
                toolbar: 'list,10',
              }),
              a.ui.addButton('BulletedList', {
                isToggle: !0,
                label: a.lang.list.bulletedlist,
                command: 'bulletedlist',
                directional: !0,
                toolbar: 'list,20',
              })),
            a.on('key', function (b) {
              var e = b.data.domEvent.getKey(),
                c;
              if ('wysiwyg' == a.mode && e in { 8: 1, 46: 1 }) {
                var f = a.getSelection().getRanges()[0],
                  h = f && f.startPath();
                if (f && f.collapsed) {
                  var l = 8 == e,
                    n = a.editable(),
                    p = new CKEDITOR.dom.walker(f.clone());
                  p.evaluator = function (a) {
                    return r(a) && !x(a);
                  };
                  p.guard = function (a, b) {
                    return !(b && a.type == CKEDITOR.NODE_ELEMENT && a.is('table'));
                  };
                  e = f.clone();
                  if (l) {
                    var u;
                    (u = h.contains(d)) && f.checkBoundaryOfElement(u, CKEDITOR.START) && (u = u.getParent()) && u.is('li') && (u = g(u))
                      ? ((c = u), (u = u.getPrevious(r)), e.moveToPosition(u && x(u) ? u : c, CKEDITOR.POSITION_BEFORE_START))
                      : (p.range.setStartAt(n, CKEDITOR.POSITION_AFTER_START),
                        p.range.setEnd(f.startContainer, f.startOffset),
                        (u = p.previous()) &&
                          u.type == CKEDITOR.NODE_ELEMENT &&
                          (u.getName() in d || u.is('li')) &&
                          (u.is('li') || (p.range.selectNodeContents(u), p.reset(), (p.evaluator = k), (u = p.previous())),
                          (c = u),
                          e.moveToElementEditEnd(c),
                          e.moveToPosition(e.endPath().block, CKEDITOR.POSITION_BEFORE_END)));
                    if (c) m(a, e, f), b.cancel();
                    else {
                      var w = h.contains(d);
                      w &&
                        f.checkBoundaryOfElement(w, CKEDITOR.START) &&
                        ((c = w.getFirst(r)),
                        f.checkBoundaryOfElement(c, CKEDITOR.START) &&
                          ((u = w.getPrevious(r)),
                          g(c) ? u && (f.moveToElementEditEnd(u), f.select()) : a.execCommand('outdent'),
                          b.cancel()));
                    }
                  } else if ((c = h.contains('li'))) {
                    if (
                      (p.range.setEndAt(n, CKEDITOR.POSITION_BEFORE_END),
                      (l = (n = c.getLast(r)) && k(n) ? n : c),
                      (h = 0),
                      (u = p.next()) && u.type == CKEDITOR.NODE_ELEMENT && u.getName() in d && u.equals(n)
                        ? ((h = 1), (u = p.next()))
                        : f.checkBoundaryOfElement(l, CKEDITOR.END) && (h = 2),
                      h && u)
                    ) {
                      f = f.clone();
                      f.moveToElementEditStart(u);
                      if (1 == h && (e.optimize(), !e.startContainer.equals(c))) {
                        for (c = e.startContainer; c.is(CKEDITOR.dtd.$inline); ) (w = c), (c = c.getParent());
                        w && e.moveToPosition(w, CKEDITOR.POSITION_AFTER_END);
                      }
                      2 == h &&
                        (e.moveToPosition(e.endPath().block, CKEDITOR.POSITION_BEFORE_END),
                        f.endPath().block && f.moveToPosition(f.endPath().block, CKEDITOR.POSITION_AFTER_START));
                      m(a, e, f);
                      b.cancel();
                    }
                  } else
                    p.range.setEndAt(n, CKEDITOR.POSITION_BEFORE_END),
                      (u = p.next()) &&
                        u.type == CKEDITOR.NODE_ELEMENT &&
                        u.is(d) &&
                        ((u = u.getFirst(r)),
                        h.block && f.checkStartOfBlock() && f.checkEndOfBlock()
                          ? (h.block.remove(), f.moveToElementEditStart(u), f.select())
                          : g(u)
                            ? (f.moveToElementEditStart(u), f.select())
                            : ((f = f.clone()), f.moveToElementEditStart(u), m(a, e, f)),
                        b.cancel());
                  setTimeout(function () {
                    a.selectionChange(1);
                  });
                }
              }
            }));
        },
      });
    })();
    (function () {
      CKEDITOR.plugins.liststyle = {
        requires: 'dialog,contextmenu',
        init: function (a) {
          if (!a.blockless) {
            var h;
            h = new CKEDITOR.dialogCommand('numberedListStyle', {
              requiredContent: 'ol',
              allowedContent: 'ol{list-style-type}[start]; li{list-style-type}[value]',
              contentTransformations: [['ol: listTypeToStyle']],
            });
            h = a.addCommand('numberedListStyle', h);
            a.addFeature(h);
            CKEDITOR.dialog.add('numberedListStyle', this.path + 'dialogs/liststyle.js');
            h = new CKEDITOR.dialogCommand('bulletedListStyle', {
              requiredContent: 'ul',
              allowedContent: 'ul{list-style-type}',
              contentTransformations: [['ul: listTypeToStyle']],
            });
            h = a.addCommand('bulletedListStyle', h);
            a.addFeature(h);
            CKEDITOR.dialog.add('bulletedListStyle', this.path + 'dialogs/liststyle.js');
            a.addMenuGroup('list', 108);
            a.addMenuItems({
              numberedlist: { label: a.lang.liststyle.numberedTitle, group: 'list', command: 'numberedListStyle' },
              bulletedlist: { label: a.lang.liststyle.bulletedTitle, group: 'list', command: 'bulletedListStyle' },
            });
            a.contextMenu.addListener(function (a) {
              if (!a || a.isReadOnly()) return null;
              for (; a; ) {
                var b = a.getName();
                if ('ol' == b) return { numberedlist: CKEDITOR.TRISTATE_OFF };
                if ('ul' == b) return { bulletedlist: CKEDITOR.TRISTATE_OFF };
                a = a.getParent();
              }
              return null;
            });
          }
        },
      };
      CKEDITOR.plugins.add('liststyle', CKEDITOR.plugins.liststyle);
    })();
    ('use strict');
    (function () {
      function a(a, b, d) {
        return (
          n(b) &&
          n(d) &&
          d.equals(
            b.getNext(function (a) {
              return !(aa(a) || ca(a) || r(a));
            }),
          )
        );
      }
      function h(a) {
        this.upper = a[0];
        this.lower = a[1];
        this.set.apply(this, a.slice(2));
      }
      function f(a) {
        var b = a.element;
        if (b && n(b) && (b = b.getAscendant(a.triggers, !0)) && a.editable.contains(b)) {
          var d = k(b);
          if ('true' == d.getAttribute('contenteditable')) return b;
          if (d.is(a.triggers)) return d;
        }
        return null;
      }
      function b(a, b, d) {
        z(a, b);
        z(a, d);
        a = b.size.bottom;
        d = d.size.top;
        return a && d ? 0 | ((a + d) / 2) : a || d;
      }
      function c(a, b, d) {
        return (b = b[d ? 'getPrevious' : 'getNext'](function (b) {
          return (b && b.type == CKEDITOR.NODE_TEXT && !aa(b)) || (n(b) && !r(b) && !e(a, b));
        }));
      }
      function l(a, b, d) {
        return a > b && a < d;
      }
      function k(a, b) {
        if (a.data('cke-editable')) return null;
        for (b || (a = a.getParent()); a && !a.data('cke-editable'); ) {
          if (a.hasAttribute('contenteditable')) return a;
          a = a.getParent();
        }
        return null;
      }
      function m(a) {
        var b = a.doc,
          d = G(
            '\x3cspan contenteditable\x3d"false" data-cke-magic-line\x3d"1" style\x3d"' +
              fa +
              'position:absolute;border-top:1px dashed ' +
              a.boxColor +
              '"\x3e\x3c/span\x3e',
            b,
          ),
          e = CKEDITOR.getUrl(this.path + 'images/' + (H.hidpi ? 'hidpi/' : '') + 'icon' + (a.rtl ? '-rtl' : '') + '.png');
        w(d, {
          attach: function () {
            this.wrap.getParent() || this.wrap.appendTo(a.editable, !0);
            return this;
          },
          lineChildren: [
            w(G('\x3cspan title\x3d"' + a.editor.lang.magicline.title + '" contenteditable\x3d"false"\x3e\x26#8629;\x3c/span\x3e', b), {
              base:
                fa +
                'height:17px;width:17px;' +
                (a.rtl ? 'left' : 'right') +
                ':17px;background:url(' +
                e +
                ') center no-repeat ' +
                a.boxColor +
                ';cursor:pointer;' +
                (H.hc ? 'font-size: 15px;line-height:14px;border:1px solid #fff;text-align:center;' : '') +
                (H.hidpi ? 'background-size: 9px 10px;' : ''),
              looks: [
                'top:-8px; border-radius: 2px;',
                'top:-17px; border-radius: 2px 2px 0px 0px;',
                'top:-1px; border-radius: 0px 0px 2px 2px;',
              ],
            }),
            w(G(ka, b), {
              base: ja + 'left:0px;border-left-color:' + a.boxColor + ';',
              looks: ['border-width:8px 0 8px 8px;top:-8px', 'border-width:8px 0 0 8px;top:-8px', 'border-width:0 0 8px 8px;top:0px'],
            }),
            w(G(ka, b), {
              base: ja + 'right:0px;border-right-color:' + a.boxColor + ';',
              looks: ['border-width:8px 8px 8px 0;top:-8px', 'border-width:8px 8px 0 0;top:-8px', 'border-width:0 8px 8px 0;top:0px'],
            }),
          ],
          detach: function () {
            this.wrap.getParent() && this.wrap.remove();
            return this;
          },
          mouseNear: function () {
            z(a, this);
            var b = a.holdDistance,
              d = this.size;
            return d && l(a.mouse.y, d.top - b, d.bottom + b) && l(a.mouse.x, d.left - b, d.right + b) ? !0 : !1;
          },
          place: function () {
            var b = a.view,
              d = a.editable,
              e = a.trigger,
              c = e.upper,
              f = e.lower,
              g = c || f,
              h = g.getParent(),
              k = {};
            this.trigger = e;
            c && z(a, c, !0);
            f && z(a, f, !0);
            z(a, h, !0);
            a.inInlineMode && y(a, !0);
            h.equals(d)
              ? ((k.left = b.scroll.x), (k.right = -b.scroll.x), (k.width = ''))
              : ((k.left = g.size.left - g.size.margin.left + b.scroll.x - (a.inInlineMode ? b.editable.left + b.editable.border.left : 0)),
                (k.width = g.size.outerWidth + g.size.margin.left + g.size.margin.right + b.scroll.x),
                (k.right = ''));
            c && f
              ? (k.top =
                  c.size.margin.bottom === f.size.margin.top
                    ? 0 | (c.size.bottom + c.size.margin.bottom / 2)
                    : c.size.margin.bottom < f.size.margin.top
                      ? c.size.bottom + c.size.margin.bottom
                      : c.size.bottom + c.size.margin.bottom - f.size.margin.top)
              : c
                ? f || (k.top = c.size.bottom + c.size.margin.bottom)
                : (k.top = f.size.top - f.size.margin.top);
            e.is(O) || l(k.top, b.scroll.y - 15, b.scroll.y + 5)
              ? ((k.top = a.inInlineMode ? 0 : b.scroll.y), this.look(O))
              : e.is(N) || l(k.top, b.pane.bottom - 5, b.pane.bottom + 15)
                ? ((k.top = a.inInlineMode ? b.editable.height + b.editable.padding.top + b.editable.padding.bottom : b.pane.bottom - 1),
                  this.look(N))
                : (a.inInlineMode && (k.top -= b.editable.top + b.editable.border.top), this.look(X));
            a.inInlineMode && (k.top--, (k.top += b.editable.scroll.top), (k.left += b.editable.scroll.left));
            for (var m in k) k[m] = CKEDITOR.tools.cssLength(k[m]);
            this.setStyles(k);
          },
          look: function (a) {
            if (this.oldLook != a) {
              for (var b = this.lineChildren.length, d; b--; )
                (d = this.lineChildren[b]).setAttribute('style', d.base + d.looks[0 | (a / 2)]);
              this.oldLook = a;
            }
          },
          wrap: new D('span', a.doc),
        });
        for (b = d.lineChildren.length; b--; ) d.lineChildren[b].appendTo(d);
        d.look(X);
        d.appendTo(d.wrap);
        d.unselectable();
        d.lineChildren[0].on('mouseup', function (b) {
          d.detach();
          g(
            a,
            function (b) {
              var d = a.line.trigger;
              b[d.is(I) ? 'insertBefore' : 'insertAfter'](d.is(I) ? d.lower : d.upper);
            },
            !0,
          );
          a.editor.focus();
          H.ie || a.enterMode == CKEDITOR.ENTER_BR || a.hotNode.scrollIntoView();
          b.data.preventDefault(!0);
        });
        d.on('mousedown', function (a) {
          a.data.preventDefault(!0);
        });
        a.line = d;
      }
      function g(a, b, d) {
        var e = new CKEDITOR.dom.range(a.doc),
          c = a.editor,
          f;
        H.ie && a.enterMode == CKEDITOR.ENTER_BR
          ? (f = a.doc.createText(T))
          : ((f = ((f = k(a.element, !0)) && f.data('cke-enter-mode')) || a.enterMode),
            (f = new D(S[f], a.doc)),
            f.is('br') || a.doc.createText(T).appendTo(f));
        d && c.fire('saveSnapshot');
        b(f);
        e.moveToPosition(f, CKEDITOR.POSITION_AFTER_START);
        c.getSelection().selectRanges([e]);
        a.hotNode = f;
        d && c.fire('saveSnapshot');
      }
      function d(a, b) {
        return {
          canUndo: !0,
          modes: { wysiwyg: 1 },
          exec: (function () {
            function d(e) {
              var c = H.ie && 9 > H.version ? ' ' : T,
                f = a.hotNode && a.hotNode.getText() == c && a.element.equals(a.hotNode) && a.lastCmdDirection === !!b;
              g(a, function (d) {
                f && a.hotNode && a.hotNode.remove();
                d[b ? 'insertAfter' : 'insertBefore'](e);
                d.setAttributes({ 'data-cke-magicline-hot': 1, 'data-cke-magicline-dir': !!b });
                a.lastCmdDirection = !!b;
              });
              H.ie || a.enterMode == CKEDITOR.ENTER_BR || a.hotNode.scrollIntoView();
              a.line.detach();
            }
            return function (e) {
              e = e.getSelection().getStartElement();
              var g;
              e = e.getAscendant(ha, 1);
              if (!p(a, e) && e && !e.equals(a.editable) && !e.contains(a.editable)) {
                (g = k(e)) && 'false' == g.getAttribute('contenteditable') && (e = g);
                a.element = e;
                g = c(a, e, !b);
                var h;
                n(g) && g.is(a.triggers) && g.is(U) && (!c(a, g, !b) || ((h = c(a, g, !b)) && n(h) && h.is(a.triggers)))
                  ? d(g)
                  : ((h = f(a, e)), n(h) && (c(a, h, !b) ? (e = c(a, h, !b)) && n(e) && e.is(a.triggers) && d(h) : d(h)));
              }
            };
          })(),
        };
      }
      function e(a, b) {
        if (!b || b.type != CKEDITOR.NODE_ELEMENT || !b.$) return !1;
        var d = a.line;
        return d.wrap.equals(b) || d.wrap.contains(b);
      }
      function n(a) {
        return a && a.type == CKEDITOR.NODE_ELEMENT && a.$;
      }
      function r(a) {
        if (!n(a)) return !1;
        var b;
        (b = x(a)) ||
          (n(a)
            ? ((b = { left: 1, right: 1, center: 1 }), (b = !(!b[a.getComputedStyle('float')] && !b[a.getAttribute('align')])))
            : (b = !1));
        return b;
      }
      function x(a) {
        return !!{ absolute: 1, fixed: 1 }[a.getComputedStyle('position')];
      }
      function u(a, b) {
        return n(b) ? b.is(a.triggers) : null;
      }
      function p(a, b) {
        if (!b) return !1;
        for (var d = b.getParents(1), e = d.length; e--; )
          for (var c = a.tabuList.length; c--; ) if (d[e].hasAttribute(a.tabuList[c])) return !0;
        return !1;
      }
      function t(a, b, d) {
        b = b[d ? 'getLast' : 'getFirst'](function (b) {
          return a.isRelevant(b) && !b.is(da);
        });
        if (!b) return !1;
        z(a, b);
        return d ? b.size.top > a.mouse.y : b.size.bottom < a.mouse.y;
      }
      function A(a) {
        var b = a.editable,
          d = a.mouse,
          c = a.view,
          f = a.triggerOffset;
        y(a);
        var g = d.y > (a.inInlineMode ? c.editable.top + c.editable.height / 2 : Math.min(c.editable.height, c.pane.height) / 2),
          b = b[g ? 'getLast' : 'getFirst'](function (a) {
            return !(aa(a) || ca(a));
          });
        if (!b) return null;
        e(a, b) &&
          (b = a.line.wrap[g ? 'getPrevious' : 'getNext'](function (a) {
            return !(aa(a) || ca(a));
          }));
        if (!n(b) || r(b) || !u(a, b)) return null;
        z(a, b);
        return !g && 0 <= b.size.top && l(d.y, 0, b.size.top + f)
          ? ((a = a.inInlineMode || 0 === c.scroll.y ? O : X), new h([null, b, I, M, a]))
          : g && b.size.bottom <= c.pane.height && l(d.y, b.size.bottom - f, c.pane.height)
            ? ((a = a.inInlineMode || l(b.size.bottom, c.pane.height - f, c.pane.height) ? N : X), new h([b, null, E, M, a]))
            : null;
      }
      function q(a) {
        var b = a.mouse,
          d = a.view,
          e = a.triggerOffset,
          g = f(a);
        if (!g) return null;
        z(a, g);
        var e = Math.min(e, 0 | (g.size.outerHeight / 2)),
          k = [],
          m,
          p;
        if (l(b.y, g.size.top - 1, g.size.top + e)) p = !1;
        else if (l(b.y, g.size.bottom - e, g.size.bottom + 1)) p = !0;
        else return null;
        if (r(g) || t(a, g, p) || g.getParent().is(Y)) return null;
        var v = c(a, g, !p);
        if (v) {
          if (v && v.type == CKEDITOR.NODE_TEXT) return null;
          if (n(v)) {
            if (r(v) || !u(a, v) || v.getParent().is(Y)) return null;
            k = [v, g][p ? 'reverse' : 'concat']().concat([P, M]);
          }
        } else
          g.equals(a.editable[p ? 'getLast' : 'getFirst'](a.isRelevant))
            ? (y(a),
              p && l(b.y, g.size.bottom - e, d.pane.height) && l(g.size.bottom, d.pane.height - e, d.pane.height)
                ? (m = N)
                : l(b.y, 0, g.size.top + e) && (m = O))
            : (m = X),
            (k = [null, g]
              [p ? 'reverse' : 'concat']()
              .concat([p ? E : I, M, m, g.equals(a.editable[p ? 'getLast' : 'getFirst'](a.isRelevant)) ? (p ? N : O) : X]));
        return 0 in k ? new h(k) : null;
      }
      function B(a, b, d, e) {
        for (var c = b.getDocumentPosition(), f = {}, g = {}, h = {}, k = {}, l = Q.length; l--; )
          (f[Q[l]] = parseInt(b.getComputedStyle.call(b, 'border-' + Q[l] + '-width'), 10) || 0),
            (h[Q[l]] = parseInt(b.getComputedStyle.call(b, 'padding-' + Q[l]), 10) || 0),
            (g[Q[l]] = parseInt(b.getComputedStyle.call(b, 'margin-' + Q[l]), 10) || 0);
        (d && !e) || v(a, e);
        k.top = c.y - (d ? 0 : a.view.scroll.y);
        k.left = c.x - (d ? 0 : a.view.scroll.x);
        k.outerWidth = b.$.offsetWidth;
        k.outerHeight = b.$.offsetHeight;
        k.height = k.outerHeight - (h.top + h.bottom + f.top + f.bottom);
        k.width = k.outerWidth - (h.left + h.right + f.left + f.right);
        k.bottom = k.top + k.outerHeight;
        k.right = k.left + k.outerWidth;
        a.inInlineMode && (k.scroll = { top: b.$.scrollTop, left: b.$.scrollLeft });
        return w({ border: f, padding: h, margin: g, ignoreScroll: d }, k, !0);
      }
      function z(a, b, d) {
        if (!n(b)) return (b.size = null);
        if (!b.size) b.size = {};
        else if (b.size.ignoreScroll == d && b.size.date > new Date() - ia) return null;
        return w(b.size, B(a, b, d), { date: +new Date() }, !0);
      }
      function y(a, b) {
        a.view.editable = B(a, a.editable, b, !0);
      }
      function v(a, b) {
        a.view || (a.view = {});
        var d = a.view;
        if (!(!b && d && d.date > new Date() - ia)) {
          var e = a.win,
            d = e.getScrollPosition(),
            e = e.getViewPaneSize();
          w(
            a.view,
            {
              scroll: {
                x: d.x,
                y: d.y,
                width: a.doc.$.documentElement.scrollWidth - e.width,
                height: a.doc.$.documentElement.scrollHeight - e.height,
              },
              pane: { width: e.width, height: e.height, bottom: e.height + d.y },
              date: +new Date(),
            },
            !0,
          );
        }
      }
      function C(a, b, d, e) {
        for (var c = e, f = e, g = 0, k = !1, l = !1, m = a.view.pane.height, n = a.mouse; n.y + g < m && 0 < n.y - g; ) {
          k || (k = b(c, e));
          l || (l = b(f, e));
          !k && 0 < n.y - g && (c = d(a, { x: n.x, y: n.y - g }));
          !l && n.y + g < m && (f = d(a, { x: n.x, y: n.y + g }));
          if (k && l) break;
          g += 2;
        }
        return new h([c, f, null, null]);
      }
      CKEDITOR.plugins.add('magicline', {
        init: function (a) {
          var b = a.config,
            k = b.magicline_triggerOffset || 30,
            l = {
              editor: a,
              enterMode: b.enterMode,
              triggerOffset: k,
              holdDistance: 0 | (k * (b.magicline_holdDistance || 0.5)),
              boxColor: b.magicline_color || '#ff0000',
              rtl: 'rtl' == b.contentsLangDirection,
              tabuList: ['data-cke-hidden-sel'].concat(b.magicline_tabuList || []),
              triggers: b.magicline_everywhere ? ha : { table: 1, hr: 1, div: 1, ul: 1, ol: 1, dl: 1, form: 1, blockquote: 1 },
            },
            t,
            u,
            C;
          l.isRelevant = function (a) {
            return n(a) && !e(l, a) && !r(a);
          };
          a.on(
            'contentDom',
            function () {
              var k = a.editable(),
                n = a.document,
                r = a.window;
              w(l, { editable: k, inInlineMode: k.isInline(), doc: n, win: r, hotNode: null }, !0);
              l.boundary = l.inInlineMode ? l.editable : l.doc.getDocumentElement();
              k.is(K.$inline) ||
                (l.inInlineMode && !x(k) && k.setStyles({ position: 'relative', top: null, left: null }),
                m.call(this, l),
                v(l),
                k.attachListener(a, 'beforeUndoImage', function () {
                  l.line.detach();
                }),
                k.attachListener(
                  a,
                  'beforeGetData',
                  function () {
                    l.line.wrap.getParent() &&
                      (l.line.detach(),
                      a.once(
                        'getData',
                        function () {
                          l.line.attach();
                        },
                        null,
                        null,
                        1e3,
                      ));
                  },
                  null,
                  null,
                  0,
                ),
                k.attachListener(l.inInlineMode ? n : n.getWindow().getFrame(), 'mouseout', function (b) {
                  if ('wysiwyg' == a.mode)
                    if (l.inInlineMode) {
                      var d = b.data.$.clientX;
                      b = b.data.$.clientY;
                      v(l);
                      y(l, !0);
                      var e = l.view.editable,
                        c = l.view.scroll;
                      (d > e.left - c.x && d < e.right - c.x && b > e.top - c.y && b < e.bottom - c.y) ||
                        (clearTimeout(C), (C = null), l.line.detach());
                    } else clearTimeout(C), (C = null), l.line.detach();
                }),
                k.attachListener(k, 'keyup', function () {
                  l.hiddenMode = 0;
                }),
                k.attachListener(k, 'keydown', function (b) {
                  if ('wysiwyg' == a.mode)
                    switch (b.data.getKeystroke()) {
                      case 2228240:
                      case 16:
                        (l.hiddenMode = 1), l.line.detach();
                    }
                }),
                k.attachListener(l.inInlineMode ? k : n, 'mousemove', function (b) {
                  u = !0;
                  if ('wysiwyg' == a.mode && !a.readOnly && !C) {
                    var d = { x: b.data.$.clientX, y: b.data.$.clientY };
                    C = setTimeout(function () {
                      l.mouse = d;
                      C = l.trigger = null;
                      v(l);
                      u &&
                        !l.hiddenMode &&
                        a.focusManager.hasFocus &&
                        !l.line.mouseNear() &&
                        (l.element = Z(l, !0)) &&
                        ((l.trigger = A(l) || q(l) || V(l)) && !p(l, l.trigger.upper || l.trigger.lower)
                          ? l.line.attach().place()
                          : ((l.trigger = null), l.line.detach()),
                        (u = !1));
                    }, 30);
                  }
                }),
                k.attachListener(r, 'scroll', function () {
                  'wysiwyg' == a.mode &&
                    (l.line.detach(),
                    H.webkit &&
                      ((l.hiddenMode = 1),
                      clearTimeout(t),
                      (t = setTimeout(function () {
                        l.mouseDown || (l.hiddenMode = 0);
                      }, 50))));
                }),
                k.attachListener(L ? n : r, 'mousedown', function () {
                  'wysiwyg' == a.mode && (l.line.detach(), (l.hiddenMode = 1), (l.mouseDown = 1));
                }),
                k.attachListener(L ? n : r, 'mouseup', function () {
                  l.hiddenMode = 0;
                  l.mouseDown = 0;
                }),
                a.addCommand('accessPreviousSpace', d(l)),
                a.addCommand('accessNextSpace', d(l, !0)),
                a.setKeystroke([
                  [b.magicline_keystrokePrevious, 'accessPreviousSpace'],
                  [b.magicline_keystrokeNext, 'accessNextSpace'],
                ]),
                a.on('loadSnapshot', function () {
                  var b, d, e, c;
                  for (c in { p: 1, br: 1, div: 1 })
                    for (b = a.document.getElementsByTag(c), e = b.count(); e--; )
                      if ((d = b.getItem(e)).data('cke-magicline-hot')) {
                        l.hotNode = d;
                        l.lastCmdDirection = 'true' === d.data('cke-magicline-dir') ? !0 : !1;
                        return;
                      }
                }),
                (a._.magiclineBackdoor = {
                  accessFocusSpace: g,
                  boxTrigger: h,
                  isLine: e,
                  getAscendantTrigger: f,
                  getNonEmptyNeighbour: c,
                  getSize: B,
                  that: l,
                  triggerEdge: q,
                  triggerEditable: A,
                  triggerExpand: V,
                }));
            },
            this,
          );
        },
      });
      var w = CKEDITOR.tools.extend,
        D = CKEDITOR.dom.element,
        G = D.createFromHtml,
        H = CKEDITOR.env,
        L = CKEDITOR.env.ie && 9 > CKEDITOR.env.version,
        K = CKEDITOR.dtd,
        S = {},
        I = 128,
        E = 64,
        P = 32,
        M = 16,
        O = 4,
        N = 2,
        X = 1,
        T = ' ',
        Y = K.$listItem,
        da = K.$tableContent,
        U = w({}, K.$nonEditable, K.$empty),
        ha = K.$block,
        ia = 100,
        fa =
          'width:0px;height:0px;padding:0px;margin:0px;display:block;z-index:9999;color:#fff;position:absolute;font-size: 0px;line-height:0px;',
        ja = fa + 'border-color:transparent;display:block;border-style:solid;',
        ka = '\x3cspan\x3e' + T + '\x3c/span\x3e';
      S[CKEDITOR.ENTER_BR] = 'br';
      S[CKEDITOR.ENTER_P] = 'p';
      S[CKEDITOR.ENTER_DIV] = 'div';
      h.prototype = {
        set: function (a, b, d) {
          this.properties = a + b + (d || X);
          return this;
        },
        is: function (a) {
          return (this.properties & a) == a;
        },
      };
      var Z = (function () {
          function a(b, d) {
            var e = b.$.elementFromPoint(d.x, d.y);
            return e && e.nodeType ? new CKEDITOR.dom.element(e) : null;
          }
          return function (b, d, c) {
            if (!b.mouse) return null;
            var f = b.doc,
              g = b.line.wrap;
            c = c || b.mouse;
            var h = a(f, c);
            d && e(b, h) && (g.hide(), (h = a(f, c)), g.show());
            return !h ||
              h.type != CKEDITOR.NODE_ELEMENT ||
              !h.$ ||
              (H.ie && 9 > H.version && !b.boundary.equals(h) && !b.boundary.contains(h))
              ? null
              : h;
          };
        })(),
        aa = CKEDITOR.dom.walker.whitespaces(),
        ca = CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_COMMENT),
        V = (function () {
          function d(e) {
            var f = e.element,
              g,
              h,
              k;
            if (!n(f) || f.contains(e.editable) || f.isReadOnly()) return null;
            k = C(
              e,
              function (a, b) {
                return !b.equals(a);
              },
              function (a, b) {
                return Z(a, !0, b);
              },
              f,
            );
            g = k.upper;
            h = k.lower;
            if (a(e, g, h)) return k.set(P, 8);
            if (g && f.contains(g)) for (; !g.getParent().equals(f); ) g = g.getParent();
            else
              g = f.getFirst(function (a) {
                return c(e, a);
              });
            if (h && f.contains(h)) for (; !h.getParent().equals(f); ) h = h.getParent();
            else
              h = f.getLast(function (a) {
                return c(e, a);
              });
            if (!g || !h) return null;
            z(e, g);
            z(e, h);
            if (!l(e.mouse.y, g.size.top, h.size.bottom)) return null;
            for (var f = Number.MAX_VALUE, m, J, p, v; h && !h.equals(g) && (J = g.getNext(e.isRelevant)); )
              (m = Math.abs(b(e, g, J) - e.mouse.y)), m < f && ((f = m), (p = g), (v = J)), (g = J), z(e, g);
            if (!p || !v || !l(e.mouse.y, p.size.top, v.size.bottom)) return null;
            k.upper = p;
            k.lower = v;
            return k.set(P, 8);
          }
          function c(a, b) {
            return !(
              (b && b.type == CKEDITOR.NODE_TEXT) ||
              ca(b) ||
              r(b) ||
              e(a, b) ||
              (b.type == CKEDITOR.NODE_ELEMENT && b.$ && b.is('br'))
            );
          }
          return function (b) {
            var e = d(b),
              c;
            if ((c = e)) {
              c = e.upper;
              var f = e.lower;
              c =
                !c || !f || r(f) || r(c) || f.equals(c) || c.equals(f) || f.contains(c) || c.contains(f)
                  ? !1
                  : u(b, c) && u(b, f) && a(b, c, f)
                    ? !0
                    : !1;
            }
            return c ? e : null;
          };
        })(),
        Q = ['top', 'left', 'right', 'bottom'];
    })();
    CKEDITOR.config.magicline_keystrokePrevious = CKEDITOR.CTRL + CKEDITOR.SHIFT + 51;
    CKEDITOR.config.magicline_keystrokeNext = CKEDITOR.CTRL + CKEDITOR.SHIFT + 52;
    (function () {
      function a(a) {
        if (!a || a.type != CKEDITOR.NODE_ELEMENT || 'form' != a.getName()) return [];
        for (var b = [], c = ['style', 'className'], f = 0; f < c.length; f++) {
          var d = a.$.elements.namedItem(c[f]);
          d && ((d = new CKEDITOR.dom.element(d)), b.push([d, d.nextSibling]), d.remove());
        }
        return b;
      }
      function h(a, b) {
        if (a && a.type == CKEDITOR.NODE_ELEMENT && 'form' == a.getName() && 0 < b.length)
          for (var c = b.length - 1; 0 <= c; c--) {
            var f = b[c][0],
              d = b[c][1];
            d ? f.insertBefore(d) : f.appendTo(a);
          }
      }
      function f(b, c) {
        var f = a(b),
          g = {},
          d = b.$;
        c || ((g['class'] = d.className || ''), (d.className = ''));
        g.inline = d.style.cssText || '';
        c || (d.style.cssText = 'position: static; overflow: visible');
        h(f);
        return g;
      }
      function b(b, c) {
        var f = a(b),
          g = b.$;
        'class' in c && (g.className = c['class']);
        'inline' in c && (g.style.cssText = c.inline);
        h(f);
      }
      function c(a) {
        if (!a.editable().isInline()) {
          var b = CKEDITOR.instances,
            c;
          for (c in b) {
            var f = b[c];
            'wysiwyg' != f.mode ||
              f.readOnly ||
              ((f = f.document.getBody()), f.setAttribute('contentEditable', !1), f.setAttribute('contentEditable', !0));
          }
          a.editable().hasFocus && (a.toolbox.focus(), a.focus());
        }
      }
      CKEDITOR.plugins.add('maximize', {
        init: function (a) {
          function h() {
            var b = d.getViewPaneSize();
            a.resize(b.width, b.height, null, !0);
          }
          if (a.elementMode != CKEDITOR.ELEMENT_MODE_INLINE) {
            var m = a.lang,
              g = CKEDITOR.document,
              d = g.getWindow(),
              e,
              n,
              r,
              x = CKEDITOR.TRISTATE_OFF;
            a.addCommand('maximize', {
              modes: { wysiwyg: !CKEDITOR.env.iOS, source: !CKEDITOR.env.iOS },
              readOnly: 1,
              editorFocus: !1,
              exec: function () {
                var m = a.container.getFirst(function (a) {
                    return a.type == CKEDITOR.NODE_ELEMENT && a.hasClass('cke_inner');
                  }),
                  p = a.ui.space('contents');
                if ('wysiwyg' == a.mode) {
                  var t = a.getSelection();
                  e = t && t.getRanges();
                  n = d.getScrollPosition();
                } else {
                  var A = a.editable().$;
                  e = !CKEDITOR.env.ie && [A.selectionStart, A.selectionEnd];
                  n = [A.scrollLeft, A.scrollTop];
                }
                if (this.state == CKEDITOR.TRISTATE_OFF) {
                  d.on('resize', h);
                  r = d.getScrollPosition();
                  for (t = a.container; (t = t.getParent()); )
                    t.setCustomData('maximize_saved_styles', f(t)), t.setStyle('z-index', a.config.baseFloatZIndex - 5);
                  p.setCustomData('maximize_saved_styles', f(p, !0));
                  m.setCustomData('maximize_saved_styles', f(m, !0));
                  p = { overflow: CKEDITOR.env.webkit ? '' : 'hidden', width: 0, height: 0 };
                  g.getDocumentElement().setStyles(p);
                  !CKEDITOR.env.gecko && g.getDocumentElement().setStyle('position', 'fixed');
                  (CKEDITOR.env.gecko && CKEDITOR.env.quirks) || g.getBody().setStyles(p);
                  CKEDITOR.env.ie
                    ? setTimeout(function () {
                        d.$.scrollTo(0, 0);
                      }, 0)
                    : d.$.scrollTo(0, 0);
                  m.setStyle('position', CKEDITOR.env.gecko && CKEDITOR.env.quirks ? 'fixed' : 'absolute');
                  m.$.offsetLeft;
                  m.setStyles({ 'z-index': a.config.baseFloatZIndex - 5, left: '0px', top: '0px' });
                  m.addClass('cke_maximized');
                  h();
                  p = m.getDocumentPosition();
                  m.setStyles({ left: -1 * p.x + 'px', top: -1 * p.y + 'px' });
                  CKEDITOR.env.gecko && c(a);
                } else if (this.state == CKEDITOR.TRISTATE_ON) {
                  d.removeListener('resize', h);
                  for (var t = [p, m], q = 0; q < t.length; q++)
                    b(t[q], t[q].getCustomData('maximize_saved_styles')), t[q].removeCustomData('maximize_saved_styles');
                  for (t = a.container; (t = t.getParent()); )
                    b(t, t.getCustomData('maximize_saved_styles')), t.removeCustomData('maximize_saved_styles');
                  CKEDITOR.env.ie
                    ? setTimeout(function () {
                        d.$.scrollTo(r.x, r.y);
                      }, 0)
                    : d.$.scrollTo(r.x, r.y);
                  m.removeClass('cke_maximized');
                  CKEDITOR.env.webkit &&
                    (m.setStyle('display', 'inline'),
                    setTimeout(function () {
                      m.setStyle('display', 'block');
                    }, 0));
                  a.fire('resize', {
                    outerHeight: a.container.$.offsetHeight,
                    contentsHeight: p.$.offsetHeight,
                    outerWidth: a.container.$.offsetWidth,
                  });
                }
                this.toggleState();
                'wysiwyg' == a.mode
                  ? e
                    ? (CKEDITOR.env.gecko && c(a),
                      a.getSelection().selectRanges(e),
                      (A = a.getSelection().getStartElement()) && A.scrollIntoView(!0))
                    : d.$.scrollTo(n.x, n.y)
                  : (e && ((A.selectionStart = e[0]), (A.selectionEnd = e[1])), (A.scrollLeft = n[0]), (A.scrollTop = n[1]));
                e = n = null;
                x = this.state;
                a.fire('maximize', this.state);
              },
              canUndo: !1,
            });
            a.ui.addButton &&
              a.ui.addButton('Maximize', { isToggle: !0, label: m.maximize.maximize, command: 'maximize', toolbar: 'tools,10' });
            a.on(
              'mode',
              function () {
                var b = a.getCommand('maximize');
                b.setState(b.state == CKEDITOR.TRISTATE_DISABLED ? CKEDITOR.TRISTATE_DISABLED : x);
              },
              null,
              null,
              100,
            );
            if (a.config.maximize_historyIntegration)
              d.on(a.config.maximize_historyIntegration === CKEDITOR.HISTORY_NATIVE ? 'popstate' : 'hashchange', function () {
                var b = a.getCommand('maximize');
                b.state === CKEDITOR.TRISTATE_ON && b.exec();
              });
          }
        },
      });
      CKEDITOR.config.maximize_historyIntegration = CKEDITOR.HISTORY_NATIVE;
    })();
    CKEDITOR.plugins.add('newpage', {
      init: function (a) {
        a.addCommand('newpage', {
          modes: { wysiwyg: 1, source: 1 },
          exec: function (a) {
            var f = this;
            a.setData(a.config.newpage_html || '', function () {
              a.focus();
              setTimeout(function () {
                a.fire('afterCommandExec', { name: 'newpage', command: f });
                a.selectionChange();
              }, 200);
            });
          },
          async: !0,
        });
        a.ui.addButton && a.ui.addButton('NewPage', { label: a.lang.newpage.toolbar, command: 'newpage', toolbar: 'document,20' });
      },
    });
    ('use strict');
    (function () {
      function a(a) {
        return {
          'aria-label': a,
          class: 'cke_pagebreak',
          contenteditable: 'false',
          'data-cke-display-name': 'pagebreak',
          'data-cke-pagebreak': 1,
          style: 'page-break-after: always',
          title: a,
        };
      }
      CKEDITOR.plugins.add('pagebreak', {
        requires: 'fakeobjects',
        onLoad: function () {
          var a = (
            'background:url(' +
            CKEDITOR.getUrl(this.path + 'images/pagebreak.gif') +
            ') no-repeat center center;clear:both;width:100%;border-top:#999 1px dotted;border-bottom:#999 1px dotted;padding:0;height:7px;cursor:default;'
          ).replace(/;/g, ' !important;');
          CKEDITOR.addCss('div.cke_pagebreak{' + a + '}');
        },
        init: function (a) {
          a.blockless ||
            (a.addCommand('pagebreak', CKEDITOR.plugins.pagebreakCmd),
            a.ui.addButton && a.ui.addButton('PageBreak', { label: a.lang.pagebreak.toolbar, command: 'pagebreak', toolbar: 'insert,70' }),
            CKEDITOR.env.webkit &&
              a.on('contentDom', function () {
                a.document.on('click', function (f) {
                  f = f.data.getTarget();
                  f.is('div') && f.hasClass('cke_pagebreak') && a.getSelection().selectElement(f);
                });
              }));
        },
        afterInit: function (h) {
          function f(b) {
            CKEDITOR.tools.extend(b.attributes, a(h.lang.pagebreak.alt), !0);
            b.children.length = 0;
          }
          var b = h.dataProcessor,
            c = b && b.dataFilter,
            b = b && b.htmlFilter,
            l = /page-break-after\s*:\s*always/i,
            k = /display\s*:\s*none/i;
          b &&
            b.addRules(
              {
                attributes: {
                  class: function (a, b) {
                    var d = a.replace('cke_pagebreak', '');
                    if (d != a) {
                      var e = CKEDITOR.htmlParser.fragment.fromHtml('\x3cspan style\x3d"display: none;"\x3e\x26nbsp;\x3c/span\x3e')
                        .children[0];
                      b.children.length = 0;
                      b.add(e);
                      e = b.attributes;
                      delete e['aria-label'];
                      delete e.contenteditable;
                      delete e.title;
                    }
                    return d;
                  },
                },
              },
              { applyToAll: !0, priority: 5 },
            );
          c &&
            c.addRules({
              elements: {
                div: function (a) {
                  if (a.attributes['data-cke-pagebreak']) f(a);
                  else if (l.test(a.attributes.style)) {
                    var b = a.children[0];
                    b && 'span' == b.name && k.test(b.attributes.style) && f(a);
                  }
                },
              },
            });
        },
      });
      CKEDITOR.plugins.pagebreakCmd = {
        exec: function (a) {
          a.insertElement(CKEDITOR.plugins.pagebreak.createElement(a));
        },
        context: 'div',
        allowedContent: {
          div: { styles: '!page-break-after' },
          span: {
            match: function (a) {
              return (a = a.parent) && 'div' == a.name && a.styles && a.styles['page-break-after'];
            },
            styles: 'display',
          },
        },
        requiredContent: 'div{page-break-after}',
      };
      CKEDITOR.plugins.pagebreak = {
        createElement: function (h) {
          return h.document.createElement('div', { attributes: a(h.lang.pagebreak.alt) });
        },
      };
    })();
    (function () {
      CKEDITOR.plugins.add('xml', {});
      CKEDITOR.xml = function (a) {
        var h = null;
        if ('object' == typeof a) h = a;
        else if (((a = (a || '').replace(/&nbsp;/g, ' ')), 'ActiveXObject' in window)) {
          try {
            h = new ActiveXObject('MSXML2.DOMDocument');
          } catch (f) {
            try {
              h = new ActiveXObject('Microsoft.XmlDom');
            } catch (b) {}
          }
          h && ((h.async = !1), (h.resolveExternals = !1), (h.validateOnParse = !1), h.loadXML(a));
        } else window.DOMParser && (h = new DOMParser().parseFromString(a, 'text/xml'));
        this.baseXml = h;
      };
      CKEDITOR.xml.prototype = {
        selectSingleNode: function (a, h) {
          var f = this.baseXml;
          if (h || (h = f)) {
            if ('selectSingleNode' in h) return h.selectSingleNode(a);
            if (f.evaluate) return ((f = f.evaluate(a, h, null, 9, null)) && f.singleNodeValue) || null;
          }
          return null;
        },
        selectNodes: function (a, h) {
          var f = this.baseXml,
            b = [];
          if (h || (h = f)) {
            if ('selectNodes' in h) return h.selectNodes(a);
            if (f.evaluate && (f = f.evaluate(a, h, null, 5, null))) for (var c; (c = f.iterateNext()); ) b.push(c);
          }
          return b;
        },
        getInnerXml: function (a, h) {
          var f = this.selectSingleNode(a, h),
            b = [];
          if (f)
            for (f = f.firstChild; f; )
              f.xml ? b.push(f.xml) : window.XMLSerializer && b.push(new XMLSerializer().serializeToString(f)), (f = f.nextSibling);
          return b.length ? b.join('') : null;
        },
      };
    })();
    (function () {
      CKEDITOR.plugins.add('ajax', { requires: 'xml' });
      CKEDITOR.ajax = (function () {
        function a() {
          if (!CKEDITOR.env.ie || 'file:' != location.protocol)
            try {
              return new XMLHttpRequest();
            } catch (a) {}
          try {
            return new ActiveXObject('Msxml2.XMLHTTP');
          } catch (b) {}
          try {
            return new ActiveXObject('Microsoft.XMLHTTP');
          } catch (f) {}
          return null;
        }
        function h(a, b) {
          if (4 != a.readyState || !((200 <= a.status && 300 > a.status) || 304 == a.status || 0 === a.status || 1223 == a.status))
            return null;
          switch (b) {
            case 'text':
              return a.responseText;
            case 'xml':
              var f = a.responseXML;
              return new CKEDITOR.xml(f && f.firstChild ? f : a.responseText);
            case 'arraybuffer':
              return a.response;
            default:
              return null;
          }
        }
        function f(b, f, k) {
          var m = !!f,
            g = a();
          if (!g) return null;
          m && 'text' !== k && 'xml' !== k && (g.responseType = k);
          g.open('GET', b, m);
          m &&
            (g.onreadystatechange = function () {
              4 == g.readyState && (f(h(g, k)), (g = null));
            });
          g.send(null);
          return m ? '' : h(g, k);
        }
        function b(b, f, k, m, g) {
          var d = a();
          if (!d) return null;
          d.open('POST', b, !0);
          d.onreadystatechange = function () {
            4 == d.readyState && (m && m(h(d, g)), (d = null));
          };
          d.setRequestHeader('Content-type', k || 'application/x-www-form-urlencoded; charset\x3dUTF-8');
          d.send(f);
        }
        return {
          load: function (a, b, h) {
            return f(a, b, h || 'text');
          },
          post: function (a, f, h, m) {
            return b(a, f, h, m, 'text');
          },
          loadXml: function (a, b) {
            return f(a, b, 'xml');
          },
          loadText: function (a, b) {
            return f(a, b, 'text');
          },
          loadBinary: function (a, b) {
            return f(a, b, 'arraybuffer');
          },
        };
      })();
    })();
    (function () {
      function a(a, b) {
        return CKEDITOR.tools.array
          .filter(a, function (a) {
            return a.canHandle(b);
          })
          .sort(function (a, b) {
            return a.priority === b.priority ? 0 : a.priority - b.priority;
          });
      }
      function h(a, b) {
        var c = a.shift();
        c &&
          c.handle(b, function () {
            h(a, b);
          });
      }
      function f(a) {
        var b = CKEDITOR.tools.array.reduce(
          a,
          function (a, b) {
            return CKEDITOR.tools.array.isArray(b.filters) ? a.concat(b.filters) : a;
          },
          [],
        );
        return CKEDITOR.tools.array.filter(b, function (a, d) {
          return CKEDITOR.tools.array.indexOf(b, a) === d;
        });
      }
      function b(a, b) {
        var f = 0,
          d,
          e;
        if (!CKEDITOR.tools.array.isArray(a) || 0 === a.length) return !0;
        d = CKEDITOR.tools.array.filter(a, function (a) {
          return -1 === CKEDITOR.tools.array.indexOf(c, a);
        });
        if (0 < d.length)
          for (e = 0; e < d.length; e++)
            (function (a) {
              CKEDITOR.scriptLoader.queue(a, function (e) {
                e && c.push(a);
                ++f === d.length && b();
              });
            })(d[e]);
        return 0 === d.length;
      }
      var c = [],
        l = CKEDITOR.tools.createClass({
          $: function () {
            this.handlers = [];
          },
          proto: {
            register: function (a) {
              'number' !== typeof a.priority && (a.priority = 10);
              this.handlers.push(a);
            },
            addPasteListener: function (c) {
              c.on(
                'paste',
                function (l) {
                  var g = a(this.handlers, l),
                    d;
                  if (0 !== g.length) {
                    d = f(g);
                    d = b(d, function () {
                      return c.fire('paste', l.data);
                    });
                    if (!d) return l.cancel();
                    h(g, l);
                  }
                },
                this,
                null,
                3,
              );
            },
          },
        });
      CKEDITOR.plugins.add('pastetools', {
        requires: ['clipboard', 'ajax'],
        beforeInit: function (a) {
          a.pasteTools = new l();
          a.pasteTools.addPasteListener(a);
        },
      });
      CKEDITOR.plugins.pastetools = {
        filters: {},
        loadFilters: b,
        createFilter: function (a) {
          var b = CKEDITOR.tools.array.isArray(a.rules) ? a.rules : [a.rules],
            c = a.additionalTransforms;
          return function (a, e) {
            var f = new CKEDITOR.htmlParser.basicWriter(),
              h = new CKEDITOR.htmlParser.filter(),
              k;
            c && (a = c(a, e));
            CKEDITOR.tools.array.forEach(b, function (b) {
              h.addRules(b(a, e, h));
            });
            k = CKEDITOR.htmlParser.fragment.fromHtml(a);
            h.applyTo(k);
            k.writeHtml(f);
            return f.getHtml();
          };
        },
        getClipboardData: function (a, b) {
          var c;
          return CKEDITOR.plugins.clipboard.isCustomDataTypesSupported || 'text/html' === b
            ? (c = a.dataTransfer.getData(b, !0)) || 'text/html' !== b
              ? c
              : a.dataValue
            : null;
        },
        getConfigValue: function (a, b) {
          if (a && a.config) {
            var c = CKEDITOR.tools,
              d = a.config,
              e = c.object.keys(d),
              f = ['pasteTools_' + b, 'pasteFromWord_' + b, 'pasteFromWord' + c.capitalize(b, !0)],
              f = c.array.find(f, function (a) {
                return -1 !== c.array.indexOf(e, a);
              });
            return d[f];
          }
        },
        getContentGeneratorName: function (a) {
          if ((a = /<meta\s+name=["']?generator["']?\s+content=["']?(\w+)/gi.exec(a)) && a.length)
            return (
              (a = a[1].toLowerCase()),
              0 === a.indexOf('microsoft') ? 'microsoft' : 0 === a.indexOf('libreoffice') ? 'libreoffice' : 'unknown'
            );
        },
      };
      CKEDITOR.pasteFilters = CKEDITOR.plugins.pastetools.filters;
    })();
    (function () {
      CKEDITOR.plugins.add('pastefromgdocs', {
        requires: 'pastetools',
        init: function (a) {
          var h = CKEDITOR.plugins.getPath('pastetools'),
            f = this.path;
          a.pasteTools.register({
            filters: [CKEDITOR.getUrl(h + 'filter/common.js'), CKEDITOR.getUrl(f + 'filter/default.js')],
            canHandle: function (a) {
              return /id=(\"|\')?docs\-internal\-guid\-/.test(a.data.dataValue);
            },
            handle: function (b, c) {
              var f = b.data,
                h = CKEDITOR.plugins.pastetools.getClipboardData(f, 'text/html');
              f.dontFilter = !0;
              f.dataValue = CKEDITOR.pasteFilters.gdocs(h, a);
              !0 === a.config.forcePasteAsPlainText && (f.type = 'text');
              c();
            },
          });
        },
      });
    })();
    (function () {
      CKEDITOR.plugins.add('pastefromlibreoffice', {
        requires: 'pastetools',
        isSupportedEnvironment: function () {
          var a = CKEDITOR.env.ie && 11 >= CKEDITOR.env.version;
          return !(CKEDITOR.env.webkit && !CKEDITOR.env.chrome) && !a;
        },
        init: function (a) {
          if (this.isSupportedEnvironment()) {
            var h = CKEDITOR.plugins.getPath('pastetools'),
              f = this.path;
            a.pasteTools.register({
              priority: 100,
              filters: [
                CKEDITOR.getUrl(h + 'filter/common.js'),
                CKEDITOR.getUrl(h + 'filter/image.js'),
                CKEDITOR.getUrl(f + 'filter/default.js'),
              ],
              canHandle: function (a) {
                a = a.data;
                return (a = a.dataTransfer.getData('text/html', !0) || a.dataValue)
                  ? 'libreoffice' === CKEDITOR.plugins.pastetools.getContentGeneratorName(a)
                  : !1;
              },
              handle: function (b, c) {
                var f = b.data,
                  h = f.dataValue || CKEDITOR.plugins.pastetools.getClipboardData(f, 'text/html');
                f.dontFilter = !0;
                h = CKEDITOR.pasteFilters.image(h, a, CKEDITOR.plugins.pastetools.getClipboardData(f, 'text/rtf'));
                f.dataValue = CKEDITOR.pasteFilters.libreoffice(h, a);
                !0 === a.config.forcePasteAsPlainText && (f.type = 'text');
                c();
              },
            });
          }
        },
      });
    })();
    (function () {
      CKEDITOR.plugins.add('pastefromword', {
        requires: 'pastetools',
        init: function (a) {
          var h = 0,
            f = CKEDITOR.plugins.getPath('pastetools'),
            b = this.path,
            c = void 0 === a.config.pasteFromWord_inlineImages ? !0 : a.config.pasteFromWord_inlineImages,
            f = [CKEDITOR.getUrl(f + 'filter/common.js'), CKEDITOR.getUrl(f + 'filter/image.js'), CKEDITOR.getUrl(b + 'filter/default.js')];
          a.addCommand('pastefromword', {
            canUndo: !1,
            async: !0,
            exec: function (a, b) {
              h = 1;
              a.execCommand('paste', { type: 'html', notification: b && 'undefined' !== typeof b.notification ? b.notification : !0 });
            },
          });
          CKEDITOR.plugins.clipboard.addPasteButton(a, 'PasteFromWord', {
            label: a.lang.pastefromword.toolbar,
            command: 'pastefromword',
            toolbar: 'clipboard,50',
          });
          a.pasteTools.register({
            filters: a.config.pasteFromWordCleanupFile ? [a.config.pasteFromWordCleanupFile] : f,
            canHandle: function (a) {
              a = CKEDITOR.plugins.pastetools.getClipboardData(a.data, 'text/html');
              var b = CKEDITOR.plugins.pastetools.getContentGeneratorName(a),
                c = /(class="?Mso|style=["'][^"]*?\bmso\-|w:WordDocument|<o:\w+>|<\/font>)/,
                b = b ? 'microsoft' === b : c.test(a);
              return a && (h || b);
            },
            handle: function (b, f) {
              var m = b.data,
                g = CKEDITOR.plugins.pastetools.getClipboardData(m, 'text/html'),
                d = CKEDITOR.plugins.pastetools.getClipboardData(m, 'text/rtf'),
                g = { dataValue: g, dataTransfer: { 'text/rtf': d } };
              if (!1 !== a.fire('pasteFromWord', g) || h) {
                m.dontFilter = !0;
                if (h || !a.config.pasteFromWordPromptCleanup || confirm(a.lang.pastefromword.confirmCleanup))
                  (g.dataValue = CKEDITOR.cleanWord(g.dataValue, a)),
                    CKEDITOR.plugins.clipboard.isCustomDataTypesSupported &&
                      c &&
                      CKEDITOR.pasteFilters.image &&
                      (g.dataValue = CKEDITOR.pasteFilters.image(g.dataValue, a, d)),
                    a.fire('afterPasteFromWord', g),
                    (m.dataValue = g.dataValue),
                    !0 === a.config.forcePasteAsPlainText
                      ? (m.type = 'text')
                      : CKEDITOR.plugins.clipboard.isCustomCopyCutSupported ||
                        'allow-word' !== a.config.forcePasteAsPlainText ||
                        (m.type = 'html');
                h = 0;
                f();
              }
            },
          });
        },
      });
    })();
    (function () {
      var a = {
        canUndo: !1,
        async: !0,
        exec: function (a, f) {
          var b = a.lang,
            c = CKEDITOR.tools.keystrokeToString(b.common.keyboard, a.getCommandKeystroke(CKEDITOR.env.ie ? a.commands.paste : this)),
            l =
              f && 'undefined' !== typeof f.notification
                ? f.notification
                : !f || !f.from || ('keystrokeHandler' === f.from && CKEDITOR.env.ie),
            b =
              l && 'string' === typeof l
                ? l
                : b.pastetext.pasteNotification.replace(/%1/, '\x3ckbd aria-label\x3d"' + c.aria + '"\x3e' + c.display + '\x3c/kbd\x3e');
          a.execCommand('paste', { type: 'text', notification: l ? b : !1 });
        },
      };
      CKEDITOR.plugins.add('pastetext', {
        requires: 'clipboard',
        init: function (h) {
          var f = CKEDITOR.env.safari ? CKEDITOR.CTRL + CKEDITOR.ALT + CKEDITOR.SHIFT + 86 : CKEDITOR.CTRL + CKEDITOR.SHIFT + 86;
          h.addCommand('pastetext', a);
          h.setKeystroke(f, 'pastetext');
          CKEDITOR.plugins.clipboard.addPasteButton(h, 'PasteText', {
            label: h.lang.pastetext.button,
            command: 'pastetext',
            toolbar: 'clipboard,40',
          });
          if (h.config.forcePasteAsPlainText)
            h.on('beforePaste', function (a) {
              'html' != a.data.type && (a.data.type = 'text');
            });
          h.on('pasteState', function (a) {
            h.getCommand('pastetext').setState(a.data);
          });
        },
      });
    })();
    (function () {
      function a(a, c) {
        var f = CKEDITOR.plugins.getPath('preview'),
          h = a.config,
          m = a.title,
          g = (function () {
            var a = location.origin,
              b = location.pathname;
            if (!h.baseHref && !CKEDITOR.env.gecko) return '';
            if (h.baseHref) return '\x3cbase href\x3d"{HREF}"\x3e'.replace('{HREF}', h.baseHref);
            b = b.split('/');
            b.pop();
            b = b.join('/');
            return '\x3cbase href\x3d"{HREF}"\x3e'.replace('{HREF}', a + b + '/');
          })();
        return h.fullPage
          ? a
              .getData()
              .replace(/<head>/, '$\x26' + g)
              .replace(/[^>]*(?=<\/title>)/, '$\x26 \x26mdash; ' + m)
          : h.docType +
              '\x3chtml dir\x3d"' +
              h.contentsLangDirection +
              '"\x3e\x3chead\x3e' +
              g +
              '\x3ctitle\x3e' +
              m +
              '\x3c/title\x3e' +
              CKEDITOR.tools.buildStyleHtml(h.contentsCss) +
              '\x3clink rel\x3d"stylesheet" media\x3d"screen" href\x3d"' +
              f +
              'styles/screen.css"\x3e\x3c/head\x3e' +
              (function () {
                var d = '\x3cbody\x3e',
                  e = a.document && a.document.getBody();
                if (!e) return d;
                e.getAttribute('id') && (d = d.replace('\x3e', ' id\x3d"' + e.getAttribute('id') + '"\x3e'));
                e.getAttribute('class') && (d = d.replace('\x3e', ' class\x3d"' + e.getAttribute('class') + '"\x3e'));
                return d;
              })() +
              a.getData() +
              (c
                ? '\x3cscript\x3e' +
                  (CKEDITOR.env.ie ? 'window.onload' : 'document.onreadystatechange') +
                  ' \x3d function() { previewCallback(); } \x3c/script\x3e'
                : '') +
              '\x3c/body\x3e\x3c/html\x3e';
      }
      function h() {
        var a = window.screen;
        return { width: Math.round(0.8 * a.width), height: Math.round(0.7 * a.height), left: Math.round(0.1 * a.width) };
      }
      function f() {
        var a = CKEDITOR.plugins.getPath('preview');
        return CKEDITOR.env.gecko ? CKEDITOR.getUrl(a + 'preview.html') : '';
      }
      CKEDITOR.plugins.add('preview', {
        init: function (a) {
          a.addCommand('preview', {
            modes: { wysiwyg: 1 },
            canUndo: !1,
            readOnly: 1,
            exec: function () {
              CKEDITOR.plugins.preview.createPreview(a);
            },
          });
          a.ui.addButton && a.ui.addButton('Preview', { label: a.lang.preview.preview, command: 'preview', toolbar: 'document,40' });
        },
      });
      CKEDITOR.plugins.preview = {
        createPreview: function (b, c) {
          var l = { dataValue: a(b, c) },
            k = h(),
            m;
          m =
            CKEDITOR.env.ie || CKEDITOR.env.gecko
              ? 'javascript:void( (function(){document.open();' +
                ('(' + CKEDITOR.tools.fixDomain + ')();').replace(/\/\/.*?\n/g, '').replace(/parent\./g, 'window.opener.') +
                'document.write( window.opener._cke_htmlToLoad );document.close();window.opener._cke_htmlToLoad \x3d null;})() )'
              : null;
          var g = f(),
            d,
            e;
          if (!1 === b.fire('contentPreview', l)) return !1;
          if (m || g) window._cke_htmlToLoad = l.dataValue;
          d = window.open(
            g,
            null,
            [
              'toolbar\x3dyes,location\x3dno,status\x3dyes,menubar\x3dyes,scrollbars\x3dyes,resizable\x3dyes',
              'width\x3d' + k.width,
              'height\x3d' + k.height,
              'left\x3d' + k.left,
            ].join(),
          );
          e = new CKEDITOR.dom.window(d);
          m && d && (d.location = m);
          window._cke_htmlToLoad || ((k = d.document), k.open(), k.write(l.dataValue), k.close());
          c &&
            ((d.previewCallback = function () {
              'complete' === d.document.readyState && c(e);
            }),
            d.previewCallback());
          return e;
        },
      };
    })();
    (function () {
      CKEDITOR.plugins.add('print', {
        requires: 'preview',
        init: function (a) {
          a.addCommand('print', CKEDITOR.plugins.print);
          a.ui.addButton && a.ui.addButton('Print', { label: a.lang.print.toolbar, command: 'print', toolbar: 'document,50' });
        },
      });
      CKEDITOR.plugins.print = {
        exec: function (a) {
          CKEDITOR.plugins.preview.createPreview(a, function (a) {
            a = a.$;
            CKEDITOR.env.gecko ? a.print() : a.document.execCommand('Print');
            a.close();
          });
        },
        canUndo: !1,
        readOnly: 1,
        modes: { wysiwyg: 1 },
      };
    })();
    CKEDITOR.plugins.add('removeformat', {
      init: function (a) {
        a.addCommand('removeFormat', CKEDITOR.plugins.removeformat.commands.removeformat);
        a.ui.addButton &&
          a.ui.addButton('RemoveFormat', { label: a.lang.removeformat.toolbar, command: 'removeFormat', toolbar: 'cleanup,10' });
      },
    });
    CKEDITOR.plugins.removeformat = {
      commands: {
        removeformat: {
          exec: function (a) {
            for (
              var h =
                  a._.removeFormatRegex ||
                  (a._.removeFormatRegex = new RegExp('^(?:' + a.config.removeFormatTags.replace(/,/g, '|') + ')$', 'i')),
                f = a._.removeAttributes || (a._.removeAttributes = a.config.removeFormatAttributes.split(',')),
                b = CKEDITOR.plugins.removeformat.filter,
                c = a.getSelection().getRanges(),
                l = c.createIterator(),
                k = function (a) {
                  return a.type == CKEDITOR.NODE_ELEMENT;
                },
                m;
              (m = l.getNextRange());

            ) {
              m.enlarge(CKEDITOR.ENLARGE_INLINE);
              var g = m.createBookmark(),
                d = g.startNode,
                e = g.endNode,
                n = function (d) {
                  for (var e = a.elementPath(d), c = e.elements, f = 1, g; (g = c[f]) && !g.equals(e.block) && !g.equals(e.blockLimit); f++)
                    h.test(g.getName()) && b(a, g) && d.breakParent(g);
                };
              n(d);
              if (e)
                for (n(e), d = d.getNextSourceNode(!0, CKEDITOR.NODE_ELEMENT); d && !d.equals(e); )
                  if (d.isReadOnly()) {
                    if (d.getPosition(e) & CKEDITOR.POSITION_CONTAINS) break;
                    d = d.getNext(k);
                  } else
                    (n = d.getNextSourceNode(!1, CKEDITOR.NODE_ELEMENT)),
                      ('img' == d.getName() && d.data('cke-realelement')) ||
                        !b(a, d) ||
                        (h.test(d.getName()) ? d.remove(1) : (d.removeAttributes(f), a.fire('removeFormatCleanup', d))),
                      (d = n);
              m.moveToBookmark(g);
            }
            a.forceNextSelectionCheck();
            a.getSelection().selectRanges(c);
          },
        },
      },
      filter: function (a, h) {
        for (var f = a._.removeFormatFilters || [], b = 0; b < f.length; b++) if (!1 === f[b](h)) return !1;
        return !0;
      },
    };
    CKEDITOR.editor.prototype.addRemoveFormatFilter = function (a) {
      this._.removeFormatFilters || (this._.removeFormatFilters = []);
      this._.removeFormatFilters.push(a);
    };
    CKEDITOR.config.removeFormatTags = 'b,big,cite,code,del,dfn,em,font,i,ins,kbd,q,s,samp,small,span,strike,strong,sub,sup,tt,u,var';
    CKEDITOR.config.removeFormatAttributes = 'class,style,lang,width,height,align,hspace,valign';
    CKEDITOR.plugins.add('resize', {
      init: function (a) {
        function h(c) {
          var f = g.width,
            h = g.height,
            k = f + (c.data.$.screenX - m.x) * ('rtl' == l ? -1 : 1);
          c = h + (c.data.$.screenY - m.y);
          d && (f = Math.max(b.resize_minWidth, Math.min(k, b.resize_maxWidth)));
          e && (h = Math.max(b.resize_minHeight, Math.min(c, b.resize_maxHeight)));
          a.resize(d ? f : null, h);
        }
        function f() {
          CKEDITOR.document.removeListener('mousemove', h);
          CKEDITOR.document.removeListener('mouseup', f);
          a.document && (a.document.removeListener('mousemove', h), a.document.removeListener('mouseup', f));
        }
        var b = a.config,
          c = a.ui.spaceId('resizer'),
          l = a.element ? a.element.getDirection(1) : 'ltr';
        !b.resize_dir && (b.resize_dir = 'vertical');
        void 0 === b.resize_maxWidth && (b.resize_maxWidth = 3e3);
        void 0 === b.resize_maxHeight && (b.resize_maxHeight = 3e3);
        void 0 === b.resize_minWidth && (b.resize_minWidth = 750);
        void 0 === b.resize_minHeight && (b.resize_minHeight = 250);
        if (!1 !== b.resize_enabled) {
          var k = null,
            m,
            g,
            d = ('both' == b.resize_dir || 'horizontal' == b.resize_dir) && b.resize_minWidth != b.resize_maxWidth,
            e = ('both' == b.resize_dir || 'vertical' == b.resize_dir) && b.resize_minHeight != b.resize_maxHeight,
            n = CKEDITOR.tools.addFunction(function (d) {
              k || (k = a.getResizable());
              g = { width: k.$.offsetWidth || 0, height: k.$.offsetHeight || 0 };
              m = { x: d.screenX, y: d.screenY };
              b.resize_minWidth > g.width && (b.resize_minWidth = g.width);
              b.resize_minHeight > g.height && (b.resize_minHeight = g.height);
              CKEDITOR.document.on('mousemove', h);
              CKEDITOR.document.on('mouseup', f);
              a.document && (a.document.on('mousemove', h), a.document.on('mouseup', f));
              d.preventDefault && d.preventDefault();
            });
          a.on('destroy', function () {
            CKEDITOR.tools.removeFunction(n);
          });
          a.on(
            'uiSpace',
            function (b) {
              if ('bottom' == b.data.space) {
                var f = '';
                d && !e && (f = ' cke_resizer_horizontal');
                !d && e && (f = ' cke_resizer_vertical');
                var g =
                  '\x3cspan id\x3d"' +
                  c +
                  '" class\x3d"cke_resizer' +
                  f +
                  ' cke_resizer_' +
                  l +
                  '" title\x3d"' +
                  CKEDITOR.tools.htmlEncode(a.lang.common.resize) +
                  '" onmousedown\x3d"CKEDITOR.tools.callFunction(' +
                  n +
                  ', event)"\x3e' +
                  ('ltr' == l ? '◢' : '◣') +
                  '\x3c/span\x3e';
                'ltr' == l && 'ltr' == f ? (b.data.html += g) : (b.data.html = g + b.data.html);
              }
            },
            a,
            null,
            100,
          );
          a.on('maximize', function (b) {
            a.ui.space('resizer')[b.data == CKEDITOR.TRISTATE_ON ? 'hide' : 'show']();
          });
        }
      },
    });
    (function () {
      var a = {
        readOnly: 1,
        modes: { wysiwyg: 1, source: 1 },
        exec: function (a) {
          if (a.fire('save') && (a = a.element.$.form))
            try {
              a.submit();
            } catch (f) {
              a.submit.click && a.submit.click();
            }
        },
      };
      CKEDITOR.plugins.add('save', {
        init: function (h) {
          h.elementMode == CKEDITOR.ELEMENT_MODE_REPLACE &&
            ((h.addCommand('save', a).startDisabled = !h.element.$.form),
            h.ui.addButton && h.ui.addButton('Save', { label: h.lang.save.toolbar, command: 'save', toolbar: 'document,10' }));
        },
      });
    })();
    ('use strict');
    CKEDITOR.plugins.add('scayt', {
      requires: 'menubutton,dialog',
      tabToOpen: null,
      dialogName: 'scaytDialog',
      onLoad: function (a) {
        'moono-lisa' == (CKEDITOR.skinName || a.config.skin) &&
          CKEDITOR.document.appendStyleSheet(CKEDITOR.getUrl(this.path + 'skins/' + CKEDITOR.skin.name + '/scayt.css'));
        CKEDITOR.document.appendStyleSheet(CKEDITOR.getUrl(this.path + 'dialogs/dialog.css'));
        var h = !1;
        CKEDITOR.on('instanceLoaded', function (a) {
          if (!h && CKEDITOR.plugins.autocomplete) {
            h = !0;
            var b = CKEDITOR.plugins.autocomplete.prototype.getModel;
            CKEDITOR.plugins.autocomplete.prototype.getModel = function (a) {
              var f = this.editor;
              a = b.bind(this)(a);
              a.on('change-isActive', function (a) {
                a.data ? f.fire('autocompletePanelShow') : f.fire('autocompletePanelHide');
              });
              return a;
            };
          }
        });
      },
      init: function (a) {
        var h = this,
          f = CKEDITOR.plugins.scayt;
        this.bindEvents(a);
        this.parseConfig(a);
        this.addRule(a);
        CKEDITOR.dialog.add(this.dialogName, CKEDITOR.getUrl(this.path + 'dialogs/options.js'));
        this.addMenuItems(a);
        var b = a.lang.scayt,
          c = CKEDITOR.env;
        a.ui.add('Scayt', CKEDITOR.UI_MENUBUTTON, {
          label: b.text_title,
          title: a.plugins.wsc ? a.lang.wsc.title : b.text_title,
          modes: { wysiwyg: !(c.ie && (8 > c.version || c.quirks)) },
          toolbar: 'spellchecker,20',
          refresh: function () {
            var b = a.ui.instances.Scayt.getState();
            a.scayt && (b = f.state.scayt[a.name] ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF);
            a.fire('scaytButtonState', b);
          },
          onRender: function () {
            var b = this;
            a.on('scaytButtonState', function (a) {
              void 0 !== typeof a.data && b.setState(a.data);
            });
          },
          onMenu: function () {
            var b = a.scayt;
            a.getMenuItem('scaytToggle').label = a.lang.scayt[b && f.state.scayt[a.name] ? 'btn_disable' : 'btn_enable'];
            var c = {
              scaytToggle: CKEDITOR.TRISTATE_OFF,
              scaytOptions: b ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
              scaytLangs: b ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
              scaytDict: b ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
              scaytAbout: b ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
              WSC: a.plugins.wsc ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
            };
            a.config.scayt_uiTabs[0] || delete c.scaytOptions;
            a.config.scayt_uiTabs[1] || delete c.scaytLangs;
            a.config.scayt_uiTabs[2] || delete c.scaytDict;
            b &&
              !CKEDITOR.plugins.scayt.isNewUdSupported(b) &&
              (delete c.scaytDict, (a.config.scayt_uiTabs[2] = 0), CKEDITOR.plugins.scayt.alarmCompatibilityMessage());
            return c;
          },
        });
        a.contextMenu &&
          a.addMenuItems &&
          (a.contextMenu.addListener(function (b, c) {
            var f = a.scayt,
              g,
              d;
            f &&
              (d = f.getSelectionNode()) &&
              ((g = h.menuGenerator(a, d)), f.showBanner('.' + a.contextMenu._.definition.panel.className.split(' ').join(' .')));
            return g;
          }),
          (a.contextMenu._.onHide = CKEDITOR.tools.override(a.contextMenu._.onHide, function (b) {
            return function () {
              var c = a.scayt;
              c && c.hideBanner();
              return b.apply(this);
            };
          })));
      },
      addMenuItems: function (a) {
        var h = this,
          f = CKEDITOR.plugins.scayt;
        a.addMenuGroup('scaytButton');
        for (var b = a.config.scayt_contextMenuItemsOrder.split('|'), c = 0; c < b.length; c++) b[c] = 'scayt_' + b[c];
        if ((b = ['grayt_description', 'grayt_suggest', 'grayt_control'].concat(b)) && b.length)
          for (c = 0; c < b.length; c++) a.addMenuGroup(b[c], c - 10);
        a.addCommand('scaytToggle', {
          exec: function (a) {
            var b = a.scayt;
            f.state.scayt[a.name] = !f.state.scayt[a.name];
            !0 === f.state.scayt[a.name] ? b || f.createScayt(a) : b && f.destroy(a);
          },
        });
        a.addCommand('scaytAbout', {
          exec: function (a) {
            a.scayt.tabToOpen = 'about';
            f.openDialog(h.dialogName, a);
          },
        });
        a.addCommand('scaytOptions', {
          exec: function (a) {
            a.scayt.tabToOpen = 'options';
            f.openDialog(h.dialogName, a);
          },
        });
        a.addCommand('scaytLangs', {
          exec: function (a) {
            a.scayt.tabToOpen = 'langs';
            f.openDialog(h.dialogName, a);
          },
        });
        a.addCommand('scaytDict', {
          exec: function (a) {
            a.scayt.tabToOpen = 'dictionaries';
            f.openDialog(h.dialogName, a);
          },
        });
        b = {
          scaytToggle: { label: a.lang.scayt.btn_enable, group: 'scaytButton', command: 'scaytToggle' },
          scaytAbout: { label: a.lang.scayt.btn_about, group: 'scaytButton', command: 'scaytAbout' },
          scaytOptions: { label: a.lang.scayt.btn_options, group: 'scaytButton', command: 'scaytOptions' },
          scaytLangs: { label: a.lang.scayt.btn_langs, group: 'scaytButton', command: 'scaytLangs' },
          scaytDict: { label: a.lang.scayt.btn_dictionaries, group: 'scaytButton', command: 'scaytDict' },
        };
        a.plugins.wsc &&
          (b.WSC = {
            label: a.lang.wsc.toolbar,
            group: 'scaytButton',
            onClick: function () {
              var b = CKEDITOR.plugins.scayt,
                c = a.scayt,
                f = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE ? a.container.getText() : a.document.getBody().getText();
              (f = f.replace(/\s/g, ''))
                ? (c && b.state.scayt[a.name] && c.setMarkupPaused && c.setMarkupPaused(!0), a.lockSelection(), a.execCommand('checkspell'))
                : alert('Nothing to check!');
            },
          });
        a.addMenuItems(b);
      },
      bindEvents: function (a) {
        var h = CKEDITOR.plugins.scayt,
          f = a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE,
          b = function () {
            h.destroy(a);
          },
          c = function () {
            !h.state.scayt[a.name] || a.readOnly || a.scayt || h.createScayt(a);
          },
          l = function () {
            var b = a.editable();
            b.attachListener(
              b,
              'focus',
              function (b) {
                CKEDITOR.plugins.scayt && !a.scayt && setTimeout(c, 0);
                b = CKEDITOR.plugins.scayt && CKEDITOR.plugins.scayt.state.scayt[a.name] && a.scayt;
                var d, e;
                if ((f || b) && a._.savedSelection) {
                  b = a._.savedSelection.getSelectedElement();
                  b = !b && a._.savedSelection.getRanges();
                  for (var h = 0; h < b.length; h++)
                    (e = b[h]),
                      'string' === typeof e.startContainer.$.nodeValue &&
                        ((d = e.startContainer.getText().length), (d < e.startOffset || d < e.endOffset) && a.unlockSelection(!1));
                }
              },
              this,
              null,
              -10,
            );
          },
          k = function () {
            f
              ? a.config.scayt_inlineModeImmediateMarkup
                ? c()
                : (a.on('blur', function () {
                    setTimeout(b, 0);
                  }),
                  a.on('focus', c),
                  a.focusManager.hasFocus && c())
              : c();
            l();
            var h = a.editable();
            h.attachListener(
              h,
              'mousedown',
              function (b) {
                b = b.data.getTarget();
                var d = a.widgets && a.widgets.getByElement(b);
                d &&
                  (d.wrapper = b.getAscendant(function (a) {
                    return a.hasAttribute('data-cke-widget-wrapper');
                  }, !0));
              },
              this,
              null,
              -10,
            );
          };
        a.on('contentDom', k);
        a.on('beforeCommandExec', function (b) {
          var c = a.scayt,
            d = !1,
            e = !1,
            f = !0;
          b.data.name in h.options.disablingCommandExec && 'wysiwyg' == a.mode
            ? c && (h.destroy(a), a.fire('scaytButtonState', CKEDITOR.TRISTATE_DISABLED))
            : ('bold' !== b.data.name &&
                'italic' !== b.data.name &&
                'underline' !== b.data.name &&
                'strike' !== b.data.name &&
                'subscript' !== b.data.name &&
                'superscript' !== b.data.name &&
                'enter' !== b.data.name &&
                'cut' !== b.data.name &&
                'language' !== b.data.name) ||
              !c ||
              ('cut' === b.data.name && ((f = !1), (e = !0)),
              'language' === b.data.name && (e = d = !0),
              a.fire('reloadMarkupScayt', { removeOptions: { removeInside: f, forceBookmark: e, language: d }, timeout: 0 }));
        });
        a.on('beforeSetMode', function (b) {
          if ('source' == b.data) {
            if ((b = a.scayt)) h.destroy(a), a.fire('scaytButtonState', CKEDITOR.TRISTATE_DISABLED);
            a.document && a.document.getBody().removeAttribute('_jquid');
          }
        });
        a.on('afterCommandExec', function (b) {
          'wysiwyg' != a.mode ||
            ('undo' != b.data.name && 'redo' != b.data.name) ||
            setTimeout(function () {
              h.reloadMarkup(a.scayt);
            }, 250);
        });
        a.on('readOnly', function (b) {
          var c;
          b &&
            ((c = a.scayt),
            !0 === b.editor.readOnly
              ? c && c.fire('removeMarkupInDocument', {})
              : c
                ? h.reloadMarkup(c)
                : 'wysiwyg' == b.editor.mode &&
                  !0 === h.state.scayt[b.editor.name] &&
                  (h.createScayt(a), b.editor.fire('scaytButtonState', CKEDITOR.TRISTATE_ON)));
        });
        a.on('beforeDestroy', b);
        a.on(
          'setData',
          function () {
            b();
            (a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE || a.plugins.divarea) && k();
          },
          this,
          null,
          50,
        );
        a.on('reloadMarkupScayt', function (b) {
          var c = b.data && b.data.removeOptions,
            d = b.data && b.data.timeout,
            e = b.data && b.data.language,
            f = a.scayt;
          f &&
            setTimeout(function () {
              e &&
                ((c.selectionNode = a.plugins.language.getCurrentLangElement(a)),
                (c.selectionNode = (c.selectionNode && c.selectionNode.$) || null));
              f.removeMarkupInSelectionNode(c);
              h.reloadMarkup(f);
            }, d || 0);
        });
        a.on(
          'insertElement',
          function () {
            a.fire('reloadMarkupScayt', { removeOptions: { forceBookmark: !0 } });
          },
          this,
          null,
          50,
        );
        a.on(
          'insertHtml',
          function () {
            a.scayt && a.scayt.setFocused && a.scayt.setFocused(!0);
            a.fire('reloadMarkupScayt');
          },
          this,
          null,
          50,
        );
        a.on(
          'insertText',
          function () {
            a.scayt && a.scayt.setFocused && a.scayt.setFocused(!0);
            a.fire('reloadMarkupScayt');
          },
          this,
          null,
          50,
        );
        a.on('scaytDialogShown', function (b) {
          b.data.selectPage(a.scayt.tabToOpen);
        });
        a.on('autocompletePanelShow', function (b) {
          (b = a.scayt) && b.setMarkupPaused && b.setMarkupPaused(!0);
        });
        a.on('autocompletePanelHide', function (b) {
          (b = a.scayt) && b.setMarkupPaused && b.setMarkupPaused(!1);
        });
      },
      parseConfig: function (a) {
        var h = CKEDITOR.plugins.scayt;
        h.replaceOldOptionsNames(a.config);
        'boolean' !== typeof a.config.scayt_autoStartup && (a.config.scayt_autoStartup = !1);
        h.state.scayt[a.name] = a.config.scayt_autoStartup;
        'boolean' !== typeof a.config.grayt_autoStartup && (a.config.grayt_autoStartup = !1);
        'boolean' !== typeof a.config.scayt_inlineModeImmediateMarkup && (a.config.scayt_inlineModeImmediateMarkup = !1);
        h.state.grayt[a.name] = a.config.grayt_autoStartup;
        a.config.scayt_contextCommands || (a.config.scayt_contextCommands = 'ignoreall|add');
        a.config.scayt_contextMenuItemsOrder || (a.config.scayt_contextMenuItemsOrder = 'suggest|moresuggest|control');
        a.config.scayt_sLang || (a.config.scayt_sLang = 'en_US');
        if (
          void 0 === a.config.scayt_maxSuggestions ||
          'number' != typeof a.config.scayt_maxSuggestions ||
          0 > a.config.scayt_maxSuggestions
        )
          a.config.scayt_maxSuggestions = 3;
        if (void 0 === a.config.scayt_minWordLength || 'number' != typeof a.config.scayt_minWordLength || 1 > a.config.scayt_minWordLength)
          a.config.scayt_minWordLength = 3;
        if (void 0 === a.config.scayt_customDictionaryIds || 'string' !== typeof a.config.scayt_customDictionaryIds)
          a.config.scayt_customDictionaryIds = '';
        if (void 0 === a.config.scayt_userDictionaryName || 'string' !== typeof a.config.scayt_userDictionaryName)
          a.config.scayt_userDictionaryName = null;
        if ('string' === typeof a.config.scayt_uiTabs && 3 === a.config.scayt_uiTabs.split(',').length) {
          var f = [],
            b = [];
          a.config.scayt_uiTabs = a.config.scayt_uiTabs.split(',');
          CKEDITOR.tools.search(a.config.scayt_uiTabs, function (a) {
            1 === Number(a) || 0 === Number(a) ? (b.push(!0), f.push(Number(a))) : b.push(!1);
          });
          null === CKEDITOR.tools.search(b, !1) ? (a.config.scayt_uiTabs = f) : (a.config.scayt_uiTabs = [1, 1, 1]);
        } else a.config.scayt_uiTabs = [1, 1, 1];
        'string' != typeof a.config.scayt_serviceProtocol && (a.config.scayt_serviceProtocol = null);
        'string' != typeof a.config.scayt_serviceHost && (a.config.scayt_serviceHost = null);
        'string' != typeof a.config.scayt_servicePort && (a.config.scayt_servicePort = null);
        'string' != typeof a.config.scayt_servicePath && (a.config.scayt_servicePath = null);
        a.config.scayt_moreSuggestions || (a.config.scayt_moreSuggestions = 'on');
        'string' !== typeof a.config.scayt_customerId &&
          (a.config.scayt_customerId = '1:WvF0D4-UtPqN1-43nkD4-NKvUm2-daQqk3-LmNiI-z7Ysb4-mwry24-T8YrS3-Q2tpq2');
        'string' !== typeof a.config.scayt_customPunctuation && (a.config.scayt_customPunctuation = '-');
        'string' !== typeof a.config.scayt_srcUrl &&
          (a.config.scayt_srcUrl = 'https://svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js');
        'boolean' !== typeof CKEDITOR.config.scayt_handleCheckDirty && (CKEDITOR.config.scayt_handleCheckDirty = !0);
        'boolean' !== typeof CKEDITOR.config.scayt_handleUndoRedo && (CKEDITOR.config.scayt_handleUndoRedo = !0);
        CKEDITOR.config.scayt_handleUndoRedo = CKEDITOR.plugins.undo ? CKEDITOR.config.scayt_handleUndoRedo : !1;
        a.config.scayt_ignoreAllCapsWords &&
          'boolean' !== typeof a.config.scayt_ignoreAllCapsWords &&
          (a.config.scayt_ignoreAllCapsWords = !1);
        a.config.scayt_ignoreDomainNames &&
          'boolean' !== typeof a.config.scayt_ignoreDomainNames &&
          (a.config.scayt_ignoreDomainNames = !1);
        a.config.scayt_ignoreWordsWithMixedCases &&
          'boolean' !== typeof a.config.scayt_ignoreWordsWithMixedCases &&
          (a.config.scayt_ignoreWordsWithMixedCases = !1);
        a.config.scayt_ignoreWordsWithNumbers &&
          'boolean' !== typeof a.config.scayt_ignoreWordsWithNumbers &&
          (a.config.scayt_ignoreWordsWithNumbers = !1);
        if (a.config.scayt_disableOptionsStorage) {
          var h = CKEDITOR.tools.isArray(a.config.scayt_disableOptionsStorage)
              ? a.config.scayt_disableOptionsStorage
              : 'string' === typeof a.config.scayt_disableOptionsStorage
                ? [a.config.scayt_disableOptionsStorage]
                : void 0,
            c = 'all options lang ignore-all-caps-words ignore-domain-names ignore-words-with-mixed-cases ignore-words-with-numbers'.split(
              ' ',
            ),
            l = ['lang', 'ignore-all-caps-words', 'ignore-domain-names', 'ignore-words-with-mixed-cases', 'ignore-words-with-numbers'],
            k = CKEDITOR.tools.search,
            m = CKEDITOR.tools.indexOf;
          a.config.scayt_disableOptionsStorage = (function (a) {
            for (var b = [], e = 0; e < a.length; e++) {
              var f = a[e],
                h = !!k(a, 'options');
              if (
                !k(c, f) ||
                (h &&
                  k(l, function (a) {
                    if ('lang' === a) return !1;
                  }))
              )
                return;
              k(l, f) && l.splice(m(l, f), 1);
              if ('all' === f || (h && k(a, 'lang'))) return [];
              'options' === f && (l = ['lang']);
            }
            return (b = b.concat(l));
          })(h);
        }
      },
      addRule: function (a) {
        var h = CKEDITOR.plugins.scayt,
          f = a.dataProcessor,
          b = f && f.htmlFilter,
          c = a._.elementsPath && a._.elementsPath.filters,
          f = f && f.dataFilter,
          l = a.addRemoveFormatFilter,
          k = function (b) {
            if (a.scayt && (b.hasAttribute(h.options.data_attribute_name) || b.hasAttribute(h.options.problem_grammar_data_attribute)))
              return !1;
          },
          m = function (b) {
            var d = !0;
            a.scayt &&
              (b.hasAttribute(h.options.data_attribute_name) || b.hasAttribute(h.options.problem_grammar_data_attribute)) &&
              (d = !1);
            return d;
          };
        c && c.push(k);
        f &&
          f.addRules({
            elements: {
              span: function (a) {
                var b = a.hasClass(h.options.misspelled_word_class) && a.attributes[h.options.data_attribute_name],
                  e = a.hasClass(h.options.problem_grammar_class) && a.attributes[h.options.problem_grammar_data_attribute];
                h && (b || e) && delete a.name;
                return a;
              },
            },
          });
        b &&
          b.addRules({
            elements: {
              span: function (a) {
                var b = a.hasClass(h.options.misspelled_word_class) && a.attributes[h.options.data_attribute_name],
                  e = a.hasClass(h.options.problem_grammar_class) && a.attributes[h.options.problem_grammar_data_attribute];
                h && (b || e) && delete a.name;
                return a;
              },
            },
          });
        l && l.call(a, m);
      },
      scaytMenuDefinition: function (a) {
        var h = this,
          f = CKEDITOR.plugins.scayt;
        a = a.scayt;
        return {
          scayt: {
            scayt_ignore: {
              label: a.getLocal('btn_ignore'),
              group: 'scayt_control',
              order: 1,
              exec: function (a) {
                a.scayt.ignoreWord();
              },
            },
            scayt_ignoreall: {
              label: a.getLocal('btn_ignoreAll'),
              group: 'scayt_control',
              order: 2,
              exec: function (a) {
                a.scayt.ignoreAllWords();
              },
            },
            scayt_add: {
              label: a.getLocal('btn_addWord'),
              group: 'scayt_control',
              order: 3,
              exec: function (a) {
                var c = a.scayt;
                setTimeout(function () {
                  c.addWordToUserDictionary();
                }, 10);
              },
            },
            scayt_option: {
              label: a.getLocal('btn_options'),
              group: 'scayt_control',
              order: 4,
              exec: function (a) {
                a.scayt.tabToOpen = 'options';
                f.openDialog(h.dialogName, a);
              },
              verification: function (a) {
                return 1 == a.config.scayt_uiTabs[0] ? !0 : !1;
              },
            },
            scayt_language: {
              label: a.getLocal('btn_langs'),
              group: 'scayt_control',
              order: 5,
              exec: function (a) {
                a.scayt.tabToOpen = 'langs';
                f.openDialog(h.dialogName, a);
              },
              verification: function (a) {
                return 1 == a.config.scayt_uiTabs[1] ? !0 : !1;
              },
            },
            scayt_dictionary: {
              label: a.getLocal('btn_dictionaries'),
              group: 'scayt_control',
              order: 6,
              exec: function (a) {
                a.scayt.tabToOpen = 'dictionaries';
                f.openDialog(h.dialogName, a);
              },
              verification: function (a) {
                return 1 == a.config.scayt_uiTabs[2] ? !0 : !1;
              },
            },
            scayt_about: {
              label: a.getLocal('btn_about'),
              group: 'scayt_control',
              order: 7,
              exec: function (a) {
                a.scayt.tabToOpen = 'about';
                f.openDialog(h.dialogName, a);
              },
            },
          },
          grayt: {
            grayt_problemdescription: {
              label: 'Grammar problem description',
              group: 'grayt_description',
              order: 1,
              state: CKEDITOR.TRISTATE_DISABLED,
              exec: function (a) {},
            },
            grayt_ignore: {
              label: a.getLocal('btn_ignore'),
              group: 'grayt_control',
              order: 2,
              exec: function (a) {
                a.scayt.ignorePhrase();
              },
            },
            grayt_ignoreall: {
              label: a.getLocal('btn_ignoreAll'),
              group: 'grayt_control',
              order: 3,
              exec: function (a) {
                a.scayt.ignoreAllPhrases();
              },
            },
          },
        };
      },
      buildSuggestionMenuItems: function (a, h, f) {
        var b = {},
          c = {},
          l = f ? 'word' : 'phrase',
          k = f ? 'startGrammarCheck' : 'startSpellCheck',
          m = a.scayt;
        if (0 < h.length && 'no_any_suggestions' !== h[0])
          if (f)
            for (f = 0; f < h.length; f++) {
              var g = 'scayt_suggest_' + CKEDITOR.plugins.scayt.suggestions[f].replace(' ', '_');
              a.addCommand(g, this.createCommand(CKEDITOR.plugins.scayt.suggestions[f], l, k));
              f < a.config.scayt_maxSuggestions
                ? (a.addMenuItem(g, { label: h[f], command: g, group: 'scayt_suggest', order: f + 1 }), (b[g] = CKEDITOR.TRISTATE_OFF))
                : (a.addMenuItem(g, { label: h[f], command: g, group: 'scayt_moresuggest', order: f + 1 }),
                  (c[g] = CKEDITOR.TRISTATE_OFF),
                  'on' === a.config.scayt_moreSuggestions &&
                    (a.addMenuItem('scayt_moresuggest', {
                      label: m.getLocal('btn_moreSuggestions'),
                      group: 'scayt_moresuggest',
                      order: 10,
                      getItems: function () {
                        return c;
                      },
                    }),
                    (b.scayt_moresuggest = CKEDITOR.TRISTATE_OFF)));
            }
          else
            for (f = 0; f < h.length; f++)
              (g = 'grayt_suggest_' + CKEDITOR.plugins.scayt.suggestions[f].replace(' ', '_')),
                a.addCommand(g, this.createCommand(CKEDITOR.plugins.scayt.suggestions[f], l, k)),
                a.addMenuItem(g, { label: h[f], command: g, group: 'grayt_suggest', order: f + 1 }),
                (b[g] = CKEDITOR.TRISTATE_OFF);
        else
          (b.no_scayt_suggest = CKEDITOR.TRISTATE_DISABLED),
            a.addCommand('no_scayt_suggest', { exec: function () {} }),
            a.addMenuItem('no_scayt_suggest', {
              label: m.getLocal('btn_noSuggestions') || 'no_scayt_suggest',
              command: 'no_scayt_suggest',
              group: 'scayt_suggest',
              order: 0,
            });
        return b;
      },
      menuGenerator: function (a, h) {
        var f = a.scayt,
          b = this.scaytMenuDefinition(a),
          c = {},
          l = a.config.scayt_contextCommands.split('|'),
          k = h.getAttribute(f.getLangAttribute()) || f.getLang(),
          m,
          g,
          d,
          e;
        g = f.isScaytNode(h);
        d = f.isGraytNode(h);
        g
          ? ((b = b.scayt),
            (m = h.getAttribute(f.getScaytNodeAttributeName())),
            f.fire('getSuggestionsList', { lang: k, word: m }),
            (c = this.buildSuggestionMenuItems(a, CKEDITOR.plugins.scayt.suggestions, g)))
          : d &&
            ((b = b.grayt),
            (c = h.getAttribute(f.getGraytNodeAttributeName())),
            f.getGraytNodeRuleAttributeName
              ? ((m = h.getAttribute(f.getGraytNodeRuleAttributeName())), f.getProblemDescriptionText(c, m, k))
              : f.getProblemDescriptionText(c, k),
            (e = f.getProblemDescriptionText(c, m, k)),
            b.grayt_problemdescription && e && ((e = e.replace(/([.!?])\s/g, '$1\x3cbr\x3e')), (b.grayt_problemdescription.label = e)),
            f.fire('getGrammarSuggestionsList', { lang: k, phrase: c, rule: m }),
            (c = this.buildSuggestionMenuItems(a, CKEDITOR.plugins.scayt.suggestions, g)));
        if (g && 'off' == a.config.scayt_contextCommands) return c;
        for (var n in b)
          (g && -1 == CKEDITOR.tools.indexOf(l, n.replace('scayt_', '')) && 'all' != a.config.scayt_contextCommands) ||
            (d &&
              'grayt_problemdescription' !== n &&
              -1 == CKEDITOR.tools.indexOf(l, n.replace('grayt_', '')) &&
              'all' != a.config.scayt_contextCommands) ||
            ((c[n] = 'undefined' != typeof b[n].state ? b[n].state : CKEDITOR.TRISTATE_OFF),
            'function' !== typeof b[n].verification || b[n].verification(a) || delete c[n],
            a.addCommand(n, { exec: b[n].exec }),
            a.addMenuItem(n, { label: a.lang.scayt[b[n].label] || b[n].label, command: n, group: b[n].group, order: b[n].order }));
        return c;
      },
      createCommand: function (a, h, f) {
        return {
          exec: function (b) {
            b = b.scayt;
            var c = {};
            c[h] = a;
            b.replaceSelectionNode(c);
            'startGrammarCheck' === f && b.removeMarkupInSelectionNode({ grammarOnly: !0 });
            b.fire(f);
          },
        };
      },
    });
    CKEDITOR.plugins.scayt = {
      charsToObserve: [
        {
          charName: 'cke-fillingChar',
          charCode: (function () {
            var a = CKEDITOR.version,
              h = [4, 5, 6],
              f = String.fromCharCode(8203),
              b = Array(8).join(f),
              c,
              l;
            if (!a) return f;
            for (var a = a.split('.'), k = 0; k < h.length; k++) {
              c = h[k];
              l = Number(a[k]);
              if (l > c) return b;
              if (l < c) break;
            }
            return f;
          })(),
        },
      ],
      state: { scayt: {}, grayt: {} },
      warningCounter: 0,
      suggestions: [],
      options: {
        disablingCommandExec: { source: !0, newpage: !0, templates: !0 },
        data_attribute_name: 'data-scayt-word',
        misspelled_word_class: 'scayt-misspell-word',
        problem_grammar_data_attribute: 'data-grayt-phrase',
        problem_grammar_class: 'gramm-problem',
      },
      backCompatibilityMap: {
        scayt_service_protocol: 'scayt_serviceProtocol',
        scayt_service_host: 'scayt_serviceHost',
        scayt_service_port: 'scayt_servicePort',
        scayt_service_path: 'scayt_servicePath',
        scayt_customerid: 'scayt_customerId',
      },
      openDialog: function (a, h) {
        var f = h.scayt;
        (f.isAllModulesReady && !1 === f.isAllModulesReady()) || (h.lockSelection(), h.openDialog(a));
      },
      alarmCompatibilityMessage: function () {
        5 > this.warningCounter &&
          (console.warn(
            'You are using the latest version of SCAYT plugin for CKEditor with the old application version. In order to have access to the newest features, it is recommended to upgrade the application version to latest one as well. Contact us for more details at support@webspellchecker.net.',
          ),
          (this.warningCounter += 1));
      },
      isNewUdSupported: function (a) {
        return a.getUserDictionary ? !0 : !1;
      },
      reloadMarkup: function (a) {
        var h;
        a &&
          ((h = a.getScaytLangList()),
          a.reloadMarkup
            ? a.reloadMarkup()
            : (this.alarmCompatibilityMessage(), h && h.ltr && h.rtl && a.fire('startSpellCheck, startGrammarCheck')));
      },
      replaceOldOptionsNames: function (a) {
        for (var h in a) h in this.backCompatibilityMap && ((a[this.backCompatibilityMap[h]] = a[h]), delete a[h]);
      },
      createScayt: function (a) {
        var h = this,
          f = CKEDITOR.plugins.scayt;
        this.loadScaytLibrary(a, function (a) {
          function c(a) {
            return new SCAYT.CKSCAYT(
              a,
              function () {},
              function () {},
            );
          }
          var l;
          a.window && (l = 'BODY' == a.editable().$.nodeName ? a.window.getFrame() : a.editable());
          if (l) {
            l = {
              lang: a.config.scayt_sLang,
              container: l.$,
              customDictionary: a.config.scayt_customDictionaryIds,
              userDictionaryName: a.config.scayt_userDictionaryName,
              localization: a.langCode,
              customer_id: a.config.scayt_customerId,
              customPunctuation: a.config.scayt_customPunctuation,
              debug: a.config.scayt_debug,
              data_attribute_name: h.options.data_attribute_name,
              misspelled_word_class: h.options.misspelled_word_class,
              problem_grammar_data_attribute: h.options.problem_grammar_data_attribute,
              problem_grammar_class: h.options.problem_grammar_class,
              'options-to-restore': a.config.scayt_disableOptionsStorage,
              focused: a.editable().hasFocus,
              ignoreElementsRegex: a.config.scayt_elementsToIgnore,
              ignoreGraytElementsRegex: a.config.grayt_elementsToIgnore,
              minWordLength: a.config.scayt_minWordLength,
              graytAutoStartup: a.config.grayt_autoStartup,
              charsToObserve: f.charsToObserve,
            };
            a.config.scayt_serviceProtocol && (l.service_protocol = a.config.scayt_serviceProtocol);
            a.config.scayt_serviceHost && (l.service_host = a.config.scayt_serviceHost);
            a.config.scayt_servicePort && (l.service_port = a.config.scayt_servicePort);
            a.config.scayt_servicePath && (l.service_path = a.config.scayt_servicePath);
            'boolean' === typeof a.config.scayt_ignoreAllCapsWords && (l['ignore-all-caps-words'] = a.config.scayt_ignoreAllCapsWords);
            'boolean' === typeof a.config.scayt_ignoreDomainNames && (l['ignore-domain-names'] = a.config.scayt_ignoreDomainNames);
            'boolean' === typeof a.config.scayt_ignoreWordsWithMixedCases &&
              (l['ignore-words-with-mixed-cases'] = a.config.scayt_ignoreWordsWithMixedCases);
            'boolean' === typeof a.config.scayt_ignoreWordsWithNumbers &&
              (l['ignore-words-with-numbers'] = a.config.scayt_ignoreWordsWithNumbers);
            var k;
            try {
              k = c(l);
            } catch (m) {
              h.alarmCompatibilityMessage(), delete l.charsToObserve, (k = c(l));
            }
            k.subscribe('suggestionListSend', function (a) {
              for (var b = {}, e = [], c = 0; c < a.suggestionList.length; c++)
                b['word_' + a.suggestionList[c]] || ((b['word_' + a.suggestionList[c]] = a.suggestionList[c]), e.push(a.suggestionList[c]));
              CKEDITOR.plugins.scayt.suggestions = e;
            });
            k.subscribe('selectionIsChanged', function (c) {
              a.getSelection().isLocked && 'restoreSelection' !== c.action && a.lockSelection();
              'restoreSelection' === c.action && a.selectionChange(!0);
            });
            k.subscribe('graytStateChanged', function (c) {
              f.state.grayt[a.name] = c.state;
            });
            k.addMarkupHandler &&
              k.addMarkupHandler(function (c) {
                var d = a.editable(),
                  e = d.getCustomData(c.charName);
                e && ((e.$ = c.node), d.setCustomData(c.charName, e));
              });
            a.scayt = k;
            a.fire('scaytButtonState', a.readOnly ? CKEDITOR.TRISTATE_DISABLED : CKEDITOR.TRISTATE_ON);
          } else f.state.scayt[a.name] = !1;
        });
      },
      destroy: function (a) {
        a.scayt && a.scayt.destroy();
        delete a.scayt;
        a.fire('scaytButtonState', CKEDITOR.TRISTATE_OFF);
      },
      loadScaytLibrary: function (a, h) {
        var f,
          b = function () {
            CKEDITOR.fireOnce('scaytReady');
            a.scayt || ('function' === typeof h && h(a));
          };
        'undefined' === typeof window.SCAYT || 'function' !== typeof window.SCAYT.CKSCAYT
          ? ((f = a.config.scayt_srcUrl),
            CKEDITOR.scriptLoader.load(f, function (a) {
              a && b();
            }))
          : window.SCAYT && 'function' === typeof window.SCAYT.CKSCAYT && b();
      },
    };
    CKEDITOR.on('dialogDefinition', function (a) {
      var h = a.data.name;
      a = a.data.definition.dialog;
      'scaytDialog' !== h &&
        'checkspell' !== h &&
        (a.on('show', function (a) {
          a = a.sender && a.sender.getParentEditor();
          var b = CKEDITOR.plugins.scayt,
            c = a.scayt;
          c && b.state.scayt[a.name] && c.setMarkupPaused && c.setMarkupPaused(!0);
        }),
        a.on('hide', function (a) {
          a = a.sender && a.sender.getParentEditor();
          var b = CKEDITOR.plugins.scayt,
            c = a.scayt;
          c && b.state.scayt[a.name] && c.setMarkupPaused && c.setMarkupPaused(!1);
        }));
      if ('scaytDialog' === h)
        a.on(
          'cancel',
          function (a) {
            return !1;
          },
          this,
          null,
          -1,
        );
      if ('checkspell' === h)
        a.on(
          'cancel',
          function (a) {
            a = a.sender && a.sender.getParentEditor();
            var b = CKEDITOR.plugins.scayt,
              c = a.scayt;
            c && b.state.scayt[a.name] && c.setMarkupPaused && c.setMarkupPaused(!1);
            a.unlockSelection();
          },
          this,
          null,
          -2,
        );
      if ('link' === h)
        a.on('ok', function (a) {
          var b = a.sender && a.sender.getParentEditor();
          b &&
            setTimeout(function () {
              b.fire('reloadMarkupScayt', { removeOptions: { removeInside: !0, forceBookmark: !0 }, timeout: 0 });
            }, 0);
        });
      if ('replace' === h)
        a.on('hide', function (a) {
          a = a.sender && a.sender.getParentEditor();
          var b = CKEDITOR.plugins.scayt,
            c = a.scayt;
          a &&
            setTimeout(function () {
              c && (c.fire('removeMarkupInDocument', {}), b.reloadMarkup(c));
            }, 0);
        });
    });
    CKEDITOR.on('scaytReady', function () {
      if (!0 === CKEDITOR.config.scayt_handleCheckDirty) {
        var a = CKEDITOR.editor.prototype;
        a.checkDirty = CKEDITOR.tools.override(a.checkDirty, function (a) {
          return function () {
            var b = null,
              c = this.scayt;
            if (CKEDITOR.plugins.scayt && CKEDITOR.plugins.scayt.state.scayt[this.name] && this.scayt) {
              if ((b = 'ready' == this.status))
                var h = c.removeMarkupFromString(this.getSnapshot()),
                  c = c.removeMarkupFromString(this._.previousValue),
                  b = b && c !== h;
            } else b = a.call(this);
            return b;
          };
        });
        a.resetDirty = CKEDITOR.tools.override(a.resetDirty, function (a) {
          return function () {
            var b = this.scayt;
            CKEDITOR.plugins.scayt && CKEDITOR.plugins.scayt.state.scayt[this.name] && this.scayt
              ? (this._.previousValue = b.removeMarkupFromString(this.getSnapshot()))
              : a.call(this);
          };
        });
      }
      if (!0 === CKEDITOR.config.scayt_handleUndoRedo) {
        var a = CKEDITOR.plugins.undo.Image.prototype,
          h = 'function' == typeof a.equalsContent ? 'equalsContent' : 'equals';
        a[h] = CKEDITOR.tools.override(a[h], function (a) {
          return function (b) {
            var c = b.editor.scayt,
              h = this.contents,
              k = b.contents,
              m = null;
            CKEDITOR.plugins.scayt &&
              CKEDITOR.plugins.scayt.state.scayt[b.editor.name] &&
              b.editor.scayt &&
              ((this.contents = c.removeMarkupFromString(h) || ''), (b.contents = c.removeMarkupFromString(k) || ''));
            m = a.apply(this, arguments);
            this.contents = h;
            b.contents = k;
            return m;
          };
        });
      }
    });
    (function () {
      CKEDITOR.plugins.add('selectall', {
        init: function (a) {
          a.addCommand('selectAll', {
            modes: { wysiwyg: 1, source: 1 },
            exec: function (a) {
              var f = a.editable();
              if (f.is('textarea'))
                (a = f.$),
                  CKEDITOR.env.ie && a.createTextRange
                    ? a.createTextRange().execCommand('SelectAll')
                    : ((a.selectionStart = 0), (a.selectionEnd = a.value.length)),
                  a.focus();
              else {
                if (f.is('body')) a.document.$.execCommand('SelectAll', !1, null);
                else {
                  var b = a.createRange();
                  b.selectNodeContents(f);
                  b.select();
                }
                a.forceNextSelectionCheck();
                a.selectionChange();
              }
            },
            canUndo: !1,
          });
          a.ui.addButton && a.ui.addButton('SelectAll', { label: a.lang.selectall.toolbar, command: 'selectAll', toolbar: 'selection,10' });
        },
      });
    })();
    (function () {
      var a = {
        readOnly: 1,
        preserveState: !0,
        editorFocus: !1,
        exec: function (a) {
          this.toggleState();
          this.refresh(a);
        },
        refresh: function (a) {
          if (a.document) {
            var f =
              this.state != CKEDITOR.TRISTATE_ON || (a.elementMode == CKEDITOR.ELEMENT_MODE_INLINE && !a.focusManager.hasFocus)
                ? 'removeClass'
                : 'attachClass';
            a.editable()[f]('cke_show_blocks');
          }
        },
      };
      CKEDITOR.plugins.add('showblocks', {
        onLoad: function () {
          var a = 'p div pre address blockquote h1 h2 h3 h4 h5 h6'.split(' '),
            f,
            b,
            c,
            l,
            k = CKEDITOR.getUrl(this.path),
            m = !(CKEDITOR.env.ie && 9 > CKEDITOR.env.version),
            g = m ? ':not([contenteditable\x3dfalse]):not(.cke_show_blocks_off)' : '',
            d,
            e;
          for (f = b = c = l = ''; (d = a.pop()); )
            (e = a.length ? ',' : ''),
              (f += '.cke_show_blocks ' + d + g + e),
              (c += '.cke_show_blocks.cke_contents_ltr ' + d + g + e),
              (l += '.cke_show_blocks.cke_contents_rtl ' + d + g + e),
              (b += '.cke_show_blocks ' + d + g + '{background-image:url(' + CKEDITOR.getUrl(k + 'images/block_' + d + '.png') + ')}');
          CKEDITOR.addCss(
            (f + '{background-repeat:no-repeat;border:1px dotted gray;padding-top:8px}').concat(
              b,
              c + '{background-position:top left;padding-left:8px}',
              l + '{background-position:top right;padding-right:8px}',
            ),
          );
          m ||
            CKEDITOR.addCss(
              '.cke_show_blocks [contenteditable\x3dfalse],.cke_show_blocks .cke_show_blocks_off{border:none;padding-top:0;background-image:none}.cke_show_blocks.cke_contents_rtl [contenteditable\x3dfalse],.cke_show_blocks.cke_contents_rtl .cke_show_blocks_off{padding-right:0}.cke_show_blocks.cke_contents_ltr [contenteditable\x3dfalse],.cke_show_blocks.cke_contents_ltr .cke_show_blocks_off{padding-left:0}',
            );
        },
        init: function (h) {
          function f() {
            b.refresh(h);
          }
          if (!h.blockless) {
            var b = h.addCommand('showblocks', a);
            b.canUndo = !1;
            h.config.startupOutlineBlocks && b.setState(CKEDITOR.TRISTATE_ON);
            h.ui.addButton &&
              h.ui.addButton('ShowBlocks', { label: h.lang.showblocks.toolbar, command: 'showblocks', toolbar: 'tools,20' });
            h.on('mode', function () {
              b.state != CKEDITOR.TRISTATE_DISABLED && b.refresh(h);
            });
            h.elementMode == CKEDITOR.ELEMENT_MODE_INLINE && (h.on('focus', f), h.on('blur', f));
            h.on('contentDom', function () {
              b.state != CKEDITOR.TRISTATE_DISABLED && b.refresh(h);
            });
          }
        },
      });
    })();
    (function () {
      var a = {
        preserveState: !0,
        editorFocus: !1,
        readOnly: 1,
        exec: function (a) {
          this.toggleState();
          this.refresh(a);
        },
        refresh: function (a) {
          if (a.document) {
            var f = this.state == CKEDITOR.TRISTATE_ON ? 'attachClass' : 'removeClass';
            a.editable()[f]('cke_show_borders');
          }
        },
      };
      CKEDITOR.plugins.add('showborders', {
        modes: { wysiwyg: 1 },
        onLoad: function () {
          var a;
          a = (
            CKEDITOR.env.ie6Compat
              ? ['.%1 table.%2,', '.%1 table.%2 td, .%1 table.%2 th', '{', 'border : #d3d3d3 1px dotted', '}']
              : '.%1 table.%2,;.%1 table.%2 \x3e tr \x3e td, .%1 table.%2 \x3e tr \x3e th,;.%1 table.%2 \x3e tbody \x3e tr \x3e td, .%1 table.%2 \x3e tbody \x3e tr \x3e th,;.%1 table.%2 \x3e thead \x3e tr \x3e td, .%1 table.%2 \x3e thead \x3e tr \x3e th,;.%1 table.%2 \x3e tfoot \x3e tr \x3e td, .%1 table.%2 \x3e tfoot \x3e tr \x3e th;{;border : #d3d3d3 1px dotted;}'.split(
                  ';',
                )
          )
            .join('')
            .replace(/%2/g, 'cke_show_border')
            .replace(/%1/g, 'cke_show_borders ');
          CKEDITOR.addCss(a);
        },
        init: function (h) {
          var f = h.addCommand('showborders', a);
          f.canUndo = !1;
          !1 !== h.config.startupShowBorders && f.setState(CKEDITOR.TRISTATE_ON);
          h.on(
            'mode',
            function () {
              f.state != CKEDITOR.TRISTATE_DISABLED && f.refresh(h);
            },
            null,
            null,
            100,
          );
          h.on('contentDom', function () {
            f.state != CKEDITOR.TRISTATE_DISABLED && f.refresh(h);
          });
          h.on('removeFormatCleanup', function (a) {
            a = a.data;
            h.getCommand('showborders').state == CKEDITOR.TRISTATE_ON &&
              a.is('table') &&
              (!a.hasAttribute('border') || 0 >= parseInt(a.getAttribute('border'), 10)) &&
              a.addClass('cke_show_border');
          });
        },
        afterInit: function (a) {
          var f = a.dataProcessor;
          a = f && f.dataFilter;
          f = f && f.htmlFilter;
          a &&
            a.addRules({
              elements: {
                table: function (a) {
                  a = a.attributes;
                  var c = a['class'],
                    f = parseInt(a.border, 10);
                  (f && !(0 >= f)) || (c && -1 != c.indexOf('cke_show_border')) || (a['class'] = (c || '') + ' cke_show_border');
                },
              },
            });
          f &&
            f.addRules({
              elements: {
                table: function (a) {
                  a = a.attributes;
                  var c = a['class'];
                  c &&
                    (a['class'] = c
                      .replace('cke_show_border', '')
                      .replace(/\s{2}/, ' ')
                      .replace(/^\s+|\s+$/, ''));
                },
              },
            });
        },
      });
      CKEDITOR.on('dialogDefinition', function (a) {
        var f = a.data.name;
        if ('table' == f || 'tableProperties' == f)
          if (
            ((a = a.data.definition),
            (f = a.getContents('info').get('txtBorder')),
            (f.commit = CKEDITOR.tools.override(f.commit, function (a) {
              return function (c, f) {
                a.apply(this, arguments);
                var h = parseInt(this.getValue(), 10);
                f[!h || 0 >= h ? 'addClass' : 'removeClass']('cke_show_border');
              };
            })),
            (a = (a = a.getContents('advanced')) && a.get('advCSSClasses')))
          )
            (a.setup = CKEDITOR.tools.override(a.setup, function (a) {
              return function () {
                a.apply(this, arguments);
                this.setValue(this.getValue().replace(/cke_show_border/, ''));
              };
            })),
              (a.commit = CKEDITOR.tools.override(a.commit, function (a) {
                return function (c, f) {
                  a.apply(this, arguments);
                  parseInt(f.getAttribute('border'), 10) || f.addClass('cke_show_border');
                };
              }));
      });
    })();
    CKEDITOR.plugins.add('smiley', {
      requires: 'dialog',
      init: function (a) {
        a.config.smiley_path = a.config.smiley_path || this.path + 'images/';
        a.addCommand(
          'smiley',
          new CKEDITOR.dialogCommand('smiley', { allowedContent: 'img[alt,height,!src,title,width]', requiredContent: 'img' }),
        );
        a.ui.addButton && a.ui.addButton('Smiley', { label: a.lang.smiley.toolbar, command: 'smiley', toolbar: 'insert,50' });
        CKEDITOR.dialog.add('smiley', this.path + 'dialogs/smiley.js');
      },
    });
    CKEDITOR.config.smiley_images =
      'regular_smile.png sad_smile.png wink_smile.png teeth_smile.png confused_smile.png tongue_smile.png embarrassed_smile.png omg_smile.png whatchutalkingabout_smile.png angry_smile.png angel_smile.png shades_smile.png devil_smile.png cry_smile.png lightbulb.png thumbs_down.png thumbs_up.png heart.png broken_heart.png kiss.png envelope.png'.split(
        ' ',
      );
    CKEDITOR.config.smiley_descriptions =
      'smiley;sad;wink;laugh;frown;cheeky;blush;surprise;indecision;angry;angel;cool;devil;crying;enlightened;no;yes;heart;broken heart;kiss;mail'.split(
        ';',
      );
    (function () {
      CKEDITOR.plugins.add('sourcearea', {
        init: function (h) {
          function f() {
            var a = c && this.equals(CKEDITOR.document.getActive());
            this.hide();
            this.setStyle('height', this.getParent().$.clientHeight + 'px');
            this.setStyle('width', this.getParent().$.clientWidth + 'px');
            this.show();
            a && this.focus();
          }
          if (h.elementMode != CKEDITOR.ELEMENT_MODE_INLINE) {
            var b = CKEDITOR.plugins.sourcearea;
            h.addMode('source', function (b) {
              var c = h.ui.space('contents').getDocument().createElement('textarea');
              c.setStyles(
                CKEDITOR.tools.extend(
                  { width: CKEDITOR.env.ie7Compat ? '99%' : '100%', height: '100%', resize: 'none', outline: 'none', 'text-align': 'left' },
                  CKEDITOR.tools.cssVendorPrefix('tab-size', h.config.sourceAreaTabSize || 4),
                ),
              );
              c.setAttribute('dir', 'ltr');
              c.addClass('cke_source').addClass('cke_reset').addClass('cke_enable_context_menu');
              h.ui.space('contents').append(c);
              c = h.editable(new a(h, c));
              c.setData(h.getData(1));
              CKEDITOR.env.ie &&
                (c.attachListener(h, 'resize', f, c),
                c.attachListener(CKEDITOR.document.getWindow(), 'resize', f, c),
                CKEDITOR.tools.setTimeout(f, 0, c));
              h.fire('ariaWidget', this);
              b();
            });
            h.addCommand('source', b.commands.source);
            h.ui.addButton &&
              h.ui.addButton('Source', { isToggle: !0, label: h.lang.sourcearea.toolbar, command: 'source', toolbar: 'mode,10' });
            h.on('mode', function () {
              h.getCommand('source').setState('source' == h.mode ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF);
            });
            var c = CKEDITOR.env.ie && 9 == CKEDITOR.env.version;
          }
        },
      });
      var a = CKEDITOR.tools.createClass({
        base: CKEDITOR.editable,
        proto: {
          setData: function (a) {
            this.setValue(a);
            this.status = 'ready';
            this.editor.fire('dataReady');
          },
          getData: function () {
            return this.getValue();
          },
          insertHtml: function () {},
          insertElement: function () {},
          insertText: function () {},
          setReadOnly: function (a) {
            this[(a ? 'set' : 'remove') + 'Attribute']('readOnly', 'readonly');
          },
          detach: function () {
            a.baseProto.detach.call(this);
            this.clearCustomData();
            this.remove();
          },
        },
      });
    })();
    CKEDITOR.plugins.sourcearea = {
      commands: {
        source: {
          modes: { wysiwyg: 1, source: 1 },
          editorFocus: !1,
          readOnly: 1,
          exec: function (a) {
            'wysiwyg' == a.mode && a.fire('saveSnapshot');
            a.getCommand('source').setState(CKEDITOR.TRISTATE_DISABLED);
            a.setMode('source' == a.mode ? 'wysiwyg' : 'source');
          },
          canUndo: !1,
        },
      },
    };
    CKEDITOR.plugins.add('specialchar', {
      availableLangs: {
        af: 1,
        ar: 1,
        az: 1,
        bg: 1,
        ca: 1,
        cs: 1,
        cy: 1,
        da: 1,
        de: 1,
        'de-ch': 1,
        el: 1,
        en: 1,
        'en-au': 1,
        'en-ca': 1,
        'en-gb': 1,
        eo: 1,
        es: 1,
        'es-mx': 1,
        et: 1,
        eu: 1,
        fa: 1,
        fi: 1,
        fr: 1,
        'fr-ca': 1,
        gl: 1,
        he: 1,
        hr: 1,
        hu: 1,
        id: 1,
        it: 1,
        ja: 1,
        km: 1,
        ko: 1,
        ku: 1,
        lt: 1,
        lv: 1,
        nb: 1,
        nl: 1,
        no: 1,
        oc: 1,
        pl: 1,
        pt: 1,
        'pt-br': 1,
        ro: 1,
        ru: 1,
        si: 1,
        sk: 1,
        sl: 1,
        sq: 1,
        sr: 1,
        'sr-latn': 1,
        sv: 1,
        th: 1,
        tr: 1,
        tt: 1,
        ug: 1,
        uk: 1,
        vi: 1,
        zh: 1,
        'zh-cn': 1,
      },
      requires: 'dialog',
      init: function (a) {
        var h = this;
        CKEDITOR.dialog.add('specialchar', this.path + 'dialogs/specialchar.js');
        a.addCommand('specialchar', {
          exec: function () {
            var f = a.langCode,
              f = h.availableLangs[f] ? f : h.availableLangs[f.replace(/-.*/, '')] ? f.replace(/-.*/, '') : 'en';
            CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(h.path + 'dialogs/lang/' + f + '.js'), function () {
              CKEDITOR.tools.extend(a.lang.specialchar, h.langEntries[f]);
              a.openDialog('specialchar');
            });
          },
          modes: { wysiwyg: 1 },
          canUndo: !1,
        });
        a.ui.addButton &&
          a.ui.addButton('SpecialChar', { label: a.lang.specialchar.toolbar, command: 'specialchar', toolbar: 'insert,50' });
      },
    });
    CKEDITOR.config.specialChars =
      "! \x26quot; # $ % \x26amp; ' ( ) * + - . / 0 1 2 3 4 5 6 7 8 9 : ; \x26lt; \x3d \x26gt; ? @ A B C D E F G H I J K L M N O P Q R S T U V W X Y Z [ ] ^ _ ` a b c d e f g h i j k l m n o p q r s t u v w x y z { | } ~ \x26euro; \x26lsquo; \x26rsquo; \x26ldquo; \x26rdquo; \x26ndash; \x26mdash; \x26iexcl; \x26cent; \x26pound; \x26curren; \x26yen; \x26brvbar; \x26sect; \x26uml; \x26copy; \x26ordf; \x26laquo; \x26not; \x26reg; \x26macr; \x26deg; \x26sup2; \x26sup3; \x26acute; \x26micro; \x26para; \x26middot; \x26cedil; \x26sup1; \x26ordm; \x26raquo; \x26frac14; \x26frac12; \x26frac34; \x26iquest; \x26Agrave; \x26Aacute; \x26Acirc; \x26Atilde; \x26Auml; \x26Aring; \x26AElig; \x26Ccedil; \x26Egrave; \x26Eacute; \x26Ecirc; \x26Euml; \x26Igrave; \x26Iacute; \x26Icirc; \x26Iuml; \x26ETH; \x26Ntilde; \x26Ograve; \x26Oacute; \x26Ocirc; \x26Otilde; \x26Ouml; \x26times; \x26Oslash; \x26Ugrave; \x26Uacute; \x26Ucirc; \x26Uuml; \x26Yacute; \x26THORN; \x26szlig; \x26agrave; \x26aacute; \x26acirc; \x26atilde; \x26auml; \x26aring; \x26aelig; \x26ccedil; \x26egrave; \x26eacute; \x26ecirc; \x26euml; \x26igrave; \x26iacute; \x26icirc; \x26iuml; \x26eth; \x26ntilde; \x26ograve; \x26oacute; \x26ocirc; \x26otilde; \x26ouml; \x26divide; \x26oslash; \x26ugrave; \x26uacute; \x26ucirc; \x26uuml; \x26yacute; \x26thorn; \x26yuml; \x26OElig; \x26oelig; \x26#372; \x26#374 \x26#373 \x26#375; \x26sbquo; \x26#8219; \x26bdquo; \x26hellip; \x26trade; \x26#9658; \x26bull; \x26rarr; \x26rArr; \x26hArr; \x26diams; \x26asymp;".split(
        ' ',
      );
    (function () {
      CKEDITOR.plugins.add('stylescombo', {
        requires: 'richcombo',
        init: function (a) {
          var h = a.config,
            f = a.lang.stylescombo,
            b = {},
            c = [],
            l = [];
          a.on('stylesSet', function (f) {
            if ((f = f.data.styles)) {
              for (var m, g, d, e = 0, n = f.length; e < n; e++)
                ((m = f[e]),
                (a.blockless && m.element in CKEDITOR.dtd.$block) ||
                  ('string' == typeof m.type && !CKEDITOR.style.customHandlers[m.type]) ||
                  ((g = m.name), (m = new CKEDITOR.style(m)), a.filter.customConfig && !a.filter.check(m))) ||
                  ((m._name = g),
                  (m._.enterMode = h.enterMode),
                  (m._.type = d = m.assignedTo || m.type),
                  (m._.weight = e + 1e3 * (d == CKEDITOR.STYLE_OBJECT ? 1 : d == CKEDITOR.STYLE_BLOCK ? 2 : 3)),
                  (b[g] = m),
                  c.push(m),
                  l.push(m));
              c.sort(function (a, b) {
                return a._.weight - b._.weight;
              });
            }
          });
          a.on('stylesRemove', function (c) {
            c = c.data && c.data.type;
            var f = void 0 === c,
              g;
            for (g in b) {
              var d = b[g];
              (f || d.type === c) && a.removeStyle(d);
            }
          });
          a.ui.addRichCombo('Styles', {
            label: f.label,
            title: f.panelTitle,
            toolbar: 'styles,10',
            allowedContent: l,
            panel: {
              css: [CKEDITOR.skin.getPath('editor')].concat(h.contentsCss),
              multiSelect: !0,
              attributes: { 'aria-label': f.panelTitle },
            },
            init: function () {
              var a, b, g, d, e, h;
              e = 0;
              for (h = c.length; e < h; e++)
                (a = c[e]),
                  (b = a._name),
                  (d = a._.type),
                  d != g && (this.startGroup(f['panelTitle' + String(d)]), (g = d)),
                  this.add(b, a.type == CKEDITOR.STYLE_OBJECT ? b : a.buildPreview(), b);
              this.commit();
            },
            onClick: function (c) {
              a.focus();
              a.fire('saveSnapshot');
              c = b[c];
              var f = a.elementPath();
              if (c.group && c.removeStylesFromSameGroup(a)) a.applyStyle(c);
              else a[c.checkActive(f, a) ? 'removeStyle' : 'applyStyle'](c);
              a.fire('saveSnapshot');
            },
            onRender: function () {
              a.on(
                'selectionChange',
                function (c) {
                  var f = this.getValue();
                  c = c.data.path.elements;
                  for (var g = 0, d = c.length, e; g < d; g++) {
                    e = c[g];
                    for (var h in b)
                      if (b[h].checkElementRemovable(e, !0, a)) {
                        h != f && this.setValue(h);
                        return;
                      }
                  }
                  this.setValue('');
                },
                this,
              );
            },
            onOpen: function () {
              var c = a.getSelection(),
                c = c.getSelectedElement() || c.getStartElement() || a.editable(),
                c = a.elementPath(c),
                h = [0, 0, 0, 0];
              this.showAll();
              this.unmarkAll();
              for (var g in b) {
                var d = b[g],
                  e = d._.type;
                d.checkApplicable(c, a, a.activeFilter) ? h[e]++ : this.hideItem(g);
                d.checkActive(c, a) && this.mark(g);
              }
              h[CKEDITOR.STYLE_BLOCK] || this.hideGroup(f['panelTitle' + String(CKEDITOR.STYLE_BLOCK)]);
              h[CKEDITOR.STYLE_INLINE] || this.hideGroup(f['panelTitle' + String(CKEDITOR.STYLE_INLINE)]);
              h[CKEDITOR.STYLE_OBJECT] || this.hideGroup(f['panelTitle' + String(CKEDITOR.STYLE_OBJECT)]);
            },
            refresh: function () {
              var c = a.elementPath();
              if (c) {
                for (var f in b) if (b[f].checkApplicable(c, a, a.activeFilter)) return;
                this.setState(CKEDITOR.TRISTATE_DISABLED);
              }
            },
            reset: function () {
              b = {};
              c = [];
            },
          });
        },
      });
    })();
    (function () {
      function a(a) {
        return {
          editorFocus: !1,
          canUndo: !1,
          modes: { wysiwyg: 1 },
          exec: function (b) {
            if (b.editable().hasFocus) {
              var f = b.getSelection(),
                h;
              if ((h = new CKEDITOR.dom.elementPath(f.getStartElement(), f.root).contains({ td: 1, th: 1 }, 1))) {
                var f = b.createRange(),
                  g = CKEDITOR.tools.tryThese(
                    function () {
                      var b = h.getParent().$.cells[h.$.cellIndex + (a ? -1 : 1)];
                      b.parentNode.parentNode;
                      return b;
                    },
                    function () {
                      var b = h.getParent(),
                        b = b.getAscendant('table').$.rows[b.$.rowIndex + (a ? -1 : 1)];
                      return b.cells[a ? b.cells.length - 1 : 0];
                    },
                  );
                if (g || a)
                  if (g)
                    (g = new CKEDITOR.dom.element(g)),
                      f.moveToElementEditStart(g),
                      (f.checkStartOfBlock() && f.checkEndOfBlock()) || f.selectNodeContents(g);
                  else return !0;
                else {
                  for (
                    var d = h.getAscendant('table').$,
                      g = h.getParent().$.cells,
                      d = new CKEDITOR.dom.element(d.insertRow(-1), b.document),
                      e = 0,
                      n = g.length;
                    e < n;
                    e++
                  )
                    d.append(new CKEDITOR.dom.element(g[e], b.document).clone(!1, !1)).appendBogus();
                  f.moveToElementEditStart(d);
                }
                f.select(!0);
                return !0;
              }
            }
            return !1;
          },
        };
      }
      var h = { editorFocus: !1, modes: { wysiwyg: 1, source: 1 } },
        f = {
          exec: function (a) {
            a.container.focusNext(!0, a.tabIndex);
          },
        },
        b = {
          exec: function (a) {
            a.container.focusPrevious(!0, a.tabIndex);
          },
        };
      CKEDITOR.plugins.add('tab', {
        init: function (c) {
          for (var l = !1 !== c.config.enableTabKeyTools, k = c.config.tabSpaces || 0, m = ''; k--; ) m += ' ';
          if (m)
            c.on('key', function (a) {
              9 == a.data.keyCode && (c.insertText(m), a.cancel());
            });
          if (l)
            c.on('key', function (a) {
              ((9 == a.data.keyCode && c.execCommand('selectNextCell')) ||
                (a.data.keyCode == CKEDITOR.SHIFT + 9 && c.execCommand('selectPreviousCell'))) &&
                a.cancel();
            });
          c.addCommand('blur', CKEDITOR.tools.extend(f, h));
          c.addCommand('blurBack', CKEDITOR.tools.extend(b, h));
          c.addCommand('selectNextCell', a());
          c.addCommand('selectPreviousCell', a(!0));
        },
      });
    })();
    CKEDITOR.dom.element.prototype.focusNext = function (a, h) {
      var f = void 0 === h ? this.getTabIndex() : h,
        b,
        c,
        l,
        k,
        m,
        g;
      if (0 >= f)
        for (m = this.getNextSourceNode(a, CKEDITOR.NODE_ELEMENT); m; ) {
          if (m.isVisible() && 0 === m.getTabIndex()) {
            l = m;
            break;
          }
          m = m.getNextSourceNode(!1, CKEDITOR.NODE_ELEMENT);
        }
      else
        for (m = this.getDocument().getBody().getFirst(); (m = m.getNextSourceNode(!1, CKEDITOR.NODE_ELEMENT)); ) {
          if (!b)
            if (!c && m.equals(this)) {
              if (((c = !0), a)) {
                if (!(m = m.getNextSourceNode(!0, CKEDITOR.NODE_ELEMENT))) break;
                b = 1;
              }
            } else c && !this.contains(m) && (b = 1);
          if (m.isVisible() && !(0 > (g = m.getTabIndex()))) {
            if (b && g == f) {
              l = m;
              break;
            }
            g > f && (!l || !k || g < k) ? ((l = m), (k = g)) : l || 0 !== g || ((l = m), (k = g));
          }
        }
      l && l.focus();
    };
    CKEDITOR.dom.element.prototype.focusPrevious = function (a, h) {
      for (
        var f = void 0 === h ? this.getTabIndex() : h, b, c, l, k = 0, m, g = this.getDocument().getBody().getLast();
        (g = g.getPreviousSourceNode(!1, CKEDITOR.NODE_ELEMENT));

      ) {
        if (!b)
          if (!c && g.equals(this)) {
            if (((c = !0), a)) {
              if (!(g = g.getPreviousSourceNode(!0, CKEDITOR.NODE_ELEMENT))) break;
              b = 1;
            }
          } else c && !this.contains(g) && (b = 1);
        if (g.isVisible() && !(0 > (m = g.getTabIndex())))
          if (0 >= f) {
            if (b && 0 === m) {
              l = g;
              break;
            }
            m > k && ((l = g), (k = m));
          } else {
            if (b && m == f) {
              l = g;
              break;
            }
            m < f && (!l || m > k) && ((l = g), (k = m));
          }
      }
      l && l.focus();
    };
    CKEDITOR.plugins.add('table', {
      requires: 'dialog',
      init: function (a) {
        function h(a) {
          return CKEDITOR.tools.extend(a || {}, {
            contextSensitive: 1,
            refresh: function (a, b) {
              this.setState(b.contains('table', 1) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
            },
          });
        }
        if (!a.blockless) {
          var f = a.lang.table;
          a.addCommand(
            'table',
            new CKEDITOR.dialogCommand('table', {
              context: 'table',
              allowedContent:
                'table{width,height,border-collapse}[align,border,cellpadding,cellspacing,summary];caption tbody thead tfoot;th td tr[scope];td{border*,background-color,vertical-align,width,height}[colspan,rowspan];' +
                (a.plugins.dialogadvtab ? 'table' + a.plugins.dialogadvtab.allowedContent() : ''),
              requiredContent: 'table',
              contentTransformations: [
                ['table{width}: sizeToStyle', 'table[width]: sizeToAttribute'],
                ['td: splitBorderShorthand'],
                [
                  {
                    element: 'table',
                    right: function (a) {
                      if (a.styles) {
                        var c;
                        if (a.styles.border) c = CKEDITOR.tools.style.parse.border(a.styles.border);
                        else if (CKEDITOR.env.ie && 8 === CKEDITOR.env.version) {
                          var f = a.styles;
                          f['border-left'] &&
                            f['border-left'] === f['border-right'] &&
                            f['border-right'] === f['border-top'] &&
                            f['border-top'] === f['border-bottom'] &&
                            (c = CKEDITOR.tools.style.parse.border(f['border-top']));
                        }
                        c && c.style && 'solid' === c.style && c.width && 0 !== parseFloat(c.width) && (a.attributes.border = 1);
                        'collapse' == a.styles['border-collapse'] && (a.attributes.cellspacing = 0);
                      }
                    },
                  },
                ],
              ],
            }),
          );
          a.addCommand('tableProperties', new CKEDITOR.dialogCommand('tableProperties', h()));
          a.addCommand(
            'tableDelete',
            h({
              exec: function (a) {
                var c = a.elementPath().contains('table', 1);
                if (c) {
                  var f = c.getParent(),
                    h = a.editable();
                  1 != f.getChildCount() || f.is('td', 'th') || f.equals(h) || (c = f);
                  a = a.createRange();
                  a.moveToPosition(c, CKEDITOR.POSITION_BEFORE_START);
                  c.remove();
                  a.select();
                }
              },
            }),
          );
          a.ui.addButton && a.ui.addButton('Table', { label: f.toolbar, command: 'table', toolbar: 'insert,30' });
          CKEDITOR.dialog.add('table', this.path + 'dialogs/table.js');
          CKEDITOR.dialog.add('tableProperties', this.path + 'dialogs/table.js');
          a.addMenuItems &&
            a.addMenuItems({
              table: { label: f.menu, command: 'tableProperties', group: 'table', order: 5 },
              tabledelete: { label: f.deleteTable, command: 'tableDelete', group: 'table', order: 1 },
            });
          a.on('doubleclick', function (a) {
            a.data.element.is('table') && (a.data.dialog = 'tableProperties');
          });
          a.contextMenu &&
            a.contextMenu.addListener(function () {
              return { tabledelete: CKEDITOR.TRISTATE_OFF, table: CKEDITOR.TRISTATE_OFF };
            });
        }
      },
    });
    (function () {
      function a(a, b) {
        function d(a) {
          return b ? b.contains(a) && a.getAscendant('table', !0).equals(b) : !0;
        }
        function e(a) {
          var b = /^(?:td|th)$/;
          0 < c.length ||
            a.type != CKEDITOR.NODE_ELEMENT ||
            !b.test(a.getName()) ||
            a.getCustomData('selected_cell') ||
            (CKEDITOR.dom.element.setMarker(f, a, 'selected_cell', !0), c.push(a));
        }
        var c = [],
          f = {};
        if (!a) return c;
        for (var g = a.getRanges(), h = 0; h < g.length; h++) {
          var k = g[h];
          if (k.collapsed) (k = k.getCommonAncestor().getAscendant({ td: 1, th: 1 }, !0)) && d(k) && c.push(k);
          else {
            var k = new CKEDITOR.dom.walker(k),
              l;
            for (k.guard = e; (l = k.next()); )
              (l.type == CKEDITOR.NODE_ELEMENT && l.is(CKEDITOR.dtd.table)) ||
                ((l = l.getAscendant({ td: 1, th: 1 }, !0)) &&
                  !l.getCustomData('selected_cell') &&
                  d(l) &&
                  (CKEDITOR.dom.element.setMarker(f, l, 'selected_cell', !0), c.push(l)));
          }
        }
        CKEDITOR.dom.element.clearAllMarkers(f);
        return c;
      }
      function h(b, d) {
        for (
          var e = u(b) ? b : a(b),
            c = e[0],
            f = c.getAscendant('table'),
            c = c.getDocument(),
            g = e[0].getParent(),
            h = g.$.rowIndex,
            e = e[e.length - 1],
            k = e.getParent().$.rowIndex + e.$.rowSpan - 1,
            e = new CKEDITOR.dom.element(f.$.rows[k]),
            h = d ? h : k,
            g = d ? g : e,
            e = CKEDITOR.tools.buildTableMap(f),
            f = e[h],
            h = d ? e[h - 1] : e[h + 1],
            e = e[0].length,
            c = c.createElement('tr'),
            k = 0;
          f[k] && k < e;
          k++
        ) {
          var l;
          1 < f[k].rowSpan && h && f[k] == h[k]
            ? ((l = f[k]), (l.rowSpan += 1))
            : ((l = new CKEDITOR.dom.element(f[k]).clone()), l.removeAttribute('rowSpan'), l.appendBogus(), c.append(l), (l = l.$));
          k += l.colSpan - 1;
        }
        d ? c.insertBefore(g) : c.insertAfter(g);
        return c;
      }
      function f(b) {
        if (b instanceof CKEDITOR.dom.selection) {
          var d = b.getRanges(),
            e = a(b),
            c = e[0].getAscendant('table'),
            g = CKEDITOR.tools.buildTableMap(c),
            h = e[0].getParent().$.rowIndex,
            e = e[e.length - 1],
            k = e.getParent().$.rowIndex + e.$.rowSpan - 1,
            e = [];
          b.reset();
          for (b = h; b <= k; b++) {
            for (var l = g[b], m = new CKEDITOR.dom.element(c.$.rows[b]), n = 0; n < l.length; n++) {
              var r = new CKEDITOR.dom.element(l[n]),
                u = r.getParent().$.rowIndex;
              1 == r.$.rowSpan
                ? r.remove()
                : (--r.$.rowSpan,
                  u == b &&
                    ((u = g[b + 1]),
                    u[n - 1] ? r.insertAfter(new CKEDITOR.dom.element(u[n - 1])) : new CKEDITOR.dom.element(c.$.rows[b + 1]).append(r, 1)));
              n += r.$.colSpan - 1;
            }
            e.push(m);
          }
          g = c.$.rows;
          d[0].moveToPosition(c, CKEDITOR.POSITION_BEFORE_START);
          h = new CKEDITOR.dom.element(g[k + 1] || (0 < h ? g[h - 1] : null) || c.$.parentNode);
          for (b = e.length; 0 <= b; b--) f(e[b]);
          return c.$.parentNode ? h : (d[0].select(), null);
        }
        b instanceof CKEDITOR.dom.element && ((c = b.getAscendant('table')), 1 == c.$.rows.length ? c.remove() : b.remove());
        return null;
      }
      function b(a) {
        for (var b = a.getParent().$.cells, d = 0, e = 0; e < b.length; e++) {
          var c = b[e],
            d = d + c.colSpan;
          if (c == a.$) break;
        }
        return d - 1;
      }
      function c(a, d) {
        for (var e = d ? Infinity : 0, c = 0; c < a.length; c++) {
          var f = b(a[c]);
          if (d ? f < e : f > e) e = f;
        }
        return e;
      }
      function l(b, d) {
        for (
          var e = u(b) ? b : a(b),
            f = e[0].getAscendant('table'),
            g = c(e, 1),
            e = c(e),
            h = d ? g : e,
            k = CKEDITOR.tools.buildTableMap(f),
            f = [],
            g = [],
            e = [],
            l = k.length,
            m = 0;
          m < l;
          m++
        ) {
          var n = d ? k[m][h - 1] : k[m][h + 1];
          f.push(k[m][h]);
          g.push(n);
        }
        for (m = 0; m < l; m++)
          f[m] &&
            (1 < f[m].colSpan && g[m] == f[m]
              ? ((k = f[m]), (k.colSpan += 1))
              : ((h = new CKEDITOR.dom.element(f[m])),
                (k = h.clone()),
                k.removeAttribute('colSpan'),
                k.appendBogus(),
                k[d ? 'insertBefore' : 'insertAfter'].call(k, h),
                e.push(k),
                (k = k.$)),
            (m += k.rowSpan - 1));
        return e;
      }
      function k(b) {
        function d(a) {
          var b = a.getRanges(),
            e,
            c;
          if (1 !== b.length) return a;
          b = b[0];
          if (b.collapsed || 0 !== b.endOffset) return a;
          e = b.endContainer;
          c = e.getName().toLowerCase();
          if ('td' !== c && 'th' !== c) return a;
          for (
            (c = e.getPrevious()) || (c = e.getParent().getPrevious().getLast());
            c.type !== CKEDITOR.NODE_TEXT && 'br' !== c.getName().toLowerCase();

          )
            if (((c = c.getLast()), !c)) return a;
          b.setEndAt(c, CKEDITOR.POSITION_BEFORE_END);
          return b.select();
        }
        CKEDITOR.env.webkit && !b.isFake && (b = d(b));
        var e = b.getRanges(),
          c = a(b),
          f = c[0],
          g = c[c.length - 1],
          c = f.getAscendant('table'),
          h = CKEDITOR.tools.buildTableMap(c),
          k,
          l,
          m = [];
        b.reset();
        var n = 0;
        for (b = h.length; n < b; n++)
          for (var r = 0, u = h[n].length; r < u; r++) void 0 === k && h[n][r] == f.$ && (k = r), h[n][r] == g.$ && (l = r);
        for (n = k; n <= l; n++)
          for (r = 0; r < h.length; r++)
            (g = h[r]),
              (f = new CKEDITOR.dom.element(c.$.rows[r])),
              (g = new CKEDITOR.dom.element(g[n])),
              g.$ && (1 == g.$.colSpan ? g.remove() : --g.$.colSpan, (r += g.$.rowSpan - 1), f.$.cells.length || m.push(f));
        k =
          h[0].length - 1 > l
            ? new CKEDITOR.dom.element(h[0][l + 1])
            : k && -1 !== h[0][k - 1].cellIndex
              ? new CKEDITOR.dom.element(h[0][k - 1])
              : new CKEDITOR.dom.element(c.$.parentNode);
        m.length == b && (e[0].moveToPosition(c, CKEDITOR.POSITION_AFTER_END), e[0].select(), c.remove());
        return k;
      }
      function m(a, b) {
        var d = a.getStartElement().getAscendant({ td: 1, th: 1 }, !0);
        if (d) {
          var e = d.clone();
          e.appendBogus();
          b ? e.insertBefore(d) : e.insertAfter(d);
        }
      }
      function g(b) {
        if (b instanceof CKEDITOR.dom.selection) {
          var e = b.getRanges(),
            c = a(b),
            f = c[0] && c[0].getAscendant('table'),
            h;
          a: {
            var k = 0;
            h = c.length - 1;
            for (var l = {}, m, n; (m = c[k++]); ) CKEDITOR.dom.element.setMarker(l, m, 'delete_cell', !0);
            for (k = 0; (m = c[k++]); )
              if (((n = m.getPrevious()) && !n.getCustomData('delete_cell')) || ((n = m.getNext()) && !n.getCustomData('delete_cell'))) {
                CKEDITOR.dom.element.clearAllMarkers(l);
                h = n;
                break a;
              }
            CKEDITOR.dom.element.clearAllMarkers(l);
            k = c[0].getParent();
            (k = k.getPrevious()) ? (h = k.getLast()) : ((k = c[h].getParent()), (h = (k = k.getNext()) ? k.getChild(0) : null));
          }
          b.reset();
          for (b = c.length - 1; 0 <= b; b--) g(c[b]);
          h ? d(h, !0) : f && (e[0].moveToPosition(f, CKEDITOR.POSITION_BEFORE_START), e[0].select(), f.remove());
        } else b instanceof CKEDITOR.dom.element && ((e = b.getParent()), 1 == e.getChildCount() ? e.remove() : b.remove());
      }
      function d(a, b) {
        var d = a.getDocument(),
          e = CKEDITOR.document;
        CKEDITOR.env.ie && 10 == CKEDITOR.env.version && (e.focus(), d.focus());
        d = new CKEDITOR.dom.range(d);
        d['moveToElementEdit' + (b ? 'End' : 'Start')](a) || (d.selectNodeContents(a), d.collapse(b ? !1 : !0));
        d.select(!0);
      }
      function e(a, b, d) {
        a = a[b];
        if ('undefined' == typeof d) return a;
        for (b = 0; a && b < a.length; b++) {
          if (d.is && a[b] == d.$) return b;
          if (b == d) return new CKEDITOR.dom.element(a[b]);
        }
        return d.is ? -1 : null;
      }
      function n(b, d, c) {
        var f = a(b),
          g;
        if ((d ? 1 != f.length : 2 > f.length) || ((g = b.getCommonAncestor()) && g.type == CKEDITOR.NODE_ELEMENT && g.is('table')))
          return !1;
        b = f[0];
        g = b.getAscendant('table');
        var h = CKEDITOR.tools.buildTableMap(g),
          k = h.length,
          l = h[0].length,
          m = b.getParent().$.rowIndex,
          n = e(h, m, b),
          r;
        if (d) {
          var u;
          try {
            var x = parseInt(b.getAttribute('rowspan'), 10) || 1;
            r = parseInt(b.getAttribute('colspan'), 10) || 1;
            u = h['up' == d ? m - x : 'down' == d ? m + x : m]['left' == d ? n - r : 'right' == d ? n + r : n];
          } catch (w) {
            return !1;
          }
          if (!u || b.$ == u) return !1;
          f['up' == d || 'left' == d ? 'unshift' : 'push'](new CKEDITOR.dom.element(u));
        }
        d = b.getDocument();
        var K = m,
          x = (u = 0),
          S = !c && new CKEDITOR.dom.documentFragment(d),
          I = 0;
        for (d = 0; d < f.length; d++) {
          r = f[d];
          var E = r.getParent(),
            P = r.getFirst(),
            M = r.$.colSpan,
            O = r.$.rowSpan,
            E = E.$.rowIndex,
            N = e(h, E, r),
            I = I + M * O,
            x = Math.max(x, N - n + M);
          u = Math.max(u, E - m + O);
          c ||
            ((M = r),
            (O = M.getBogus()) && O.remove(),
            M.trim(),
            r.getChildren().count() &&
              (E == K ||
                !P ||
                (P.isBlockBoundary && P.isBlockBoundary({ br: 1 })) ||
                ((K = S.getLast(CKEDITOR.dom.walker.whitespaces(!0))), !K || (K.is && K.is('br')) || S.append('br')),
              r.moveChildren(S)),
            d ? r.remove() : r.setHtml(''));
          K = E;
        }
        if (c) return u * x == I;
        S.moveChildren(b);
        b.appendBogus();
        x >= l ? b.removeAttribute('rowSpan') : (b.$.rowSpan = u);
        u >= k ? b.removeAttribute('colSpan') : (b.$.colSpan = x);
        c = new CKEDITOR.dom.nodeList(g.$.rows);
        f = c.count();
        for (d = f - 1; 0 <= d; d--) (g = c.getItem(d)), g.$.cells.length || (g.remove(), f++);
        return b;
      }
      function r(b, d) {
        var c = a(b);
        if (1 < c.length) return !1;
        if (d) return !0;
        var c = c[0],
          f = c.getParent(),
          g = f.getAscendant('table'),
          h = CKEDITOR.tools.buildTableMap(g),
          k = f.$.rowIndex,
          l = e(h, k, c),
          m = c.$.rowSpan,
          n;
        if (1 < m) {
          n = Math.ceil(m / 2);
          for (
            var m = Math.floor(m / 2), f = k + n, g = new CKEDITOR.dom.element(g.$.rows[f]), h = e(h, f), r, f = c.clone(), k = 0;
            k < h.length;
            k++
          )
            if (((r = h[k]), r.parentNode == g.$ && k > l)) {
              f.insertBefore(new CKEDITOR.dom.element(r));
              break;
            } else r = null;
          r || g.append(f);
        } else
          for (m = n = 1, g = f.clone(), g.insertAfter(f), g.append((f = c.clone())), r = e(h, k), l = 0; l < r.length; l++) r[l].rowSpan++;
        f.appendBogus();
        c.$.rowSpan = n;
        f.$.rowSpan = m;
        1 == n && c.removeAttribute('rowSpan');
        1 == m && f.removeAttribute('rowSpan');
        return f;
      }
      function x(b, d) {
        var c = a(b);
        if (1 < c.length) return !1;
        if (d) return !0;
        var c = c[0],
          f = c.getParent(),
          g = f.getAscendant('table'),
          g = CKEDITOR.tools.buildTableMap(g),
          h = e(g, f.$.rowIndex, c),
          k = c.$.colSpan;
        if (1 < k) (f = Math.ceil(k / 2)), (k = Math.floor(k / 2));
        else {
          for (var k = (f = 1), l = [], m = 0; m < g.length; m++) {
            var n = g[m];
            l.push(n[h]);
            1 < n[h].rowSpan && (m += n[h].rowSpan - 1);
          }
          for (g = 0; g < l.length; g++) l[g].colSpan++;
        }
        g = c.clone();
        g.insertAfter(c);
        g.appendBogus();
        c.$.colSpan = f;
        g.$.colSpan = k;
        1 == f && c.removeAttribute('colSpan');
        1 == k && g.removeAttribute('colSpan');
        return g;
      }
      var u = CKEDITOR.tools.isArray;
      CKEDITOR.plugins.tabletools = {
        requires: 'table,dialog,contextmenu',
        init: function (b) {
          function c(a) {
            return CKEDITOR.tools.extend(a || {}, {
              contextSensitive: 1,
              refresh: function (a, b) {
                this.setState(b.contains({ td: 1, th: 1 }, 1) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
              },
            });
          }
          function e(a, d) {
            var c = b.addCommand(a, d);
            b.addFeature(c);
          }
          var q = b.lang.table,
            u = CKEDITOR.tools.style.parse,
            w =
              'td{width} td{height} td{border-color} td{background-color} td{white-space} td{vertical-align} td{text-align} td[colspan] td[rowspan] th'.split(
                ' ',
              );
          e(
            'cellProperties',
            new CKEDITOR.dialogCommand(
              'cellProperties',
              c({
                allowedContent: 'td th{width,height,border-color,background-color,white-space,vertical-align,text-align}[colspan,rowspan]',
                requiredContent: w,
                contentTransformations: [
                  [
                    {
                      element: 'td',
                      left: function (a) {
                        return a.styles.background && u.background(a.styles.background).color;
                      },
                      right: function (a) {
                        a.styles['background-color'] = u.background(a.styles.background).color;
                      },
                    },
                    {
                      element: 'td',
                      check: 'td{vertical-align}',
                      left: function (a) {
                        return a.attributes && a.attributes.valign;
                      },
                      right: function (a) {
                        a.styles['vertical-align'] = a.attributes.valign;
                        delete a.attributes.valign;
                      },
                    },
                  ],
                  [
                    {
                      element: 'tr',
                      check: 'td{height}',
                      left: function (a) {
                        return a.styles && a.styles.height;
                      },
                      right: function (a) {
                        CKEDITOR.tools.array.forEach(a.children, function (b) {
                          b.name in { td: 1, th: 1 } && (b.attributes['cke-row-height'] = a.styles.height);
                        });
                        delete a.styles.height;
                      },
                    },
                  ],
                  [
                    {
                      element: 'td',
                      check: 'td{height}',
                      left: function (a) {
                        return (a = a.attributes) && a['cke-row-height'];
                      },
                      right: function (a) {
                        a.styles.height = a.attributes['cke-row-height'];
                        delete a.attributes['cke-row-height'];
                      },
                    },
                  ],
                ],
              }),
            ),
          );
          CKEDITOR.dialog.add('cellProperties', this.path + 'dialogs/tableCell.js');
          e(
            'rowDelete',
            c({
              requiredContent: 'table',
              exec: function (a) {
                a = a.getSelection();
                (a = f(a)) && d(a);
              },
            }),
          );
          e(
            'rowInsertBefore',
            c({
              requiredContent: 'table',
              exec: function (b) {
                b = b.getSelection();
                b = a(b);
                h(b, !0);
              },
            }),
          );
          e(
            'rowInsertAfter',
            c({
              requiredContent: 'table',
              exec: function (b) {
                b = b.getSelection();
                b = a(b);
                h(b);
              },
            }),
          );
          e(
            'columnDelete',
            c({
              requiredContent: 'table',
              exec: function (a) {
                a = a.getSelection();
                (a = k(a)) && d(a, !0);
              },
            }),
          );
          e(
            'columnInsertBefore',
            c({
              requiredContent: 'table',
              exec: function (b) {
                b = b.getSelection();
                b = a(b);
                l(b, !0);
              },
            }),
          );
          e(
            'columnInsertAfter',
            c({
              requiredContent: 'table',
              exec: function (b) {
                b = b.getSelection();
                b = a(b);
                l(b);
              },
            }),
          );
          e(
            'cellDelete',
            c({
              requiredContent: 'table',
              exec: function (a) {
                a = a.getSelection();
                g(a);
              },
            }),
          );
          e(
            'cellMerge',
            c({
              allowedContent: 'td[colspan,rowspan]',
              requiredContent: 'td[colspan,rowspan]',
              exec: function (a, b) {
                b.cell = n(a.getSelection());
                d(b.cell, !0);
              },
            }),
          );
          e(
            'cellMergeRight',
            c({
              allowedContent: 'td[colspan]',
              requiredContent: 'td[colspan]',
              exec: function (a, b) {
                b.cell = n(a.getSelection(), 'right');
                d(b.cell, !0);
              },
            }),
          );
          e(
            'cellMergeDown',
            c({
              allowedContent: 'td[rowspan]',
              requiredContent: 'td[rowspan]',
              exec: function (a, b) {
                b.cell = n(a.getSelection(), 'down');
                d(b.cell, !0);
              },
            }),
          );
          e(
            'cellVerticalSplit',
            c({
              allowedContent: 'td[rowspan]',
              requiredContent: 'td[rowspan]',
              exec: function (a) {
                d(x(a.getSelection()));
              },
            }),
          );
          e(
            'cellHorizontalSplit',
            c({
              allowedContent: 'td[colspan]',
              requiredContent: 'td[colspan]',
              exec: function (a) {
                d(r(a.getSelection()));
              },
            }),
          );
          e(
            'cellInsertBefore',
            c({
              requiredContent: 'table',
              exec: function (a) {
                a = a.getSelection();
                m(a, !0);
              },
            }),
          );
          e(
            'cellInsertAfter',
            c({
              requiredContent: 'table',
              exec: function (a) {
                a = a.getSelection();
                m(a);
              },
            }),
          );
          b.addMenuItems &&
            b.addMenuItems({
              tablecell: {
                label: q.cell.menu,
                group: 'tablecell',
                order: 1,
                getItems: function () {
                  var d = b.getSelection(),
                    c = a(d),
                    d = {
                      tablecell_insertBefore: CKEDITOR.TRISTATE_OFF,
                      tablecell_insertAfter: CKEDITOR.TRISTATE_OFF,
                      tablecell_delete: CKEDITOR.TRISTATE_OFF,
                      tablecell_merge: n(d, null, !0) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                      tablecell_merge_right: n(d, 'right', !0) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                      tablecell_merge_down: n(d, 'down', !0) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                      tablecell_split_vertical: x(d, !0) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                      tablecell_split_horizontal: r(d, !0) ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED,
                    };
                  b.filter.check(w) && (d.tablecell_properties = 0 < c.length ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
                  return d;
                },
              },
              tablecell_insertBefore: { label: q.cell.insertBefore, group: 'tablecell', command: 'cellInsertBefore', order: 5 },
              tablecell_insertAfter: { label: q.cell.insertAfter, group: 'tablecell', command: 'cellInsertAfter', order: 10 },
              tablecell_delete: { label: q.cell.deleteCell, group: 'tablecell', command: 'cellDelete', order: 15 },
              tablecell_merge: { label: q.cell.merge, group: 'tablecell', command: 'cellMerge', order: 16 },
              tablecell_merge_right: { label: q.cell.mergeRight, group: 'tablecell', command: 'cellMergeRight', order: 17 },
              tablecell_merge_down: { label: q.cell.mergeDown, group: 'tablecell', command: 'cellMergeDown', order: 18 },
              tablecell_split_horizontal: { label: q.cell.splitHorizontal, group: 'tablecell', command: 'cellHorizontalSplit', order: 19 },
              tablecell_split_vertical: { label: q.cell.splitVertical, group: 'tablecell', command: 'cellVerticalSplit', order: 20 },
              tablecell_properties: { label: q.cell.title, group: 'tablecellproperties', command: 'cellProperties', order: 21 },
              tablerow: {
                label: q.row.menu,
                group: 'tablerow',
                order: 1,
                getItems: function () {
                  return {
                    tablerow_insertBefore: CKEDITOR.TRISTATE_OFF,
                    tablerow_insertAfter: CKEDITOR.TRISTATE_OFF,
                    tablerow_delete: CKEDITOR.TRISTATE_OFF,
                  };
                },
              },
              tablerow_insertBefore: { label: q.row.insertBefore, group: 'tablerow', command: 'rowInsertBefore', order: 5 },
              tablerow_insertAfter: { label: q.row.insertAfter, group: 'tablerow', command: 'rowInsertAfter', order: 10 },
              tablerow_delete: { label: q.row.deleteRow, group: 'tablerow', command: 'rowDelete', order: 15 },
              tablecolumn: {
                label: q.column.menu,
                group: 'tablecolumn',
                order: 1,
                getItems: function () {
                  return {
                    tablecolumn_insertBefore: CKEDITOR.TRISTATE_OFF,
                    tablecolumn_insertAfter: CKEDITOR.TRISTATE_OFF,
                    tablecolumn_delete: CKEDITOR.TRISTATE_OFF,
                  };
                },
              },
              tablecolumn_insertBefore: { label: q.column.insertBefore, group: 'tablecolumn', command: 'columnInsertBefore', order: 5 },
              tablecolumn_insertAfter: { label: q.column.insertAfter, group: 'tablecolumn', command: 'columnInsertAfter', order: 10 },
              tablecolumn_delete: { label: q.column.deleteColumn, group: 'tablecolumn', command: 'columnDelete', order: 15 },
            });
          b.contextMenu &&
            b.contextMenu.addListener(function (a, b, d) {
              return (a = d.contains({ td: 1, th: 1 }, 1)) && !a.isReadOnly()
                ? { tablecell: CKEDITOR.TRISTATE_OFF, tablerow: CKEDITOR.TRISTATE_OFF, tablecolumn: CKEDITOR.TRISTATE_OFF }
                : null;
            });
        },
        getCellColIndex: b,
        insertRow: h,
        insertColumn: l,
        getSelectedCells: a,
      };
      CKEDITOR.plugins.add('tabletools', CKEDITOR.plugins.tabletools);
    })();
    CKEDITOR.tools.buildTableMap = function (a, h, f, b, c) {
      a = a.$.rows;
      f = f || 0;
      b = 'number' === typeof b ? b : a.length - 1;
      c = 'number' === typeof c ? c : -1;
      var l = -1,
        k = [];
      for (h = h || 0; h <= b; h++) {
        l++;
        !k[l] && (k[l] = []);
        for (var m = -1, g = f; g <= (-1 === c ? a[h].cells.length - 1 : c); g++) {
          var d = a[h].cells[g];
          if (!d) break;
          for (m++; k[l][m]; ) m++;
          for (var e = isNaN(d.colSpan) ? 1 : d.colSpan, d = isNaN(d.rowSpan) ? 1 : d.rowSpan, n = 0; n < d && !(h + n > b); n++) {
            k[l + n] || (k[l + n] = []);
            for (var r = 0; r < e; r++) k[l + n][m + r] = a[h].cells[g];
          }
          m += e - 1;
          if (-1 !== c && m >= c) break;
        }
      }
      return k;
    };
    (function () {
      function a(a) {
        return CKEDITOR.plugins.widget && CKEDITOR.plugins.widget.isDomWidget(a);
      }
      function h(a, b) {
        var d = a.getAscendant('table'),
          c = b.getAscendant('table'),
          e = CKEDITOR.tools.buildTableMap(d),
          f = g(a),
          h = g(b),
          k = [],
          l = {},
          m,
          n;
        d.contains(c) && ((b = b.getAscendant({ td: 1, th: 1 })), (h = g(b)));
        f > h && ((d = f), (f = h), (h = d), (d = a), (a = b), (b = d));
        for (d = 0; d < e[f].length; d++)
          if (a.$ === e[f][d]) {
            m = d;
            break;
          }
        for (d = 0; d < e[h].length; d++)
          if (b.$ === e[h][d]) {
            n = d;
            break;
          }
        m > n && ((d = m), (m = n), (n = d));
        for (d = f; d <= h; d++)
          for (f = m; f <= n; f++)
            (c = new CKEDITOR.dom.element(e[d][f])),
              c.$ && !c.getCustomData('selected_cell') && (k.push(c), CKEDITOR.dom.element.setMarker(l, c, 'selected_cell', !0));
        CKEDITOR.dom.element.clearAllMarkers(l);
        return k;
      }
      function f(a) {
        return (a = a.editable().findOne('.cke_table-faked-selection')) && a.getAscendant('table');
      }
      function b(a, b) {
        var d = a.editable().find('.cke_table-faked-selection'),
          c = a.editable().findOne('[data-cke-table-faked-selection-table]'),
          e;
        a.fire('lockSnapshot');
        a.editable().removeClass('cke_table-faked-selection-editor');
        for (e = 0; e < d.count(); e++) d.getItem(e).removeClass('cke_table-faked-selection');
        c && c.data('cke-table-faked-selection-table', !1);
        a.fire('unlockSnapshot');
        b && ((p = { active: !1 }), a.getSelection().isInTable() && a.getSelection().reset());
      }
      function c(a, b) {
        var d = [],
          c,
          e;
        for (e = 0; e < b.length; e++) (c = a.createRange()), c.setStartBefore(b[e]), c.setEndAfter(b[e]), d.push(c);
        a.getSelection().selectRanges(d);
      }
      function l(a) {
        var b = a.editable().find('.cke_table-faked-selection');
        1 > b.count() || ((b = h(b.getItem(0), b.getItem(b.count() - 1))), c(a, b));
      }
      function k(d, e, f) {
        var g = w(d.getSelection(!0));
        e = e.is('table') ? null : e;
        var k;
        (k = p.active && !p.first) &&
          !(k = e) &&
          ((k = d.getSelection().getRanges()), (k = 1 < g.length || (k[0] && !k[0].collapsed) ? !0 : !1));
        if (k) (p.first = e || g[0]), (p.dirty = e ? !1 : 1 !== g.length);
        else if (p.active && e && p.first.getAscendant('table').equals(e.getAscendant('table'))) {
          g = h(p.first, e);
          if (!p.dirty && 1 === g.length && !a(f.data.getTarget())) return b(d, 'mouseup' === f.name);
          p.dirty = !0;
          p.last = e;
          c(d, g);
        }
      }
      function m(a) {
        var d = (a = a.editor || a.sender.editor) && a.getSelection(),
          c = (d && d.getRanges()) || [],
          e = c && c[0].getEnclosedNode(),
          e = e && e.type == CKEDITOR.NODE_ELEMENT && e.is('img'),
          f;
        if (d && (b(a), d.isInTable() && d.isFake))
          if (e) a.getSelection().reset();
          else if (!c[0]._getTableElement({ table: 1 }).hasAttribute('data-cke-tableselection-ignored')) {
            1 === c.length && c[0]._getTableElement() && c[0]._getTableElement().is('table') && (f = c[0]._getTableElement());
            f = w(d, f);
            a.fire('lockSnapshot');
            for (d = 0; d < f.length; d++) f[d].addClass('cke_table-faked-selection');
            0 < f.length &&
              (a.editable().addClass('cke_table-faked-selection-editor'),
              f[0].getAscendant('table').data('cke-table-faked-selection-table', ''));
            a.fire('unlockSnapshot');
          }
      }
      function g(a) {
        return a.getAscendant('tr', !0).$.rowIndex;
      }
      function d(c) {
        function e(a, b) {
          return a && b ? a.equals(b) || a.contains(b) || b.contains(a) || a.getCommonAncestor(b).is(t) : !1;
        }
        function g(a) {
          return !a.getAscendant('table', !0) && a.getDocument().equals(m.document);
        }
        function h(a, b, d, c) {
          if ('mousedown' === a.name && (CKEDITOR.tools.getMouseButton(a) === CKEDITOR.MOUSE_BUTTON_LEFT || !c)) return !0;
          if ((b = a.name === (CKEDITOR.env.gecko ? 'mousedown' : 'mouseup') && !g(a.data.getTarget())))
            (a = a.data.getTarget().getAscendant({ td: 1, th: 1 }, !0)), (b = !(a && a.hasClass('cke_table-faked-selection')));
          return b;
        }
        if (c.data.getTarget().getName && ('mouseup' === c.name || !a(c.data.getTarget()))) {
          var m = c.editor || c.listenerData.editor,
            n = m.getSelection(1),
            r = f(m),
            q = c.data.getTarget(),
            u = q && q.getAscendant({ td: 1, th: 1 }, !0),
            q = q && q.getAscendant('table', !0),
            t = { table: 1, thead: 1, tbody: 1, tfoot: 1, tr: 1, td: 1, th: 1 };
          (q && q.hasAttribute('data-cke-tableselection-ignored')) ||
            (h(c, n, r, q) && b(m, !0),
            !p.active &&
              'mousedown' === c.name &&
              CKEDITOR.tools.getMouseButton(c) === CKEDITOR.MOUSE_BUTTON_LEFT &&
              q &&
              ((p = { active: !0 }), CKEDITOR.document.on('mouseup', d, null, { editor: m })),
            (u || q) && k(m, u || q, c),
            'mouseup' === c.name &&
              (CKEDITOR.tools.getMouseButton(c) === CKEDITOR.MOUSE_BUTTON_LEFT && (g(c.data.getTarget()) || e(r, q)) && l(m),
              (p = { active: !1 }),
              CKEDITOR.document.removeListener('mouseup', d)));
        }
      }
      function e(a) {
        var b = a.data.getTarget().getAscendant('table', !0);
        p.active = !1;
        (b && b.hasAttribute('data-cke-tableselection-ignored')) ||
          ((a = a.data.getTarget().getAscendant({ td: 1, th: 1 }, !0)), !a || a.hasClass('cke_table-faked-selection'));
      }
      function n(a, b) {
        function d(a) {
          a.cancel();
        }
        var c = a.getSelection(),
          e = c.createBookmarks(),
          f = a.document,
          g = a.createRange(),
          h = f.getDocumentElement().$,
          k = CKEDITOR.env.ie && 9 > CKEDITOR.env.version,
          l = a.blockless || CKEDITOR.env.ie ? 'span' : 'div',
          m,
          n,
          p,
          r;
        f.getById('cke_table_copybin') ||
          ((m = f.createElement(l)),
          (n = f.createElement(l)),
          n.setAttributes({ id: 'cke_table_copybin', 'data-cke-temp': '1' }),
          m.setStyles({ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden' }),
          m.setStyle('ltr' == a.config.contentsLangDirection ? 'left' : 'right', '-5000px'),
          m.setHtml(a.getSelectedHtml(!0)),
          a.fire('lockSnapshot'),
          n.append(m),
          a.editable().append(n),
          (r = a.on('selectionChange', d, null, null, 0)),
          k && (p = h.scrollTop),
          g.selectNodeContents(m),
          g.select(),
          k && (h.scrollTop = p),
          setTimeout(function () {
            n.remove();
            c.selectBookmarks(e);
            r.removeListener();
            a.fire('unlockSnapshot');
            b && (a.extractSelectedHtml(), a.fire('saveSnapshot'));
          }, 100));
      }
      function r(a) {
        var b = a.editor || a.sender.editor,
          d = b.getSelection();
        d.isInTable() &&
          (d.getRanges()[0]._getTableElement({ table: 1 }).hasAttribute('data-cke-tableselection-ignored') || n(b, 'cut' === a.name));
      }
      function x(a) {
        this._reset();
        a && this.setSelectedCells(a);
      }
      function u(a, b, d) {
        a.on('beforeCommandExec', function (d) {
          -1 !== CKEDITOR.tools.array.indexOf(b, d.data.name) && (d.data.selectedCells = w(a.getSelection()));
        });
        a.on(
          'afterCommandExec',
          function (c) {
            -1 !== CKEDITOR.tools.array.indexOf(b, c.data.name) && d(a, c.data);
          },
          null,
          null,
          9,
        );
      }
      var p = { active: !1 },
        t,
        w,
        q,
        B,
        z;
      x.prototype = {};
      x.prototype._reset = function () {
        this.cells = { first: null, last: null, all: [] };
        this.rows = { first: null, last: null };
      };
      x.prototype.setSelectedCells = function (a) {
        this._reset();
        a = a.slice(0);
        this._arraySortByDOMOrder(a);
        this.cells.all = a;
        this.cells.first = a[0];
        this.cells.last = a[a.length - 1];
        this.rows.first = a[0].getAscendant('tr');
        this.rows.last = this.cells.last.getAscendant('tr');
      };
      x.prototype.getTableMap = function () {
        var a = q(this.cells.first),
          b;
        a: {
          b = this.cells.last;
          var d = b.getAscendant('table'),
            c = g(b),
            d = CKEDITOR.tools.buildTableMap(d),
            e;
          for (e = 0; e < d[c].length; e++)
            if (new CKEDITOR.dom.element(d[c][e]).equals(b)) {
              b = e;
              break a;
            }
          b = void 0;
        }
        return CKEDITOR.tools.buildTableMap(this._getTable(), g(this.rows.first), a, g(this.rows.last), b);
      };
      x.prototype._getTable = function () {
        return this.rows.first.getAscendant('table');
      };
      x.prototype.insertRow = function (a, b, d) {
        if ('undefined' === typeof a) a = 1;
        else if (0 >= a) return;
        for (var c = this.cells.first.$.cellIndex, e = this.cells.last.$.cellIndex, f = d ? [] : this.cells.all, g, h = 0; h < a; h++)
          (g = B(d ? this.cells.all : f, b)),
            (g = CKEDITOR.tools.array.filter(g.find('td, th').toArray(), function (a) {
              return d ? !0 : a.$.cellIndex >= c && a.$.cellIndex <= e;
            })),
            (f = b ? g.concat(f) : f.concat(g));
        this.setSelectedCells(f);
      };
      x.prototype.insertColumn = function (a) {
        function b(a) {
          a = g(a);
          return a >= e && a <= f;
        }
        if ('undefined' === typeof a) a = 1;
        else if (0 >= a) return;
        for (var d = this.cells, c = d.all, e = g(d.first), f = g(d.last), d = 0; d < a; d++)
          c = c.concat(CKEDITOR.tools.array.filter(z(c), b));
        this.setSelectedCells(c);
      };
      x.prototype.emptyCells = function (a) {
        a = a || this.cells.all;
        for (var b = 0; b < a.length; b++) a[b].setHtml('');
      };
      x.prototype._arraySortByDOMOrder = function (a) {
        a.sort(function (a, b) {
          return a.getPosition(b) & CKEDITOR.POSITION_PRECEDING ? -1 : 1;
        });
      };
      var y = {
        onPaste: function (a) {
          function b(a) {
            var d = e.createRange();
            d.selectNodeContents(a);
            d.select();
          }
          function d(a) {
            return Math.max.apply(
              null,
              CKEDITOR.tools.array.map(
                a,
                function (a) {
                  return a.length;
                },
                0,
              ),
            );
          }
          var e = a.editor,
            f = e.getSelection(),
            g = w(f),
            k = f.isInTable(!0) && this.isBoundarySelection(f),
            l = this.findTableInPastedContent(e, a.data.dataValue),
            m,
            n;
          (function (a, b, d, c) {
            a = a.getRanges();
            var e = a.length && a[0]._getTableElement({ table: 1 });
            if (!b.length || (e && e.hasAttribute('data-cke-tableselection-ignored')) || (c && !d)) return !1;
            if ((b = !c))
              (b = a[0])
                ? ((b = b.clone()),
                  b.enlarge(CKEDITOR.ENLARGE_ELEMENT),
                  (b = (b = b.getEnclosedNode()) && b.is && b.is(CKEDITOR.dtd.$tableContent)))
                : (b = void 0),
                (b = !b);
            return b ? !1 : !0;
          })(f, g, l, k) &&
            'drop' !== a.data.method &&
            ((g = g[0].getAscendant('table')),
            (m = new x(w(f, g))),
            e.once('afterPaste', function () {
              var a;
              if (n) {
                a = new CKEDITOR.dom.element(n[0][0]);
                var b = n[n.length - 1];
                a = h(a, new CKEDITOR.dom.element(b[b.length - 1]));
              } else a = m.cells.all;
              c(e, a);
            }),
            l
              ? (a.stop(),
                k ? (m.insertRow(1, 1 === k, !0), f.selectElement(m.rows.first)) : (m.emptyCells(), c(e, m.cells.all)),
                (a = m.getTableMap()),
                (n = CKEDITOR.tools.buildTableMap(l)),
                m.insertRow(n.length - a.length),
                m.insertColumn(d(n) - d(a)),
                (a = m.getTableMap()),
                this.pasteTable(m, a, n),
                e.fire('saveSnapshot'),
                setTimeout(function () {
                  e.fire('afterPaste');
                }, 0))
              : (b(m.cells.first),
                e.once('afterPaste', function () {
                  e.fire('lockSnapshot');
                  m.emptyCells(m.cells.all.slice(1));
                  c(e, m.cells.all);
                  e.fire('unlockSnapshot');
                })));
        },
        isBoundarySelection: function (a) {
          a = a.getRanges()[0];
          var b = a.endContainer.getAscendant('tr', !0);
          if (b && a.collapsed) {
            if (a.checkBoundaryOfElement(b, CKEDITOR.START)) return 1;
            if (a.checkBoundaryOfElement(b, CKEDITOR.END)) return 2;
          }
          return 0;
        },
        findTableInPastedContent: function (a, b) {
          var d = a.dataProcessor,
            c = new CKEDITOR.dom.element('body');
          d || (d = new CKEDITOR.htmlDataProcessor(a));
          c.setHtml(d.toHtml(b), { fixForBody: !1 });
          return 1 < c.getChildCount() ? null : c.findOne('table');
        },
        pasteTable: function (a, b, d) {
          var c,
            e = q(a.cells.first),
            f = a._getTable(),
            g = {},
            h,
            k,
            l,
            m;
          for (l = 0; l < d.length; l++)
            for (h = new CKEDITOR.dom.element(f.$.rows[a.rows.first.$.rowIndex + l]), m = 0; m < d[l].length; m++)
              if (
                ((k = new CKEDITOR.dom.element(d[l][m])),
                (c = b[l] && b[l][m] ? new CKEDITOR.dom.element(b[l][m]) : null),
                k && !k.getCustomData('processed'))
              ) {
                if (c && c.getParent()) k.replace(c);
                else if (0 === m || d[l][m - 1])
                  (c = 0 !== m ? new CKEDITOR.dom.element(d[l][m - 1]) : null) && h.equals(c.getParent())
                    ? k.insertAfter(c)
                    : 0 < e
                      ? h.$.cells[e]
                        ? k.insertAfter(new CKEDITOR.dom.element(h.$.cells[e]))
                        : h.append(k)
                      : h.append(k, !0);
                CKEDITOR.dom.element.setMarker(g, k, 'processed', !0);
              } else k.getCustomData('processed') && c && c.remove();
          CKEDITOR.dom.element.clearAllMarkers(g);
        },
      };
      CKEDITOR.plugins.tableselection = {
        getCellsBetween: h,
        keyboardIntegration: function (a) {
          function b(a) {
            var d = a.getEnclosedNode();
            d && 'function' === typeof d.is && d.is({ td: 1, th: 1 }) ? d.setText('') : a.deleteContents();
            CKEDITOR.tools.array.forEach(a._find('td'), function (a) {
              a.appendBogus();
            });
          }
          var d = a.editable();
          d.attachListener(
            d,
            'keydown',
            (function (a) {
              function d(b, c) {
                if (!c.length) return null;
                var f = a.createRange(),
                  g = CKEDITOR.dom.range.mergeRanges(c);
                CKEDITOR.tools.array.forEach(g, function (a) {
                  a.enlarge(CKEDITOR.ENLARGE_ELEMENT);
                });
                var h = g[0].getBoundaryNodes(),
                  k = h.startNode,
                  h = h.endNode;
                if (k && k.is && k.is(e)) {
                  for (
                    var l = k.getAscendant('table', !0),
                      m = k.getPreviousSourceNode(!1, CKEDITOR.NODE_ELEMENT, l),
                      n = !1,
                      p = function (a) {
                        return !k.contains(a) && a.is && a.is('td', 'th');
                      };
                    m && !p(m);

                  )
                    m = m.getPreviousSourceNode(!1, CKEDITOR.NODE_ELEMENT, l);
                  !m && h && h.is && !h.is('table') && h.getNext() && ((m = h.getNext().findOne('td, th')), (n = !0));
                  if (m) f['moveToElementEdit' + (n ? 'Start' : 'End')](m);
                  else f.setStartBefore(k.getAscendant('table', !0)), f.collapse(!0);
                  g[0].deleteContents();
                  return [f];
                }
                if (k) return f.moveToElementEditablePosition(k), [f];
              }
              var c = { 37: 1, 38: 1, 39: 1, 40: 1, 8: 1, 46: 1, 13: 1 },
                e = CKEDITOR.tools.extend({ table: 1 }, CKEDITOR.dtd.$tableContent);
              delete e.td;
              delete e.th;
              return function (e) {
                var f = e.data.getKey(),
                  g = e.data.getKeystroke(),
                  h,
                  k = 37 === f || 38 == f,
                  l,
                  m,
                  n;
                if (c[f] && !a.readOnly && (h = a.getSelection()) && h.isInTable() && h.isFake) {
                  l = h.getRanges();
                  m = l[0]._getTableElement();
                  n = l[l.length - 1]._getTableElement();
                  if (13 !== f || a.plugins.enterkey) e.data.preventDefault(), e.cancel();
                  if (36 < f && 41 > f) l[0].moveToElementEditablePosition(k ? m : n, !k), h.selectRanges([l[0]]);
                  else if (13 !== f || 13 === g || g === CKEDITOR.SHIFT + 13) {
                    for (e = 0; e < l.length; e++) b(l[e]);
                    (e = d(m, l)) ? (l = e) : l[0].moveToElementEditablePosition(m);
                    h.selectRanges(l);
                    13 === f && a.plugins.enterkey
                      ? (a.fire('lockSnapshot'),
                        13 === g ? a.execCommand('enter') : a.execCommand('shiftEnter'),
                        a.fire('unlockSnapshot'),
                        a.fire('saveSnapshot'))
                      : 13 !== f && a.fire('saveSnapshot');
                  }
                }
              };
            })(a),
            null,
            null,
            -1,
          );
          d.attachListener(
            d,
            'keypress',
            function (d) {
              var c = a.getSelection(),
                e = d.data.$.charCode || 13 === d.data.getKey(),
                f;
              if (!a.readOnly && c && c.isInTable() && c.isFake && e && !(d.data.getKeystroke() & CKEDITOR.CTRL)) {
                d = c.getRanges();
                e = d[0].getEnclosedNode().getAscendant({ td: 1, th: 1 }, !0);
                for (f = 0; f < d.length; f++) b(d[f]);
                e && (d[0].moveToElementEditablePosition(e), c.selectRanges([d[0]]));
              }
            },
            null,
            null,
            -1,
          );
        },
      };
      CKEDITOR.plugins.add('tableselection', {
        requires: 'clipboard,tabletools',
        isSupportedEnvironment: function () {
          return !(CKEDITOR.env.ie && 11 > CKEDITOR.env.version);
        },
        onLoad: function () {
          t = CKEDITOR.plugins.tabletools;
          w = t.getSelectedCells;
          q = t.getCellColIndex;
          B = t.insertRow;
          z = t.insertColumn;
          CKEDITOR.document.appendStyleSheet(this.path + 'styles/tableselection.css');
        },
        init: function (a) {
          this.isSupportedEnvironment() &&
            (a.addContentsCss && a.addContentsCss(this.path + 'styles/tableselection.css'),
            a.on('contentDom', function () {
              var b = a.editable(),
                c = b.isInline() ? b : a.document,
                f = { editor: a };
              b.attachListener(c, 'mousedown', d, null, f);
              b.attachListener(c, 'mousemove', d, null, f);
              b.attachListener(c, 'mouseup', d, null, f);
              b.attachListener(b, 'dragstart', e);
              b.attachListener(a, 'selectionCheck', m);
              CKEDITOR.plugins.tableselection.keyboardIntegration(a);
              CKEDITOR.plugins.clipboard &&
                !CKEDITOR.plugins.clipboard.isCustomCopyCutSupported &&
                (b.attachListener(b, 'cut', r), b.attachListener(b, 'copy', r));
            }),
            a.on('paste', y.onPaste, y),
            u(
              a,
              'rowInsertBefore rowInsertAfter columnInsertBefore columnInsertAfter cellInsertBefore cellInsertAfter'.split(' '),
              function (a, b) {
                c(a, b.selectedCells);
              },
            ),
            u(a, ['cellMerge', 'cellMergeRight', 'cellMergeDown'], function (a, b) {
              c(a, [b.commandData.cell]);
            }),
            u(a, ['cellDelete'], function (a) {
              b(a, !0);
            }));
        },
      });
    })();
    (function () {
      CKEDITOR.plugins.add('templates', {
        requires: 'dialog,ajax',
        init: function (a) {
          CKEDITOR.dialog.add('templates', CKEDITOR.getUrl(this.path + 'dialogs/templates.js'));
          a.addCommand('templates', new CKEDITOR.dialogCommand('templates'));
          a.ui.addButton && a.ui.addButton('Templates', { label: a.lang.templates.button, command: 'templates', toolbar: 'doctools,10' });
        },
      });
      var a = {},
        h = {};
      CKEDITOR.addTemplates = function (f, b) {
        a[f] = b;
      };
      CKEDITOR.getTemplates = function (f) {
        return a[f];
      };
      CKEDITOR.loadTemplates = function (a, b) {
        for (var c = [], l = 0, k = a.length; l < k; l++) h[a[l]] || (c.push(a[l]), (h[a[l]] = 1));
        c.length ? CKEDITOR.scriptLoader.load(c, b) : setTimeout(b, 0);
      };
    })();
    CKEDITOR.config.templates_files = [CKEDITOR.getUrl('plugins/templates/templates/default.js')];
    CKEDITOR.config.templates_replaceContent = !0;
    ('use strict');
    (function () {
      function a(a, b) {
        return CKEDITOR.tools.array.reduce(
          b,
          function (a, b) {
            return b(a);
          },
          a,
        );
      }
      var h = [CKEDITOR.CTRL + 90, CKEDITOR.CTRL + 89, CKEDITOR.CTRL + CKEDITOR.SHIFT + 90],
        f = { 8: 1, 46: 1 };
      CKEDITOR.plugins.add('undo', {
        init: function (a) {
          function d(a) {
            f.enabled && !1 !== a.data.command.canUndo && f.save();
          }
          function c() {
            f.enabled = a.readOnly ? !1 : 'wysiwyg' == a.mode;
            f.onChange();
          }
          var f = (a.undoManager = new b(a)),
            l = (f.editingHandler = new k(f)),
            m = a.addCommand('undo', {
              exec: function () {
                f.undo() && (a.selectionChange(), this.fire('afterUndo'));
              },
              startDisabled: !0,
              canUndo: !1,
            }),
            u = a.addCommand('redo', {
              exec: function () {
                f.redo() && (a.selectionChange(), this.fire('afterRedo'));
              },
              startDisabled: !0,
              canUndo: !1,
            });
          a.setKeystroke([
            [h[0], 'undo'],
            [h[1], 'redo'],
            [h[2], 'redo'],
          ]);
          f.onChange = function () {
            m.setState(f.undoable() ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
            u.setState(f.redoable() ? CKEDITOR.TRISTATE_OFF : CKEDITOR.TRISTATE_DISABLED);
          };
          a.on('beforeCommandExec', d);
          a.on('afterCommandExec', d);
          a.on('saveSnapshot', function (a) {
            f.save(a.data && a.data.contentOnly);
          });
          a.on('contentDom', l.attachListeners, l);
          a.on('instanceReady', function () {
            a.fire('saveSnapshot');
          });
          a.on('beforeModeUnload', function () {
            'wysiwyg' == a.mode && f.save(!0);
          });
          a.on('mode', c);
          a.on('readOnly', c);
          a.ui.addButton &&
            (a.ui.addButton('Undo', { label: a.lang.undo.undo, command: 'undo', toolbar: 'undo,10' }),
            a.ui.addButton('Redo', { label: a.lang.undo.redo, command: 'redo', toolbar: 'undo,20' }));
          a.resetUndo = function () {
            f.reset();
            a.fire('saveSnapshot');
          };
          a.on('updateSnapshot', function () {
            f.currentImage && f.update();
          });
          a.on('lockSnapshot', function (a) {
            a = a.data;
            f.lock(a && a.dontUpdate, a && a.forceUpdate);
          });
          a.on('unlockSnapshot', f.unlock, f);
        },
      });
      CKEDITOR.plugins.undo = {};
      var b = (CKEDITOR.plugins.undo.UndoManager = function (a) {
        this.strokesRecorded = [0, 0];
        this.locked = null;
        this.previousKeyGroup = -1;
        this.limit = a.config.undoStackSize || 20;
        this.strokesLimit = 25;
        this._filterRules = [];
        this.editor = a;
        this.reset();
        CKEDITOR.env.ie &&
          this.addFilterRule(function (a) {
            return a.replace(/\s+data-cke-expando=".*?"/g, '');
          });
      });
      b.prototype = {
        type: function (a, d) {
          var c = b.getKeyGroup(a),
            f = this.strokesRecorded[c] + 1;
          d = d || f >= this.strokesLimit;
          this.typing || ((this.hasUndo = this.typing = !0), (this.hasRedo = !1), this.onChange());
          d ? ((f = 0), this.editor.fire('saveSnapshot')) : this.editor.fire('change');
          this.strokesRecorded[c] = f;
          this.previousKeyGroup = c;
        },
        keyGroupChanged: function (a) {
          return b.getKeyGroup(a) != this.previousKeyGroup;
        },
        reset: function () {
          this.snapshots = [];
          this.index = -1;
          this.currentImage = null;
          this.hasRedo = this.hasUndo = !1;
          this.locked = null;
          this.resetType();
        },
        resetType: function () {
          this.strokesRecorded = [0, 0];
          this.typing = !1;
          this.previousKeyGroup = -1;
        },
        refreshState: function () {
          this.hasUndo = !!this.getNextImage(!0);
          this.hasRedo = !!this.getNextImage(!1);
          this.resetType();
          this.onChange();
        },
        save: function (a, b, e) {
          var f = this.editor;
          if (this.locked || 'ready' != f.status || 'wysiwyg' != f.mode) return !1;
          var h = f.editable();
          if (!h || 'ready' != h.status) return !1;
          h = this.snapshots;
          b || (b = new c(f));
          if (!1 === b.contents) return !1;
          if (this.currentImage)
            if (b.equalsContent(this.currentImage)) {
              if (a || b.equalsSelection(this.currentImage)) return !1;
            } else !1 !== e && f.fire('change');
          h.splice(this.index + 1, h.length - this.index - 1);
          h.length == this.limit && h.shift();
          this.index = h.push(b) - 1;
          this.currentImage = b;
          !1 !== e && this.refreshState();
          return !0;
        },
        restoreImage: function (a) {
          var b = this.editor,
            c;
          a.bookmarks && (b.focus(), (c = b.getSelection()));
          this.locked = { level: 999 };
          this.editor.loadSnapshot(a.contents);
          a.bookmarks
            ? c.selectBookmarks(a.bookmarks)
            : CKEDITOR.env.ie && ((c = this.editor.document.getBody().$.createTextRange()), c.collapse(!0), c.select());
          this.locked = null;
          this.index = a.index;
          this.currentImage = this.snapshots[this.index];
          this.update();
          this.refreshState();
          b.fire('change');
        },
        getNextImage: function (a) {
          var b = this.snapshots,
            c = this.currentImage,
            f;
          if (c)
            if (a)
              for (f = this.index - 1; 0 <= f; f--) {
                if (((a = b[f]), !c.equalsContent(a))) return (a.index = f), a;
              }
            else for (f = this.index + 1; f < b.length; f++) if (((a = b[f]), !c.equalsContent(a))) return (a.index = f), a;
          return null;
        },
        redoable: function () {
          return this.enabled && this.hasRedo;
        },
        undoable: function () {
          return this.enabled && this.hasUndo;
        },
        undo: function () {
          if (this.undoable()) {
            this.save(!0);
            var a = this.getNextImage(!0);
            if (a) return this.restoreImage(a), !0;
          }
          return !1;
        },
        redo: function () {
          if (this.redoable() && (this.save(!0), this.redoable())) {
            var a = this.getNextImage(!1);
            if (a) return this.restoreImage(a), !0;
          }
          return !1;
        },
        update: function (a) {
          if (!this.locked) {
            a || (a = new c(this.editor));
            for (var b = this.index, e = this.snapshots; 0 < b && this.currentImage.equalsContent(e[b - 1]); ) --b;
            e.splice(b, this.index - b + 1, a);
            this.index = b;
            this.currentImage = a;
          }
        },
        updateSelection: function (a) {
          if (!this.snapshots.length) return !1;
          var b = this.snapshots,
            c = b[b.length - 1];
          return c.equalsContent(a) && !c.equalsSelection(a) ? ((this.currentImage = b[b.length - 1] = a), !0) : !1;
        },
        lock: function (a, b) {
          if (this.locked) this.locked.level++;
          else if (a) this.locked = { level: 1 };
          else {
            var e = null;
            if (b) e = !0;
            else {
              var f = new c(this.editor, !0);
              this.currentImage && this.currentImage.equalsContent(f) && (e = f);
            }
            this.locked = { update: e, level: 1 };
          }
        },
        unlock: function () {
          if (this.locked && !--this.locked.level) {
            var a = this.locked.update;
            this.locked = null;
            if (!0 === a) this.update();
            else if (a) {
              var b = new c(this.editor, !0);
              a.equalsContent(b) || this.update();
            }
          }
        },
        addFilterRule: function (a) {
          this._filterRules.push(a);
        },
      };
      b.navigationKeyCodes = { 37: 1, 38: 1, 39: 1, 40: 1, 36: 1, 35: 1, 33: 1, 34: 1 };
      b.keyGroups = { PRINTABLE: 0, FUNCTIONAL: 1 };
      b.isNavigationKey = function (a) {
        return !!b.navigationKeyCodes[a];
      };
      b.getKeyGroup = function (a) {
        var d = b.keyGroups;
        return f[a] ? d.FUNCTIONAL : d.PRINTABLE;
      };
      b.getOppositeKeyGroup = function (a) {
        var d = b.keyGroups;
        return a == d.FUNCTIONAL ? d.PRINTABLE : d.FUNCTIONAL;
      };
      b.ieFunctionalKeysBug = function (a) {
        return CKEDITOR.env.ie && b.getKeyGroup(a) == b.keyGroups.FUNCTIONAL;
      };
      var c = (CKEDITOR.plugins.undo.Image = function (b, d) {
          this.editor = b;
          b.fire('beforeUndoImage');
          var c = b.getSnapshot();
          c && (this.contents = a(c, b.undoManager._filterRules));
          d || (this.bookmarks = (c = c && b.getSelection()) && c.createBookmarks2(!0));
          b.fire('afterUndoImage');
        }),
        l = /\b(?:href|src|name)="[^"]*?"/gi;
      c.prototype = {
        equalsContent: function (a) {
          var b = this.contents;
          a = a.contents;
          CKEDITOR.env.ie && (CKEDITOR.env.ie7Compat || CKEDITOR.env.quirks) && ((b = b.replace(l, '')), (a = a.replace(l, '')));
          return b != a ? !1 : !0;
        },
        equalsSelection: function (a) {
          var b = this.bookmarks;
          a = a.bookmarks;
          if (b || a) {
            if (!b || !a || b.length != a.length) return !1;
            for (var c = 0; c < b.length; c++) {
              var f = b[c],
                h = a[c];
              if (
                f.startOffset != h.startOffset ||
                f.endOffset != h.endOffset ||
                !CKEDITOR.tools.arrayCompare(f.start, h.start) ||
                !CKEDITOR.tools.arrayCompare(f.end, h.end)
              )
                return !1;
            }
          }
          return !0;
        },
      };
      var k = (CKEDITOR.plugins.undo.NativeEditingHandler = function (a) {
        this.undoManager = a;
        this.ignoreInputEvent = !1;
        this.keyEventsStack = new m();
        this.lastKeydownImage = null;
      });
      k.prototype = {
        onKeydown: function (a) {
          var d = a.data.getKey();
          if (229 !== d)
            if (-1 < CKEDITOR.tools.indexOf(h, a.data.getKeystroke())) a.data.preventDefault();
            else if (
              (this.keyEventsStack.cleanUp(a),
              (a = this.undoManager),
              this.keyEventsStack.getLast(d) || this.keyEventsStack.push(d),
              (this.lastKeydownImage = new c(a.editor)),
              b.isNavigationKey(d) || this.undoManager.keyGroupChanged(d))
            )
              if (a.strokesRecorded[0] || a.strokesRecorded[1]) a.save(!1, this.lastKeydownImage, !1), a.resetType();
        },
        onInput: function () {
          if (this.ignoreInputEvent) this.ignoreInputEvent = !1;
          else {
            var a = this.keyEventsStack.getLast();
            a || (a = this.keyEventsStack.push(0));
            this.keyEventsStack.increment(a.keyCode);
            this.keyEventsStack.getTotalInputs() >= this.undoManager.strokesLimit &&
              (this.undoManager.type(a.keyCode, !0), this.keyEventsStack.resetInputs());
          }
        },
        onKeyup: function (a) {
          var d = this.undoManager;
          a = a.data.getKey();
          var e = this.keyEventsStack.getTotalInputs();
          this.keyEventsStack.remove(a);
          if (!(b.ieFunctionalKeysBug(a) && this.lastKeydownImage && this.lastKeydownImage.equalsContent(new c(d.editor, !0))))
            if (0 < e) d.type(a);
            else if (b.isNavigationKey(a)) this.onNavigationKey(!0);
        },
        onNavigationKey: function (a) {
          var b = this.undoManager;
          (!a && b.save(!0, null, !1)) || b.updateSelection(new c(b.editor));
          b.resetType();
        },
        ignoreInputEventListener: function () {
          this.ignoreInputEvent = !0;
        },
        activateInputEventListener: function () {
          this.ignoreInputEvent = !1;
        },
        attachListeners: function () {
          var a = this.undoManager.editor,
            c = a.editable(),
            e = this;
          c.attachListener(
            c,
            'keydown',
            function (a) {
              e.onKeydown(a);
              if (b.ieFunctionalKeysBug(a.data.getKey())) e.onInput();
            },
            null,
            null,
            999,
          );
          c.attachListener(c, CKEDITOR.env.ie ? 'keypress' : 'input', e.onInput, e, null, 999);
          c.attachListener(c, 'keyup', e.onKeyup, e, null, 999);
          c.attachListener(c, 'paste', e.ignoreInputEventListener, e, null, 999);
          c.attachListener(c, 'drop', e.ignoreInputEventListener, e, null, 999);
          a.on('afterPaste', e.activateInputEventListener, e, null, 999);
          c.attachListener(
            c.isInline() ? c : a.document.getDocumentElement(),
            'click',
            function () {
              e.onNavigationKey();
            },
            null,
            null,
            999,
          );
          c.attachListener(
            this.undoManager.editor,
            'blur',
            function () {
              e.keyEventsStack.remove(9);
            },
            null,
            null,
            999,
          );
        },
      };
      var m = (CKEDITOR.plugins.undo.KeyEventsStack = function () {
        this.stack = [];
      });
      m.prototype = {
        push: function (a) {
          a = this.stack.push({ keyCode: a, inputs: 0 });
          return this.stack[a - 1];
        },
        getLastIndex: function (a) {
          if ('number' != typeof a) return this.stack.length - 1;
          for (var b = this.stack.length; b--; ) if (this.stack[b].keyCode == a) return b;
          return -1;
        },
        getLast: function (a) {
          a = this.getLastIndex(a);
          return -1 != a ? this.stack[a] : null;
        },
        increment: function (a) {
          this.getLast(a).inputs++;
        },
        remove: function (a) {
          a = this.getLastIndex(a);
          -1 != a && this.stack.splice(a, 1);
        },
        resetInputs: function (a) {
          if ('number' == typeof a) this.getLast(a).inputs = 0;
          else for (a = this.stack.length; a--; ) this.stack[a].inputs = 0;
        },
        getTotalInputs: function () {
          for (var a = this.stack.length, b = 0; a--; ) b += this.stack[a].inputs;
          return b;
        },
        cleanUp: function (a) {
          a = a.data.$;
          a.ctrlKey || a.metaKey || this.remove(17);
          a.shiftKey || this.remove(16);
          a.altKey || this.remove(18);
        },
      };
    })();
    ('use strict');
    (function () {
      function a(a, b) {
        CKEDITOR.tools.extend(this, { editor: a, editable: a.editable(), doc: a.document, win: a.window }, b, !0);
        this.inline = this.editable.isInline();
        this.inline || (this.frame = this.win.getFrame());
        this.target = this[this.inline ? 'editable' : 'doc'];
      }
      function h(a, b) {
        CKEDITOR.tools.extend(this, b, { editor: a }, !0);
      }
      function f(a, b) {
        var e = a.editable();
        CKEDITOR.tools.extend(
          this,
          {
            editor: a,
            editable: e,
            inline: e.isInline(),
            doc: a.document,
            win: a.window,
            container: CKEDITOR.document.getBody(),
            winTop: CKEDITOR.document.getWindow(),
          },
          b,
          !0,
        );
        this.hidden = {};
        this.visible = {};
        this.inline || (this.frame = this.win.getFrame());
        this.queryViewport();
        var f = CKEDITOR.tools.bind(this.queryViewport, this),
          h = CKEDITOR.tools.bind(this.hideVisible, this),
          k = CKEDITOR.tools.bind(this.removeAll, this);
        e.attachListener(this.winTop, 'resize', f);
        e.attachListener(this.winTop, 'scroll', f);
        e.attachListener(this.winTop, 'resize', h);
        e.attachListener(this.win, 'scroll', h);
        e.attachListener(
          this.inline ? e : this.frame,
          'mouseout',
          function (a) {
            var b = a.data.$.clientX;
            a = a.data.$.clientY;
            this.queryViewport();
            (b <= this.rect.left || b >= this.rect.right || a <= this.rect.top || a >= this.rect.bottom) && this.hideVisible();
            (0 >= b || b >= this.winTopPane.width || 0 >= a || a >= this.winTopPane.height) && this.hideVisible();
          },
          this,
        );
        e.attachListener(a, 'resize', f);
        e.attachListener(a, 'mode', k);
        a.on('destroy', k);
        this.lineTpl = new CKEDITOR.template(
          '\x3cdiv data-cke-lineutils-line\x3d"1" class\x3d"cke_reset_all" style\x3d"{lineStyle}"\x3e\x3cspan style\x3d"{tipLeftStyle}"\x3e\x26nbsp;\x3c/span\x3e\x3cspan style\x3d"{tipRightStyle}"\x3e\x26nbsp;\x3c/span\x3e\x3c/div\x3e',
        ).output({
          lineStyle: CKEDITOR.tools.writeCssText(CKEDITOR.tools.extend({}, l, this.lineStyle, !0)),
          tipLeftStyle: CKEDITOR.tools.writeCssText(
            CKEDITOR.tools.extend(
              {},
              c,
              { left: '0px', 'border-left-color': 'red', 'border-width': '6px 0 6px 6px' },
              this.tipCss,
              this.tipLeftStyle,
              !0,
            ),
          ),
          tipRightStyle: CKEDITOR.tools.writeCssText(
            CKEDITOR.tools.extend(
              {},
              c,
              { right: '0px', 'border-right-color': 'red', 'border-width': '6px 6px 6px 0' },
              this.tipCss,
              this.tipRightStyle,
              !0,
            ),
          ),
        });
      }
      function b(a) {
        var b;
        if ((b = a && a.type == CKEDITOR.NODE_ELEMENT)) b = !(k[a.getComputedStyle('float')] || k[a.getAttribute('align')]);
        return b && !m[a.getComputedStyle('position')];
      }
      CKEDITOR.plugins.add('lineutils');
      CKEDITOR.LINEUTILS_BEFORE = 1;
      CKEDITOR.LINEUTILS_AFTER = 2;
      CKEDITOR.LINEUTILS_INSIDE = 4;
      a.prototype = {
        start: function (a) {
          var b = this,
            c = this.editor,
            f = this.doc,
            h,
            k,
            l,
            m,
            t = CKEDITOR.tools.eventsBuffer(50, function () {
              c.readOnly ||
                'wysiwyg' != c.mode ||
                ((b.relations = {}),
                (k = f.$.elementFromPoint(l, m)) &&
                  k.nodeType &&
                  ((h = new CKEDITOR.dom.element(k)),
                  b.traverseSearch(h),
                  isNaN(l + m) || b.pixelSearch(h, l, m),
                  a && a(b.relations, l, m)));
            });
          this.listener = this.editable.attachListener(this.target, 'mousemove', function (a) {
            l = a.data.$.clientX;
            m = a.data.$.clientY;
            t.input();
          });
          this.editable.attachListener(this.inline ? this.editable : this.frame, 'mouseout', function () {
            t.reset();
          });
        },
        stop: function () {
          this.listener && this.listener.removeListener();
        },
        getRange: (function () {
          var a = {};
          a[CKEDITOR.LINEUTILS_BEFORE] = CKEDITOR.POSITION_BEFORE_START;
          a[CKEDITOR.LINEUTILS_AFTER] = CKEDITOR.POSITION_AFTER_END;
          a[CKEDITOR.LINEUTILS_INSIDE] = CKEDITOR.POSITION_AFTER_START;
          return function (b) {
            var c = this.editor.createRange();
            c.moveToPosition(this.relations[b.uid].element, a[b.type]);
            return c;
          };
        })(),
        store: (function () {
          function a(b, c, f) {
            var g = b.getUniqueId();
            g in f ? (f[g].type |= c) : (f[g] = { element: b, type: c });
          }
          return function (c, e) {
            var f;
            e & CKEDITOR.LINEUTILS_AFTER &&
              b((f = c.getNext())) &&
              f.isVisible() &&
              (a(f, CKEDITOR.LINEUTILS_BEFORE, this.relations), (e ^= CKEDITOR.LINEUTILS_AFTER));
            e & CKEDITOR.LINEUTILS_INSIDE &&
              b((f = c.getFirst())) &&
              f.isVisible() &&
              (a(f, CKEDITOR.LINEUTILS_BEFORE, this.relations), (e ^= CKEDITOR.LINEUTILS_INSIDE));
            a(c, e, this.relations);
          };
        })(),
        traverseSearch: function (a) {
          var c, e, f;
          do
            if (((f = a.$['data-cke-expando']), !(f && f in this.relations))) {
              if (a.equals(this.editable)) break;
              if (b(a)) for (c in this.lookups) (e = this.lookups[c](a)) && this.store(a, e);
            }
          while ((!a || a.type != CKEDITOR.NODE_ELEMENT || 'true' != a.getAttribute('contenteditable')) && (a = a.getParent()));
        },
        pixelSearch: (function () {
          function a(e, f, g, h, k) {
            for (var l = 0, m; k(g); ) {
              g += h;
              if (25 == ++l) break;
              if ((m = this.doc.$.elementFromPoint(f, g)))
                if (m == e) l = 0;
                else if (c(e, m) && ((l = 0), b((m = new CKEDITOR.dom.element(m))))) return m;
            }
          }
          var c =
            CKEDITOR.env.ie || CKEDITOR.env.webkit
              ? function (a, b) {
                  return a.contains(b);
                }
              : function (a, b) {
                  return !!(a.compareDocumentPosition(b) & 16);
                };
          return function (c, d, f) {
            var h = this.win.getViewPaneSize().height,
              k = a.call(this, c.$, d, f, -1, function (a) {
                return 0 < a;
              });
            d = a.call(this, c.$, d, f, 1, function (a) {
              return a < h;
            });
            if (k) for (this.traverseSearch(k); !k.getParent().equals(c); ) k = k.getParent();
            if (d) for (this.traverseSearch(d); !d.getParent().equals(c); ) d = d.getParent();
            for (; k || d; ) {
              k && (k = k.getNext(b));
              if (!k || k.equals(d)) break;
              this.traverseSearch(k);
              d && (d = d.getPrevious(b));
              if (!d || d.equals(k)) break;
              this.traverseSearch(d);
            }
          };
        })(),
        greedySearch: function () {
          this.relations = {};
          for (var a = this.editable.getElementsByTag('*'), c = 0, e, f, h; (e = a.getItem(c++)); )
            if (
              !e.equals(this.editable) &&
              e.type == CKEDITOR.NODE_ELEMENT &&
              (e.hasAttribute('contenteditable') || !e.isReadOnly()) &&
              b(e) &&
              e.isVisible()
            )
              for (h in this.lookups) (f = this.lookups[h](e)) && this.store(e, f);
          return this.relations;
        },
      };
      h.prototype = {
        locate: (function () {
          function a(c, e) {
            var f = c.element[e === CKEDITOR.LINEUTILS_BEFORE ? 'getPrevious' : 'getNext']();
            return f && b(f)
              ? ((c.siblingRect = f.getClientRect()),
                e == CKEDITOR.LINEUTILS_BEFORE
                  ? (c.siblingRect.bottom + c.elementRect.top) / 2
                  : (c.elementRect.bottom + c.siblingRect.top) / 2)
              : e == CKEDITOR.LINEUTILS_BEFORE
                ? c.elementRect.top
                : c.elementRect.bottom;
          }
          return function (b) {
            var c;
            this.locations = {};
            for (var f in b)
              (c = b[f]),
                (c.elementRect = c.element.getClientRect()),
                c.type & CKEDITOR.LINEUTILS_BEFORE && this.store(f, CKEDITOR.LINEUTILS_BEFORE, a(c, CKEDITOR.LINEUTILS_BEFORE)),
                c.type & CKEDITOR.LINEUTILS_AFTER && this.store(f, CKEDITOR.LINEUTILS_AFTER, a(c, CKEDITOR.LINEUTILS_AFTER)),
                c.type & CKEDITOR.LINEUTILS_INSIDE &&
                  this.store(f, CKEDITOR.LINEUTILS_INSIDE, (c.elementRect.top + c.elementRect.bottom) / 2);
            return this.locations;
          };
        })(),
        sort: (function () {
          var a, b, c, f;
          return function (h, k) {
            a = this.locations;
            b = [];
            for (var l in a)
              for (var m in a[l])
                if (((c = Math.abs(h - a[l][m])), b.length)) {
                  for (f = 0; f < b.length; f++)
                    if (c < b[f].dist) {
                      b.splice(f, 0, { uid: +l, type: m, dist: c });
                      break;
                    }
                  f == b.length && b.push({ uid: +l, type: m, dist: c });
                } else b.push({ uid: +l, type: m, dist: c });
            return 'undefined' != typeof k ? b.slice(0, k) : b;
          };
        })(),
        store: function (a, b, c) {
          this.locations[a] || (this.locations[a] = {});
          this.locations[a][b] = c;
        },
      };
      var c = {
          display: 'block',
          width: '0px',
          height: '0px',
          'border-color': 'transparent',
          'border-style': 'solid',
          position: 'absolute',
          top: '-6px',
        },
        l = { height: '0px', 'border-top': '1px dashed red', position: 'absolute', 'z-index': 9999 };
      f.prototype = {
        removeAll: function () {
          for (var a in this.hidden) this.hidden[a].remove(), delete this.hidden[a];
          for (a in this.visible) this.visible[a].remove(), delete this.visible[a];
        },
        hideLine: function (a) {
          var b = a.getUniqueId();
          a.hide();
          this.hidden[b] = a;
          delete this.visible[b];
        },
        showLine: function (a) {
          var b = a.getUniqueId();
          a.show();
          this.visible[b] = a;
          delete this.hidden[b];
        },
        hideVisible: function () {
          for (var a in this.visible) this.hideLine(this.visible[a]);
        },
        placeLine: function (a, b) {
          var c, f, h;
          if ((c = this.getStyle(a.uid, a.type))) {
            for (h in this.visible)
              if (this.visible[h].getCustomData('hash') !== this.hash) {
                f = this.visible[h];
                break;
              }
            if (!f)
              for (h in this.hidden)
                if (this.hidden[h].getCustomData('hash') !== this.hash) {
                  this.showLine((f = this.hidden[h]));
                  break;
                }
            f || this.showLine((f = this.addLine()));
            f.setCustomData('hash', this.hash);
            this.visible[f.getUniqueId()] = f;
            f.setStyles(c);
            b && b(f);
          }
        },
        getStyle: function (a, b) {
          var c = this.relations[a],
            f = this.locations[a][b],
            h = {};
          h.width = c.siblingRect ? Math.max(c.siblingRect.width, c.elementRect.width) : c.elementRect.width;
          h.top = this.inline ? f + this.winTopScroll.y - this.rect.relativeY : this.rect.top + this.winTopScroll.y + f;
          if (h.top - this.winTopScroll.y < this.rect.top || h.top - this.winTopScroll.y > this.rect.bottom) return !1;
          this.inline
            ? (h.left = c.elementRect.left - this.rect.relativeX)
            : (0 < c.elementRect.left
                ? (h.left = this.rect.left + c.elementRect.left)
                : ((h.width += c.elementRect.left), (h.left = this.rect.left)),
              0 < (c = h.left + h.width - (this.rect.left + this.winPane.width)) && (h.width -= c));
          h.left += this.winTopScroll.x;
          for (var k in h) h[k] = CKEDITOR.tools.cssLength(h[k]);
          return h;
        },
        addLine: function () {
          var a = CKEDITOR.dom.element.createFromHtml(this.lineTpl);
          a.appendTo(this.container);
          return a;
        },
        prepare: function (a, b) {
          this.relations = a;
          this.locations = b;
          this.hash = Math.random();
        },
        cleanup: function () {
          var a, b;
          for (b in this.visible) (a = this.visible[b]), a.getCustomData('hash') !== this.hash && this.hideLine(a);
        },
        queryViewport: function () {
          this.winPane = this.win.getViewPaneSize();
          this.winTopScroll = this.winTop.getScrollPosition();
          this.winTopPane = this.winTop.getViewPaneSize();
          this.rect = this.getClientRect(this.inline ? this.editable : this.frame);
        },
        getClientRect: function (a) {
          a = a.getClientRect();
          var b = this.container.getDocumentPosition(),
            c = this.container.getComputedStyle('position');
          a.relativeX = a.relativeY = 0;
          'static' != c &&
            ((a.relativeY = b.y),
            (a.relativeX = b.x),
            (a.top -= a.relativeY),
            (a.bottom -= a.relativeY),
            (a.left -= a.relativeX),
            (a.right -= a.relativeX));
          return a;
        },
      };
      var k = { left: 1, right: 1, center: 1 },
        m = { absolute: 1, fixed: 1 };
      CKEDITOR.plugins.lineutils = { finder: a, locator: h, liner: f };
    })();
    (function () {
      function a(a) {
        return a.getName && !a.hasAttribute('data-cke-temp');
      }
      CKEDITOR.plugins.add('widgetselection', {
        init: function (a) {
          if (CKEDITOR.env.webkit) {
            var f = CKEDITOR.plugins.widgetselection;
            a.on('contentDom', function (a) {
              a = a.editor;
              var c = a.editable();
              c.attachListener(
                c,
                'keydown',
                function (a) {
                  a.data.getKeystroke() == CKEDITOR.CTRL + 65 &&
                    CKEDITOR.tools.setTimeout(function () {
                      f.addFillers(c) || f.removeFillers(c);
                    }, 0);
                },
                null,
                null,
                -1,
              );
              a.on('selectionCheck', function (a) {
                f.removeFillers(a.editor.editable());
              });
              a.on('paste', function (a) {
                a.data.dataValue = f.cleanPasteData(a.data.dataValue);
              });
              'selectall' in a.plugins && f.addSelectAllIntegration(a);
            });
          }
        },
      });
      CKEDITOR.plugins.widgetselection = {
        startFiller: null,
        endFiller: null,
        fillerAttribute: 'data-cke-filler-webkit',
        fillerContent: '\x26nbsp;',
        fillerTagName: 'div',
        addFillers: function (h) {
          var f = h.editor;
          if (!this.isWholeContentSelected(h) && 0 < h.getChildCount()) {
            var b = h.getFirst(a),
              c = h.getLast(a);
            b &&
              b.type == CKEDITOR.NODE_ELEMENT &&
              !b.isEditable() &&
              ((this.startFiller = this.createFiller()), h.append(this.startFiller, 1));
            c &&
              c.type == CKEDITOR.NODE_ELEMENT &&
              !c.isEditable() &&
              ((this.endFiller = this.createFiller(!0)), h.append(this.endFiller, 0));
            if (this.hasFiller(h)) return (f = f.createRange()), f.selectNodeContents(h), f.select(), !0;
          }
          return !1;
        },
        removeFillers: function (a) {
          if (this.hasFiller(a) && !this.isWholeContentSelected(a)) {
            var f = a.findOne(this.fillerTagName + '[' + this.fillerAttribute + '\x3dstart]'),
              b = a.findOne(this.fillerTagName + '[' + this.fillerAttribute + '\x3dend]');
            this.startFiller && f && this.startFiller.equals(f) ? this.removeFiller(this.startFiller, a) : (this.startFiller = f);
            this.endFiller && b && this.endFiller.equals(b) ? this.removeFiller(this.endFiller, a) : (this.endFiller = b);
          }
        },
        cleanPasteData: function (a) {
          a && a.length && (a = a.replace(this.createFillerRegex(), '').replace(this.createFillerRegex(!0), ''));
          return a;
        },
        isWholeContentSelected: function (a) {
          var f = a.editor.getSelection().getRanges()[0];
          return !f || (f && f.collapsed)
            ? !1
            : ((f = f.clone()),
              f.enlarge(CKEDITOR.ENLARGE_ELEMENT),
              !!(
                f &&
                a &&
                f.startContainer &&
                f.endContainer &&
                0 === f.startOffset &&
                f.endOffset === a.getChildCount() &&
                f.startContainer.equals(a) &&
                f.endContainer.equals(a)
              ));
        },
        hasFiller: function (a) {
          return 0 < a.find(this.fillerTagName + '[' + this.fillerAttribute + ']').count();
        },
        createFiller: function (a) {
          var f = new CKEDITOR.dom.element(this.fillerTagName);
          f.setHtml(this.fillerContent);
          f.setAttribute(this.fillerAttribute, a ? 'end' : 'start');
          f.setAttribute('data-cke-temp', 1);
          f.setStyles({
            display: 'block',
            width: 0,
            height: 0,
            padding: 0,
            border: 0,
            margin: 0,
            position: 'absolute',
            top: 0,
            left: '-9999px',
            opacity: 0,
            overflow: 'hidden',
          });
          return f;
        },
        removeFiller: function (a, f) {
          if (a) {
            var b = f.editor,
              c = f.editor.getSelection().getRanges()[0].startPath(),
              l = b.createRange(),
              k,
              m;
            c.contains(a) && ((k = a.getHtml()), (m = !0));
            c = 'start' == a.getAttribute(this.fillerAttribute);
            a.remove();
            k && 0 < k.length && k != this.fillerContent
              ? (f.insertHtmlIntoRange(k, b.getSelection().getRanges()[0]),
                l.setStartAt(f.getChild(f.getChildCount() - 1), CKEDITOR.POSITION_BEFORE_END),
                b.getSelection().selectRanges([l]))
              : m &&
                (c
                  ? l.setStartAt(f.getFirst().getNext(), CKEDITOR.POSITION_AFTER_START)
                  : l.setEndAt(f.getLast().getPrevious(), CKEDITOR.POSITION_BEFORE_END),
                f.editor.getSelection().selectRanges([l]));
          }
        },
        createFillerRegex: function (a) {
          var f = this.createFiller(a)
            .getOuterHtml()
            .replace(/style="[^"]*"/gi, 'style\x3d"[^"]*"')
            .replace(/>[^<]*</gi, '\x3e[^\x3c]*\x3c');
          return new RegExp((a ? '' : '^') + f + (a ? '$' : ''));
        },
        addSelectAllIntegration: function (a) {
          var f = this;
          a.editable().attachListener(
            a,
            'beforeCommandExec',
            function (b) {
              var c = a.editable();
              'selectAll' == b.data.name && c && f.addFillers(c);
            },
            null,
            null,
            9999,
          );
        },
      };
    })();
    ('use strict');
    (function () {
      function a(a) {
        this.editor = a;
        this.registered = {};
        this.instances = {};
        this.selected = [];
        this.widgetHoldingFocusedEditable = this.focused = null;
        this._ = { nextId: 0, upcasts: [], upcastCallbacks: [], filters: {} };
        D(this);
        F(this);
        this.on('checkWidgets', k);
        this.editor.on('contentDomInvalidated', this.checkWidgets, this);
        C(this);
        z(this);
        y(this);
        B(this);
        v(this);
      }
      function h(a, b, c, d, e) {
        var f = a.editor;
        CKEDITOR.tools.extend(
          this,
          d,
          {
            editor: f,
            id: b,
            inline: 'span' == c.getParent().getName(),
            element: c,
            data: CKEDITOR.tools.extend({}, 'function' == typeof d.defaults ? d.defaults() : d.defaults),
            dataReady: !1,
            inited: !1,
            ready: !1,
            edit: h.prototype.edit,
            focusedEditable: null,
            definition: d,
            repository: a,
            draggable: !1 !== d.draggable,
            _: { downcastFn: d.downcast && 'string' == typeof d.downcast ? d.downcasts[d.downcast] : d.downcast },
          },
          !0,
        );
        a.fire('instanceCreated', this);
        N(this, d);
        this.init && this.init();
        this.inited = !0;
        (a = this.element.data('cke-widget-data')) && this.setData(JSON.parse(decodeURIComponent(a)));
        e && this.setData(e);
        this.data.classes || this.setData('classes', this.getClasses());
        this.dataReady = !0;
        Z(this);
        this.fire('data', this.data);
        this.isInited() && f.editable().contains(this.wrapper) && ((this.ready = !0), this.fire('ready'));
      }
      function f(a, b, c) {
        CKEDITOR.dom.element.call(this, b.$);
        this.editor = a;
        this._ = {};
        b = this.filter = c.filter;
        CKEDITOR.dtd[this.getName()].p
          ? ((this.enterMode = b ? b.getAllowedEnterMode(a.enterMode) : a.enterMode),
            (this.shiftEnterMode = b ? b.getAllowedEnterMode(a.shiftEnterMode, !0) : a.shiftEnterMode))
          : (this.enterMode = this.shiftEnterMode = CKEDITOR.ENTER_BR);
      }
      function b(a, b) {
        a.addCommand(b.name, {
          exec: function (a, c) {
            function d() {
              a.widgets.finalizeCreation(h);
            }
            var e = a.widgets.focused;
            if (e && e.name == b.name) e.edit();
            else if (b.insert) b.insert({ editor: a, commandData: c });
            else if (b.template) {
              var e = 'function' == typeof b.defaults ? b.defaults() : b.defaults,
                e = CKEDITOR.dom.element.createFromHtml(b.template.output(e), a.document),
                f,
                g = a.widgets.wrapElement(e, b.name),
                h = new CKEDITOR.dom.documentFragment(g.getDocument());
              h.append(g);
              (f = a.widgets.initOn(e, b, c && c.startupData))
                ? ((e = f.once(
                    'edit',
                    function (b) {
                      if (b.data.dialog)
                        f.once('dialog', function (b) {
                          b = b.data;
                          var c, e;
                          c = b.once('ok', d, null, null, 20);
                          e = b.once('cancel', function (b) {
                            (b.data && !1 === b.data.hide) || a.widgets.destroy(f, !0);
                          });
                          b.once('hide', function () {
                            c.removeListener();
                            e.removeListener();
                          });
                        });
                      else d();
                    },
                    null,
                    null,
                    999,
                  )),
                  f.edit(),
                  e.removeListener())
                : d();
            }
          },
          allowedContent: b.allowedContent,
          requiredContent: b.requiredContent,
          contentForms: b.contentForms,
          contentTransformations: b.contentTransformations,
        });
      }
      function c(a, b) {
        function c(a, d) {
          var e = b.upcast.split(','),
            f,
            g;
          for (g = 0; g < e.length; g++) if (((f = e[g]), f === a.name)) return b.upcasts[f].call(this, a, d);
          return !1;
        }
        function d(b, c, e) {
          var f = CKEDITOR.tools.getIndex(a._.upcasts, function (a) {
            return a[2] > e;
          });
          0 > f && (f = a._.upcasts.length);
          a._.upcasts.splice(f, 0, [CKEDITOR.tools.bind(b, c), c.name, e]);
        }
        var e = b.upcast,
          f = b.upcastPriority || 10;
        e && ('string' == typeof e ? d(c, b, f) : d(e, b, f));
      }
      function l(a, b) {
        a.focused = null;
        if (b.isInited()) {
          var c = b.editor.checkDirty();
          a.fire('widgetBlurred', { widget: b });
          b.setFocused(!1);
          !c && b.editor.resetDirty();
        }
      }
      function k(a) {
        a = a.data;
        if ('wysiwyg' == this.editor.mode) {
          var b = this.editor.editable(),
            c = this.instances,
            d,
            e,
            f,
            g;
          if (b) {
            for (d in c) c[d].isReady() && !b.contains(c[d].wrapper) && this.destroy(c[d], !0);
            if (a && a.initOnlyNew) c = this.initOnAll();
            else {
              var k = b.find('.cke_widget_wrapper'),
                c = [];
              d = 0;
              for (e = k.count(); d < e; d++) {
                f = k.getItem(d);
                if ((g = !this.getByElement(f, !0))) {
                  a: {
                    g = p;
                    for (var l = f; (l = l.getParent()); )
                      if (g(l)) {
                        g = !0;
                        break a;
                      }
                    g = !1;
                  }
                  g = !g;
                }
                g && b.contains(f) && (f.addClass('cke_widget_new'), c.push(this.initOn(f.getFirst(h.isDomWidgetElement))));
              }
            }
            a && a.focusInited && 1 == c.length && c[0].focus();
          }
        }
      }
      function m(a) {
        if ('undefined' != typeof a.attributes && a.attributes['data-widget']) {
          var b = g(a),
            c = d(a),
            e = !1;
          b &&
            b.value &&
            b.value.match(/^\s/g) &&
            ((b.parent.attributes['data-cke-white-space-first'] = 1), (b.value = b.value.replace(/^\s/g, '\x26nbsp;')), (e = !0));
          c &&
            c.value &&
            c.value.match(/\s$/g) &&
            ((c.parent.attributes['data-cke-white-space-last'] = 1), (c.value = c.value.replace(/\s$/g, '\x26nbsp;')), (e = !0));
          e && (a.attributes['data-cke-widget-white-space'] = 1);
        }
      }
      function g(a) {
        return a
          .find(function (a) {
            return 3 === a.type;
          }, !0)
          .shift();
      }
      function d(a) {
        return a
          .find(function (a) {
            return 3 === a.type;
          }, !0)
          .pop();
      }
      function e(a, b, c) {
        if (!c.allowedContent && !c.disallowedContent) return null;
        var d = this._.filters[a];
        d || (this._.filters[a] = d = {});
        a = d[b];
        a ||
          ((a = c.allowedContent ? new CKEDITOR.filter(c.allowedContent) : this.editor.filter.clone()),
          (d[b] = a),
          c.disallowedContent && a.disallow(c.disallowedContent));
        return a;
      }
      function n(a) {
        var b = [],
          c = a._.upcasts,
          d = a._.upcastCallbacks;
        return {
          toBeWrapped: b,
          iterator: function (a) {
            var e, f, g, k, l;
            if ('data-cke-widget-wrapper' in a.attributes) return (a = a.getFirst(h.isParserWidgetElement)) && b.push([a]), !1;
            if ('data-widget' in a.attributes) return b.push([a]), !1;
            if ((l = c.length)) {
              if (a.attributes['data-cke-widget-upcasted']) return !1;
              k = 0;
              for (e = d.length; k < e; ++k) if (!1 === d[k](a)) return;
              for (k = 0; k < l; ++k)
                if (((e = c[k]), (g = {}), (f = e[0](a, g))))
                  return (
                    f instanceof CKEDITOR.htmlParser.element && (a = f),
                    (a.attributes['data-cke-widget-data'] = encodeURIComponent(JSON.stringify(g))),
                    (a.attributes['data-cke-widget-upcasted'] = 1),
                    b.push([a, e[1]]),
                    !1
                  );
            }
          },
        };
      }
      function r(a, b) {
        return {
          tabindex: -1,
          contenteditable: 'false',
          'data-cke-widget-wrapper': 1,
          'data-cke-filter': 'off',
          class: 'cke_widget_wrapper cke_widget_new cke_widget_' + (a ? 'inline' : 'block') + (b ? ' cke_widget_' + b : ''),
        };
      }
      function x(a, b, c) {
        if (a.type == CKEDITOR.NODE_ELEMENT) {
          var d = CKEDITOR.dtd[a.name];
          if (d && !d[c.name]) {
            var d = a.split(b),
              e = a.parent;
            b = d.getIndex();
            a.children.length || (--b, a.remove());
            d.children.length || d.remove();
            return x(e, b, c);
          }
        }
        a.add(c, b);
      }
      function u(a, b) {
        return 'boolean' == typeof a.inline ? a.inline : !!CKEDITOR.dtd.$inline[b];
      }
      function p(a) {
        return a.hasAttribute('data-cke-temp');
      }
      function t(a, b, c, d) {
        var e = a.editor;
        e.fire('lockSnapshot');
        c
          ? ((d = c.data('cke-widget-editable')),
            (d = b.editables[d]),
            (a.widgetHoldingFocusedEditable = b),
            (b.focusedEditable = d),
            c.addClass('cke_widget_editable_focused'),
            d.filter && e.setActiveFilter(d.filter),
            e.setActiveEnterMode(d.enterMode, d.shiftEnterMode))
          : (d || b.focusedEditable.removeClass('cke_widget_editable_focused'),
            (b.focusedEditable = null),
            (a.widgetHoldingFocusedEditable = null),
            e.setActiveFilter(null),
            e.setActiveEnterMode(null, null));
        e.fire('unlockSnapshot');
      }
      function w(a) {
        a.contextMenu &&
          a.contextMenu.addListener(function (b) {
            if ((b = a.widgets.getByElement(b, !0))) return b.fire('contextMenu', {});
          });
      }
      function q(a, b) {
        return CKEDITOR.tools.trim(b);
      }
      function B(a) {
        var b = a.editor,
          c = CKEDITOR.plugins.lineutils;
        b.on('dragstart', function (c) {
          var d = c.data.target;
          h.isDomDragHandler(d) && ((d = a.getByElement(d)), c.data.dataTransfer.setData('cke/widget-id', d.id), b.focus(), d.focus());
        });
        b.on('drop', function (c) {
          function d(a, b) {
            return a && b ? a.wrapper.equals(b.wrapper) || a.wrapper.contains(b.wrapper) : !1;
          }
          var e = c.data.dataTransfer,
            f = e.getData('cke/widget-id'),
            g = e.getTransferType(b),
            e = b.createRange(),
            h = (function (a) {
              a = a.getBoundaryNodes().startNode;
              a.type !== CKEDITOR.NODE_ELEMENT && (a = a.getParent());
              return b.widgets.getByElement(a);
            })(c.data.dropRange);
          if ('' !== f && g === CKEDITOR.DATA_TRANSFER_CROSS_EDITORS) c.cancel();
          else if (g == CKEDITOR.DATA_TRANSFER_INTERNAL)
            if ('' === f && 0 < b.widgets.selected.length) c.data.dataTransfer.setData('text/html', O(b));
            else if ((f = a.instances[f]))
              d(f, h)
                ? c.cancel()
                : (e.setStartBefore(f.wrapper),
                  e.setEndAfter(f.wrapper),
                  (c.data.dragRange = e),
                  delete CKEDITOR.plugins.clipboard.dragStartContainerChildCount,
                  delete CKEDITOR.plugins.clipboard.dragEndContainerChildCount,
                  c.data.dataTransfer.setData('text/html', f.getClipboardHtml()),
                  b.widgets.destroy(f, !0));
        });
        b.on('contentDom', function () {
          var d = b.editable();
          CKEDITOR.tools.extend(
            a,
            {
              finder: new c.finder(b, {
                lookups: {
                  default: function (b) {
                    if (
                      !b.is(CKEDITOR.dtd.$listItem) &&
                      b.is(CKEDITOR.dtd.$block) &&
                      !h.isDomNestedEditable(b) &&
                      !a._.draggedWidget.wrapper.contains(b)
                    ) {
                      var c = h.getNestedEditable(d, b);
                      if (c) {
                        b = a._.draggedWidget;
                        if (a.getByElement(c) == b) return;
                        c = CKEDITOR.filter.instances[c.data('cke-filter')];
                        b = b.requiredContent;
                        if (c && b && !c.check(b)) return;
                      }
                      return CKEDITOR.LINEUTILS_BEFORE | CKEDITOR.LINEUTILS_AFTER;
                    }
                  },
                },
              }),
              locator: new c.locator(b),
              liner: new c.liner(b, {
                lineStyle: { cursor: 'move !important', 'border-top-color': '#666' },
                tipLeftStyle: { 'border-left-color': '#666' },
                tipRightStyle: { 'border-right-color': '#666' },
              }),
            },
            !0,
          );
        });
      }
      function z(a) {
        var b = a.editor;
        b.on('contentDom', function () {
          var c = b.editable(),
            d = c.isInline() ? c : b.document,
            e,
            f;
          c.attachListener(d, 'mousedown', function (c) {
            var d = c.data.getTarget();
            e = d instanceof CKEDITOR.dom.element ? a.getByElement(d) : null;
            f = 0;
            e &&
              (e.inline && d.type == CKEDITOR.NODE_ELEMENT && d.hasAttribute('data-cke-widget-drag-handler')
                ? ((f = 1), a.focused != e && b.getSelection().removeAllRanges())
                : h.getNestedEditable(e.wrapper, d)
                  ? (e = null)
                  : (c.data.preventDefault(), CKEDITOR.env.ie || e.focus()));
          });
          c.attachListener(d, 'mouseup', function () {
            f && e && e.wrapper && ((f = 0), e.focus());
          });
          CKEDITOR.env.ie &&
            c.attachListener(d, 'mouseup', function () {
              setTimeout(function () {
                e && e.wrapper && c.contains(e.wrapper) && (e.focus(), (e = null));
              });
            });
        });
        b.on(
          'doubleclick',
          function (b) {
            var c = a.getByElement(b.data.element);
            if (c && !h.getNestedEditable(c.wrapper, b.data.element)) return c.fire('doubleclick', { element: b.data.element });
          },
          null,
          null,
          1,
        );
      }
      function y(a) {
        a.editor.on(
          'key',
          function (b) {
            var c = a.focused,
              d = a.widgetHoldingFocusedEditable,
              e;
            c
              ? (e = c.fire('key', { keyCode: b.data.keyCode }))
              : d &&
                ((c = b.data.keyCode),
                (b = d.focusedEditable),
                c == CKEDITOR.CTRL + 65
                  ? ((c = b.getBogus()),
                    (d = d.editor.createRange()),
                    d.selectNodeContents(b),
                    c && d.setEndAt(c, CKEDITOR.POSITION_BEFORE_START),
                    d.select(),
                    (e = !1))
                  : 8 == c || 46 == c
                    ? ((e = d.editor.getSelection().getRanges()),
                      (d = e[0]),
                      (e = !(1 == e.length && d.collapsed && d.checkBoundaryOfElement(b, CKEDITOR[8 == c ? 'START' : 'END']))))
                    : (e = void 0));
            return e;
          },
          null,
          null,
          1,
        );
      }
      function v(a) {
        function b(d) {
          1 > a.selected.length || I(c, 'cut' === d.name);
        }
        var c = a.editor;
        c.on('contentDom', function () {
          var a = c.editable();
          a.attachListener(a, 'copy', b);
          a.attachListener(a, 'cut', b);
        });
      }
      function C(a) {
        function b() {
          var a = e.getSelection();
          if (a && (a = a.getRanges()[0]) && !a.collapsed) {
            var d = c(a.startContainer),
              f = c(a.endContainer);
            !d && f ? (a.setEndBefore(f.wrapper), a.select()) : d && !f && (a.setStartAfter(d.wrapper), a.select());
          }
        }
        function c(a) {
          return a ? (a.type == CKEDITOR.NODE_TEXT ? c(a.getParent()) : e.widgets.getByElement(a)) : null;
        }
        function d() {
          a.fire('checkSelection');
        }
        var e = a.editor;
        e.on('selectionCheck', d);
        e.on('contentDom', function () {
          e.editable().attachListener(e, 'key', function () {
            setTimeout(d, 10);
          });
        });
        if (!CKEDITOR.env.ie) a.on('checkSelection', b);
        a.on('checkSelection', a.checkSelection, a);
        e.on('selectionChange', function (b) {
          var c = (b = h.getNestedEditable(e.editable(), b.data.selection.getStartElement())) && a.getByElement(b),
            d = a.widgetHoldingFocusedEditable;
          d ? (d === c && d.focusedEditable.equals(b)) || (t(a, d, null), c && b && t(a, c, b)) : c && b && t(a, c, b);
        });
        e.on('dataReady', function () {
          G(a).commit();
        });
        e.on('blur', function () {
          var b;
          (b = a.focused) && l(a, b);
          (b = a.widgetHoldingFocusedEditable) && t(a, b, null);
        });
      }
      function F(a) {
        var b = a.editor,
          c = {};
        b.on(
          'toDataFormat',
          function (b) {
            var e = CKEDITOR.tools.getNextNumber(),
              f = [];
            b.data.downcastingSessionId = e;
            c[e] = f;
            b.data.dataValue.forEach(
              function (b) {
                var c = b.attributes,
                  e;
                if ('data-cke-widget-white-space' in c) {
                  e = g(b);
                  var k = d(b);
                  e.parent.attributes['data-cke-white-space-first'] && (e.value = e.value.replace(/^&nbsp;/g, ' '));
                  k.parent.attributes['data-cke-white-space-last'] && (k.value = k.value.replace(/&nbsp;$/g, ' '));
                }
                if ('data-cke-widget-id' in c) {
                  if ((c = a.instances[c['data-cke-widget-id']]))
                    (e = b.getFirst(h.isParserWidgetElement)),
                      f.push({ wrapper: b, element: e, widget: c, editables: {} }),
                      '1' != e.attributes['data-cke-widget-keep-attr'] && delete e.attributes['data-widget'];
                } else if ('data-cke-widget-editable' in c)
                  return 0 < f.length && (f[f.length - 1].editables[c['data-cke-widget-editable']] = b), !1;
              },
              CKEDITOR.NODE_ELEMENT,
              !0,
            );
          },
          null,
          null,
          8,
        );
        b.on(
          'toDataFormat',
          function (a) {
            if (a.data.downcastingSessionId)
              for (var b = c[a.data.downcastingSessionId], d, e, f, g, h, k; (d = b.shift()); ) {
                e = d.widget;
                f = d.element;
                g = e._.downcastFn && e._.downcastFn.call(e, f);
                a.data.widgetsCopy &&
                  e.getClipboardHtml &&
                  ((g = CKEDITOR.htmlParser.fragment.fromHtml(e.getClipboardHtml())), (g = g.children[0]));
                for (k in d.editables) (h = d.editables[k]), delete h.attributes.contenteditable, h.setHtml(e.editables[k].getData());
                g || (g = f);
                d.wrapper.replaceWith(g);
              }
          },
          null,
          null,
          13,
        );
        b.on('contentDomUnload', function () {
          a.destroyAll(!0);
        });
      }
      function D(a) {
        var b = a.editor,
          c,
          d;
        b.on(
          'toHtml',
          function (b) {
            var d = n(a),
              e;
            for (b.data.dataValue.forEach(d.iterator, CKEDITOR.NODE_ELEMENT, !0); (e = d.toBeWrapped.pop()); ) {
              var f = e[0],
                g = f.parent;
              g.type == CKEDITOR.NODE_ELEMENT && g.attributes['data-cke-widget-wrapper'] && g.replaceWith(f);
              a.wrapElement(e[0], e[1]);
            }
            c = b.data.protectedWhitespaces
              ? 3 == b.data.dataValue.children.length && h.isParserWidgetWrapper(b.data.dataValue.children[1])
              : 1 == b.data.dataValue.children.length && h.isParserWidgetWrapper(b.data.dataValue.children[0]);
          },
          null,
          null,
          8,
        );
        b.on('dataReady', function () {
          if (d)
            for (var c = b.editable().find('.cke_widget_wrapper'), e, f, g = 0, k = c.count(); g < k; ++g)
              (e = c.getItem(g)),
                (f = e.getFirst(h.isDomWidgetElement)),
                f.type == CKEDITOR.NODE_ELEMENT && f.data('widget') ? (f.replace(e), a.wrapElement(f)) : e.remove();
          d = 0;
          a.destroyAll(!0);
          a.initOnAll();
        });
        b.on(
          'loadSnapshot',
          function (b) {
            /data-cke-widget/.test(b.data) && (d = 1);
            a.destroyAll(!0);
          },
          null,
          null,
          9,
        );
        b.on('paste', function (a) {
          a = a.data;
          a.dataValue = a.dataValue.replace(ca, q);
          a.range &&
            (a = h.getNestedEditable(b.editable(), a.range.startContainer)) &&
            (a = CKEDITOR.filter.instances[a.data('cke-filter')]) &&
            b.setActiveFilter(a);
        });
        b.on('afterInsertHtml', function (d) {
          d.data.intoRange
            ? a.checkWidgets({ initOnlyNew: !0 })
            : (b.fire('lockSnapshot'), a.checkWidgets({ initOnlyNew: !0, focusInited: c }), b.fire('unlockSnapshot'));
        });
      }
      function G(a) {
        var b = a.selected,
          c = [],
          d = b.slice(0),
          e = null;
        return {
          select: function (a) {
            0 > CKEDITOR.tools.indexOf(b, a) && c.push(a);
            a = CKEDITOR.tools.indexOf(d, a);
            0 <= a && d.splice(a, 1);
            return this;
          },
          focus: function (a) {
            e = a;
            return this;
          },
          commit: function () {
            var f = a.focused !== e,
              g,
              h;
            a.editor.fire('lockSnapshot');
            for (f && (g = a.focused) && l(a, g); (g = d.pop()); )
              b.splice(CKEDITOR.tools.indexOf(b, g), 1),
                g.isInited() && ((h = g.editor.checkDirty()), g.setSelected(!1), !h && g.editor.resetDirty());
            f &&
              e &&
              ((h = a.editor.checkDirty()),
              (a.focused = e),
              a.fire('widgetFocused', { widget: e }),
              e.setFocused(!0),
              !h && a.editor.resetDirty());
            for (; (g = c.pop()); ) b.push(g), g.setSelected(!0);
            a.editor.fire('unlockSnapshot');
          },
        };
      }
      function H(a) {
        a &&
          a.addFilterRule(function (a) {
            return a.replace(/\s*cke_widget_selected/g, '').replace(/\s*cke_widget_focused/g, '');
          });
      }
      function L(a, b, c) {
        var d = 0;
        b = E(b);
        var e = a.data.classes || {},
          f;
        if (b) {
          for (e = CKEDITOR.tools.clone(e); (f = b.pop()); ) c ? e[f] || (d = e[f] = 1) : e[f] && (delete e[f], (d = 1));
          d && a.setData('classes', e);
        }
      }
      function K(a) {
        a.cancel();
      }
      function S(a, b) {
        var c = (function (a) {
            return a == CKEDITOR.ENTER_BR ? 'br' : a == CKEDITOR.ENTER_DIV ? 'div' : 'p';
          })(a.editor.config.enterMode),
          d = new CKEDITOR.dom.element(c);
        'br' !== c && d.appendBogus();
        'after' === b ? d.insertAfter(a.wrapper) : d.insertBefore(a.wrapper);
        (function (b) {
          var c = a.editor.createRange();
          c.setStart(b, 0);
          a.editor.getSelection().selectRanges([c]);
        })(d);
      }
      function I(a, b) {
        var c = a.widgets.focused,
          d,
          e,
          f;
        Q.hasCopyBin(a) ||
          ((e = new Q(a, {
            beforeDestroy: function () {
              !b && c && c.focus();
              f && a.getSelection().selectBookmarks(f);
              d && CKEDITOR.plugins.widgetselection.addFillers(a.editable());
            },
            afterDestroy: function () {
              b && !a.readOnly && (c ? a.widgets.del(c) : a.extractSelectedHtml(), a.fire('saveSnapshot'));
            },
          })),
          c ||
            ((d = CKEDITOR.env.webkit && CKEDITOR.plugins.widgetselection.isWholeContentSelected(a.editable())),
            (f = a.getSelection().createBookmarks(!0))),
          e.handle(O(a)));
      }
      function E(a) {
        return (a = (a = a.getDefinition().attributes) && a['class']) ? a.split(/\s+/) : null;
      }
      function P() {
        var a = CKEDITOR.document.getActive(),
          b = this.editor,
          c = b.editable();
        (c.isInline() ? c : b.document.getWindow().getFrame()).equals(a) && b.focusManager.focus(c);
      }
      function M() {
        CKEDITOR.env.gecko && this.editor.unlockSelection();
        CKEDITOR.env.webkit || (this.editor.forceNextSelectionCheck(), this.editor.selectionChange(1));
      }
      function O(a) {
        var b = a.getSelectedHtml(!0);
        if (a.widgets.focused) return a.widgets.focused.getClipboardHtml();
        a.once(
          'toDataFormat',
          function (a) {
            a.data.widgetsCopy = !0;
          },
          null,
          null,
          -1,
        );
        return a.dataProcessor.toDataFormat(b);
      }
      function N(a, b) {
        var c = a.editor.config.widget_keystrokeInsertLineBefore,
          d = a.editor.config.widget_keystrokeInsertLineAfter;
        X(a);
        T(a);
        Y(a);
        da(a);
        ia(a);
        ja(a);
        ka(a);
        if (CKEDITOR.env.ie && 9 > CKEDITOR.env.version)
          a.wrapper.on('dragstart', function (b) {
            var c = b.data.getTarget();
            h.getNestedEditable(a, c) || (a.inline && h.isDomDragHandler(c)) || b.data.preventDefault();
          });
        a.wrapper.removeClass('cke_widget_new');
        a.element.addClass('cke_widget_element');
        a.on(
          'key',
          function (b) {
            b = b.data.keyCode;
            if (b == c) S(a, 'before'), a.editor.fire('saveSnapshot');
            else if (b == d) S(a, 'after'), a.editor.fire('saveSnapshot');
            else if (13 == b) a.edit();
            else {
              if (b == CKEDITOR.CTRL + 67 || b == CKEDITOR.CTRL + 88) {
                I(a.editor, b == CKEDITOR.CTRL + 88);
                return;
              }
              if (b in V || CKEDITOR.CTRL & b || CKEDITOR.ALT & b) return;
            }
            return !1;
          },
          null,
          null,
          999,
        );
        a.on('doubleclick', function (b) {
          a.edit() && b.cancel();
        });
        if (b.data) a.on('data', b.data);
        if (b.edit) a.on('edit', b.edit);
      }
      function X(a) {
        (a.wrapper = a.element.getParent()).setAttribute('data-cke-widget-id', a.id);
      }
      function T(a, b) {
        a.partSelectors || (a.partSelectors = a.parts);
        if (a.parts) {
          var c = {},
            d,
            e;
          for (e in a.partSelectors)
            b || !a.parts[e] || 'string' == typeof a.parts[e]
              ? ((d = a.wrapper.findOne(a.partSelectors[e])), (c[e] = d))
              : (c[e] = a.parts[e]);
          a.parts = c;
        }
      }
      function Y(a) {
        var b = a.editables,
          c,
          d;
        a.editables = {};
        if (a.editables) for (c in b) (d = b[c]), a.initEditable(c, 'string' == typeof d ? { selector: d } : d);
      }
      function da(a) {
        if (!0 === a.mask) U(a);
        else if (a.mask) {
          var b = new CKEDITOR.tools.buffers.throttle(250, ha, a),
            c = CKEDITOR.env.gecko ? 300 : 0,
            d,
            e;
          a.on('focus', function () {
            b.input();
            d = a.editor.on('change', b.input);
            e = a.on('blur', function () {
              d.removeListener();
              e.removeListener();
            });
          });
          a.editor.on('instanceReady', function () {
            setTimeout(function () {
              b.input();
            }, c);
          });
          a.editor.on('mode', function () {
            setTimeout(function () {
              b.input();
            }, c);
          });
          if (CKEDITOR.env.gecko) {
            var f = a.element.find('img');
            CKEDITOR.tools.array.forEach(f.toArray(), function (a) {
              a.on('load', function () {
                b.input();
              });
            });
          }
          for (var g in a.editables)
            a.editables[g].on('focus', function () {
              a.editor.on('change', b.input);
              e && e.removeListener();
            }),
              a.editables[g].on('blur', function () {
                a.editor.removeListener('change', b.input);
              });
          b.input();
        }
      }
      function U(a) {
        var b = a.wrapper.findOne('.cke_widget_mask');
        b ||
          ((b = new CKEDITOR.dom.element('img', a.editor.document)),
          b.setAttributes({ src: CKEDITOR.tools.transparentImageData, class: 'cke_reset cke_widget_mask' }),
          a.wrapper.append(b));
        a.mask = b;
      }
      function ha() {
        if (this.wrapper) {
          this.maskPart = this.maskPart || this.mask;
          var a = this.parts[this.maskPart],
            b;
          if (a && 'string' != typeof a) {
            b = this.wrapper.findOne('.cke_widget_partial_mask');
            b ||
              ((b = new CKEDITOR.dom.element('img', this.editor.document)),
              b.setAttributes({ src: CKEDITOR.tools.transparentImageData, class: 'cke_reset cke_widget_partial_mask' }),
              this.wrapper.append(b));
            this.mask = b;
            var c = b.$,
              d = a.$,
              e = !(c.offsetTop == d.offsetTop && c.offsetLeft == d.offsetLeft);
            if (c.offsetWidth != d.offsetWidth || c.offsetHeight != d.offsetHeight || e)
              (c = a.getParent()),
                (d = CKEDITOR.plugins.widget.isDomWidget(c)),
                b.setStyles({
                  top: a.$.offsetTop + (d ? 0 : c.$.offsetTop) + 'px',
                  left: a.$.offsetLeft + (d ? 0 : c.$.offsetLeft) + 'px',
                  width: a.$.offsetWidth + 'px',
                  height: a.$.offsetHeight + 'px',
                });
          }
        }
      }
      function ia(a) {
        if (a.draggable) {
          var b = a.editor,
            c = a.wrapper.getLast(h.isDomDragHandlerContainer),
            d;
          c
            ? (d = c.findOne('img'))
            : ((c = new CKEDITOR.dom.element('span', b.document)),
              c.setAttributes({
                class: 'cke_reset cke_widget_drag_handler_container',
                style:
                  'background:rgba(220,220,220,0.5);background-image:url(' + b.plugins.widget.path + 'images/handle.png);display:none;',
              }),
              (d = new CKEDITOR.dom.element('img', b.document)),
              d.setAttributes({
                class: 'cke_reset cke_widget_drag_handler',
                'data-cke-widget-drag-handler': '1',
                src: CKEDITOR.tools.transparentImageData,
                width: 15,
                title: b.lang.widget.move,
                height: 15,
                role: 'presentation',
              }),
              a.inline && d.setAttribute('draggable', 'true'),
              c.append(d),
              a.wrapper.append(c));
          a.wrapper.on('dragover', function (a) {
            a.data.preventDefault();
          });
          a.wrapper.on('mouseenter', a.updateDragHandlerPosition, a);
          setTimeout(function () {
            a.on('data', a.updateDragHandlerPosition, a);
          }, 50);
          if (!a.inline && (d.on('mousedown', fa, a), CKEDITOR.env.ie && 9 > CKEDITOR.env.version))
            d.on('dragstart', function (a) {
              a.data.preventDefault(!0);
            });
          a.dragHandlerContainer = c;
        }
      }
      function fa(a) {
        function b() {
          var c;
          for (p.reset(); (c = h.pop()); ) c.removeListener();
          var d = k;
          c = a.sender;
          var e = this.repository.finder,
            f = this.repository.liner,
            g = this.editor,
            l = this.editor.editable();
          CKEDITOR.tools.isEmpty(f.visible) ||
            ((d = e.getRange(d[0])), this.focus(), g.fire('drop', { dropRange: d, target: d.startContainer }));
          l.removeClass('cke_widget_dragging');
          f.hideVisible();
          g.fire('dragend', { target: c });
        }
        if (CKEDITOR.tools.getMouseButton(a) === CKEDITOR.MOUSE_BUTTON_LEFT) {
          var c = this.repository.finder,
            d = this.repository.locator,
            e = this.repository.liner,
            f = this.editor,
            g = f.editable(),
            h = [],
            k = [],
            l,
            m;
          this.repository._.draggedWidget = this;
          var n = c.greedySearch(),
            p = CKEDITOR.tools.eventsBuffer(50, function () {
              l = d.locate(n);
              k = d.sort(m, 1);
              k.length && (e.prepare(n, l), e.placeLine(k[0]), e.cleanup());
            });
          g.addClass('cke_widget_dragging');
          h.push(
            g.on('mousemove', function (a) {
              m = a.data.$.clientY;
              p.input();
            }),
          );
          f.fire('dragstart', { target: a.sender });
          h.push(f.document.once('mouseup', b, this));
          g.isInline() || h.push(CKEDITOR.document.once('mouseup', b, this));
        }
      }
      function ja(a) {
        var b = null;
        a.on('data', function () {
          var a = this.data.classes,
            c;
          if (b != a) {
            for (c in b) (a && a[c]) || this.removeClass(c);
            for (c in a) this.addClass(c);
            b = a;
          }
        });
      }
      function ka(a) {
        a.on(
          'data',
          function () {
            if (a.wrapper) {
              var b = this.getLabel
                ? this.getLabel()
                : this.editor.lang.widget.label.replace(/%1/, this.pathName || this.element.getName());
              a.wrapper.setAttribute('role', 'region');
              a.wrapper.setAttribute('aria-label', b);
            }
          },
          null,
          null,
          9999,
        );
      }
      function Z(a) {
        a.element.data('cke-widget-data', encodeURIComponent(JSON.stringify(a.data)));
      }
      function aa() {
        function a() {}
        function b(a, c, d) {
          return d && this.checkElement(a) ? (a = d.widgets.getByElement(a, !0)) && a.checkStyleActive(this) : !1;
        }
        function c(a) {
          function b(a, c, d) {
            for (var e = a.length, f = 0; f < e; ) {
              if (c.call(d, a[f], f, a)) return a[f];
              f++;
            }
          }
          function e(a) {
            function b(a, c) {
              var d = CKEDITOR.tools.object.keys(a),
                e = CKEDITOR.tools.object.keys(c);
              if (d.length !== e.length) return !1;
              for (var f in a) if (('object' !== typeof a[f] || 'object' !== typeof c[f] || !b(a[f], c[f])) && a[f] !== c[f]) return !1;
              return !0;
            }
            return function (c) {
              return b(a.getDefinition(), c.getDefinition());
            };
          }
          var f = a.widget,
            g;
          d[f] || (d[f] = {});
          for (var h = 0, k = a.group.length; h < k; h++)
            (g = a.group[h]), d[f][g] || (d[f][g] = []), (g = d[f][g]), b(g, e(a)) || g.push(a);
        }
        var d = {};
        CKEDITOR.style.addCustomHandler({
          type: 'widget',
          setup: function (a) {
            this.widget = a.widget;
            (this.group = 'string' == typeof a.group ? [a.group] : a.group) && c(this);
          },
          apply: function (a) {
            var b;
            a instanceof CKEDITOR.editor &&
              this.checkApplicable(a.elementPath(), a) &&
              ((b = a.widgets.focused), this.group && this.removeStylesFromSameGroup(a), b.applyStyle(this));
          },
          remove: function (a) {
            a instanceof CKEDITOR.editor && this.checkApplicable(a.elementPath(), a) && a.widgets.focused.removeStyle(this);
          },
          removeStylesFromSameGroup: function (a) {
            var b = !1,
              c,
              e;
            if (!(a instanceof CKEDITOR.editor)) return !1;
            e = a.elementPath();
            if (this.checkApplicable(e, a))
              for (var f = 0, g = this.group.length; f < g; f++) {
                c = d[this.widget][this.group[f]];
                for (var h = 0; h < c.length; h++)
                  c[h] !== this && c[h].checkActive(e, a) && (a.widgets.focused.removeStyle(c[h]), (b = !0));
              }
            return b;
          },
          checkActive: function (a, b) {
            return this.checkElementMatch(a.lastElement, 0, b);
          },
          checkApplicable: function (a, b) {
            return b instanceof CKEDITOR.editor ? this.checkElement(a.lastElement) : !1;
          },
          checkElementMatch: b,
          checkElementRemovable: b,
          checkElement: function (a) {
            return h.isDomWidgetWrapper(a) ? (a = a.getFirst(h.isDomWidgetElement)) && a.data('widget') == this.widget : !1;
          },
          buildPreview: function (a) {
            return a || this._.definition.name;
          },
          toAllowedContentRules: function (a) {
            if (!a) return null;
            a = a.widgets.registered[this.widget];
            var b,
              c = {};
            if (!a) return null;
            if (a.styleableElements) {
              b = this.getClassesArray();
              if (!b) return null;
              c[a.styleableElements] = { classes: b, propertiesOnly: !0 };
              return c;
            }
            return a.styleToAllowedContentRules ? a.styleToAllowedContentRules(this) : null;
          },
          getClassesArray: function () {
            var a = this._.definition.attributes && this._.definition.attributes['class'];
            return a ? CKEDITOR.tools.trim(a).split(/\s+/) : null;
          },
          applyToRange: a,
          removeFromRange: a,
          applyToObject: a,
        });
      }
      CKEDITOR.plugins.add('widget', {
        requires: 'lineutils,clipboard,widgetselection',
        onLoad: function () {
          void 0 !== CKEDITOR.document.$.querySelectorAll &&
            (CKEDITOR.addCss(
              '.cke_widget_wrapper{position:relative;outline:none}.cke_widget_inline{display:inline-block}.cke_widget_wrapper:hover\x3e.cke_widget_element{outline:2px solid #ffd25c;cursor:default}.cke_widget_wrapper:hover .cke_widget_editable{outline:2px solid #ffd25c}.cke_widget_wrapper.cke_widget_focused\x3e.cke_widget_element,.cke_widget_wrapper .cke_widget_editable.cke_widget_editable_focused{outline:2px solid #47a4f5}.cke_widget_editable{cursor:text}.cke_widget_drag_handler_container{position:absolute;width:15px;height:0;display:block;opacity:0.75;transition:height 0s 0.2s;line-height:0}.cke_widget_wrapper:hover\x3e.cke_widget_drag_handler_container{height:15px;transition:none}.cke_widget_drag_handler_container:hover{opacity:1}.cke_editable[contenteditable\x3d"false"] .cke_widget_drag_handler_container{display:none;}img.cke_widget_drag_handler{cursor:move;width:15px;height:15px;display:inline-block}.cke_widget_mask{position:absolute;top:0;left:0;width:100%;height:100%;display:block}.cke_widget_partial_mask{position:absolute;display:block}.cke_editable.cke_widget_dragging, .cke_editable.cke_widget_dragging *{cursor:move !important}',
            ),
            aa());
        },
        beforeInit: function (b) {
          void 0 !== CKEDITOR.document.$.querySelectorAll && (b.widgets = new a(b));
        },
        afterInit: function (a) {
          if (void 0 !== CKEDITOR.document.$.querySelectorAll) {
            var b = a.widgets.registered,
              c,
              d,
              e;
            for (d in b)
              (c = b[d]),
                (e = c.button) &&
                  a.ui.addButton &&
                  a.ui.addButton(CKEDITOR.tools.capitalize(c.name, !0), { label: e, command: c.name, toolbar: 'insert,10' });
            w(a);
            H(a.undoManager);
          }
        },
      });
      a.prototype = {
        MIN_SELECTION_CHECK_INTERVAL: 500,
        add: function (a, d) {
          var e = this.editor;
          d = CKEDITOR.tools.prototypedCopy(d);
          d.name = a;
          d._ = d._ || {};
          e.fire('widgetDefinition', d);
          d.template && (d.template = new CKEDITOR.template(d.template));
          b(e, d);
          c(this, d);
          this.registered[a] = d;
          if (d.dialog && e.plugins.dialog)
            var f = CKEDITOR.on('dialogDefinition', function (a) {
              a = a.data.definition;
              var b = a.dialog;
              a.getMode ||
                b.getName() !== d.dialog ||
                (a.getMode = function () {
                  var a = b.getModel(e);
                  return a && a instanceof CKEDITOR.plugins.widget && a.ready
                    ? CKEDITOR.dialog.EDITING_MODE
                    : CKEDITOR.dialog.CREATION_MODE;
                });
              f.removeListener();
            });
          return d;
        },
        addUpcastCallback: function (a) {
          this._.upcastCallbacks.push(a);
        },
        checkSelection: function () {
          if (this.editor.getSelection()) {
            var a = this.editor.getSelection(),
              b = a.getSelectedElement(),
              c = G(this),
              d;
            if (b && (d = this.getByElement(b, !0))) return c.focus(d).select(d).commit();
            a = a.getRanges()[0];
            if (!a || a.collapsed) return c.commit();
            a = new CKEDITOR.dom.walker(a);
            for (a.evaluator = h.isDomWidgetWrapper; (b = a.next()); ) c.select(this.getByElement(b));
            c.commit();
          }
        },
        checkWidgets: function (a) {
          this.fire('checkWidgets', CKEDITOR.tools.copy(a || {}));
        },
        del: function (a) {
          if (this.focused === a) {
            var b = a.editor,
              c = b.createRange(),
              d;
            (d = c.moveToClosestEditablePosition(a.wrapper, !0)) || (d = c.moveToClosestEditablePosition(a.wrapper, !1));
            d && b.getSelection().selectRanges([c]);
          }
          a.wrapper.remove();
          this.destroy(a, !0);
        },
        destroy: function (a, b) {
          this.widgetHoldingFocusedEditable === a && t(this, a, null, b);
          a.destroy(b);
          delete this.instances[a.id];
          this.fire('instanceDestroyed', a);
        },
        destroyAll: function (a, b) {
          var c,
            d,
            e = this.instances;
          if (b && !a) {
            d = b.find('.cke_widget_wrapper');
            for (var e = d.count(), f = 0; f < e; ++f) (c = this.getByElement(d.getItem(f), !0)) && this.destroy(c);
          } else for (d in e) (c = e[d]), this.destroy(c, a);
        },
        finalizeCreation: function (a) {
          (a = a.getFirst()) &&
            h.isDomWidgetWrapper(a) &&
            (this.editor.insertElement(a), (a = this.getByElement(a)), (a.ready = !0), a.fire('ready'), a.focus());
        },
        getByElement: (function () {
          function a(c) {
            return c.is(b) && c.data('cke-widget-id');
          }
          var b = { div: 1, span: 1 };
          return function (b, c) {
            if (!b) return null;
            var d = a(b);
            if (!c && !d) {
              var e = this.editor.editable();
              do b = b.getParent();
              while (b && !b.equals(e) && !(d = a(b)));
            }
            return this.instances[d] || null;
          };
        })(),
        initOn: function (a, b, c) {
          b ? 'string' == typeof b && (b = this.registered[b]) : (b = this.registered[a.data('widget')]);
          if (!b) return null;
          var d = this.wrapElement(a, b.name);
          return d
            ? d.hasClass('cke_widget_new')
              ? ((a = new h(this, this._.nextId++, a, b, c)), a.isInited() ? (this.instances[a.id] = a) : null)
              : this.getByElement(a)
            : null;
        },
        initOnAll: function (a) {
          a = (a || this.editor.editable()).find('.cke_widget_new');
          for (var b = [], c, d = a.count(); d--; ) (c = this.initOn(a.getItem(d).getFirst(h.isDomWidgetElement))) && b.push(c);
          return b;
        },
        onWidget: function (a) {
          var b = Array.prototype.slice.call(arguments);
          b.shift();
          for (var c in this.instances) {
            var d = this.instances[c];
            d.name == a && d.on.apply(d, b);
          }
          this.on('instanceCreated', function (c) {
            c = c.data;
            c.name == a && c.on.apply(c, b);
          });
        },
        parseElementClasses: function (a) {
          if (!a) return null;
          a = CKEDITOR.tools.trim(a).split(/\s+/);
          for (var b, c = {}, d = 0; (b = a.pop()); ) -1 == b.indexOf('cke_') && (c[b] = d = 1);
          return d ? c : null;
        },
        wrapElement: function (a, b) {
          var c = null,
            d,
            e;
          if (a instanceof CKEDITOR.dom.element) {
            b = b || a.data('widget');
            d = this.registered[b];
            if (!d) return null;
            if ((c = a.getParent()) && c.type == CKEDITOR.NODE_ELEMENT && c.data('cke-widget-wrapper')) return c;
            a.hasAttribute('data-cke-widget-keep-attr') || a.data('cke-widget-keep-attr', a.data('widget') ? 1 : 0);
            a.data('widget', b);
            (e = u(d, a.getName())) && m(a);
            c = new CKEDITOR.dom.element(e ? 'span' : 'div', a.getDocument());
            c.setAttributes(r(e, b));
            c.data('cke-display-name', d.pathName ? d.pathName : a.getName());
            a.getParent(!0) && c.replace(a);
            a.appendTo(c);
          } else if (a instanceof CKEDITOR.htmlParser.element) {
            b = b || a.attributes['data-widget'];
            d = this.registered[b];
            if (!d) return null;
            if ((c = a.parent) && c.type == CKEDITOR.NODE_ELEMENT && c.attributes['data-cke-widget-wrapper']) return c;
            'data-cke-widget-keep-attr' in a.attributes ||
              (a.attributes['data-cke-widget-keep-attr'] = a.attributes['data-widget'] ? 1 : 0);
            b && (a.attributes['data-widget'] = b);
            (e = u(d, a.name)) && m(a);
            c = new CKEDITOR.htmlParser.element(e ? 'span' : 'div', r(e, b));
            c.attributes['data-cke-display-name'] = d.pathName ? d.pathName : a.name;
            d = a.parent;
            var f;
            d && ((f = a.getIndex()), a.remove());
            c.add(a);
            d && x(d, f, c);
          }
          return c;
        },
        _tests_createEditableFilter: e,
      };
      CKEDITOR.event.implementOn(a.prototype);
      h.prototype = {
        addClass: function (a) {
          this.element.addClass(a);
          this.wrapper.addClass(h.WRAPPER_CLASS_PREFIX + a);
        },
        applyStyle: function (a) {
          L(this, a, 1);
        },
        checkStyleActive: function (a) {
          a = E(a);
          var b;
          if (!a) return !1;
          for (; (b = a.pop()); ) if (!this.hasClass(b)) return !1;
          return !0;
        },
        destroy: function (a) {
          this.fire('destroy');
          if (this.editables) for (var b in this.editables) this.destroyEditable(b, a);
          a ||
            ('0' == this.element.data('cke-widget-keep-attr') && this.element.removeAttribute('data-widget'),
            this.element.removeAttributes(['data-cke-widget-data', 'data-cke-widget-keep-attr']),
            this.element.removeClass('cke_widget_element'),
            this.element.replace(this.wrapper));
          this.wrapper = null;
        },
        destroyEditable: function (a, b) {
          var c = this.editables[a],
            d = !0;
          c.removeListener('focus', M);
          c.removeListener('blur', P);
          this.editor.focusManager.remove(c);
          if (c.filter) {
            for (var e in this.repository.instances) {
              var f = this.repository.instances[e];
              f.editables && (f = f.editables[a]) && f !== c && c.filter === f.filter && (d = !1);
            }
            d && (c.filter.destroy(), (d = this.repository._.filters[this.name]) && delete d[a]);
          }
          b ||
            (this.repository.destroyAll(!1, c),
            c.removeClass('cke_widget_editable'),
            c.removeClass('cke_widget_editable_focused'),
            c.removeAttributes(['contenteditable', 'data-cke-widget-editable', 'data-cke-enter-mode']));
          delete this.editables[a];
        },
        edit: function () {
          var a = { dialog: this.dialog },
            b = this;
          if (!1 === this.fire('edit', a) || !a.dialog) return !1;
          this.editor.openDialog(
            a.dialog,
            function (a) {
              var c, d;
              !1 !== b.fire('dialog', a) &&
                ((c = a.on('show', function () {
                  a.setupContent(b);
                })),
                (d = a.on('ok', function () {
                  var c,
                    d = b.on(
                      'data',
                      function (a) {
                        c = 1;
                        a.cancel();
                      },
                      null,
                      null,
                      0,
                    );
                  b.editor.fire('saveSnapshot');
                  a.commitContent(b);
                  d.removeListener();
                  c && (b.fire('data', b.data), b.editor.fire('saveSnapshot'));
                })),
                a.once('hide', function () {
                  c.removeListener();
                  d.removeListener();
                }));
            },
            b,
          );
          return !0;
        },
        getClasses: function () {
          return this.repository.parseElementClasses(this.element.getAttribute('class'));
        },
        getClipboardHtml: function () {
          var a = this.editor.createRange();
          a.setStartBefore(this.wrapper);
          a.setEndAfter(this.wrapper);
          return this.editor.editable().getHtmlFromRange(a).getHtml();
        },
        hasClass: function (a) {
          return this.element.hasClass(a);
        },
        initEditable: function (a, b) {
          var c = this._findOneNotNested(b.selector);
          return c && c.is(CKEDITOR.dtd.$editable)
            ? ((c = new f(this.editor, c, { filter: e.call(this.repository, this.name, a, b) })),
              (this.editables[a] = c),
              c.setAttributes({ contenteditable: 'true', 'data-cke-widget-editable': a, 'data-cke-enter-mode': c.enterMode }),
              c.filter && c.data('cke-filter', c.filter.id),
              c.addClass('cke_widget_editable'),
              c.removeClass('cke_widget_editable_focused'),
              b.pathName && c.data('cke-display-name', b.pathName),
              this.editor.focusManager.add(c),
              c.on('focus', M, this),
              CKEDITOR.env.ie && c.on('blur', P, this),
              (c._.initialSetData = !0),
              c.setData(c.getHtml()),
              !0)
            : !1;
        },
        _findOneNotNested: function (a) {
          a = this.wrapper.find(a);
          for (var b, c, d = 0; d < a.count(); d++)
            if (((b = a.getItem(d)), (c = b.getAscendant(h.isDomWidgetWrapper)), this.wrapper.equals(c))) return b;
          return null;
        },
        isInited: function () {
          return !(!this.wrapper || !this.inited);
        },
        isReady: function () {
          return this.isInited() && this.ready;
        },
        focus: function () {
          var a = this.editor.getSelection();
          if (a) {
            var b = this.editor.checkDirty();
            a.fake(this.wrapper);
            !b && this.editor.resetDirty();
          }
          this.editor.focus();
        },
        refreshMask: function () {
          da(this);
        },
        refreshParts: function (a) {
          T(this, 'undefined' !== typeof a ? a : !0);
        },
        removeClass: function (a) {
          this.element.removeClass(a);
          this.wrapper.removeClass(h.WRAPPER_CLASS_PREFIX + a);
        },
        removeStyle: function (a) {
          L(this, a, 0);
        },
        setData: function (a, b) {
          var c = this.data,
            d = 0;
          if ('string' == typeof a) c[a] !== b && ((c[a] = b), (d = 1));
          else {
            var e = a;
            for (a in e) c[a] !== e[a] && ((d = 1), (c[a] = e[a]));
          }
          d && this.dataReady && (Z(this), this.fire('data', c));
          return this;
        },
        setFocused: function (a) {
          this.wrapper[a ? 'addClass' : 'removeClass']('cke_widget_focused');
          this.fire(a ? 'focus' : 'blur');
          return this;
        },
        setSelected: function (a) {
          this.wrapper[a ? 'addClass' : 'removeClass']('cke_widget_selected');
          this.fire(a ? 'select' : 'deselect');
          return this;
        },
        updateDragHandlerPosition: function () {
          var a = this.editor,
            b = this.element.$,
            c = this._.dragHandlerOffset,
            b = { x: b.offsetLeft, y: b.offsetTop - 15 };
          (c && b.x == c.x && b.y == c.y) ||
            ((c = a.checkDirty()),
            a.fire('lockSnapshot'),
            this.dragHandlerContainer.setStyles({ top: b.y + 'px', left: b.x + 'px' }),
            this.dragHandlerContainer.removeStyle('display'),
            a.fire('unlockSnapshot'),
            !c && a.resetDirty(),
            (this._.dragHandlerOffset = b));
        },
      };
      CKEDITOR.event.implementOn(h.prototype);
      h.getNestedEditable = function (a, b) {
        return !b || b.equals(a) ? null : h.isDomNestedEditable(b) ? b : h.getNestedEditable(a, b.getParent());
      };
      h.isDomDragHandler = function (a) {
        return a.type == CKEDITOR.NODE_ELEMENT && a.hasAttribute('data-cke-widget-drag-handler');
      };
      h.isDomDragHandlerContainer = function (a) {
        return a.type == CKEDITOR.NODE_ELEMENT && a.hasClass('cke_widget_drag_handler_container');
      };
      h.isDomNestedEditable = function (a) {
        return a.type == CKEDITOR.NODE_ELEMENT && a.hasAttribute('data-cke-widget-editable');
      };
      h.isDomWidgetElement = function (a) {
        return a.type == CKEDITOR.NODE_ELEMENT && a.hasAttribute('data-widget');
      };
      h.isDomWidgetWrapper = function (a) {
        return a.type == CKEDITOR.NODE_ELEMENT && a.hasAttribute('data-cke-widget-wrapper');
      };
      h.isDomWidget = function (a) {
        return a ? this.isDomWidgetWrapper(a) || this.isDomWidgetElement(a) : !1;
      };
      h.isParserWidgetElement = function (a) {
        return a.type == CKEDITOR.NODE_ELEMENT && !!a.attributes['data-widget'];
      };
      h.isParserWidgetWrapper = function (a) {
        return a.type == CKEDITOR.NODE_ELEMENT && !!a.attributes['data-cke-widget-wrapper'];
      };
      h.WRAPPER_CLASS_PREFIX = 'cke_widget_wrapper_';
      f.prototype = CKEDITOR.tools.extend(CKEDITOR.tools.prototypedCopy(CKEDITOR.dom.element.prototype), {
        setData: function (a) {
          this._.initialSetData || this.editor.widgets.destroyAll(!1, this);
          this._.initialSetData = !1;
          a = this.editor.dataProcessor.unprotectRealComments(a);
          a = this.editor.dataProcessor.unprotectSource(a);
          a = this.editor.dataProcessor.toHtml(a, { context: this.getName(), filter: this.filter, enterMode: this.enterMode });
          this.setHtml(a);
          this.editor.widgets.initOnAll(this);
        },
        getData: function () {
          return this.editor.dataProcessor.toDataFormat(this.getHtml(), {
            context: this.getName(),
            filter: this.filter,
            enterMode: this.enterMode,
          });
        },
      });
      var ca =
          /^(?:<(?:div|span)(?: data-cke-temp="1")?(?: id="cke_copybin")?(?: data-cke-temp="1")?>)?(?:<(?:div|span)(?: style="[^"]+")?>)?<span [^>]*data-cke-copybin-start="1"[^>]*>.?<\/span>([\s\S]+)<span [^>]*data-cke-copybin-end="1"[^>]*>.?<\/span>(?:<\/(?:div|span)>)?(?:<\/(?:div|span)>)?$/i,
        V = { 37: 1, 38: 1, 39: 1, 40: 1, 8: 1, 46: 1 };
      V[CKEDITOR.SHIFT + 121] = 1;
      var Q = CKEDITOR.tools.createClass({
        $: function (a, b) {
          this._.createCopyBin(a, b);
          this._.createListeners(b);
        },
        _: {
          createCopyBin: function (a) {
            var b = a.document,
              c = CKEDITOR.env.edge && 16 <= CKEDITOR.env.version,
              d = (!a.blockless && !CKEDITOR.env.ie) || c ? 'div' : 'span',
              c = b.createElement(d),
              b = b.createElement(d);
            b.setAttributes({ id: 'cke_copybin', 'data-cke-temp': '1' });
            c.setStyles({ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden' });
            c.setStyle('ltr' == a.config.contentsLangDirection ? 'left' : 'right', '-5000px');
            this.editor = a;
            this.copyBin = c;
            this.container = b;
          },
          createListeners: function (a) {
            a && (a.beforeDestroy && (this.beforeDestroy = a.beforeDestroy), a.afterDestroy && (this.afterDestroy = a.afterDestroy));
          },
        },
        proto: {
          handle: function (a) {
            var b = this.copyBin,
              c = this.editor,
              d = this.container,
              e = CKEDITOR.env.ie && 9 > CKEDITOR.env.version,
              f = c.document.getDocumentElement().$,
              g = c.createRange(),
              h = this,
              k = CKEDITOR.env.mac && CKEDITOR.env.webkit,
              l = k ? 100 : 0,
              m = window.requestAnimationFrame && !k ? requestAnimationFrame : setTimeout,
              n,
              p,
              q;
            b.setHtml(
              '\x3cspan data-cke-copybin-start\x3d"1"\x3e​\x3c/span\x3e' + a + '\x3cspan data-cke-copybin-end\x3d"1"\x3e​\x3c/span\x3e',
            );
            c.fire('lockSnapshot');
            d.append(b);
            c.editable().append(d);
            n = c.on('selectionChange', K, null, null, 0);
            p = c.widgets.on('checkSelection', K, null, null, 0);
            e && (q = f.scrollTop);
            g.selectNodeContents(b);
            g.select();
            e && (f.scrollTop = q);
            return new CKEDITOR.tools.promise(function (a) {
              m(function () {
                h.beforeDestroy && h.beforeDestroy();
                d.remove();
                n.removeListener();
                p.removeListener();
                c.fire('unlockSnapshot');
                h.afterDestroy && h.afterDestroy();
                a();
              }, l);
            });
          },
        },
        statics: {
          hasCopyBin: function (a) {
            return !!Q.getCopyBin(a);
          },
          getCopyBin: function (a) {
            return a.document.getById('cke_copybin');
          },
        },
      });
      CKEDITOR.plugins.widget = h;
      h.repository = a;
      h.nestedEditable = f;
    })();
    CKEDITOR.config.widget_keystrokeInsertLineBefore = CKEDITOR.SHIFT + CKEDITOR.ALT + 13;
    CKEDITOR.config.widget_keystrokeInsertLineAfter = CKEDITOR.SHIFT + 13;
    (function () {
      function a(a, b, c) {
        this.editor = a;
        this.notification = null;
        this._message = new CKEDITOR.template(b);
        this._singularMessage = c ? new CKEDITOR.template(c) : null;
        this._tasks = [];
        this._doneTasks = this._doneWeights = this._totalWeights = 0;
      }
      function h(a) {
        this._weight = a || 1;
        this._doneWeight = 0;
        this._isCanceled = !1;
      }
      CKEDITOR.plugins.add('notificationaggregator', { requires: 'notification' });
      a.prototype = {
        createTask: function (a) {
          a = a || {};
          var b = !this.notification,
            c;
          b && (this.notification = this._createNotification());
          c = this._addTask(a);
          c.on('updated', this._onTaskUpdate, this);
          c.on('done', this._onTaskDone, this);
          c.on(
            'canceled',
            function () {
              this._removeTask(c);
            },
            this,
          );
          this.update();
          b && this.notification.show();
          return c;
        },
        update: function () {
          this._updateNotification();
          this.isFinished() && this.fire('finished');
        },
        getPercentage: function () {
          return 0 === this.getTaskCount() ? 1 : this._doneWeights / this._totalWeights;
        },
        isFinished: function () {
          return this.getDoneTaskCount() === this.getTaskCount();
        },
        getTaskCount: function () {
          return this._tasks.length;
        },
        getDoneTaskCount: function () {
          return this._doneTasks;
        },
        _updateNotification: function () {
          this.notification.update({ message: this._getNotificationMessage(), progress: this.getPercentage() });
        },
        _getNotificationMessage: function () {
          var a = this.getTaskCount(),
            b = { current: this.getDoneTaskCount(), max: a, percentage: Math.round(100 * this.getPercentage()) };
          return (1 == a && this._singularMessage ? this._singularMessage : this._message).output(b);
        },
        _createNotification: function () {
          return new CKEDITOR.plugins.notification(this.editor, { type: 'progress' });
        },
        _addTask: function (a) {
          a = new h(a.weight);
          this._tasks.push(a);
          this._totalWeights += a._weight;
          return a;
        },
        _removeTask: function (a) {
          var b = CKEDITOR.tools.indexOf(this._tasks, a);
          -1 !== b &&
            (a._doneWeight && (this._doneWeights -= a._doneWeight),
            (this._totalWeights -= a._weight),
            this._tasks.splice(b, 1),
            this.update());
        },
        _onTaskUpdate: function (a) {
          this._doneWeights += a.data;
          this.update();
        },
        _onTaskDone: function () {
          this._doneTasks += 1;
          this.update();
        },
      };
      CKEDITOR.event.implementOn(a.prototype);
      h.prototype = {
        done: function () {
          this.update(this._weight);
        },
        update: function (a) {
          if (!this.isDone() && !this.isCanceled()) {
            a = Math.min(this._weight, a);
            var b = a - this._doneWeight;
            this._doneWeight = a;
            this.fire('updated', b);
            this.isDone() && this.fire('done');
          }
        },
        cancel: function () {
          this.isDone() || this.isCanceled() || ((this._isCanceled = !0), this.fire('canceled'));
        },
        isDone: function () {
          return this._weight === this._doneWeight;
        },
        isCanceled: function () {
          return this._isCanceled;
        },
      };
      CKEDITOR.event.implementOn(h.prototype);
      CKEDITOR.plugins.notificationAggregator = a;
      CKEDITOR.plugins.notificationAggregator.task = h;
    })();
    ('use strict');
    (function () {
      CKEDITOR.plugins.add('uploadwidget', {
        requires: 'widget,clipboard,filetools,notificationaggregator',
        init: function (a) {
          a.filter.allow('*[!data-widget,!data-cke-upload-id]');
        },
        isSupportedEnvironment: function () {
          return CKEDITOR.plugins.clipboard.isFileApiSupported;
        },
      });
      CKEDITOR.fileTools || (CKEDITOR.fileTools = {});
      CKEDITOR.tools.extend(CKEDITOR.fileTools, {
        addUploadWidget: function (a, h, f) {
          var b = CKEDITOR.fileTools,
            c = a.uploadRepository,
            l = f.supportedTypes ? 10 : 20;
          CKEDITOR.plugins.clipboard.addFileMatcher(a, function (a) {
            return f.supportedTypes ? b.isTypeSupported(a, f.supportedTypes) : !0;
          });
          if (f.fileToElement)
            a.on(
              'paste',
              function (f) {
                f = f.data;
                var l = a.widgets.registered[h],
                  g = f.dataTransfer,
                  d = g.getFilesCount(),
                  e = l.loadMethod || 'loadAndUpload',
                  n,
                  r;
                if (!f.dataValue && d)
                  for (r = 0; r < d; r++)
                    if (((n = g.getFile(r)), !l.supportedTypes || b.isTypeSupported(n, l.supportedTypes))) {
                      var x = l.fileToElement(n);
                      n = c.create(n, void 0, l.loaderType);
                      x &&
                        (n[e](l.uploadUrl, l.additionalRequestParameters),
                        CKEDITOR.fileTools.markElement(x, h, n.id),
                        ('loadAndUpload' != e && 'upload' != e) || l.skipNotifications || CKEDITOR.fileTools.bindNotifications(a, n),
                        (f.dataValue += x.getOuterHtml()));
                    }
              },
              null,
              null,
              l,
            );
          CKEDITOR.tools.extend(f, {
            downcast: function () {
              return new CKEDITOR.htmlParser.text('');
            },
            init: function () {
              var b = this,
                f = this.wrapper.findOne('[data-cke-upload-id]').data('cke-upload-id'),
                g = c.loaders[f],
                d = CKEDITOR.tools.capitalize,
                e,
                h;
              g.on('update', function (c) {
                if ('abort' === g.status && 'function' === typeof b.onAbort) b.onAbort(g);
                if (b.wrapper && b.wrapper.getParent()) {
                  a.fire('lockSnapshot');
                  c = 'on' + d(g.status);
                  if ('abort' === g.status || 'function' !== typeof b[c] || !1 !== b[c](g))
                    (h = 'cke_upload_' + g.status),
                      b.wrapper && h != e && (e && b.wrapper.removeClass(e), b.wrapper.addClass(h), (e = h)),
                      ('error' != g.status && 'abort' != g.status) || a.widgets.del(b);
                  a.fire('unlockSnapshot');
                } else
                  (CKEDITOR.instances[a.name] &&
                    a
                      .editable()
                      .find('[data-cke-upload-id\x3d"' + f + '"]')
                      .count()) ||
                    g.abort(),
                    c.removeListener();
              });
              g.update();
            },
            replaceWith: function (b, c) {
              if ('' === b.trim()) a.widgets.del(this);
              else {
                var f = this == a.widgets.focused,
                  d = a.editable(),
                  e = a.createRange(),
                  h,
                  l;
                f || (l = a.getSelection().createBookmarks());
                e.setStartBefore(this.wrapper);
                e.setEndAfter(this.wrapper);
                f && (h = e.createBookmark());
                d.insertHtmlIntoRange(b, e, c);
                a.widgets.checkWidgets({ initOnlyNew: !0 });
                a.widgets.destroy(this, !0);
                f ? (e.moveToBookmark(h), e.select()) : a.getSelection().selectBookmarks(l);
              }
            },
            _getLoader: function () {
              var a = this.wrapper.findOne('[data-cke-upload-id]');
              return a ? this.editor.uploadRepository.loaders[a.data('cke-upload-id')] : null;
            },
          });
          a.widgets.add(h, f);
        },
        markElement: function (a, h, f) {
          a.setAttributes({ 'data-cke-upload-id': f, 'data-widget': h });
        },
        bindNotifications: function (a, h) {
          function f() {
            b = a._.uploadWidgetNotificaionAggregator;
            if (!b || b.isFinished())
              (b = a._.uploadWidgetNotificaionAggregator =
                new CKEDITOR.plugins.notificationAggregator(a, a.lang.uploadwidget.uploadMany, a.lang.uploadwidget.uploadOne)),
                b.once('finished', function () {
                  var c = b.getTaskCount();
                  0 === c
                    ? b.notification.hide()
                    : b.notification.update({
                        message: 1 == c ? a.lang.uploadwidget.doneOne : a.lang.uploadwidget.doneMany.replace('%1', c),
                        type: 'success',
                        important: 1,
                      });
                });
          }
          var b,
            c = null;
          h.on('update', function () {
            !c && h.uploadTotal && (f(), (c = b.createTask({ weight: h.uploadTotal })));
            c && 'uploading' == h.status && c.update(h.uploaded);
          });
          h.on('uploaded', function () {
            c && c.done();
          });
          h.on('error', function () {
            c && c.cancel();
            a.showNotification(h.message, 'warning');
          });
          h.on('abort', function () {
            c && c.cancel();
            CKEDITOR.instances[a.name] && a.showNotification(a.lang.uploadwidget.abort, 'info');
          });
        },
      });
    })();
    ('use strict');
    (function () {
      function a(a) {
        9 >= a && (a = '0' + a);
        return String(a);
      }
      function h(b) {
        var c = new Date(),
          c = [c.getFullYear(), c.getMonth() + 1, c.getDate(), c.getHours(), c.getMinutes(), c.getSeconds()];
        f += 1;
        return 'image-' + CKEDITOR.tools.array.map(c, a).join('') + '-' + f + '.' + b;
      }
      var f = 0;
      CKEDITOR.plugins.add('uploadimage', {
        requires: 'uploadwidget',
        onLoad: function () {
          CKEDITOR.addCss('.cke_upload_uploading img{opacity: 0.3}');
        },
        isSupportedEnvironment: function () {
          return CKEDITOR.plugins.clipboard.isFileApiSupported;
        },
        init: function (a) {
          if (this.isSupportedEnvironment()) {
            var c = CKEDITOR.fileTools,
              f = c.getUploadUrl(a.config, 'image');
            f &&
              (c.addUploadWidget(a, 'uploadimage', {
                supportedTypes: /image\/(jpeg|png|gif|bmp)/,
                uploadUrl: f,
                fileToElement: function () {
                  var a = new CKEDITOR.dom.element('img');
                  a.setAttribute(
                    'src',
                    'data:image/gif;base64,R0lGODlhDgAOAIAAAAAAAP///yH5BAAAAAAALAAAAAAOAA4AAAIMhI+py+0Po5y02qsKADs\x3d',
                  );
                  return a;
                },
                parts: { img: 'img' },
                onUploading: function (a) {
                  this.parts.img.setAttribute('src', a.data);
                },
                onUploaded: function (a) {
                  var b = this.parts.img.$;
                  this.replaceWith(
                    '\x3cimg src\x3d"' +
                      a.url +
                      '" width\x3d"' +
                      (a.responseData.width || b.naturalWidth) +
                      '" height\x3d"' +
                      (a.responseData.height || b.naturalHeight) +
                      '"\x3e',
                  );
                },
              }),
              a.on('paste', function (k) {
                if (k.data.dataValue.match(/<img[\s\S]+data:/i)) {
                  k = k.data;
                  var m = document.implementation.createHTMLDocument(''),
                    m = new CKEDITOR.dom.element(m.body),
                    g,
                    d,
                    e;
                  m.data('cke-editable', 1);
                  m.appendHtml(k.dataValue);
                  g = m.find('img');
                  for (e = 0; e < g.count(); e++) {
                    d = g.getItem(e);
                    var n = d.getAttribute('src'),
                      r = n && 'data:' == n.substring(0, 5),
                      x = null === d.data('cke-realelement');
                    r &&
                      x &&
                      !d.data('cke-upload-id') &&
                      !d.isReadOnly(1) &&
                      ((r = ((r = n.match(/image\/([a-z]+?);/i)) && r[1]) || 'jpg'),
                      (n = a.uploadRepository.create(n, h(r))),
                      n.upload(f),
                      c.markElement(d, 'uploadimage', n.id),
                      c.bindNotifications(a, n));
                  }
                  k.dataValue = m.getHtml();
                }
              }));
          }
        },
      });
    })();
    (function () {
      function a(a) {
        function b(a) {
          var c = !1;
          e.attachListener(
            e,
            'keydown',
            function () {
              var b = m.getBody().getElementsByTag(a);
              if (!c) {
                for (var d = 0; d < b.count(); d++) b.getItem(d).setCustomData('retain', !0);
                c = !0;
              }
            },
            null,
            null,
            1,
          );
          e.attachListener(e, 'keyup', function () {
            var b = m.getElementsByTag(a);
            c &&
              (1 == b.count() &&
                !b.getItem(0).getCustomData('retain') &&
                CKEDITOR.tools.isEmpty(b.getItem(0).getAttributes()) &&
                b.getItem(0).remove(1),
              (c = !1));
          });
        }
        var f = this.editor;
        if (f && !f.isDetached()) {
          var m = a.document,
            g = m.body,
            d = m.getElementById('cke_actscrpt');
          d && d.parentNode.removeChild(d);
          (d = m.getElementById('cke_shimscrpt')) && d.parentNode.removeChild(d);
          (d = m.getElementById('cke_basetagscrpt')) && d.parentNode.removeChild(d);
          g.contentEditable = !0;
          CKEDITOR.env.ie && ((g.hideFocus = !0), (g.disabled = !0), g.removeAttribute('disabled'));
          delete this._.isLoadingData;
          this.$ = g;
          m = new CKEDITOR.dom.document(m);
          this.setup();
          this.fixInitialSelection();
          var e = this;
          CKEDITOR.env.ie && !CKEDITOR.env.edge && m.getDocumentElement().addClass(m.$.compatMode);
          CKEDITOR.env.ie && !CKEDITOR.env.edge && f.enterMode != CKEDITOR.ENTER_P
            ? b('p')
            : CKEDITOR.env.edge && 15 > CKEDITOR.env.version && f.enterMode != CKEDITOR.ENTER_DIV && b('div');
          if (CKEDITOR.env.webkit || (CKEDITOR.env.ie && 10 < CKEDITOR.env.version))
            m.getDocumentElement().on('mousedown', function (a) {
              a.data.getTarget().is('html') &&
                setTimeout(function () {
                  f.editable().focus();
                });
            });
          h(f);
          try {
            f.document.$.execCommand('2D-position', !1, !0);
          } catch (n) {}
          (CKEDITOR.env.gecko || (CKEDITOR.env.ie && 'CSS1Compat' == f.document.$.compatMode)) &&
            this.attachListener(this, 'keydown', function (a) {
              var b = a.data.getKeystroke();
              if (33 == b || 34 == b)
                if (CKEDITOR.env.ie)
                  setTimeout(function () {
                    f.getSelection().scrollIntoView();
                  }, 0);
                else if (f.window.$.innerHeight > this.$.offsetHeight) {
                  var c = f.createRange();
                  c[33 == b ? 'moveToElementEditStart' : 'moveToElementEditEnd'](this);
                  c.select();
                  a.data.preventDefault();
                }
            });
          CKEDITOR.env.ie &&
            this.attachListener(m, 'blur', function () {
              try {
                m.$.selection.empty();
              } catch (a) {}
            });
          CKEDITOR.env.iOS &&
            this.attachListener(m, 'touchend', function () {
              a.focus();
            });
          g = f.document.getElementsByTag('title').getItem(0);
          g.data('cke-title', g.getText());
          CKEDITOR.env.ie && (f.document.$.title = this._.docTitle);
          CKEDITOR.tools.setTimeout(
            function () {
              'unloaded' == this.status && (this.status = 'ready');
              f.fire('contentDom');
              this._.isPendingFocus && (f.focus(), (this._.isPendingFocus = !1));
              setTimeout(function () {
                f.fire('dataReady');
              }, 0);
            },
            0,
            this,
          );
        }
      }
      function h(a) {
        function b() {
          var d;
          a.editable().attachListener(a, 'selectionChange', function () {
            var b = a.getSelection().getSelectedElement();
            b && (d && (d.detachEvent('onresizestart', f), (d = null)), b.$.attachEvent('onresizestart', f), (d = b.$));
          });
        }
        function f(a) {
          a.returnValue = !1;
        }
        if (CKEDITOR.env.gecko)
          try {
            var h = a.document.$;
            h.execCommand('enableObjectResizing', !1, !a.config.disableObjectResizing);
            h.execCommand('enableInlineTableEditing', !1, !a.config.disableNativeTableHandles);
          } catch (g) {}
        else CKEDITOR.env.ie && 11 > CKEDITOR.env.version && a.config.disableObjectResizing && b();
      }
      function f() {
        var a = [];
        if (8 <= CKEDITOR.document.$.documentMode) {
          a.push('html.CSS1Compat [contenteditable\x3dfalse]{min-height:0 !important}');
          var b = [],
            f;
          for (f in CKEDITOR.dtd.$removeEmpty) b.push('html.CSS1Compat ' + f + '[contenteditable\x3dfalse]');
          a.push(b.join(',') + '{display:inline-block}');
        } else
          CKEDITOR.env.gecko &&
            (a.push('html{height:100% !important}'),
            a.push('img:-moz-broken{-moz-force-broken-image-icon:1;min-width:24px;min-height:24px}'));
        a.push('html{cursor:text;*cursor:auto}');
        a.push('img,input,textarea{cursor:default}');
        return a.join('\n');
      }
      var b;
      CKEDITOR.plugins.add('wysiwygarea', {
        init: function (a) {
          a.config.fullPage &&
            a.addFeature({ allowedContent: 'html head title; style [media,type]; body (*)[id]; meta link [*]', requiredContent: 'body' });
          a.addMode('wysiwyg', function (f) {
            function h(d) {
              d && d.removeListener();
              if (
                !a.isDestroyed() &&
                !a.isDetached() &&
                (a.editable(new b(a, n.getFrameDocument().getBody())), a.setData(a.getData(1), f), w)
              ) {
                if (t) a.on('mode', m, { iframe: n, editor: a, callback: f });
                a.on('mode', function () {
                  a.status = 'ready';
                });
                g();
              }
            }
            function m(a) {
              a && a.removeListener();
              n.on('load', function () {
                p && ((p = !1), d());
              });
            }
            function g() {
              q = new MutationObserver(function (b) {
                for (var e = 0; e < b.length; e++) {
                  var f = b[e];
                  if ('childList' === f.type && 0 !== f.addedNodes.length)
                    for (var g = 0; g < f.addedNodes.length; g++) {
                      var h = f.addedNodes[g];
                      h.contains && h.contains(a.container.$) && (t ? (p = !0) : d());
                    }
                }
              });
              q.observe(a.config.observableParent, { childList: !0, subtree: !0 });
            }
            function d() {
              var d = a.getData(!1),
                e;
              a.editable().preserveIframe = !0;
              a.editable(null);
              e = new b(a, n.getFrameDocument().getBody());
              a.editable(e);
              a.status = 'recreating';
              a.setData(d, { callback: f, internal: !1, noSnapshot: !1 });
            }
            var e = 'document.open();' + (CKEDITOR.env.ie ? '(' + CKEDITOR.tools.fixDomain + ')();' : '') + 'document.close();',
              e = CKEDITOR.env.air
                ? 'javascript:void(0)'
                : CKEDITOR.env.ie && !CKEDITOR.env.edge
                  ? 'javascript:void(function(){' + encodeURIComponent(e) + '}())'
                  : '',
              n = CKEDITOR.dom.element.createFromHtml('\x3ciframe src\x3d"' + e + '" frameBorder\x3d"0"\x3e\x3c/iframe\x3e');
            n.setStyles({ width: '100%', height: '100%' });
            n.addClass('cke_wysiwyg_frame').addClass('cke_reset');
            e = a.ui.space('contents');
            e.append(n);
            var r = (CKEDITOR.env.ie && !CKEDITOR.env.edge) || CKEDITOR.env.gecko;
            if (r) n.on('load', h);
            var x = a.title,
              u = a.fire('ariaEditorHelpLabel', {}).label,
              p = !1,
              t = CKEDITOR.env.ie && 11 === CKEDITOR.env.version,
              w = !!window.MutationObserver,
              q;
            x && (CKEDITOR.env.ie && u && (x += ', ' + u), n.setAttribute('title', x));
            if (u) {
              var x = CKEDITOR.tools.getNextId(),
                B = CKEDITOR.dom.element.createFromHtml('\x3cspan id\x3d"' + x + '" class\x3d"cke_voice_label"\x3e' + u + '\x3c/span\x3e');
              e.append(B, 1);
              n.setAttribute('aria-describedby', x);
            }
            a.on('beforeModeUnload', function (a) {
              a.removeListener();
              B && B.remove();
              w && q.disconnect();
            });
            a.on('destroy', function () {
              q && q.disconnect();
            });
            n.setAttributes({ tabIndex: a.tabIndex, allowTransparency: 'true' });
            !r && h();
            a.fire('ariaWidget', n);
          });
        },
      });
      CKEDITOR.editor.prototype.addContentsCss = function (a) {
        var b = this.config,
          f = b.contentsCss;
        CKEDITOR.tools.isArray(f) || (b.contentsCss = f ? [f] : []);
        b.contentsCss.push(a);
      };
      b = CKEDITOR.tools.createClass({
        $: function () {
          this.base.apply(this, arguments);
          this._.frameLoadedHandler = CKEDITOR.tools.addFunction(function (b) {
            CKEDITOR.tools.setTimeout(a, 0, this, b);
          }, this);
          this._.docTitle = this.getWindow().getFrame().getAttribute('title') || ' ';
        },
        base: CKEDITOR.editable,
        proto: {
          preserveIframe: !1,
          setData: function (a, b) {
            var h = this.editor;
            if (b) this.setHtml(a), this.fixInitialSelection(), h.fire('dataReady');
            else {
              this._.isLoadingData = !0;
              h._.dataStore = { id: 1 };
              var m = h.config,
                g = m.fullPage,
                d = m.docType,
                e = CKEDITOR.tools.buildStyleHtml(f()).replace(/<style>/, '\x3cstyle data-cke-temp\x3d"1"\x3e');
              g || (e += CKEDITOR.tools.buildStyleHtml(h.config.contentsCss));
              var n = m.baseHref ? '\x3cbase href\x3d"' + m.baseHref + '" data-cke-temp\x3d"1" /\x3e' : '';
              g &&
                (a = a
                  .replace(/<!DOCTYPE[^>]*>/i, function (a) {
                    h.docType = d = a;
                    return '';
                  })
                  .replace(/<\?xml\s[^\?]*\?>/i, function (a) {
                    h.xmlDeclaration = a;
                    return '';
                  }));
              a = h.dataProcessor.toHtml(a);
              g
                ? (/<body[\s|>]/.test(a) || (a = '\x3cbody\x3e' + a),
                  /<html[\s|>]/.test(a) || (a = '\x3chtml\x3e' + a + '\x3c/html\x3e'),
                  /<head[\s|>]/.test(a)
                    ? /<title[\s|>]/.test(a) || (a = a.replace(/<head[^>]*>/, '$\x26\x3ctitle\x3e\x3c/title\x3e'))
                    : (a = a.replace(/<html[^>]*>/, '$\x26\x3chead\x3e\x3ctitle\x3e\x3c/title\x3e\x3c/head\x3e')),
                  n && (a = a.replace(/<head[^>]*?>/, '$\x26' + n)),
                  (a = a.replace(/<\/head\s*>/, e + '$\x26')),
                  (a = d + a))
                : (a =
                    m.docType +
                    '\x3chtml dir\x3d"' +
                    m.contentsLangDirection +
                    '" lang\x3d"' +
                    (m.contentsLanguage || h.langCode) +
                    '"\x3e\x3chead\x3e\x3ctitle\x3e' +
                    this._.docTitle +
                    '\x3c/title\x3e' +
                    n +
                    e +
                    '\x3c/head\x3e\x3cbody' +
                    (m.bodyId ? ' id\x3d"' + m.bodyId + '"' : '') +
                    (m.bodyClass ? ' class\x3d"' + m.bodyClass + '"' : '') +
                    '\x3e' +
                    a +
                    '\x3c/body\x3e\x3c/html\x3e');
              CKEDITOR.env.gecko &&
                ((a = a.replace(/<body/, '\x3cbody contenteditable\x3d"true" ')),
                2e4 > CKEDITOR.env.version && (a = a.replace(/<body[^>]*>/, '$\x26\x3c!-- cke-content-start --\x3e')));
              a = a.replace(/<body/, '\x3cbody role\x3d"textbox" aria-multiline\x3d"true"');
              h.title && (a = a.replace(/<body/, '\x3cbody aria-label\x3d"' + CKEDITOR.tools.htmlEncodeAttr(h.title) + '"'));
              CKEDITOR.env.gecko || (a = a.replace('\x3cbody', '\x3cbody tabindex\x3d"0" '));
              m =
                '\x3cscript id\x3d"cke_actscrpt" type\x3d"text/javascript"' +
                (CKEDITOR.env.ie ? ' defer\x3d"defer" ' : '') +
                '\x3evar wasLoaded\x3d0;function onload(){if(!wasLoaded)window.parent.CKEDITOR \x26\x26 window.parent.CKEDITOR.tools.callFunction(' +
                this._.frameLoadedHandler +
                ',window);wasLoaded\x3d1;}' +
                (CKEDITOR.env.ie ? 'onload();' : 'document.addEventListener("DOMContentLoaded", onload, false );') +
                '\x3c/script\x3e';
              CKEDITOR.env.ie &&
                9 > CKEDITOR.env.version &&
                (m += '\x3cscript id\x3d"cke_shimscrpt"\x3ewindow.parent.CKEDITOR.tools.enableHtml5Elements(document)\x3c/script\x3e');
              n &&
                CKEDITOR.env.ie &&
                10 > CKEDITOR.env.version &&
                (m +=
                  '\x3cscript id\x3d"cke_basetagscrpt"\x3evar baseTag \x3d document.querySelector( "base" );baseTag.href \x3d baseTag.href;\x3c/script\x3e');
              a = a.replace(/(?=\s*<\/(:?head)>)/, m);
              this.clearCustomData();
              this.clearListeners();
              h.fire('contentDomUnload');
              var r = this.getDocument();
              try {
                r.write(a);
              } catch (w) {
                setTimeout(function () {
                  r.write(a);
                }, 0);
              }
            }
          },
          getData: function (a) {
            if (a) return this.getHtml();
            a = this.editor;
            var b = a.config,
              f = b.fullPage,
              h = f && a.docType,
              g = f && a.xmlDeclaration,
              d = this.getDocument(),
              d = f ? d.getDocumentElement().getOuterHtml() : d.getBody().getHtml();
            CKEDITOR.env.gecko && b.enterMode != CKEDITOR.ENTER_BR && (d = d.replace(/<br>(?=\s*(:?$|<\/body>))/, ''));
            f &&
              (d = d
                .replace(/<body(.*?)role="?textbox"?/i, '\x3cbody$1')
                .replace(/<body(.*?)aria-multiline="?true"?/i, '\x3cbody$1')
                .replace(/<body(.*?)tabindex="?0"?/i, '\x3cbody$1')
                .replace(/<body(.*?)aria-label="(.+?)"/i, '\x3cbody$1')
                .replace(/<body(.*?)aria-readonly="?(?:true|false)"?/i, '\x3cbody$1'));
            d = a.dataProcessor.toDataFormat(d);
            g && (d = g + '\n' + d);
            h && (d = h + '\n' + d);
            return d;
          },
          focus: function () {
            this._.isLoadingData ? (this._.isPendingFocus = !0) : b.baseProto.focus.call(this);
          },
          detach: function () {
            if (!this.preserveIframe) {
              var a = this.editor,
                f = a.document,
                a = a.container.findOne('iframe.cke_wysiwyg_frame');
              b.baseProto.detach.call(this);
              this.clearCustomData(this._.expandoNumber);
              f.getDocumentElement().clearCustomData();
              CKEDITOR.tools.removeFunction(this._.frameLoadedHandler);
              a && (a.clearCustomData(), (f = a.removeCustomData('onResize')) && f.removeListener(), a.isDetached() || a.remove());
            }
          },
        },
      });
    })();
    CKEDITOR.config.disableObjectResizing = !1;
    CKEDITOR.config.disableNativeTableHandles = !0;
    CKEDITOR.config.disableNativeSpellChecker = !0;
    CKEDITOR.config.observableParent = CKEDITOR.document.$;
    CKEDITOR.config.plugins =
      'dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,notification,button,toolbar,clipboard,panelbutton,panel,floatpanel,colorbutton,colordialog,copyformatting,menu,contextmenu,dialogadvtab,div,editorplaceholder,elementspath,enterkey,entities,exportpdf,popup,filetools,filebrowser,find,floatingspace,listblock,richcombo,font,format,fakeobjects,forms,horizontalrule,htmlwriter,iframe,image,indent,indentblock,indentlist,justify,menubutton,language,link,list,liststyle,magicline,maximize,newpage,pagebreak,xml,ajax,pastetools,pastefromgdocs,pastefromlibreoffice,pastefromword,pastetext,preview,print,removeformat,resize,save,scayt,selectall,showblocks,showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,tabletools,tableselection,templates,undo,lineutils,widgetselection,widget,notificationaggregator,uploadwidget,uploadimage,wysiwygarea';
    CKEDITOR.config.skin = 'moono-lisa';
    (function () {
      var a = function (a, f) {
        var b = CKEDITOR.getUrl('plugins/' + f);
        a = a.split(',');
        for (var c = 0; c < a.length; c++) CKEDITOR.skin.icons[a[c]] = { path: b, offset: -a[++c], bgsize: a[++c] };
      };
      CKEDITOR.env.hidpi
        ? a(
            'about,0,,bold,24,,italic,48,,strike,72,,subscript,96,,superscript,120,,underline,144,,bidiltr,168,,bidirtl,192,,blockquote,216,,copy-rtl,240,,copy,264,,cut-rtl,288,,cut,312,,paste-rtl,336,,paste,360,,codesnippet,384,,bgcolor,408,,textcolor,432,,copyformatting,456,,creatediv,480,,docprops-rtl,504,,docprops,528,,easyimagealigncenter,552,,easyimagealignleft,576,,easyimagealignright,600,,easyimagealt,624,,easyimagefull,648,,easyimageside,672,,easyimageupload,696,,embed,720,,embedsemantic,744,,emojipanel,768,,exportpdf,792,,find-rtl,816,,find,840,,replace,864,,button,888,,checkbox,912,,form,936,,hiddenfield,960,,imagebutton,984,,radio,1008,,select-rtl,1032,,select,1056,,textarea-rtl,1080,,textarea,1104,,textfield-rtl,1128,,textfield,1152,,horizontalrule,1176,,iframe,1200,,image,1224,,indent-rtl,1248,,indent,1272,,outdent-rtl,1296,,outdent,1320,,justifyblock,1344,,justifycenter,1368,,justifyleft,1392,,justifyright,1416,,language,1440,,anchor-rtl,1464,,anchor,1488,,link,1512,,unlink,1536,,bulletedlist-rtl,1560,,bulletedlist,1584,,numberedlist-rtl,1608,,numberedlist,1632,,mathjax,1656,,maximize,1680,,newpage-rtl,1704,,newpage,1728,,pagebreak-rtl,1752,,pagebreak,1776,,pastefromword-rtl,1800,,pastefromword,1824,,pastetext-rtl,1848,,pastetext,1872,,placeholder,1896,,preview-rtl,1920,,preview,1944,,print,1968,,removeformat,1992,,save,2016,,scayt,2040,,selectall,2064,,showblocks-rtl,2088,,showblocks,2112,,smiley,2136,,source-rtl,2160,,source,2184,,sourcedialog-rtl,2208,,sourcedialog,2232,,specialchar,2256,,table,2280,,templates-rtl,2304,,templates,2328,,uicolor,2352,,redo-rtl,2376,,redo,2400,,undo-rtl,2424,,undo,2448,,simplebox,4944,auto',
            'icons_hidpi.png',
          )
        : a(
            'about,0,auto,bold,24,auto,italic,48,auto,strike,72,auto,subscript,96,auto,superscript,120,auto,underline,144,auto,bidiltr,168,auto,bidirtl,192,auto,blockquote,216,auto,copy-rtl,240,auto,copy,264,auto,cut-rtl,288,auto,cut,312,auto,paste-rtl,336,auto,paste,360,auto,codesnippet,384,auto,bgcolor,408,auto,textcolor,432,auto,copyformatting,456,auto,creatediv,480,auto,docprops-rtl,504,auto,docprops,528,auto,easyimagealigncenter,552,auto,easyimagealignleft,576,auto,easyimagealignright,600,auto,easyimagealt,624,auto,easyimagefull,648,auto,easyimageside,672,auto,easyimageupload,696,auto,embed,720,auto,embedsemantic,744,auto,emojipanel,768,auto,exportpdf,792,auto,find-rtl,816,auto,find,840,auto,replace,864,auto,button,888,auto,checkbox,912,auto,form,936,auto,hiddenfield,960,auto,imagebutton,984,auto,radio,1008,auto,select-rtl,1032,auto,select,1056,auto,textarea-rtl,1080,auto,textarea,1104,auto,textfield-rtl,1128,auto,textfield,1152,auto,horizontalrule,1176,auto,iframe,1200,auto,image,1224,auto,indent-rtl,1248,auto,indent,1272,auto,outdent-rtl,1296,auto,outdent,1320,auto,justifyblock,1344,auto,justifycenter,1368,auto,justifyleft,1392,auto,justifyright,1416,auto,language,1440,auto,anchor-rtl,1464,auto,anchor,1488,auto,link,1512,auto,unlink,1536,auto,bulletedlist-rtl,1560,auto,bulletedlist,1584,auto,numberedlist-rtl,1608,auto,numberedlist,1632,auto,mathjax,1656,auto,maximize,1680,auto,newpage-rtl,1704,auto,newpage,1728,auto,pagebreak-rtl,1752,auto,pagebreak,1776,auto,pastefromword-rtl,1800,auto,pastefromword,1824,auto,pastetext-rtl,1848,auto,pastetext,1872,auto,placeholder,1896,auto,preview-rtl,1920,auto,preview,1944,auto,print,1968,auto,removeformat,1992,auto,save,2016,auto,scayt,2040,auto,selectall,2064,auto,showblocks-rtl,2088,auto,showblocks,2112,auto,smiley,2136,auto,source-rtl,2160,auto,source,2184,auto,sourcedialog-rtl,2208,auto,sourcedialog,2232,auto,specialchar,2256,auto,table,2280,auto,templates-rtl,2304,auto,templates,2328,auto,uicolor,2352,auto,redo-rtl,2376,auto,redo,2400,auto,undo-rtl,2424,auto,undo,2448,auto,simplebox,2472,auto',
            'icons.png',
          );
    })();
  }
})();
